(function() {
  'use strict';

  angular
    .module('app', [
      'ngSanitize',
      'ui.router',
      'ngMaterial',
      'md.data.table',
      'formlyMaterial',
      'satellizer',
      'dndLists',
      'angularFileUpload',
      'leaflet-directive',
      'rzModule',
      'angular-timeline',
      'naif.base64',
      'angular-bind-html-compile',
      'ngCsv'
    ]);

})();

(function() {

  'use strict';

  angular
    .module('app')
    .controller('PlantillaController', PlantillaController);

  /** @ngInject */
  function PlantillaController( UtilFormly, Message, Storage, $stateParams, $location, $log, $mdSidenav, DataService, restUrl, Panel, ArrayUtil, backUrl,  Documento) {
    var vm = this;

    var init_index = null; // indice del item que inicia el efecto dnd
    var to_index = null; // indice al que apunta el efecto dnd

    var init_index_l = null; // indice del item que inicia el efecto dnd y esta dentro de un layout
    var to_index_l = null; // indice al que apunta el efecto dnd y apunta a una posicion dentro de un layout
    var drop_layout = false; // true: indica si se dropeo dentro de un layout, para que dropCallback no se active
    var item_fg = null; // Objeto de referencia para fieldGroup del layout que inicia el efecto dnd
    var data_fg = null; // Objeto de referencia limpio(que tiene la estructura minima de los templates) para fieldGroup del layout que inicia el efecto dnd
    var to_item_fg = null; // Objeto de referencia para fieldGroup del layout al que se esta dropeando
    var to_data_fg = null; // Objeto de referencia limpio(que tiene la estructura minima de los templates) para fieldGroup del layout al que se esta dropeando
    var to_item_fg_num_cols = null; // Numero de columnas que puede soportar el layout al que se esta dropeando

    var cuenta = Storage.getUser();
    vm.id_plantilla = $stateParams.idPlantilla;
    vm.form_model = {};
    vm.items = [];
    vm.data = [];
    vm.existe_documento = false;
    vm.existe_datosGenerales = false;
    vm.existe_certificacionComprometido = false;
    vm.existe_recuperarEntregaAlmacen = false;
    vm.url_img = null;

    //cargamos funciones
    vm.funcionAgregar = funcionAgregar;
    vm.editItem = editItem;
    vm.removeItem = removeItem;
    vm.openEditItem = openEditItem;
    vm.cancelEditItem = cancelEditItem;
    vm.dropCallback = dropCallback;
    vm.endCallback = endCallback;
    vm.startCallback = startCallback;
    vm.dropLayoutCallback = dropLayoutCallback;
    vm.endLayoutCallback = endLayoutCallback;
    vm.startLayoutCallback = startLayoutCallback;
    vm.guardarPlantilla = guardarPlantilla;
    vm.vistaPrevia = vistaPrevia;
    vm.verPdf = verPdf;
    vm.openMenu = openMenu;
    vm.togglePalette = togglePalette;

    inicializarPlantilla();
    function inicializarPlantilla() {
        if ( vm.id_plantilla == 0 ) {
            // Nuevo
            vm.implicados = [];
            vm.items = [ newItem(UtilFormly.newTemplate('cite')) ];
            vm.data = [  UtilFormly.newTemplate('cite') ];
            vm.nombre = "Nueva plantilla";
        } else {
            DataService.get(restUrl + 'plantillasFormly/plantilla_formly/' + vm.id_plantilla)
            .then(function (respuesta) {
                vm.nombre = respuesta.datos.nombre;
                vm.abreviacion = respuesta.datos.abreviacion;
                vm.form_model = angular.fromJson(respuesta.datos.plantilla_valor);
                vm.items = transformGet(angular.fromJson(respuesta.datos.plantilla));
                vm.data = angular.fromJson(respuesta.datos.plantilla);
                for (var i = 0; i < vm.data.length; i++) {
                    if( vm.data[i].type=='datosGenerales' ) vm.existe_datosGenerales = true;
                    if( vm.data[i].type=='certificacionComprometido' ) vm.existe_certificacionComprometido = true;
                    if( vm.data[i].type=='recuperarEntregaAlmacen' ) vm.existe_recuperarEntregaAlmacen = true;
                }
                actualizarPagina(vm.data[0]);
                return DataService.get(restUrl + 'plantillasFormly/documento/?abreviacion='+vm.abreviacion)
            })
            .then(function (respuesta) {
                if(respuesta.datos.total>0){
                    vm.existe_documento = true;
                }
            })
        }
    }

    function togglePalette(ev) {
        $log.log("evento toggle-> ",ev);
        $mdSidenav('right').toggle();
    }

    function vistaPrevia() {
        vm.form_previo = UtilFormly.dataToView(vm.data);
        // console.log(vm.form_previo);
        if (angular.isObject(vm.form_model)) vm.form_model = UtilFormly.clearModel(vm.data, vm.form_model);
        vm.vista_previa = true;
    }

    function guardarPlantilla() {
        var xplantilla_valor = angular.copy(vm.form_model);
        var abreviacion;
        if(vm.nombre){
            for (var k in xplantilla_valor) {
                if(k.indexOf("editorTexto")===-1 &&  k.indexOf("textarea")===-1){
                    delete xplantilla_valor[k];
                }else if(xplantilla_valor[k]==''){
                    delete xplantilla_valor[k];
                }
            }

            var plantilla = {
                nombre: vm.nombre,
                plantilla: angular.toJson(vm.data),
                plantilla_valor: angular.toJson(xplantilla_valor),
                _usuario_creacion: cuenta.id
            };

            abreviacion = (vm.existe_documento)? vm.abreviacion : Documento.generarAbreviacion(vm.nombre);

            DataService.get(restUrl+"plantillasFormly/plantilla_formly/abreviacion/"+abreviacion)
            .then(function (respuesta) {
                // console.log(respuesta);
                if(respuesta && angular.isDefined(respuesta.datos))
                    return respuesta.datos;
                else
                    throw new Error('sin respuesta');
            })
            .then(function (resp) {
                var abc = ['', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z' ];
                var xabc = { 'A':1, 'B':2, 'C':3, 'D':4, 'E':5, 'F':6, 'G':7, 'H':8, 'I':9, 'J':10, 'K':11, 'L':12, 'M':13, 'N':14, 'O':15, 'P':16, 'Q':17, 'R':18, 'S':19, 'T':20, 'U':21, 'V':22, 'W':23, 'X':24, 'Y':25, 'Z':26 };

                var sub_arr, max_num, pun;
                max_num=-1;
                pun = false
                if(resp.rows.count){
                    sub_arr = resp.rows.rows[0].abreviacion.split('-');
                    max_num = xabc[sub_arr[1]];
                    for (var i = 0; i < resp.rows.rows.length; i++) {
                        sub_arr = resp.rows.rows[i].abreviacion.split('-');
                        resp.rows.rows[i].num = sub_arr[1];
                        if( xabc[sub_arr[1]] > max_num )
                            max_num = xabc[sub_arr[1]];
                        if( resp.rows.rows[i].abreviacion==vm.abreviacion )
                            pun = true;

                    }
                    max_num++;
                    abreviacion+='-'+abc[max_num];
                }

                if( vm.id_plantilla>0 && resp.row.rows[0] && resp.row.rows[0].id_plantilla_formly==vm.id_plantilla ){
                    abreviacion = vm.abreviacion;
                }
                if( vm.id_plantilla>0 && pun){
                    abreviacion = vm.abreviacion;
                }
                if( vm.id_plantilla==0 && max_num==-1 && resp.row.count==1 )
                    abreviacion += '-A';
                plantilla.abreviacion = abreviacion;

                if (vm.id_plantilla == 0) {
                    //nuevo
                    plantilla._usuario_creacion = cuenta.id;
                    DataService.post(restUrl + "plantillasFormly/plantilla_formly", plantilla)
                    .then(function (respuesta) {
                        Message.show(respuesta.tipoMensaje, respuesta.mensaje);
                        $location.path('plantillas');
                    });
                }else {
                    //editando
                    plantilla._usuario_modificacion = cuenta.id;
                    DataService.put(restUrl + "plantillasFormly/plantilla_formly/" + vm.id_plantilla, plantilla)
                    .then(function (respuesta) {
                        Message.show(respuesta.tipoMensaje, respuesta.mensaje);
                        $location.path('plantillas');
                    });
                }
            })

        }else {
            Message.error('Debe llenar nombre y abreviacion');
        }

    }

    function transformGet(data) {
        var items = [];
        for (var i = 0; i < data.length; i++) {
            if( data[i].type!=="layout" ){
                items.push(newItem(data[i]));
            }else {
                var elements = [];
                for (var j = 0; j < data[i].fieldGroup.length; j++) {
                    elements.push(newItem( UtilFormly.getConfigItem(data[i].fieldGroup[j]) ));
                }
                data[i].fieldGroup = elements;
                items.push(newItem(data[i]));
            }
        }
        return items;
    }

    /**
        El orden en que se activan las funciones es diferente y para cada uno se construyo un camino
        CG: Contenedor General
        draguear: levantar
        dropear: dejar, poner, añadir
        * En los movimientos Drag And Drop (dnd)
            1.- cuando se jala de la paleta se puede activar dropCallback o bien dropLayoutCallback solo uno
            2.- Si se draguea del CG se activa startCallback y se puede dropear al CG o a un Layout. una vez que se termine de dropear automaticamente se activa endCallback
            3.- Si se draguea de un Layout se activa startLayoutCallback y se puede dropear al CG, al mismo layout o a otr layout, una vezque se termine de dropear automaticamente se activa endLayoutCallback
        * si se añade elementos con el boton + de la paleta, este solo añadira al CG
    */

    // cargamos los templates
    // for (var i = 0; i < vm.data.length; i++) {
    //   var item = newItem();
    //   item.val.element.push(UtilFormly.getConfigItem(vm.data[i]));
    //   vm.items.push(item);
    // }


    /**
      Funcion que guardara los datos de un elemento que se empieza a mover con dnd
      @param {Integer} index Indice del item que se clickeo para drag
      @param {Objeto} item Objeto item que tiene la forma de newItem
    */
    function startCallback(index, item){
        // console.log("startCallback-"+index);
        // console.log(item);
        item.notvisualize = true;
        init_index = index;
    }
    /**
      Funcion que se encarga de mover los items
    */
    function endCallback(){
        // console.log("endCallback");
        if( to_index!==null ){
            // console.log("moviendo a el contenedor general");
            if( init_index < to_index ) to_index--;
            ArrayUtil.mover( vm.items, init_index, to_index );
            ArrayUtil.mover( vm.data, init_index, to_index );
            delete vm.items[to_index].notvisualize;
            init_index = null;
            to_index = null;
        }else {
            if( to_index_l!==null ){
                // console.log("moviendo a layout");
                // console.log(to_item_fg);
                // console.log(to_data_fg);
                if( vm.items[init_index].val.element[0].type!=="layout" ){
                    if( to_item_fg.length < to_item_fg_num_cols ){
                        if( to_item_fg.length==0 ) to_index_l = 0;
                        ArrayUtil.mover( vm.items, init_index, to_index_l, to_item_fg );
                        ArrayUtil.mover( vm.data, init_index, to_index_l, to_data_fg );
                        delete to_item_fg[to_index_l].notvisualize;
                    }else {
                        delete vm.items[init_index].notvisualize;
                        Message.error("No puede añadir mas elementos");
                    }
                }else {
                    delete vm.items[init_index].notvisualize;
                    Message.error("No puede añadir contenedores dentro de contenedores");
                }
            }else {
                delete vm.items[init_index].notvisualize;
            }
            init_index = null;
            to_index_l = null;
        }
    }

    /**
      Funcion que se ejecuta cuando se dropea un elemento a la lista general
      @param {Integer} index Indice del item que se clickeo para drag
      @param {Objeto} template Objeto que es el template del item que se movio
    */
    function dropCallback(index, template) {
        if(!drop_layout){
            
            if( init_index==null && init_index_l==null ){
                // si se esta jalando desde la paleta
                var tipo = template;
                try {
                    var mensajeError = "La plantilla solo puede tener un elemento ";
                  if (vm.existe_datosGenerales && tipo == 'datosGenerales') {
                    throw Error(mensajeError + tipo)
                  }
                  if (vm.existe_certificacionComprometido && tipo == 'certificacionComprometido') {
                    throw Error(mensajeError + tipo)
                  }
                  if (vm.existe_recuperarEntregaAlmacen && tipo == 'recuperarEntregaAlmacen') {
                    throw Error(mensajeError + tipo)
                  }
        
                  if (tipo == 'datosGenerales') vm.existe_datosGenerales = true;
                  if (tipo == 'certificacionComprometido') vm.existe_certificacionComprometido = true;
                  if (tipo == 'recuperarEntregaAlmacen') vm.existe_recuperarEntregaAlmacen = true;
                  template = UtilFormly.newTemplate(tipo);
                  var item = newItem(template);
                  if( vm.data.length==0 ) index = 0;
                  ArrayUtil.insert( vm.items, index, item );
                  ArrayUtil.insert( vm.data, index, UtilFormly.getConfigItem(template) );
                  delete vm.data[index].validation;
                } catch (error) {
                  if (error.name == 'Error') Message.error(error.message);
                }

            }else {
                // console.log("guardando index--"+index);
                to_index = index;
            }
        } else {
            drop_layout = false;
        }
    }

    /**
      Funcion que guardara los datos de un elemento que se empieza a mover con dnd
      @param {Integer} index Indice del item que se clickeo para drag
      @param {Objeto} item Objeto item que tiene la forma de newItem
      @param {Integer} index_l Indice del layout que se clickeo para drag
    */
    function startLayoutCallback(index, item, index_l){
        // console.log("startLayoutCallback--"+index+"--"+index_l);
        // console.log(item);
        item.notvisualize = true;
        init_index_l = index;
        item_fg = vm.items[index_l].val.element[0].fieldGroup;
        data_fg = vm.data[index_l].fieldGroup;
        // console.log(item_fg);
        // console.log(data_fg);
    }
    /**
      Funcion que guardara los datos de un elemento que se empieza a mover con dnd
    */
    function endLayoutCallback(){
        if( to_index_l!==null ){
            if( to_item_fg===item_fg ){
                // console.log("moviendo de layout a si mismo");
                if( init_index_l < to_index_l ) to_index_l--;
                ArrayUtil.mover( item_fg, init_index_l, to_index_l );
                ArrayUtil.mover( data_fg, init_index_l, to_index_l );
                delete item_fg[to_index_l].notvisualize;
            }else {
                // console.log("moviendo de layout a layout");
                if( to_item_fg.length==0 ) to_index_l = 0;
                ArrayUtil.mover( item_fg, init_index_l, to_index_l, to_item_fg );
                ArrayUtil.mover( data_fg, init_index_l, to_index_l, to_data_fg );
                delete to_item_fg[to_index_l].notvisualize;
            }
            init_index_l = null;
            to_index_l = null;
        }else {
            if( to_index!==null ){
                // console.log("moviendo a afuera de layout");
                ArrayUtil.mover( item_fg, init_index_l, to_index, vm.items );
                ArrayUtil.mover( data_fg, init_index_l, to_index, vm.data );
                delete vm.items[to_index].notvisualize;
            }else {
                delete item_fg[init_index_l].notvisualize;
            }
            init_index_l = null;
            to_index = null;
        }
    }

    /**
      Funcion que se ejecuta cuando se dropea un elemento a la lista
      @param {Integer} index Indice del item que se clickeo para drag
      @param {Objeto} template Objeto que es el template del item que se movio
      @param {Integer} index_l Indice del layout al que se esta dropeando
    */
    function dropLayoutCallback(index, template, index_l){
        // console.log("dropLayoutCallback--"+index);
        // console.log(template);
        // console.log(index_l);
        drop_layout = true;
        to_item_fg = vm.items[index_l].val.element[0].fieldGroup;
        to_data_fg = vm.data[index_l].fieldGroup;
        to_item_fg_num_cols = vm.items[index_l].val.element[0].elementAttributes['num-cols'];
        if( init_index_l == null && init_index == null ){
            // si se esta jalando desde la paleta
            var tipo = template;
            template = UtilFormly.newTemplate(tipo);
            var item = newItem(template);
            if( tipo!="layout" ){
                if( to_item_fg.length < to_item_fg_num_cols ){
                    if(to_item_fg.length==0) index = 0;
                    ArrayUtil.insert( to_item_fg , index, item );
                    ArrayUtil.insert( to_data_fg, index, UtilFormly.getConfigItem(template) );
                    delete to_data_fg[index].validation;
                }else {
                    Message.error("No puede añadir mas elementos");
                }
            }else {
                Message.error("No puede añadir contenedores dentro de contenedores");
            }
        }else {
            to_index_l = index;
        }
    }

    /**
      Funcion que se dispara al añadir un elemento desde la paleta
      @param {String} tipo Tipo de template que se quiere añadir
    */
    function funcionAgregar(tipo) {
        try {
            if (vm.existe_datosGenerales && tipo == 'datosGenerales') {
                throw Error("La plantilla solo puede tener un elemento " + tipo)
            }
            if (vm.existe_certificacionComprometido && tipo == 'certificacionComprometido') {
                throw Error("La plantilla solo puede tener un elemento " + tipo)
            }
            if (vm.existe_recuperarEntregaAlmacen && tipo == 'recuperarEntregaAlmacen') {
                throw Error("La plantilla solo puede tener un elemento " + tipo)
            }
            
            if(tipo=='datosGenerales') vm.existe_datosGenerales = true;
            if(tipo=='certificacionComprometido') vm.existe_certificacionComprometido = true;
            if(tipo=='recuperarEntregaAlmacen') vm.existe_recuperarEntregaAlmacen = true;
            var template = UtilFormly.newTemplate(tipo);
            var item = newItem(template);
            vm.items.push( item );
            vm.data.push( UtilFormly.getConfigItem(template) );
            delete vm.data[vm.data.length-1].validation;
        } catch (error) {            
            if (error.name == 'Error') Message.error(error.message);
        }
    }

    /**
      Funcion que abre un panel para poder editar
      Si es un elemento radio o select modifica sus funciones al añadir o borrar elementos de los chips que son sus opciones
      @param {Objeto} item Objeto item que tiene la forma de newItem
      @param {Servicio} mdOpenMenu Servicio de angular material para abrir el menu
      @param {Evento} event Evento del servicio mdOpenMenu
    */

    function openEditItem(item, $mdOpenMenu, event){
        var ik;
        if(angular.isDefined($mdOpenMenu)) $mdOpenMenu(event);
        item.init = UtilFormly.getConfigItem(item.val.element[0]);
        if(item.val.element[0].type == "radio" || item.val.element[0].type == "select"){
            item.val.element[0].opciones = [];
            for (ik in item.val.element[0].templateOptions.options) {
                item.val.element[0].opciones.push(item.val.element[0].templateOptions.options[ik].value);
            }
            item.val.element[0].opciones.push = function() {
                Array.prototype.push.apply(this, arguments); // eslint-disable-line angular/controller-as-vm
                item.val.element[0].templateOptions.options.push({
                    value: arguments[0],
                    id: arguments[0]
                });
            };
            item.val.element[0].opciones.splice = function() {
                Array.prototype.splice.apply(this, arguments); // eslint-disable-line angular/controller-as-vm
                item.val.element[0].templateOptions.options.splice(arguments[0],arguments[1]);
            };
        }
        if(item.val.element[0].type == "lista"){
            item.val.element[0].opciones = [];
            for (ik in item.val.element[0].templateOptions.options) {
                item.val.element[0].opciones.push(item.val.element[0].templateOptions.options[ik]);
            }
            item.val.element[0].opciones.push = function() {
                Array.prototype.push.apply(this, arguments); // eslint-disable-line angular/controller-as-vm
                item.val.element[0].templateOptions.options.push( arguments[0] );
            };
            item.val.element[0].opciones.splice = function() {
                Array.prototype.splice.apply(this, arguments); // eslint-disable-line angular/controller-as-vm
                item.val.element[0].templateOptions.options.splice(arguments[0],arguments[1]);
            };
        }
    }

    function actualizarPagina(template_cite) {
        var to = template_cite.templateOptions;
        switch (to.tipoMembrete) {
            case 'sin membrete':
                vm.url_img = null;
            break;
            case 'externo':
                vm.url_img = backUrl+'public/membrete.png';
            break;
            default:
                vm.url_img = null;
            break;
        }
    }

    /**
      Funcion que actualizara la configuracion del template de un item
      @param {Objeto} item Objeto item que tiene la forma de newItem
      @param {Integer} i Indice del item que se clickeo para drag
      @param {Integer} i_l Indice del item que se clickeo para drag
    */
    function editItem(item, i, i_l){
        var xdata, xitem;
        // console.log(item);
        if(angular.isUndefined(i_l)){
            // Si se esta editando elemento del contenedor gral
            xdata = vm.items.splice(i, vm.data.length);
            xdata.shift();

            xitem = newItem();
            xitem.val.element.push(UtilFormly.getConfigItem(item.val.element[0]));
            xdata.unshift(xitem);
            vm.items = vm.items.concat(xdata);

            vm.data[i] = UtilFormly.getConfigItem(item.val.element[0]);
            if(vm.data[i].type=="layout"){
                // console.log("entra a actualizarse");
                var elements = [];
                for (var j = 0; j < vm.data[i].fieldGroup.length; j++) {
                    elements.push(UtilFormly.getConfigItem(vm.data[i].fieldGroup[j].val.element[0]));
                    delete elements[elements.length-1].validation;
                }
                vm.data[i].fieldGroup = elements;
            }
            delete vm.data[i].validation;
            if(vm.data[i].type=="cite") actualizarPagina(vm.data[i]);
        }else {
            // si se esta editando elemento dentro de un layout
            xdata = vm.items[i_l].val.element[0].fieldGroup.splice(i, vm.data[i_l].fieldGroup.length);
            xdata.shift();

            xitem = newItem();
            xitem.val.element.push(UtilFormly.getConfigItem(item.val.element[0]));
            xdata.unshift(xitem);
            vm.items[i_l].val.element[0].fieldGroup = vm.items[i_l].val.element[0].fieldGroup.concat(xdata);

            vm.data[i_l].fieldGroup[i] = UtilFormly.getConfigItem(item.val.element[0]);
            delete vm.data[i_l].fieldGroup[i].validation;
            if(vm.data[i_l].fieldGroup[i].type=="cite") actualizarPagina(vm.data[i_l].fieldGroup[i]);
        }

    }

    /**
    Funcioon que elimina un item en la posicion
    @param {Objeto} item Objeto item que tiene la forma de newItem
    @param {Integer} i Indice del item que se clickeo para eliminar
    @param {Integer} i_l Indice del layout en que se encuentra un item
    */
    function removeItem(item, i, i_l){
        if(angular.isUndefined(i_l)){
            // Si se esta eliminando elemento del contenedor gral
            if( vm.data[i].type=='datosGenerales' )
                vm.existe_datosGenerales = false;
            if( vm.data[i].type=='certificacionComprometido' )
                vm.existe_certificacionComprometido = false;
            if( vm.data[i].type=='recuperarEntregaAlmacen' )
                vm.existe_recuperarEntregaAlmacen = false;
            vm.items.splice(i, 1);
            vm.data.splice(i, 1);
        }else {
            // si se esta eliminando elemento dentro de un layout
            if( vm.data[i_l].fieldGroup[i].type=='datosGenerales' )
                vm.existe_datosGenerales = false;
            if (vm.data[i].type == 'certificacionComprometido')
                vm.existe_certificacionComprometido = false;
            if (vm.data[i].type == 'recuperarEntregaAlmacen')
                vm.existe_recuperarEntregaAlmacen = false;
            vm.items[i_l].val.element[0].fieldGroup.splice(i, 1);
            vm.data[i_l].fieldGroup.splice(i, 1);
        }
    }

    /**
        Funcion que no actualizara la configuracion del template de un item
        @param {Objeto} item Objeto item que tiene la forma de newItem
    */
    function cancelEditItem(item){
        item.val.element.shift();
        item.val.element.push(item.init);
    }

    /**
        Funcion que retorna un nuevo objeto con forma de item, si se manda template lo crea junto a el
        @param {Objeto} template Objeto template formly
    */
    function newItem(template) {
        return { val:{ element: (template)? [template] : [] , model:{} }, init: {} };
    }

    function openMenu(item, event, index, index_l) {
        var data = {
            item: item,
            index: index,
            index_l: index_l
        }

        var config = {
            event: event,
            data: data,
            clickOutsideToClose: false,
            escapeToClose:false,
            controller: ['$scope', '$mdPanel', 'data', 'mdPanelRef',PanelItemController],
            templateUrl: 'app/modules/plantillasFormly/plantillas/plantilla/item.panel.html'
        };
        Panel.show(config);
    }

    function PanelItemController($scope, $mdPanel, data, mdPanelRef) {
        var vmp = $scope;
        vmp.item = data.item;
        vmp.input_valid = null;
        vmp.validaciones = null;
        vmp.titulos = {
            datosGenerales: 'Datos generales',
            inputt: 'Asunto',
            editorTexto: 'Editor de texto',
            documentosRelacionados: 'Documentos relacionados',
            titulo: 'Título',
            subtitulo: 'Subtítulo',
            parrafo: 'Párrafo',
            lista: 'Lista',
            layout: 'Contenedor',
            vacio: 'Espacio',
            input: 'Campo de texto ',
            radio: 'Selección radio',
            select: 'Selección simple',
            select_multiple: 'Selección multiple',
            textarea: 'Area de texto',
            checkbox: 'Checkbox',
            datepicker: 'Calendario',
            slider: 'Deslizador',
            switch: 'Interruptor',
            chips: 'Palabras clave',
            cajachica: 'Caja chica',
            consultaAlmacen: 'Consultar Almacen',
            recuperarEntregaAlmacen: 'Recuperar entrega almacen',
            certificacionComprometido: 'Certificación comprometido',
            listaContactos: 'Lista de contactos',
            calendario: 'Mi calendario'
        };

        //cargamos funciones
        vmp.xeditItem = xeditItem;
        vmp.xremoveItem = xremoveItem;
        vmp.xcancelEditItem = xcancelEditItem;

        //iniciamos la edicion
        vm.openEditItem(vmp.item);
        vmp.validaciones = [
            { name: "Ninguno", pattern: "" },
            { name: "Solo texto", pattern: "([a-zA-Zñáéíóú]+ ?)+" },
            { name: "Solo números", pattern: "\\d+" },
            { name: "Texto y números", pattern: "([a-zA-Z0-9ñáéíóú]+ ?)+" },
            { name: "Hora 24hrs", pattern: '^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$' },
            { name: "Email", pattern: '^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$' }
        ];

        // console.log(data);
        function xeditItem() {
            vm.editItem(data.item, data.index, data.index_l);
            closePanel();
        }
        function xremoveItem() {
            vm.removeItem(data.item, data.index, data.index_l);
            closePanel();
        }
        function xcancelEditItem() {
            // console.log($mdPanel);
            // console.log(mdPanelRef);
            vm.cancelEditItem(data.item);
            closePanel();
        }
        function closePanel() {
            mdPanelRef && mdPanelRef.close().then(function() { mdPanelRef.destroy(); });
        }
    }

    function verPdf(){
        if( UtilFormly.sizeObj(vm.formu_prueba.$error)==0 ){
            Documento.showPdf(angular.toJson(vm.data), angular.toJson(vm.form_model), 'prueba');
        }else {
            UtilFormly.recursiveShowError(vm.formu_prueba.$error);
        }
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('DocumentoController', DocumentoController);

  /** @ngInject */
  function DocumentoController(DataService, restUrl, Modal, Message, UtilFormly, Storage, $stateParams, $location, backUrl, Panel, Documento, ExpirationTime) {
    var vm = this;
    var cuenta = Storage.getUser();

    vm.id_documento = $stateParams.idDocumento;
    vm.load = false;
    vm.model_actual = {};
    vm.form_actual = [];
    vm.doc = {};
    vm.sw_enviado = true;
    vm.sw_rechazado = false;
    vm.url_img = null;

    // cargamos funciones
    vm.cargarPlantilla = cargarPlantilla;
    vm.guardarDocumento = guardarDocumento;
    vm.enviarMultiple = enviarMultiple;
    vm.vistaPrevia = vistaPrevia;
    vm.firmar = firmar;
    vm.volverAtras = volverAtras;
    vm.verObservaciones = verObservaciones;
    vm.verDocumento = verDocumento;
    vm.copearDocumento = copearDocumento;

    iniciar();

    function iniciar() {
      vm.enviarEjecutandose=0;
        if (vm.id_documento==0) {
            // console.log(Storage.getSession('pl'));
            if(Storage.getSession("pl")!=null){
                cargarPlantilla(Storage.getSession("pl"));
                vm.sw_enviado = false;
                verificarZonaHoraria();
                vm.load = true;
                ExpirationTime.initAutoSave(guardar, false);
                Message.show('INFORMACION', 'No olvide guardar sus cambios cada 40 minutos, de lo contrario se perderán.');
            } else $location.path('documentos');
        }else {
            // console.log(restUrl + 'plantillasFormly/documento/'+vm.id_documento);
            DataService.get(restUrl + 'plantillasFormly/documento/'+vm.id_documento)
            .then(function (resultado) {
                Storage.setSession('pl', resultado.datos);
                if(resultado.datos._usuario_creacion!=cuenta.id)
                    $location.path('documentos');
                cargarPlantilla(resultado.datos, true);
                vm.sw_rechazado = (resultado.datos.estado=="RECHAZADO")? true : false;
                vm.sw_enviado = ( resultado.datos.estado!="NUEVO" && !vm.sw_rechazado)? true : false;
                // deshabilitamos todos los campos para
                UtilFormly.disableForm(vm.form_actual, vm.sw_enviado);
                if(vm.sw_enviado){
                    var flujo = {
                        via_actual: resultado.datos.via_actual,
                        para: angular.fromJson(resultado.datos.para),
                        via: angular.fromJson(resultado.datos.via)
                    };
                    Storage.setSession('flujo_doc',flujo);
                }
                ExpirationTime.initAutoSave(guardar, vm.sw_enviado);
                Message.show('INFORMACION', 'No olvide guardar sus cambios cada 40 minutos, de lo contrario se perderán.');
                verificarZonaHoraria();
                vm.load = true;
            });
        }
    }
    function verificarZonaHoraria() {
      var es_zona_horaria_bolivia = true, offset;
      var data = angular.fromJson(vm.doc.plantilla);
      for (var i = 0; i < data.length; i++) {
        if (data[i].type=="layout") {
            for (var j = 0; j < data[i].fieldGroup.length; j++) {
              if (vm.form_actual[i].fieldGroup[j].type=='datepicker'){
                offset = new Date().getTimezoneOffset();
                es_zona_horaria_bolivia = (offset==240);
              }
            }
        } else {
          if (vm.form_actual[i].type=='datepicker'){
            offset = new Date().getTimezoneOffset();
            es_zona_horaria_bolivia = (offset==240);
          }
        }
        if (!es_zona_horaria_bolivia) break;
      }

      if (!es_zona_horaria_bolivia && !vm.sw_enviado) abrirDialogError('timeZone');
    }

    function copearDocumento() {
        Modal.confirm('¿Esta seguro de que quiere crear otro documento igual a este?', function () {
            var model = angular.copy(vm.model_actual);
            delete model['cite-0'];
            
            if (model['listaContactos-0'] && model['listaContactos-0'].contacto) {
                delete model['listaContactos-0'].contacto;
            }
            
            var pl = {
                nombre: vm.doc.nombre_plantilla,
                nombre_plantilla: vm.doc.nombre_plantilla,
                abreviacion: vm.doc.abreviacion,
                plantilla: vm.doc.plantilla,
                plantilla_valor: angular.toJson(model),
                observaciones: null
            };
            
            
            var verificar = {
              nombre: pl.nombre,
              abreviacion: pl.abreviacion,
              plantilla: pl.plantilla
            };
            
            DataService.post(restUrl + 'plantillasFormly/plantilla_formly/verificar', verificar)
            .then(function respuesta (respuesta) {
              if(respuesta.datos.valido === true) {
                Storage.setSession('pl',pl);
                $location.path('documento/0');
              }
              else {
                Message.show('ERROR', 'La plantilla ya no existe o no se encuetra activa. El documento no se puede duplicar.');
              }
            });
        });
    }

    function cargarPlantilla(pl, model) {

        vm.model_actual = (pl.plantilla_valor==null)? {} : angular.fromJson(pl.plantilla_valor);
        if(model)
            vm.form_actual = UtilFormly.dataToView(angular.fromJson(pl.plantilla), vm.model_actual);
        else
            vm.form_actual = UtilFormly.dataToView(angular.fromJson(pl.plantilla));

        actualizarPagina(vm.form_actual[0]);

        vm.doc.nombre = (model)? pl.nombre : pl.nombre+' - '+cuenta.first_name+' '+cuenta.last_name;
        vm.doc.nombre_plantilla = (model)? pl.nombre_plantilla : pl.nombre;
        vm.doc.abreviacion = pl.abreviacion;
        vm.doc.plantilla = pl.plantilla;
        vm.doc.observaciones = (model)? pl.observaciones : null;
        vm.sw_es_respuesta = pl.documento_padre || false;
        if(vm.sw_es_respuesta) {
            vm.doc.documento_padre = pl.documento_padre;
        }

        vm.sw_grupo = pl.grupo || false;
        if(vm.sw_grupo) {
            // obtener documentos de grupo
            DataService.get(restUrl + 'plantillasFormly/documento/?fields=id_documento,nombre,nombre_plantilla&estado=DERIVADO,CERRADO,APROBADO&sort=_fecha_creacion&grupo='+pl.grupo)
            .then(function (resultado) {
                vm.docs_grupo = resultado.datos.resultado;
            });
        }

    }

    function verDocumento(id_doc) { Documento.showPdfId(id_doc, false); }

    function actualizarPagina(template_cite) {
        var to = template_cite.templateOptions || 'sin membrete';
        switch (to.tipoMembrete) {
            case 'sin membrete':
                vm.url_img = null;
            break;
            case 'externo':
                vm.url_img = backUrl+'public/membrete.png';
            break;
        }
    }

    function agregarFlujo(documento, enviar) {
        if(enviar){
            var k, key, arr, i;
            k = key = "para";
            documento[k] = angular.toJson([vm.model_actual["datosGenerales-0"][key].id_usuario]);

            k = key = "via";
            arr = vm.model_actual["datosGenerales-0"][key] || [];
            documento[k] = [];
            for (i = 0; i < arr.length; i++) {
                documento[k].push(arr[i].id_usuario);
            }
            documento[k] = angular.toJson(documento[k].reverse());

            k = key = "de";
            arr = vm.model_actual["datosGenerales-0"][key];
            documento[k] = [];
            for (i = 0; i < arr.length; i++) {
                documento[k].push(arr[i].id_usuario);
            }
            documento[k] = angular.toJson(documento[k]);

            k = "referencia" ; key = "ref";
            documento[k] = vm.model_actual["datosGenerales-0"][key];
        }
    }
    function transformarModel(model) {
        // archivos
        var i = 0, arch;
        while (i!=-1) {
            arch = model['archivo-'+i];
            if(angular.isUndefined(arch)) break;
            if(angular.isUndefined(arch.length)){
                model['archivo-'+i] = [arch];
            }
            i++;
        }
        return angular.toJson(model);
    }

    function guardar(enviar, sw_location){
      if(vm.enviarEjecutandose > 1) {
        return;
      }
      var documento = {
          nombre: vm.doc.nombre,
          nombre_plantilla: vm.doc.nombre_plantilla,
          abreviacion: vm.doc.abreviacion,
          plantilla: vm.doc.plantilla,
          plantilla_valor: transformarModel(angular.copy(vm.model_actual))
      };

      if(vm.sw_es_respuesta) {
        documento.documento_padre = vm.doc.documento_padre;
      }

      if (!vm.sw_enviado) agregarFlujo(documento, enviar);
      // console.log(documento);
      if ( vm.id_documento==0 ) {
          documento._usuario_creacion = cuenta.id;
      }else {
          documento._usuario_modificacion = cuenta.id;
          documento.id = vm.id_documento;
      }
      documento.sw = {
          enviar: enviar,
          enviado: vm.sw_enviado,
          es_respuesta: vm.sw_es_respuesta
      };

      DataService.save( restUrl+'plantillasFormly/documento/', documento)
      .then(function (respuesta) {
        if (respuesta) {
          if(!sw_location){
              Message.show(respuesta.tipoMensaje, respuesta.mensaje);
              $location.path('documentos');
              Storage.removeSession('pl');
          }else if(vm.id_documento==0) $location.path('documento/'+respuesta.datos.id_documento);
        }
          vm.enviarEjecutandose=0;
      });
    }

    function guardarDocumento(enviar) {
      vm.enviarEjecutandose += 1;
        // Valida si es para enviar.
        if(enviar){
          if( UtilFormly.sizeObj(vm.formu.$error)==0 ){
              guardar(enviar);
          }else {
            var adjuntoCD = false;
            if (vm.formu.$error.accept && UtilFormly.sizeObj(vm.formu.$error)==1) {
              var json = vm.formu.$error.accept[0] || {};
              for (var key in json) {
                if (json.hasOwnProperty(key) && key.indexOf('pdfsAprobacionCD') != -1)
                  adjuntoCD = true;
              }
            }
            if (adjuntoCD) guardar(enviar);
            else {
            UtilFormly.recursiveShowError(vm.formu.$error);
            Message.show("ERROR", 'Debe llenar todos los campos marcados con rojo porque son requeridos'.toUpperCase());
            abrirDialogError('formu');
            vm.enviarEjecutandose=0;
            }
          }
        }
        else{
          guardar();

        }

    }
    
    function enviarMultiple() {
        if (vm.enviarEjecutandose > 1) {
          return;
        }
        var documento = {
          nombre: vm.doc.nombre,
          nombre_plantilla: vm.doc.nombre_plantilla,
          abreviacion: vm.doc.abreviacion,
          plantilla: vm.doc.plantilla,
          plantilla_valor: transformarModel(angular.copy(vm.model_actual))
        };

        if (vm.sw_es_respuesta) {
          documento.documento_padre = vm.doc.documento_padre;
        }

        if (!vm.sw_enviado) agregarFlujo(documento, true);
        // console.log(documento);
        if (vm.id_documento == 0) {
          documento._usuario_creacion = cuenta.id;
        } else {
          documento._usuario_modificacion = cuenta.id;
          documento.id = vm.id_documento;
        }
        documento.sw = {
          enviar: true,
          enviado: vm.sw_enviado,
          es_respuesta: vm.sw_es_respuesta
        };

        DataService.save(restUrl + 'plantillasFormly/documento/', documento)
        .then(function (respuesta) {
            // if (!sw_location) {
            //     Message.show(respuesta.tipoMensaje, respuesta.mensaje);
            //     $location.path('documentos');
            //     Storage.removeSession('pl');
            // } else 
            if (vm.id_documento == 0) $location.path('documento/' + respuesta.datos.id_documento);
            vm.enviarEjecutandose = 0;
        });
    }


    function abrirDialogError(tipo){
      var config = {
        data: tipo,
        templateUrl: 'app/modules/plantillasFormly/documentos/documento/dialogError.html',
        controller: ['data', '$scope', '$mdDialog', DialogErrorController]
      }
      Modal.show(config);
    }

    function DialogErrorController(data, $scope, $mdDialog){
      var vmd = $scope;
      vmd.data={tipo:data};

      vmd.cerrar= function(){
        $mdDialog.cancel();
      }
    }

    function volverAtras() {
        $location.path('documentos');
    }

    function vistaPrevia(){
      if ( UtilFormly.sizeObj(vm.formu.$error)==0 ){
        Documento.showPdf(vm.doc.plantilla, angular.toJson(vm.model_actual), vm.doc.nombre);
      }
      else if (vm.sw_enviado && vm.id_documento) {
        Documento.showPdfId(vm.id_documento);
      }
      else {
        Message.show('INFORMACION', 'Antes de visualizar el documento debe llenar todos los campos requeridos.');
        UtilFormly.recursiveShowError(vm.formu.$error);
      }
    }

    function firmar(){
        var config = {
            data: "", //datosEnviar,
            templateUrl: 'app/modules/firmador/modules.firmador.html',
            controller: ['data', '$scope', '$mdDialog', 'Util', 'DemofiService', DialogFirmadorController]
        }
        Modal.show(config);
    }

    function DialogFirmadorController(data, $scope, $mdDialog, Util, DemofiService){
        var vmd = $scope;
        vmd.data={};

        //valores para firma digital
        vmd.iniciado = false;
        vmd.pin = undefined;
        vmd.tokens = [];
        vmd.certificados = [];
          //this.$scope.firmados = 0;
        vmd.iniciado = false;
        vmd.iniciando = false;
        vmd.certificado_seleccionado = undefined;
          //this.$scope.solicitudes = data.solicitudes;
        vmd.autenticado = false;
        vmd.autenticando = false;
          //this.$scope.firmando = false;
        vmd.demofi_ejecutandose = false;
        vmd.token_conectado = false;
        vmd.boton_autenticar_habilitado = false;
        vmd.mostrar_progress = false;


        vmd.data.html=data.html;
        vmd.data.pdf=data.pdf;
        vmd.data.flag_html=true;
        vmd.data.show_pdf=!data.esDispositivoMovil;
        if (data.esDispositivoMovil) {
            Util.loadCanvas(data.pdf_buffer, '#canvasContainer');
        }

        //funciones

        /*vmd.cerrar = function (){ $mdDialog.cancel(); }
        vmd.verHtml = function(){ vmd.data.flag_html=true; }
        vmd.verPdf = function(){ vmd.data.flag_html=false; }*/


        vmd.verificarTokenConectado = verificarTokenConectado;
        vmd.autenticar = autenticar;
        vmd.cancelar = cancelar;
        vmd.verificarServidor = verificarServidor;

        verificarTokenConectado();

        function verificarTokenConectado() {
            if (vmd.iniciando === false) {
                vmd.iniciando = true;
                DemofiService.listTokens()
                .then( function (response) {
                    // this.$log.log('verificarTokenConectado-then', response)
                    vmd.iniciando = false;
                    vmd.iniciado = true;
                    vmd.demofi_ejecutandose = true;
                    vmd.tokens = response.datos;
                    vmd.token_conectado = response.datos.length > 0;
                })
                .catch( function () {
                    // this.$log.log('verificarTokenConectado-catch', error)
                    vmd.iniciando = false;
                    vmd.iniciado = true;
                    vmd.token_conectado = false;
                    vmd.demofi_ejecutandose = false;
                });

                /*vmd.iniciando = false;
                vmd.iniciado = true;
                vmd.demofi_ejecutandose = true;
                vmd.tokens = ["FT ePass2003Auto"]; //{"datos":["FT ePass2003Auto"],"finalizado":true,"mensaje":"Tokens detectados"};
                vmd.token_conectado = true; //response.datos.length > 0; */
            }
        }

        function autenticar() {
            vmd.mostrar_progress = true;
            vmd.autenticando = true;
            //this.cancelInterval();
            //this.Loading.show('Cargando', true);
            DemofiService.login(vmd.pin)
            .then(function (respLogin) {
                //this.$log.log(respLogin);
                vmd.mostrar_progress = false;
                vmd.autenticando = false;
                if (respLogin.finalizado === true) {
                    vmd.boton_autenticar_habilitado = false;
                    // Obtener certificados
                    vmd.autenticado = true;
                    // Una ves autenticado actualizamos la lista de certificados
                    DemofiService.listCertificates()
                    .then(function (respCert) {
                        vmd.certificados = respCert.datos;
                        if (vmd.certificados[0]) {
                            vmd.certificado_seleccionado = vmd.certificados[0];
                        }
                    });
                }
            })
            .catch( function () {
                // this.$log.log(error);
                vmd.mostrar_progress = false;
                vmd.autenticando = false;
                vmd.pin = undefined;
                vmd.autenticado = false;
                vmd.boton_autenticar_habilitado = true;
                //this.Message.warning(error.mensaje);
                //this.initInterval();
            });
        }

        function verificarServidor() {
            DemofiService.verificarServidor();
        }

        function cancelar() {
            $mdDialog.cancel();
        }
    }


    function verObservaciones(event) {
        var data = {
            observacion: vm.doc.observaciones || 'El documento esta mal'
        }
        var config = {
            event: event,
            data: data,
            controller: ['$scope', 'data', 'mdPanelRef',PanelItemController],
            templateUrl: 'app/modules/plantillasFormly/documentos/documento/observacion.panel.html'
        };
        Panel.show(config);
    }

    function PanelItemController($scope, data, mdPanelRef) {
        var vmp = $scope;
        vmp.observacion = data.observacion;

        //cargamos funciones
        vmp.closePanel = closePanel;

        function closePanel() {
            mdPanelRef && mdPanelRef.close().then(function() { mdPanelRef.destroy(); });
        }
    }


  }
})();


(function () {
  'use strict';

  angular
    .module('app')
    .controller('CompartidoController', CompartidoController);

  /**@ngInject */
  function CompartidoController(DataService, restUrl, Storage, $stateParams, Message, $location, Documento, $timeout, $filter) {
    var vm = this;
    var cuenta = Storage.getUser();
    vm.id_catalogo = $stateParams.idCompartido;
    vm.data = {
      usuarios: [],
      documentos: []
    };
    vm.esEditor = false;
    vm.buscarDocumento = buscarDocumento;
    vm.guardarModificarDocumento = guardarModificarDocumento;
    vm.volverAtras = volverAtras;

    iniciar();

    function iniciar() {
      inicializarConfiguracionTablas();
      if (vm.id_catalogo == 0) {
        Message.show('ERROR', 'Identificador no valido.');
        $location.path('compartidos')
      } else {
        DataService.get(restUrl + 'plantillasFormly/catalogo/' + vm.id_catalogo+'?filter=true')
        .then(function (resp) {
          if (!resp) {
            Message.show('ERROR', 'El catalogo no pudo ser encontrado.');
            $location.path('compartidos');
          }
          var esValido = false;
          
          for (var i = 0; i < resp.datos.usuarios.length; i++) {
            var usuario = resp.datos.usuarios[i];
            if (usuario.fid_usuario == cuenta.id) {
              esValido = true;
              vm.esEditor = usuario.escritura;
            }
          }
          angular.forEach(resp.datos.documentos, function (item) {
            if (item._usuario_creacion == cuenta.id) {
              item.esCreador = true;
            }
          });
          if (esValido == false) {
            Message.show('ERROR', 'Usted no se encuentra autorizado para ver este catalogo.');
            $location.path('compartidos');
          }
          vm.data = resp.datos;

          vm.data.documentos = $filter("orderBy")(resp.datos.documentos,"orden", false);

        });
      }
    }

    function guardarModificarDocumento() {
      if (vm.documento && vm.documento.id_catalogo_documento && vm.documento.fid_documento && vm.documento.fid_catalogo) return guardarCambiosDocumento();
      return agregarDocumento();
    }

    function guardarCambiosDocumento() {
      var datos = {
        fid_catalogo: vm.documento.fid_catalogo,
        actualizar: {
          descripcion: vm.documento.descripcion
        }
      };
      aplicarCambio(vm.documento.id_catalogo_documento, "documento", datos);
      $timeout(function () {
        vm.documento = {};
        return iniciar();
      }, 300);
    }

    function iniciarEdicionDocumento(ev, item) {
      vm.documento = angular.copy(item);
      vm.documento.editar = true;
    }

    /**
     * Inicializa las cabeceras de las tablas y la configuracion de los botones de acción
     * las tablas son de documentos y usuarios
     * @returns Un vector de objetos
     */
    function inicializarConfiguracionTablas() {
      vm.camposDocumentos = [{
          field_value: 'nombre',
          field_name: 'Documento'
        },
        {
          field_value: 'descripcion',
          field_name: 'Descripción'
        }
      ]
      vm.botonesDocumentos = [
        {
          tooltip: 'Ver documento',
          icon: 'remove_red_eye',
          onclick: verDocumento
        },
        {
          tooltip: "Editar",
          icon: "create",
          onclick: iniciarEdicionDocumento,
          condition: {
            field: "esCreador",
            is: true
          }
        }
      ];
      vm.camposUsuarios = [
        {
          field_value: 'nombres',
          field_name: 'Nombres'
        },
        {
          field_value: 'apellidos',
          field_name: 'Apellidos'
        }
      ];
      vm.botonesUsuarios = [];
    }

    function verDocumento(ev, item) {
      ev.preventDefault();
      Documento.showPdfId(item.fid_documento);
    }

    function buscarDocumento() {
      if (!vm.buscar_documento || vm.buscar_documento == "")
        Message.show("ADVERTENCIA", "Escriba el cite del documento a buscar.");
      var datos = {
        cite: vm.buscar_documento
      };
      DataService.post(
        restUrl + "plantillasFormly/catalogo/documento/",
        datos
      ).then(function (resp) {
        if (resp) {
          vm.documento = resp.datos;
        } else {
          vm.documento = {};
        }
      });
    }

    function agregarDocumento() {
      if (
        !vm.documento ||
        !vm.documento.nombre ||
        !vm.documento.id_documento ||
        !vm.documento.descripcion
      ) {
        Message.show("ERROR", "Los datos del documento estan incompletos.");
        return;
      }
      vm.documento.estado = "ACTIVO";
      if (!vm.documento.fid_documento)
        vm.documento.fid_documento = vm.documento.id_documento;
      vm.data.documentos.push(vm.documento);
      vm.documento = {};
      vm.buscar_documento = null;

      // TODO: Reutilizar el servicio de guardado
      // TODO: Revisar el backend para que no duplique documentos ya agregados
      guardarCatalogo();
    }

    function guardarCatalogo() {
      if (vm.id_catalogo == 0) {
        DataService.post(restUrl + "plantillasFormly/catalogo", vm.data).then(
          function (resp) {
            $timeout(function () {
              $location.path("catalogo/" + resp.datos.id_catalogo);
            }, 300);
          }
        );
      }
      // Actualizar catalogo
      else {
        DataService.put(
          restUrl + "plantillasFormly/catalogo/" + vm.id_catalogo,
          vm.data
        ).then(function () {
          iniciar();
        });
      }
    }

    function aplicarCambio(id, ruta, datos) {
      DataService.put(restUrl+'plantillasFormly/catalogo/'+ruta+'/'+id, datos);
    }

    function volverAtras() {
      $location.path("catalogos");
    }

  }
})();
(function () {
  'use strict';

  angular
  .module('app')
  .controller('CatalogoController', CatalogoController);

  /**@ngInject */
  function CatalogoController(DataService, restUrl, Storage, $stateParams, Message, $location, Documento, $timeout, Modal, $filter) {
    var vm = this;
    var cuenta = Storage.getUser();
    vm.id_catalogo = $stateParams.idCatalogo;
    vm.esPropietario= false;
    vm.esModificacionNombre = false;
    vm.nombreAntiguo = '';
    vm.documentosDic = {};
    
    vm.data = {
      usuarios: [],
      documentos: []
    };
    vm.usuarios = [];
    vm.dic_estado = {
      'ACTIVO': 'INACTIVO',
      'INACTIVO': 'ACTIVO'
    }
    vm.buscarUsuario = buscarUsuario;
    vm.autorizarUsuario = autorizarUsuario;
    vm.buscarDocumento = buscarDocumento;
    vm.agregarDocumento = agregarDocumento;
    vm.guardarCatalogo = guardarCatalogo;
    vm.volverAtras = volverAtras;
    vm.escucharCambioNombre = escucharCambioNombre;
    vm.subirOrdenDocumento = subirOrdenDocumento;
    vm.bajarOrdenDocumento = bajarOrdenDocumento;
    vm.actualizarMultiple = actualizarMultiple;
    vm.construirActualizacionOrden = construirActualizacionOrden;
    vm.guardarCambiosDocumento = guardarCambiosDocumento;
    vm.guardarModificarDocumento = guardarModificarDocumento;
    iniciar();
    

    function iniciar() {
      inicializarConfiguracionTablas();
      if (vm.id_catalogo == 0) {
        Message.show('INFORMACION', 'No olvide guardar sus cambios, de lo contrario se perderán.');
      }
      else {
        DataService.get(restUrl+'plantillasFormly/catalogo/'+vm.id_catalogo)
        .then(function (resp) {
          if (resp.datos.propietario != cuenta.id) $location.path('catalogos');
          vm.data = resp.datos;
          vm.data.usuarios = resp.datos.usuarios;
          if (vm.data.propietario == cuenta.id) {
            vm.esPropietario = true;
            vm.data.comentario = "";
            vm.nombreAntiguo = vm.data.nombre;
          }
          vm.data.documentos = $filter("orderBy")(resp.datos.documentos,"orden", false);
          angular.forEach(vm.data.documentos, function (item) {
            if (item._usuario_creacion == cuenta.id) {
              item.esCreador = true;
            }
          });
        });
      }
    }

    function guardarModificarDocumento() {
      if (vm.documento && vm.documento.id_catalogo_documento && vm.documento.fid_documento && vm.documento.fid_catalogo) return guardarCambiosDocumento();
      return agregarDocumento();
    }

    function iniciarEdicionDocumento(ev, item) {
      vm.documento = angular.copy(item);
      vm.documento.editar = true;
    }

    function buscarDocumento() {
      
      if (!vm.buscar_documento || vm.buscar_documento == '') Message.show('ADVERTENCIA', 'Escriba el cite del documento a buscar.');
      var datos = {
        cite: vm.buscar_documento
      }
      DataService.post(restUrl+'plantillasFormly/catalogo/documento/', datos)
      .then(function (resp) {
        if (resp) {
          vm.documento = resp.datos;
        }
        else {
          vm.documento = {};
        }
      });
      
    }

    function guardarCambiosDocumento() {
      var datos = {
        fid_catalogo: vm.documento.fid_catalogo,
        actualizar: {
          descripcion: vm.documento.descripcion
        }
      };
      aplicarCambio(vm.documento.id_catalogo_documento, "documento", datos);
      $timeout(function () {
        vm.documento = {};
        return iniciar();
      }, 300);
    }


    function agregarDocumento() {
      if (!vm.documento || !vm.documento.nombre || !vm.documento.id_documento || !vm.documento.descripcion) {
        Message.show('ERROR', 'Los datos del documento estan incompletos.');
        return;
      }
      vm.documento.estado = 'ACTIVO';
      vm.documento.orden = vm.data.documentos.length + 1;
      if (!vm.documento.fid_documento) vm.documento.fid_documento = vm.documento.id_documento;
      vm.data.documentos.push(vm.documento);
      vm.documento = {};
      vm.buscar_documento = null;

      guardarCatalogo();
    }

    function verDocumento(ev,item) {
      ev.preventDefault();
      Documento.showPdfId(item.fid_documento);
    }

    function cambiarEstadoUsuario(ev, item) {
      ev.preventDefault();
      var datos = {
        fid_catalogo: item.fid_catalogo,
        actualizar: {
          estado: vm.dic_estado[item.estado]
        }
      };
      aplicarCambio(item.id_catalogo_usuario, 'usuario', datos);
      $timeout(function () {
        iniciar();
      }, 300);
    }

    function cambiarPermisoEdicion(ev, item) {
      ev.preventDefault();

      var datos = {
        fid_catalogo: item.fid_catalogo,
        actualizar: {
          escritura: !item.escritura
        }
      };
      aplicarCambio(item.id_catalogo_usuario, "usuario", datos);
    }
    function cambiarPermisoLectura(ev, item) {
      ev.preventDefault();

      var datos = {
        fid_catalogo: item.fid_catalogo,
        actualizar: {
          lectura: !item.lectura
        }
      };
      aplicarCambio(item.id_catalogo_usuario, "usuario", datos);
      $timeout(function () {
        iniciar();
      }, 300);
    }

    function cambiarEstadoDocumento(ev, item) {
      ev.preventDefault();
      var datos = {
        fid_catalogo: item.fid_catalogo,
        actualizar: {
          estado: vm.dic_estado[item.estado]
        }
      };
      aplicarCambio(item.id_catalogo_documento, 'documento', datos);
      $timeout(function () {
        iniciar();
      }, 300);
    }
    
    function aplicarCambio(id, ruta, datos) {
      DataService.put(restUrl+'plantillasFormly/catalogo/'+ruta+'/'+id, datos);
    }

    function buscarUsuario() {
      if (!vm.buscar_usuario || vm.buscar_usuario == '') return;
      DataService.get(restUrl + 'seguridad/usuario/catalogo?fields=id_usuario,nombres,apellidos,estado&filter=' + vm.buscar_usuario)
      .then(function (resp) {
        filtrarUsuarios(resp.datos.resultado);
      });
    }

    function autorizarUsuario(ev, usuario) {
      if (!usuario.fid_usuario) usuario.fid_usuario = usuario.id_usuario;
      var existe = false;
      if (!vm.data.usuarios) vm.data.usuarios = [];
      vm.data.usuarios.forEach(function (item) {
        if (item.id_usuario == usuario.id_usuario) {
          existe = true;
        }
      });

      if (existe !== true) {
        vm.data.usuarios.push(usuario);
        guardarCatalogo();
        filtrarUsuarios();
      }
    }

    // FIXME: Verificar el correcto funcionamiento y la logica
    function filtrarUsuarios(usuarios) {
      if (!vm.data.usuarios || vm.data.usuarios.length == 0) {
        vm.usuarios = usuarios? usuarios: [];
        return;
      }
      var lista = vm.usuarios;
      if (usuarios) {
        if (lista.length == 0) lista = usuarios;
        else lista = usuarios;
      }
      var enUso = vm.data.usuarios;
      var listaLimpia = [];
      for (var i = 0; i < lista.length; i++) {
        var usado = false;
        var item = null;
        for (var j = 0; j < enUso.length; j++) {
          item = lista[i];
          if (enUso[j].id_usuario == lista[i].id_usuario) {
            usado = true;
            break;
          }
        }
        if (usado == false && item != null ) {
          listaLimpia.push(item)
        }
      }
      vm.usuarios = listaLimpia;
    }

    function guardarCatalogo() {
      if (vm.id_catalogo == 0) {
        DataService.post(restUrl+'plantillasFormly/catalogo', vm.data)
        .then(function () {
          $timeout(function () {
            volverAtras();
          }, 300);
        });
      }
      else {
        DataService.put(restUrl+'plantillasFormly/catalogo/'+vm.id_catalogo, vm.data)
        .then(function () {
          $timeout(function () {
            iniciar();
            volverAtras();
          }, 300);
        })
      }
    }

    function volverAtras() {
      $location.path('catalogos');
    }

    function escucharCambioNombre() {
      if (vm.data.nombre != vm.nombreAntiguo) {
        vm.esModificacionNombre = true;
      }
    }
    function subirOrdenDocumento (ev, item, indice) {
      var listaActualizar = [];
      listaActualizar.push(vm.construirActualizacionOrden(indice, indice-1));
      listaActualizar.push(vm.construirActualizacionOrden(indice-1, indice));
      vm.actualizarMultiple(listaActualizar);
      $timeout(function () {
        iniciar();
      }, 350);
    }
    
    function actualizarMultiple(lista) {
      angular.forEach(lista, function (item) {
        aplicarCambio(item.id_catalogo_documento, "documento", item);
      });
    }
    function construirActualizacionOrden(indice, orden) {
      var temp = vm.data.documentos[indice]
      return {
        actualizar: { orden: orden },
        fid_catalogo: temp.fid_catalogo,
        fid_documento: temp.fid_documento,
        id_catalogo_documento: temp.id_catalogo_documento
      };
    }
    function bajarOrdenDocumento (ev, item, indice) {
      var listaActualizar = [];
      listaActualizar.push({
        actualizar: { orden: indice + 1 },
        fid_catalogo: item.fid_catalogo,
        fid_documento: item.fid_documento,
        id_catalogo_documento: item.id_catalogo_documento
      });
      var documentoTemp = vm.data.documentos[indice + 1];
      listaActualizar.push({
        actualizar: { orden: indice },
        fid_catalogo: documentoTemp.fid_catalogo,
        fid_documento: documentoTemp.fid_documento,
        id_catalogo_documento: documentoTemp.id_catalogo_documento
      });
      vm.actualizarMultiple(listaActualizar);
      $timeout(function () {
        iniciar();
      }, 350);
    }

    /**
     * Inicializa las cabeceras de las tablas y la configuracion de los botones de acción
     * las tablas son de documentos y usuarios
     * @returns Un vector de objetos
     */
    function inicializarConfiguracionTablas() {
      vm.camposDocumentos = [{
          field_value: 'nombre',
          field_name: 'Documento'
        },
        {
          field_value: 'descripcion',
          field_name: 'Descripción'
        }
      ]
      vm.botonesDocumentos = [
        {
          tooltip: "Ver documento",
          icon: "remove_red_eye",
          onclick: verDocumento
        },
        {
          tooltip: "Editar",
          icon: "create",
          onclick: iniciarEdicionDocumento,
          condition: {
            field: "esCreador",
            is: true
          }
        },
        {
          tooltip: "Activar",
          icon: "done",
          onclick: cambiarEstadoDocumento,
          condition: {
            field: "estado",
            is: "INACTIVO"
          }
        },
        {
          tooltip: "Inactivar",
          icon: "clear",
          onclick: cambiarEstadoDocumento,
          condition: {
            field: "estado",
            is: "ACTIVO"
          }
        },
        {
          tooltip: "Subir",
          icon: "keyboard_arrow_up",
          onclick: subirOrdenDocumento,
          condition: {
            type: "defaultUp"
          }
        },
        {
          tooltip: "Bajar",
          icon: "keyboard_arrow_down",
          onclick: bajarOrdenDocumento,
          condition: {
            type: "defaultDown"
          }
        }
        
      ];
      vm.camposUsuarios = [{
          field_value: 'nombres',
          field_name: 'Nombres'
        },
        {
          field_value: 'apellidos',
          field_name: 'Apellidos'
        }
      ];
      vm.botonesUsuarios = [
        {
          tooltip: "Activar",
          icon: "done",
          onclick: cambiarEstadoUsuario,
          condition: {
            field: "estado",
            is: "INACTIVO"
          }
        },
        {
          tooltip: "Inactivar",
          icon: "clear",
          onclick: cambiarEstadoUsuario,
          condition: {
            field: "estado",
            is: "ACTIVO"
          }
        },
        {
          tooltip: "No puede ver",
          icon: "remove_red_eye",
          onclick: cambiarPermisoLectura,
          condition: {
            field: "lectura",
            is: false,
            class: "botonDesactivado"
          }
        },
        {
          tooltip: "Puede ver",
          icon: "remove_red_eye",
          onclick: cambiarPermisoLectura,
          condition: {
            field: "lectura",
            is: true,
            class: "botonActivado"
          }
        },
        {
          tooltip: "No puede modificar",
          icon: "create",
          onclick: cambiarPermisoEdicion,
          condition: {
            field: "escritura",
            is: false,
            class: "botonDesactivado"
          }
        },
        {
          tooltip: "Puede modificar",
          icon: "create",
          onclick: cambiarPermisoEdicion,
          condition: {
            field: "escritura",
            is: true,
            class: "botonActivado"
          }
        }
      ];
    }

  }
})();

(function () {
  'use strict';

  angular
  .module('app')
  .controller('fcRecuperarEntregaAlmacenController', RecuperarEntregaAlmacen);

  /**@ngInject */
  function RecuperarEntregaAlmacen($scope, $timeout, DataService, restUrl, Message, Storage) {
    var vm = this;
    var sc = $scope;

    sc.vm = vm;

    vm.buscar = {};
    vm.recuperarEntrega = recuperarEntrega;
    vm.activar_busqueda = true;

    $timeout(iniciarController);

    function iniciarController() {
      vm.items = [];
      var datosPlantilla = Storage.getSession('pl');
      if (angular.isUndefined(sc.model[sc.options.key])) {
        sc.model[sc.options.key] = {
          solicitado_por: {
            nombre_completo: null,
            cargo: null
          },
          entregado_por: {
            nombre_completo: null,
            cargo: null
          },
          fecha_entrega:null,
          filas: []
        };
      }
      if (datosPlantilla.grupo) {
        obtenerFlujo(datosPlantilla.grupo);
      }
    }

    function recuperarEntrega(cite, automatico) {
      var citeBuscar = vm.cite_buscar;
      if (angular.isUndefined(vm.cite_buscar) && angular.isUndefined(cite)) {
        return;
      }
      if (angular.isUndefined(vm.cite_buscar) && angular.isDefined(cite)) {
        citeBuscar = cite;
      }
      var url = restUrl+'almacen/recuperar';
      return DataService.post(url, {cite: citeBuscar})
      .then(function (respuesta) {
        if (angular.isUndefined(respuesta)) return;
        sc.model[sc.options.key].filas = respuesta.datos.items;
        sc.model[sc.options.key].fecha_entrega = respuesta.datos.cabecera.fecha_entrega;
        sc.model[sc.options.key].entregado_por.nombre_completo = respuesta.datos.cabecera.entregado_por;
        sc.model[sc.options.key].solicitado_por.nombre_completo = respuesta.datos.cabecera.solicitado_por;
        sc.model[sc.options.key].cite_sms = respuesta.datos.cite_sms;
        sc.model[sc.options.key].id_solicitud = respuesta.datos.id_solicitud;
        if (automatico && automatico == true) {
          sc.model[sc.options.key].consultado = true;
        }
        if (sc.model[sc.options.key].consultado == true && sc.model[sc.options.key].filas.length > 0) {
          vm.activar_busqueda = false;
        }
      });
    }

    function obtenerFlujo(grupo) {
      var grupoDocPadre = grupo;
      var docsFlujo = [];
      var citeSolicitud = null;
      var abreviacionSolicitud = sc.options.templateOptions.solicitud;
      if (sc.model[sc.options.key].consultado == true && sc.options.templateOptions.manual == false) {
        vm.activar_busqueda = false;
        return;
      }
      if (angular.isUndefined(grupo)) {
        if (sc.model[sc.options.key].consultado == true && sc.model[sc.options.key].filas.length > 0) {
          vm.activar_busqueda = false;
          return;
        }
      }
      DataService.get(restUrl + 'plantillasFormly/documento/?fields=id_documento,nombre,nombre_plantilla,grupo&estado=DERIVADO,CERRADO,APROBADO&sort=_fecha_creacion&grupo='+grupoDocPadre)
      .then(function (respuesta) {
        docsFlujo = respuesta.datos.resultado;

        for (var i = 0; i < docsFlujo.length; i++) {
          // TODO: esta abreviacion debe venir en el componente
          if (docsFlujo[i].nombre.indexOf('/'+abreviacionSolicitud+'/') > -1) {
            citeSolicitud = docsFlujo[i].nombre;
          }
        }
        if (citeSolicitud == null) {
          Message.show('INFO', 'No se encontro una solicitud en el flujo.');
          vm.activar_busqueda = true;
          return;
        }
        recuperarEntrega(citeSolicitud, true);
      });
      
    }

  }
})();
(function () {
  'use strict';

  angular
  .module('app')
  .controller('fcConsultaAlmacenController', ConsultaAlmacen);


  /** @ngInject */
  function ConsultaAlmacen($scope, $timeout, DataService, restUrl) {
    var vm = this;
    var sc = $scope;
    var model;

    sc.vm = vm;

    vm.buscar = {};
    vm.alert = {};
    vm.agregarFila = agregarFila;
    vm.eliminarFila = eliminarFila;
    vm.consultarAlmacen = consultarAlmacen;
    
    $timeout(iniciarController);

    function iniciarController() {
      vm.items = [];
      if (angular.isUndefined(sc.model[sc.options.key])) {
        sc.model[sc.options.key] = { filas: []};
      }

      model = sc.model[sc.options.key];
    }

    function consultarAlmacen(texto) {
      if (!texto) return [];
      var url = restUrl+'almacen/consulta/?filter='+texto;
      if (sc.options.templateOptions.tipo == 'REINGRESO') {
        url += '&reingreso='+true;
      }

      return DataService.get(url)
      .then(function (respuesta) {
        return respuesta.datos || [];
      });
    }
    function seRepite(codigo) {
      var resp = false;
      model.filas.forEach(function (item)  {
        if (item.codigo === codigo) {
          resp = true;
        }
      });
      return resp;
    }
    function agregarFila() {
      var itemTemp = angular.copy(vm.buscar.item_seleccionado);
      if (itemTemp) {
        itemTemp.cantidad = 1;
        if (!seRepite(itemTemp.codigo)) model.filas.push(itemTemp);
        vm.buscar.item_seleccionado = undefined;        
      }
    }

    function eliminarFila(indice) {
      model.filas.splice(indice, 1);
    }
  }
})();
(function () {
  'use strict';

  angular
  .module('app')
  .controller('fcTablaActivosController', TablaActivos);

  /**@ngInject */
  function TablaActivos($scope, $timeout, DataService, restUrl, Message, Storage, $location) {
    var vm = this;
    var sc = $scope;

    sc.vm = vm;

    vm.buscar = {};
    vm.alert  = {};
    
    vm.validado     = false;
    vm.listaMotivos = ['Abandono', 'Fallecimiento', 'Caso fortuito', 'Fuerza mayor'];

    vm.recuperarActivosAsignados = recuperarActivosAsignados;
    vm.recuperarSolicitud        = recuperarSolicitud;

    vm.agregarFila         = agregarFila;
    vm.eliminarFila        = eliminarFila;
    vm.consultarActivo     = consultarActivo;
    vm.cambiarTipoBusqueda = cambiarTipoBusqueda;
    vm.validarUsuario      = validarUsuario;

    var DATOS_POR_DEFECTO = {
      documentoDe     : {},
      documentoPara   : {},
      filas           : [],
      tipoFormulario  : 'SOLICITUD',
      tipoBusqueda    : 'BUSQUEDA_POR_CITE',
      citeBusqueda    : null,
      usuario_ci      : null,
      usuario_nuevo   : false,
      devolucionPropia: true,
      motivo          : 'Abandono',
      tipoFormularioSeleccionado: 'ASIGNACION'
    };
    
    $timeout(iniciarController);

    function iniciarController() {
      vm.items = [];
      if (angular.isUndefined(sc.model[sc.options.key])) {
        sc.model[sc.options.key] = angular.copy(DATOS_POR_DEFECTO);
      }
      var url = $location.url();
      if (url.startsWith('/plantilla')) {
        // Asignando valores por defecto [VISTA EDICION DE PLANTILLA]
        sc.model[sc.options.key].tipoFormulario = sc.options.templateOptions.tipoFormulario;
        sc.model[sc.options.key].tipoBusqueda   = (sc.model[sc.options.key].tipoFormulario === 'SOLICITUD') ? 'BUSQUEDA_GLOBAL' : 'BUSQUEDA_POR_CITE';
      }
      if (url.startsWith('/documento')) {
        // Recupera los valores del documento [VISTA CREACION DE DOCUMENTO]
        var datosPlantilla = Storage.getSession('pl');
        var plantillaValor = angular.fromJson(datosPlantilla.plantilla_valor);
        var comp = plantillaValor[sc.options.key];
        if (comp) {
          sc.model[sc.options.key].tipoFormulario = comp.tipoFormulario;
          sc.model[sc.options.key].tipoBusqueda   = comp.tipoBusqueda;
          sc.model[sc.options.key].citeBusqueda   = comp.citeBusqueda;

          sc.model[sc.options.key].tipoFormularioSeleccionado = comp.tipoFormularioSeleccionado;
        } else {
          // Si no existen datos previos, se cargan los datos por defecto de plantillas. [CASO NUEVO DOCUMENTO]
          sc.model[sc.options.key].tipoFormulario = sc.options.templateOptions.tipoFormulario;
          sc.model[sc.options.key].tipoBusqueda   = (sc.model[sc.options.key].tipoFormulario === 'SOLICITUD') ? 'BUSQUEDA_GLOBAL' : 'BUSQUEDA_POR_CITE';
        }
      }
      sc.model[sc.options.key].usuario_nuevo = (sc.model[sc.options.key].tipoBusqueda === 'BUSQUEDA_GLOBAL');
      if (sc.model[sc.options.key].tipoFormulario === 'OTRA_DEVOLUCION') {
        sc.model[sc.options.key].tipoFormularioSeleccionado = 'DEVOLUCION';
        sc.model[sc.options.key].devolucionPropia = false;
      }
      recuperarSolicitud();

    }

    function cambiarTipoBusqueda (tipoBusqueda) {
      if (tipoBusqueda === 'BUSQUEDA_GLOBAL') {
        sc.model[sc.options.key].usuario_nuevo = true;
        sc.model[sc.options.key].citeBusqueda  = null;
      }
    }

    function recuperarSolicitud(cite) {
      var citeBuscar = sc.model[sc.options.key].citeBusqueda;
      if (angular.isUndefined(sc.model[sc.options.key].citeBusqueda) && angular.isUndefined(cite)) {
        return;
      }
      if (angular.isUndefined(sc.model[sc.options.key].citeBusqueda) && angular.isDefined(cite)) {
        citeBuscar = cite;
      }
      if (!citeBuscar) {
        return;
      }
      var url = restUrl+'activos/recuperar';
      return DataService.post(url, {cite: citeBuscar})
      .then(function (respuesta) {
        if (angular.isUndefined(respuesta)) {
          return;
        }
        sc.model[sc.options.key].filas         = respuesta.datos.items;
        sc.model[sc.options.key].documentoDe   = respuesta.datos.cabecera.documentoDe;
        sc.model[sc.options.key].documentoPara = respuesta.datos.cabecera.documentoPara;
        sc.model[sc.options.key].usuario_ci    = respuesta.datos.usuario_ci || null;

        sc.model[sc.options.key].tipoFormulario = sc.options.templateOptions.tipoFormulario;
        sc.model[sc.options.key].tipoBusqueda   = (sc.model[sc.options.key].tipoFormulario === 'SOLICITUD') ? 'BUSQUEDA_GLOBAL' : 'BUSQUEDA_POR_CITE';
        sc.model[sc.options.key].citeBusqueda   = citeBuscar;
        sc.model[sc.options.key].usuario_nuevo  = (sc.model[sc.options.key].tipoBusqueda === 'BUSQUEDA_GLOBAL');
      });
    }

    function recuperarActivosAsignados (ci) {
      var ciBuscar = sc.model[sc.options.key].usuario_ci;

      if (angular.isUndefined(sc.model[sc.options.key].usuario_ci) && angular.isUndefined(ci)) {
        return;
      }
      if (angular.isUndefined(sc.model[sc.options.key].usuario_ci) && angular.isDefined(ci)) {
        ciBuscar = ci;
      }
      if (!ciBuscar) {
        return;
      }
      var url = restUrl+'activos/consulta/usuario/' + ciBuscar;
      return DataService.get(url)
      .then(function (respuesta) {
        if (angular.isUndefined(respuesta)) {
          sc.model[sc.options.key].filas = [];
          return;
        }
        respuesta.datos.items.map(function (x) { x.cantidad = 1; });
        sc.model[sc.options.key].filas = respuesta.datos.items || [];
        sc.model[sc.options.key].devolucionPropia = respuesta.datos.propio;
      });
    }

    function consultarActivo(texto) {
      if (!texto || texto.length < 1) return [];
      var url = restUrl+'activos/consulta?filter='+texto;
      return DataService.get(url)
      .then(function (respuesta) {
        return respuesta ? respuesta.datos : [];
      });
    }

    function seRepite(id) {
      var resp = false;
      sc.model[sc.options.key].filas.forEach(function (item)  {
        if (item.id === id) {
          resp = true;
        }
      });
      return resp;
    }

    function agregarFila() {
      var itemTemp = angular.copy(vm.buscar.item_seleccionado);
      if (itemTemp) {
        itemTemp.cantidad = 1;
        if (!seRepite(itemTemp.id)) {
          sc.model[sc.options.key].filas.push(itemTemp);
        }
        vm.buscar.item_seleccionado = undefined;        
      }
    }

    function eliminarFila(indice) {
      sc.model[sc.options.key].filas.splice(indice, 1);
    }

    function  validarUsuario() {
      DataService.get(restUrl + 'seguridad/usuario_unidad/' + sc.model[sc.options.key].usuario_ci)
      .then(function (resp) {
        sc.model[sc.options.key].documentoDe = resp.datos;
        vm.validado = true;
        Message.show('EXITO','Usuario valido');
      });
      
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('fcIngresoAlmacenController', IngresoAlmacen);

  /** @ngInject */
  function IngresoAlmacen($scope, $timeout, DataService, restUrl, Datetime, Documento) {
    var vm = this;
    var sc = $scope;
    var model, articulos;

    sc.vm = vm;
    vm.buscarProveedor = buscarProveedor;
    vm.buscarArticulo = buscarArticulo;
    vm.agregarFila = agregarFila;
    vm.eliminarFila = eliminarFila;
    vm.calcularSubTotal = calcularSubTotal;
    vm.calcularTotal = calcularTotal;
    vm.calcularTotalConDescuento = calcularTotalConDescuento;
    vm.proveedores = [];
    vm.documentos = [];
    vm.docSeleccionado = {};
    vm.buscar_doc = '';
    vm.listaTipos = [
      { key: 1, value: 'Compra' },
      { key: 2, value: 'Donación y/o transferencia' },
      { key: 3, value: 'Reingreso' }
    ];

    vm.campoRequerido = true;

    vm.controlSelectDoc = controlSelectDoc;
    vm.openSelect = openSelect;
    vm.closeSelectDoc = closeSelectDoc;
    vm.mostrarPdf = mostrarPdf;
    vm.controlSeleccionProveedor = controlSeleccionProveedor;

    
    $timeout(iniciarController);
  

    function iniciarController() {
      if (angular.isUndefined(sc.model[sc.options.key])) {
        sc.model[sc.options.key] = {
          reingreso: false,
          proveedor: {},
          proveedorSeleccionado: {},
          proveedor_nombre: '',
          c31: null,
          c31_fecha: null,
          nota_entrega_numero: null,
          nota_entrega_fecha: null,
          factura_numero: null,
          factura_autorizacion: null,
          factura_fecha: null,
          items: [],
          descuento: 0,
          subtotal: 0.00,
          total: 0.00,
          observaciones:'',
          tipoIngreso: 1,
          respaldo: {
            nombre: '',
            fecha:''
          },
          listaTipos: {}

        };
        for (var i = 0; i < vm.listaTipos.length; i++) {
          var temp = vm.listaTipos[i];
          sc.model[sc.options.key].listaTipos[temp.key] = temp.value;
        }
      }
      if(vm.proveedores.length === 0) {
        if (angular.isDefined(sc.model[sc.options.key].proveedor.nombre)) {
          vm.proveedores.push(sc.model[sc.options.key].proveedor);
        }
        vm.proveedor_buscar = sc.model[sc.options.key].proveedor.nombre;
      }
      articulos = sc.model[sc.options.key].items;
      model = sc.model[sc.options.key];

      if (sc.model[sc.options.key].respaldo) {
        vm.docSeleccionado = sc.model[sc.options.key].respaldo;
        vm.documentos = [vm.docSeleccionado];
      }
      
      if (sc.model[sc.options.key].c31_fecha) sc.model[sc.options.key].c31_fecha = new Date(sc.model[sc.options.key].c31_fecha);
      if (sc.model[sc.options.key].factura_fecha) sc.model[sc.options.key].factura_fecha = new Date(sc.model[sc.options.key].factura_fecha);
      if (sc.model[sc.options.key].nota_entrega_fecha) sc.model[sc.options.key].nota_entrega_fecha = new Date(sc.model[sc.options.key].nota_entrega_fecha);

    }

    function buscarProveedor() {
      if (!vm.proveedor_buscar) return;
      var url = restUrl + 'almacen/proveedor/?filter='+vm.proveedor_buscar;
      return DataService.get(url)
      .then(function (resp) {
        vm.proveedores = resp.datos;
      })
    }
    function buscarArticulo() {
      var url = restUrl + 'almacen/consulta?todos=1&filter='+vm.articulo_buscar;
      return DataService.get(url)
      .then(function (resp) {
        vm.articulos = resp.datos || [];
        
      })
    }

    function agregarFila(indice) {
      var itemTemp = angular.copy(vm.articulos[indice]);
      if (itemTemp) {
        itemTemp.cantidad = 0;
        itemTemp.precio = '0.00';
        itemTemp.total = '0.00';
        if (!seRepite(itemTemp.codigo)) articulos.push(itemTemp);
        vm.articulos.splice(indice, 1);
      }
    }

    function eliminarFila(indice) {
      articulos.splice(indice, 1);
      vm.calcularTotal();
    }

    function seRepite(codigo) {
      var resp = false;
      articulos.forEach(function (item) {
        if (item.codigo === codigo) {
          resp = true;
        }
      });
      return resp;
    }

    function calcularSubTotal(indice) {
      var precio = articulos[indice].precio;
      var cantidad = articulos[indice].cantidad;
      var total = parseInt(cantidad) *  parseFloat(precio);
      articulos[indice].total = total.toFixed(2);
      vm.calcularTotal();
    }

    function calcularTotal() {
      var descuento = model.descuento || 0;
      var total = 0;
      for (var i = 0; i < articulos.length; i++) {
        var element = articulos[i];
        total += parseFloat(element.total);
      }
      model.subtotal = total.toFixed(2);
      // if (descuento) 
      total = total - parseFloat(descuento);
      model.total = total.toFixed(2);
    }

    function calcularTotalConDescuento() {
      var descuento = model.descuento || 0;
      var total = model.total || 0;
      var totalConDescuento = parseFloat(total) - parseFloat(descuento);
      model.total = totalConDescuento.toFixed(2);
    }

    sc.$watch('vm.buscar_doc', function () {
      if (vm.buscar_doc != "") {
        DataService.get(restUrl + 'plantillasFormly/documento?fields=id_documento,nombre,fecha&estado=APROBADO,CERRADO,DERIVADO&page=1&order=-fecha&limit=20&searchPro=1&tipoBus=campo&campoSel=nombre&filter=' + vm.buscar_doc)
          .then(function (respuesta) {
            vm.documentos = respuesta.datos.resultado || [];
          });
      }
    });


    function openSelect(ev, show) {
      angular.element(ev.currentTarget).parent().next().children()[1].click();
      switch (show) {
        case 'doc': vm.show_doc = true; break;
      }
    }

    function closeSelectDoc() {
      vm.buscar_doc = '';
      vm.show_doc = false;
    }

    function mostrarPdf(pIdentificador) {
      Documento.showPdfId(pIdentificador);
    }


    function controlSelectDoc(documento) {
      vm.show_doc = true;
      sc.model[sc.options.key].respaldo = angular.copy(documento);
      sc.model[sc.options.key].respaldo.fechaMostrar = Datetime.dateLiteral(sc.model[sc.options.key].respaldo.fecha);

    }

    function controlSeleccionProveedor(proveedor) {
      if (proveedor) {
        sc.model[sc.options.key].nitProveedor = proveedor.nit;
        sc.model[sc.options.key].idProveedor = proveedor.id;
        sc.model[sc.options.key].proveedorSeleccionado = proveedor;
      }
    }
  }
})();
(function () {
  'use strict';
  angular
  .module('app')
  .controller('fcIngresoActivosController', IngresoActivos);

  /**@ngInject */
  function IngresoActivos($scope, $timeout, DataService, restUrl, Datetime, Documento) {
    var vm = this;
    var sc = $scope;

    sc.vm = vm;
    vm.buscar = {};
    vm.general = {};
    vm.buscar_doc_activos = '';
    vm.buscar_doc_baja = '';
    vm.documentos = [];
    vm.docSeleccionado = {};

    vm.agregarActivo    = agregarActivo;
    vm.seleccionarActivoBaja = seleccionarActivoBaja;
    vm.eliminarActivo   = eliminarActivo;
    vm.consultarActivo  = consultarActivo;
    vm.consultarActivoBaja  = consultarActivoBaja;
    vm.buscarProveedor  = buscarProveedor;
    vm.controlSeleccionProveedor = controlSeleccionProveedor;
    vm.controlSeleccionTipoIngreso = controlSeleccionTipoIngreso;
    vm.controlSelectDoc = controlSelectDoc;
    vm.openSelect = openSelect;
    vm.closeSelectDoc = closeSelectDoc;
    vm.mostrarPdf = mostrarPdf;
    
    vm.listaTipos = [
      {key: 1, value: 'Compra'},
      {key: 2, value: 'Donación y/o transferencia'},
      {key: 3, value: 'Reposición'}
    ];

    var datosIniciales = {
      activos: [],
      nitProveedor: null,
      proveedor: null,
      proveedorSeleccionado: {},
      total: 0,
      tipoIngreso: 1,
      respaldo: {
        nombre:'',
        fecha:''
      },
      listaTipos: {}
    };
    for (var i = 0; i < vm.listaTipos.length; i++) {
      var temp = vm.listaTipos[i];
      datosIniciales.listaTipos[temp.key] = temp.value;
    }

    $timeout(inicializarDatos);

    function inicializarDatos() {
      if (angular.isUndefined(sc.model[sc.options.key])) {
        sc.model[sc.options.key] = angular.copy(datosIniciales);
      }
      else if (angular.isDefined(sc.model[sc.options.key].proveedorSeleccionado)) {
        vm.proveedores = [sc.model[sc.options.key].proveedorSeleccionado];
        sc.model[sc.options.key].proveedor = sc.model[sc.options.key].proveedorSeleccionado;
        if (sc.model[sc.options.key].fechaFactura) sc.model[sc.options.key].fechaFactura = new Date(sc.model[sc.options.key].fechaFactura);
        if (sc.model[sc.options.key].fechaEntrega) sc.model[sc.options.key].fechaEntrega = new Date(sc.model[sc.options.key].fechaEntrega);
        if (sc.model[sc.options.key].fechaPreventivo) sc.model[sc.options.key].fechaPreventivo = new Date(sc.model[sc.options.key].fechaPreventivo);

        

      }
      if (sc.model[sc.options.key].respaldo) {
        vm.docSeleccionado = sc.model[sc.options.key].respaldo;
        vm.documentos = [vm.docSeleccionado];
      }

    }

    function consultarActivo(texto) {
      if (!texto || texto.length < 1) return [];
      var url = restUrl + 'activos/consulta/ingreso?filter=' + texto;
      return DataService.get(url)
      .then(function (respuesta) {
        return respuesta ? respuesta.datos : [];
      });
    }

    function seRepite(id) {
      var resp = false;
      
      sc.model[sc.options.key].activos.forEach(function (item) {
        if (item.id === id) {
          resp = true;
        }
      });
      return resp;
    }

    function agregarActivo() {
      var itemTemp = angular.copy(vm.buscar.item_seleccionado);
      if (itemTemp) {
        itemTemp.cantidad = 1;
        if (!seRepite(itemTemp.id)) {
          sc.model[sc.options.key].activos.push(itemTemp);
          sc.model[sc.options.key].total = parseFloat(sc.model[sc.options.key].total)+ parseFloat(itemTemp.precio);
        }
        vm.buscar.item_seleccionado = undefined;
      }
    }

    function eliminarActivo(indice) {
      sc.model[sc.options.key].total = parseFloat(sc.model[sc.options.key].total) - parseFloat(sc.model[sc.options.key].activos[indice].precio);
      sc.model[sc.options.key].activos.splice(indice, 1);

    }

    function buscarProveedor() {
      if (!vm.proveedor_buscar) return;
      var url = restUrl + 'activos/proveedor/?filter=' + vm.proveedor_buscar;
      return DataService.get(url)
        .then(function (resp) {
          vm.proveedores = resp.datos;
        });
    }

    function controlSeleccionProveedor(proveedor) {
      if (proveedor) {
        sc.model[sc.options.key].nitProveedor = proveedor.nit;
        sc.model[sc.options.key].idProveedor = proveedor.id;
        sc.model[sc.options.key].proveedorSeleccionado = proveedor;
      }
    }

    function controlSeleccionTipoIngreso(tipo) {
      if(tipo) {
        sc.model[sc.options.key].tipoSeleccionado = tipo;
      }
    }


    function openSelect(ev, show) {
      angular.element(ev.currentTarget).parent().next().children()[1].click();
      switch (show) {
        case 'doc': vm.show_doc = true; break;
      }
    }

    function closeSelectDoc() {
      vm.buscar_doc_activos = '';
      vm.show_doc = false;
    }

    function mostrarPdf(pIdentificador) {
      Documento.showPdfId(pIdentificador);
    }


    function controlSelectDoc(documento) {
      vm.show_doc = true;
      sc.model[sc.options.key].respaldo = angular.copy(documento);
      sc.model[sc.options.key].respaldo.fechaMostrar = Datetime.dateLiteral(sc.model[sc.options.key].respaldo.fecha);

    }

    function consultarActivoBaja(texto) {
      if (!texto || texto.length < 1) return [];
      var url = restUrl + 'activos/consulta/reposicion?filter=' + texto;
      return DataService.get(url)
        .then(function (respuesta) {
          return respuesta? respuesta.datos : [];
        });
    }

    function seleccionarActivoBaja() {
      var bajaTemp = angular.copy(vm.buscar.item_seleccionado_baja);
      if (bajaTemp) {
        sc.model[sc.options.key].activoBaja = bajaTemp;
        vm.buscar.item_seleccionado_baja = undefined;
      }
    }
    sc.$watch('vm.buscar_doc_activos', function () {
      if (vm.buscar_doc_activos != "") {
        DataService.get(restUrl + 'plantillasFormly/documento?fields=id_documento,nombre,fecha&estado=APROBADO,CERRADO,DERIVADO&page=1&order=-fecha&limit=20&searchPro=1&tipoBus=campo&campoSel=nombre&filter=' + vm.buscar_doc_activos)
          .then(function (respuesta) {
            vm.documentos = respuesta.datos.resultado || [];
          });
      }
    });

  }
})();
(function () {
  'use strict';
  angular
    .module('app')
    .controller('fcBajaActivosController', BajaActivos);

  /**@ngInject */
  function BajaActivos($scope, $timeout, DataService, restUrl, Datetime, Documento) {
    var vm = this;
    var sc = $scope;

    sc.vm = vm;
    vm.buscar = {};
    vm.general = {};
    vm.buscar_doc = '';
    vm.documentos = [];

    vm.agregarActivo = agregarActivo;
    vm.eliminarActivo = eliminarActivo;
    vm.consultarActivo = consultarActivo;
    vm.controlSelectDoc = controlSelectDoc;
    vm.openSelect = openSelect;
    vm.closeSelectDoc = closeSelectDoc;
    vm.mostrarPdf = mostrarPdf;


    vm.listaMotivos = [
      {key:1, value:'Disposición definitiva de bienes'},
      {key:2, value:'Hurto, robo o pérdida fortuita'},
      {key:3, value:'Mermas'},
      {key:4, value:'Vencimientos, descomposiciones, alteraciones o deterioros'},
      {key:5, value:'Inutilización'},
      {key:6, value:'Obselescencia'},
      {key:7, value:'Desmantelamiento total o parcial de edificaciones'},
      {key:8, value:'Otros'}
    ];


    var datosIniciales = {
      activos: [],
      motivo: {},
      respaldo: {
        nombre: '',
        fecha: ''
      },
      listaMotivos: {}
    };
    for (var i = 0; i < vm.listaMotivos.length; i++) {
      var temp = vm.listaMotivos[i];
      datosIniciales.listaMotivos[temp.key] = temp.value;
    }
    $timeout(inicializarDatos);

    function inicializarDatos() {
      if (angular.isUndefined(sc.model[sc.options.key])) {
        sc.model[sc.options.key] = angular.copy(datosIniciales);
      }
      else {
        if (sc.model[sc.options.key].fecha) sc.model[sc.options.key].fecha = new Date(sc.model[sc.options.key].fecha);
        vm.docSeleccionado = sc.model[sc.options.key].respaldo;
        vm.documentos = [vm.docSeleccionado];
      }
      
    }

    function consultarActivo(texto) {
      if (!texto || texto.length < 1) return [];
      var url = restUrl + 'activos/consulta/baja?filter=' + texto;
      return DataService.get(url)
        .then(function (respuesta) {
          return respuesta ? respuesta.datos : [];
        });
    }

    function seRepite(id) {
      var resp = false;

      sc.model[sc.options.key].activos.forEach(function (item) {
        if (item.id === id) {
          resp = true;
        }
      });
      return resp;
    }

    function agregarActivo() {
      var itemTemp = angular.copy(vm.buscar.item_seleccionado);
      if (itemTemp) {
        itemTemp.cantidad = 1;
        if (!seRepite(itemTemp.id)) {
          sc.model[sc.options.key].activos.push(itemTemp);
        }
        vm.buscar.item_seleccionado = undefined;
      }
    }

    function eliminarActivo(indice) {
      sc.model[sc.options.key].activos.splice(indice, 1);

    }

    function openSelect(ev, show) {
      angular.element(ev.currentTarget).parent().next().children()[1].click();
      switch (show) {
        case 'doc': vm.show_doc = true; break;
      }
    }

    function closeSelectDoc() {
      vm.buscar_doc = '';
      vm.show_doc = false;
    }

    function mostrarPdf(pIdentificador) {
      Documento.showPdfId(pIdentificador);
    }


    function controlSelectDoc(documento) {
      vm.show_doc = true;
      sc.model[sc.options.key].respaldo = angular.copy(documento);
      sc.model[sc.options.key].respaldo.fechaMostrar = Datetime.dateLiteral(sc.model[sc.options.key].respaldo.fecha);

    }

    sc.$watch('vm.buscar_doc', function () {
      if (vm.buscar_doc != "") {
        DataService.get(restUrl + 'plantillasFormly/documento?fields=id_documento,nombre,fecha&estado=APROBADO,CERRADO,DERIVADO&page=1&order=-fecha&limit=20&searchPro=1&tipoBus=campo&campoSel=nombre&filter=' + vm.buscar_doc)
        .then(function (respuesta) {
          vm.documentos = respuesta.datos.resultado || [];
        });
      }
    });

  }
})();
(function() {
  'use strict';

  angular
    .module('app')
    .controller('VistaPdfController', VistaPdfController);

  /** @ngInject */
  function VistaPdfController($scope, DataService, restUrl, Storage, $sce, $location, Documento, Util) {
      var vm = this;
      var datos_enviar = Storage.getSession('datos_enviar');

      if(datos_enviar==null) $location.path('/documentos');
      else {
          DataService.pdf(restUrl+'plantillasFormly/documentoPDF/',{cite: datos_enviar.nombre})
          .then(function (respuestaPdf) {
            if(!respuestaPdf) return;
              datos_enviar.pdf = respuestaPdf.url;
              datos_enviar.pdf_buffer = respuestaPdf.data;

            //   if(angular.isUndefined(respuestaPdf)) $location.path('/documentos');
              vm.html=datos_enviar.html;
              vm.pdf=datos_enviar.pdf;
              vm.flag_html=true;
              if (datos_enviar.esDocumentoExterno) vm.flag_html=false;
              vm.show_pdf=!datos_enviar.esDispositivoMovil;
               if (datos_enviar.esDispositivoMovil) {
                Util.loadCanvas(datos_enviar.pdf_buffer, '#canvasContainer');
            }
              //funciones
              vm.verHtml = function(){ vm.flag_html=true; }
              vm.verPdf = function(){ vm.flag_html=false; }
              vm.load = true;
          })
      }

      $scope.mostrarPdf = function (id, sw){ if(sw) Documento.showPdfx(id); else Documento.showPdfId(id, false); } // eslint-disable-line angular/controller-as
  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('PlantillasController', PlantillasController);

  /** @ngInject */

  function PlantillasController(restUrl, Storage, $location) {
    var vm = this;
    vm.titulo = "Bandeja de plantillas";
    vm.url = restUrl + "plantillasFormly/plantilla_formly/";
    var cuenta = Storage.getUser();
    vm.usuario=cuenta.id;
    vm.estadoSw=true;
    vm.permission ={
      create:false,
      update:false,
      delete:true
    };
    vm.fields = [
      "id_plantilla_formly",
      "nombre",
      "abreviacion",
      "estado",
      "_fecha_creacion",
      "_fecha_modificacion"
    ];

    vm.buttons = [
      {
        tooltip: 'Editar',
        icon: 'checked',
        onclick: irPlantilla
      }
    ];
    vm.buttonAgregar = {
        tooltip: 'Añadir',
        icon: 'add',
        onclick: nuevaPlantilla
    };
    function nuevaPlantilla(event) { irPlantilla(event, 0); }

    function irPlantilla(pEvento, pIdentificador){
      $location.path('plantilla/' + pIdentificador);
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('MonitoreoController', MonitoreoController);

  /** @ngInject */
  function MonitoreoController(charColors, DataService, restUrl, Modal, $window, $filter, Documento) {
    var vm = this,
      fecha_actual = new Date(),
      limite_inferior = 1990,
      limite_inferior_contable = 2018,
      limite_superior = 2130;
      

    iniciar();
    reiniciarChart();
    vm.refrescarChart = refrescarChart;
    vm.reiniciarChart = reiniciarChart;
    vm.paginar = paginar;
    vm.mostrarOcultar = mostrarOcultar;
    vm.generarPDF = generarPDF;
    var date = new Date(),
      y = date.getFullYear(),
      m = date.getMonth();
    vm.fechaInicial = new Date(y, m, 1);
    vm.fechaFinal = new Date();
    vm.cabeceraPresupuesto = cabeceraPresupuesto;
    vm.generarNombre = generarNombre;
    vm.filasPresupuesto = filasPresupuesto;
    vm.consultarComprometido = consultarComprometido;
    vm.consultarPagado = consultarPagado;
    vm.vistaPrevia = vistaPrevia;
    vm.busqueda = {};

    function iniciar() {
      vm.chart = {};

      vm.graficos = [
        { cod: 0, nombre: 'Cantidad de documentos por mes', labelChart: '# Visitas por día', tipoChart: 'line' },
        // { cod: 1, nombre: 'Usuarios que más documentos ven', labelChart: 'Usuarios más concurrentes', tipoChart: 'bar' },
        // { cod: 2, nombre: 'Documentos más vistos', labelChart: 'Documentos más vistos', tipoChart: 'bar' },
        // { cod: 3, nombre: 'Documentos más vistos por usuario', labelChart: 'Documentos más visitados', tipoChart: 'bar' },
        { cod: 4, nombre: 'Presupuesto', labelChart: 'Presupuesto', tipoChart: 'presupuesto' },
        { cod: 5, nombre: 'Documentos por estado y usuario', labelChart: 'estados', tipoChart: 'estados' },
        { cod: 6, nombre: 'Documentos pendientes por usuario', labelChart: 'pendientes', tipoChart: 'pendientes' },
        { cod: 7, nombre: 'Comprometido', labelChart: 'Comprometido', tipoChart: 'comprometido' },
        { cod: 8, nombre: 'Pagado', labelChart: 'Pagado', tipoChart: 'pagado' },
        { cod: 9, nombre: 'Reporte contable', labelChart: 'Reporte contable', tipoChart: 'reporteContable' }
      ];
      vm.grafico = vm.graficos[0];
      vm.mes = fecha_actual.getMonth();
      vm.meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
      vm.docsContables = ['IPBS', 'IPV', 'IPSPCL-A'];
      vm.tipoInformePago = 1;
      vm.anio = fecha_actual.getFullYear() - limite_inferior;
      vm.anios = [];
      vm.aniosContables = [];
      for (var i = limite_inferior - 1; i < limite_superior; i++) vm.anios.push(i + 1);
      for (var j = limite_inferior_contable - 1; j < fecha_actual.getFullYear(); j++) vm.aniosContables.push(j + 1);
      
      vm.anioContable = vm.aniosContables.length -1;
      DataService.get(restUrl + 'seguridad/usuario/?fields=id_usuario,usuario,nombres,apellidos&order=nombres&estado=ACTIVO')
        .then(function (respuesta) {
          vm.usuarios = respuesta.datos.resultado;
          vm.usuario = vm.usuarios[0].id_usuario;
        })

      DataService.get(restUrl + 'presupuesto/gestiones')
        .then(function (respuesta) {
          vm.gestiones = respuesta.datos;
          vm.gestionActual = vm.anio + limite_inferior;
          vm.gestion = 0;
        })
    }

    function reiniciarChart() {
      vm.busqueda = {};
      vm.ordenInverso = false;
      vm.chart.tipo = vm.grafico.tipoChart;
      vm.gestion = 0;
      if (vm.chart.tipo === 'presupuesto') {
        vm.ordenarPor = 'descripcion';
        consultarPresupuesto(vm.gestionActual - vm.gestion);
      } else if (vm.chart.tipo === 'estados') {
        vm.ordenarPor = 'nombres';
        consultarDocumentosUsuarioEstados(vm.fechaInicial, vm.fechaFinal);
      } else if (vm.chart.tipo === 'pendientes') {
        vm.ordenarPor = 'nombres';
        consultarDocumentosPendientes();
      } else if (vm.chart.tipo === 'comprometido') {
        vm.ordenarPor = 'descripcion';
        consultarComprometido(vm.gestionActual - vm.gestion);
      } else if (vm.chart.tipo === 'pagado') {
        vm.ordenarPor = 'descripcion';
        consultarPagado(vm.gestionActual - vm.gestion);
      } else if (vm.chart.tipo === 'reporteContable') {
        vm.ordenarPor = '-cite';
        consultarReporteContable(vm.tipoInformePago, vm.anioContable);

      } else {
        vm.chart.datos = {
          labels: [],
          datasets: [
            {
              label: vm.grafico.labelChart + ' total.',
              data: [],
              backgroundColor: charColors.bg.amarillo,
              borderColor: charColors.bo.amarillo,
              borderWidth: 1
            },
            {
              label: vm.grafico.labelChart + ' con relación.',
              data: [],
              backgroundColor: charColors.bg.verde,
              borderColor: charColors.bo.verde,
              borderWidth: 1
            },
            {
              label: vm.grafico.labelChart + ' sin relación.',
              data: [],
              backgroundColor: charColors.bg.azul,
              borderColor: charColors.bo.azul,
              borderWidth: 1
            }
          ]
        };
        vm.chart.reiniciar = !vm.chart.reiniciar;
        vm.page = 1;
        vm.page_cant = 20;
        vm.page_text = '' + ((vm.page - 1) * vm.page_cant + 1) + '-' + (vm.page * vm.page_cant);
        vm.page_tot = 1;
        refrescarChart();
      }
    }

    function consultarPresupuesto(gestion) {
      DataService.get(restUrl + 'presupuesto/saldos?gestion=' + gestion)
      .then(function (respuesta) {
        vm.headers = [
          { name: 'numero', title: 'Número', mostrar: true },
          { name: 'descripcion', title: 'Descripción', mostrar: true },
          { name: 'inicial', title: 'Inicial', mostrar: true },
          { name: 'comprometido', title: 'Comprometido', mostrar: true },
          { name: 'pagado', title: 'Pagado', mostrar: true },
          { name: 'modificado', title: 'Modificado', mostrar: true },
          { name: 'vigente', title: 'Vigente', mostrar: true },
          { name: 'saldo', title: 'Saldo', mostrar: true }
        ];
        vm.items = [];
        respuesta.datos.map(function (item) {
          vm.items.push({
            comprometido: $filter('number')(parseFloat(item.comprometido), 2).replace(/,/g, "").replace(".", ","),
            descripcion: item.descripcion == null ? '-' : item.descripcion,
            inicial: $filter('number')(parseFloat(item.inicial), 2).replace(/,/g, "").replace(".", ","),
            modificado: $filter('number')(parseFloat(item.modificado), 2).replace(/,/g, "").replace(".", ","),
            numero: !isNaN(item.numero) ? $filter('number')(parseFloat(item.numero), 2).replace(/,/g, "").replace(".", ",") : item.numero,
            pagado: $filter('number')(parseFloat(item.pagado), 2).replace(/,/g, "").replace(".", ","),
            saldo: $filter('number')(parseFloat(item.saldo), 2).replace(/,/g, "").replace(".", ","),
            vigente: $filter('number')(parseFloat(item.vigente), 2).replace(/,/g, "").replace(".", ",")
          })
        });
      })
    }

    function consultarReporteContable(tipoInforme, gestion) {
      var datosConsulta = {
        tipoInforme: vm.docsContables[tipoInforme],
        gestion: vm.aniosContables[gestion]
      };
      
      DataService.post(restUrl + 'reportes/contables', datosConsulta)
      .then(function (respuesta) {
        vm.headers = [
          { name: 'cite', title: 'Cite', mostrar: true },
          { name: 'detalle', title: 'Detalle', mostrar: true },
          { name: 'c31', title: 'C-31', mostrar: true },
          { name: 'importe', title: 'Importe', mostrar: true }
        ];
        vm.items = respuesta.datos.documentos;
      });
    }

    function generarNombre() {
      var nombre = 'reporte_' + vm.docsContables[vm.tipoInformePago];
      return nombre;
    }

    function cabeceraPresupuesto() {
      var cabecera = [];
      for (var i = 0; i < vm.headers.length; i++) {
        if (vm.headers[i].mostrar) cabecera.push(vm.headers[i].title);
      }
      return cabecera;
    }

    function filasPresupuesto() {
      vm.filas = [];
      vm.items.map(function (item) {
        var nuevo = {};
        for (var i = 0; i < vm.headers.length; i++) {
          if (vm.headers[i].mostrar) {
            if (!isNaN(item[vm.headers[i].name])) {
              nuevo[vm.headers[i].name] = $filter('number')(item[vm.headers[i].name], 2);
            } else {
              nuevo[vm.headers[i].name] = item[vm.headers[i].name];
            }
          }
        }
        vm.filas.push(nuevo);
      });
      return vm.filas;
    }

    function mostrarOcultar(columna) {
      for (var i = 0; i < vm.headers.length; i++) {
        if (vm.headers[i].name === columna) return vm.headers[i].mostrar;
      }
      return true;
    }

    function consultarDocumentosUsuarioEstados(fechaInicial, fechaFinal) {
      DataService.get(restUrl + 'monitoreo/estados?fechaInicial=' + fechaInicial + '&&fechaFinal=' + fechaFinal)
      .then(function (respuesta) {
        vm.estados = respuesta.datos;
      })
    }

    function consultarDocumentosPendientes() {
      DataService.get(restUrl + 'monitoreo/pendientes')
      .then(function (respuesta) {
        vm.pendientes = [];
        respuesta.datos[0].map(function (item) {
          vm.pendientes.push({
            nombres: item.nombres,
            apellidos: item.apellidos,
            ENVIADO: item.ENVIADO,
            RECHAZADO: item.RECHAZADO,
            DERIVADO: item.DERIVADO,
            total: (item.ENVIADO + item.RECHAZADO + item.DERIVADO)
          })
        });
      });
    }

    function consultarComprometido(gestion) {
      DataService.get(restUrl + 'presupuesto/comprometido?gestion=' + gestion)
        .then(function (respuesta) {
          vm.comprometido = [];
          respuesta.datos.map(function (item) {
            vm.comprometido.push({
              _fecha_creacion: $filter('date')(item._fecha_creacion, "dd/MM/yyyy"),
              cite: item.cite,
              descripcion: item.descripcion == null ? '-' : item.descripcion,
              id_documento: item.id_documento,
              monto: $filter('number')(parseFloat(item.monto), 2).replace(/,/g, "").replace(".", ","),
              numero: item.numero
            })
          });
        })
    }

    function consultarPagado(gestion) {
        DataService.get(restUrl + 'presupuesto/pagado?gestion=' + gestion)
        .then(function (respuesta) {
            vm.pagado = [];
            respuesta.datos.map(function (item) {
            vm.pagado.push({
                _fecha_creacion: $filter('date')(item._fecha_creacion, "dd/MM/yyyy"),
                cite: item.cite,
                descripcion: item.descripcion == null ? '-' : item.descripcion,
                id_documento: item.id_documento,
                monto: $filter('number')(parseFloat(item.monto), 2).replace(/,/g, "").replace(".", ","),
                numero: item.numero
            })
            });
        })
    }

    function vistaPrevia(pIdentificador) {
      Documento.showPdfId(pIdentificador);
    }

    function generarPDF() {
      var presupuesto = {};
      presupuesto.cabecera = cabeceraPresupuesto();
      presupuesto.filas = filasPresupuesto();
      presupuesto.gestion = vm.anio + limite_inferior;
      var datosEnviar = {
        doc: {}
      };
      datosEnviar.esDispositivoMovil = angular.isDefined($window.orientation);
      DataService.pdf(restUrl + 'presupuesto/pdf', presupuesto)
        .then(function (respuesta) {
          datosEnviar.pdf = respuesta.url;
          datosEnviar.pdf_buffer = respuesta.data;
          var config = {
            data: datosEnviar,
            templateUrl: 'app/modules/plantillasFormly/monitoreo/dialogPresupuestoPDF.html',
            controller: ['data', '$scope', '$mdDialog', 'Util', DialogPDFController]
          }
          Modal.show(config);
        })
    }

    function DialogPDFController(data, $scope, $mdDialog, Util) {
      var vmd = $scope;
      vmd.data = {};
      vmd.data.html = data.html;
      vmd.data.pdf = data.pdf;
      vmd.data.flag_html = false;
      vmd.data.show_pdf = !data.esDispositivoMovil;
      if (data.esDispositivoMovil) {
        Util.loadCanvas(data.pdf_buffer, '#canvasContainer');
      }

      //funciones
      /*vmd.mostrarPdf = function (id, sw){ 
          if(sw) showPdfx(id); 
          else showPdfId(id, 
          false); 
      }*/
      vmd.cerrar = function () {
        $mdDialog.cancel();
      }
      vmd.verHtml = function () {
        vmd.data.flag_html = true;
      }
      vmd.verPdf = function () {
        vmd.data.flag_html = false;
      }
    }

    function refrescarChart() {
      vm.busqueda = {};
      vm.ordenInverso = false;
      if (vm.chart.tipo === 'presupuesto') {
        vm.ordenarPor = 'descripcion';
        consultarPresupuesto(vm.gestionActual - vm.gestion);
      } else if (vm.chart.tipo === 'estados') {
        vm.ordenarPor = 'nombres';
        consultarDocumentosUsuarioEstados(vm.fechaInicial, vm.fechaFinal);
      } else if (vm.chart.tipo === 'pendientes') {
        vm.ordenarPor = 'nombres';
        consultarDocumentosPendientes();
      } else if (vm.chart.tipo === 'comprometido') {
        vm.ordenarPor = 'descripcion';
        consultarComprometido(vm.gestionActual - vm.gestion);
      } else if (vm.chart.tipo === 'pagado') {
        vm.ordenarPor = 'descripcion';
        consultarPagado(vm.gestionActual - vm.gestion);
      } else if (vm.chart.tipo === 'reporteContable') {
        vm.ordenarPor = 'cite';
        consultarReporteContable(vm.tipoInformePago, vm.anioContable);
      } else {
        var anio = vm.anio + limite_inferior,
          mes = vm.mes + 1;
        
        var url_get = [
          restUrl + 'monitoreo/global/?anio=' + anio + '&mes=' + mes,
          restUrl + 'monitoreo/usuario/?anio=' + anio + '&mes=' + mes + '&page=' + vm.page,
          restUrl + 'monitoreo/documento/?anio=' + anio + '&mes=' + mes + '&page=' + vm.page,
          restUrl + 'monitoreo/' + vm.usuario + '/documento/?anio=' + anio + '&mes=' + mes
        ];
        DataService.get(url_get[vm.grafico.cod])
        .then(function (respuesta) {
          vm.chart.datos.labels = respuesta.datos.nombres;
          vm.chart.datos.datasets[0].data = respuesta.datos.global;
          vm.chart.datos.datasets[1].data = respuesta.datos.relacionado;
          vm.chart.datos.datasets[2].data = respuesta.datos.no_relacionado;
          vm.chart.actualizar = !vm.chart.actualizar;
          vm.page_tot = respuesta.datos.total;
        });
      }
    }

    function paginar(acc) {
      if (acc == 'aa')
        vm.page = 1;
      if (acc == 'a')
        vm.page--;
      if (acc == 's')
        vm.page++;
      if (acc == 'ss')
        vm.page = Math.ceil(vm.page_tot / vm.page_cant);
      vm.page_text = '' + ((vm.page - 1) * vm.page_cant + 1) + '-' + (((vm.page * vm.page_cant) > vm.page_tot) ? vm.page_tot : vm.page * vm.page_cant);
      refrescarChart();
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('ImpresionController', ImpresionController);

  /** @ngInject */
  function ImpresionController(restUrl, Storage, Documento, Modal) {
    var vm = this;
    vm.titulo = "Imprimir documentos";
    vm.url = restUrl + "plantillasFormly/documento/";
    var cuenta = Storage.getUser();
    vm.usuario = cuenta.id;

    vm.queryExtra = {
        estado: 'APROBADO,CERRADO,DERIVADO'
    };

    vm.permission = {
        create: false,
        update: false,
        delete: false
    };

    vm.fields = [
      "id_documento",
      "nombre",
      "nombre_plantilla",
      "fecha",
      "impreso",
      "_usuario_modificacion",
      "_fecha_creacion",
      "_fecha_modificacion"
    ];

    vm.buttons = [
      {
        tooltip: 'Ver',
        icon: 'remove_red_eye',
        onclick: vistaPrevia
      },
      {
        tooltip: 'Ver Historial',
        icon: 'timeline',
        onclick: verProgreso
      }
    ];
    vm.multiple = {
      tooltip: 'Impresion multiple',
      icon: 'print',
      onclick: impresionMultiple
    };

    function verProgreso(pEvento, pIdentificador) {
      Documento.showProgressAll(pEvento, pIdentificador);
    }

    function vistaPrevia(pEvento, pIdentificador){
      Documento.showPdfId(pIdentificador);
    }

    function impresionMultiple(evento) {
      var config = {
        event: evento,
        templateUrl: 'app/modules/plantillasFormly/impresion/multiple.dialog.html',
        controller: ['$scope', '$mdDialog', 'DataService', 'Message', 'restUrl', DialogImpresionMultiple]
      };
      Modal.show(config);      
    }

    function DialogImpresionMultiple($scope, $mdDialog, DataService, Message, restUrl) {
      var vmd = $scope;
      vmd.obtenerDocumento = obtenerDocumento;
      vmd.cancel = cancel;

      /**
       * Función que obtiene el buffer de todos los documentos de un grupo multiple
       */
      function obtenerDocumento() {
        if (angular.isUndefined(vmd.cite) || vmd.cite=="") {
          Message.warning('Debe escribir un número de cite');
          return;
        }
        
        DataService.pdf(restUrl + 'plantillasFormly/multiple', { cite: vmd.cite })
        .then(function (respuestaPdf) {
          if (respuestaPdf){            
            vmd.documentoAImprimir = respuestaPdf;
          }
        })
        .catch(function () {
          // console.log('Error en la obtencion del documento a imprimir', error);
          return;
        });
        
      }

      /**
       * Funcion que permite cancelar el modal
       */
      function cancel() {
        
        $mdDialog.cancel();
        
      }
      
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('EnCursoController', EnCursoController);

  /** @ngInject */
  function EnCursoController(restUrl, Storage, Documento) {

      var vm = this;
      var cuenta = Storage.getUser();
      vm.usuario = cuenta.id;
      vm.titulo = "Documentos en curso";
      vm.url = restUrl + "plantillasFormly/documento/"+cuenta.id+"/encurso";

      vm.permission = {
          create: false,
          update: false,
          delete: false
      };

      vm.fields = [
          "id_documento",
          "nombre",
          "nombre_plantilla",
          "estado",
          "fecha",
          "_fecha_creacion",
          "_fecha_modificacion"
      ];

      vm.buttons = [
        {
          tooltip: 'Ver',
          icon: 'remove_red_eye',
          onclick: vistaPrevia
        },
        {
            tooltip: 'Ver Historial',
            icon: 'timeline',
            onclick: verProgreso
        }
      ];

      function vistaPrevia(pEvento, pIdentificador){
          Documento.showPdfId(pIdentificador);
      }
      function verProgreso(pEvento, pIdentificador) {
          Documento.showProgressAll(pEvento, pIdentificador);
      }

  }
})();

(function() {
  'use strict';

  angular
  .module('app')
  .controller('FirmarController', FirmarController);

  /** @ngInject */
  function FirmarController(restUrl, Storage, Documento, Modal, $q, DataService, FirmaticService, $window, Message, Loading, $timeout) {

    var vm = this;
    var cuenta = Storage.getUser();
    vm.cuenta = cuenta;
    vm.usuario = cuenta.id;
    vm.titulo = "Documentos para firma digital";
    vm.url = restUrl + 'documento/firmar';
    vm.firmarDocumentos = firmarDocumentos;
    vm.items = {};
    vm.habilitarSeleccion = true;

    vm.permission = {
      create: false,
      update: false,
      delete: false
    };

    vm.fields = [
      "id_documento",
      "nombre",
      "nombre_plantilla",
      "estado",
      "fecha",
      "_fecha_creacion",
      "_fecha_modificacion",
      "firmado"
    ];

    vm.estadoOpciones = [
      { v:'cerra', t:'CERRADO'}
    ];

    vm.buttons = [
      {
        tooltip: 'Ver',
        icon: 'remove_red_eye',
        onclick: vistaPrevia
      },
      {
        tooltip: 'Ver Historial',
        icon: 'timeline',
        onclick: verProgreso
      }
    ];
    vm.habilitarBotonFirma = false;
    vm.obtenerSeleccionados=obtenerNumeroSeleccionados;
    vm.verificarSeleccionados = verificarSeleccionados;
    vm.arrayBufferToBase64 = arrayBufferToBase64;
    vm.obtenerDocumentos = obtenerDocumentos;
    vm.guardarDocumentosFirmados = guardarDocumentosFirmados;
    vm.docDic = {};
    
    /**
     * Funcion que obtiene el número de documentos seleccionados.
     * @param {Integer} cantidad Informacion respecto a la cantidad de documentos seleccionados.
     */
    function obtenerNumeroSeleccionados(cantidad) {
      vm.habilitarBotonFirma = cantidad;
    }

    /**
     * Funcion que permite carga la vista previa de un documento.
     * @param {Function} pEvento Funcion de control del evento(click)
     * @param {Integer} pIdentificador Identificador del documento.
     */
    function vistaPrevia(pEvento, pIdentificador){
      Documento.showPdfId(pIdentificador);
    }

    /**
     * Funcion que permite la carga del progreso del documento seleccionado
     * @param {Function} pEvento Funcion de control del evento(click)
     * @param {Integer} pIdentificador Identificador del documento
     */
    function verProgreso(pEvento, pIdentificador) {
      Documento.showProgressAll(pEvento, pIdentificador);
    }

    
    function obtenerDocumentos(lista) {      
      var respuesta = {
        obtenidos: [],
        noObtenidos: []
      };
      var promesas = lista.map(function (item) {
        return new Promise(function (resolve) {
          return DataService.pdf(restUrl + 'documento/firmar', {
              cite: item.nombre,
              id_documento: item.id_documento
            })
            .then(function (respuestaPdf) {
              if (!respuestaPdf || !respuestaPdf.data) throw Error('No se pudo obtener el documento');
              return arrayBufferToBase64(respuestaPdf.data);
            })
            .then(function (base64) {
              respuesta.obtenidos.push({
                base64: 'data:application/pdf;base64,' + base64,
                name: item.id_documento + '.pdf'
              });
              
              return resolve();
            })
            .catch(function (errorObtener) {
              // console.log('Error al obtener el base 64');
              respuesta.noObtenidos.push({
                documento: item.nombre,
                error: errorObtener
              });
              return resolve();

            });

        });

      });
      return Promise.all(promesas)
        .then(function () {
          return Promise.resolve(respuesta);
        })
        .catch(function (error) {
          // console.log('Error al ejecutar las promesas', error);
          return Promise.reject(error);
        });
    }
    function guardarDocumentosFirmados(lista) {
      var respuesta = {
        total: lista.length || 0,
        guardado: [],
        noGuardado: []
      };
      var promesas = lista.map(function(item) {
        return new Promise(function (resolve) {
          var nombreDocumento = item.name          
          if (angular.isUndefined(vm.docDic[nombreDocumento])){
            respuesta.noGuardado.push(nombreDocumento.replace('.pdf', ''));
            return resolve();
          }
          return DataService.post(restUrl + 'documento/firmado/', {
            base64: item.base64,
            id_documento: vm.docDic[nombreDocumento]
          })
          .then(function (respGuardado) {
            if(respGuardado.tipoMensaje !== 'EXITO') throw Error(respGuardado.mensaje);
            respuesta.guardado.push(nombreDocumento);
            return resolve();
          })
          .catch(function () {
            respuesta.noGuardado.push(item.name);
            return resolve();
          });
        });
      });


      return Promise.all(promesas)
      .then(function () {
        return Promise.resolve(respuesta);
      })
      .catch(function(error){
        // console.log('Error al ejecutar las promesas de guardado', error);
        
        return Promise.reject(error);
      })
    }

    function firmarDocumentos() {
      var verificacion = {};
      var configLoad = {
        data:{
          mensaje: 'Verificando firmador...',
          tipo: 'info'
        }
      };
      Loading.show(configLoad);
      var documentosParaFirmar = vm.verificarSeleccionados(vm.items.data);
      var control = {
        seleccionados: documentosParaFirmar.length,
        obtenidos: 0,
        firmados: 0,
        guardados: 0
      };

      FirmaticService.verificarEstado()
      .then(function (respEstado) {
        if(respEstado.activo === false) throw Error(respEstado.mensaje);
        Loading.cambiar({
          mensaje: 'Obteniendo documentos ...',
          tipo: 'warning'
        });
        return DataService.get(restUrl + 'seguridad/virtual/verificar');
      })
      .then(function (respVerificar) {
        if (angular.isDefined(respVerificar.datos.esVirtual) && respVerificar.datos.esVirtual) verificacion = respVerificar.datos;
        return obtenerDocumentos(documentosParaFirmar);
      })
      .then(function (respDocumentos) {
        if(!respDocumentos) throw Error('No se pudieron obtener documentos.');
        if(!respDocumentos.obtenidos.length === 0) throw Error('No se obtuvieron documentos firmar');
        control.obtenidos = respDocumentos.obtenidos.length || 0;
        Loading.cambiar({
          mensaje: 'Firmando documentos ...',
          tipo: 'info'
        });
        var nroDocumento = cuenta.doc;
        if (verificacion.esVirtual == true) nroDocumento = verificacion.nroDocumento;
        return FirmaticService.firmarPdf(respDocumentos.obtenidos, nroDocumento);
      })
      .then(function (respuestaFirma) {
        
        if (!respuestaFirma || respuestaFirma.status !== 200) {
          throw Error("No se pudo firmar el documento, revise que el firmador se encuentra en ejecución.");
        }
        Loading.cambiar({
          mensaje: 'Guardando documentos firmados ...',
          tipo: 'success'
        });
        control.firmados = respuestaFirma.data.files.length || 0;
        return guardarDocumentosFirmados(respuestaFirma.data.files);
      })
      .then(function (respGuardados) {
        if(respGuardados.guardado.length === 0 && control.seleccionados.length > 0 ) throw Error('No se guardo ningun documento.');
        control.guardados = respGuardados.guardado.length || 0;
        
        if(control.seleccionados === control.guardados) {
          Message.success(control.seleccionados+' documentos firmados y guardados correctamente.');
        }
        else {
          
          Message.show('INFORMACION','De '+control.seleccionados+' se firmaron '+control.firmados+' y se guardaron '+control.guardados);
        }
        
        Loading.cerrar();
        $timeout(function () {
          angular.element('#btn-refresh-crudtable').click();
        });
      })
      .catch(function (error) {
        Message.error(error.message);
        Loading.cerrar();
      });

    }

    function verificarSeleccionados(documentos) {
      var respuesta = []
      vm.docDic = {};
      documentos.map(function (documento) {
        if (documento.selected != null && documento.selected) {
          documento.firmado = false;
          respuesta.push(documento);
          vm.docDic[documento.id_documento+'.pdf'] = documento.id_documento;
        }
      });

      return respuesta;
    }
    /**
     * Funcion que transforma un buffer en base64
     * @param {Buffer} buffer buffer de un archivo
     */
    function arrayBufferToBase64(buffer) {
      var defer = $q.defer();
      var binary = '';
      var bytes = new Uint8Array(buffer);
      var len = bytes.byteLength;
      for (var i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      defer.resolve($window.btoa(binary));
      return defer.promise;
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('DocumentosController', DocumentosController);

  /** @ngInject */
  function DocumentosController(DataService, restUrl, Storage, Datetime, $location, Modal, Documento) {
    var vm = this;
    vm.titulo = "Bandeja de documentos";
    var cuenta = Storage.getUser();

    vm.usuario=cuenta.id;
    vm.url = restUrl + 'plantillasFormly/documento/'+cuenta.id+'/misdocumentos/';
    vm.permission = {
      create:false,
      update:false,
      delete:true
    };
    vm.fields = [
      "id_documento",
      "nombre",
      "nombre_plantilla",
      "fecha",
      "estado",
      "impreso",
      "_fecha_creacion",
      "_fecha_modificacion"
    ];

    vm.estadoOpciones = [
        { v:'nuevo', t:'NUEVO'},
        { v:'firme', t:'FIRMÉ'},
        { v:'envia', t:'ENVIADO'},
        { v:'cerra', t:'CERRADO'},
        { v:'deriv', t:'DERIVADO'},
        { v:'derive', t:'DERIVE'},
        { v:'respondi', t:'RESPONDI'}
    ];
    if(cuenta.es_jefe){
        vm.estadoOpciones.push( { v:'aprobe', t:'APROBE'} );
        vm.estadoOpciones.push( { v:'rechace', t:'RECHACE'} );
    }

    vm.buttons = [
        {
          multiple: true,
          key_item: 'estado',
          opcion: {
            'NUEVO': { tooltip: 'Editar', icon: 'checked', onclick: irDocumento },
            'ENVIADO': { tooltip: 'Editar', icon: 'checked', onclick: irDocumento},
            'CERRADO': { tooltip: 'Editar', icon: 'checked', onclick: irDocumento},
            'DERIVADO': { tooltip: 'Editar', icon: 'checked', onclick: irDocumento},
            'DEFAULT': { tooltip: 'Ver', icon: 'remove_red_eye', onclick: irDocumento}
          }
        },
        {
            tooltip: 'Ver Historial',
            icon: 'timeline',
            onclick: verProgreso
        }
    ];
    vm.buttonAgregar = {
        tooltip: 'Añadir',
        icon: 'add',
        onclick: nuevoDocumento
    };

    function irDocumento(pEvento, pIdentificador){
        DataService.get(restUrl+'plantillasFormly/documento/?id_documento='+pIdentificador+'&fields=_usuario_creacion')
        .then(function (respuesta) {
            if(respuesta.datos.resultado[0]._usuario_creacion==cuenta.id)
                $location.path('documento/' + pIdentificador);
            else
                Documento.showPdfId(pIdentificador);
        })
    }
    function verProgreso(pEvento, pIdentificador) {
        Documento.showProgressAll(pEvento, pIdentificador);
    }

    function nuevoDocumento(pEvento){
        var config = {
            event: pEvento,
            templateUrl: 'app/modules/plantillasFormly/documentos/documento.dialog.html',
            controller: ['$scope','$mdDialog','DataService','Message','restUrl', 'Storage', DialogEscojerPlantilla]
        };
        Modal.show(config);
    }

    function DialogEscojerPlantilla( $scope, $mdDialog, DataService, Message, restUrl, Storage ) {
        var vmd = $scope;

        vmd.elegir = elegir;
        vmd.urlBase = 'plantillasFormly/plantilla_formly/?fields=id_plantilla_formly,nombre,abreviacion&sort=nombre&estado=ACTIVO&limit=10000'
        
        iniciarDialog();

        function iniciarDialog() {
            DataService.get(restUrl + vmd.urlBase)
            .then(function (data) {
                vmd.plantillas_disponibles = data.datos.resultado;
                vmd.plantilla_seleccionada = data.datos.resultado[0].id_plantilla_formly;
            });
        }

        function elegir() {
            DataService.get(restUrl + 'plantillasFormly/plantilla_formly/'+vmd.plantilla_seleccionada)
            .then(function (data) {
                Storage.setSession("pl", data.datos);
                $location.path('documento/0');
                $mdDialog.cancel();
            });
        }
    }

  }
})();

(function () {
  'use strict';

  angular
  .module('app')
  .controller('ContactosController', ContactosController);

  /** @ngInject */

  function ContactosController(restUrl, Storage) {
    var vm = this;
    var cuenta = Storage.getUser();
    vm.usuario = cuenta.id;
    
    vm.titulo = 'Bandeja de contactos';
    vm.url = restUrl + 'plantillasFormly/contacto/';
    vm.fields = [
      'id_contacto',
      'grado',
      'nombres',
      'apellidos',
      'entidad',
      'tipo_entidad',
      'estado',
      '_fecha_creacion',
      '_fecha_modificacion'
    ];
    vm.permission = {
      delete: false
    };

    vm.order= 'estado';
    vm.dialogController = ['data', 'Message', '$scope', '$mdDialog', 'DataService', 'restUrl', '$timeout', DialogContactoController];
    vm.template = 'app/modules/plantillasFormly/contactos/dialog.contactos.html';
    function DialogContactoController(data, Message, $scope, $mdDialog, DataService, restUrl, $timeout) {
      var vmd = $scope;
      
      vmd.obtenerTiposEntidad = obtenerTiposEntidad;
      vmd.cerrar = cerrar;
      vmd.registrarContacto = registrarContacto;
      vmd.habilitarOtro = habilitarOtro;
      vmd.data = data;
      vmd.titulo = 'Editar';
      vmd.otroEditar = false;
      vmd.departamentos = [
        { id: 'BENI', name: 'BENI'},
        { id: 'CHUQUISACA', name: 'CHUQUISACA'},
        { id: 'COCHABAMBA', name: 'COCHABAMBA'},
        { id: 'LA PAZ', name: 'LA PAZ'},
        { id: 'ORURO', name: 'ORURO'},
        { id: 'PANDO', name: 'PANDO'},
        { id: 'POTOSI', name: 'POTOSI'},
        { id: 'SANTA CRUZ', name: 'SANTA CRUZ'},
        { id: 'TARIJA', name: 'TARIJA'}
      ];
      vmd.estados = [
        { id: 'ACTIVO', name: 'ACTIVO'},
        { id: 'INACTIVO', name: 'INACTIVO'}
      ];
      if(vmd.data.id_contacto == null) {
        vmd.titulo = 'Agregar';
        vmd.data.estado = 'ACTIVO';
        vmd.data.departamento = 'LA PAZ';
      }
      vmd.obtenerTiposEntidad();
      
      function registrarContacto() {
        var datosEnviar = vmd.data;

        if (vmd.otroEditar == true) {
          datosEnviar.tipo_entidad = datosEnviar.otro_tipo;
        }
        // Modificar contacto
        if(vmd.data.id_contacto) {
          DataService.put(restUrl + 'plantillasFormly/contacto/' + vmd.data.id_contacto, datosEnviar)
          .then(function (respContacto) {
            Message.show(respContacto.tipoMensaje, respContacto.mensaje);
            $mdDialog.hide();
            $timeout(function (){
              angular.element('#btn-refresh-crudtable').click();
            }, 500);
          });
        }
        // Crear contacto
        else {
          DataService.post(restUrl+'plantillasFormly/contacto', datosEnviar)
          .then(function (respContacto) {
            Message.show(respContacto.tipoMensaje, respContacto.mensaje);
            $mdDialog.hide();
            $timeout(function () {
              angular.element('#btn-refresh-crudtable').click();
            }, 500)
          })
        }
      }
      
      function obtenerTiposEntidad() {
        DataService.get(restUrl + 'plantillasFormly/contactos/tiposEntidad')
        .then(function (respTipos) {
          vmd.tiposEntidad = respTipos.datos;
          vmd.tiposEntidad.push({tipo_entidad:'Otros...', otro:true});
        })
        
      }

      function habilitarOtro(item) {
        if (angular.isDefined(item.otro) && item.otro == true) {
          vmd.otroEditar = true;
        }
        else {
          vmd.otroEditar = false;
        }
        
      }

      function cerrar() {
        $mdDialog.cancel();
      }
      
    }

  }
})();
(function (){
  'use strict';

  angular
  .module('app')
  .controller('CompartidosController', CompartidosController);

  /**@ngInject */

  function CompartidosController(restUrl, Storage, $location, Catalogo) {
    var vm = this;
    var cuenta = Storage.getUser();
    vm.cuenta = cuenta;
    vm.usuario = cuenta.id;
    vm.titulo = 'Catalogos compartidos';

    vm.url = restUrl + 'plantillasFormly/catalogo/'+vm.usuario+'/compartidos';
    vm.fields = ['id_catalogo', 'nombre', 'descripcion', 'estado'];
    vm.permissions = {
      create: false,
      update: false,
      delete: false
    };

    vm.order = 'nombre'
    vm.botones = [
      { tooltip: 'Ir catalogo', icon:'folder_shared', onclick: irCatalogo },
      { tooltip: 'Ver historial', icon:'timeline', onclick: obtenerHistorial }
    ]


    function irCatalogo(ev, id) {
      ev.preventDefault();
      var identificador = 0;
      if (id) identificador = id;
      $location.path('compartido/' + identificador);
    }

    function obtenerHistorial(ev, id) {
      ev.preventDefault();
      Catalogo.showHistory(ev, id);
    }
  }
})();
(function() {
  'use strict';

  angular
    .module('app')
    .controller('AprobarDocumentoController', AprobarDocumentoController);

  /** @ngInject */
  function AprobarDocumentoController(restUrl, Storage, Documento, Modal, $q, DataService, FirmaticService, $window, Message, Loading, $timeout) {

    var vm = this;
    var cuenta = Storage.getUser();
    vm.cuenta = cuenta;
    vm.usuario = cuenta.id;
    vm.titulo = "Aprobar documentos";
    vm.url = restUrl + 'documento/aprobarCiudadania';
    vm.firmarDocumentos = firmarDocumentos;
    vm.items = {};
    vm.habilitarSeleccion = true;

    verificarNotificacionesCDAprobaciones();

    function verificarNotificacionesCDAprobaciones() {
      if ($window.localStorage.getItem('CD_aprobacion_notificacion') != null && $window.localStorage.getItem('CD_aprobacion_notificacion') != undefined) {
        var notificacionAprobaciones = angular.fromJson($window.localStorage.getItem('CD_aprobacion_notificacion'));
        if (notificacionAprobaciones.type === 'error') {
          Message.error(notificacionAprobaciones.message);
        } else if (notificacionAprobaciones.type === 'success') {
          Message.success(notificacionAprobaciones.message)
        } else {
          Message.warning(notificacionAprobaciones.message)
        }
        $window.localStorage.removeItem('CD_aprobacion_notificacion');
      }
    }

    vm.permission = {
      create: false,
      update: false,
      delete: false
    };

    vm.fields = [
      "id_documento",
      "nombre",
      "nombre_plantilla",
      "fecha",
      "estado",
      "_fecha_modificacion",
      "adjunto_aprobacion_cd",
      "aprobarDocumento"
    ];

    vm.estadoOpciones = [
      { v:'cerra', t:'CERRADO'}
    ];

    vm.buttons = [
      {
        tooltip: 'Ver',
        icon: 'remove_red_eye',
        onclick: vistaPrevia
      },
      {
        tooltip: 'Ver Historial',
        icon: 'timeline',
        onclick: verProgreso
      }
    ];
    vm.habilitarBotonFirma = false;
    vm.obtenerSeleccionados=obtenerNumeroSeleccionados;
    vm.verificarSeleccionados = verificarSeleccionados;
    vm.arrayBufferToBase64 = arrayBufferToBase64;
    vm.obtenerDocumentos = obtenerDocumentos;
    vm.guardarDocumentosFirmados = guardarDocumentosFirmados;
    vm.docDic = {};
    
    /**
     * Funcion que obtiene el número de documentos seleccionados.
     * @param {Integer} cantidad Informacion respecto a la cantidad de documentos seleccionados.
     */
    function obtenerNumeroSeleccionados(cantidad) {
      vm.habilitarBotonFirma = cantidad;
    }

    /**
     * Funcion que permite carga la vista previa de un documento.
     * @param {Function} pEvento Funcion de control del evento(click)
     * @param {Integer} pIdentificador Identificador del documento.
     */
    function vistaPrevia(pEvento, pIdentificador){
      Documento.showPdfId(pIdentificador);
    }

    /**
     * Funcion que permite la carga del progreso del documento seleccionado
     * @param {Function} pEvento Funcion de control del evento(click)
     * @param {Integer} pIdentificador Identificador del documento
     */
    function verProgreso(pEvento, pIdentificador) {
      Documento.showProgressAll(pEvento, pIdentificador);
    }

    
    function obtenerDocumentos(lista) {      
      var respuesta = {
        obtenidos: [],
        noObtenidos: []
      };
      var promesas = lista.map(function (item) {
        return new Promise(function (resolve) {
          return DataService.pdf(restUrl + 'documento/firmar', {
              cite: item.nombre,
              id_documento: item.id_documento
            })
            .then(function (respuestaPdf) {
              if (!respuestaPdf || !respuestaPdf.data) throw Error('No se pudo obtener el documento');
              return arrayBufferToBase64(respuestaPdf.data);
            })
            .then(function (base64) {
              respuesta.obtenidos.push({
                base64: 'data:application/pdf;base64,' + base64,
                name: item.id_documento + '.pdf'
              });
              
              return resolve();
            })
            .catch(function (errorObtener) {
              // console.log('Error al obtener el base 64');
              respuesta.noObtenidos.push({
                documento: item.nombre,
                error: errorObtener
              });
              return resolve();

            });

        });

      });
      return Promise.all(promesas)
        .then(function () {
          return Promise.resolve(respuesta);
        })
        .catch(function (error) {
          // console.log('Error al ejecutar las promesas', error);
          return Promise.reject(error);
        });
    }
    function guardarDocumentosFirmados(lista) {
      var respuesta = {
        total: lista.length || 0,
        guardado: [],
        noGuardado: []
      };
      var promesas = lista.map(function(item) {
        return new Promise(function (resolve) {
          var nombreDocumento = item.name          
          if (angular.isUndefined(vm.docDic[nombreDocumento])){
            respuesta.noGuardado.push(nombreDocumento.replace('.pdf', ''));
            return resolve();
          }
          return DataService.post(restUrl + 'documento/firmado/', {
            base64: item.base64,
            id_documento: vm.docDic[nombreDocumento]
          })
          .then(function (respGuardado) {
            if(respGuardado.tipoMensaje !== 'EXITO') throw Error(respGuardado.mensaje);
            respuesta.guardado.push(nombreDocumento);
            return resolve();
          })
          .catch(function () {
            respuesta.noGuardado.push(item.name);
            return resolve();
          });
        });
      });


      return Promise.all(promesas)
      .then(function () {
        return Promise.resolve(respuesta);
      })
      .catch(function(error){
        // console.log('Error al ejecutar las promesas de guardado', error);
        
        return Promise.reject(error);
      })
    }

    function firmarDocumentos() {
      var verificacion = {};
      var configLoad = {
        data:{
          mensaje: 'Verificando firmador...',
          tipo: 'info'
        }
      };
      Loading.show(configLoad);
      var documentosParaFirmar = vm.verificarSeleccionados(vm.items.data);
      var control = {
        seleccionados: documentosParaFirmar.length,
        obtenidos: 0,
        firmados: 0,
        guardados: 0
      };

      FirmaticService.verificarEstado()
      .then(function (respEstado) {
        if(respEstado.activo === false) throw Error(respEstado.mensaje);
        Loading.cambiar({
          mensaje: 'Obteniendo documentos ...',
          tipo: 'warning'
        });
        return DataService.get(restUrl + 'seguridad/virtual/verificar');
      })
      .then(function (respVerificar) {
        if (angular.isDefined(respVerificar.datos.esVirtual) && respVerificar.datos.esVirtual) verificacion = respVerificar.datos;
        return obtenerDocumentos(documentosParaFirmar);
      })
      .then(function (respDocumentos) {
        if(!respDocumentos) throw Error('No se pudieron obtener documentos.');
        if(!respDocumentos.obtenidos.length === 0) throw Error('No se obtuvieron documentos firmar');
        control.obtenidos = respDocumentos.obtenidos.length || 0;
        Loading.cambiar({
          mensaje: 'Firmando documentos ...',
          tipo: 'info'
        });
        var nroDocumento = cuenta.doc;
        if (verificacion.esVirtual == true) nroDocumento = verificacion.nroDocumento;
        return FirmaticService.firmarPdf(respDocumentos.obtenidos, nroDocumento);
      })
      .then(function (respuestaFirma) {
        
        if (!respuestaFirma || respuestaFirma.status !== 200) {
          throw Error("No se pudo firmar el documento, revise que el firmador se encuentra en ejecución.");
        }
        Loading.cambiar({
          mensaje: 'Guardando documentos firmados ...',
          tipo: 'success'
        });
        control.firmados = respuestaFirma.data.files.length || 0;
        return guardarDocumentosFirmados(respuestaFirma.data.files);
      })
      .then(function (respGuardados) {
        if(respGuardados.guardado.length === 0 && control.seleccionados.length > 0 ) throw Error('No se guardo ningun documento.');
        control.guardados = respGuardados.guardado.length || 0;
        
        if(control.seleccionados === control.guardados) {
          Message.success(control.seleccionados+' documentos firmados y guardados correctamente.');
        }
        else {
          
          Message.show('INFORMACION','De '+control.seleccionados+' se firmaron '+control.firmados+' y se guardaron '+control.guardados);
        }
        
        Loading.cerrar();
        $timeout(function () {
          angular.element('#btn-refresh-crudtable').click();
        });
      })
      .catch(function (error) {
        Message.error(error.message);
        Loading.cerrar();
      });

    }

    function verificarSeleccionados(documentos) {
      var respuesta = []
      vm.docDic = {};
      documentos.map(function (documento) {
        if (documento.selected != null && documento.selected) {
          documento.firmado = false;
          respuesta.push(documento);
          vm.docDic[documento.id_documento+'.pdf'] = documento.id_documento;
        }
      });

      return respuesta;
    }
    /**
     * Funcion que transforma un buffer en base64
     * @param {Buffer} buffer buffer de un archivo
     */
    function arrayBufferToBase64(buffer) {
      var defer = $q.defer();
      var binary = '';
      var bytes = new Uint8Array(buffer);
      var len = bytes.byteLength;
      for (var i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      defer.resolve($window.btoa(binary));
      return defer.promise;
    }
  }
})();


(function () {
  'use strict';

  angular
  .module('app')
  .controller('CatalogosController', CatalogosController);

  /**@ngInject */
  function CatalogosController(DataService, restUrl, Storage, $timeout, $location, Message, Modal, Catalogo) {
    var vm = this;
    var cuenta = Storage.getUser();
    vm.cuenta = cuenta;
    vm.usuario = cuenta.id;
    vm.titulo = "Edición/Creación de Catalogos";

    vm.url = restUrl + 'plantillasFormly/catalogo/'+vm.usuario+'/miscatalogos';
    vm.fields = ['id_catalogo', 'nombre', 'descripcion', 'estado'];
    vm.escucharSeleccion = escucharSeleccion;
    vm.existeSeleccionados = false;
    vm.items = {};

    vm.permissions = {
      create: false,
      update: false,
      delete: false
    };

    vm.order = 'estado';

    vm.botonAgregar = {
      tooltip: 'crear',
      icon: 'add',
      onclick: irCatalogo
    }
    vm.botonesCabecera = [
      {
        tooltip: "Cambiar propietario",
        icon: "security",
        onclick: abrirModalCambioPropietario,
        enable: vm.habilitarCambioPropietario
      }
    ];
    vm.botones = [
      {
        tooltip: "Agregar documentos/usuarios",
        icon: "create",
        onclick: irCatalogo
      },
      {
        tooltip: "Eliminar catalogo",
        icon: "delete",
        onclick: eliminarCatalogo
      },
      {
        tooltip: "Ver historial",
        icon: "timeline",
        onclick: obtenerHistorial
      }
    ];

    function abrirModalCambioPropietario(ev) {
      ev.preventDefault();
      if (!vm.existeSeleccionados) {
        Message.show('ADVERTENCIA', "No existe ningun catalogo seleccionado");
      }
      else {
        var config = {
          data: {
            items: vm.items,
            cuenta: vm.cuenta
          },
          templateUrl:
            "app/modules/plantillasFormly/catalogos/propietario.dialog.html",
          controller: [
            "data",
            "$scope",
            "$mdDialog",
            "DataService",
            "Message",
            "restUrl",
            "$timeout",
            DialogCambiarPropietario
          ]
        };
        Modal.show(config);
      }
    }

    function escucharSeleccion(seleccionado) {
      vm.existeSeleccionados = seleccionado;
    }

    function irCatalogo(ev, id) {
      ev.preventDefault();
      var identificador = 0;
      if (id) identificador = id;
      $location.path('catalogo/'+identificador);
    }
    function eliminarCatalogo(ev, id) {
      ev.preventDefault();
      if (!id) {
        Message.show('INFORMACION', 'No selecciono un catalogo a eliminar');
        return;
      }
      DataService.delete(restUrl + 'plantillasFormly/catalogo/' + id +'/miscatalogos', null, true)
      .then(function (resp) {
        Message.show(resp.tipoMensaje, resp.mensaje);
        $timeout(function () {
          angular.element('#btn-refresh-crudtable').click();
        }, 500);

      })
      
    }

    function obtenerHistorial(ev, id) {
      ev.preventDefault();
      Catalogo.showHistory(ev, id);
    }

    function DialogCambiarPropietario(data, $scope, $mdDialog, DataService, Message, restUrl, $timeout) {
      var vmd = $scope;
      vmd.test = 'asdasd';
      vmd.buscarPropietario="";
      vmd.data = data;
      vmd.listaCatalogos = [];
      
      iniciarController();

      vmd.clearSearchTerm = function () {
        vmd.buscarPropietario = "";
      };
      function iniciarController() {

        angular.element("input.header-searchbox").on("keydown", function (ev) {
          ev.stopPropagation();
        });
        
        vmd.listaCatalogos = data.items.data.filter(function (item) {
          if (item.selected) return item;
        });

        DataService.get(restUrl + "seguridad/usuario_rol/")
        .then(function (resp) {
          vmd.usuarios = resp.datos;
        });
        
      }
      vmd.transferir = function() {
        var datosEnviar= {
          propietario: vmd.usuario.id_usuario,
          catalogos: vmd.listaCatalogos
        };
        DataService.put(restUrl + "plantillasFormly/catalogo/"+vmd.data.cuenta.id+"/propietario", datosEnviar)
        .then(function(resp){
          Message.show(resp.tipoMensaje, resp.mensaje );
          // $location.path("catalogos");
          vmd.cerrar();
          $timeout(function () {
            angular.element("#btn-refresh-crudtable").click();
          }, 300);
        })

      }

      vmd.cerrar = function() {
        $mdDialog.cancel();
      }
      
    }
  }
})();
(function() {
  'use strict';

  angular
    .module('app')
    .controller('AprobacionController', AprobacionController);

  /** @ngInject */
  function AprobacionController(DataService, restUrl, backUrl, Storage, $location, Modal, UtilFormly, Datetime, Documento, Loading) {

    var vm = this;
    vm.titulo = "Documentos pendientes";
    var cuenta = Storage.getUser();
    vm.usuario=cuenta.id;
    vm.url = restUrl + 'plantillasFormly/documento/'+cuenta.id+'/todo/';

    //cargamos funciones
    vm.vistaPrevia = vistaPrevia;

    vm.permission ={
      create:false,
      update:false,
      delete:true
    };

    vm.estadoOpciones = [{ v:'deriv', t:'DERIVADO'},{ v:'recha', t:'RECHAZADO'}];
    if(cuenta.es_jefe){
        vm.estadoOpciones.push({ v:'envia', t:'ENVIADO'});
    }

    vm.fields = [
      "id_documento",
      "nombre",
      "nombre_plantilla",
      "fecha",
      "estado",
      "_fecha_creacion",
      "_fecha_modificacion"
      // "firmado"
      // "adjunto_aprobacion_cd"
    ];

    vm.buttons = [
      {
        multiple: true,
        key_item: 'estado',
        opcion: {
          'RECHAZADO': {
            tooltip: 'Editar',
            icon: 'checked',
            onclick: irDocumento
          },
          'DEFAULT': {
            tooltip: 'Ver',
            icon: 'remove_red_eye',
            onclick: vistaPrevia
          }
        }
      },
      {
          tooltip: 'Ver Historial',
          icon: 'timeline',
          onclick: verProgreso
      }
    ];

    function irDocumento(pEvento, pIdentificador){
        DataService.get(restUrl+'plantillasFormly/documento/?id_documento='+pIdentificador+'&fields=_usuario_creacion')
        .then(function (respuesta) {
            if(respuesta.datos.resultado[0]._usuario_creacion==cuenta.id)
                $location.path('documento/' + pIdentificador);
            else
                Documento.showPdfId(pIdentificador);
        });
    }

    function verProgreso(pEvento, pIdentificador) {
        Documento.showProgressAll(pEvento, pIdentificador);
    }

    function vistaPrevia(pEvento, pIdentificador){
      var datosEnviar = {doc:{}};
      datosEnviar.doc = {};
      var data;
      DataService.get(restUrl + 'plantillasFormly/documento/'+pIdentificador)
      .then(function (respuestaDocumento) {
        // $log.log("revisando la obtencion de datos", respuestaDocumento);
        data = respuestaDocumento;
        // var usuarioPara = JSON.parse(data.datos.para);
        datosEnviar.model_actual = angular.fromJson(data.datos.plantilla_valor);
        var model = datosEnviar.model_actual;
        if( model["cite-0"] && model["cite-0"].fecha )
        model["cite-0"].fecha = Datetime.format(model["cite-0"].fecha, 'dd de MMM de YYYY');
        datosEnviar.form_actual = UtilFormly.dataToView(angular.fromJson(data.datos.plantilla), datosEnviar.model_actual);
        datosEnviar.doc.nombre = data.datos.nombre;
        datosEnviar.doc.plantilla = data.datos.plantilla;

        return;

      })
      .then(function() {
        return DataService.post(restUrl+ "plantillasFormly/generarDocumento/",datosEnviar);
      })
      .then(function (pRespuesta) {
        datosEnviar = { html: pRespuesta.datos.html, nombre: pRespuesta.datos.nombre};
        datosEnviar.esDispositivoMovil = Documento.isMobile();
        return DataService.pdf(restUrl+'plantillasFormly/documentoPDF/',{cite: datosEnviar.nombre});
      })
      .then(function (respuesta) {
        if(!respuesta) return;
        datosEnviar.pdf = respuesta.url;
        datosEnviar.pdf_buffer = respuesta.data;
        var config = {
          data: { id:data.datos.id_documento, dc: data.datos, cuenta: cuenta, pdf: datosEnviar },
          templateUrl: 'app/modules/plantillasFormly/aprobacion/dialogPDF.html',
          controller: ['data', '$scope', '$mdDialog', 'DataService', 'restUrl', '$timeout', 'Storage', 'Datetime', 'Documento', 'Message', 'Util', DialogPDFController]
        };
        Modal.show(config);
      });

    }

    
    function DialogPDFController(data, $scope, $mdDialog, DataService, restUrl, $timeout, Storage, Datetime, Documento, Message, Util){
        var vmd = $scope;
        vmd.data={};
        vmd.data.dc=data.dc;
        vmd.data.observaciones;
        vmd.data.show_select = false;
        vmd.data.datosEnviar=data.dc.datosEnviar;

        vmd.data.html=data.pdf.html;
        vmd.data.pdf=data.pdf.pdf;
        vmd.data.flag_html=true;
        vmd.data.show_pdf=!data.pdf.esDispositivoMovil;

        //funciones
        vmd.cerrar = cerrar;
        vmd.aprobar = aprobar;
        vmd.observar = observar;
        vmd.derivar = derivar;
        vmd.openSelect = openSelect;
        vmd.crear = crear;
        vmd.verDocumento = verDocumento;

        vmd.mostrarPdf = function (id, sw){ if(sw) Documento.showPdfx(id); else Documento.showPdfId(id, false); }
        vmd.verHtml=function(){ vmd.data.flag_html=true; }
        vmd.verPdf=function(){ vmd.data.flag_html=false; }

        iniciar();

        function iniciar() {
            if (angular.isString(vmd.data.dc.para)) {
                vmd.data.dc.para = angular.fromJson(vmd.data.dc.para);
            }
            vmd.data.es_derivar = (vmd.data.dc.estado=='DERIVADO');
            vmd.data.es_para = (vmd.data.dc.para.indexOf(data.cuenta.id)!=-1 && !vmd.data.es_derivar);
            vmd.data.sw_es_respuesta = vmd.data.dc.grupo || false;
            if(vmd.data.sw_es_respuesta) {
                // obtener documentos de grupo
                DataService.get(restUrl + 'plantillasFormly/documento/?fields=id_documento,nombre,nombre_plantilla&estado=DERIVADO,CERRADO,APROBADO&sort=_fecha_creacion&grupo='+vmd.data.dc.grupo)
                .then(function (resultado) {
                    vmd.data.docs_grupo = resultado.datos.resultado;
                });
            }
            if (data.pdf.esDispositivoMovil) {
                Util.loadCanvas(data.pdf.pdf_buffer, '#canvasContainer');
            }

            DataService.get(restUrl + 'seguridad/usuario/'+vmd.data.dc._usuario_creacion)
            .then(function (respuesta) {
                vmd.data.nombres =  respuesta.datos.nombres;
                vmd.data.apellidos =  respuesta.datos.apellidos;
                if(vmd.data.es_para || vmd.data.es_derivar)
                    return DataService.get(restUrl + 'seguridad/usuario/'+cuenta.id+'/informacion');
                return;
            })
            .then(function (respuesta) {
                if(respuesta){
                    vmd.data.accion='observar';
                    vmd.data.usuarios = respuesta.datos.resultado;
                }
                if(vmd.data.es_derivar || vmd.data.es_para)
                    return DataService.get(restUrl + 'plantillasFormly/plantilla_formly/?fields=id_plantilla_formly,nombre,abreviacion&sort=nombre&estado=ACTIVO&limit=10000');
                return;
            })
            .then(function (respuesta) {
                if(respuesta){
                    vmd.data.plantillas_disponibles = respuesta.datos.resultado;
                }
            });

            if(vmd.data.es_derivar){
                DataService.get(restUrl + 'historialFlujo/'+vmd.data.dc.id_documento+'/ultimo')
                .then(function (resultado) {
                    vmd.data.usuario_proveido = resultado.datos.nombres+' '+resultado.datos.apellidos;
                });
            }

        }

        function aprobar(text) {
            var datos = { usuario: cuenta.id };
            var sw_crear = text=='crear';
            var mensajeLoad = 'Espere...';
            if(vmd.data.es_para) {

                datos.usuario_derivar = vmd.data._usuario_seleccionado;
                if(text=='aprobar') {
                    text = 'aprobar y cerrar';
                    mensajeLoad = ' Aprobando y cerrando...';
                    datos.derivar = false;
                }
                if(text=='derivar'){
                    text = 'aprobar y derivar';
                    mensajeLoad = 'Aprobando y derivando...'
                    datos.observaciones = vmd.data.observaciones;
                    datos.derivar = true;
                }
                if(sw_crear){
                    text = 'aprobar y luego crear documento';
                    datos.usuario_derivar = datos.usuario;
                    datos.observaciones = '';
                    datos.derivar = true;
                }
            }
            Modal.confirm('¿Esta seguro de que quiere '+text+'?', function () {
                var configLoad = {
                    data: {
                        mensaje: mensajeLoad,
                        tipo: 'info'
                    }
                };
                Loading.show(configLoad);
                Loading.cambiar({tipo:'info'});
                DataService.put( restUrl+'plantillasFormly/documento/'+data.id+"/aprobar", datos)
                .then(function (respuesta) {
                  if (angular.isUndefined(respuesta)) throw Error ('Sin respuesta');
                  Message.show(respuesta.tipoMensaje, respuesta.mensaje);
                  if (sw_crear) {
                    DataService.get(restUrl + 'plantillasFormly/plantilla_formly/'+vmd.data._plantilla_seleccionada.id_plantilla_formly)
                    .then(function (respuesta) {
                    respuesta.datos.documento_padre = data.id;
                    respuesta.datos.grupo = data.dc.grupo;
                    Storage.setSession("pl", respuesta.datos);
                    Storage.setSession("doc_padre", data.id);
                    $location.path('documento/0');
                    $mdDialog.cancel();
                    Loading.cerrar();
                  });
                  $timeout(function(){ angular.element('#btn-refresh-crudtable').click(); });
                  cerrar();
                  }else{
                    $timeout(function(){ angular.element('#btn-refresh-crudtable').click(); });
                    cerrar();
                    Loading.cerrar();
                  }
                })
                .catch(function () {
                  cerrar();
                  $timeout(function(){ angular.element('#btn-refresh-crudtable').click(); });
                  Loading.cerrar();
                });
            });
        }

        function observar() {
            var datos = {
                usuario: cuenta.id,
                observaciones: vmd.data.observaciones,
                observado_por: cuenta.first_name+' '+cuenta.last_name
            };
            
            Modal.confirm('¿Esta seguro de que quiere observar?', function(){
              DataService.put( restUrl+'plantillasFormly/documento/'+data.id+"/rechazar", datos)
              .then(function (respuesta) {
                Message.show(respuesta.tipoMensaje, respuesta.mensaje);
                $timeout(function(){ angular.element('#btn-refresh-crudtable').click(); });
                cerrar();
              });
            });
        }

        function derivar(){
            Modal.confirm('¿Esta seguro de que quiere derivar?', function(){
                var datos = {
                    usuario: cuenta.id,
                    destino: vmd.data._usuario_seleccionado,
                    observaciones: vmd.data.observaciones
                };
                DataService.put( restUrl+'plantillasFormly/documento/'+data.id+"/derivar", datos)
                .then(function (respuesta) {
                    Message.show(respuesta.tipoMensaje, respuesta.mensaje);
                    $timeout(function(){ angular.element('#btn-refresh-crudtable').click(); });
                    cerrar();
                });
            });
        }

        function openSelect(ev){
            angular.element(ev.currentTarget).next().children()[0].click();
            vmd.data.show_select = true;
        }

        function crear(p) {
            DataService.get(restUrl+'plantillasFormly/documento/?documento_padre='+data.id)
            .then(function (respuesta) {
                if(respuesta.datos.total==0){
                  if(angular.isDefined(p) && p){
                    aprobar('crear');
                  }
                  else {
                    Modal.confirm('¿Esta seguro de que quiere crear '+vmd.data._plantilla_seleccionada.nombre+'?', function () {
                      DataService.get(restUrl + 'plantillasFormly/plantilla_formly/'+vmd.data._plantilla_seleccionada.id_plantilla_formly)
                      .then(function (respuesta) {
                          respuesta.datos.documento_padre = data.id;
                          respuesta.datos.grupo = data.dc.grupo;
                          Storage.setSession("pl", respuesta.datos);
                          $location.path('documento/0');
                          $mdDialog.cancel();
                      });
                      cerrar();
                    });
                  }

                }

                else{
                    var doc = respuesta.datos.resultado[0];
                    var html = '';
                    html+= 'El documento ya tiene respuesta!!<br>';
                    html+= 'Si quiere crear otra tiene que borrar la actual <br>';
                    html+= 'Nombre: '+doc.nombre+' <br>';
                    html+= 'Tipo de documento: '+doc.nombre_plantilla+' <br>';
                    html+= 'Estado: '+doc.estado+' <br>';
                    html+= 'Fecha de creación: '+Datetime.format(doc._fecha_creacion)+' <br>';
                    Modal.alert(html);
                    $location.path('documentos');
                }


            })



        }

        function verDocumento(id_doc) { Documento.showPdfId(id_doc, false); }
        function cerrar(){ $mdDialog.cancel(); }
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('RolController', RolController);

  /** @ngInject */
  function RolController(restUrl, Storage) {
    var vm = this;

    var cuenta=Storage.getUser();
    vm.usuario = cuenta.id;

    //config para crudTable
    vm.url = restUrl+'seguridad/rol/';
    vm.fields = ['id_rol','nombre','descripcion','peso','estado','_fecha_creacion','_fecha_modificacion'];
    vm.titulo = "Roles";
    vm.dialogController = ['data', 'Message', '$scope', '$mdDialog', 'DataService', 'restUrl', '$timeout', DialogRolController];
    vm.template = 'app/modules/seguridad/rol/dialog.rol.html';

    function DialogRolController(data, Message, $scope, $mdDialog, DataService, restUrl, $timeout) {
        var vmd = $scope;

        vmd.cerrar = cerrar;
        vmd.registrarRol = registrarRol;
        vmd.data = data;
        vmd.estados = [{id:"ACTIVO", name: "ACTIVO"},{id:"INACTIVO", name: "INACTIVO"}];

        // console.log(data);

        if (!vmd.data.id_rol) vmd.data._fecha_creacion = new Date();
        vmd.data._fecha_modificacion = new Date();
        obtenerMenus();
        function obtenerMenus() {
            if(vmd.data.id_rol){
                DataService.get(restUrl+"seguridad/menu?limit=1000&estado=ACTIVO")
                .then(function(respuesta){
                    vmd.menus = respuesta.datos.resultado;
                    // console.log("id_rol->"+vmd.data.id_rol);
                    return DataService.get(restUrl+"seguridad/rol/"+vmd.data.id_rol+"/menu");
                })
                .then(function(respuesta){
                    vmd.rol_menus = respuesta.datos;
                    // console.log(vmd.rol_menus);
                    for (var i = 0; i < vmd.rol_menus.length; i++) {
                        for (var j = 0; j < vmd.menus.length; j++) {
                            if(vmd.rol_menus[i].fid_menu == vmd.menus[j].id_menu){
                                vmd.menus[j].checked = (vmd.rol_menus[i].estado == 'ACTIVO')? true : false;
                                j = vmd.menus.length;
                            }
                        }
                    }
                });

            }else {
                DataService.get(restUrl+"seguridad/menu?limit=1000&estado=ACTIVO")
                .then(function(respuesta){
                    vmd.menus = respuesta.datos.resultado;
                })
            }

        }

        function registrarRol() {
            var datosEnviar = {
                rol: {
                    id_rol: vmd.data.id_rol,
                    nombre: vmd.data.nombre,
                    descripcion: vmd.data.descripcion,
                    peso: vmd.data.peso,
                    estado: vmd.data.estado
                },
                menus: []
            };
            // console.log(datosEnviar);
            if (vmd.data.id_rol) {
                datosEnviar.rol._usuario_modificacion = cuenta.id;
                datosEnviar.menus_nuevos = [];
                for (var i = 0; i < vmd.menus.length; i++) {
                    var existe = false;
                    for (var j = 0; j < vmd.rol_menus.length; j++) {
                        if(vmd.menus[i].id_menu == vmd.rol_menus[j].fid_menu)
                        {
                            // console.log(vmd.rol_menus[j]);
                            vmd.rol_menus[j].estado = (vmd.menus[i].checked)? 'ACTIVO' : 'INACTIVO';
                            vmd.rol_menus[j]._usuario_modificacion = cuenta.id;
                            delete vmd.rol_menus[j]._fecha_creacion;
                            delete vmd.rol_menus[j]._fecha_modificacion;
                            datosEnviar.menus.push(angular.fromJson(angular.toJson(vmd.rol_menus[j])));
                            existe = true;
                            j = vmd.rol_menus.length;
                        }
                    }
                    if(!existe && vmd.menus[i].checked){
                        datosEnviar.menus_nuevos.push(vmd.menus[i].id_menu);
                    }
                }

                DataService.put(restUrl+"seguridad/rol/"+vmd.data.id_rol+"/menu", datosEnviar)
                .then(function (respuesta) {
                    Message.show(respuesta.tipoMensaje,respuesta.mensaje);
                    $mdDialog.hide();
                    $timeout(function () {
                        angular.element('#btn-refresh-crudtable').click();
                    }, 500);
                });
            }else{
                datosEnviar.rol._usuario_creacion = cuenta.id;

                for (i = 0; i < vmd.menus.length; i++) {
                    if(vmd.menus[i].checked){
                        datosEnviar.menus.push(vmd.menus[i].id_menu);
                    }
                }
                DataService.post(restUrl+"seguridad/rol/0/menu", datosEnviar)
                .then(function (respuesta) {
                    Message.show(respuesta.tipoMensaje,respuesta.mensaje);
                    $mdDialog.hide();
                    $timeout(function () {
                        angular.element('#btn-refresh-crudtable').click();
                    }, 500);
                });
            }

        }
        function cerrar() {
            $mdDialog.cancel();
        }

    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('MenuController', MenuController);

    /** @ngInject */
    function MenuController(Storage, restUrl) {

        var vm=this;

        vm.url = restUrl + 'seguridad/menu/';
        vm.fields = [
            'id_menu', 
            'fid_menu_padre',
            'nombre', 
            'descripcion', 
            'orden', 
            'ruta', 
            'icono', 
            'estado',
            '_fecha_creacion',
            '_fecha_modificacion'
        ];
        
        vm.titulo = "Menús";

        var cuenta=Storage.getUser();
        vm.usuario = cuenta.id;
        
    }
})();

(function () {
  'use strict';

  angular
  .module('app')
  .controller('VirtualController', VirtualController);

  /** @ngInject */
  function VirtualController($location, Message, DataService, restUrl, SideNavFactory, ExpirationTime, Storage, Loading, $timeout, $auth, Util, BreadcrumbFactory) {
  
    var vm = this;
    vm.usuariosVirtuales = [];

    vm.seleccionar = function (item) {
      Loading.show({
        data: {
          mensaje: 'Cambiando de usuario...',
          tipo: 'success'
        }
      });
      
      DataService.get(restUrl + 'seguridad/virtual/cambiar/' + item.id_usuario)
      .then(function (respVirtual) {
        // TODO: controlar si no se pudo obtener los datos de activacion del usuario virtual.
        if(angular.isUndefined(respVirtual)) {
          throw Error('Error en el cambio de usuario.');
        }
        var user = respVirtual.datos.user;
        var menu = respVirtual.datos.menu;
        var roles = respVirtual.datos.roles;
        var path = Storage.getSession('path');
        user.es_jefe = false;
        if(path == null ) {
          var max = 10;
          roles.forEach(function(item) {
            if (item.rol.peso < max && item.rol.peso !== 0) max = item.rol.peso;
            if (item.rol.nombre == 'JEFE')  user.es_jefe = true;
          });
          path = ['documentos', 'aprobacion', 'impresion', 'documentos', 'documentos'][max];
        }
        SideNavFactory.setUser(user);
        Storage.setUser(user);
        SideNavFactory.setMenu(menu.menu);
        Storage.setSession('menu', SideNavFactory.getMenu());
        if(path) {
          var route = path.replace('/', '');
          var page = Util.getMenuOption(Storage.getSession('menu'), route);
          BreadcrumbFactory.setParent(page[0]);
          BreadcrumbFactory.setCurrent(page[1]);
        }
        $timeout(function () {
          var $sidenav = angular.element('#sidenav')
          $sidenav.find('.md-button-href').removeClass('active');
          $sidenav.find('.sidenav-sublist').hide();
          $sidenav.find(".md-button-href[data-url='" + route + "']")
          .addClass('active').parent().parent().prev().click();
        });
        $auth.setToken(respVirtual.datos.token);
        $timeout(ExpirationTime.init(), 800);
        angular.element('#toast-container-main').find('md-toast').fadeOut();
        $timeout($location.path(path && path.indexOf('login') == -1 ? path : '/'), 10000);
        $timeout(Loading.cerrar(), 8000);
      })
      .catch(function(){
        Message.show('ERROR', 'Error en el cambio de usuario.');
      });
    };

    vm.obtenerVirtuales = function () {
      DataService.get(restUrl + 'seguridad/virtual')
      .then(function (respVirtual) {
        if (angular.isUndefined(respVirtual)) {
          $location.path("documentos");          
          return;
        }
        Message.show(respVirtual.tipoMensaje, respVirtual.mensaje);
        vm.usuariosVirtuales = respVirtual.datos.resultado;
      })
      .catch(function () {
        Message.show('ERROR', 'Error en la obtencion de datos virtuales');
      })
    };
    vm.obtenerVirtuales();
  }

})();
(function() {
    'use strict';

    angular
    .module('app')
    .controller('UsuariosController',UsuariosController);


    /** @ngInject */
    function UsuariosController(restUrl, Modal, DataService, Util, Message, Storage, $log) {
        var vm = this;

        vm.title = 'Usuarios';
        vm.url = restUrl + 'seguridad/usuario/';
        vm.fields = ['id_usuario','usuario','numero_documento','nombres','apellidos','cargo','email','estado','_fecha_creacion','_fecha_modificacion'];
        vm.dialogController = [ 'data', 'Message', '$scope', '$mdConstant', '$mdDialog', 'Modal', 'DataService', 'restUrl', '$timeout', DialogUsuarioController];
        vm.template = 'app/modules/admin/usuarios/dialog.usuario.html'; // TODO: Es necesario crear???.
        var cuenta=Storage.getUser();
        vm.usuario=cuenta.id;

        vm.permission ={
          create:true,
          update:true,
          delete:false
        };

        vm.buttonAgregar = {
            tooltip: 'Syncronizar todos los datos con ldap',
            icon: 'cached',
            onclick: Syncronizar
        };

        function Syncronizar(ev) {
            $log.log("Sin servicio", ev);
        }

        function DialogUsuarioController(data, Message, $scope,$mdConstant,$mdDialog,Modal,DataService,restUrl,$timeout){

          var vmd=$scope;

          vmd.data = data;
          // funciones
          vmd.cerrar = cerrar;
          vmd.registrarUsuario = registrarUsuario;
          // vmd.eliminarVirtual = eliminarVirtual;
          // vmd.agregarVirtual = agregarVirtual;

          var flagEditar=(data.id_usuario)?true:false; // true: editar, false:crear.
          iniciarDialog();

          // TODO: Abstraer un nivel mas los metodos iniciarDialog y obtener Usuarios.
          function iniciarDialog(){
            var roles=[];
            var rolesEnviar=[];
            var virtuales = [];
            DataService.get(restUrl+"seguridad/rol")
            .then(function(response){
              roles=response.datos.resultado;
              if(flagEditar){
                var rolesAsignados=data.usuario_rol;
                roles.forEach(function(itemGlobal,indiceGlobal){
                  var rol={
                    id_rol:itemGlobal.id_rol,
                    nombre:itemGlobal.nombre,
                    valor:false
                  }

                  if(rolesAsignados!=null && rolesAsignados.length>0){
                    rolesAsignados.forEach(function(item,indice){
                      if(itemGlobal.id_rol==item.rol.id_rol) rol.valor=true;
                      if(indice==rolesAsignados.length-1){
                        rolesEnviar.push(rol);
                        if(indiceGlobal==roles.length-1) vmd.data.roles=rolesEnviar;
                      }
                    });
                  }else{
                    vmd.data.roles = roles;
                  }

                });
              }
              else{
                // Agrega valor, por defecto en false.
                roles.forEach(function(item,indice){

                  var rol={
                    id_rol:item.id_rol,
                    nombre:item.nombre,
                    valor:false
                  }
                  rolesEnviar.push(rol);
                  if(indice==roles.length-1) vmd.data.roles=rolesEnviar;
                });

              }
            })

            DataService.get(restUrl + "seguridad/virtual/todos")
            .then(function (response) {
              if (angular.isUndefined(response.datos.resultado)) virtuales = [];
              virtuales = response.datos.resultado;
              var procesado = [];
              // vmd.data.virtuales = virtuales;
              if (flagEditar && flagEditar === false) {
                vmd.data.virtuales = virtuales;
                return;                
              }
              
              var enUso = vmd.data.virtuales || [];
              virtuales.forEach(function (dispItem) {
                var objTemp = {
                  id_usuario: dispItem.id_usuario,
                  cargo: dispItem.cargo,
                  nombres: dispItem.nombres,
                  libre: dispItem.libre,
                  valor: false,
                  titular: dispItem.titular
                };
                if(enUso.length == 0) {
                  procesado.push(objTemp);
                }
                var idProcesado = [];
                enUso.forEach(function (usoItem) {
                  if (dispItem.id_usuario == usoItem.fid_usuario_virtual) {
                    idProcesado.push(dispItem.id_usuario);
                    objTemp.id_virtual = usoItem.id_virtual;
                    if ( usoItem.estado == 'ACTIVO') {
                      objTemp.libre = true;
                      objTemp.valor = true;
                    } else {
                      // objTemp.libre = true;
                      objTemp.valor = false;
                    }

                    procesado.push(objTemp);
                  }
                });
                
                if(idProcesado.indexOf(dispItem.id_usuario)=== -1 && enUso.length > 0) {
                  procesado.push(objTemp)
                }
              })

              vmd.data.virtuales = procesado;

            })

            DataService.get(restUrl+"seguridad/unidad?fields=id_unidad,nombre,abreviacion")
            .then(function (respuesta) {
                vmd.data.unidades = respuesta.datos.resultado;
            })

          }

          function cerrar(){
            $mdDialog.cancel();
          }


          function registrarUsuario(){

            var roles=[];
            for(var i in vmd.data.roles){
              if(vmd.data.roles[i].valor==true) roles.push(vmd.data.roles[i].id_rol);
            }
            var oficinas=[];
            for(var j in vmd.data.oficinas){

              if(vmd.data.oficinas[j].valor==true) oficinas.push(vmd.data.oficinas[j].id_oficina);
            }

            var usuario={
              usuario:vmd.data.usuario,
              fid_unidad:vmd.data.fid_unidad,
              contrasena:" ",//vmd.data.contrasena, //Se utiliza la contraseña del LDAP
              numero_documento:vmd.data.numero_documento,
              nombres:vmd.data.nombres,
              apellidos:vmd.data.apellidos,
              cargo:vmd.data.cargo,
              email:vmd.data.email,
              estado:vmd.data.estado,
              roles:roles,
              oficinas:oficinas,
              virtuales: vmd.data.virtuales
              // virtuales: vmd.data.virtuales
            }

            if(flagEditar){
              usuario.id_usuario=vmd.data.id_usuario;
              usuario._usuario_modificacion=cuenta.id;
              usuario._fecha_modificacion=new Date();
            }
            else{
              usuario._usuario_creacion=cuenta.id;
              usuario._fecha_creacion= new Date();
            }

            if(flagEditar){
              DataService.put(restUrl+"seguridad/usuario/"+usuario.id_usuario, usuario)
              .then(function(respuesta){
                //console.log("Verificando la modificacion",respuesta);
                Message.success();
                if(respuesta!=undefined ){
                  $mdDialog.hide();

                  $timeout(function(){
                    angular.element('#btn-refresh-crudtable').click();
                  },500)
                }

              });
            }
            else{
              DataService.post(restUrl+"seguridad/usuario", usuario)
              .then(function(respuesta){
                //console.log("Verificando la creacion",respuesta);
                Message.success();
                if(respuesta!=undefined){
                  $mdDialog.hide();
                  $timeout(function(){
                    angular.element('#btn-refresh-crudtable').click();
                  },500)
                }

              });
            }

          }

        } // Fin DialogUsuarioController.



    }
})();

(function() {
	'use strict';

	angular
	.module('app')
	.controller('ProfileController', ProfileController);

	/** @ngInject */
	function ProfileController(Storage, SideNavFactory, Datetime, DataService, restUrl, Message) {
		var vm = this;

		vm.getColor = function () {
			return SideNavFactory.userColor;
		}

		vm.getName = function () {
			var user = SideNavFactory.getUser();
			return user.first_name + ' ' + user.last_name;
		}

		vm.getEmail = function () {
			return SideNavFactory.getUser().email;
		}

		vm.getInitial = function () {
			var firstName = SideNavFactory.getUser().first_name;
			return firstName.length ? firstName[0].toUpperCase() : '?';
		}

		vm.getData = function (key) {

			var value = SideNavFactory.getUser()[key];
			if (['last_login', 'date_joined'].indexOf(key) != -1) {
				return Datetime.datetimeLiteral(new Date(value));
			}

			return value;
		}

		vm.getEsJefe = function () {
			return SideNavFactory.getUser().es_jefe || false;
		}

		vm.abrirEditar = function (acc){
			if(acc=='editar_notificaciones'){
				// DataService.get(restUrl + "notificacion/conf_notificacion/?fields=id_conf_notificacion,canal,enviado,celular,observado,aprobado,derivado&fid_usuario="+vm.getData('id'))
				DataService.get(restUrl + "notificacion/conf_notificacion/?fields=id_conf_notificacion,canal,enviado,observado,derivado,aprobar_ciudadania,aprobados_ciudadania,canal_habilitado&fid_usuario="+vm.getData('id'))
				.then(function (respuesta) {
					vm.swEditarCuenta = acc;
					vm.ca = respuesta.datos.resultado[0];
					vm.ca.email = vm.getEmail();
				})

			}else {
				DataService.get(restUrl + "seguridad/usuario/", vm.getData('id'))
				.then(function (respuesta) {
					if(respuesta.datos){
						// console.log(respuesta);
						vm.numero_documento = respuesta.datos.numero_documento;
						vm.nombre_usuario = respuesta.datos.usuario;
						vm.email = respuesta.datos.email;
						vm.nombres = respuesta.datos.nombres;
						vm.apellidos = respuesta.datos.apellidos;
						if(acc == "editar_cuenta"){
							vm.contrasena = respuesta.datos.contrasena;
						}
						vm.swEditarCuenta = acc;
					}
				});
			}
		}
		vm.editarCuenta = function (){
			var usuario_enviar = {
				id_usuario: vm.getData('id'),
				numero_documento: vm.numero_documento,
				usuario: vm.nombre_usuario,
				email: vm.email,
				nombres: vm.nombres,
				apellido_paterno: vm.apellidos,
				_usuario_modificacion: vm.getData('id')
			}
			var swPut = true;
			if (vm.swEditarCuenta == "editar_cuenta") {
				usuario_enviar.contrasena = vm.contrasena;
			}else if (vm.swEditarCuenta == "editar_contrasena") {
				if(vm.contrasena_nueva !== vm.contrasena_confirm){
					Message.error("Las contraseña a confirmar no coincide con la contraseña nueva!!");
					swPut = false;
				}
				usuario_enviar.verificarContrasena = vm.contrasena;
				usuario_enviar.contrasena = vm.contrasena_nueva;
			}
			if(swPut){
				DataService.put(restUrl + "seguridad/usuario/"+vm.getData('id'), usuario_enviar)
				.then(function (respuesta) {
					if(respuesta.datos){
						// console.log(respuesta);
						vm.numero_documento = null;
						vm.nombre_usuario = null;
						vm.email = null;
						vm.nombres = null;
						vm.apellidos = null;

						vm.contrasena = null;
						vm.contrasena_nueva = null;
						vm.contrasena_confirm = null;
						var user_set={
							id: respuesta.datos.id_usuario,
							username: respuesta.datos.usuario,
							first_name: respuesta.datos.nombres,
							last_name: respuesta.datos.apellido_paterno+" "+respuesta.datos.apellido_materno,
							cargo: respuesta.datos.cargo,
							doc: respuesta.datos.numero_documento,
							email: respuesta.datos.email,
							date_joined: respuesta.datos._fecha_creacion
						}
						// Set user
						SideNavFactory.setUser(user_set);
						Storage.setUser(user_set);
						vm.swEditarCuenta = null;
						Message.show(respuesta.tipoMensaje, respuesta.mensaje);
					}
				});
			}
		}
		vm.editarConfiguracion = function () {
			var conf_enviar = angular.copy(vm.ca)
			DataService.put(restUrl + "notificacion/conf_notificacion/"+conf_enviar.id_conf_notificacion, conf_enviar)
			.then(function (respuesta) {
				Message.show(respuesta.tipoMensaje, respuesta.mensaje);
				vm.swEditarCuenta = null;
			})
		}


		vm.cancelarEditar = function () {
			vm.numero_documento = null;
			vm.nombre_usuario = null;
			vm.email = null;
			vm.nombres = null;
			vm.apellidos = null;

			vm.contrasena = null;
			vm.contrasena_nueva = null;
			vm.contrasena_confirm = null;

			vm.swEditarCuenta=null;
		}

	}
})();

(function() {
    'use strict';

    angular
    .module('app')
    .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController($auth, $location, Message, SideNavFactory, Storage, $timeout, Util, BreadcrumbFactory, $window, Datetime, $mdDialog, Modal, ExpirationTime, backUrl, DataService) {

        var vm = this;
        vm.login = login;
        vm.iniciarSesion= iniciarSesion;
        vm.irAVerificar= irAVerificar;
        vm.backUrl = backUrl;
        Storage.destroySession();
        activate();
            
        function activate() {
            angular.element('body').addClass('no-login');
            angular.element('body').removeClass('principal');
            //TODO: Mostrar para ver errores cuando se bloquea ciudania digital
            if ($window.localStorage.getItem('error') != null && $window.localStorage.getItem('error') != undefined) {
                Message.error($window.localStorage.getItem('error'));
                $window.localStorage.removeItem('error');
            }
        }

        function login () {
            $auth.login({
                username: vm.username,
                password: vm.password
            })
            .then(function(response) {
                var user = response.data.datos.user;
                var menu = response.data.datos.menu;
                var roles = response.data.datos.roles;

                angular.element('body').removeClass('no-login');
                angular.element('body').addClass('principal');

                var path = Storage.getSession('path');
                user.es_jefe=false;
                if(path==null){
                    var max = 10;
                    roles.forEach(function (it) {
                        if(it.rol.peso<max && it.rol.peso!==0){ max = it.rol.peso; }
                        if(it.rol.nombre=='JEFE') user.es_jefe=true;
                    })
                    path = ['documentos','aprobacion','aprobacion', 'impresion', 'documentos', 'documentos'][max];
                }

                // Set user
                SideNavFactory.setUser(user);
                Storage.setUser(user);


                // Set Menu
                SideNavFactory.setMenu(menu);
                Storage.setSession('menu', SideNavFactory.getMenu());


                if (path) {
                    var route = path.replace('/', '');

                    // Set breadcrumb
                    var page = Util.getMenuOption(Storage.getSession('menu'), route);
                    BreadcrumbFactory.setParent(page[0]);
                    BreadcrumbFactory.setCurrent(page[1]);

                    // Select menu option
                    $timeout(function () {
                        var $sidenav = angular.element('#sidenav')
                        $sidenav.find('.md-button-href').removeClass('active');
                        $sidenav.find('.sidenav-sublist').hide();
                        $sidenav.find(".md-button-href[data-url='" + route + "']")
                                .addClass('active').parent().parent().prev().click();
                    });

                }
                ExpirationTime.init();

                angular.element('#toast-container-main').find('md-toast').fadeOut();

                // Redirect to dashboard
                $location.path(path && path.indexOf('login') == -1? path : '/');

            })
            .catch(function(error) {
                if (error.status == 400 || error.status == 401) {
                    Message.error('Nombre de usuario y/o contraseña no válidos.');
                }
                if(error.status == 412){
                    Message.show(error.data.tipoMensaje,error.data.mensaje);
                }

                if (error.status == -1) {
                    Message.error('Servidor no Disponible.');
                }
            });
        }


        vm.abrirDialog= function(pEvento){

          var config={
            event: pEvento,
            title: 'Recuperar contraseña',
            templateUrl: 'app/modules/admin/login/recuperar.dialog.html',
            controller: ['$scope','$mdDialog','DataService','Message','restUrl', DialogRecuperarController]
          };
          Modal.show(config);
        }

        /**
         Funcion Controlador para el dialogo de recuperacion de contraseña.
         */
        function DialogRecuperarController($scope,$mdDialog, DataService, Message, restUrl){
          var vmd=$scope;
          vmd.usuario=null;
          vmd.email=null;
          vmd.numero_documento=null;

          // Funcion que recupera los datos y los envia al servicio rest.
          vmd.recuperar=function(){

            var datosEnviar={
              usuario:vmd.usuario,
              email:vmd.email,
              numero_documento:vmd.numero_documento
            }

            DataService.put(restUrl+"seguridad/recuperar/", datosEnviar)
            .then(function(pRespuesta){
              Message.show(pRespuesta.tipoMensaje,pRespuesta.mensaje);
              vmd.cerrar();
            })

          }
          vmd.cerrar= function(){
            $mdDialog.cancel();
          }
        }

      function iniciarSesion() {
          var ruta =  vm.backUrl + 'codigo';
          DataService.get(ruta)
          .then(function(response) {
            if (response) {
              $window.localStorage.setItem('oauth2_state', response.datos.codigo);
              $window.location.href = response.datos.url;
            }

        })
        .catch(function (err) {
          Message.error(err);
        });
      }

      function irAVerificar() {
          $location.path('verificar');
      }
    }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('fcVacioController', CiteController);

  /** @ngInject */
  function CiteController($scope) {
        var vm = this;
        var sc = $scope;
        sc.vm = vm;
        sc.$watch('to.height', function (newValue) {
            if( newValue<0 ) sc.to.style.height = '0cm';
            else if( newValue>30 ) sc.to.style.height = '30cm';
            else if(sc.to.style) sc.to.style.height = sc.to.height+'cm';
        });
  }
})();

(function() {
  'use strict';

  angular
  .module('app')
  .controller('fcListaContactosController', listaContactos);

  /** @ngInject */
  function listaContactos($scope, DataService, restUrl, ArrayUtil) {
    var vm = this;
    var sc = $scope;
    var tempContactos;
    
    sc.vm = vm;
    vm.buscarContacto = "";
    vm.mostrarContacto = false;
    vm.contactos = [];
    vm.contadorBusquedasKey = 0;

    vm.abrirSelector = abrirSelector;
    vm.cerrarSelector = cerrarSelector;
    if (angular.isUndefined(sc.model[sc.options.key])) sc.model[sc.options.key]={};
    if (angular.isUndefined(sc.model[sc.options.key].lista)) sc.model[sc.options.key].lista=[];

    sc.$watch('vm.buscarContacto', function () {
      vm.contadorBusquedasKey++;
      if (vm.contadorBusquedasKey < 3) {
        return;
      }
      vm.contadorBusquedasKey = 0;
      
      var contador;
      var vector = [];
      vm.contactos = [];
      tempContactos = sc.model[sc.options.key].lista || [];
      
      for (contador = 0; contador < tempContactos.length; contador++) {
        vm.contactos.push(tempContactos[contador]);
      }

      if(vm.buscarContacto != "") {
        DataService.get(restUrl + 'plantillasFormly/contactos?filter='+vm.buscarContacto)
        .then(function (respuesta) {
          vm.contactos = [];
          vector = respuesta.datos.resultado;
          for (contador = 0; contador < tempContactos; contador ++) vm.contactos.push(tempContactos[contador]);
          for (contador = 0; contador < vector.length; contador++) {
            if(!ArrayUtil.buscarObj(tempContactos, 'id_contacto', vector[contador].id_contacto)) {
              vm.contactos.push(vector[contador]);
            }
          }
        });
      }
    });
    
    function abrirSelector(evento, mostrar) {
      vm.contadorBusquedasKey = 0;
      angular.element(evento.currentTarget).parent().next().children()[1].click();
      switch (mostrar) {
        case 'contacto': vm.mostrarContacto = true; break;
      }
    }

    function cerrarSelector() {
      vm.buscarContacto = '';
      vm.mostrarContacto = false;
    }

  }
})();
(function() {
  'use strict';

  angular
    .module('app')
    .controller('fcEncabezadoController', EncabezadoController);

  /** @ngInject */
  function EncabezadoController($scope, DataService, restUrl, $timeout, Storage, Datetime, ArrayUtil) {
    var vm = this;
    var sc = $scope;
    sc.vm = vm;
    var cuenta = Storage.getUser();

    vm.buscar_para = "";
    vm.buscar_via = "";
    vm.buscar_de = "";
    vm.show_para = false;
    vm.show_via = false;
    vm.show_de = false;

    //cargamos funciones
    vm.openSelect = openSelect;
    vm.moverUsuario = moverUsuario;

    $timeout(iniciarController);

    function iniciarController() {
        var xu, u, i, arr, xde, xpara, xvia, fd;
        var form_nuevo = angular.isUndefined(sc.model[sc.options.key]);

        xu = {
            id_usuario: cuenta.id,
            nombres: cuenta.first_name,
            apellidos: cuenta.last_name,
            cargo: cuenta.cargo
        };

        // cambiamos evento de los inputs
        angular.element('input.header-searchbox').on('keydown', function(ev) {
            ev.stopPropagation();
        });

        if(form_nuevo){
            sc.model[sc.options.key] = {};
            sc.model[sc.options.key]["de"] = [xu];
        }else {
            // delete sc.model[sc.options.key]["para"].$$mdSelectId;
            xpara = sc.model[sc.options.key]["para"] || {id_usuario:-1};
            xde = sc.model[sc.options.key]["de"] || {id_usuario:-1};
            xvia = sc.model[sc.options.key]["via"] || {id_usuario:-1};
            vm.usuarios_check = {};
            fd = Storage.getSession('flujo_doc');

            if(fd!=null){
                if(angular.isDefined(fd.via)){
                    for (i = 0; i < fd.via.length; i++) {
                        if(fd.via[i]!==fd.via_actual)
                        vm.usuarios_check[fd.via[i]] = true;
                    }
                }
                if(sc.model['cite-0'] && sc.model['cite-0']['cite'])
                    vm.usuarios_check[fd.para[0]] = true;
            }
        }

        DataService.get(restUrl + 'seguridad/usuario_rol/')
        .then(function (resultado) {
            vm.usuarios = [];
            vm.usuarios_jefes = [];
            arr = resultado.datos;
            // console.log(arr);
            if(form_nuevo){
                for (i = 0; i < arr.length; i++) {
                    u = newUser(arr[i]);
                    vm.usuarios.push( (xu.id_usuario==u.id_usuario)? xu : u );
                    vm.usuarios_jefes.push(u);
                }
            }else {
                for (i = 0; i < arr.length; i++) {
                    u = newUser(arr[i]);
                    if(xpara && ArrayUtil.buscarObj(xpara, 'id_usuario', u.id_usuario)){
                        vm.usuarios_jefes.push(ArrayUtil.buscarObj(xpara, 'id_usuario', u.id_usuario, true));
                        vm.usuarios.push(u);
                    }else if(xvia && ArrayUtil.buscarObj(xvia, 'id_usuario', u.id_usuario)) {
                        vm.usuarios_jefes.push(ArrayUtil.buscarObj(xvia, 'id_usuario', u.id_usuario, true));
                        vm.usuarios.push(u);
                    }else if(ArrayUtil.buscarObj(xde, 'id_usuario', u.id_usuario)) {
                        vm.usuarios.push(ArrayUtil.buscarObj(xde, 'id_usuario', u.id_usuario, true));
                    }else {
                        vm.usuarios_jefes.push(u);
                        vm.usuarios.push(u);
                    }
                }
            }
        });
    }

    function newUser(el) {
        return {
            id_usuario: el.id_usuario,
            nombres: el.nombres,
            apellidos: el.apellidos,
            cargo: el.cargo
        };
    }

    function moverUsuario(index, dir, nom) {
        var arr = sc.model[sc.options.key][ nom||'via' ];
        if(dir=="down") ArrayUtil.mover(arr, index, index+1);
        else if(dir=="up") ArrayUtil.mover(arr, index, index-1);
    }


    function openSelect(ev, show) {
        // console.log($(ev.currentTarget).next().children()[1]);
        angular.element(ev.currentTarget).parent().next().children()[1].click();
        switch (show) {
            case 'para': vm.show_para = true; break;
            case 'via': vm.show_via = true; break;
            case 'de': vm.show_de = true; break;
        }
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('fcDocumentosRelacionadosController', documentosRelacionados);

  /** @ngInject */
  function documentosRelacionados($scope, DataService, restUrl, ArrayUtil, Documento) {
    var vm = this,
        sc = $scope,
        xdocs;
    sc.vm = vm;
    vm.buscar_doc = "";
    vm.show_doc = false;
    vm.documentos = [];

    //cargamos funciones
    vm.openSelect = openSelect;
    vm.mostrarPdf = mostrarPdf;
    vm.closeSelectDoc = closeSelectDoc;

    sc.$watch('vm.buscar_doc', function () {
        var i, arr;
        vm.documentos = [];
        xdocs = sc.model[sc.options.key] || [];
        for (i = 0; i < xdocs.length; i++) vm.documentos.push(xdocs[i]);

        if (vm.buscar_doc!="") {
            // DataService.get( restUrl+'plantillasFormly/documento?fields=id_documento,nombre,fecha' )
            DataService.get( restUrl+'plantillasFormly/documento?fields=id_documento,nombre,fecha&estado=APROBADO,CERRADO,DERIVADO&page=1&order=-fecha&limit=20&searchPro=1&tipoBus=campo&campoSel=nombre&filter='+vm.buscar_doc)
            .then(function (respuesta) {
                vm.documentos = [];
                arr = respuesta.datos.resultado;
                for (i = 0; i < xdocs.length; i++) vm.documentos.push(xdocs[i]);
                for (i = 0; i < arr.length; i++) {
                    if(!ArrayUtil.buscarObj(xdocs, 'id_documento', arr[i].id_documento))
                        vm.documentos.push( arr[i] );
                }
            })
        }
    })

    function openSelect(ev, show) {
        angular.element(ev.currentTarget).parent().next().children()[1].click();
        switch (show) {
            case 'doc': vm.show_doc = true; break;
        }
    }

    function closeSelectDoc() {
        vm.buscar_doc='';
        vm.show_doc=false;
    }

    function mostrarPdf(pIdentificador){
        Documento.showPdfId(pIdentificador);
    }

  }
})();

(function() {
  'use strict';

  angular
  .module('app')
  .controller('fcDocumentosAnularController', documentosAnular);

  /** @ngInject */
  function documentosAnular($scope, DataService, restUrl, ArrayUtil, Documento) {
    var vm = this,
    sc = $scope,
    xdocs;
    sc.vm = vm;
    vm.buscar_doc = "";
    vm.show_doc = false;
    vm.documentos = [];

    //cargamos funciones
    vm.openSelect = openSelect;
    vm.mostrarPdf = mostrarPdf;
    vm.closeSelectDoc = closeSelectDoc;

    sc.$watch('vm.buscar_doc', function () {
      var i, arr;
      vm.documentos = [];
      xdocs = sc.model[sc.options.key] || [];
      for (i = 0; i < xdocs.length; i++) vm.documentos.push(xdocs[i]);

      if (vm.buscar_doc!="") {
        // TODO: No es necesario evitar el listado de documentos anulados?
        DataService.get( restUrl+'plantillasFormly/documento?fields=id_documento,nombre,fecha&estado=APROBADO,CERRADO,DERIVADO&page=1&order=-fecha&limit=20&searchPro=1&tipoBus=campo&campoSel=nombre&filter='+vm.buscar_doc)
        .then(function (respuesta) {
          vm.documentos = [];
          arr = respuesta.datos.resultado;
          for (i = 0; i < xdocs.length; i++) vm.documentos.push(xdocs[i]);
          for (i = 0; i < arr.length; i++) {
            if(!ArrayUtil.buscarObj(xdocs, 'id_documento', arr[i].id_documento))
            vm.documentos.push( arr[i] );
          }
        });
      }
    });

    function openSelect(ev, show) {
      angular.element(ev.currentTarget).parent().next().children()[1].click();
      switch (show) {
        case 'doc': vm.show_doc = true; break;
      }
    }

    function closeSelectDoc() {
      vm.buscar_doc='';
      vm.show_doc=false;
    }

    function mostrarPdf(pIdentificador){
      Documento.showPdfId(pIdentificador);
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('fcDatosGeneralesController', DatosGeneralesController);

  /** @ngInject */
  function DatosGeneralesController($scope, DataService, restUrl, $timeout, Storage, Datetime, ArrayUtil) {
    var vm = this;
    var sc = $scope;
    sc.vm = vm;
    var cuenta = Storage.getUser();

    vm.buscar_para = "";
    vm.buscar_via = "";
    vm.buscar_de = "";
    vm.show_para = false;
    vm.show_via = false;
    vm.show_de = false;

    //cargamos funciones
    vm.openSelect = openSelect;
    vm.moverUsuario = moverUsuario;

    $timeout(iniciarController);

    function iniciarController() {
        var xu, u, i, j, arr, xde, xpara, xvia, rol, fd, push_gral, push_jefe;
        var form_nuevo = angular.isUndefined(sc.model[sc.options.key]);

        xu = {
            id_usuario: cuenta.id,
            nombres: cuenta.first_name,
            apellidos: cuenta.last_name,
            cargo: cuenta.cargo
        };

        // cambiamos evento de los inputs
        angular.element('input.header-searchbox').on('keydown', function(ev) {
            ev.stopPropagation();
        });

        if(form_nuevo){
            sc.model[sc.options.key] = {};
            sc.model[sc.options.key]["de"] = [xu];
        }else {
            // delete sc.model[sc.options.key]["para"].$$mdSelectId;
            xpara = sc.model[sc.options.key]["para"] || {id_usuario:-1};
            xde = sc.model[sc.options.key]["de"] || {id_usuario:-1};
            xvia = sc.model[sc.options.key]["via"] || {id_usuario:-1};
            vm.usuarios_check = {};
            fd = Storage.getSession('flujo_doc');

            if(angular.isDefined(fd) && fd!=null){
                if(fd.via!=null){
                    for (i = 0; i < fd.via.length; i++) {
                        if(fd.via[i]!==fd.via_actual)
                        vm.usuarios_check[fd.via[i]] = true;
                    }
                }
                if(sc.model['cite-0'] && sc.model['cite-0']['cite'])
                    vm.usuarios_check[fd.para[0]] = true;
            }
        }

        DataService.get(restUrl + 'seguridad/usuario_rol/')
        .then(function (resultado) {
            vm.usuarios = [];
            vm.usuarios_jefes = [];
            arr = resultado.datos;
            // console.log(arr);
            if(form_nuevo){
                for (i = 0; i < arr.length; i++) {
                    u = newUser(arr[i]);
                    push_jefe = false;
                    for (j = 0; j < arr[i].usuario_rol.length; j++) {
                        rol = arr[i].usuario_rol[j].rol.nombre;
                        if(rol==="JEFE" ||rol =="CORRESPONDENCIA")
                            push_jefe=true;
                    }
                    vm.usuarios.push( (xu.id_usuario==u.id_usuario)? xu : u );
                    if(push_jefe && xu.id_usuario!=u.id_usuario) vm.usuarios_jefes.push(u);
                }
            }else {
                for (i = 0; i < arr.length; i++) {
                    push_gral = false;
                    push_jefe = false;
                    u = newUser(arr[i]);
                    if( u.id_usuario==xpara.id_usuario ){
                        vm.usuarios_jefes.push(xpara);
                        if(!push_gral) vm.usuarios.push(u);
                        push_gral = true;
                        push_jefe = true;
                    }
                    if(xvia && ArrayUtil.buscarObj(xvia, 'id_usuario', u.id_usuario)) {
                        vm.usuarios_jefes.push(ArrayUtil.buscarObj(xvia, 'id_usuario', u.id_usuario, true));
                        if(!push_gral) vm.usuarios.push(u);
                        push_gral = true;
                        push_jefe = true;
                    }
                    if(ArrayUtil.buscarObj(xde, 'id_usuario', u.id_usuario)) {
                        vm.usuarios.push(ArrayUtil.buscarObj(xde, 'id_usuario', u.id_usuario, true));
                        push_gral = true;
                    }

                    {
                        if(!push_gral) vm.usuarios.push(u);

                        push_gral = false; // usamos para ver si en sus roles es jefe o CORRESPONDENCIA
                        if(!push_jefe)
                            for (j = 0; j < arr[i].usuario_rol.length; j++) {
                                rol = arr[i].usuario_rol[j].rol.nombre;
                                if(rol==="JEFE" ||rol =="CORRESPONDENCIA")
                                    push_gral = true;
                            }

                        if(push_gral && xu.id_usuario!=u.id_usuario &&  !push_jefe) vm.usuarios_jefes.push(u);
                    }
                }
            }
        });
    }

    function newUser(el) {
        return {
            id_usuario: el.id_usuario,
            nombres: el.nombres,
            apellidos: el.apellidos,
            cargo: el.cargo
        };
    }

    function moverUsuario(index, dir) {
        var arr = sc.model[sc.options.key]["via"];
        if(dir=="down") ArrayUtil.mover(arr, index, index+1);
        else if(dir=="up") ArrayUtil.mover(arr, index, index-1);
    }


    function openSelect(ev, show) {
        // console.log($(ev.currentTarget).next().children()[1]);
        angular.element(ev.currentTarget).parent().next().children()[1].click();
        switch (show) {
            case 'para': vm.show_para = true; break;
            case 'via': vm.show_via = true; break;
            case 'de': vm.show_de = true; break;
        }
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('fcCiteController', CiteController);

  /** @ngInject */
  function CiteController($scope, Datetime) {
    var vm = this;
    var sc = $scope;
    sc.vm = vm;

    if(sc.model[sc.options.key] && sc.model[sc.options.key]['fecha'])
        sc.model[sc.options.key]["fecha"] = Datetime.format(sc.model[sc.options.key]["fecha"], 'dd de MMM de YYYY');

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('fcConCopiaArchivoController', ConCopiaArchivoController);

  /** @ngInject */
  function ConCopiaArchivoController($scope, $timeout, Storage) {
    var vm = this;
    var sc = $scope;
    sc.vm = vm;
    var cuenta = Storage.getUser();

    $timeout(iniciarController);

    function iniciarController() {
        if(angular.isUndefined(sc.model[sc.options.key])){
            sc.model[sc.options.key] = generarAbreviacion(cuenta.first_name + " " + cuenta.last_name);
            sc.model[sc.options.key] += '\nCc.:archivo';    
        }
    }
        
    function generarAbreviacion(cadena) {        
        cadena = cadena.replace(/[^a-zA-Z ]/g, "");
        var str = cadena.toUpperCase();
        var res = str.split(" ");
        var abreviacion = "";
        for (var i = 0; i < res.length; i++) {            
            abreviacion = abreviacion + res[i][0];            
        }
        return abreviacion;
    }
  }
})();

  (function (){
    'use strict';
    angular
    .module('app')
    .controller('fcCalendarioController', calendario);

    /** @ngInject */
    function calendario($scope, $log) {
      var vm = this;
      var sc = $scope;
      $log.log('Iniciando el controlador del componente calendario', sc);
      sc.vm = vm;
      vm.minDate= '';
      vm.maxDate= '';
      
      
      sc.actualizarLimites = function(diasAntes, diasDespues) {        
        var fechaActualMin = new Date();
        var fechaActualMax = new Date();
        if (diasAntes!= undefined && diasAntes >= 0) {
          sc.to.minDate= new Date(fechaActualMin.setDate(fechaActualMin.getDate()- (diasAntes)));
        }
        if (diasDespues != undefined && diasDespues >= 0) {
          sc.to.maxDate = new Date(fechaActualMax.setDate(fechaActualMax.getDate() + (diasDespues)));
        }
        
      }

      sc.actualizarLimites(sc.to.diasAntes, sc.to.diasDespues);

      // var fechasBlockeadas = [new Date('2018-12-14'.toString())];
      // sc.onlyWeekendsPredicate = function(date) {
      //   // console.log('Revisando los datos', date);
      //   // TODO: el $filter no es reconocido por el int
      //   // return $filter('filterBookings')(date, fechasBlockeadas);
      // }
      sc.filterBookings = function() {
        return function (date, bookedDates) {
          for (var i = 0; i < bookedDates.length; i++) {
            return date.toString() !== bookedDates[i];
          }
        };
      }
    }
  })();
(function() {
  'use strict';

  angular
    .module('app')
    .controller('fcArchivoController', archivos);

  /** @ngInject */
  function archivos($scope, $timeout, Documento) {
    var vm = this;
    var sc = $scope;
    sc.vm = vm;

    //funciones
    vm.elegirPdf = elegirPdf;
    vm.limpiarPdf = limpiarPdf;
    vm.showPdf = showPdf;
    vm.redondear = redondear;
    vm.onLoadModel = onLoadModel;

    $timeout(iniciarController);

    function iniciarController() {
        vm.form_nuevo = angular.isUndefined(sc.model[sc.options.key]);
        if(!vm.form_nuevo){
            if(!sc.to.multiple){
                sc.model[sc.options.key] = sc.model[sc.options.key][0];
            }
        }
    }

    function showPdf(nombre) { Documento.showPdfx(nombre); }
    

    function elegirPdf(ev) {
        angular.element(ev.currentTarget).next().click();
    }

    function onLoadModel(ev, afiles) {
        afiles.forEach(function (f, i, arr) {
            if(f.filetype!="application/pdf"){
                arr.splice(i, 1);
                if(sc.to.multiple){
                    sc.model[sc.options.key].splice(i,1);
                }else {
                    delete sc.model[sc.options.key];
                }
            }
        })
    }

    function limpiarPdf(index) {
        if(!sc.to.multiple){
            delete sc.model[sc.options.key]
        }else {
            if (index) {
                sc.model[sc.options.key].splice(index, 1);
            }else {
                sc.model[sc.options.key].splice(0, 1);
            }
        }
    }

    function redondear(x, a) {
        return Math.round(x*Math.pow(10,a))/Math.pow(10,a);
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('fcCajaChicaController', CajaChicaController);

  /** @ngInject */
  function CajaChicaController($scope, $timeout, DataService, restUrl) {
    var vm = this;
    var sc = $scope;
    var model, to;
    sc.vm = vm;

    vm.buscar = {};
    vm.alert = {};

    vm.addRow = addRow;
    vm.deleteRow = deleteRow;
    vm.buscarDocumentos = buscarDocumentos;
    vm.buscarPartidas = buscarPartidas;
    vm.cargarPartidas = cargarPartidas;
    vm.obtenerSaldo = obtenerSaldo;
    vm.calcularTotal = calcularTotal;

    $timeout(iniciarController);

    function iniciarController() {
        to = sc.options.templateOptions;
        vm.documentos = [];
        if (angular.isUndefined(sc.model[sc.options.key])) {
            sc.model[sc.options.key] = { rows: [], monto_total:0 };
            sc.model[sc.options.key].tipo = to.tipo=='GESTION'? 'MODIFICADO': to.tipo;
        }else {
          calcularTotal();
        }
        model = sc.model[sc.options.key];
    }

    function buscarPartidas(texto) {
      var url = restUrl+'presupuesto/partidas/';
      if (texto) { url += '?filter='+texto; }
      return DataService.get(url)
      .then(function (respuesta) {
        return respuesta.datos || [];
      })
    }

    function calcularTotal(row) {
      if (row) row.monto = isFloat(row.monto)? parseFloat(row.monto).toFixed(2) : '0.00';

      sc.model[sc.options.key].monto_total = 0;
      sc.model[sc.options.key].rows.forEach(function (it) {
        if (isFloat(it.monto)) sc.model[sc.options.key].monto_total+=toFloat(it.monto);
      })
      sc.model[sc.options.key].monto_total = parseFloat(sc.model[sc.options.key].monto_total).toFixed(2);
    }
    function toFloat(string) { return parseFloat(parseFloat(string).toFixed(2)); }
    function isFloat(string) { return /(?:\d*\.)?\d+/.test(string); }

    function obtenerSaldo(multiple) {
        var url = restUrl+'presupuesto/partidas/?saldo='+multiple;
        DataService.get(url)
        .then(function (respuesta) {
          if (respuesta) {
            if (respuesta.tipoMensaje=='EXITO')
              showALert('info', ' El saldo actual del comprometido es '+respuesta.datos.monto);
            if (respuesta.tipoMensaje=='ADVERTENCIA')
              showALert('warning', ' '+respuesta.mensaje);
          }
        })
    }

    function cargarPartidas(cite) {
      if (cite) {
        var url = restUrl+'presupuesto/partidas/?cite='+cite;
        DataService.get(url)
        .then(function (respuesta) {
          if (respuesta){
            if (respuesta.tipoMensaje=='EXITO'){
              if (model.rows) {
                vm.ids_comprometidos = {};
                model.rows.forEach(function (it) { vm.ids_comprometidos[it.id_comprometido] = !it.pago_multiple; })

                for (var k in respuesta.datos) {
                  if (respuesta.datos.hasOwnProperty(k) && !vm.ids_comprometidos[k]) {
                      model.rows.push({
                        cite: angular.copy(vm.buscar.doc_seleccionado),
                        partida: angular.copy(respuesta.datos[k].partida),
                        descripcion: angular.copy(respuesta.datos[k].descripcion),
                        id_comprometido: angular.copy(respuesta.datos[k].id),
                        comprometido: angular.copy(respuesta.datos[k].monto),
                        pago_multiple: angular.copy(respuesta.datos[k].pago_multiple),
                        monto: '0.00'
                      })
                      vm.ids_comprometidos[k] = !respuesta.datos[k].pago_multiple;
                  }
                }
                if (Object.keys(respuesta.datos)==0) showALert('warning', 'El documento ya no tiene partidas disponibles.')
              }
            } else if (respuesta.tipoMensaje=='ADVERTENCIA') showALert('warning', respuesta.mensaje);
          }
          vm.buscar.doc_seleccionado = null;
        })
      }
    }

    function buscarDocumentos(texto) {
      var url = restUrl+'plantillasFormly/documento?fields=id_documento,nombre,fecha&estado=APROBADO,CERRADO,DERIVADO&page=1&order=-fecha&limit=20';
      if (texto) {
        url += '&searchPro=1&tipoBus=campo&campoSel=nombre&filter='+texto;
      }
      return DataService.get(url)
      .then(function (respuesta) {
        if (respuesta){
          vm.documentos = respuesta.datos.resultado;
        }
        return respuesta.datos.resultado || [];
      })
    }

    function addRow(tipo, button) {
      if (tipo=='MODIFICADO'||tipo=='COMPROMETIDO') {
        if (button) {
          if (vm.buscar.par_seleccionado)
            model.rows.push({ partida: angular.copy(vm.buscar.par_seleccionado), monto:'0.00' });
          else showALert('warning', 'Seleccione una partida para adicionar');
        }
        else if (vm.buscar.par_seleccionado) model.rows.push({ partida: angular.copy(vm.buscar.par_seleccionado), monto:'0.00' });
      }
      else if ( tipo=='INICIAL' )
        model.rows.push({monto:'0.00'});
      calcularTotal();
    }
    function deleteRow(i) { model.rows.splice(i, 1); calcularTotal(); }
    function showALert(tipo, mensaje, time) {
      var icons = {
        'info': 'info',
        'warning': 'warning'
      }
      vm.alert.show = true;
      vm.alert.tipo = tipo;
      vm.alert.mensaje = mensaje;
      vm.alert.icono = icons[tipo];
      vm.alert.time = time || 0;
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .controller('fcPdfsAprobacionCDController', archivos);

    /** @ngInject */
    function archivos($scope, $timeout, Documento, Message, maxPdfSizeAprobacion) {
        var vm = this;
        var sc = $scope;
        sc.vm = vm;
        vm.alert = {};
        vm.cargando = false;
        //funciones
        vm.elegirPdf = elegirPdf;
        vm.limpiarPdf = limpiarPdf;
        vm.showPdf = showPdf;
        vm.redondear = redondear;
        vm.onLoadModel = onLoadModel;
        vm.getTotalFilesSize = getTotalFilesSize;
        vm.onLoadStart = onLoadStart;
        vm.loaded = false;
        $timeout(iniciarController);

        function iniciarController() {
            vm.form_nuevo = angular.isUndefined(sc.model[sc.options.key]);
            // if(!vm.form_nuevo){
            //     if(!sc.to.multiple){
            //         console.log('setting :>> ');
            //         sc.model[sc.options.key] = sc.model[sc.options.key][0];
            //     }
            // }
        }

        function showPdf(nombre) { Documento.showPdfx(nombre); }


        function elegirPdf(ev) {
            angular.element(ev.currentTarget).next().click();
        }

        function onLoadModel(ev, afiles) {
            vm.cargando = false;
            var tipoArchivo = false;
            var tamanioArchivo = false;
            var tamanio = maxPdfSizeAprobacion / 1024 / 1024;
            if (!sc.model[sc.options.key]) {
                sc.model[sc.options.key] = []
            }
            afiles.forEach(function (f) {
                if (f.filetype !== 'application/pdf') tipoArchivo = true;
                else if (f.filesize > maxPdfSizeAprobacion) tamanioArchivo = true;
                else {
                    sc.model[sc.options.key].push(f);
                }
            })
            if (tipoArchivo)
              Message.error('No se pudo subir uno o más documentos ya que sólo se pueden adjuntar archivos PDF');
            if (tamanioArchivo)
              Message.error('No se pudo subir uno o más documentos ya que alguno tiene un tamaño mayor a ' + tamanio + ' MB');
        }

        function onLoadStart() {
            vm.cargando = true;
        }

        function limpiarPdf(index) {
            if (index) {
                sc.model[sc.options.key].splice(index, 1);
            } else {
                sc.model[sc.options.key].splice(0, 1);
            }
        }
        function getTotalFilesSize() {
            var total = 0;
            for (var i = 0; i < sc.model[sc.options.key].length; i++) {
                var file = sc.model[sc.options.key][i];
                total += vm.redondear(file.filesize / 1024, 2);
            }
            return total;
        }

        function redondear(x, a) {
            return Math.round(x * Math.pow(10, a)) / Math.pow(10, a);
        }
    }
})();

(function() {
    'use strict';
    
    angular
    .module('app')
    .service('DemofiService', ['$log', '$q', '$http', '$compile', 'Modal', '$window', 'Message', DemofiService]);

    /** @ngInject */
    function DemofiService($log, $q, $http, $compile, Modal, $window, Message) {

        var url_demofi = 'https://localhost:3200';

        var service = {
            openModal: openModal,
            verificarServidor: verificarServidor,
            listTokens: listTokens,
            login: login,
            listCertificates: listCertificates,
            sign: sign,
            logout: logout
        };

        return service;

        function openModal(solicitudes, config) {
            //import templateModal from './demofi.modal.html';
            //import controllerModal from './demofi.modal.controller';
            return Modal.show({
                template: './demofi.modal.html', //templateModal,
                controller: './demofi.modal.controller', //controllerModal,
                data: { solicitudes: solicitudes, config: config },
                size: 'lg'
            });
        }

        function verificarServidor() {
            var w = 800;
            var h = 400;
            var y = $window.outerHeight / 2 + $window.screenY - (h / 2);
            var x = $window.outerWidth / 2 + $window.screenX - (w / 2);
            $window.open(url_demofi,'_blank', 'toolbar=no,status=no,menubar=no,scrollbars=yes,left='+x+', top='+y+', width='+w+', height='+h+', visible=none', '');
        }

        function listTokens() {
            var req = url_demofi+'/tokens';
            return callRequest(req);
        }

        function login(pinToken) {
            var req = url_demofi+'/start?pin='+pinToken;
            return callRequest(req);
        }

        function listCertificates() {
            var req = url_demofi+'/certs';
            return callRequest(req);
        }

        function sign(solicitudFirma, aliasParaFirmar) {
            var dataSend = {
                nombre_archivo: solicitudFirma.codigo_archivo,
                pdf_base64: solicitudFirma.pdf_base64,
                alias: aliasParaFirmar
            };

            return $q(function(resolve, reject) {
                axios.post(url_demofi+'/sign', dataSend,  {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                    })
                  .then(function (response) {
                    //console.log(response);
                    resolve(response.data);
                    return;
                  })
                  .catch(function (error) {
                    //console.log(error);
                    reject({ finalizado: false, mensaje: "Demofi no se esta ejecutando en su equipo" + error });
                  });
            });
        }

        function logout() {
            var req =  url_demofi + '/finish';
            return callRequest(req);
        }

        function callRequest(req) {
            return $q(function(resolve, reject) {
                axios.get(req)
                .then(function (response) {
                    if (response.data.finalizado === false) {
                        reject(response.data);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(function (error) {
                    if (error) {
                        Message.error('Demofi no se esta ejecutando en su equipo.');
                        reject({ finalizado: false, mensaje: "Demofi no se esta ejecutando en su equipo" });
                    }
                    else {
                        Message.error('No se puede conectar con Demofi. Verifique que el programa se este ejecutando en su maquina.');
                        reject({ finalizado: false, mensaje: "No se puede conectar con Demofi. Verifique que el programa se este ejecutando en su maquina." });
                    }
                });
            });
        }

    }

})();

(function () {
  'use strict';

  angular
  .module('app')
  .service('FirmaticService', ['$log', '$q',  FirmaticService]);

  /** @ngInject */
  function FirmaticService($log, $q) {
    var urlFirmatic = 'https://localhost:4637';
    var service = {
      firmarPdf: firmarPdf,
      verificarEstado: verificarEstado
    };
    return service;

    function firmarPdf(documentos, ci) {
      // $log.log('Iniciando el proceso de firma', documentos);
      var datos = {
        archivo: documentos,
        format: 'pades',
        language: 'es'
      };
      if(angular.isDefined(ci)) datos.ci = ci;
      var cabeceras = {
        headers: {
          'Content-Type': 'application/json'
          // 'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
      var urlFirma = urlFirmatic + '/sign';
      return $q(function (resolve, reject) {
        axios.post(urlFirma, datos, cabeceras)
        .then(function (respFirma) {
          // $log.log('Revisando la respuesta de la firma', respFirma);
          return resolve(respFirma);
        })
        .catch(function (errorFirma) {
          // $log.log('#error en la firma', errorFirma.response);
          return reject({
            finalizado: false,
            message: (errorFirma.response.data.message || errorFirma.response.data) + ' (Error en el firmador.)'
          });
        });
      });
    }

    function verificarEstado() {
      var respuesta = {
        activo: false,
        mensaje: ''
      }
      return $q(function (resolve) {
        axios.get(urlFirmatic)
        .then(function (respEstado) {
          // $log.log('Revisando la respuesta del estado', respEstado);
          if(respEstado.status === 200) {
            respuesta.activo = true;
          }
          else {
            $log.log('Error no definido');
          }
          return resolve(respuesta);
        })
        .catch(function (errorEstado) {
          respuesta.activo = false;
          if(errorEstado.message.indexOf('Network Error' > -1)) {
            respuesta.mensaje = 'El servicio del firmador no se encuentra iniciado.'
          }

          return resolve(respuesta);
        });
      });
    }
  }
  
})();

(function () {
  'use strict';

  angular
  .module('app')
  .controller('VerificarController', VerificarController);


  function VerificarController(Message, backUrl, DataService, $window, Documento, Util, $location, $scope, reCaptchaSiteKey) {

    var claveSitio = reCaptchaSiteKey;

    var vm = this;

    vm.sc = $scope;
    vm.currentNavItem= 'verificar';
    vm.deshabilitado = true;
    vm.datos = {
      recaptcha: null
    };


    vm.recaptchaSolucion = function (token) {
      vm.datos.recaptcha = token;
    };

    vm.recaptchaVencimiento = function () {
      vm.datos.recaptcha = null;
    };

    vm.goto= function(page) {
      vm.status = 'Go to '+page;
    };

    activate();
    vm.data = {
      selectedIndex: 0
    };

    vm.next = function () {
      vm.data.selectedIndex = Math.min(vm.data.selectedIndex +1, 2);
    };
    vm.previous = function () {
      vm.data.selectedIndex = Math.max(vm.data.selectedIndex -1, 0);
    };


    vm.esMovil = Documento.isMobile();


    vm.buscar = buscar;
    vm.irInicio = irInicio;
    vm.verificarDocumento = verificarDocumento;



    function activate() {
      angular.element('body').addClass('no-login');
      angular.element('body').removeClass('principal');

      var configRecaptcha = {
        sitekey: claveSitio,
        callback: vm.recaptchaSolucion.bind(vm),
        "expired-callback": vm.recaptchaVencimiento.bind(vm),
        hl:'es',
        size: 'normal'
      };

      $window.grecaptcha.ready(function(){
        $window.grecaptcha.render('recaptcha', configRecaptcha);
      });
      
    }
   
    function buscar() {
      // if (!vm.datos.recaptcha) {
      //   Message.show('ADVERTENCIA', 'Debe completar el reCaptcha');
      //   return;
      // }

      if(vm.datosDocumento) {
        vm.datosDocumento = {};
        vm.pdf = null;
        vm.pdf_buffer = null;
      }
      vm.datos.codigo = vm.datos.codigo.toUpperCase();

      DataService.post(backUrl + 'verificar', vm.datos)
      .then(function (respPost) {
        if(respPost && respPost.tipoMensaje !== 'ERROR') {
          vm.datosDocumento = respPost.datos;
          vm.datos.token = respPost.datos.token;
        }
        if(respPost ) {
          DataService.pdf(backUrl + 'pdfVerificado', vm.datos)
          .then(function (response) {
            if(response) {
              vm.pdf = response.url;
              vm.pdf_buffer = response.data;
              if (vm.esMovil) {
                Util.loadCanvas(response.data, '#canvasContainerVerificado');
              }
            }

          });
        }
        $window.grecaptcha.reset();
      })
      .catch(function (error) {
        Message.error(error);
        $window.grecaptcha.reset();
      })
    }

    function verificarDocumento() {
      if (!vm.datos.recaptcha) {
        Message.show('ADVERTENCIA', 'Debe completar el reCaptcha');
        return;
      }

      if(vm.datosDocumento) {
        vm.datosDocumento = {};
        vm.pdf = null;
        vm.pdf_buffer = null;
      }
      vm.datos.codigo = vm.datos.codigo.toUpperCase();

      DataService.post(backUrl + 'verificarDocumento', vm.datos)
      .then(function (respPost) {
        if(respPost && respPost.tipoMensaje !== 'ERROR') {
          vm.datosDocumento = respPost.datos;
          vm.datos.token = respPost.datos.token;
        }
        if(respPost ) {
          Message.show(respPost.tipoMensaje, respPost.mensaje);
          DataService.pdf(backUrl + 'pdfVerificado', vm.datos)
          .then(function (response) {
            if(response) {
              vm.pdf = response.url;
              vm.pdf_buffer = response.data;
              if (vm.esMovil) {
                Util.loadCanvas(response.data, '#canvasContainerVerificado');
              }
            }
          });
        }
        $window.grecaptcha.reset();
      })
      .catch(function (error) {
        Message.error(error);
        $window.grecaptcha.reset();
      })
    }

    function irInicio() {
      $location.path('login');
    }

    
  }
})();

(function() {
    'use strict';

    angular
    .module('app')
    .controller('MainController', MainController);

    /** @ngInject */
    function MainController() {

        // var vm = this;        

    }

})();

(function() {
    'use strict'

    angular
    .module('app')
    .factory('Util', ['$window', '$injector', UtilFactory]);

    /** @ngInject */
    function UtilFactory($window, $injector) {

        var $document = $window.document;

        var tmpl_print ='<!DOCTYPE html>' +
                        '<html lang="en">' +
                        '<head>' +
                            '<meta charset="UTF-8"/>' +
                            '<title>Document</title>' +
                            '<style>{css}</style>' +
                        '</head>' +
                        '<body>{body}' +
                        '</body>' +
                        '</html>';

        var factory = {
            toType: toType,
            isJson: isJson,
            getParams: getParams,
            print: print,
            fullscreen: fullscreen,
            nano: nano,
            popup: popup,
            filterFields: filterFields,
            addPropertiesFormly: addPropertiesFormly,
            size: size,
            getFkData: getFkData,
            serialize: serialize,
            serializeToJson: serializeToJson,
            getMenuOption: getMenuOption,
            searchField: searchField,
            lengthOptions: lengthOptions,
            formatDate: formatDate,
            filterItem: filterItem,
            getKeys: getKeys,
            getId: getId,
            parseSave: parseSave,
            truncate: truncate,
            loadCanvas: loadCanvas,
            stripHTML: stripHTML
        };

        return factory;

        function nano (template, data) {
            return template.replace(/\{([\w\.]*)\}/g, function (str, key) {
                var keys = key.split("."), v = data[keys.shift()];
                for (var i = 0, l = keys.length;i < l;i++)
                    v = v[keys[i]];
                return (typeof v !== "undefined" && v !== null) ? v : "";
            });
        }

        function toType (obj) {
            return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
        }

        function isJson (text) {
            return /^[\],:{}\s]*$/.test(text.replace(/\\["\\\/bfnrtu]/g, '@').
                replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').
                replace(/(?:^|:|,)(?:\s*\[)+/g, ''));
        }

        function truncate (text, length) {
            return text.length > length ? (text.substring(0, Math.min(length, text.length)) + '...') : text;
        }

        function stripHTML(texto) {
            return texto.replace(/(<([^>]+)>)/ig,"");
        }

        function getParams (p, args) {
            var first = p.first.defaultValue,
            second = p.second.defaultValue;

            p.first.position = p.first.position || 0;
            p.second.position = p.second.position || 1;

            var type = toType(args[p.first.position]);
            if (type != 'undefined') {
                if (type == p.first.type) {
                    first = args[p.first.position];
                    second = toType(args[p.second.position]) == p.second.type ? args[p.second.position] : p.second.defaultValue;
                } else {
                    if (type == p.second.type) {
                        first = toType(args[p.second.position]) == p.first.type ? args[p.second.position] : p.first.defaultValue;
                        second = args[p.first.position];
                    }
                }
            }
            return {
                first : first,
                second : second
            };
        }

        function print (html, css) {
            if (typeof css == 'string') {
                angular.element.get(css, function (response) {
                    var popup = $window.open('', 'print');
                    popup.document.write(nano(tmpl_print, {body : html, css : response}));
                    popup.document.close();
                    popup.focus();
                    popup.print();
                    popup.close();
                });
            } else {
                var popup = $window.open('', 'print');
                popup.document.write(nano(tmpl_print, {body : html, css : css}));
                popup.document.close();
                popup.focus();
                popup.print();
                popup.close();
            }

            return true;
        }

        function popup(url) {
            $window.open(url, 'print');
        }

        function fullscreen () {
            if (!$document.fullscreenElement &&    // alternative standard method
                !$document.mozFullScreenElement && !$document.webkitFullscreenElement && !$document.msFullscreenElement ) {  // current working methods
                if ($document.documentElement.requestFullscreen) {
                    $document.documentElement.requestFullscreen();
                } else if ($document.documentElement.msRequestFullscreen) {
                    $document.documentElement.msRequestFullscreen();
                } else if ($document.documentElement.mozRequestFullScreen) {
                    $document.documentElement.mozRequestFullScreen();
                } else if ($document.documentElement.webkitRequestFullscreen) {
                    $document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
                }
            } else {
                if ($document.exitFullscreen) {
                    $document.exitFullscreen();
                } else if ($document.msExitFullscreen) {
                    $document.msExitFullscreen();
                } else if ($document.mozCancelFullScreen) {
                    $document.mozCancelFullScreen();
                } else if ($document.webkitExitFullscreen) {
                    $document.webkitExitFullscreen();
                }
            }
        }

        function filterFields(data, fields) {
            if (typeof fields == 'undefined' || fields.length == 0) {
                return data;
            }
            var filter = [];
            for (var i in fields) {
                var field = searchField(data, fields[i]);
                if (field) {
                    filter.push(field);
                }
            }
            return filter;
        }

        function searchField(fields, field) {
            for (var i in fields) {
                if (fields[i].key == field) {
                    return fields[i];
                }
            }
            return null;
        }

        function addPropertiesFormly(data, formly) {
            if (typeof formly == 'undefined' || formly.length == 0) {
                return data;
            }
            for (var i in data) {
                var field = searchField(formly, data[i].key);
                if (field) {
                    //data[i] = angular.element.extend(true, data[i], field);
                    data[i] = angular.element.extend(true, {}, data[i], field);
                }
            }
            return data;
        }

        function size(obj) {
            return Object.keys(obj).length;
        }

        function parseSave(data, formly) {
            var Datetime = $injector.get('Datetime');
            var item = {};
            for (var i in data) {
                if (toType(data[i]) == 'date') {
                    item[i] = Datetime.format(data[i], 'YYYY-MM-dd');
                } else {
                    if (typeof data[i] == 'string' && (data[i] == 'true' || data[i] == 'false')) {
                        item[i] = item[i] == 'true';
                    } else {
                        item[i] = data[i];
                    }
                }
            }
            item.id = getId(item, formly);
            return item;
        }

        function getId(item, formly, key) {            
            if (item) {
                for (var i in formly) {
                    if (formly[i].templateOptions.label && formly[i].templateOptions.label == 'ID') {
                        if (key) {
                            return formly[i].key;
                        } else {
                            return item[formly[i].key];
                        }
                    }
                }
            }
            return null;
        }

        function getFkData(fieldsData, key, value) {
            fieldsData.filter(function (e) {
                if (e.key == key && e.templateOptions.options) {
                    e.templateOptions.options.filter(function(elem) {
                        if (elem.value == value) {
                            value = elem.name;
                        }
                    })
                }
            });
            return value;
        }

        // TODO: Comentado en la limpieza de errores de consola.
        // function parseDate(date) {
        //     return [date.getFullYear(),date.getMonth()+1,date.getDate()].join('-');
        // }

        function serialize(json) {
            var string = [];
            for (var i in json) {
                string.push(i + '=' + json[i]);
            }
            return string.join('&');
        }

        function serializeToJson(json, limpiar) {
            var string = [];
            for (var i in json) {
                if(limpiar){
                    for (var j in json[i]) {
                        if ( json[i][j]==null || json[i][j]==undefined || json[i][j]=='' ) {
                            delete json[i][j];
                        }
                    }
                }
                if(Object.keys(json[i]).length > 0)
                    string.push(i + '=' + angular.toJson(json[i]));
            }
            return string.join('&');
        }

        function getMenuOption(menu, url) {
            for (var i in menu) {
                if (typeof menu[i].submenu != 'undefined') {
                    var pages = menu[i].submenu;
                    for (var j in pages) {
                        if (pages[j].url == url) {
                            return [menu[i].label, pages[j].label];
                        }
                    }
                }
            }
            for (var k in menu) {
                if (menu[k].url == url) {
                    return [menu[k].label, false];
                }
            }
            return [false,false];
        }

        function lengthOptions(data, key) {
            for (var i in data) {
                if (data[i].key == key && data[i].templateOptions && data[i].templateOptions.options) {
                    return data[i].templateOptions.options.length;
                }
            }
            return 0;
        }

        function formatDate(date) {
            date = date.split('-')
            return [date[2], date[1], date[0]].join('/');
        }

        function filterItem(data) {
            var Datetime = $injector.get('Datetime');            
            for (var i in data) {
                if (typeof data[i] == 'string') {
                    if (Datetime.isDate(data[i])) {
                      if (!(/^[0-9]\s*$/).test(data[i]))
                        data[i] = new Date();
                    } else if (!/[a-zA-Z]+/g.test(data[i]) && /^(?:(?:([01]?\d|2[0-3]):)?([0-5]?\d):)?([0-5]?\d)$/g.test(data[i]) && data[i].length == 8) {                        
                        data[i] = formatTime(data[i]);
                    }
                }
            }
            return data;
        }

        function formatTime(time) {
            time = time.split(':')
            return [time[0], time[1]].join(':')
        }

        function getKeys(data) {
            var types = {};

            data.map(function(el) {
                types[el.key] = el;
            });

            return types;
        }
        /**
         * Funcion para cargar pdf a un canvas
         * @param {texto o array} url data del pdf a renderizar
         * @param {texto} idCanvasContainer selectorID del div padre
         */

         /* eslint-disable */
        function loadCanvas(url, idCanvasContainer) {
            PDFJS.workerSrc = $injector.get('backUrl') + 'flibs/pdfjs/pdf.worker.js';
            var scale= 1.5;  //"zoom" factor for the PDF
            function renderPage(page) {
                var viewport = page.getViewport(scale);
                var canvas = document.createElement('canvas');
                var ctx = canvas.getContext('2d');
                var renderContext = {
                    canvasContext: ctx,
                    viewport: viewport
                };
                canvas.height = viewport.height;
                canvas.width = viewport.width;
                canvas.style = "width:100%; height:100%;";

                document.querySelector(idCanvasContainer).appendChild(canvas);
                page.render(renderContext);
            }

            function renderPages(pdfDoc) {
                for(var num = 1; num <= pdfDoc.numPages; num++)
                    pdfDoc.getPage(num).then(renderPage);
            }
            PDFJS.disableWorker = true;
            PDFJS.getDocument(url).then(renderPages);
        }
        /* eslint-enable */
    }
  })();

(function() {
    'use strict'

    angular
    .module('app')
    .factory('UtilFormly', UtilFormlyFactory);

    /** @ngInject */
    function UtilFormlyFactory() {

        var factory = {
            getConfigItem: getConfigItem,
            parse: parse,
            listToForm: listToForm,
            filterDates: filterDates,
            newTemplate: newTemplate,
            dataToView: dataToView,
            sizeObj: sizeObj,
            recursiveShowError: recursiveShowError,
            disableForm: disableForm,
            clearModel: clearModel
        };

        load_templates();

        return factory;

        /**
          Funcion que crea un nuevo template
          @param {String} tipo Tipo de template que se quiere crear
        */
        function newTemplate(tipo) {
            return parse(this.templates[tipo].template);
        }

        function sizeObj(o) {
            return Object.keys(o).length;
        }
        function recursiveShowError(error) {
            for (var k in error) {
                for (var i = 0; i < error[k].length; i++) {
                    if(angular.isDefined(error[k][i].$submitted)){
                        error[k][i].$submitted = true;
                        recursiveShowError(error[k][i].$error);
                    }else {
                        if(error[k][i].$setTouched)
                            error[k][i].$setTouched(true);
                    }
                }
            }
        }

        /**
          Funcion que limpia los valores del modelo, para que no quede basura
          @param {Array} data Array de objetos formly
          @param {Objeto} model contiene los valores para todos los keys de cada template
        */
        function clearModel(data, model) {
            var elem,
                new_model = {},
                keys = {};
                for (var i = 0; i < data.length; i++) {
                  if (data[i].type=="layout") {
                      for (var j = 0; j < data[i].fieldGroup.length; j++) {
                          elem = getConfigItem(data[i].fieldGroup[j]);
                          clearElem(elem, keys, model, new_model);
                      }
                  }else {
                      elem = getConfigItem(data[i]);
                      clearElem(elem, keys, model, new_model)                    ;
                  }
                }
            return new_model;
        }

        /**
          Funcion que modifica la estructura de un elemento, ademas tranforma de cadena a Date del modelo de la plantilla
          @param {Objecto} elem Template formly
          @param {Objeto} keys Objeto que representa un arbol de tipos de formly, para ir incrementando sus keys
          @param {Objeto} model contiene los valores para todos los keys de cada template
          @param {Objeto} new_model contiene los valores para todos los keys de cada template limpiado
        */
        function clearElem(elem, keys, model, new_model) {
          if (angular.isUndefined(keys[elem.type])) {
              keys[elem.type] = 1;
              elem.key = elem.type + "-0";
          } else {
              elem.key = elem.type +"-"+ keys[elem.type];
              keys[elem.type]++;
          }
          if (angular.isDefined(model[elem.key])) new_model[elem.key] = angular.copy(model[elem.key]);
        }

        /**
          Funcion que transforma los string de la lista_valores a datepicker
          @param {Array} lista_templates Lista de objetos formato formly
          @param {Array} lista_valores Lista de objetos que son valores de los templates
        */
        function filterDates(lista_templates, lista_valores) {
            for (var j = 0; j < lista_templates.length; j++) {
                //cuando en la lista de templates exista uno de tipo datepicker
                //hay que cambiar de tipo String a Objeto Date
                if (lista_templates[j].type == "datepicker") {
                    var nombre = lista_templates[j].templateOptions.label;
                    if(lista_valores.hasOwnProperty(nombre)){
                        lista_valores[nombre] = new Date(lista_valores[nombre]);
                    }
                }
            }
        }
        /**
          Funcion que crea un array de templates formly tranformado
          @param {Array} data Array de objetos formly
          @param {Objeto} model contiene los valores para todos los keys de cada template
        */
        function dataToView(data, model) {
            var elem;
            var form = [];
            var keys = {}; // variable para controlar que no existan keys iguales
            for (var i = 0; i < data.length; i++) {
                if (data[i].type=="layout") {
                    var fg = parse(data[i]);
                    var clase = " flex-"+parseInt(100/fg.elementAttributes['num-cols']);
                    delete fg.type;
                    delete fg.elementAttributes['num-cols'];
                    fg.fieldGroup = [];
                    for (var j = 0; j < data[i].fieldGroup.length; j++) {
                        elem = getConfigItem(data[i].fieldGroup[j]);
                        elem.className += clase;
                        changeElement(elem, keys, model);
                        fg.fieldGroup.push(elem);
                    }
                    form.push(fg);
                }else {
                    elem = getConfigItem(data[i]);
                    changeElement(elem, keys, model);
                    form.push(elem);
                }
            }

            return form;
        }
        /**
          Funcion deshabilita/habilita todos los campos de un formulario
          @param {Array} data Array de objetos formly
          @param {Boolean} val True/false
        */
        function disableForm(data, val) {
            angular.forEach(data, function(field) {
                if (angular.isDefined(field.fieldGroup)) {
                    for (var i = 0; i < field.fieldGroup.length; i++) {
                        if(field.fieldGroup[i].templateOptions)
                            field.fieldGroup[i].templateOptions.disabled = val;
                    }
                }else {
                    if(field.templateOptions)
                        field.templateOptions.disabled = val;
                }
            });
        }


        /**
          Funcion que modifica la estructura de un elemento, ademas tranforma de cadena a Date del modelo de la plantilla
          @param {Template} elem template formly
          @param {Objeto} keys Objeto que representa un arbol de tipos de formly, para ir incrementando sus keys
          @param {Objeto} model contiene los valores para todos los keys de cada template
        */
        function changeElement(elem, keys, model) {
            if(angular.isUndefined(keys[elem.type])){
                keys[elem.type] = 1;
                elem.key = elem.type + "-0";
            } else {
                elem.key = elem.type +"-"+ keys[elem.type];
                keys[elem.type]++;
            }
            if(elem.type === "radio"){
                elem.templateOptions.className = "layout layout-wrap";
            }
            if(elem.type === "datepicker" && angular.isDefined(model) && angular.isDefined(model[elem.key])){
                model[elem.key] = new Date(model[elem.key]);
            }
            // if(elem.type === "calendario" && angular.isDefined(model) && angular.isDefined(model[elem.key])){
            //     model[elem.key] = new Date(model[elem.key]);
            // }
            if(elem.type === "textarea"){
                elem.templateOptions.grow = true;
            }

            if(elem.templateOptions){
                var validation = {messages:{}};
                if(elem.templateOptions.required){
                    validation.messages.required = '"Debe llenar este campo."';
                }
                if( elem.type==="input"){
                    var idx = {
                        '([a-zA-Zñáéíóú]+ ?)+': '"El campo debe contener solo palabras separadas por un espacio."',
                        '\\d+': '"El campo debe contener solo números."',
                        '([a-zA-Z0-9ñáéíóú]+ ?)+': '"El campo debe contener palabras y números separadas por un espacio."',
                        '^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$': '"El campo debe ser un email válido."',
                        '^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$':'"El campo debe ser una hora en formato hh:mm (ej. 08:47)"'
                    };
                    if(elem.templateOptions.pattern) validation.messages.pattern = idx[elem.templateOptions.pattern];
                    //le da el efecto de slider al mensaje de error
                    validation.show = true;
                    elem.validation = validation;
                }
            }
        }
        /**
          Funcion que añade clases a la lista de templates para que se renderizen dividos por columnas
          @param {Array} lista_templates Lista de objetos formato formly
          @param {Objeto} config configuracion que tendra el formulario tiene columnas y deshabilitar
          @return {Array} formulario Lista de objetos, que son la transformacion de la lista de templates
        */
        function listToForm(lista_templates, config) {

            var nro_columnas = config.columnas || 1;

            var clase='flex-gt-sm-' + parseInt(100/nro_columnas);
            // console.log(lista_templates.length+"/"+nro_columnas+"="+(parseInt( lista_templates.length / nro_columnas ) + 1 ));
            var nro_filas = parseInt( lista_templates.length / nro_columnas ) + 1;

            var formulario = [];
            for (var i = 0; i < nro_filas; i++) {
                formulario.push({
                    "elementAttributes": {
                        "layout-gt-sm": "row",
                        "layout": "column",
                        "layout-align-gt-sm": "start end"
                    },
                    "fieldGroup": []
                });
            }
            i = 0;
            var k = 0;
            while ( i < lista_templates.length ) {
                var j = 0;
                while (i < lista_templates.length && j < nro_columnas ) {

                    lista_templates[i].className = clase;

                    // Hacemos que el key de cada elemento sea su label
                    if(lista_templates[i].templateOptions.label === "" || lista_templates[i].templateOptions.label === null){
                        lista_templates[i].key = lista_templates[i].templateOptions.placeholder;
                    }
                    else lista_templates[i].key = lista_templates[i].templateOptions.label;


                    if(lista_templates[i].type === "radio"){
                        lista_templates[i].templateOptions.className = "layout layout-wrap";
                    }

                    if(config.deshabilitar || false){
                        lista_templates[i].templateOptions.disabled = true;
                    }else {
                        lista_templates[i].templateOptions.disabled = false;
                    }
                    if(config.todoMayuscula || false){
                        if(lista_templates[i].type === "input"){
                            var onkeyup = 'model["' + lista_templates[i].key + '"] = model["' + lista_templates[i].key + '"].toUpperCase()';
                            lista_templates[i].templateOptions.onKeyup = onkeyup;
                        }
                    }

                    if(config.validacion || false){
                        if(lista_templates[i].type === "input" || lista_templates[i].type === "datepicker"){
                            lista_templates[i].validation = {
                                messages: {
                                    required: '"Debe llenar este campo."'
                                    // required: '"El campo " + to.label + " es requerido"'
                                }
                            }
                        }
                    }

                    formulario[k].fieldGroup.push(getConfigItem(lista_templates[i]));
                    i++;
                    j++;
                }
                k++;
            }

            return formulario;
        }

        /**
        Funcion que obtiene el template limpio de un elemento
        */
        function getConfigItem(item){
            if(item.type=='layout') return parse(item);            
            var obj = {
                type: item.type,
                key: item.key,
                className: parse(item.className),
                templateOptions: parse(item.templateOptions),
                validation: parse(item.validation),
                expressionProperties: parse(item.expressionProperties),
                controller: parse(item.controller)
            }
            return obj;
        }
        /**
        Funcion que copia un objeto, pero perdiendo la referencia
        */
        function parse(data) {
            return angular.fromJson(angular.toJson(data));
        }

        function load_templates() {
            // console.log(this);
            factory.templates = {
                input: {
                    template: {
                        type: "input",
                        key: "inputText",
                        templateOptions: {
                            type: "text",
                            label: "Campo de texto",
                            disabled: false
                        }
                    }
                },
                radio: {
                    template: {
                        type: "radio",
                        key: "inputRadio",
                        templateOptions: {
                            label: "Selección simple",
                            labelProp: "value",
                            valueProp: "id",
                            vertical:false,
                            options: [
                                {value: "opción 1", id: "opcion 1"},
                                {value: "opción 2", id: "opcion 2"}
                            ]
                        }
                    }
                },
                select: {
                    template: {
                        type: "select",
                        key: "inputSelect",
                        templateOptions: {
                            label: "Lista de selección",
                            multiple: false,
                            labelProp: "value",
                            valueProp: "id",
                            showItem: true,
                            options: [
                                {value: "opción 1", id: "opcion 1"},
                                {value: "opción 2", id: "opcion 2"}
                            ]
                        }
                    }
                },
                select_multiple: {
                    template: {
                        type: "select",
                        key: "inputSelect",
                        templateOptions: {
                            label: "Lista de selección",
                            multiple: true,
                            labelProp: "value",
                            valueProp: "id",
                            options: [
                                { value: "opción 1", id: "opcion 1" },
                                { value: "opción 2", id: "opcion 2" }
                            ]
                        }
                    }
                },
                textarea: {
                    template: {
                        type: "textarea",
                        key: "inputTextArea",
                        // className: "ap-text-left",
                        templateOptions: {
                            label: "Area de texto",
                            rows: 2,
                            grow: false
                        }
                    }
                },
                checkbox: {
                    template: {
                        type: "checkbox",
                        key: "inputCheckBox",
                        templateOptions: {
                            label: "Casilla de verificación",
                            disabled: false
                        }
                    }
                },
                datepicker: {
                    template: {
                        type: "datepicker",
                        key: "inputDatePicker",
                        templateOptions: {
                            label: "Calendario"
                        }
                    }
                },
                // calendario: {
                //     template: {
                //         type: "calendario",
                //         key: "calendario",
                //         templateOptions: {
                //             label: 'Calendario',
                //             minDate: '',
                //             maxDate: ''
                //         }
                //     }
                // },
                slider: {
                    template: {
                        type: "slider",
                        key: "inputSlider",
                        templateOptions: {
                            label: "Deslizador",
                            min: 1,
                            max: 5,
                            step: 0.5,
                            discrete: true
                        }
                    }
                },
                switch: {
                    template: {
                        type: "switch",
                        key: "inputSwitch",
                        templateOptions: {
                            label: "Interruptor"
                        }
                    }
                },
                chips: {
                    template: {
                        type: "chips",
                        key: "inputChips",
                        templateOptions: {
                            label: "Palabras clave",
                            placeholder: "+palabras",
                            secondaryPlaceholder: "Añadir palabras",
                            deleteButtonLabel: "Borrar",
                            deleteHint: "Borrar palabra"
                            // onAdd: function() {
                            //   console.log('new chip');
                            // },
                            // onRemove: function() {
                            //   console.log('chip removed');
                            // }
                        }
                    }
                },
                titulo: {
                    template: {
                        type: "texto",
                        key: "texto",
                        templateOptions: {
                            label: "Título",
                            tipo: "h2",
                            className: "ap-text-left",
                            mTop: true,
                            mBot: true
                        }
                    }
                },
                subtitulo: {
                    template: {
                        type: "texto",
                        key: "texto",
                        templateOptions: {
                            label: "Subtítulo",
                            tipo: "h3",
                            className: "ap-text-left",
                            mTop: true,
                            mBot: true
                        }
                    }
                },
                parrafo: {
                    template: {
                        type: "texto",
                        key: "parrafo",
                        templateOptions: {
                            label: "Texto del párrafo, texto del párrafo, texto del párrafo, texto del párrafo, texto del párrafo, texto del párrafo, texto del párrafo, texto del párrafo.",
                            tipo: "p",
                            className: "ap-text-justify",
                            mTop: true,
                            mBot: true
                        }
                    }
                },
                lista: {
                    template: {
                        type: "lista",
                        key: "lista",
                        templateOptions: {
                            label: "Lista de elementos",
                            className: "ap-text-left",
                            tipo: "ol",
                            showItem: true,
                            options: [
                                "Elemento 1",
                                "Elemento 2"
                            ]
                        }
                    }
                },
                datosGenerales: {
                    template: {
                        type: "datosGenerales",
                        key: "datosGenerales",
                        templateOptions: {
                            labelw: 10,
                            labelRef: 'REF.:',
                            showItem: true,
                            show: {
                                para: true,
                                via: true,
                                de: true,
                                ref: true
                            }
                        }
                    }
                },
                encabezado: {
                  template: {
                    type: "encabezado",
                    key: "encabezado",
                    templateOptions: {
                      labelw: 10,
                      labelRef: 'REF.:',
                      show: {
                        para: true,
                        via: true,
                        de: true,
                        ref: true
                      }
                    }
                  }
                },
                documentosRelacionados: {
                    template: {
                        type: "documentosRelacionados",
                        key: "documentosRelacionados",
                        templateOptions: {
                          labelw: 10,
                          label: "Referencias:"
                        }
                    }
                },
                listaContactos: {
                    template: {
                        type: "listaContactos",
                        key: "listaContactos",
                        templateOptions: {
                            labelw: 20,
                            label: 'Lista de contactos:'
                        }
                    }
                },
                documentosAnular: {
                    template: {
                        type: "documentosAnular",
                        key: "documentosAnular",
                        templateOptions: {
                          labelw: 10,
                          label: "Referencias:"
                        }
                    }
                },
                ccArchivo: {
                    template: {
                        type: "ccArchivo",
                        key: "ccArchivo",
                        templateOptions: {
                            labelw: 10,
                            label: "CC/Archivo:"
                        }
                    }
                },
                archivo: {
                    template: {
                        type: "archivo",
                        key: "archivo",
                        templateOptions: {
                            label: "Elegir PDF"
                        }
                    }
                },
                pdfsAprobacionCD: {
                    template: {
                        type: "pdfsAprobacionCD",
                        key: "pdfsAprobacionCD",
                        templateOptions: {
                            label: "ADJUNTAR"
                        }
                    }
                },
                cite: {
                    template: {
                        type: "cite",
                        templateOptions: {
                            labelCite: 'CITE',
                            labelFecha: 'FECHA',
                            tipo: 'general',
                            numeracionPagina:'false',
                            tipoHoja:'Letter'
                        }
                    }
                },
                inputt: {
                    template: {
                        type: "inputt",
                        templateOptions: {
                            labelw: 20,
                            labelx: 'Asunto:'
                        }
                    }
                },
                editorTexto: {
                    template: {
                        type: "editorTexto",
                        templateOptions: {
                            label: 'jojojo'
                        }
                    }
                },
                layout: {
                    template: {
                        "type": "layout",
                        "elementAttributes": {
                            "num-cols": "2",
                            "layout-align": "start end",
                            "layout": "row"
                        },
                        "fieldGroup": []
                    }
                },
                vacio: {
                    template: {
                        type: "vacio",
                        templateOptions: {
                            height: 1,
                            style: {}
                        }
                    }
                },
                cajachica: {
                    template: {
                        type: "cajachica",
                        templateOptions: {
                            tipo: 'GESTION'
                        }
                    }
                },
                certificacionComprometido: {
                  template: {
                    type: "certificacionComprometido",
                    templateOptions: {
                      label: 'Certificación de presupuesto comprometido'
                    }
                  }
                },
                consultaAlmacen: {
                    template: {
                        type:"consultaAlmacen",
                        templateOptions: {
                            label: "Consulta al sistema de almacenes",
                            tipo: 'SOLCITUD'
                        }
                    }
                },
                recuperarEntregaAlmacen: {
                    template: {
                        type:"recuperarEntregaAlmacen",
                        templateOptions: {
                            label: "Recuperacion de entrega desde Almacen",
                            solicitud: 'SMS',
                            manual: false,
                            consultado: false
                        }
                    }
                },
                ingresoAlmacen: {
                    template: {
                        type:"ingresoAlmacen",
                        templateOptions: {
                            label: "Ingreso de suministros y/o materiales"
                        }
                    }
                },
                tablaActivos: {
                    template: {
                        type:"tablaActivos",
                        templateOptions: {
                            label: "Tabla de Activos Fijos",
                            tipoFormulario: 'SOLICITUD'
                        }
                    }
                },
                ingresoActivos: {
                    template: {
                        type:"ingresoActivos",
                        templateOptions: {
                            label: "Ingreso de Activos Fijos",
                            activos: []
                        }
                    }
                },
                bajaActivos: {
                    template: {
                        type:"bajaActivos",
                        templateOptions: {
                            label: "Baja de Activos Fijos",
                            activos: []
                        }
                    }
                }
            };
        }

    }
})();

(function() {
    'use strict'

    angular
    .module('app')
    .factory('Storage', ['$window', 'appName', StorageFactory]);

    /** @ngInject */
    function StorageFactory($window, appName) {

        appName = appName || 'app';

        var $local = $window.localStorage;
        var $session = $window.sessionStorage;

        var factory = {
            get: get,
            set: set,
            remove: remove,
            destroy: destroy,
            exist: exist,
            getSession: getSession,
            setSession: setSession,
            removeSession: removeSession,
            destroySession: destroySession,
            existSession: existSession,
            setUser: setUser,
            getUser: getUser,
            existUser: existUser,
            removeUser: removeUser,
            getToken: getToken
        };

        return factory;

        function setUser(user) {
            setSession('user', user);
        }

        function getUser() {
            return getSession('user');
        }

        function existUser() {
            return existSession('user');
        }

        function removeUser() {
            removeSession('user');
        }

        function getToken() {
            return $local.getItem(appName + '_' + 'token');
        }

        // LocalStorage
        function set(key, value) {
            $local.setItem(appName + '_' + key, angular.toJson(value));
        }

        function get(key) {
            return angular.fromJson($local.getItem(appName + '_' + key));
        }

        function remove(key) {
            $local.removeItem(appName + '_' + key);
        }

        function destroy() {
            for(var x in $local)
                $local.removeItem(x);
        }

        function exist(key) {
            return typeof $local.getItem(appName + '_' + key) != 'undefined' && $local.getItem(appName + '_' + key) != null && $local.getItem(appName + '_' + key) != 'undefined';
        }

        // SessionStorage
        function setSession(key, value) {
            $session.setItem(appName + '_' + key, angular.toJson(value));
        }

        function getSession(key) {
            return angular.fromJson($session.getItem(appName + '_' + key));
        }

        function removeSession(key) {
            $session.removeItem(appName + '_' + key);
        }
        function destroySession() {
            for(var x in $session)
                $session.removeItem(x);
        }

        function existSession(key) {
            return typeof $session.getItem(appName + '_' + key) != 'undefined' && $session.getItem(appName + '_' + key) != null && $session.getItem(appName + '_' + key) != 'undefined';
        }
    }
})();

(function() {
    'use strict'

    angular
    .module('app')
    .factory('RouteValidator', ['$rootScope', 'Storage', 'Message', 'ExpirationTime', RouteValidatorFactory]);

    /** @ngInject */
    function RouteValidatorFactory($rootScope, Storage, Message, ExpirationTime) {

        var factory = {
            init: init
        };

        return factory;

        function init(){
            $rootScope.$on('$stateChangeStart', onStateChangeStart); // eslint-disable-line angular/on-watch
        }

        /**
            Funcion que se activa cada vez que se quiere cambiar de localizacion de vista
            @param {Objeto} ev Evento cambiar de localizacion
            @param {Objeto} toState Objeto con datos de la url a la que se quiere ir
            @param {Objeto} toParams Objeto con los parametros de la url a la que se quiere ir
            @param {Objeto} fromState Objeto con datos de la url en la se encuentra actualmente
        */
        function onStateChangeStart(ev, toState, toParams, fromState){

            if (fromState.url !== "^" && toState.url!=="/login" && toState.url!=="/verificar") {
                // console.log("origen->"+fromState.url);
                // console.log("destino->" +toState.url);

                var user = Storage.getUser();
                var existeUsuario = (user !== null)? true : false;
                // console.log(user);

                var menus = Storage.getSession('menu');
                var rutaPermitida = true;

                if(fromState.url==="/login" && toState.url!=="/login" && !existeUsuario){
                    Message.error('Usted no esta autorizado para acceder a la vista.');
                    ev.preventDefault();
                    return;
                }else {
                    rutaPermitida = (toState.url === "/")? true : false;
                    if(toState.url==="/profile") rutaPermitida = true;
                    if(toState.url==="/vista_pdf") rutaPermitida = true;
                    if(toState.url==="/elegir") rutaPermitida = true;
                    // rutaPermitida = true;
                    if(existeUsuario && !rutaPermitida){
                        for (var i = 0; i < menus.length; i++) {
                            for (var j = 0; j < menus[i].submenu.length; j++) {
                                // console.log("submenu "+"/"+menus[i].submenu[j]);
                                if(tienePermiso(menus[i].submenu[j].url, toState.url)){
                                    rutaPermitida = true;
                                }
                            }
                        }
                    }

                    if(toState.url!=='/documento/:idDocumento') ExpirationTime.stopAutoSave();
                    // console.log(existeUsuario +"   "+ rutaPermitida);
                    if(!existeUsuario || !rutaPermitida){
                        Message.error('Usted no esta autorizado para acceder a la vista.');
                        ev.preventDefault();
                        return;
                    }
                }
            }
        }

        function tienePermiso(ruta, ruta_destino) {
            // console.log("sm-> " + ruta);
            var submenu_rutas = {
                "plantillas": {
                    "/plantillas": true,
                    "/plantilla/:idPlantilla": true
                },
                "usuario": {
                    "/usuario": true,
                    "/elegir": true
                },
                "rol": {
                    "/rol": true
                },
                "menu": {
                    "/menu": true
                },
                "documentos": {
                    "/documentos": true,
                    "/documento/:idDocumento": true
                },
                "aprobacion": {
                    "/aprobacion": true
                },
                "progreso": {
                    "/progreso": true
                },
                "impresion": {
                    "/impresion": true
                },
                "en_curso": {
                    "/en_curso": true
                },
                "firmar": {
                    "/firmar": true
                },
                "aprobar_documento": {
                    "/aprobar_documento": true
                },
                "monitoreo": {
                    "/monitoreo": true
                },
                "contactos": {
                  "/contactos": true
                },
                "catalogos": {
                    "/catalogos": true,
                    "/catalogo/:idCatalogo": true
                },
                "compartidos": {
                    "/compartidos": true,
                    "/compartido/:idCompartido": true
                }
            }
            if(angular.isDefined(submenu_rutas[ruta])){
                if(angular.isDefined(submenu_rutas[ruta][ruta_destino]))
                    return submenu_rutas[ruta][ruta_destino];
            }
            return false;
        }

    }
})();

(function() {
    'use strict';

    angular
    .module('app')
    .factory('Panel', ['$mdPanel', '$document',PanelFactory]);

    /** @ngInject */
    function PanelFactory($mdPanel, $document) {

        var factory = {
            show : show
        };

        return factory;

        function show(config) {
            // console.log(config);

            var position = null;
            // delete config.event;
            if(config.event){
                position = $mdPanel.newPanelPosition()
                .relativeTo(config.event.currentTarget)
                .addPanelPosition($mdPanel.xPosition.ALIGN_END, $mdPanel.yPosition.BELOW);
            }else {
                position = $mdPanel.newPanelPosition().absolute().center();
            }
            // console.log(position);

            var default_template = 'app/factories/Panel/defaultPanelTemplate.html';

            var settings = {
                    attachTo: angular.element($document[0].body),
                    controller: config.controller || ['$scope', '$log', PanelController],
                    templateUrl: config.templateUrl || default_template,
                    panelClass: 'md-panel',
                    position: position,
                    locals: {
                        data: config.data || ''
                    },
                    openFrom: config.event,
                    clickOutsideToClose: angular.isUndefined(config.clickOutsideToClose) ? true : config.clickOutsideToClose,
                    escapeToClose: angular.isUndefined(config.clickOutsideToClose) ? true : config.clickOutsideToClose,
                    focusOnOpen: true
                    // zIndex: 2
                };

            if (config.event) {
                settings.targetEvent = config.event;
            }

            $mdPanel.open(settings);

            // var settings = {
            //     controller: config.controller || ['$scope', '$mdDialog', 'data', 'fields', 'title', 'add', 'column', 'done', DialogController],
            //     templateUrl: config.templateUrl || '',
            //     parent: angular.element('body'),
            //     clickOutsideToClose:typeof config.clickOutsideToClose == 'undefined' ? true : config.clickOutsideToClose,
            //     escapeToClose:typeof config.escapeToClose == 'undefined' ? true : config.escapeToClose,
            //     locals: {
            //         data: config.data || '',
            //         fields: config.fields || '',
            //         title: config.title || '',
            //         add: config.add || '',
            //         column: config.column || 1,
            //         done: config.done || function () {}
            //     }
            // };
            // if (config.event) {
            //     settings.targetEvent = config.event;
            // }
            // $mdDialog.show(settings)
            // .then(function () {}, function() {
            //     if (config.close) {
            //         config.close();
            //     }
            // });
        }

        function PanelController($scope, $log) {
            $log.info("hola desde controller default, introduzca su controller");
        }

        // BasicDemoCtrl.prototype.showMenu = function(ev) {
        //     var position = this._mdPanel.newPanelPosition()
        //     .relativeTo('.demo-menu-open-button')
        //     .addPanelPosition(this._mdPanel.xPosition.ALIGN_START, this._mdPanel.yPosition.BELOW);
        //
        //     var config = {
        //         attachTo: angular.element(document.body),
        //         controller: PanelMenuCtrl,
        //         controllerAs: 'ctrl',
        //         template:
        //         '<div class="demo-menu-example" ' +
        //         '     aria-label="Select your favorite dessert." ' +
        //         '     role="listbox">' +
        //         '  <div class="demo-menu-item" ' +
        //         '       ng-class="{selected : dessert == ctrl.favoriteDessert}" ' +
        //         '       aria-selected="{{dessert == ctrl.favoriteDessert}}" ' +
        //         '       tabindex="-1" ' +
        //         '       role="option" ' +
        //         '       ng-repeat="dessert in ctrl.desserts" ' +
        //         '       ng-click="ctrl.selectDessert(dessert)"' +
        //         '       ng-keydown="ctrl.onKeydown($event, dessert)">' +
        //         '    {{ dessert }} ' +
        //         '  </div>' +
        //         '</div>',
        //         panelClass: 'demo-menu-example',
        //         position: position,
        //         locals: {
        //             'selected': el.selected,
        //             'desserts': el.desserts
        //         },
        //         openFrom: ev,
        //         clickOutsideToClose: true,
        //         escapeToClose: true,
        //         focusOnOpen: false,
        //         zIndex: 2
        //     };
        // }
    }
})();

(function() {
    'use strict';

    angular
    .module('app')
    .factory('Modal', ['$mdDialog', ModalFactory]);

    /** @ngInject */
    function ModalFactory($mdDialog) {

        var factory = {
            show : show,
            alert : alert,
            confirm : confirm
        };

        return factory;

        function show(config) {
            var settings = {
                controller: config.dialogController || config.controller || ['$scope', '$mdDialog', 'data', 'fields', 'title', 'add', 'column', 'done', DialogController],
                templateUrl: config.templateUrl || '',
                parent: angular.element('body'),
                clickOutsideToClose:typeof config.clickOutsideToClose == 'undefined' ? true : config.clickOutsideToClose,
                escapeToClose:typeof config.escapeToClose == 'undefined' ? true : config.escapeToClose,
                locals: {
                    data: config.data || '',
                    fields: config.fields || '',
                    title: config.title || '',
                    add: config.add || '',
                    column: config.column || 1,
                    done: config.done || function () {}
                }
            };
            if (config.event) {
                settings.targetEvent = config.event;
            }
            $mdDialog.show(settings)
            .then(function () {}, function() {
                if (config.close) {
                    config.close();
                }
            });
        }

        function DialogController($scope, $mdDialog, data, fields, title, add, column, done) {
            var vm = $scope;

            vm.data = data;
            vm.fields = fields;
            vm.title = title;
            vm.add = add;
            vm.column = column;
            vm.hide = $mdDialog.hide;
            vm.cancel = $mdDialog.cancel;

            vm.answer = function(answer) {
                done(answer, $mdDialog);
            }
        }

        function alert(text, event) {
            var $alert = $mdDialog.alert()
                .clickOutsideToClose(true)
                .title('Alerta')
                .htmlContent(text)
                .ariaLabel('Alerta')
                .ok('Aceptar');

            if (event) {
                $alert.targetEvent(event);
            }
            $mdDialog.show($alert);
        }

        function confirm(text, done, cancel, event) {
            var $confirm = $mdDialog.confirm()
                .title('Confirmar')
                .textContent(text)
                .ariaLabel('Confirmar')
                .ok('Aceptar')
                .cancel('Cancelar');

            if (event) {
                $confirm.targetEvent(event);
            }

            $mdDialog.show($confirm)
            .then(function() {
                if (done) {
                    done();
                }
            }, function() {
                if (cancel) {
                    cancel();
                }
            });
        }

    }
})();

(function() {
    'use strict'

    angular
    .module('app')
    .factory('MyFormlyConfig', FormlyConfigFactory);

    /** @ngInject */
    function FormlyConfigFactory() {

        var factory = {
            init: init
        };

        return factory;


        /**
          Funcion que inicia los elementos formly extras que se usaran en la aplicacion
          @param {formlyConfig} ProveedorServicio Objeto el cual angular-formly provee para poder configurar nuevos elementos y wrappers
        */
        function init(formlyConfig){
            // console.log(formlyConfig);
            formlyConfig.setType({
                name: 'texto',
                templateUrl: 'app/components/formlyComponents/texto/texto.html'
            });
            formlyConfig.setType({
              name: 'lista',
              templateUrl: 'app/components/formlyComponents/listas/listas.html'
            });
            formlyConfig.setType({
                name: 'vacio',
                templateUrl: 'app/components/formlyComponents/vacio/vacio.html',
                controller: 'fcVacioController'
            });
            formlyConfig.setType({
                name: 'cite',
                templateUrl: 'app/components/formlyComponents/cite/cite.html',
                controller: 'fcCiteController'
            });
            formlyConfig.setType({
                name: 'inputt',
                templateUrl: 'app/components/formlyComponents/inputt/inputt.html'
            });
            formlyConfig.setType({
                name: 'editorTexto',
                templateUrl: 'app/components/formlyComponents/editorTexto/editorTexto.html'
            });
            formlyConfig.setType({
              name: 'datosGenerales',
              templateUrl: 'app/components/formlyComponents/datosGenerales/datosGenerales.html',
              controller: 'fcDatosGeneralesController'
            });
            formlyConfig.setType({
              name: 'encabezado',
              templateUrl: 'app/components/formlyComponents/encabezado/encabezado.html',
              controller: 'fcEncabezadoController'
            });
            formlyConfig.setType({
              name: 'documentosRelacionados',
              templateUrl: 'app/components/formlyComponents/documentosRelacionados/documentosRelacionados.html',
              controller: 'fcDocumentosRelacionadosController'
            });
            formlyConfig.setType({
              name: 'documentosAnular',
              templateUrl: 'app/components/formlyComponents/documentosAnular/documentosAnular.html',
              controller: 'fcDocumentosAnularController'
            });
            formlyConfig.setType({
              name: 'ccArchivo',
              templateUrl: 'app/components/formlyComponents/ccArchivo/ccArchivo.html',
              controller: 'fcConCopiaArchivoController'
            });
            formlyConfig.setType({
              name: 'archivo',
              templateUrl: 'app/components/formlyComponents/archivo/archivo.html',
              controller: 'fcArchivoController'
            });
            formlyConfig.setType({
              name: 'pdfsAprobacionCD',
              templateUrl: 'app/components/formlyComponents/aprobacionCD/pdfsAprobacionCD.html',
              controller: 'fcPdfsAprobacionCDController'
            });
            formlyConfig.setType({
              name: 'cajachica',
              templateUrl: 'app/components/formlyComponents/cajachica/cajachica.html',
              controller: 'fcCajaChicaController'
            });
            formlyConfig.setType({
              name: 'certificacionComprometido',
              templateUrl: 'app/components/formlyComponents/certificacionComprometido/certificacionComprometido.html'
            });
            formlyConfig.setType({
              name: 'listaContactos',
              templateUrl: 'app/components/formlyComponents/listaContactos/listaContactos.html',
              controller: 'fcListaContactosController'
            });
            formlyConfig.setType({
              name: 'consultaAlmacen',
              templateUrl: 'app/components/formlyComponents/almacen/consultaAlmacen/consultaAlmacen.html',
              controller: 'fcConsultaAlmacenController'
            });
            formlyConfig.setType({
              name: 'recuperarEntregaAlmacen',
              templateUrl: 'app/components/formlyComponents/almacen/recuperarEntregaAlmacen/recuperarEntregaAlmacen.html',
              controller: 'fcRecuperarEntregaAlmacenController'
            });
            formlyConfig.setType({
              name: 'ingresoAlmacen',
              templateUrl: 'app/components/formlyComponents/almacen/ingreso/ingreso.html',
              controller: 'fcIngresoAlmacenController'
            });
            formlyConfig.setType({
              name: 'consultaActivo',
              templateUrl: 'app/components/formlyComponents/activo/consultaActivo/consultaActivo.html',
              controller: 'fcConsultaActivoController'
            });
            formlyConfig.setType({
              name: 'asignacionActivo',
              templateUrl: 'app/components/formlyComponents/activo/asignacionActivo/asignacionActivo.html',
              controller: 'fcAsignacionActivoController'
            });
            formlyConfig.setType({
              name: 'devolucionActivo',
              templateUrl: 'app/components/formlyComponents/activo/devolucionActivo/devolucionActivo.html',
              controller: 'fcDevolucionActivoController'
            });
            formlyConfig.setType({
              name: 'tablaActivos',
              templateUrl: 'app/components/formlyComponents/activo/tablaActivos/tablaActivos.html',
              controller: 'fcTablaActivosController'
            });
            formlyConfig.setType({
              name: 'ingresoActivos',
              templateUrl: 'app/components/formlyComponents/activo/ingresoActivos/ingresoActivos.html',
              controller: 'fcIngresoActivosController'
            });
            formlyConfig.setType({
              name: 'bajaActivos',
              templateUrl: 'app/components/formlyComponents/activo/bajaActivos/bajaActivos.html',
              controller: 'fcBajaActivosController'
            });
        }
    }
})();

(function() {
    'use strict'

    angular
    .module('app')
    .factory('Message', ['$mdToast', MessageFactory]);

    /** @ngInject */
    function MessageFactory($mdToast) {

        var factory = {
            success : success,
            warning : warning,
            error : error,
            show: show
        };

        return factory;

        function show(type, msg, title, timeout) {
            var typeIcon = {
              'EXITO': 'check',
              'ERROR': 'error',
              'ADVERTENCIA': 'warning',
              'INFORMACION': 'info'
            }

            var messageDefault = {
              'EXITO': 'La operación se realizó correctamente.',
              'ERROR': 'Ocurrió un error al procesar su operación.',
              'ADVERTENCIA': 'Ocurrió algo inesperado al procesar su operación.',
              'INFORMACION': 'La operacion se realizó correctamente, pero hay alguna infromación que no se muestra'
            }

            var titleDefault = {
              'EXITO': 'Correcto',
              'ERROR': 'Error',
              'ADVERTENCIA': 'Advertencia',
              'INFORMACION': 'Información'
            }

            var typeClass = {
              'EXITO': 'success',
              'ERROR': 'danger',
              'ADVERTENCIA': 'warning',
              'INFORMACION': 'info'
            }

            var data = {
                icon : typeIcon[type],
                message : msg || messageDefault[type],
                title : title || titleDefault[type],
                type : typeClass[type],
                timeout: timeout
            };

            render(data);
        }


        function success(msg, title, timeout) {
            var data = {
                icon : 'check',
                message : msg || 'La operación se realizó correctamente.',
                title : title || 'Correcto',
                type : 'success',
                timeout: timeout
            };

            render(data);
        }

        function error(msg, title, timeout) {
            var data = {
                icon : 'error',
                message : msg || 'Ocurrió un error al procesar su operación.',
                title : title || 'Error',
                type : 'danger',
                timeout: timeout
            };

            render(data);
        }

        function warning(msg, title, timeout) {
            var data = {
                icon : 'warning',
                message : msg || 'Ocurrió algo inesperado al procesar su operación.',
                title : title || 'Advertencia',
                type : 'warning',
                timeout: timeout
            };

            render(data);
        }

        function render(data) {
            $mdToast.show({
                controller: ToastController,
                templateUrl: 'app/factories/Messages/layout.toast.html',
                parent : angular.element('#toast-container-main'),
                hideDelay: typeof data.timeout != 'undefined' ? (data.timeout == 0 ? 31536000000 : data.timeout) : 5000,
                position: 'top right',
                locals: data
            });
        }

        function ToastController($scope, $mdToast, icon, message, title, type) {
            var vm = $scope;

            vm.icon = icon;
            vm.message = message;
            vm.title = title;
            vm.type = type;

            vm.close = function() {
                $mdToast.hide()
            };
        }
    }
})();

(function() {
    'use strict';

    angular
    .module('app')
    .factory('Loading', ['$mdDialog', LoadingFactory]);

    /** @ngInject */
    function LoadingFactory($mdDialog) {

        var factory = {
            show : show,
            cerrar : cerrar,
            cambiar: cambiar
        };
        var tiposDic = {
            warning: 'loader-warning',
            error: 'loader-error',
            success: 'loader-success',
            info: 'loader-info'
        };
        var dataLocal = {
            mensaje: 'Cargando...',
            tipo: tiposDic.warning
        };

        return factory;

        function show(config) {
            if(config.data) dataLocal= config.data;
            var settings = {
                controller: config.dialogController || config.controller || ['$scope', '$mdDialog', 'data', 'fields', 'title', 'add', 'column', DialogController],
                templateUrl: config.templateUrl || 'app/factories/Loading/Loading.html' ||'',
                parent: angular.element('body'),
                // clickOutsideToClose:typeof config.clickOutsideToClose == 'undefined' ? true : config.clickOutsideToClose,
                escapeToClose: false,
                locals: {
                    // data: config.data || dataLocal ||'',
                    data:  dataLocal,
                    fields: config.fields || '',
                    title: config.title || '',
                    add: config.add || '',
                    column: config.column || 1
                    // done: config.done || function () {}
                }
            };
            if (config.event) {
                settings.targetEvent = config.event;
            }
            $mdDialog.show(settings)
            .then(function () {}, function() {
                if (config.close) {
                    // console.log('OHHHH NO!!!!');
                    
                    config.close();
                }
            });
        }
        function cerrar() {
        //   console.log('Ejecutando el cerrar');
          $mdDialog.hide();
        }

        function cambiar(datos) {
            // console.log('Inciando el cambio');
            if(datos.mensaje) dataLocal.mensaje = datos.mensaje;
            if (datos.tipo) dataLocal.tipo = tiposDic[datos.tipo];
        }

        function DialogController($scope, $mdDialog, data, fields, title, add, column) {
            var vm = $scope;
            vm.data = data;
            vm.fields = fields;
            vm.title = title;
            vm.add = add;
            vm.column = column;
            vm.hide = $mdDialog.hide;
            

            
        }

        
    }
})();

(function() {
    'use strict'

    angular
    .module('app')
    .factory('HttpInterceptor', ['$q', 'Storage', 'restUrl', HttpInterceptorFactory]);

    /** @ngInject */
    function HttpInterceptorFactory($q, Storage, restUrl) {

        var factory = {
            request: request
        };

        return factory;

        function request(req) {
            if(req.url.indexOf(restUrl) !== -1){
                var validacion = {
                    flag: true,
                    token: Storage.getToken()
                };
                req.headers["validacion"] = base64Encode(angular.toJson(validacion));
            }
            return req;
        }

        // function responseError(response) {
        //     return $q.reject(response);
        // }

        function base64Encode(text){

            if (/([^\u0000-\u00ff])/.test(text)){
                throw new Error("Can't base64 encode non-ASCII characters.");
            }

            var digits = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
                i = 0,
                cur, prev, byteNum,
                result=[];

            while(i < text.length){

                cur = text.charCodeAt(i);
                byteNum = i % 3;

                switch(byteNum){
                    case 0: //first byte
                        result.push(digits.charAt(cur >> 2));
                        break;

                    case 1: //second byte
                        result.push(digits.charAt((prev & 3) << 4 | (cur >> 4)));
                        break;

                    case 2: //third byte
                        result.push(digits.charAt((prev & 0x0f) << 2 | (cur >> 6)));
                        result.push(digits.charAt(cur & 0x3f));
                        break;
                }

                prev = cur;
                i++;
            }

            if (byteNum == 0){
                result.push(digits.charAt((prev & 3) << 4));
                result.push("==");
            } else if (byteNum == 1){
                result.push(digits.charAt((prev & 0x0f) << 2));
                result.push("=");
            }

            return result.join("");
        }

    }
})();

(function() {
    'use strict'

    angular
    .module('app')
    .factory('ExpirationTime', ['Storage', 'Message', '$interval', '$auth', '$location', '$mdDialog', 'DataService', 'restUrl', ExpirationTimeFactory]);

    /** @ngInject */
    function ExpirationTimeFactory(Storage, Message, $interval, $auth, $location, $mdDialog, DataService, restUrl) {

        /**
            Factory que se encargara de controlar el tiempo de expiración de la sesion de usuario.
            interval: funcion que se repite cada segundo
            time: el tiempo que se que tiende a disminuir hasta cero si no se apreta alguna tecla o se hace un click
            init: funcion que inicializara a la funcion interval y el tiempo time
            stopInterval: funcion que cancela la funcion interval y la vuelve indefinida
            refreshToken: funcion que refresca el tiempo time, esta funcion se activa al entrar a la ruta documento/:idDocumento
            guardar: funcion que se manda desde documento/:idDocumento
            autoSaveInterval: funcion que se repite cada 10 minutos y activa a guardar,
            initAutoSave: iniciar el autoguardado,
            stopAutoSave: cancelar el autoguardado,
            getExpirationTime: obtener el tiempo de expiracion,
            logout: funcion desloguearse del sistema
        */
        var factory = {
            interval: undefined,
            time: null,
            init: init,
            stopInterval: stopInterval,
            refreshToken: refreshToken,
            guardar: undefined,
            autoSaveInterval: undefined,
            initAutoSave: initAutoSave,
            stopAutoSave: stopAutoSave,
            getExpirationTime: getExpirationTime,
            logout: logout
        };
        var fac = factory;
        return factory;

        function init(){
            if(angular.isUndefined(fac.interval)){
                fac.time = getExpirationTime()*60;
                fac.interval = $interval(function () {
                    fac.time--;
                    if (fac.time == 10 && $location.url().indexOf('/documento/') && angular.isDefined(fac.autoSaveInterval)) fac.guardar(false, true);
                    if (fac.time <= 0 || $location.url().indexOf('/login')==0)  logout(true);
                }, 1000)
            }
        }

        function getExpirationTime() {
             return angular.isDefined($auth.getPayload())? $auth.getPayload().tiempo : 0 ;
         }

        function stopInterval() {
            if(angular.isDefined(fac.interval)) {
                $interval.cancel(fac.interval);
                fac.interval = undefined;
            }
        }

        function stopAutoSave() {
            if(angular.isDefined(fac.autoSaveInterval)) {
                $interval.cancel(fac.autoSaveInterval);
                fac.autoSaveInterval = undefined;
            }
        }

        function initAutoSave(funcionGuardar, enviado) {
            fac.guardar = angular.isFunction(funcionGuardar)? funcionGuardar: function(x,y){};  // eslint-disable-line no-unused-vars
            if(angular.isUndefined(fac.autoSaveInterval)){
                // la funcion interval se activara cada 10 minutos--> 10*60 = 600, tiempo en miliseconds 600*1000=600000
                fac.autoSaveInterval = $interval(function () {
                    fac.guardar(false, true);
                }, 600000); //
            }
            if(enviado) stopAutoSave();
            refreshToken();
        }

        /*
            Funcion logout que limpia la session de usuario y redirecciona a la vista login
            se activa cuando el tiempo de expiracion es igual a 0 o menor
        */
        function logout (sw_inactive) {
            fac.stopInterval();
            if(sw_inactive) Message.warning('Su sesión ha sido cerrada automáticamente después de ' + getExpirationTime() + ' minutos, tiempo que dura la sesión.', null, 0);
            $auth.logout()
            .then(function() {
                $location.path("login");
                $mdDialog.hide();
            });
        }

        function refreshToken() {
            if(angular.isDefined(fac.interval)){
                DataService.get(restUrl+'refrescar')
                .then(function (respuesta) {
                    if(angular.isDefined(respuesta)){
                        $auth.setToken(respuesta.token);
                        fac.time = getExpirationTime()*60;
                    }
                })
            }
        }

    }
})();

/* eslint-disable no-unused-vars */
(function() {
'use strict'

angular
.module('app')
.factory('Documento', DocumentoFactory);

/** @ngInject */
function DocumentoFactory(DataService, restUrl, backUrl, Datetime, UtilFormly, Modal, $window, $location, Storage, $log) {

    var factory = {
        showPdfId: showPdfId,
        showPdf: showPdf,
        showPdfx: showPdfx,
        showProgress: showProgress,
        showProgressAll: showProgressAll,
        generarAbreviacion: generarAbreviacion,
        isMobile: isMobile
    }

    var detalleAdjuntos;

    return factory;

    function generarAbreviacion(cadena) {
        cadena = cadena.replace(/[^a-zA-Z ]/g, "");
        var str = cadena.toUpperCase();
        var res = str.split(" ");
        var abreviacion = "";
        for (var i = 0; i < res.length; i++) {
            if(res[i] !== "DE" && res[i] !== "PARA" && res[i] !== "Y" && res[i] !== "LA") {
                if (angular.isDefined(res[i][0])) {
                    abreviacion = abreviacion + res[i][0];
                }
            }
        }
        return abreviacion;
    }


    function showPdfx(nombre) {
        var datosEnviar = { nombre:nombre, html:'<p>Este es un documento externo, no puede transformarse en texto.</p>' };
        var new_url =  $location.absUrl();
        datosEnviar.esDocumentoExterno = true;
        new_url = new_url.substring(0, new_url.indexOf('#/')+2);
        Storage.setSession('datos_enviar', datosEnviar);
        $window.open(new_url+'vista_pdf');
    }


    /**
      Funcion que descarga un documento y lo muestra en pdf
      @param {Integer} id_documento Id de documento
    */
    function showPdfId(id_documento, sw_url) {
        DataService.get(restUrl + 'plantillasFormly/documento/'+id_documento)
        .then(function (respuesta) {
            showPdf(respuesta.datos.plantilla, respuesta.datos.plantilla_valor, respuesta.datos.nombre, sw_url, id_documento);
        });
    }


    /**
      Funcion que muestra pdf de documento
      @param {String} plantilla Cadena de json que contiene la estructura de un documento
      @param {String} plantilla_valor Valores de los campos del documento
      @param {String} nombre Nombre del documento
    */
    function showPdf(plantilla, plantilla_valor, nombre, sw_url,id_documento) {
        var abrirDialogPDF = (angular.isUndefined(sw_url))? true : sw_url;
        var datosEnviar = {doc:{}};
        datosEnviar.model_actual = angular.fromJson(plantilla_valor);
        var model = datosEnviar.model_actual;
        if( model["cite-0"] && model["cite-0"]["fecha"] )
            model["cite-0"]["fecha"] = Datetime.format(model["cite-0"]["fecha"], 'dd de MMM de YYYY');
        datosEnviar.form_actual = UtilFormly.dataToView(angular.fromJson(plantilla), model);
        datosEnviar.doc.nombre = nombre;
        datosEnviar.doc.plantilla = plantilla;
        DataService.post(restUrl+ "plantillasFormly/generarDocumento/",datosEnviar)
        .then(function(respuesta){
            datosEnviar = { html: respuesta.datos.html, nombre: respuesta.datos.nombre};
            datosEnviar.esDispositivoMovil = factory.isMobile();
            if(abrirDialogPDF){
                //abrimos dialogPDF
                DataService.pdf(restUrl+'plantillasFormly/documentoPDF/',{cite: datosEnviar.nombre})
                .then(function (respuestaPdf) {
                  if(!respuestaPdf) return;
                    datosEnviar.pdf = respuestaPdf.url;
                    datosEnviar.pdf_buffer = respuestaPdf.data;
                    if(id_documento !== null && id_documento) {
                      $log.log("Obteniendo firmas");
                      return DataService.get(restUrl +'documento/firmado/'+id_documento);
                    }

                })
                .then(function (firmas) {
                  if(firmas) datosEnviar.firmas = firmas.datos || [];
                  var config = {
                    data: datosEnviar,
                    templateUrl: 'app/factories/Documento/dialogPDF.html',
                    controller: ['data', '$scope', '$mdDialog', 'Util', DialogPDFController]
                  };
                  Modal.show(config);
                });
            }else {
                var new_url =  $location.absUrl();
                new_url = new_url.substring(0, new_url.indexOf('#/')+2);
                Storage.setSession('datos_enviar', datosEnviar);
                $window.open(new_url+'vista_pdf');
            }
        });
    }

    function isMobile() { return angular.isDefined($window.orientation)
        || navigator.userAgent.match(/Android/i)
        || navigator.userAgent.match(/webOS/i)
        || navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/iPad/i)
        || navigator.userAgent.match(/iPod/i)
        || navigator.userAgent.match(/BlackBerry/i)
        || navigator.userAgent.match(/Windows Phone/i)
    }

    /**
      Funcion que muestra pdf de documento
      @param {Objeto} data Objeto que tiene valores que llegan de la configuracion
      @param {Objeto} scope Scope del controlador
      @param {Objeto} mdDialog mdDialog usado para cerrar el modal
    */
    function DialogPDFController(data, $scope, $mdDialog, Util){
    //   $log.log("CHECK DATA ", data);
        var vmd = $scope;
        vmd.data={};
        vmd.data.html=data.html;
        vmd.data.pdf=data.pdf;
        vmd.data.flag_html=true;
        vmd.data.firmas=data.firmas || [];
        vmd.data.show_pdf=!data.esDispositivoMovil;
        if (data.esDispositivoMovil) {
            Util.loadCanvas(data.pdf_buffer, '#canvasContainer');
        }

        //funciones
        vmd.mostrarPdf = function (id, sw){ if(sw) showPdfx(id); else showPdfId(id, false); }
        vmd.cerrar = function (){ $mdDialog.cancel(); }
        vmd.verHtml = function(){ vmd.data.flag_html=true; }
        vmd.verPdf = function(){ vmd.data.flag_html=false; }

    }


    /**
      Funcion que muestra el historial del flujo del documento
      @param {Evento} ev Evento que se activa al hacer click
      @param {Integer} id_doc Id del documento
    */
    function showProgress(ev, id_doc){
        DataService.get(restUrl + 'historialFlujo/'+id_doc)
        .then(function (respuesta) {
            if(respuesta){
                setAttrs(respuesta.datos);
                var config = {
                    event: ev,
                    data: { id: id_doc, datos: respuesta.datos },
                    templateUrl: 'app/factories/Documento/dialog.progreso.html',
                    controller: ['$scope','$mdDialog', 'data', DialogProgreso]
                };
                Modal.show(config);
            }
        });


    }
    function setAttrs(arr, total) {
        arr.forEach(function (it) {
            it.fecha_mos = Datetime.dateLiteral(it._fecha_creacion);
            it.hora_mos = Datetime.time(it._fecha_creacion);
            switch (it.accion) {
                case 'ENVIADO':
                it.acc = 'Envió';
                it.icon = 'send';
                it.bg_color = 'envio';
                break;
                case 'APROBADO':
                it.acc = 'Aprobó';
                it.icon = 'done_all';
                it.bg_color = 'success';
                break;
                case 'RECHAZADO':
                it.acc = 'Observó';
                it.icon = 'error';
                it.bg_color = 'danger';
                it.observacion = it.observacion.substring(it.observacion.indexOf('Observaciones:'), it.observacion.length);
                break;
                case 'DERIVADO':
                it.acc = 'Derivó';
                it.icon = 'trending_down';
                it.bg_color = 'envio';
                break;
                case 'CERRADO':
                it.acc = 'Cerró';
                it.icon = 'assignment_turned_in';
                it.bg_color = 'warning';
                break;
                case 'CREADO':
                it.acc = 'Respondió';
                it.icon = 'undo';
                it.bg_color = 'success';
                break;
                case 'ELIMINADO':
                it.acc = 'Eliminó';
                it.icon = 'clear';
                it.bg_color = 'danger';
                break;
                case 'FIRMO':
                it.acc = 'Firmó';
                it.icon = 'fingerprint';
                it.bg_color = 'firmo';
                break;
                case 'ANULADO':
                it.acc = 'Anuló';
                it.icon = 'cancel';
                it.bg_color = 'danger';
                break;
                case 'APROBADO_CD':
                it.acc = 'Aprobó con ciudadanía digital';
                it.icon = 'fingerprint';
                it.bg_color = 'firmo';
                break;
                default:
                it.acc = 'Sin respuesta';
                it.icon = 'visibility';
                it.bg_color = 'bold';
            }
        });
    }

    function showProgressAll(ev, id_doc){
        DataService.get(restUrl + 'historialFlujo/'+id_doc+'/proceso')
        .then(function (respuesta) {
            if(respuesta){
                setAttrs(respuesta.datos);
                var config = {
                    event: ev,
                    data: { id: id_doc, datos: respuesta.datos },
                    templateUrl: 'app/factories/Documento/dialog.progreso.html',
                    controller: ['$scope','$mdDialog', 'data', 'moment', DialogProgreso]
                };
                Modal.show(config);
            }
        });
    }

    function DialogProgreso( $scope, $mdDialog, data, moment) {
        var vmd = $scope;
        vmd.data = data;
        vmd.mostrarContenido = false;
        vmd.adjuntos = [];
        vmd.titleModal = "Progreso del documento";

        //funciones
        vmd.cerrar = cerrar;
        vmd.verDocumento = verDocumento;
        vmd.mostrarHistorial = mostrarHistorial;
        vmd.verHistorial = verHistorial;
        vmd.getDate = getDate;

        function cerrar(){ $mdDialog.cancel(); }
        function verDocumento(id_doc) { showPdfId(id_doc, false); }

        function mostrarHistorial(id_historial_flujo) {
            vmd.mostrarContenido = true;
            vmd.titleModal = "Detalle de documentos adjuntos aprobados";

            DataService.get(restUrl+'documento/adjuntos?id='+id_historial_flujo)
            .then(function(response) {
                vmd.adjuntos = response.datos.resultado.adjunto_aprobacion_cd;
                vmd.adjuntos.forEach(function (it) {
                    var fecha = moment(it.solicitud_aprobacion_cd[0].fecha, 'DD/MM/YYYY HH:mm:ss').format();
                    it.fecha_mos = Datetime.dateLiteral(fecha);
                    it.hora_mos = Datetime.times(fecha);
                });
            })
            
        }

        function getDate(valor) {
            var fecha = new Date(valor.substring(1, valor.length-4));
            return fecha;
        }

        function verHistorial(valor) {
            vmd.titleModal = "Progreso del documento";
            vmd.mostrarContenido = valor;
        }
    
    }


}

})();

(function() {
    'use strict'

    angular
    .module('app')
    .factory('Datetime', ['Util', 'ArrayUtil', DatetimeFactory])
    .factory('ArrayUtil', ArrayUtilFactory);

    function ArrayUtilFactory() {
        var factory = {
            replace: replace,
            insert: insert,
            mover: mover,
            buscarObj: buscarObj
        };

        function replace (text, find, replace) {
            for (var i = 0, l = find.length, regex; i < l; i++) {
                regex = new RegExp(find[i], "g");
                text = text.replace(regex, replace[i]);
            }
            return text;
        }

        /**
            Funcion que mueve un item de un array al mismo array o a un segundo array
            @param {Array} arr Primer array del que se sacara el item
            @param {Integer} fromIndex Indice del item que se sacara del primer array
            @param {Integer} toIndex Indice del lugar en el que se pusheara en el segundo arraysi esta definido
            @param {Array} arr2 Segundo array en el que se pusheara si esta definido
        */
        function mover (arr, fromIndex, toIndex, arr2) {
            var item = arr[fromIndex];
            arr.splice(fromIndex, 1);
            if(angular.isDefined(arr2))
                arr2.splice(toIndex, 0, item);
            else
                arr.splice(toIndex, 0, item);
        }

        /**
            Funcion que inserta un item a un array en una posicion
            @param {Array} arr Array en el que se pusheara el item
            @param {Integer} toIndex Indice del lugar en el que se pusheara el item
            @param {Generico} item ELemento que se pusheara al array
        */
        function insert (arr, toIndex, item) {
            arr.splice(toIndex, 0, item);
        }

        /**
            Funcion que busca un objeto en un array
            @param {Array} arr Array que tiene objetos
            @param {string} attr Atributo de un objeto del array
            @param {string} val Valor con el que se comparara
            @param {Boolean} sw_obj True la funcion devuelve el objeto encontrado, false|undefined la funcion devuelve true si encuentra el objeto
        */
        function buscarObj(arr, attrib, val, sw_obj) {
            for (var i = 0; i < arr.length; i++)
                if(arr[i][attrib] == val) return (sw_obj)? arr[i] : true;
                
            return (sw_obj)? null : false;
        }

        return factory;
    }


    /** @ngInject */
    function DatetimeFactory(Util, ArrayUtil) {

        var formatDate = 'dd/MM/YYYY',
        months = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
        days = ["dom", "lun", "mar", "mié" , "jue", "vie" , "sáb"],
        dayslong = ["Domingo", "Lunes", "Martes", "Miércoles" , "Jueves", "Viernes" , "Sábado"];

        var factory = {
            isDate: isDate,
            isValid: isValid,
            isLessThan: isLessThan,
            isLessThanDays: isLessThanDays,
            isGreaterThan: isGreaterThan,
            isGreaterThanDays: isGreaterThanDays,
            addDays: addDays,
            subtractDays: subtractDays,
            diff: diff,
            milliseconds: milliseconds,
            convert: convert,
            setFormatDate: setFormatDate,
            now: now,
            dateLiteral: dateLiteral,
            time: time,
            times: times,
            timeLiteral: timeLiteral,
            datetimeLiteral: datetimeLiteral,
            format: format,
            getSeconds: getSeconds,
            standar: standar,
            replace: replace,
            last: last,
            secondsBetweenTwoDates: secondsBetweenTwoDates,
            minutesBetweenTwoDates: minutesBetweenTwoDates,
            hoursBetweenTwoDates: hoursBetweenTwoDates,
            daysBetweenTwoDates: daysBetweenTwoDates,
            betweenTwoDates: betweenTwoDates,
            isYesterday: isYesterday,
            parseDate: parseDate,
            parseDateDjango: parseDateDjango,
            dateMonth: dateMonth,
            parse : parse,
            formatDate: formatDate,
            months: months,
            days: days,
            getPrevDateMonth: getPrevDateMonth,
            date: date,
            dayslong: dayslong
        }

        return factory;

        function date(pDate, separator) {
            var date = pDate[0].split(separator || '-');
            // var date = pDate[i].split(separator || '-'); // TODO: verificar el indice correcto. cual es el reemplazo para "i"??.
            return new Date(date[0],date[1]-1,date[2]);
        }

        function parse(date, separator) {
            return [date.getFullYear(), date.getMonth()+1, date.getDate()].join(separator || '-');
        }

        function dateMonth() {
            var date = new Date();
            return new Date(date.getFullYear(), date.getMonth(), 1);
        }

        function getPrevDateMonth(data) {
            data = data || 1;
            var date = new Date();
            var day = date.getDate();
            var month = date.getMonth()
            var year = date.getFullYear();

            if (day < data) {
                month--;
                if (month < 0) {
                    month = 11;
                    year--;
                }
            }
            return new Date(year, month, data);
        }

        function isDate (date) {
            if (Util.toType(date) == 'string') {
                date = convert(date);
            }
            return isValid(date);
        }

        function isValid (date) {
            if (Util.toType(date) != 'date')
                return false;
            return !isNaN(date.getTime());
        }

        function isLessThan (date) {
            return milliseconds(date) < (new Date()).getTime();
        }

        function isLessThanDays (date, data) {
            return milliseconds(date) > subtractDays(new Date(), data);
        }

        function isGreaterThan (date) {
            return milliseconds(date) > (new Date()).getTime();
        }

        function isGreaterThanDays (date, data) {
            return milliseconds(date) < addDays(new Date(), data);
        }

        function addDays (date, days) {
            return milliseconds(date) + (days || 0)*24*60*60*1000;
        }

        function subtractDays (date, days) {
            return milliseconds(date) - (days || 0)*24*60*60*1000;
        }

        function diff (date2, date1) {
            return milliseconds(date2) - milliseconds(date1);
        }

        function milliseconds (date) {
            if (Util.toType(date) == 'string') {
                date = convert(date);
            }
            return date.getTime();
        }

        function convert (date) {
            date = date.split('/');
            return formatDate == 'dd/MM/YYYY' ? new Date(date[2], date[1]-1, date[0]) :
            formatDate == 'MM/dd/YYYY' ? new Date(date[2], date[0]-1, date[1]) :
            new Date(date[0], date[1]-1, date[2]);
        }

        function setFormatDate (format) {
            formatDate = format;
        }

        function now (format) {
            return replace(new Date(), format || formatDate);
        }

        function dateLiteral (date) {
            return format(date, 'dd de MMM del YYYY');
        }

        function time (date) {
            return format(date, 'HH:mm');
        }

        function times (date) {
            return format(date, 'HH:mm:ss');
        }

        function timeLiteral(time, txt) {
            var text = '';
            if (typeof time == 'number') {
                if (time == 0) {
                    return '';
                }
                if (time < 60) {
                    text = time + 's';
                } else if (time < 3600) {
                    text = Math.floor(time / 60) + 'm ' + (time % 60 > 0 ? (time % 60 + 's') : '');
                } else {
                    text = Math.floor(time / 3600) + 'h ' + (time % 3600 > 0 ? (Math.floor(time / 60) + 'm ') : '') + (time % 60 > 0 ? (time % 60 + 's') : '');
                }
                return (txt || '') + text;
            } else {
                if (time.length == 0) {
                    return '';
                }
                time = time.split(':');
                var hours = time[0],
                    minutes = time[1];

                if (parseInt(hours) > 0) {
                    text += parseInt(hours) + 'h ';
                }
                if (parseInt(minutes) > 0) {
                    text += parseInt(minutes) + 'm ';
                }
                if (time.length == 3 && parseInt(time[2]) > 0) {
                    text += parseInt(time[2]) + 's' ;
                }

                return (txt || '') + text;
            }
        }

        function getSeconds(time) {
            time = time.split(':');
            var hours = time[0],
                minutes = time[1],
                total = 0;

            if (parseInt(hours) > 0) {
                total += parseInt(hours)*3600;
            }
            if (parseInt(minutes) > 0) {
                total += parseInt(minutes)*60;
            }
            if (time.length == 3 && parseInt(time[2]) > 0) {
                total += parseInt(time[2]);
            }

            return total;
        }

        function datetimeLiteral (date) {
            return format(date, 'dddd dd de MMM del YYYY a la(s) HH:mm');
        }

        function format (date, format) {
            var d = new Date(date);
            if (isDate(d)) {
                return replace(d, format || formatDate);
            }
            return date;
        }

        function standar (date, format) {
            var type = Util.toType(date);
            if (type == 'date') {
                return date;
            }
            if (type == 'string') {
                format = format || formatDate;
                var separator = date.indexOf('/') != -1 ? '/' : '-';
                date = date.split(separator);
                if (format == 'dd/MM/YYYY' || format == 'dd-MM-YYYY') {
                    date = date[1] + separator + date[0] + separator + date[2];
                }
                if (format == 'YYYY/dd/MM' || format == 'YYYY-dd-MM') {
                    date = date[0] + separator + date[1] + separator + date[0];
                }
            }
            return new Date(date);
        }

        function replace (date, format) {
            format = format || formatDate;
            date = standar(date, format);
            var monthLiteral = format.indexOf('MMM') != -1;
            return ArrayUtil.replace(format, [
                "dddd", "ddd", "dd", monthLiteral ? 'MMM' : 'MM', 'YYYY', 'HH', 'mm', 'ss'
            ], [
                dayslong[date.getDay()],
                days[date.getDay()],
                (date.getDate() < 10 ? '0' : '') + date.getDate(),
                monthLiteral ? months[date.getMonth()] : ((date.getMonth() + 1 < 10 ? '0' : '') + (date.getMonth() + 1)),
                date.getFullYear(),
                (date.getHours() < 10 ? '0' : '') + date.getHours(),
                (date.getMinutes() < 10 ? '0' : '') + date.getMinutes(),
                (date.getSeconds() < 10 ? '0' : '') + date.getSeconds()
            ]);
        }

        function last (date) {
            var now = new Date();
            var days = daysBetweenTwoDates(date, now);
            if (days > 31) {
                return dateLiteral(date);
            } else {
                if (days > 7) {
                    var weeks = parseInt(days / 7);
                    return 'Hace ' + weeks + ' semana' + (weeks > 1 ? 's' : '');
                } else {
                    if (days >= 1) {
                        return format(date, 'ddd a la(s) HH:mm');
                    } else {
                        var hours = hoursBetweenTwoDates(date, now);
                        if (isYesterday(date, hours)) {
                            return 'Ayer a la(s) ' + time(date);
                        } else {
                            if (hours >= 1) {
                                return 'Hace ' + hours + ' hora' + (hours > 1 ? 's' : '');
                            } else {
                                var minutes = minutesBetweenTwoDates(date, now);
                                if (minutes >= 1) {
                                    return 'Hace ' + minutes + ' minuto' + (minutes > 1 ? 's' : '');
                                } else {
                                    var seconds = secondsBetweenTwoDates(date, now);
                                    return 'Hace ' + seconds + ' segundo' + (seconds > 1 ? 's' : '');
                                }
                            }
                        }
                    }
                }
            }
        }

        function secondsBetweenTwoDates (date1, date2, absolute) {
            return betweenTwoDates(date1, date2, "s", absolute);
        }

        function minutesBetweenTwoDates (date1, date2, absolute) {
            return betweenTwoDates(date1, date2, "i", absolute);
        }

        function hoursBetweenTwoDates (date1, date2, absolute) {
            return betweenTwoDates(date1, date2, "h", absolute);
        }

        function daysBetweenTwoDates (date1, date2, absolute) {
            return betweenTwoDates(date1, date2, "d", absolute);
        }

        function betweenTwoDates (date1, date2, type, absolute) {
            var types = {s : 1000, i : 60*1000, h : 60*60*1000, d : 24*60*60*1000};
            var diff = parseInt((standar(date2).getTime() - standar(date1).getTime())/types[type]);

            if (typeof absolute !== 'undefined' && absolute !== false) {
                return Math.abs(diff);
            }
            return diff;
        }

        function isYesterday (date, hours) {
            if (isDate(date)) {
                date = date.split(' ');
                var time = date[1].split(':');
                return hours >= parseInt(time[0]);
            }
            return false;
        }

        function parseDate(date) {
            return [date.getDate(), date.getMonth() + 1, date.getFullYear()].join('/')
        }

        function parseDateDjango(date) {
            return [date.getFullYear(),date.getMonth()+1,date.getDate()].join('-');
        }

    }
})();

(function () {
  'use strict'

  angular
  .module('app')
  .factory('Catalogo', CatalogoFactory);

  /** @ngInject */
  function CatalogoFactory(DataService, restUrl, Modal, Datetime) {
    var factory = {
      showHistory: showHistory
    };
    
    return factory;

    function showHistory(ev, id) {
      DataService.get(restUrl + 'historialCatalogo/' + id)
      .then(function (resp) {
        if (resp) {
          var datos = procesarData(resp.datos.catalogos, resp.datos.usuarios, resp.datos.documentos);
          var config = {
            event: ev,
            data: {id: id, catalogos: datos },
            templateUrl: 'app/factories/Catalogo/dialog.historial.html',
            controller: ['data', '$scope', '$mdDialog', '$log', DialogHistorial]
          };
          return Modal.show(config);
        }
      });
    }

    function DialogHistorial(data, $scope, $mdDialog) {
      var vmd = $scope;
      vmd.data = data;
      vmd.catalogos = vmd.data.catalogos
      vmd.cerrar = cerrar;
      function cerrar() {
        $mdDialog.cancel();
      }
    }

    function procesarData(catalogos, usuarios, documentos){
      var respuesta = [];
      catalogos.forEach(function (item)  {
        var objTemp = {
          fecha: Datetime.dateLiteral(item._fecha_creacion),
          hora: Datetime.time(item._fecha_creacion),
          autor: usuarios[item._usuario_creacion],
          accion: item.accion
        };
        if (item.datos.fid_usuario) {
          objTemp.tipo = 'USUARIO';
          objTemp.autor = usuarios[item._usuario_creacion]
          objTemp.datos = [
            { 
              campo: "Usuario", 
              valor: usuarios[item.datos.fid_usuario]
            },
            {
              campo: "¿Esta activo?",
              valor: item.datos.estado == "ACTIVO" ? "Sí" : "No"
            },
            {
              campo: "¿Puede ver el catálogo?",
              valor: item.datos.lectura ? "Sí" : "No"
            },
            {
              campo: "¿Puede ver el catálogo?",
              valor: item.datos.escritura ? "Sí" : "No"
            }
          ];

        }
        else if (item.datos.id_catalogo) {
          objTemp.tipo = 'CATALOGO';
          objTemp.nombreCatalogo = item.datos.nombre;
          objTemp.datos = [];
          // objTemp.autor = usuarios[item._usuario_creacion];

          if (item.datos.propietario) {
            objTemp.datos.push({campo:'Propietario', valor: usuarios[item.datos.propietario]})
          }
          if (item.datos.nombre) {
            objTemp.datos.push({campo:'Nombre', valor: item.datos.nombre})
          }
          if (item.datos.comentario) {
            objTemp.datos.push({campo:'Comentario', valor: item.datos.comentario})
          }
          if (item.datos.descripcion) {
            objTemp.datos.push({campo:'Descripción', valor: item.datos.descripcion})
          }
        }
        else if (item.datos.fid_documento) {
          objTemp.tipo = 'DOCUMENTO';
          objTemp.datos = [
            {
              campo: "Documento",
              valor: documentos[item.datos.fid_documento]
            },
            {
              campo: "¿Esta activo?",
              valor: item.datos.estado == "ACTIVO" ? "Sí" : "No"
            },
            {
              campo: "Descripción",
              valor: item.datos.descripcion
            }
          ];
        }
        respuesta.push(objTemp);
      });

      return respuesta;
    }
  }

})();

(function() {
    'use strict'

    angular
    .module('app')
    .factory('AuthInterceptor', AuthInterceptor)
    .config(function($httpProvider) {
        $httpProvider.interceptors.push('AuthInterceptor');
    });

    /** @ngInject */
    function AuthInterceptor($q, $location, $injector) {

        var interceptor = {
            request: function(config) {
                angular.element('#loading-progress').show();
                return config;
            },
            requestError: function(config) {
                angular.element('#loading-progress').hide();
                return config;
            },
            response: function(response){
                angular.element('#loading-progress').hide();
                return response || $q.when(response);
            },
            responseError: function(rejection) {
                if (rejection.status === 401 || rejection.status === 403) {
                    // en estos estados se deslogue y va a login
                    var Storage = $injector.get('Storage');
                    var ExpirationTime = $injector.get('ExpirationTime');

                    Storage.setSession('path', $location.path());
                    ExpirationTime.logout();
                }
                return $q.reject(rejection);
            }
        };

        /*eslint-disable no-unused-vars*/
        function exist(path) {
          /*eslint-enable no-unused-vars*/
            var paths = $injector.get('PageNoLogin');
            for (var i in paths) {
                if (path.indexOf('/' + paths[i]) != -1 || path.indexOf('/' + paths[i] + '/') != -1) {
                    return true;
                }
            }
            return false;
        }


        return interceptor;
    }

})();

(function() {
    'use strict'

    angular
    .module('app')
    .directive('tooltip', ['DataService', 'restUrl', linkTooltipController])


    function linkTooltipController(DataService, restUrl){

        var directive = {
            scope: {
                doc: '='
            },
            restrict: 'E',
            link: function (sc, elm, attrs, controller) { // eslint-disable-line no-unused-vars
                elm.hide();
                DataService.get(restUrl+'plantillasFormly/documento/'+sc.doc.id_documento+'/info')
                .then(function (respuesta) {
                    if(respuesta){
                        var $td = elm.parent().parent().parent().parent().parent().parent().parent();
                        $td.append(createTooltip(respuesta.datos));
                        var $card = $td.children('md-card');
                        $card.hide();
                        elm.parent().mouseover(function () {
                            $card.show();
                            elm.parent().css('cursor','pointer');
                        })
                        elm.parent().mouseout(function () {
                            $card.hide();
                            elm.parent().css('cursor','normal');
                        })
                    }

                })
            }
        };
        function createTooltip(html) {
            var new_html = '';
            new_html += '<md-card class="ap-tooltip"><md-card-content>';
            new_html += html;
            new_html += '</md-card-content></md-card>';
            return new_html;
        }

        return directive;
    }

  })();

(function() {
    'use strict'

    angular
    .module('app')
    .component('visorImagenes', {
        templateUrl : 'app/components/visorImagenes/visorImagenes.html',
        controller : ['$scope', 'restUrl', 'DataService', 'Storage', 'FileUploader','Modal', VisorImagenesController],
        controllerAs: 'vm',
        bindings: {
            titulo: '=', 
            imagenes: '=', // Lista de archivos subidos
            ancho: '=',
            alto: '=',            
            eliminar: '=',
            imagenesEliminar: '='            
        }
    });

    function VisorImagenesController($scope, restUrl, DataService, Storage, FileUploader,Modal) {

        var vm = this;
        vm.restUrl = restUrl;
   
        // Funcion que elimina una imagen   
        vm.eliminarImagen = function(pArchivo){
          // Despliega el modal de confirmacion para eliminar un elemento.
          Modal.confirm('Se eliminará la foto, ¿Está seguro/a?.', function () {
            var indice=vm.imagenes.indexOf(pArchivo);

            // Si el elemento existe dentro del vector.
            if (indice > -1) {
              // Elimina el elemento, basado en su indice.
              vm.imagenes.splice(indice, 1);
              // Agrega el item eliminado a un vector.
              vm.imagenesEliminar.push(pArchivo);
            }

          });

        }
        
        vm.mostrarImagen = function (ruta) {
            var config = {                
                data: ruta,
                templateUrl: 'app/components/visorImagenes/visorImagenes.dialog.html',
                controller: ['data', '$scope', '$mdDialog', DialogImagenController]
            };
            Modal.show(config);           
        }
               
        function DialogImagenController(data, $scope, $mdDialog) {
            var vmd = $scope;
            vmd.cerrar = cerrar;

            vmd.data = data ? data : {};

            // Funcion que cierra el modal.
            function cerrar() {
                $mdDialog.hide();
            }
        }


    } //Fin del controller


  })();

/* eslint-disable */
/*!
* Simditor v2.3.6
* http://simditor.tower.im/
* 2015-12-21
*/
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    define('simditor', ["jquery","simple-module","simple-hotkeys","simple-uploader"], function ($, SimpleModule, simpleHotkeys, simpleUploader) {
      return (root['Simditor'] = factory($, SimpleModule, simpleHotkeys, simpleUploader));
    });
  } else if (typeof exports === 'object') {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory(require("jquery"),require("simple-module"),require("simple-hotkeys"),require("simple-uploader"));
  } else {
    root['Simditor'] = factory(jQuery,SimpleModule,simple.hotkeys,simple.uploader);
  }
}(this, function ($, SimpleModule, simpleHotkeys, simpleUploader) {

var AlignmentButton, BlockquoteButton, BoldButton, Button, Clipboard, CodeButton, CodePopover, ColorButton, FontScaleButton, Formatter, HrButton, ImageButton, ImagePopover, IndentButton, Indentation, InputManager, ItalicButton, Keystroke, LinkButton, LinkPopover, ListButton, OrderListButton, OutdentButton, Popover, Selection, Simditor, StrikethroughButton, TableButton, TitleButton, Toolbar, UnderlineButton, UndoManager, UnorderListButton, Util,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; },
  slice = [].slice;

Selection = (function(superClass) {
  extend(Selection, superClass);

  function Selection() {
    return Selection.__super__.constructor.apply(this, arguments);
  }

  Selection.pluginName = 'Selection';

  Selection.prototype._range = null;

  Selection.prototype._startNodes = null;

  Selection.prototype._endNodes = null;

  Selection.prototype._containerNode = null;

  Selection.prototype._nodes = null;

  Selection.prototype._blockNodes = null;

  Selection.prototype._rootNodes = null;

  Selection.prototype._init = function() {
    this.editor = this._module;
    this._selection = document.getSelection();
    this.editor.on('selectionchanged', (function(_this) {
      return function(e) {
        _this.reset();
        return _this._range = _this._selection.getRangeAt(0);
      };
    })(this));
    return this.editor.on('blur', (function(_this) {
      return function(e) {
        return _this.reset();
      };
    })(this));
  };

  Selection.prototype.reset = function() {
    this._range = null;
    this._startNodes = null;
    this._endNodes = null;
    this._containerNode = null;
    this._nodes = null;
    this._blockNodes = null;
    return this._rootNodes = null;
  };

  Selection.prototype.clear = function() {
    var e;
    try {
      this._selection.removeAllRanges();
    } catch (_error) {
      e = _error;
    }
    return this.reset();
  };

  Selection.prototype.range = function(range) {
    var ffOrIE;
    if (range) {
      this.clear();
      this._selection.addRange(range);
      this._range = range;
      ffOrIE = this.editor.util.browser.firefox || this.editor.util.browser.msie;
      if (!this.editor.inputManager.focused && ffOrIE) {
        this.editor.body.focus();
      }
    } else if (!this._range && this.editor.inputManager.focused && this._selection.rangeCount) {
      this._range = this._selection.getRangeAt(0);
    }
    return this._range;
  };

  Selection.prototype.startNodes = function() {
    if (this._range) {
      this._startNodes || (this._startNodes = (function(_this) {
        return function() {
          var startNodes;
          startNodes = $(_this._range.startContainer).parentsUntil(_this.editor.body).get();
          startNodes.unshift(_this._range.startContainer);
          return $(startNodes);
        };
      })(this)());
    }
    return this._startNodes;
  };

  Selection.prototype.endNodes = function() {
    var endNodes;
    if (this._range) {
      this._endNodes || (this._endNodes = this._range.collapsed ? this.startNodes() : (endNodes = $(this._range.endContainer).parentsUntil(this.editor.body).get(), endNodes.unshift(this._range.endContainer), $(endNodes)));
    }
    return this._endNodes;
  };

  Selection.prototype.containerNode = function() {
    if (this._range) {
      this._containerNode || (this._containerNode = $(this._range.commonAncestorContainer));
    }
    return this._containerNode;
  };

  Selection.prototype.nodes = function() {
    if (this._range) {
      this._nodes || (this._nodes = (function(_this) {
        return function() {
          var nodes;
          nodes = [];
          if (_this.startNodes().first().is(_this.endNodes().first())) {
            nodes = _this.startNodes().get();
          } else {
            _this.startNodes().each(function(i, node) {
              var $endNode, $node, $nodes, endIndex, index, sharedIndex, startIndex;
              $node = $(node);
              if (_this.endNodes().index($node) > -1) {
                return nodes.push(node);
              } else if ($node.parent().is(_this.editor.body) || (sharedIndex = _this.endNodes().index($node.parent())) > -1) {
                if (sharedIndex && sharedIndex > -1) {
                  $endNode = _this.endNodes().eq(sharedIndex - 1);
                } else {
                  $endNode = _this.endNodes().last();
                }
                $nodes = $node.parent().contents();
                startIndex = $nodes.index($node);
                endIndex = $nodes.index($endNode);
                return $.merge(nodes, $nodes.slice(startIndex, endIndex).get());
              } else {
                $nodes = $node.parent().contents();
                index = $nodes.index($node);
                return $.merge(nodes, $nodes.slice(index).get());
              }
            });
            _this.endNodes().each(function(i, node) {
              var $node, $nodes, index;
              $node = $(node);
              if ($node.parent().is(_this.editor.body) || _this.startNodes().index($node.parent()) > -1) {
                nodes.push(node);
                return false;
              } else {
                $nodes = $node.parent().contents();
                index = $nodes.index($node);
                return $.merge(nodes, $nodes.slice(0, index + 1));
              }
            });
          }
          return $($.unique(nodes));
        };
      })(this)());
    }
    return this._nodes;
  };

  Selection.prototype.blockNodes = function() {
    if (!this._range) {
      return;
    }
    this._blockNodes || (this._blockNodes = (function(_this) {
      return function() {
        return _this.nodes().filter(function(i, node) {
          return _this.editor.util.isBlockNode(node);
        });
      };
    })(this)());
    return this._blockNodes;
  };

  Selection.prototype.rootNodes = function() {
    if (!this._range) {
      return;
    }
    this._rootNodes || (this._rootNodes = (function(_this) {
      return function() {
        return _this.nodes().filter(function(i, node) {
          var $parent;
          $parent = $(node).parent();
          return $parent.is(_this.editor.body) || $parent.is('blockquote');
        });
      };
    })(this)());
    return this._rootNodes;
  };

  Selection.prototype.rangeAtEndOf = function(node, range) {
    var afterLastNode, beforeLastNode, endNode, endNodeLength, lastNodeIsBr, result;
    if (range == null) {
      range = this.range();
    }
    if (!(range && range.collapsed)) {
      return;
    }
    node = $(node)[0];
    endNode = range.endContainer;
    endNodeLength = this.editor.util.getNodeLength(endNode);
    beforeLastNode = range.endOffset === endNodeLength - 1;
    lastNodeIsBr = $(endNode).contents().last().is('br');
    afterLastNode = range.endOffset === endNodeLength;
    if (!((beforeLastNode && lastNodeIsBr) || afterLastNode)) {
      return false;
    }
    if (node === endNode) {
      return true;
    } else if (!$.contains(node, endNode)) {
      return false;
    }
    result = true;
    $(endNode).parentsUntil(node).addBack().each(function(i, n) {
      var $lastChild, beforeLastbr, isLastNode, nodes;
      nodes = $(n).parent().contents().filter(function() {
        return !(this !== n && this.nodeType === 3 && !this.nodeValue);
      });
      $lastChild = nodes.last();
      isLastNode = $lastChild.get(0) === n;
      beforeLastbr = $lastChild.is('br') && $lastChild.prev().get(0) === n;
      if (!(isLastNode || beforeLastbr)) {
        result = false;
        return false;
      }
    });
    return result;
  };

  Selection.prototype.rangeAtStartOf = function(node, range) {
    var result, startNode;
    if (range == null) {
      range = this.range();
    }
    if (!(range && range.collapsed)) {
      return;
    }
    node = $(node)[0];
    startNode = range.startContainer;
    if (range.startOffset !== 0) {
      return false;
    }
    if (node === startNode) {
      return true;
    } else if (!$.contains(node, startNode)) {
      return false;
    }
    result = true;
    $(startNode).parentsUntil(node).addBack().each(function(i, n) {
      var nodes;
      nodes = $(n).parent().contents().filter(function() {
        return !(this !== n && this.nodeType === 3 && !this.nodeValue);
      });
      if (nodes.first().get(0) !== n) {
        return result = false;
      }
    });
    return result;
  };

  Selection.prototype.insertNode = function(node, range) {
    if (range == null) {
      range = this.range();
    }
    if (!range) {
      return;
    }
    node = $(node)[0];
    range.insertNode(node);
    return this.setRangeAfter(node, range);
  };

  Selection.prototype.setRangeAfter = function(node, range) {
    if (range == null) {
      range = this.range();
    }
    if (range == null) {
      return;
    }
    node = $(node)[0];
    range.setEndAfter(node);
    range.collapse(false);
    return this.range(range);
  };

  Selection.prototype.setRangeBefore = function(node, range) {
    if (range == null) {
      range = this.range();
    }
    if (range == null) {
      return;
    }
    node = $(node)[0];
    range.setEndBefore(node);
    range.collapse(false);
    return this.range(range);
  };

  Selection.prototype.setRangeAtStartOf = function(node, range) {
    if (range == null) {
      range = this.range();
    }
    node = $(node).get(0);
    range.setEnd(node, 0);
    range.collapse(false);
    return this.range(range);
  };

  Selection.prototype.setRangeAtEndOf = function(node, range) {
    var $lastNode, $node, contents, lastChild, lastChildLength, lastText, nodeLength;
    if (range == null) {
      range = this.range();
    }
    $node = $(node);
    node = $node[0];
    if ($node.is('pre')) {
      contents = $node.contents();
      if (contents.length > 0) {
        lastChild = contents.last();
        lastText = lastChild.text();
        lastChildLength = this.editor.util.getNodeLength(lastChild[0]);
        if (lastText.charAt(lastText.length - 1) === '\n') {
          range.setEnd(lastChild[0], lastChildLength - 1);
        } else {
          range.setEnd(lastChild[0], lastChildLength);
        }
      } else {
        range.setEnd(node, 0);
      }
    } else {
      nodeLength = this.editor.util.getNodeLength(node);
      if (node.nodeType !== 3 && nodeLength > 0) {
        $lastNode = $(node).contents().last();
        if ($lastNode.is('br')) {
          nodeLength -= 1;
        } else if ($lastNode[0].nodeType !== 3 && this.editor.util.isEmptyNode($lastNode)) {
          $lastNode.append(this.editor.util.phBr);
          node = $lastNode[0];
          nodeLength = 0;
        }
      }
      range.setEnd(node, nodeLength);
    }
    range.collapse(false);
    return this.range(range);
  };

  Selection.prototype.deleteRangeContents = function(range) {
    var atEndOfBody, atStartOfBody, endRange, startRange;
    if (range == null) {
      range = this.range();
    }
    startRange = range.cloneRange();
    endRange = range.cloneRange();
    startRange.collapse(true);
    endRange.collapse(false);
    atStartOfBody = this.rangeAtStartOf(this.editor.body, startRange);
    atEndOfBody = this.rangeAtEndOf(this.editor.body, endRange);
    if (!range.collapsed && atStartOfBody && atEndOfBody) {
      this.editor.body.empty();
      range.setStart(this.editor.body[0], 0);
      range.collapse(true);
      this.range(range);
    } else {
      range.deleteContents();
    }
    return range;
  };

  Selection.prototype.breakBlockEl = function(el, range) {
    var $el;
    if (range == null) {
      range = this.range();
    }
    $el = $(el);
    if (!range.collapsed) {
      return $el;
    }
    range.setStartBefore($el.get(0));
    if (range.collapsed) {
      return $el;
    }
    return $el.before(range.extractContents());
  };

  Selection.prototype.save = function(range) {
    var endCaret, endRange, startCaret;
    if (range == null) {
      range = this.range();
    }
    if (this._selectionSaved) {
      return;
    }
    endRange = range.cloneRange();
    endRange.collapse(false);
    startCaret = $('<span/>').addClass('simditor-caret-start');
    endCaret = $('<span/>').addClass('simditor-caret-end');
    endRange.insertNode(endCaret[0]);
    range.insertNode(startCaret[0]);
    this.clear();
    return this._selectionSaved = true;
  };

  Selection.prototype.restore = function() {
    var endCaret, endContainer, endOffset, range, startCaret, startContainer, startOffset;
    if (!this._selectionSaved) {
      return false;
    }
    startCaret = this.editor.body.find('.simditor-caret-start');
    endCaret = this.editor.body.find('.simditor-caret-end');
    if (startCaret.length && endCaret.length) {
      startContainer = startCaret.parent();
      startOffset = startContainer.contents().index(startCaret);
      endContainer = endCaret.parent();
      endOffset = endContainer.contents().index(endCaret);
      if (startContainer[0] === endContainer[0]) {
        endOffset -= 1;
      }
      range = document.createRange();
      range.setStart(startContainer.get(0), startOffset);
      range.setEnd(endContainer.get(0), endOffset);
      startCaret.remove();
      endCaret.remove();
      this.range(range);
    } else {
      startCaret.remove();
      endCaret.remove();
    }
    this._selectionSaved = false;
    return range;
  };

  return Selection;

})(SimpleModule);

Formatter = (function(superClass) {
  extend(Formatter, superClass);

  function Formatter() {
    return Formatter.__super__.constructor.apply(this, arguments);
  }

  Formatter.pluginName = 'Formatter';

  Formatter.prototype.opts = {
    allowedTags: [],
    allowedAttributes: {},
    allowedStyles: {}
  };

  Formatter.prototype._init = function() {//mod-for-jl
    this.editor = this._module;
    this._allowedTags = $.merge(['br', 'span', 'a', 'img',' strong', 'strike', 'u', 'p', 'ol', 'li', 'blockquote', 'pre', 'code', 'h1', 'h2', 'h3', 'h4', 'hr'], this.opts.allowedTags);
    this._allowedAttributes = $.extend({
      img: ['src', 'alt', 'width', 'height', 'data-non-image'],
      a: ['href', 'target'],
      code: ['class']
    }, this.opts.allowedAttributes);
    this._allowedStyles = $.extend({
      p: ['margin-left', 'text-align'],
      h1: ['margin-left', 'text-align'],
      h2: ['margin-left', 'text-align'],
      h3: ['margin-left', 'text-align'],
      h4: ['margin-left', 'text-align']
    }, this.opts.allowedStyles);
    return this.editor.body.on('click', 'a', function(e) {
      return false;
    });
  };

  Formatter.prototype.decorate = function($el) {
    if ($el == null) {
      $el = this.editor.body;
    }
    this.editor.trigger('decorate', [$el]);
    return $el;
  };

  Formatter.prototype.undecorate = function($el) {
    if ($el == null) {
      $el = this.editor.body.clone();
    }
    this.editor.trigger('undecorate', [$el]);
    return $el;
  };

  Formatter.prototype.autolink = function($el) {
    var $link, $node, findLinkNode, k, lastIndex, len, linkNodes, match, re, replaceEls, subStr, text, uri;
    if ($el == null) {
      $el = this.editor.body;
    }
    linkNodes = [];
    findLinkNode = function($parentNode) {
      return $parentNode.contents().each(function(i, node) {
        var $node, text;
        $node = $(node);
        if ($node.is('a') || $node.closest('a, pre', $el).length) {
          return;
        }
        if (!$node.is('iframe') && $node.contents().length) {
          return findLinkNode($node);
        } else if ((text = $node.text()) && /https?:\/\/|www\./ig.test(text)) {
          return linkNodes.push($node);
        }
      });
    };
    findLinkNode($el);
    re = /(https?:\/\/|www\.)[\w\-\.\?&=\/#%:,@\!\+]+/ig;
    for (k = 0, len = linkNodes.length; k < len; k++) {
      $node = linkNodes[k];
      text = $node.text();
      replaceEls = [];
      match = null;
      lastIndex = 0;
      while ((match = re.exec(text)) !== null) {
        subStr = text.substring(lastIndex, match.index);
        replaceEls.push(document.createTextNode(subStr));
        lastIndex = re.lastIndex;
        uri = /^(http(s)?:\/\/|\/)/.test(match[0]) ? match[0] : 'http://' + match[0];
        $link = $("<a href=\"" + uri + "\" rel=\"nofollow\"></a>").text(match[0]);
        replaceEls.push($link[0]);
      }
      replaceEls.push(document.createTextNode(text.substring(lastIndex)));
      $node.replaceWith($(replaceEls));
    }
    return $el;
  };

  Formatter.prototype.format = function($el) {
    var $node, blockNode, k, l, len, len1, n, node, ref, ref1;
    if ($el == null) {
      $el = this.editor.body;
    }

    if ($el.is(':empty')) {
      $el.append('<p>' + this.editor.util.phBr + '</p>');
      return $el;
    }
    ref = $el.contents();
    for (k = 0, len = ref.length; k < len; k++) {
      n = ref[k];
      this.cleanNode(n, true);
    }
    ref1 = $el.contents();
    for (l = 0, len1 = ref1.length; l < len1; l++) {
      node = ref1[l];
      $node = $(node);
      if ($node.is('br')) {
        if (typeof blockNode !== "undefined" && blockNode !== null) {
          blockNode = null;
        }
        $node.remove();
      } else if (this.editor.util.isBlockNode(node)) {
        if ($node.is('li')) {
          if (blockNode && blockNode.is('ul, ol')) {
            blockNode.append(node);
          } else {
            blockNode = $('<ul/>').insertBefore(node);
            blockNode.append(node);
          }
        } else {
          blockNode = null;
        }
      } else {
        if (!blockNode || blockNode.is('ul, ol')) {
          blockNode = $('<p/>').insertBefore(node);
        }
        blockNode.append(node);
        if (this.editor.util.isEmptyNode(blockNode)) {
          blockNode.append(this.editor.util.phBr);
        }
      }
    }
    return $el;
  };

  Formatter.prototype.cleanNode = function(node, recursive) {
    var $blockEls, $childImg, $node, $p, $td, allowedAttributes, attr, contents, isDecoration, k, l, len, len1, n, ref, ref1, text, textNode;
    $node = $(node);
    if (!($node.length > 0)) {
      return;
    }
    if ($node[0].nodeType === 3) {
      text = $node.text().replace(/(\r\n|\n|\r)/gm, '');
      if (text) {
        textNode = document.createTextNode(text);
        $node.replaceWith(textNode);
      } else {
        $node.remove();
      }
      return;
    }
    contents = $node.is('iframe') ? null : $node.contents();
    isDecoration = this.editor.util.isDecoratedNode($node);
    if ($node.is(this._allowedTags.join(',')) || isDecoration) {
      if ($node.is('a') && ($childImg = $node.find('img')).length > 0) {
        $node.replaceWith($childImg);
        $node = $childImg;
        contents = null;
      }
      if ($node.is('td') && ($blockEls = $node.find(this.editor.util.blockNodes.join(','))).length > 0) {
        $blockEls.each((function(_this) {
          return function(i, blockEl) {
            return $(blockEl).contents().unwrap();
          };
        })(this));
        contents = $node.contents();
      }
      if ($node.is('img') && $node.hasClass('uploading')) {
        $node.remove();
      }
      if (!isDecoration) {
        allowedAttributes = this._allowedAttributes[$node[0].tagName.toLowerCase()];
        ref = $.makeArray($node[0].attributes);
        for (k = 0, len = ref.length; k < len; k++) {
          attr = ref[k];
          if (attr.name === 'style') {
            continue;
          }
          if (!((allowedAttributes != null) && (ref1 = attr.name, indexOf.call(allowedAttributes, ref1) >= 0))) {
            $node.removeAttr(attr.name);
          }
        }
        this._cleanNodeStyles($node);
        if ($node.is('span') && $node[0].attributes.length === 0) {
          $node.contents().first().unwrap();
        }
      }
    } else if ($node[0].nodeType === 1 && !$node.is(':empty')) {
      if ($node.is('div, article, dl, header, footer, tr')) {
        $node.append('<br/>');
        contents.first().unwrap();
      } else if ($node.is('table')) {
        $p = $('<p/>');
        $node.find('tr').each(function(i, tr) {
          return $p.append($(tr).text() + '<br/>');
        });
        $node.replaceWith($p);
        contents = null;
      } else if ($node.is('thead, tfoot')) {
        $node.remove();
        contents = null;
      } else if ($node.is('th')) {
        $td = $('<td/>').append($node.contents());
        $node.replaceWith($td);
      } else {
        contents.first().unwrap();
      }
    } else {
      $node.remove();
      contents = null;
    }
    if (recursive && (contents != null) && !$node.is('pre')) {
      for (l = 0, len1 = contents.length; l < len1; l++) {
        n = contents[l];
        this.cleanNode(n, true);
      }
    }
    return null;
  };

  Formatter.prototype._cleanNodeStyles = function($node) {
    var allowedStyles, k, len, pair, ref, ref1, style, styleStr, styles;
    styleStr = $node.attr('style');
    if (!styleStr) {
      return;
    }
    $node.removeAttr('style');
    allowedStyles = this._allowedStyles[$node[0].tagName.toLowerCase()];
    if (!(allowedStyles && allowedStyles.length > 0)) {
      return $node;
    }
    styles = {};
    ref = styleStr.split(';');
    for (k = 0, len = ref.length; k < len; k++) {
      style = ref[k];
      style = $.trim(style);
      pair = style.split(':');
      if (!(pair.length = 2)) {
        continue;
      }
      if (ref1 = pair[0], indexOf.call(allowedStyles, ref1) >= 0) {
        styles[$.trim(pair[0])] = $.trim(pair[1]);
      }
    }
    if (Object.keys(styles).length > 0) {
      $node.css(styles);
    }
    return $node;
  };

  Formatter.prototype.clearHtml = function(html, lineBreak) {
    var container, contents, result;
    if (lineBreak == null) {
      lineBreak = true;
    }
    container = $('<div/>').append(html);
    contents = container.contents();
    result = '';
    contents.each((function(_this) {
      return function(i, node) {
        var $node, children;
        if (node.nodeType === 3) {
          return result += node.nodeValue;
        } else if (node.nodeType === 1) {
          $node = $(node);
          children = $node.is('iframe') ? null : $node.contents();
          if (children && children.length > 0) {
            result += _this.clearHtml(children);
          }
          if (lineBreak && i < contents.length - 1 && $node.is('br, p, div, li,tr, pre, address, artticle, aside, dl, figcaption, footer, h1, h2,h3, h4, header')) {
            return result += '\n';
          }
        }
      };
    })(this));
    return result;
  };

  Formatter.prototype.beautify = function($contents) {
    var uselessP;
    uselessP = function($el) {
      return !!($el.is('p') && !$el.text() && $el.children(':not(br)').length < 1);
    };
    return $contents.each(function(i, el) {
      var $el, invalid;
      $el = $(el);
      invalid = $el.is(':not(img, br, col, td, hr, [class^="simditor-"]):empty');
      if (invalid || uselessP($el)) {
        $el.remove();
      }
      return $el.find(':not(img, br, col, td, hr, [class^="simditor-"]):empty').remove();
    });
  };

  return Formatter;

})(SimpleModule);

InputManager = (function(superClass) {
  extend(InputManager, superClass);

  function InputManager() {
    return InputManager.__super__.constructor.apply(this, arguments);
  }

  InputManager.pluginName = 'InputManager';

  InputManager.prototype._modifierKeys = [16, 17, 18, 91, 93, 224];

  InputManager.prototype._arrowKeys = [37, 38, 39, 40];

  InputManager.prototype._init = function() {
    var selectAllKey, submitKey;
    this.editor = this._module;
    this.throttledValueChanged = this.editor.util.throttle((function(_this) {
      return function(params) {
        return setTimeout(function() {
          return _this.editor.trigger('valuechanged', params);
        }, 10);
      };
    })(this), 300);
    this.throttledSelectionChanged = this.editor.util.throttle((function(_this) {
      return function() {
        return _this.editor.trigger('selectionchanged');
      };
    })(this), 50);
    $(document).on('selectionchange.simditor' + this.editor.id, (function(_this) {
      return function(e) {
        var triggerEvent;
        if (!(_this.focused && !_this.editor.clipboard.pasting)) {
          return;
        }
        triggerEvent = function() {
          if (_this._selectionTimer) {
            clearTimeout(_this._selectionTimer);
            _this._selectionTimer = null;
          }
          if (_this.editor.selection._selection.rangeCount > 0) {
            return _this.throttledSelectionChanged();
          } else {
            return _this._selectionTimer = setTimeout(function() {
              _this._selectionTimer = null;
              if (_this.focused) {
                return triggerEvent();
              }
            }, 10);
          }
        };
        return triggerEvent();
      };
    })(this));
    this.editor.on('valuechanged', (function(_this) {
      return function() {
        var $rootBlocks;
        _this.lastCaretPosition = null;
        $rootBlocks = _this.editor.body.children().filter(function(i, node) {
          return _this.editor.util.isBlockNode(node);
        });
        if (_this.focused && $rootBlocks.length === 0) {
          _this.editor.selection.save();
          _this.editor.formatter.format();
          _this.editor.selection.restore();
        }
        _this.editor.body.find('hr, pre, .simditor-table').each(function(i, el) {
          var $el, formatted;
          $el = $(el);
          if ($el.parent().is('blockquote') || $el.parent()[0] === _this.editor.body[0]) {
            formatted = false;
            if ($el.next().length === 0) {
              $('<p/>').append(_this.editor.util.phBr).insertAfter($el);
              formatted = true;
            }
            if ($el.prev().length === 0) {
              $('<p/>').append(_this.editor.util.phBr).insertBefore($el);
              formatted = true;
            }
            if (formatted) {
              return _this.throttledValueChanged();
            }
          }
        });
        _this.editor.body.find('pre:empty').append(_this.editor.util.phBr);
        if (!_this.editor.util.support.onselectionchange && _this.focused) {
          return _this.throttledSelectionChanged();
        }
      };
    })(this));
    this.editor.body.on('keydown', $.proxy(this._onKeyDown, this)).on('keypress', $.proxy(this._onKeyPress, this)).on('keyup', $.proxy(this._onKeyUp, this)).on('mouseup', $.proxy(this._onMouseUp, this)).on('focus', $.proxy(this._onFocus, this)).on('blur', $.proxy(this._onBlur, this)).on('drop', $.proxy(this._onDrop, this)).on('input', $.proxy(this._onInput, this));
    if (this.editor.util.browser.firefox) {
      this.editor.hotkeys.add('cmd+left', (function(_this) {
        return function(e) {
          e.preventDefault();
          _this.editor.selection._selection.modify('move', 'backward', 'lineboundary');
          return false;
        };
      })(this));
      this.editor.hotkeys.add('cmd+right', (function(_this) {
        return function(e) {
          e.preventDefault();
          _this.editor.selection._selection.modify('move', 'forward', 'lineboundary');
          return false;
        };
      })(this));
      selectAllKey = this.editor.util.os.mac ? 'cmd+a' : 'ctrl+a';
      this.editor.hotkeys.add(selectAllKey, (function(_this) {
        return function(e) {
          var $children, firstBlock, lastBlock, range;
          $children = _this.editor.body.children();
          if (!($children.length > 0)) {
            return;
          }
          firstBlock = $children.first().get(0);
          lastBlock = $children.last().get(0);
          range = document.createRange();
          range.setStart(firstBlock, 0);
          range.setEnd(lastBlock, _this.editor.util.getNodeLength(lastBlock));
          _this.editor.selection.range(range);
          return false;
        };
      })(this));
    }
    submitKey = this.editor.util.os.mac ? 'cmd+enter' : 'ctrl+enter';
    return this.editor.hotkeys.add(submitKey, (function(_this) {
      return function(e) {
        _this.editor.el.closest('form').find('button:submit').click();
        return false;
      };
    })(this));
  };

  InputManager.prototype._onFocus = function(e) {
    if (this.editor.clipboard.pasting) {
      return;
    }
    this.editor.el.addClass('focus').removeClass('error');
    this.focused = true;
    return setTimeout((function(_this) {
      return function() {
        var $blockEl, range;
        range = _this.editor.selection._selection.getRangeAt(0);
        if (range.startContainer === _this.editor.body[0]) {
          if (_this.lastCaretPosition) {
            _this.editor.undoManager.caretPosition(_this.lastCaretPosition);
          } else {
            $blockEl = _this.editor.body.children().first();
            range = document.createRange();
            _this.editor.selection.setRangeAtStartOf($blockEl, range);
          }
        }
        _this.lastCaretPosition = null;
        _this.editor.triggerHandler('focus');
        if (!_this.editor.util.support.onselectionchange) {
          return _this.throttledSelectionChanged();
        }
      };
    })(this), 0);
  };

  InputManager.prototype._onBlur = function(e) {
    var ref;
    if (this.editor.clipboard.pasting) {
      return;
    }
    this.editor.el.removeClass('focus');
    this.editor.sync();
    this.focused = false;
    this.lastCaretPosition = (ref = this.editor.undoManager.currentState()) != null ? ref.caret : void 0;
    return this.editor.triggerHandler('blur');
  };

  InputManager.prototype._onMouseUp = function(e) {
    if (!this.editor.util.support.onselectionchange) {
      return this.throttledSelectionChanged();
    }
  };

  InputManager.prototype._onKeyDown = function(e) {
    var ref, ref1;
    if (this.editor.triggerHandler(e) === false) {
      return false;
    }
    if (this.editor.hotkeys.respondTo(e)) {
      return;
    }
    if (this.editor.keystroke.respondTo(e)) {
      this.throttledValueChanged();
      return false;
    }
    if ((ref = e.which, indexOf.call(this._modifierKeys, ref) >= 0) || (ref1 = e.which, indexOf.call(this._arrowKeys, ref1) >= 0)) {
      return;
    }
    if (this.editor.util.metaKey(e) && e.which === 86) {
      return;
    }
    if (!this.editor.util.support.oninput) {
      this.throttledValueChanged(['typing']);
    }
    return null;
  };

  InputManager.prototype._onKeyPress = function(e) {
    if (this.editor.triggerHandler(e) === false) {
      return false;
    }
  };

  InputManager.prototype._onKeyUp = function(e) {
    var p, ref;
    if (this.editor.triggerHandler(e) === false) {
      return false;
    }
    if (!this.editor.util.support.onselectionchange && (ref = e.which, indexOf.call(this._arrowKeys, ref) >= 0)) {
      this.throttledValueChanged();
      return;
    }
    if ((e.which === 8 || e.which === 46) && this.editor.util.isEmptyNode(this.editor.body)) {
      this.editor.body.empty();
      p = $('<p/>').append(this.editor.util.phBr).appendTo(this.editor.body);
      this.editor.selection.setRangeAtStartOf(p);
    }
  };

  InputManager.prototype._onDrop = function(e) {
    if (this.editor.triggerHandler(e) === false) {
      return false;
    }
    return this.throttledValueChanged();
  };

  InputManager.prototype._onInput = function(e) {
    return this.throttledValueChanged(['oninput']);
  };

  return InputManager;

})(SimpleModule);

Keystroke = (function(superClass) {
  extend(Keystroke, superClass);

  function Keystroke() {
    return Keystroke.__super__.constructor.apply(this, arguments);
  }

  Keystroke.pluginName = 'Keystroke';

  Keystroke.prototype._init = function() {
    this.editor = this._module;
    this._keystrokeHandlers = {};
    return this._initKeystrokeHandlers();
  };

  Keystroke.prototype.add = function(key, node, handler) {
    key = key.toLowerCase();
    key = this.editor.hotkeys.constructor.aliases[key] || key;
    if (!this._keystrokeHandlers[key]) {
      this._keystrokeHandlers[key] = {};
    }
    return this._keystrokeHandlers[key][node] = handler;
  };

  Keystroke.prototype.respondTo = function(e) {
    var base, key, ref, result;
    key = (ref = this.editor.hotkeys.constructor.keyNameMap[e.which]) != null ? ref.toLowerCase() : void 0;
    if (!key) {
      return;
    }
    if (key in this._keystrokeHandlers) {
      result = typeof (base = this._keystrokeHandlers[key])['*'] === "function" ? base['*'](e) : void 0;
      if (!result) {
        this.editor.selection.startNodes().each((function(_this) {
          return function(i, node) {
            var handler, ref1;
            if (node.nodeType !== Node.ELEMENT_NODE) {
              return;
            }
            handler = (ref1 = _this._keystrokeHandlers[key]) != null ? ref1[node.tagName.toLowerCase()] : void 0;
            result = typeof handler === "function" ? handler(e, $(node)) : void 0;
            if (result === true || result === false) {
              return false;
            }
          };
        })(this));
      }
      if (result) {
        return true;
      }
    }
  };

  Keystroke.prototype._initKeystrokeHandlers = function() {
    var titleEnterHandler;
    if (this.editor.util.browser.safari) {
      this.add('enter', '*', (function(_this) {
        return function(e) {
          var $blockEl, $br;
          if (!e.shiftKey) {
            return;
          }
          $blockEl = _this.editor.selection.blockNodes().last();
          if ($blockEl.is('pre')) {
            return;
          }
          $br = $('<br/>');
          if (_this.editor.selection.rangeAtEndOf($blockEl)) {
            _this.editor.selection.insertNode($br);
            _this.editor.selection.insertNode($('<br/>'));
            _this.editor.selection.setRangeBefore($br);
          } else {
            _this.editor.selection.insertNode($br);
          }
          return true;
        };
      })(this));
    }
    if (this.editor.util.browser.webkit || this.editor.util.browser.msie) {
      titleEnterHandler = (function(_this) {
        return function(e, $node) {
          var $p;
          if (!_this.editor.selection.rangeAtEndOf($node)) {
            return;
          }
          $p = $('<p/>').append(_this.editor.util.phBr).insertAfter($node);
          _this.editor.selection.setRangeAtStartOf($p);
          return true;
        };
      })(this);
      this.add('enter', 'h1', titleEnterHandler);
      this.add('enter', 'h2', titleEnterHandler);
      this.add('enter', 'h3', titleEnterHandler);
      this.add('enter', 'h4', titleEnterHandler);
      this.add('enter', 'h5', titleEnterHandler);
      this.add('enter', 'h6', titleEnterHandler);
    }
    this.add('backspace', '*', (function(_this) {
      return function(e) {
        var $blockEl, $prevBlockEl, $rootBlock, isWebkit;
        $rootBlock = _this.editor.selection.rootNodes().first();
        $prevBlockEl = $rootBlock.prev();
        if ($prevBlockEl.is('hr') && _this.editor.selection.rangeAtStartOf($rootBlock)) {
          _this.editor.selection.save();
          $prevBlockEl.remove();
          _this.editor.selection.restore();
          return true;
        }
        $blockEl = _this.editor.selection.blockNodes().last();
        isWebkit = _this.editor.util.browser.webkit;
        if (isWebkit && _this.editor.selection.rangeAtStartOf($blockEl)) {
          _this.editor.selection.save();
          _this.editor.formatter.cleanNode($blockEl, true);
          _this.editor.selection.restore();
          return null;
        }
      };
    })(this));
    this.add('enter', 'li', (function(_this) {
      return function(e, $node) {
        var $cloneNode, listEl, newBlockEl, newListEl;
        $cloneNode = $node.clone();
        $cloneNode.find('ul, ol').remove();
        if (!(_this.editor.util.isEmptyNode($cloneNode) && $node.is(_this.editor.selection.blockNodes().last()))) {
          return;
        }
        listEl = $node.parent();
        if ($node.next('li').length > 0) {
          if (!_this.editor.util.isEmptyNode($node)) {
            return;
          }
          if (listEl.parent('li').length > 0) {
            newBlockEl = $('<li/>').append(_this.editor.util.phBr).insertAfter(listEl.parent('li'));
            newListEl = $('<' + listEl[0].tagName + '/>').append($node.nextAll('li'));
            newBlockEl.append(newListEl);
          } else {
            newBlockEl = $('<p/>').append(_this.editor.util.phBr).insertAfter(listEl);
            newListEl = $('<' + listEl[0].tagName + '/>').append($node.nextAll('li'));
            newBlockEl.after(newListEl);
          }
        } else {
          if (listEl.parent('li').length > 0) {
            newBlockEl = $('<li/>').insertAfter(listEl.parent('li'));
            if ($node.contents().length > 0) {
              newBlockEl.append($node.contents());
            } else {
              newBlockEl.append(_this.editor.util.phBr);
            }
          } else {
            newBlockEl = $('<p/>').append(_this.editor.util.phBr).insertAfter(listEl);
            if ($node.children('ul, ol').length > 0) {
              newBlockEl.after($node.children('ul, ol'));
            }
          }
        }
        if ($node.prev('li').length) {
          $node.remove();
        } else {
          listEl.remove();
        }
        _this.editor.selection.setRangeAtStartOf(newBlockEl);
        return true;
      };
    })(this));
    this.add('enter', 'pre', (function(_this) {
      return function(e, $node) {
        var $p, breakNode, range;
        e.preventDefault();
        if (e.shiftKey) {
          $p = $('<p/>').append(_this.editor.util.phBr).insertAfter($node);
          _this.editor.selection.setRangeAtStartOf($p);
          return true;
        }
        range = _this.editor.selection.range();
        breakNode = null;
        range.deleteContents();
        if (!_this.editor.util.browser.msie && _this.editor.selection.rangeAtEndOf($node)) {
          breakNode = document.createTextNode('\n\n');
          range.insertNode(breakNode);
          range.setEnd(breakNode, 1);
        } else {
          breakNode = document.createTextNode('\n');
          range.insertNode(breakNode);
          range.setStartAfter(breakNode);
        }
        range.collapse(false);
        _this.editor.selection.range(range);
        return true;
      };
    })(this));
    this.add('enter', 'blockquote', (function(_this) {
      return function(e, $node) {
        var $closestBlock, range;
        $closestBlock = _this.editor.selection.blockNodes().last();
        if (!($closestBlock.is('p') && !$closestBlock.next().length && _this.editor.util.isEmptyNode($closestBlock))) {
          return;
        }
        $node.after($closestBlock);
        range = document.createRange();
        _this.editor.selection.setRangeAtStartOf($closestBlock, range);
        return true;
      };
    })(this));
    this.add('backspace', 'li', (function(_this) {
      return function(e, $node) {
        var $br, $childList, $newLi, $prevChildList, $prevNode, $textNode, isFF, range, text;
        $childList = $node.children('ul, ol');
        $prevNode = $node.prev('li');
        if (!($childList.length > 0 && $prevNode.length > 0)) {
          return false;
        }
        text = '';
        $textNode = null;
        $node.contents().each(function(i, n) {
          if (n.nodeType === 1 && /UL|OL/.test(n.nodeName)) {
            return false;
          }
          if (n.nodeType === 1 && /BR/.test(n.nodeName)) {
            return;
          }
          if (n.nodeType === 3 && n.nodeValue) {
            text += n.nodeValue;
          } else if (n.nodeType === 1) {
            text += $(n).text();
          }
          return $textNode = $(n);
        });
        isFF = _this.editor.util.browser.firefox && !$textNode.next('br').length;
        if ($textNode && text.length === 1 && isFF) {
          $br = $(_this.editor.util.phBr).insertAfter($textNode);
          $textNode.remove();
          _this.editor.selection.setRangeBefore($br);
          return true;
        } else if (text.length > 0) {
          return false;
        }
        range = document.createRange();
        $prevChildList = $prevNode.children('ul, ol');
        if ($prevChildList.length > 0) {
          $newLi = $('<li/>').append(_this.editor.util.phBr).appendTo($prevChildList);
          $prevChildList.append($childList.children('li'));
          $node.remove();
          _this.editor.selection.setRangeAtEndOf($newLi, range);
        } else {
          _this.editor.selection.setRangeAtEndOf($prevNode, range);
          $prevNode.append($childList);
          $node.remove();
          _this.editor.selection.range(range);
        }
        return true;
      };
    })(this));
    this.add('backspace', 'pre', (function(_this) {
      return function(e, $node) {
        var $newNode, codeStr, range;
        if (!_this.editor.selection.rangeAtStartOf($node)) {
          return;
        }
        codeStr = $node.html().replace('\n', '<br/>') || _this.editor.util.phBr;
        $newNode = $('<p/>').append(codeStr).insertAfter($node);
        $node.remove();
        range = document.createRange();
        _this.editor.selection.setRangeAtStartOf($newNode, range);
        return true;
      };
    })(this));
    return this.add('backspace', 'blockquote', (function(_this) {
      return function(e, $node) {
        var $firstChild, range;
        if (!_this.editor.selection.rangeAtStartOf($node)) {
          return;
        }
        $firstChild = $node.children().first().unwrap();
        range = document.createRange();
        _this.editor.selection.setRangeAtStartOf($firstChild, range);
        return true;
      };
    })(this));
  };

  return Keystroke;

})(SimpleModule);

UndoManager = (function(superClass) {
  extend(UndoManager, superClass);

  function UndoManager() {
    return UndoManager.__super__.constructor.apply(this, arguments);
  }

  UndoManager.pluginName = 'UndoManager';

  UndoManager.prototype._index = -1;

  UndoManager.prototype._capacity = 20;

  UndoManager.prototype._startPosition = null;

  UndoManager.prototype._endPosition = null;

  UndoManager.prototype._init = function() {
    var redoShortcut, undoShortcut;
    this.editor = this._module;
    this._stack = [];
    if (this.editor.util.os.mac) {
      undoShortcut = 'cmd+z';
      redoShortcut = 'shift+cmd+z';
    } else if (this.editor.util.os.win) {
      undoShortcut = 'ctrl+z';
      redoShortcut = 'ctrl+y';
    } else {
      undoShortcut = 'ctrl+z';
      redoShortcut = 'shift+ctrl+z';
    }
    this.editor.hotkeys.add(undoShortcut, (function(_this) {
      return function(e) {
        e.preventDefault();
        _this.undo();
        return false;
      };
    })(this));
    this.editor.hotkeys.add(redoShortcut, (function(_this) {
      return function(e) {
        e.preventDefault();
        _this.redo();
        return false;
      };
    })(this));
    this.throttledPushState = this.editor.util.throttle((function(_this) {
      return function() {
        return _this._pushUndoState();
      };
    })(this), 2000);
    this.editor.on('valuechanged', (function(_this) {
      return function(e, src) {
        if (src === 'undo' || src === 'redo') {
          return;
        }
        return _this.throttledPushState();
      };
    })(this));
    this.editor.on('selectionchanged', (function(_this) {
      return function(e) {
        _this.resetCaretPosition();
        return _this.update();
      };
    })(this));
    this.editor.on('focus', (function(_this) {
      return function(e) {
        if (_this._stack.length === 0) {
          return _this._pushUndoState();
        }
      };
    })(this));
    return this.editor.on('blur', (function(_this) {
      return function(e) {
        return _this.resetCaretPosition();
      };
    })(this));
  };

  UndoManager.prototype.resetCaretPosition = function() {
    this._startPosition = null;
    return this._endPosition = null;
  };

  UndoManager.prototype.startPosition = function() {
    if (this.editor.selection._range) {
      this._startPosition || (this._startPosition = this._getPosition('start'));
    }
    return this._startPosition;
  };

  UndoManager.prototype.endPosition = function() {
    if (this.editor.selection._range) {
      this._endPosition || (this._endPosition = (function(_this) {
        return function() {
          var range;
          range = _this.editor.selection.range();
          if (range.collapsed) {
            return _this._startPosition;
          }
          return _this._getPosition('end');
        };
      })(this)());
    }
    return this._endPosition;
  };

  UndoManager.prototype._pushUndoState = function() {
    var caret;
    if (this.editor.triggerHandler('pushundostate') === false) {
      return;
    }
    caret = this.caretPosition();
    if (!caret.start) {
      return;
    }
    this._index += 1;
    this._stack.length = this._index;
    this._stack.push({
      html: this.editor.body.html(),
      caret: this.caretPosition()
    });
    if (this._stack.length > this._capacity) {
      this._stack.shift();
      return this._index -= 1;
    }
  };

  UndoManager.prototype.currentState = function() {
    if (this._stack.length && this._index > -1) {
      return this._stack[this._index];
    } else {
      return null;
    }
  };

  UndoManager.prototype.undo = function() {
    var state;
    if (this._index < 1 || this._stack.length < 2) {
      return;
    }
    this.editor.hidePopover();
    this._index -= 1;
    state = this._stack[this._index];
    this.editor.body.get(0).innerHTML = state.html;
    this.caretPosition(state.caret);
    this.editor.body.find('.selected').removeClass('selected');
    this.editor.sync();
    return this.editor.trigger('valuechanged', ['undo']);
  };

  UndoManager.prototype.redo = function() {
    var state;
    if (this._index < 0 || this._stack.length < this._index + 2) {
      return;
    }
    this.editor.hidePopover();
    this._index += 1;
    state = this._stack[this._index];
    this.editor.body.get(0).innerHTML = state.html;
    this.caretPosition(state.caret);
    this.editor.body.find('.selected').removeClass('selected');
    this.editor.sync();
    return this.editor.trigger('valuechanged', ['redo']);
  };

  UndoManager.prototype.update = function() {
    var currentState;
    currentState = this.currentState();
    if (!currentState) {
      return;
    }
    currentState.html = this.editor.body.html();
    return currentState.caret = this.caretPosition();
  };

  UndoManager.prototype._getNodeOffset = function(node, index) {
    var $parent, merging, offset;
    if ($.isNumeric(index)) {
      $parent = $(node);
    } else {
      $parent = $(node).parent();
    }
    offset = 0;
    merging = false;
    $parent.contents().each(function(i, child) {
      if (node === child || (index === i && i === 0)) {
        return false;
      }
      if (child.nodeType === Node.TEXT_NODE) {
        if (!merging && child.nodeValue.length > 0) {
          offset += 1;
          merging = true;
        }
      } else {
        offset += 1;
        merging = false;
      }
      if (index - 1 === i) {
        return false;
      }
      return null;
    });
    return offset;
  };

  UndoManager.prototype._getPosition = function(type) {
    var $nodes, node, nodes, offset, position, prevNode, range;
    if (type == null) {
      type = 'start';
    }
    range = this.editor.selection.range();
    offset = range[type + "Offset"];
    $nodes = this.editor.selection[type + "Nodes"]();
    node = $nodes.first()[0];
    if (node.nodeType === Node.TEXT_NODE) {
      prevNode = node.previousSibling;
      while (prevNode && prevNode.nodeType === Node.TEXT_NODE) {
        node = prevNode;
        offset += this.editor.util.getNodeLength(prevNode);
        prevNode = prevNode.previousSibling;
      }
      nodes = $nodes.get();
      nodes[0] = node;
      $nodes = $(nodes);
    } else {
      offset = this._getNodeOffset(node, offset);
    }
    position = [offset];
    $nodes.each((function(_this) {
      return function(i, node) {
        return position.unshift(_this._getNodeOffset(node));
      };
    })(this));
    return position;
  };

  UndoManager.prototype._getNodeByPosition = function(position) {
    var child, childNodes, i, k, len, node, offset, ref;
    node = this.editor.body[0];
    ref = position.slice(0, position.length - 1);
    for (i = k = 0, len = ref.length; k < len; i = ++k) {
      offset = ref[i];
      childNodes = node.childNodes;
      if (offset > childNodes.length - 1) {
        if (i === position.length - 2 && $(node).is('pre:empty')) {
          child = document.createTextNode('');
          node.appendChild(child);
          childNodes = node.childNodes;
        } else {
          node = null;
          break;
        }
      }
      node = childNodes[offset];
    }
    return node;
  };

  UndoManager.prototype.caretPosition = function(caret) {
    var endContainer, endOffset, range, startContainer, startOffset;
    if (!caret) {
      range = this.editor.selection.range();
      caret = this.editor.inputManager.focused && (range != null) ? {
        start: this.startPosition(),
        end: this.endPosition(),
        collapsed: range.collapsed
      } : {};
      return caret;
    } else {
      if (!caret.start) {
        return;
      }
      startContainer = this._getNodeByPosition(caret.start);
      startOffset = caret.start[caret.start.length - 1];
      if (caret.collapsed) {
        endContainer = startContainer;
        endOffset = startOffset;
      } else {
        endContainer = this._getNodeByPosition(caret.end);
        endOffset = caret.start[caret.start.length - 1];
      }
      if (!startContainer || !endContainer) {
        if (typeof console !== "undefined" && console !== null) {
          if (typeof console.warn === "function") {
            console.warn('simditor: invalid caret state');
          }
        }
        return;
      }
      range = document.createRange();
      range.setStart(startContainer, startOffset);
      range.setEnd(endContainer, endOffset);
      return this.editor.selection.range(range);
    }
  };

  return UndoManager;

})(SimpleModule);

Util = (function(superClass) {
  extend(Util, superClass);

  function Util() {
    return Util.__super__.constructor.apply(this, arguments);
  }

  Util.pluginName = 'Util';

  Util.prototype._init = function() {
    this.editor = this._module;
    if (this.browser.msie && this.browser.version < 11) {
      return this.phBr = '';
    }
  };

  Util.prototype.phBr = '<br/>';

  Util.prototype.os = (function() {
    var os;
    os = {};
    if (/Mac/.test(navigator.appVersion)) {
      os.mac = true;
    } else if (/Linux/.test(navigator.appVersion)) {
      os.linux = true;
    } else if (/Win/.test(navigator.appVersion)) {
      os.win = true;
    } else if (/X11/.test(navigator.appVersion)) {
      os.unix = true;
    }
    if (/Mobi/.test(navigator.appVersion)) {
      os.mobile = true;
    }
    return os;
  })();

  Util.prototype.browser = (function() {
    var chrome, edge, firefox, ie, ref, ref1, ref2, ref3, ref4, safari, ua;
    ua = navigator.userAgent;
    ie = /(msie|trident)/i.test(ua);
    chrome = /chrome|crios/i.test(ua);
    safari = /safari/i.test(ua) && !chrome;
    firefox = /firefox/i.test(ua);
    edge = /edge/i.test(ua);
    if (ie) {
      return {
        msie: true,
        version: ((ref = ua.match(/(msie |rv:)(\d+(\.\d+)?)/i)) != null ? ref[2] : void 0) * 1
      };
    } else if (edge) {
      return {
        edge: true,
        webkit: true,
        version: ((ref1 = ua.match(/edge\/(\d+(\.\d+)?)/i)) != null ? ref1[1] : void 0) * 1
      };
    } else if (chrome) {
      return {
        webkit: true,
        chrome: true,
        version: ((ref2 = ua.match(/(?:chrome|crios)\/(\d+(\.\d+)?)/i)) != null ? ref2[1] : void 0) * 1
      };
    } else if (safari) {
      return {
        webkit: true,
        safari: true,
        version: ((ref3 = ua.match(/version\/(\d+(\.\d+)?)/i)) != null ? ref3[1] : void 0) * 1
      };
    } else if (firefox) {
      return {
        mozilla: true,
        firefox: true,
        version: ((ref4 = ua.match(/firefox\/(\d+(\.\d+)?)/i)) != null ? ref4[1] : void 0) * 1
      };
    } else {
      return {};
    }
  })();

  Util.prototype.support = (function() {
    return {
      onselectionchange: (function() {
        var e, onselectionchange;
        onselectionchange = document.onselectionchange;
        if (onselectionchange !== void 0) {
          try {
            document.onselectionchange = 0;
            return document.onselectionchange === null;
          } catch (_error) {
            e = _error;
          } finally {
            document.onselectionchange = onselectionchange;
          }
        }
        return false;
      })(),
      oninput: (function() {
        return !/(msie|trident)/i.test(navigator.userAgent);
      })()
    };
  })();

  Util.prototype.reflow = function(el) {
    if (el == null) {
      el = document;
    }
    return $(el)[0].offsetHeight;
  };

  Util.prototype.metaKey = function(e) {
    var isMac;
    isMac = /Mac/.test(navigator.userAgent);
    if (isMac) {
      return e.metaKey;
    } else {
      return e.ctrlKey;
    }
  };

  Util.prototype.isEmptyNode = function(node) {
    var $node;
    $node = $(node);
    return $node.is(':empty') || (!$node.text() && !$node.find(':not(br, span, div)').length);
  };

  Util.prototype.isDecoratedNode = function(node) {
    return $(node).is('[class^="simditor-"]');
  };

  Util.prototype.blockNodes = ["div", "p", "ul", "ol", "li", "blockquote", "hr", "pre", "h1", "h2", "h3", "h4", "h5", "table"];

  Util.prototype.isBlockNode = function(node) {
    node = $(node)[0];
    if (!node || node.nodeType === 3) {
      return false;
    }
    return new RegExp("^(" + (this.blockNodes.join('|')) + ")$").test(node.nodeName.toLowerCase());
  };

  Util.prototype.getNodeLength = function(node) {
    node = $(node)[0];
    switch (node.nodeType) {
      case 7:
      case 10:
        return 0;
      case 3:
      case 8:
        return node.length;
      default:
        return node.childNodes.length;
    }
  };

  Util.prototype.dataURLtoBlob = function(dataURL) {
    var BlobBuilder, arrayBuffer, bb, blobArray, byteString, hasArrayBufferViewSupport, hasBlobConstructor, i, intArray, k, mimeString, ref, supportBlob;
    hasBlobConstructor = window.Blob && (function() {
      var e;
      try {
        return Boolean(new Blob());
      } catch (_error) {
        e = _error;
        return false;
      }
    })();
    hasArrayBufferViewSupport = hasBlobConstructor && window.Uint8Array && (function() {
      var e;
      try {
        return new Blob([new Uint8Array(100)]).size === 100;
      } catch (_error) {
        e = _error;
        return false;
      }
    })();
    BlobBuilder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
    supportBlob = hasBlobConstructor || BlobBuilder;
    if (!(supportBlob && window.atob && window.ArrayBuffer && window.Uint8Array)) {
      return false;
    }
    if (dataURL.split(',')[0].indexOf('base64') >= 0) {
      byteString = atob(dataURL.split(',')[1]);
    } else {
      byteString = decodeURIComponent(dataURL.split(',')[1]);
    }
    arrayBuffer = new ArrayBuffer(byteString.length);
    intArray = new Uint8Array(arrayBuffer);
    for (i = k = 0, ref = byteString.length; 0 <= ref ? k <= ref : k >= ref; i = 0 <= ref ? ++k : --k) {
      intArray[i] = byteString.charCodeAt(i);
    }
    mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];
    if (hasBlobConstructor) {
      blobArray = hasArrayBufferViewSupport ? intArray : arrayBuffer;
      return new Blob([blobArray], {
        type: mimeString
      });
    }
    bb = new BlobBuilder();
    bb.append(arrayBuffer);
    return bb.getBlob(mimeString);
  };

  Util.prototype.throttle = function(func, wait) {
    var args, call, ctx, last, rtn, throttled, timeoutID;
    last = 0;
    timeoutID = 0;
    ctx = args = rtn = null;
    call = function() {
      timeoutID = 0;
      last = +new Date();
      rtn = func.apply(ctx, args);
      ctx = null;
      return args = null;
    };
    throttled = function() {
      var delta;
      ctx = this;
      args = arguments;
      delta = new Date() - last;
      if (!timeoutID) {
        if (delta >= wait) {
          call();
        } else {
          timeoutID = setTimeout(call, wait - delta);
        }
      }
      return rtn;
    };
    throttled.clear = function() {
      if (!timeoutID) {
        return;
      }
      clearTimeout(timeoutID);
      return call();
    };
    return throttled;
  };

  Util.prototype.formatHTML = function(html) {
    var cursor, indentString, lastMatch, level, match, re, repeatString, result, str;
    re = /<(\/?)(.+?)(\/?)>/g;
    result = '';
    level = 0;
    lastMatch = null;
    indentString = '  ';
    repeatString = function(str, n) {
      return new Array(n + 1).join(str);
    };
    while ((match = re.exec(html)) !== null) {
      match.isBlockNode = $.inArray(match[2], this.blockNodes) > -1;
      match.isStartTag = match[1] !== '/' && match[3] !== '/';
      match.isEndTag = match[1] === '/' || match[3] === '/';
      cursor = lastMatch ? lastMatch.index + lastMatch[0].length : 0;
      if ((str = html.substring(cursor, match.index)).length > 0 && $.trim(str)) {
        result += str;
      }
      if (match.isBlockNode && match.isEndTag && !match.isStartTag) {
        level -= 1;
      }
      if (match.isBlockNode && match.isStartTag) {
        if (!(lastMatch && lastMatch.isBlockNode && lastMatch.isEndTag)) {
          result += '\n';
        }
        result += repeatString(indentString, level);
      }
      result += match[0];
      if (match.isBlockNode && match.isEndTag) {
        result += '\n';
      }
      if (match.isBlockNode && match.isStartTag) {
        level += 1;
      }
      lastMatch = match;
    }
    return $.trim(result);
  };

  return Util;

})(SimpleModule);

Toolbar = (function(superClass) {
  extend(Toolbar, superClass);

  function Toolbar() {
    return Toolbar.__super__.constructor.apply(this, arguments);
  }

  Toolbar.pluginName = 'Toolbar';

  Toolbar.prototype.opts = {
    toolbar: true,
    toolbarFloat: true,
    toolbarHidden: false,
    toolbarFloatOffset: 0
  };

  Toolbar.prototype._tpl = {
    wrapper: '<div class="simditor-toolbar"><ul></ul></div>',
    separator: '<li><span class="separator"></span></li>'
  };

  Toolbar.prototype._init = function() {
    var floatInitialized, initToolbarFloat, toolbarHeight;
    this.editor = this._module;
    if (!this.opts.toolbar) {
      return;
    }
    if (!$.isArray(this.opts.toolbar)) {
      this.opts.toolbar = ['bold', 'italic', 'underline', 'strikethrough', '|', 'ol', 'ul', 'blockquote', 'code', '|', 'link', 'image', '|', 'indent', 'outdent'];
    }
    this._render();
    this.list.on('click', function(e) {
      return false;
    });
    this.wrapper.on('mousedown', (function(_this) {
      return function(e) {
        return _this.list.find('.menu-on').removeClass('.menu-on');
      };
    })(this));
    $(document).on('mousedown.simditor' + this.editor.id, (function(_this) {
      return function(e) {
        return _this.list.find('.menu-on').removeClass('.menu-on');
      };
    })(this));
    if (!this.opts.toolbarHidden && this.opts.toolbarFloat) {
      this.wrapper.css('top', this.opts.toolbarFloatOffset);
      toolbarHeight = 0;
      initToolbarFloat = (function(_this) {
        return function() {
          _this.wrapper.css('position', 'static');
          _this.wrapper.width('auto');
          _this.editor.util.reflow(_this.wrapper);
          _this.wrapper.width(_this.wrapper.outerWidth());
          _this.wrapper.css('left', _this.editor.util.os.mobile ? _this.wrapper.position().left : _this.wrapper.offset().left);
          _this.wrapper.css('position', '');
          toolbarHeight = _this.wrapper.outerHeight();
          _this.editor.placeholderEl.css('top', toolbarHeight);
          return true;
        };
      })(this);
      floatInitialized = null;
      $(window).on('resize.simditor-' + this.editor.id, function(e) {
        return floatInitialized = initToolbarFloat();
      });
      $(window).on('scroll.simditor-' + this.editor.id, (function(_this) {
        return function(e) {
          var bottomEdge, scrollTop, topEdge;
          if (!_this.wrapper.is(':visible')) {
            return;
          }
          topEdge = _this.editor.wrapper.offset().top;
          bottomEdge = topEdge + _this.editor.wrapper.outerHeight() - 80;
          scrollTop = $(document).scrollTop() + _this.opts.toolbarFloatOffset;
          if (scrollTop <= topEdge || scrollTop >= bottomEdge) {
            _this.editor.wrapper.removeClass('toolbar-floating').css('padding-top', '');
            if (_this.editor.util.os.mobile) {
              return _this.wrapper.css('top', _this.opts.toolbarFloatOffset);
            }
          } else {
            floatInitialized || (floatInitialized = initToolbarFloat());
            _this.editor.wrapper.addClass('toolbar-floating').css('padding-top', toolbarHeight);
            if (_this.editor.util.os.mobile) {
              return _this.wrapper.css('top', scrollTop - topEdge + _this.opts.toolbarFloatOffset);
            }
          }
        };
      })(this));
    }
    this.editor.on('destroy', (function(_this) {
      return function() {
        return _this.buttons.length = 0;
      };
    })(this));
    return $(document).on("mousedown.simditor-" + this.editor.id, (function(_this) {
      return function(e) {
        return _this.list.find('li.menu-on').removeClass('menu-on');
      };
    })(this));
  };

  Toolbar.prototype._render = function() {
    var k, len, name, ref;
    this.buttons = [];
    this.wrapper = $(this._tpl.wrapper).prependTo(this.editor.wrapper);
    this.list = this.wrapper.find('ul');
    ref = this.opts.toolbar;
    for (k = 0, len = ref.length; k < len; k++) {
      name = ref[k];
      if (name === '|') {
        $(this._tpl.separator).appendTo(this.list);
        continue;
      }
      if (!this.constructor.buttons[name]) {
        throw new Error("simditor: invalid toolbar button " + name);
        continue;
      }
      this.buttons.push(new this.constructor.buttons[name]({
        editor: this.editor
      }));
    }
    if (this.opts.toolbarHidden) {
      return this.wrapper.hide();
    }
  };

  Toolbar.prototype.findButton = function(name) {
    var button;
    button = this.list.find('.toolbar-item-' + name).data('button');
    return button != null ? button : null;
  };

  Toolbar.addButton = function(btn) {
    return this.buttons[btn.prototype.name] = btn;
  };

  Toolbar.buttons = {};

  return Toolbar;

})(SimpleModule);

Indentation = (function(superClass) {
  extend(Indentation, superClass);

  function Indentation() {
    return Indentation.__super__.constructor.apply(this, arguments);
  }

  Indentation.pluginName = 'Indentation';

  Indentation.prototype.opts = {
    tabIndent: true
  };

  Indentation.prototype._init = function() {
    this.editor = this._module;
    return this.editor.keystroke.add('tab', '*', (function(_this) {
      return function(e) {
        var codeButton;
        codeButton = _this.editor.toolbar.findButton('code');
        if (!(_this.opts.tabIndent || (codeButton && codeButton.active))) {
          return;
        }
        return _this.indent(e.shiftKey);
      };
    })(this));
  };

  Indentation.prototype.indent = function(isBackward) {
    var $blockNodes, $endNodes, $startNodes, nodes, result;
    $startNodes = this.editor.selection.startNodes();
    $endNodes = this.editor.selection.endNodes();
    $blockNodes = this.editor.selection.blockNodes();
    nodes = [];
    $blockNodes = $blockNodes.each(function(i, node) {
      var include, j, k, len, n;
      include = true;
      for (j = k = 0, len = nodes.length; k < len; j = ++k) {
        n = nodes[j];
        if ($.contains(node, n)) {
          include = false;
          break;
        } else if ($.contains(n, node)) {
          nodes.splice(j, 1, node);
          include = false;
          break;
        }
      }
      if (include) {
        return nodes.push(node);
      }
    });
    $blockNodes = $(nodes);
    result = false;
    $blockNodes.each((function(_this) {
      return function(i, blockEl) {
        var r;
        r = isBackward ? _this.outdentBlock(blockEl) : _this.indentBlock(blockEl);
        if (r) {
          return result = r;
        }
      };
    })(this));
    return result;
  };

  Indentation.prototype.indentBlock = function(blockEl) {
    var $blockEl, $childList, $nextTd, $nextTr, $parentLi, $pre, $td, $tr, marginLeft, tagName;
    $blockEl = $(blockEl);
    if (!$blockEl.length) {
      return;
    }
    if ($blockEl.is('pre')) {
      $pre = this.editor.selection.containerNode();
      if (!($pre.is($blockEl) || $pre.closest('pre').is($blockEl))) {
        return;
      }
      this.indentText(this.editor.selection.range());
    } else if ($blockEl.is('li')) {
      $parentLi = $blockEl.prev('li');
      if ($parentLi.length < 1) {
        return;
      }
      this.editor.selection.save();
      tagName = $blockEl.parent()[0].tagName;
      $childList = $parentLi.children('ul, ol');
      if ($childList.length > 0) {
        $childList.append($blockEl);
      } else {
        $('<' + tagName + '/>').append($blockEl).appendTo($parentLi);
      }
      this.editor.selection.restore();
    } else if ($blockEl.is('p, h1, h2, h3, h4')) {
      marginLeft = parseInt($blockEl.css('margin-left')) || 0;
      marginLeft = (Math.round(marginLeft / this.opts.indentWidth) + 1) * this.opts.indentWidth;
      $blockEl.css('margin-left', marginLeft);
    } else if ($blockEl.is('table') || $blockEl.is('.simditor-table')) {
      $td = this.editor.selection.containerNode().closest('td, th');
      $nextTd = $td.next('td, th');
      if (!($nextTd.length > 0)) {
        $tr = $td.parent('tr');
        $nextTr = $tr.next('tr');
        if ($nextTr.length < 1 && $tr.parent().is('thead')) {
          $nextTr = $tr.parent('thead').next('tbody').find('tr:first');
        }
        $nextTd = $nextTr.find('td:first, th:first');
      }
      if (!($td.length > 0 && $nextTd.length > 0)) {
        return;
      }
      this.editor.selection.setRangeAtEndOf($nextTd);
    } else {
      return false;
    }
    return true;
  };

  Indentation.prototype.indentText = function(range) {
    var text, textNode;
    text = range.toString().replace(/^(?=.+)/mg, '\u00A0\u00A0');
    textNode = document.createTextNode(text || '\u00A0\u00A0');
    range.deleteContents();
    range.insertNode(textNode);
    if (text) {
      range.selectNode(textNode);
      return this.editor.selection.range(range);
    } else {
      return this.editor.selection.setRangeAfter(textNode);
    }
  };

  Indentation.prototype.outdentBlock = function(blockEl) {
    var $blockEl, $parent, $parentLi, $pre, $prevTd, $prevTr, $td, $tr, marginLeft, range;
    $blockEl = $(blockEl);
    if (!($blockEl && $blockEl.length > 0)) {
      return;
    }
    if ($blockEl.is('pre')) {
      $pre = this.editor.selection.containerNode();
      if (!($pre.is($blockEl) || $pre.closest('pre').is($blockEl))) {
        return;
      }
      this.outdentText(range);
    } else if ($blockEl.is('li')) {
      $parent = $blockEl.parent();
      $parentLi = $parent.parent('li');
      this.editor.selection.save();
      if ($parentLi.length < 1) {
        range = document.createRange();
        range.setStartBefore($parent[0]);
        range.setEndBefore($blockEl[0]);
        $parent.before(range.extractContents());
        $('<p/>').insertBefore($parent).after($blockEl.children('ul, ol')).append($blockEl.contents());
        $blockEl.remove();
      } else {
        if ($blockEl.next('li').length > 0) {
          $('<' + $parent[0].tagName + '/>').append($blockEl.nextAll('li')).appendTo($blockEl);
        }
        $blockEl.insertAfter($parentLi);
        if ($parent.children('li').length < 1) {
          $parent.remove();
        }
      }
      this.editor.selection.restore();
    } else if ($blockEl.is('p, h1, h2, h3, h4')) {
      marginLeft = parseInt($blockEl.css('margin-left')) || 0;
      marginLeft = Math.max(Math.round(marginLeft / this.opts.indentWidth) - 1, 0) * this.opts.indentWidth;
      $blockEl.css('margin-left', marginLeft === 0 ? '' : marginLeft);
    } else if ($blockEl.is('table') || $blockEl.is('.simditor-table')) {
      $td = this.editor.selection.containerNode().closest('td, th');
      $prevTd = $td.prev('td, th');
      if (!($prevTd.length > 0)) {
        $tr = $td.parent('tr');
        $prevTr = $tr.prev('tr');
        if ($prevTr.length < 1 && $tr.parent().is('tbody')) {
          $prevTr = $tr.parent('tbody').prev('thead').find('tr:first');
        }
        $prevTd = $prevTr.find('td:last, th:last');
      }
      if (!($td.length > 0 && $prevTd.length > 0)) {
        return;
      }
      this.editor.selection.setRangeAtEndOf($prevTd);
    } else {
      return false;
    }
    return true;
  };

  Indentation.prototype.outdentText = function(range) {};

  return Indentation;

})(SimpleModule);

Clipboard = (function(superClass) {
  extend(Clipboard, superClass);

  function Clipboard() {
    return Clipboard.__super__.constructor.apply(this, arguments);
  }

  Clipboard.pluginName = 'Clipboard';

  Clipboard.prototype.opts = {
    pasteImage: false,
    cleanPaste: false
  };

  Clipboard.prototype._init = function() {
    this.editor = this._module;
    if (this.opts.pasteImage && typeof this.opts.pasteImage !== 'string') {
      this.opts.pasteImage = 'inline';
    }
    return this.editor.body.on('paste', (function(_this) {
      return function(e) {
        var range;
        if (_this.pasting || _this._pasteBin) {
          return;
        }
        if (_this.editor.triggerHandler(e) === false) {
          return false;
        }
        range = _this.editor.selection.deleteRangeContents();
        if (_this.editor.body.html()) {
          if (!range.collapsed) {
            range.collapse(true);
          }
        } else {
          _this.editor.formatter.format();
          _this.editor.selection.setRangeAtStartOf(_this.editor.body.find('p:first'));
        }
        if (_this._processPasteByClipboardApi(e)) {
          return false;
        }
        _this.editor.inputManager.throttledValueChanged.clear();
        _this.editor.inputManager.throttledSelectionChanged.clear();
        _this.editor.undoManager.throttledPushState.clear();
        _this.editor.selection.reset();
        _this.editor.undoManager.resetCaretPosition();
        _this.pasting = true;
        return _this._getPasteContent(function(pasteContent) {
          _this._processPasteContent(pasteContent);
          _this._pasteInBlockEl = null;
          _this._pastePlainText = null;
          return _this.pasting = false;
        });
      };
    })(this));
  };

  Clipboard.prototype._processPasteByClipboardApi = function(e) {
    var imageFile, pasteItem, ref, uploadOpt;
    if (this.editor.util.browser.edge) {
      return;
    }
    if (e.originalEvent.clipboardData && e.originalEvent.clipboardData.items && e.originalEvent.clipboardData.items.length > 0) {
      pasteItem = e.originalEvent.clipboardData.items[0];
      if (/^image\//.test(pasteItem.type)) {
        imageFile = pasteItem.getAsFile();
        if (!((imageFile != null) && this.opts.pasteImage)) {
          return;
        }
        if (!imageFile.name) {
          imageFile.name = "Clipboard Image.png";
        }
        if (this.editor.triggerHandler('pasting', [imageFile]) === false) {
          return;
        }
        uploadOpt = {};
        uploadOpt[this.opts.pasteImage] = true;
        if ((ref = this.editor.uploader) != null) {
          ref.upload(imageFile, uploadOpt);
        }
        return true;
      }
    }
  };

  Clipboard.prototype._getPasteContent = function(callback) {
    var state;
    this._pasteBin = $('<div contenteditable="true" />').addClass('simditor-paste-bin').attr('tabIndex', '-1').appendTo(this.editor.el);
    state = {
      html: this.editor.body.html(),
      caret: this.editor.undoManager.caretPosition()
    };
    this._pasteBin.focus();
    return setTimeout((function(_this) {
      return function() {
        var pasteContent, $el, $parent, $li;
        _this.editor.hidePopover();
        _this.editor.body.get(0).innerHTML = state.html;
        _this.editor.undoManager.caretPosition(state.caret);
        _this.editor.body.focus();
        _this.editor.selection.reset();
        _this.editor.selection.range();
        _this._pasteInBlockEl = _this.editor.selection.blockNodes().last();

        _this._pasteBin.children('style').remove(); //mod-for-jl
        _this._pasteBin.find('ul').each(function(i, ul){ $(ul).before($('<ol/>').append($(ul).find('li'))); $(ul).remove();}); //mod-for-jl
        _this._pasteBin.find('ol').find('li').children('p').each(function(i, p){ $(p).after($(p).html()); $(p).remove(); }); //mod-for-jl
        // console.log(_this._pasteBin.html());
        _this._pastePlainText = _this.opts.cleanPaste || _this._pasteInBlockEl.is('pre, table');
        if (_this._pastePlainText) {
          pasteContent = _this.editor.formatter.clearHtml(_this._pasteBin.html(), true);
        } else {
          pasteContent = $('<div/>').append(_this._pasteBin.contents());
          pasteContent.find('table colgroup').remove();
          _this.editor.formatter.format(pasteContent);
          _this.editor.formatter.decorate(pasteContent);
          _this.editor.formatter.beautify(pasteContent.children());
          pasteContent.find('p').each(function(i, p){ if($(p).html()=='				') $(p).html('<br>'); }) //mod-for-jl
          pasteContent = pasteContent.contents();
        }
        _this._pasteBin.remove();
        _this._pasteBin = null;
        return callback(pasteContent);
      };
    })(this), 0);
  };

  Clipboard.prototype._processPasteContent = function(pasteContent) {
    var $blockEl, $img, blob, children, insertPosition, k, l, lastLine, len, len1, len2, len3, len4, line, lines, m, node, o, q, ref, ref1, ref2, uploadOpt;
    if (this.editor.triggerHandler('pasting', [pasteContent]) === false) {
      return;
    }
    $blockEl = this._pasteInBlockEl;
    if (!pasteContent) {
      return;
    } else if (this._pastePlainText) {
      if ($blockEl.is('table')) {
        lines = pasteContent.split('\n');
        lastLine = lines.pop();
        for (k = 0, len = lines.length; k < len; k++) {
          line = lines[k];
          this.editor.selection.insertNode(document.createTextNode(line));
          this.editor.selection.insertNode($('<br/>'));
        }
        this.editor.selection.insertNode(document.createTextNode(lastLine));
      } else {
        pasteContent = $('<div/>').text(pasteContent);
        ref = pasteContent.contents();
        for (l = 0, len1 = ref.length; l < len1; l++) {
          node = ref[l];
          this.editor.selection.insertNode($(node)[0]);
        }
      }
    } else if ($blockEl.is(this.editor.body)) {
      for (m = 0, len2 = pasteContent.length; m < len2; m++) {
        node = pasteContent[m];
        this.editor.selection.insertNode(node);
      }
    } else if (pasteContent.length < 1) {
      return;
    } else if (pasteContent.length === 1) {
      if (pasteContent.is('p')) {
        children = pasteContent.contents();
        if (children.length === 1 && children.is('img')) {
          $img = children;
          if (/^data:image/.test($img.attr('src'))) {
            if (!this.opts.pasteImage) {
              return;
            }
            blob = this.editor.util.dataURLtoBlob($img.attr("src"));
            blob.name = "Clipboard Image.png";
            uploadOpt = {};
            uploadOpt[this.opts.pasteImage] = true;
            if ((ref1 = this.editor.uploader) != null) {
              ref1.upload(blob, uploadOpt);
            }
            return;
          } else if ($img.is('img[src^="webkit-fake-url://"]')) {
            return;
          }
        }
        for (o = 0, len3 = children.length; o < len3; o++) {
          node = children[o];
          this.editor.selection.insertNode(node);
        }
      } else if ($blockEl.is('p') && this.editor.util.isEmptyNode($blockEl)) {
        $blockEl.replaceWith(pasteContent);
        this.editor.selection.setRangeAtEndOf(pasteContent);
      } else if (pasteContent.is('ul, ol')) {
        if (pasteContent.find('li').length === 1) {
          pasteContent = $('<div/>').text(pasteContent.text());
          ref2 = pasteContent.contents();
          for (q = 0, len4 = ref2.length; q < len4; q++) {
            node = ref2[q];
            this.editor.selection.insertNode($(node)[0]);
          }
        } else if ($blockEl.is('li')) {
          $blockEl.parent().after(pasteContent);
          this.editor.selection.setRangeAtEndOf(pasteContent);
        } else {
          $blockEl.after(pasteContent);
          this.editor.selection.setRangeAtEndOf(pasteContent);
        }
      } else {
        $blockEl.after(pasteContent);
        this.editor.selection.setRangeAtEndOf(pasteContent);
      }
    } else {
      if ($blockEl.is('li')) {
        $blockEl = $blockEl.parent();
      }
      if (this.editor.selection.rangeAtStartOf($blockEl)) {
        insertPosition = 'before';
      } else if (this.editor.selection.rangeAtEndOf($blockEl)) {
        insertPosition = 'after';
      } else {
        this.editor.selection.breakBlockEl($blockEl);
        insertPosition = 'before';
      }
      $blockEl[insertPosition](pasteContent);
      this.editor.selection.setRangeAtEndOf(pasteContent.last());
    }
    return this.editor.inputManager.throttledValueChanged();
  };

  return Clipboard;

})(SimpleModule);

Simditor = (function(superClass) {
  extend(Simditor, superClass);

  function Simditor() {
    return Simditor.__super__.constructor.apply(this, arguments);
  }

  Simditor.connect(Util);

  Simditor.connect(InputManager);

  Simditor.connect(Selection);

  Simditor.connect(UndoManager);

  Simditor.connect(Keystroke);

  Simditor.connect(Formatter);

  Simditor.connect(Toolbar);

  Simditor.connect(Indentation);

  Simditor.connect(Clipboard);

  Simditor.count = 0;

  Simditor.prototype.opts = {
    textarea: null,
    placeholder: '',
    defaultImage: 'images/image.png',
    params: {},
    upload: false,
    indentWidth: 40
  };

  Simditor.prototype._init = function() {
    var e, editor, form, uploadOpts;
    this.textarea = $(this.opts.textarea);
    this.opts.placeholder = this.opts.placeholder || this.textarea.attr('placeholder');
    if (!this.textarea.length) {
      throw new Error('simditor: param textarea is required.');
      return;
    }
    editor = this.textarea.data('simditor');
    if (editor != null) {
      editor.destroy();
    }
    this.id = ++Simditor.count;
    this._render();
    if (simpleHotkeys) {
      this.hotkeys = simpleHotkeys({
        el: this.body
      });
    } else {
      throw new Error('simditor: simple-hotkeys is required.');
      return;
    }
    if (this.opts.upload && simpleUploader) {
      uploadOpts = typeof this.opts.upload === 'object' ? this.opts.upload : {};
      this.uploader = simpleUploader(uploadOpts);
    }
    form = this.textarea.closest('form');
    if (form.length) {
      form.on('submit.simditor-' + this.id, (function(_this) {
        return function() {
          return _this.sync();
        };
      })(this));
      form.on('reset.simditor-' + this.id, (function(_this) {
        return function() {
          return _this.setValue('');
        };
      })(this));
    }
    this.on('initialized', (function(_this) {
      return function() {
        if (_this.opts.placeholder) {
          _this.on('valuechanged', function() {
            return _this._placeholder();
          });
        }
        _this.setValue(_this.textarea.val().trim() || '');
        if (_this.textarea.attr('autofocus')) {
          return _this.focus();
        }
      };
    })(this));
    if (this.util.browser.mozilla) {
      this.util.reflow();
      try {
        document.execCommand('enableObjectResizing', false, false);
        return document.execCommand('enableInlineTableEditing', false, false);
      } catch (_error) {
        e = _error;
      }
    }
  };

  Simditor.prototype._tpl = "<div class=\"simditor\">\n  <div class=\"simditor-wrapper\">\n    <div class=\"simditor-placeholder\"></div>\n    <div class=\"simditor-body\" contenteditable=\"true\">\n    </div>\n  </div>\n</div>";

  Simditor.prototype._render = function() {
    var key, ref, results, val;
    this.el = $(this._tpl).insertBefore(this.textarea);
    this.wrapper = this.el.find('.simditor-wrapper');
    this.body = this.wrapper.find('.simditor-body');
    this.placeholderEl = this.wrapper.find('.simditor-placeholder').append(this.opts.placeholder);
    this.el.data('simditor', this);
    this.wrapper.append(this.textarea);
    this.textarea.data('simditor', this).blur();
    this.body.attr('tabindex', this.textarea.attr('tabindex'));
    if (this.util.os.mac) {
      this.el.addClass('simditor-mac');
    } else if (this.util.os.linux) {
      this.el.addClass('simditor-linux');
    }
    if (this.util.os.mobile) {
      this.el.addClass('simditor-mobile');
    }
    if (this.opts.params) {
      ref = this.opts.params;
      results = [];
      for (key in ref) {
        val = ref[key];
        results.push($('<input/>', {
          type: 'hidden',
          name: key,
          value: val
        }).insertAfter(this.textarea));
      }
      return results;
    }
  };

  Simditor.prototype._placeholder = function() {
    var children;
    children = this.body.children();
    if (children.length === 0 || (children.length === 1 && this.util.isEmptyNode(children) && parseInt(children.css('margin-left') || 0) < this.opts.indentWidth)) {
      return this.placeholderEl.show();
    } else {
      return this.placeholderEl.hide();
    }
  };

  Simditor.prototype.setValue = function(val) {
    this.hidePopover();
    this.textarea.val(val);
    this.body.get(0).innerHTML = val;
    this.formatter.format();
    this.formatter.decorate();
    this.util.reflow(this.body);
    this.inputManager.lastCaretPosition = null;
    return this.trigger('valuechanged');
  };

  Simditor.prototype.getValue = function() {
    return this.sync();
  };

  Simditor.prototype.sync = function() {
    var children, cloneBody, emptyP, firstP, lastP, val;
    cloneBody = this.body.clone();
    this.formatter.undecorate(cloneBody);
    this.formatter.format(cloneBody);
    this.formatter.autolink(cloneBody);
    children = cloneBody.children();
    lastP = children.last('p');
    firstP = children.first('p');
    while (lastP.is('p') && this.util.isEmptyNode(lastP)) {
      emptyP = lastP;
      lastP = lastP.prev('p');
      emptyP.remove();
    }
    while (firstP.is('p') && this.util.isEmptyNode(firstP)) {
      emptyP = firstP;
      firstP = lastP.next('p');
      emptyP.remove();
    }
    cloneBody.find('img.uploading').remove();
    val = $.trim(cloneBody.html());
    this.textarea.val(val);
    return val;
  };

  Simditor.prototype.focus = function() {
    var $blockEl, range;
    if (!(this.body.is(':visible') && this.body.is('[contenteditable]'))) {
      this.el.find('textarea:visible').focus();
      return;
    }
    if (this.inputManager.lastCaretPosition) {
      this.undoManager.caretPosition(this.inputManager.lastCaretPosition);
      return this.inputManager.lastCaretPosition = null;
    } else {
      $blockEl = this.body.children().last();
      if (!$blockEl.is('p')) {
        $blockEl = $('<p/>').append(this.util.phBr).appendTo(this.body);
      }
      range = document.createRange();
      return this.selection.setRangeAtEndOf($blockEl, range);
    }
  };

  Simditor.prototype.blur = function() {
    if (this.body.is(':visible') && this.body.is('[contenteditable]')) {
      return this.body.blur();
    } else {
      return this.body.find('textarea:visible').blur();
    }
  };

  Simditor.prototype.hidePopover = function() {
    return this.el.find('.simditor-popover').each(function(i, popover) {
      popover = $(popover).data('popover');
      if (popover.active) {
        return popover.hide();
      }
    });
  };

  Simditor.prototype.destroy = function() {
    this.triggerHandler('destroy');
    this.textarea.closest('form').off('.simditor .simditor-' + this.id);
    this.selection.clear();
    this.inputManager.focused = false;
    this.textarea.insertBefore(this.el).hide().val('').removeData('simditor');
    this.el.remove();
    $(document).off('.simditor-' + this.id);
    $(window).off('.simditor-' + this.id);
    return this.off();
  };

  return Simditor;

})(SimpleModule);

Simditor.i18n = {
  'zh-CN': {
    'blockquote': '引用',
    'bold': '加粗文字',
    'code': '插入代码',
    'color': '文字颜色',
    'coloredText': '彩色文字',
    'hr': '分隔线',
    'image': '插入图片',
    'externalImage': '外链图片',
    'uploadImage': '上传图片',
    'uploadFailed': '上传失败了',
    'uploadError': '上传出错了',
    'imageUrl': '图片地址',
    'imageSize': '图片尺寸',
    'imageAlt': '图片描述',
    'restoreImageSize': '还原图片尺寸',
    'uploading': '正在上传',
    'indent': '向右缩进',
    'outdent': '向左缩进',
    'italic': '斜体文字',
    'link': '插入链接',
    'linkText': '链接文字',
    'linkUrl': '链接地址',
    'linkTarget': '打开方式',
    'openLinkInCurrentWindow': '在当前窗口中打开',
    'openLinkInNewWindow': '在新窗口中打开',
    'removeLink': '移除链接',
    'ol': '有序列表',
    'ul': '无序列表',
    'strikethrough': '删除线文字',
    'table': '表格',
    'deleteRow': '删除行',
    'insertRowAbove': '在上面插入行',
    'insertRowBelow': '在下面插入行',
    'deleteColumn': '删除列',
    'insertColumnLeft': '在左边插入列',
    'insertColumnRight': '在右边插入列',
    'deleteTable': '删除表格',
    'title': '标题',
    'normalText': '普通文本',
    'underline': '下划线文字',
    'alignment': '水平对齐',
    'alignCenter': '居中',
    'alignLeft': '居左',
    'alignRight': '居右',
    'selectLanguage': '选择程序语言',
    'fontScale': '字体大小',
    'fontScaleXLarge': '超大字体',
    'fontScaleLarge': '大号字体',
    'fontScaleNormal': '正常大小',
    'fontScaleSmall': '小号字体',
    'fontScaleXSmall': '超小字体',
    'paintRow': 'Paint Row',
    'paintCell': 'Paint Cell',
    'dissolveRow': 'Dissolve Row',
    'dissolveCell': 'Dissolve Cell',
    'addBorder': 'Add borders',
    'removeBorder': 'Delete borders',
    'listDisc': 'List Disc',
    'listCircle': 'List Circle',
    'listSquare': 'List Square',
    'listDecimal': 'List Decimal',
    'listDecimal0': 'List Decimal 0',
    'listUpperRoman': 'List Upper Roman',
    'listLowerRoman': 'List Lower Roman',
    'listUpperAlpha': 'List Upper Alpha',
    'listLowerAlpha': 'List Lower Alpha',
    'listGreek': 'List Greek',
    'toggleList': 'List on/off'
  },
  'en-US': {
    'blockquote': 'Block Quote',
    'bold': 'Bold',
    'code': 'Code',
    'color': 'Text Color',
    'coloredText': 'Colored Text',
    'hr': 'Horizontal Line',
    'image': 'Insert Image',
    'externalImage': 'External Image',
    'uploadImage': 'Upload Image',
    'uploadFailed': 'Upload failed',
    'uploadError': 'Error occurs during upload',
    'imageUrl': 'Url',
    'imageSize': 'Size',
    'imageAlt': 'Alt',
    'restoreImageSize': 'Restore Origin Size',
    'uploading': 'Uploading',
    'indent': 'Indent',
    'outdent': 'Outdent',
    'italic': 'Italic',
    'link': 'Insert Link',
    'linkText': 'Text',
    'linkUrl': 'Url',
    'linkTarget': 'Target',
    'openLinkInCurrentWindow': 'Open link in current window',
    'openLinkInNewWindow': 'Open link in new window',
    'removeLink': 'Remove Link',
    'ol': 'Ordered List',
    'ul': 'Unordered List',
    'strikethrough': 'Strikethrough',
    'table': 'Table',
    'deleteRow': 'Delete Row',
    'insertRowAbove': 'Insert Row Above',
    'insertRowBelow': 'Insert Row Below',
    'deleteColumn': 'Delete Column',
    'insertColumnLeft': 'Insert Column Left',
    'insertColumnRight': 'Insert Column Right',
    'deleteTable': 'Delete Table',
    'title': 'Title',
    'normalText': 'Text',
    'underline': 'Underline',
    'alignment': 'Alignment',
    'alignCenter': 'Align Center',
    'alignLeft': 'Align Left',
    'alignRight': 'Align Right',
    'alignJustify': 'Align Justify',
    'selectLanguage': 'Select Language',
    'fontScale': 'Font Size',
    'fontScaleXLarge': 'X Large Size',
    'fontScaleLarge': 'Large Size',
    'fontScaleNormal': 'Normal Size',
    'fontScaleSmall': 'Small Size',
    'fontScaleXSmall': 'X Small Size',
    'paintRow': 'Paint Row',
    'paintCell': 'Paint Cell',
    'dissolveRow': 'Dissolve Row',
    'dissolveCell': 'Dissolve Cell',
    'addBorder': 'Add borders',
    'removeBorder': 'Delete borders',
    'listDisc': 'List Disc',
    'listCircle': 'List Circle',
    'listSquare': 'List Square',
    'listDecimal': 'List Decimal',
    'listDecimal0': 'List Decimal 0',
    'listUpperRoman': 'List Upper Roman',
    'listLowerRoman': 'List Lower Roman',
    'listUpperAlpha': 'List Upper Alpha',
    'listLowerAlpha': 'List Lower Alpha',
    'listGreek': 'List Greek',
    'toggleList': 'List on/off'
  }
};

Button = (function(superClass) {
  extend(Button, superClass);

  Button.prototype._tpl = {
    item: '<li><a tabindex="-1" unselectable="on" class="toolbar-item" href="javascript:;"><span></span></a></li>',
    menuWrapper: '<div class="toolbar-menu"></div>',
    menuItem: '<li><a tabindex="-1" unselectable="on" class="menu-item" href="javascript:;"><span></span></a></li>',
    separator: '<li><span class="separator"></span></li>'
  };

  Button.prototype.name = '';

  Button.prototype.icon = '';

  Button.prototype.title = '';

  Button.prototype.text = '';

  Button.prototype.htmlTag = '';

  Button.prototype.disableTag = '';

  Button.prototype.menu = false;

  Button.prototype.active = false;

  Button.prototype.disabled = false;

  Button.prototype.needFocus = true;

  Button.prototype.shortcut = null;

  function Button(opts) {
    this.editor = opts.editor;
    this.title = this._t(this.name);
    Button.__super__.constructor.call(this, opts);
  }

  Button.prototype._init = function() {
    var k, len, ref, tag;
    this.render();
    this.el.on('mousedown', (function(_this) {
      return function(e) {
        var exceed, noFocus, param;
        e.preventDefault();
        noFocus = _this.needFocus && !_this.editor.inputManager.focused;
        if (_this.el.hasClass('disabled') || noFocus) {
          return false;
        }
        if (_this.menu) {
          _this.wrapper.toggleClass('menu-on').siblings('li').removeClass('menu-on');
          if (_this.wrapper.is('.menu-on')) {
            exceed = _this.menuWrapper.offset().left + _this.menuWrapper.outerWidth() + 5 - _this.editor.wrapper.offset().left - _this.editor.wrapper.outerWidth();
            if (exceed > 0) {
              _this.menuWrapper.css({
                'left': 'auto',
                'right': 0
              });
            }
            _this.trigger('menuexpand');
          }
          return false;
        }
        param = _this.el.data('param');
        _this.command(param);
        return false;
      };
    })(this));
    this.wrapper.on('click', 'a.menu-item', (function(_this) {
      return function(e) {
        var btn, noFocus, param;
        e.preventDefault();
        btn = $(e.currentTarget);
        _this.wrapper.removeClass('menu-on');
        noFocus = _this.needFocus && !_this.editor.inputManager.focused;
        if (btn.hasClass('disabled') || noFocus) {
          return false;
        }
        _this.editor.toolbar.wrapper.removeClass('menu-on');
        param = btn.data('param');
        _this.command(param);
        return false;
      };
    })(this));
    this.wrapper.on('mousedown', 'a.menu-item', function(e) {
      return false;
    });
    this.editor.on('blur', (function(_this) {
      return function() {
        var editorActive;
        editorActive = _this.editor.body.is(':visible') && _this.editor.body.is('[contenteditable]');
        if (!(editorActive && !_this.editor.clipboard.pasting)) {
          return;
        }
        _this.setActive(false);
        return _this.setDisabled(false);
      };
    })(this));
    if (this.shortcut != null) {
      this.editor.hotkeys.add(this.shortcut, (function(_this) {
        return function(e) {
          _this.el.mousedown();
          return false;
        };
      })(this));
    }
    ref = this.htmlTag.split(',');
    for (k = 0, len = ref.length; k < len; k++) {
      tag = ref[k];
      tag = $.trim(tag);
      if (tag && $.inArray(tag, this.editor.formatter._allowedTags) < 0) {
        this.editor.formatter._allowedTags.push(tag);
      }
    }
    return this.editor.on('selectionchanged', (function(_this) {
      return function(e) {
        if (_this.editor.inputManager.focused) {
          return _this._status();
        }
      };
    })(this));
  };

  Button.prototype.iconClassOf = function(icon) {
    if (icon) {
      return "simditor-icon simditor-icon-" + icon;
    } else {
      return '';
    }
  };

  Button.prototype.setIcon = function(icon) {
    return this.el.find('span').removeClass().addClass(this.iconClassOf(icon)).text(this.text);
  };

  Button.prototype.render = function() {
    this.wrapper = $(this._tpl.item).appendTo(this.editor.toolbar.list);
    this.el = this.wrapper.find('a.toolbar-item');
    this.el.attr('title', this.title).addClass("toolbar-item-" + this.name).data('button', this);
    this.setIcon(this.icon);
    if (!this.menu) {
      return;
    }
    this.menuWrapper = $(this._tpl.menuWrapper).appendTo(this.wrapper);
    this.menuWrapper.addClass("toolbar-menu-" + this.name);
    return this.renderMenu();
  };

  Button.prototype.renderMenu = function() {
    var $menuBtnEl, $menuItemEl, k, len, menuItem, ref, ref1, results;
    if (!$.isArray(this.menu)) {
      return;
    }
    this.menuEl = $('<ul/>').appendTo(this.menuWrapper);
    ref = this.menu;
    results = [];
    for (k = 0, len = ref.length; k < len; k++) {
      menuItem = ref[k];
      if (menuItem === '|') {
        $(this._tpl.separator).appendTo(this.menuEl);
        continue;
      }
      $menuItemEl = $(this._tpl.menuItem).appendTo(this.menuEl);
      $menuBtnEl = $menuItemEl.find('a.menu-item').attr({
        'title': (ref1 = menuItem.title) != null ? ref1 : menuItem.text,
        'data-param': menuItem.param
      }).addClass('menu-item-' + menuItem.name);
      if (menuItem.icon) {
        results.push($menuBtnEl.find('span').addClass(this.iconClassOf(menuItem.icon)));
      } else {
        results.push($menuBtnEl.find('span').text(menuItem.text));
      }
    }
    return results;
  };

  Button.prototype.setActive = function(active) {
    if (active === this.active) {
      return;
    }
    this.active = active;
    return this.el.toggleClass('active', this.active);
  };

  Button.prototype.setDisabled = function(disabled) {
    if (disabled === this.disabled) {
      return;
    }
    this.disabled = disabled;
    return this.el.toggleClass('disabled', this.disabled);
  };

  Button.prototype._disableStatus = function() {
    var disabled, endNodes, startNodes;
    startNodes = this.editor.selection.startNodes();
    endNodes = this.editor.selection.endNodes();
    disabled = startNodes.filter(this.disableTag).length > 0 || endNodes.filter(this.disableTag).length > 0;
    this.setDisabled(disabled);
    if (this.disabled) {
      this.setActive(false);
    }
    return this.disabled;
  };

  Button.prototype._activeStatus = function() {
    var active, endNode, endNodes, startNode, startNodes;
    startNodes = this.editor.selection.startNodes();
    endNodes = this.editor.selection.endNodes();
    startNode = startNodes.filter(this.htmlTag);
    endNode = endNodes.filter(this.htmlTag);
    active = startNode.length > 0 && endNode.length > 0 && startNode.is(endNode);
    this.node = active ? startNode : null;
    this.setActive(active);
    return this.active;
  };

  Button.prototype._status = function() {
    this._disableStatus();
    if (this.disabled) {
      return;
    }
    return this._activeStatus();
  };

  Button.prototype.command = function(param) {};

  Button.prototype._t = function() {
    var args, ref, result;
    args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
    result = Button.__super__._t.apply(this, args);
    if (!result) {
      result = (ref = this.editor)._t.apply(ref, args);
    }
    return result;
  };

  return Button;

})(SimpleModule);

Simditor.Button = Button;

Popover = (function(superClass) {
  extend(Popover, superClass);

  Popover.prototype.offset = {
    top: 4,
    left: 0
  };

  Popover.prototype.target = null;

  Popover.prototype.active = false;

  function Popover(opts) {
    this.button = opts.button;
    this.editor = opts.button.editor;
    Popover.__super__.constructor.call(this, opts);
  }

  Popover.prototype._init = function() {
    this.el = $('<div class="simditor-popover"></div>').appendTo(this.editor.el).data('popover', this);
    this.render();
    this.el.on('mouseenter', (function(_this) {
      return function(e) {
        return _this.el.addClass('hover');
      };
    })(this));
    return this.el.on('mouseleave', (function(_this) {
      return function(e) {
        return _this.el.removeClass('hover');
      };
    })(this));
  };

  Popover.prototype.render = function() {};

  Popover.prototype._initLabelWidth = function() {
    var $fields;
    $fields = this.el.find('.settings-field');
    if (!($fields.length > 0)) {
      return;
    }
    this._labelWidth = 0;
    $fields.each((function(_this) {
      return function(i, field) {
        var $field, $label;
        $field = $(field);
        $label = $field.find('label');
        if (!($label.length > 0)) {
          return;
        }
        return _this._labelWidth = Math.max(_this._labelWidth, $label.width());
      };
    })(this));
    return $fields.find('label').width(this._labelWidth);
  };

  Popover.prototype.show = function($target, position) {
    if (position == null) {
      position = 'bottom';
    }
    if ($target == null) {
      return;
    }
    this.el.siblings('.simditor-popover').each(function(i, popover) {
      popover = $(popover).data('popover');
      if (popover.active) {
        return popover.hide();
      }
    });
    if (this.active && this.target) {
      this.target.removeClass('selected');
    }
    this.target = $target.addClass('selected');
    if (this.active) {
      this.refresh(position);
      return this.trigger('popovershow');
    } else {
      this.active = true;
      this.el.css({
        left: -9999
      }).show();
      if (!this._labelWidth) {
        this._initLabelWidth();
      }
      this.editor.util.reflow();
      this.refresh(position);
      return this.trigger('popovershow');
    }
  };

  Popover.prototype.hide = function() {
    if (!this.active) {
      return;
    }
    if (this.target) {
      this.target.removeClass('selected');
    }
    this.target = null;
    this.active = false;
    this.el.hide();
    return this.trigger('popoverhide');
  };

  Popover.prototype.refresh = function(position) {
    var editorOffset, left, maxLeft, targetH, targetOffset, top;
    if (position == null) {
      position = 'bottom';
    }
    if (!this.active) {
      return;
    }
    editorOffset = this.editor.el.offset();
    targetOffset = this.target.offset();
    targetH = this.target.outerHeight();
    if (position === 'bottom') {
      top = targetOffset.top - editorOffset.top + targetH;
    } else if (position === 'top') {
      top = targetOffset.top - editorOffset.top - this.el.height();
    }
    maxLeft = this.editor.wrapper.width() - this.el.outerWidth() - 10;
    left = Math.min(targetOffset.left - editorOffset.left, maxLeft);
    return this.el.css({
      top: top + this.offset.top,
      left: left + this.offset.left
    });
  };

  Popover.prototype.destroy = function() {
    this.target = null;
    this.active = false;
    this.editor.off('.linkpopover');
    return this.el.remove();
  };

  Popover.prototype._t = function() {
    var args, ref, result;
    args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
    result = Popover.__super__._t.apply(this, args);
    if (!result) {
      result = (ref = this.button)._t.apply(ref, args);
    }
    return result;
  };

  return Popover;

})(SimpleModule);

Simditor.Popover = Popover;

TitleButton = (function(superClass) {
  extend(TitleButton, superClass);

  function TitleButton() {
    return TitleButton.__super__.constructor.apply(this, arguments);
  }

  TitleButton.prototype.name = 'title';

  TitleButton.prototype.htmlTag = 'h1, h2, h3, h4, h5';

  TitleButton.prototype.disableTag = 'pre, table';

  TitleButton.prototype._init = function() {
    this.menu = [
      {
        name: 'normal',
        text: this._t('normalText'),
        param: 'p'
      }, '|', {
        name: 'h1',
        text: this._t('title') + ' 1',
        param: 'h1'
      }, {
        name: 'h2',
        text: this._t('title') + ' 2',
        param: 'h2'
      }, {
        name: 'h3',
        text: this._t('title') + ' 3',
        param: 'h3'
      }, {
        name: 'h4',
        text: this._t('title') + ' 4',
        param: 'h4'
      }, {
        name: 'h5',
        text: this._t('title') + ' 5',
        param: 'h5'
      }
    ];
    return TitleButton.__super__._init.call(this);
  };

  TitleButton.prototype.setActive = function(active, param) {
    TitleButton.__super__.setActive.call(this, active);
    if (active) {
      param || (param = this.node[0].tagName.toLowerCase());
    }
    this.el.removeClass('active-p active-h1 active-h2 active-h3 active-h4 active-h5');
    if (active) {
      return this.el.addClass('active active-' + param);
    }
  };

  TitleButton.prototype.command = function(param) {
    var $rootNodes;
    $rootNodes = this.editor.selection.rootNodes();
    this.editor.selection.save();
    $rootNodes.each((function(_this) {
      return function(i, node) {
        var $node;
        $node = $(node);
        if ($node.is('blockquote') || $node.is(param) || $node.is(_this.disableTag) || _this.editor.util.isDecoratedNode($node)) {
          return;
        }
        return $('<' + param + '/>').append($node.contents()).replaceAll($node);
      };
    })(this));
    this.editor.selection.restore();
    return this.editor.trigger('valuechanged');
  };

  return TitleButton;

})(Button);

Simditor.Toolbar.addButton(TitleButton);

FontScaleButton = (function(superClass) {
  extend(FontScaleButton, superClass);

  function FontScaleButton() {
    return FontScaleButton.__super__.constructor.apply(this, arguments);
  }

  FontScaleButton.prototype.name = 'fontScale';

  FontScaleButton.prototype.icon = 'font';

  FontScaleButton.prototype.disableTag = 'pre';

  FontScaleButton.prototype.htmlTag = 'span';

  FontScaleButton.prototype.sizeMap = {
    'x-large': '1.5em',
    'large': '1.25em',
    'small': '.75em',
    'x-small': '.5em'
  };

  FontScaleButton.prototype._init = function() {
    this.menu = [
      {
        name: '150%',
        text: this._t('fontScaleXLarge'),
        param: '5'
      }, {
        name: '125%',
        text: this._t('fontScaleLarge'),
        param: '4'
      }, {
        name: '100%',
        text: this._t('fontScaleNormal'),
        param: '3'
      }, {
        name: '75%',
        text: this._t('fontScaleSmall'),
        param: '2'
      }, {
        name: '50%',
        text: this._t('fontScaleXSmall'),
        param: '1'
      }
    ];
    return FontScaleButton.__super__._init.call(this);
  };

  FontScaleButton.prototype._activeStatus = function() {
    var active, endNode, endNodes, range, startNode, startNodes;
    range = this.editor.selection.range();
    startNodes = this.editor.selection.startNodes();
    endNodes = this.editor.selection.endNodes();
    startNode = startNodes.filter('span[style*="font-size"]');
    endNode = endNodes.filter('span[style*="font-size"]');
    active = startNodes.length > 0 && endNodes.length > 0 && startNode.is(endNode);
    this.setActive(active);
    return this.active;
  };

  FontScaleButton.prototype.command = function(param) {
    var $scales, containerNode, range;
    range = this.editor.selection.range();
    if (range.collapsed) {
      return;
    }
    document.execCommand('styleWithCSS', false, true);
    document.execCommand('fontSize', false, param);
    document.execCommand('styleWithCSS', false, false);
    this.editor.selection.reset();
    this.editor.selection.range();
    containerNode = this.editor.selection.containerNode();
    if (containerNode[0].nodeType === Node.TEXT_NODE) {
      $scales = containerNode.closest('span[style*="font-size"]');
    } else {
      $scales = containerNode.find('span[style*="font-size"]');
    }
    $scales.each((function(_this) {
      return function(i, n) {
        var $span, size;
        $span = $(n);
        size = n.style.fontSize;
        if (/large|x-large|small|x-small/.test(size)) {
          return $span.css('fontSize', _this.sizeMap[size]);
        } else if (size === 'medium') {
          return $span.replaceWith($span.contents());
        }
      };
    })(this));
    return this.editor.trigger('valuechanged');
  };

  return FontScaleButton;

})(Button);

Simditor.Toolbar.addButton(FontScaleButton);

BoldButton = (function(superClass) {
  extend(BoldButton, superClass);

  function BoldButton() {
    return BoldButton.__super__.constructor.apply(this, arguments);
  }

  BoldButton.prototype.name = 'bold';

  BoldButton.prototype.icon = 'bold';

  BoldButton.prototype.htmlTag = 'b, strong';

  BoldButton.prototype.disableTag = 'pre';

  BoldButton.prototype.shortcut = 'cmd+b';

  BoldButton.prototype._init = function() {
    if (this.editor.util.os.mac) {
      this.title = this.title + ' ( Cmd + b )';
    } else {
      this.title = this.title + ' ( Ctrl + b )';
      this.shortcut = 'ctrl+b';
    }
    return BoldButton.__super__._init.call(this);
  };

  BoldButton.prototype._activeStatus = function() {
    var active;
    active = document.queryCommandState('bold') === true;
    this.setActive(active);
    return this.active;
  };

  BoldButton.prototype.command = function() {
    document.execCommand('bold');
    if (!this.editor.util.support.oninput) {
      this.editor.trigger('valuechanged');
    }
    return $(document).trigger('selectionchange');
  };

  return BoldButton;

})(Button);

Simditor.Toolbar.addButton(BoldButton);

ItalicButton = (function(superClass) {
  extend(ItalicButton, superClass);

  function ItalicButton() {
    return ItalicButton.__super__.constructor.apply(this, arguments);
  }

  ItalicButton.prototype.name = 'italic';

  ItalicButton.prototype.icon = 'italic';

  ItalicButton.prototype.htmlTag = 'i';

  ItalicButton.prototype.disableTag = 'pre';

  ItalicButton.prototype.shortcut = 'cmd+i';

  ItalicButton.prototype._init = function() {
    if (this.editor.util.os.mac) {
      this.title = this.title + " ( Cmd + i )";
    } else {
      this.title = this.title + " ( Ctrl + i )";
      this.shortcut = 'ctrl+i';
    }
    return ItalicButton.__super__._init.call(this);
  };

  ItalicButton.prototype._activeStatus = function() {
    var active;
    active = document.queryCommandState('italic') === true;
    this.setActive(active);
    return this.active;
  };

  ItalicButton.prototype.command = function() {
    document.execCommand('italic');
    if (!this.editor.util.support.oninput) {
      this.editor.trigger('valuechanged');
    }
    return $(document).trigger('selectionchange');
  };

  return ItalicButton;

})(Button);

Simditor.Toolbar.addButton(ItalicButton);

UnderlineButton = (function(superClass) {
  extend(UnderlineButton, superClass);

  function UnderlineButton() {
    return UnderlineButton.__super__.constructor.apply(this, arguments);
  }

  UnderlineButton.prototype.name = 'underline';

  UnderlineButton.prototype.icon = 'underline';

  UnderlineButton.prototype.htmlTag = 'u';

  UnderlineButton.prototype.disableTag = 'pre';

  UnderlineButton.prototype.shortcut = 'cmd+u';

  UnderlineButton.prototype.render = function() {
    if (this.editor.util.os.mac) {
      this.title = this.title + ' ( Cmd + u )';
    } else {
      this.title = this.title + ' ( Ctrl + u )';
      this.shortcut = 'ctrl+u';
    }
    return UnderlineButton.__super__.render.call(this);
  };

  UnderlineButton.prototype._activeStatus = function() {
    var active;
    active = document.queryCommandState('underline') === true;
    this.setActive(active);
    return this.active;
  };

  UnderlineButton.prototype.command = function() {
    document.execCommand('underline');
    if (!this.editor.util.support.oninput) {
      this.editor.trigger('valuechanged');
    }
    return $(document).trigger('selectionchange');
  };

  return UnderlineButton;

})(Button);

Simditor.Toolbar.addButton(UnderlineButton);

ColorButton = (function(superClass) {
  extend(ColorButton, superClass);

  function ColorButton() {
    return ColorButton.__super__.constructor.apply(this, arguments);
  }

  ColorButton.prototype.name = 'color';

  ColorButton.prototype.icon = 'tint';

  ColorButton.prototype.disableTag = 'pre';

  ColorButton.prototype.menu = true;

  ColorButton.prototype.render = function() {
    var args;
    args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
    return ColorButton.__super__.render.apply(this, args);
  };

  ColorButton.prototype.renderMenu = function() {
    $('<ul class="color-list">\n  <li><a href="javascript:;" class="font-color font-color-1"></a></li>\n  <li><a href="javascript:;" class="font-color font-color-2"></a></li>\n  <li><a href="javascript:;" class="font-color font-color-3"></a></li>\n  <li><a href="javascript:;" class="font-color font-color-4"></a></li>\n  <li><a href="javascript:;" class="font-color font-color-5"></a></li>\n  <li><a href="javascript:;" class="font-color font-color-6"></a></li>\n  <li><a href="javascript:;" class="font-color font-color-7"></a></li>\n  <li><a href="javascript:;" class="font-color font-color-default"></a></li>\n</ul>').appendTo(this.menuWrapper);
    this.menuWrapper.on('mousedown', '.color-list', function(e) {
      return false;
    });
    return this.menuWrapper.on('click', '.font-color', (function(_this) {
      return function(e) {
        var $link, $p, hex, range, rgb, textNode;
        _this.wrapper.removeClass('menu-on');
        $link = $(e.currentTarget);
        if ($link.hasClass('font-color-default')) {
          $p = _this.editor.body.find('p, li');
          if (!($p.length > 0)) {
            return;
          }
          rgb = window.getComputedStyle($p[0], null).getPropertyValue('color');
          hex = _this._convertRgbToHex(rgb);
        } else {
          rgb = window.getComputedStyle($link[0], null).getPropertyValue('background-color');
          hex = _this._convertRgbToHex(rgb);
        }
        if (!hex) {
          return;
        }
        range = _this.editor.selection.range();
        if (!$link.hasClass('font-color-default') && range.collapsed) {
          textNode = document.createTextNode(_this._t('coloredText'));
          range.insertNode(textNode);
          range.selectNodeContents(textNode);
          _this.editor.selection.range(range);
        }
        document.execCommand('styleWithCSS', false, true);
        document.execCommand('foreColor', false, hex);
        document.execCommand('styleWithCSS', false, false);
        if (!_this.editor.util.support.oninput) {
          return _this.editor.trigger('valuechanged');
        }
      };
    })(this));
  };

  ColorButton.prototype._convertRgbToHex = function(rgb) {
    var match, re, rgbToHex;
    re = /rgb\((\d+),\s?(\d+),\s?(\d+)\)/g;
    match = re.exec(rgb);
    if (!match) {
      return '';
    }
    rgbToHex = function(r, g, b) {
      var componentToHex;
      componentToHex = function(c) {
        var hex;
        hex = c.toString(16);
        if (hex.length === 1) {
          return '0' + hex;
        } else {
          return hex;
        }
      };
      return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
    };
    return rgbToHex(match[1] * 1, match[2] * 1, match[3] * 1);
  };

  return ColorButton;

})(Button);

Simditor.Toolbar.addButton(ColorButton);

ListButton = (function(superClass) {
  extend(ListButton, superClass);

  function ListButton() {
    return ListButton.__super__.constructor.apply(this, arguments);
  }

  ListButton.prototype.type = '';

  ListButton.prototype.disableTag = 'pre, table';

  ListButton.prototype.command = function(param) {
    var $list, $rootNodes, anotherType;
    $rootNodes = this.editor.selection.blockNodes();
    anotherType = this.type === 'ul' ? 'ol' : 'ul';
    this.editor.selection.save();
    $list = null;
    $rootNodes.each((function(_this) {
      return function(i, node) {
        var $node;
        $node = $(node);
        if ($node.is('blockquote, li') || $node.is(_this.disableTag) || _this.editor.util.isDecoratedNode($node) || !$.contains(document, node)) {
          return;
        }
        if ($node.is(_this.type)) {
          $node.children('li').each(function(i, li) {
            var $childList, $li;
            $li = $(li);
            $childList = $li.children('ul, ol').insertAfter($node);
            return $('<p/>').append($(li).html() || _this.editor.util.phBr).insertBefore($node);
          });
          return $node.remove();
        } else if ($node.is(anotherType)) {
          return $('<' + _this.type + '/>').append($node.contents()).replaceAll($node);
        } else if ($list && $node.prev().is($list)) {
          $('<li/>').append($node.html() || _this.editor.util.phBr).appendTo($list);
          return $node.remove();
        } else {
          $list = $("<" + _this.type + "><li></li></" + _this.type + ">");
          $list.find('li').append($node.html() || _this.editor.util.phBr);
          return $list.replaceAll($node);
        }
      };
    })(this));
    this.editor.selection.restore();
    return this.editor.trigger('valuechanged');
  };

  return ListButton;

})(Button);

OrderListButton = (function(superClass) {
  extend(OrderListButton, superClass);

  function OrderListButton() {
    return OrderListButton.__super__.constructor.apply(this, arguments);
  }

  OrderListButton.prototype.type = 'ol';

  OrderListButton.prototype.name = 'ol';

  OrderListButton.prototype.icon = 'list-ol';

  OrderListButton.prototype.htmlTag = 'ol';

  OrderListButton.prototype.shortcut = 'cmd+/';

  OrderListButton.prototype._init = function() {
    if (this.editor.util.os.mac) {
      this.title = this.title + ' ( Cmd + / )';
    } else {
      this.title = this.title + ' ( ctrl + / )';
      this.shortcut = 'ctrl+/';
    }
    return OrderListButton.__super__._init.call(this);
  };

  return OrderListButton;

})(ListButton);

Simditor.Toolbar.addButton(OrderListButton);

OrderListStyleButton = (function(superClass) { //mod-for-jl
  extend(OrderListStyleButton, superClass);

  function OrderListStyleButton() {
    return OrderListStyleButton.__super__.constructor.apply(this, arguments);
  }

  OrderListStyleButton.prototype.name = 'ols';

  OrderListStyleButton.prototype.icon = 'list-ul';

  OrderListStyleButton.prototype.type = 'ol';

  OrderListStyleButton.prototype.htmlTag = 'ol';

  OrderListStyleButton.prototype.disableTag = 'pre, table';

  OrderListStyleButton.prototype.menu = true;

  OrderListStyleButton.prototype.shortcut = 'cmd+/';

  OrderListStyleButton.prototype._init = function() {
    $.extend(this.editor.formatter._allowedStyles, {
      ol: ['list-style-type']
    });
    if (this.editor.util.os.mac) {
      this.title = this.title + ' ( Cmd + / )';
    } else {
      this.title = this.title + ' ( ctrl + / )';
      this.shortcut = 'ctrl+/';
    }
    return OrderListStyleButton.__super__._init.call(this);
  };

  OrderListStyleButton.prototype.renderMenu = function() {
    $("<div class=\"menu-create-list\">\n</div>\n<div class=\"menu-edit-list\">\n  <ul>\n    <li>\n      <a tabindex=\"-1\" unselectable=\"on\" class=\"menu-item\"\n        href=\"javascript:;\" data-param=\"listDisc\">\n        <span>" + (this._t('listDisc')) + "</span>\n      </a>\n    </li>\n    <li>\n      <a tabindex=\"-1\" unselectable=\"on\" class=\"menu-item\"\n        href=\"javascript:;\" data-param=\"listCircle\">\n        <span>" + (this._t('listCircle')) + " </span>\n      </a>\n    </li>\n    <li>\n      <a tabindex=\"-1\" unselectable=\"on\" class=\"menu-item\"\n        href=\"javascript:;\" data-param=\"listSquare\">\n        <span>" + (this._t('listSquare')) + "</span>\n      </a>\n    </li>\n    <li><span class=\"separator\"></span></li>\n    <li>\n      <a tabindex=\"-1\" unselectable=\"on\" class=\"menu-item\"\n        href=\"javascript:;\" data-param=\"listDecimal\">\n        <span>" + (this._t('listDecimal')) + " </span>\n      </a>\n    </li>\n    <li>\n      <a tabindex=\"-1\" unselectable=\"on\" class=\"menu-item\"\n        href=\"javascript:;\" data-param=\"listDecimal0\">\n        <span>" + (this._t('listDecimal0')) + " </span>\n      </a>\n    </li>\n    <li>\n      <a tabindex=\"-1\" unselectable=\"on\" class=\"menu-item\"\n        href=\"javascript:;\" data-param=\"listUpperRoman\">\n        <span>" + (this._t('listUpperRoman')) + " </span>\n      </a>\n    </li>\n    <li>\n      <a tabindex=\"-1\" unselectable=\"on\" class=\"menu-item\"\n        href=\"javascript:;\" data-param=\"listLowerRoman\">\n        <span>" + (this._t('listLowerRoman')) + "</span>\n      </a>\n    </li>\n    <li><span class=\"separator\"></span></li>\n    <li>\n      <a tabindex=\"-1\" unselectable=\"on\" class=\"menu-item\"\n        href=\"javascript:;\" data-param=\"listUpperAlpha\">\n        <span>" + (this._t('listUpperAlpha')) + " </span>\n      </a>\n    </li>\n    <li>\n      <a tabindex=\"-1\" unselectable=\"on\" class=\"menu-item\"\n        href=\"javascript:;\" data-param=\"listLowerAlpha\">\n        <span>" + (this._t('listLowerAlpha')) + " </span>\n      </a>\n    </li>\n    <li>\n      <a tabindex=\"-1\" unselectable=\"on\" class=\"menu-item\"\n        href=\"javascript:;\" data-param=\"listGreek\">\n        <span>" + (this._t('listGreek')) + " </span>\n      </a>\n    </li>\n    <li>\n      <a tabindex=\"-1\" unselectable=\"on\" class=\"menu-item\"\n        href=\"javascript:;\" data-param=\"toggleList\">\n        <span>" + (this._t('toggleList')) + " </span>\n      </a>\n    </li>\n    </ul>\n</div>").appendTo(this.menuWrapper);
    this.createMenu = this.menuWrapper.find('.menu-create-list');
    this.editMenu = this.menuWrapper.find('.menu-edit-list');
  };

  OrderListStyleButton.prototype.command = function(param) {//mod-for-jl
    var $ol, type, sw_mod;
    type = {
        'listDisc': 'disc',
        'listCircle': 'circle',
        'listSquare': 'square',
        'listDecimal': 'decimal',
        'listDecimal0': 'decimal-leading-zero',
        'listUpperRoman': 'upper-roman',
        'listLowerRoman': 'lower-roman',
        'listUpperAlpha': 'upper-alpha',
        'listLowerAlpha': 'lower-alpha',
        'listGreek': 'lower-greek',
    };

    $ol = this.editor.selection.containerNode();
    if (type[param]) {
      while(!$ol.is('ol')){
        if($ol.is('div.simditor-body')) break;
        $ol = $ol.parent();
      }
      if(!$ol.is('div.simditor-body')) {
        $ol.css('list-style-type', type[param])
        return this.editor.trigger('valuechanged');
      }
    }

    // codigo copeado de listButton
    var $list, $rootNodes, anotherType;
    $rootNodes = this.editor.selection.blockNodes();
    anotherType = this.type === 'ul' ? 'ol' : 'ul';
    this.editor.selection.save();
    $list = null;
    $rootNodes.each((function(_this) {
      return function(i, node) {
        var $node;
        $node = $(node);
        if ($node.is('blockquote, li') || $node.is(_this.disableTag) || _this.editor.util.isDecoratedNode($node) || !$.contains(document, node)) {
          return;
        }
        if ($node.is(_this.type)) {
          $node.children('li').each(function(i, li) {
            var $childList, $li;
            $li = $(li);
            $childList = $li.children('ul, ol').insertAfter($node);
            return $('<p/>').append($(li).html() || _this.editor.util.phBr).insertBefore($node);
          });
          return $node.remove();
        } else if ($node.is(anotherType)) {
          return $('<' + _this.type + '/>').append($node.contents()).replaceAll($node);
        } else if ($list && $node.prev().is($list)) {
          $('<li/>').append($node.html() || _this.editor.util.phBr).appendTo($list);
          return $node.remove();
        } else {
          $list = $("<" + _this.type + "><li></li></" + _this.type + ">");
          $list.find('li').append($node.html() || _this.editor.util.phBr);
          return $list.replaceAll($node);
        }
      };
    })(this));
    this.editor.selection.restore();

    if (type[param] && $list) { $list.css('list-style-type', type[param]) }

    return this.editor.trigger('valuechanged');
  };

  return OrderListStyleButton;

})(Button);

Simditor.Toolbar.addButton(OrderListStyleButton);//mod-for-jl

/*
OrderListButton = (function(superClass) {
  extend(OrderListButton, superClass);

  function OrderListButton() {
    return OrderListButton.__super__.constructor.apply(this, arguments);
  }

  OrderListButton.prototype.type = 'ol';

  OrderListButton.prototype.name = 'ol';

  OrderListButton.prototype.icon = 'list-ol';

  OrderListButton.prototype.htmlTag = 'ol';

  OrderListButton.prototype.shortcut = 'cmd+/';

  OrderListButton.prototype._init = function() {
    if (this.editor.util.os.mac) {
      this.title = this.title + ' ( Cmd + / )';
    } else {
      this.title = this.title + ' ( ctrl + / )';
      this.shortcut = 'ctrl+/';
    }
    return OrderListButton.__super__._init.call(this);
  };

  return OrderListButton;

})(ListButton);
UnorderListButton = (function(superClass) {
  extend(UnorderListButton, superClass);

  function UnorderListButton() {
    return UnorderListButton.__super__.constructor.apply(this, arguments);
  }

  UnorderListButton.prototype.type = 'ul';

  UnorderListButton.prototype.name = 'ul';

  UnorderListButton.prototype.icon = 'list-ul';

  UnorderListButton.prototype.htmlTag = 'ul';

  UnorderListButton.prototype.shortcut = 'cmd+.';

  UnorderListButton.prototype._init = function() {
    if (this.editor.util.os.mac) {
      this.title = this.title + ' ( Cmd + . )';
    } else {
      this.title = this.title + ' ( Ctrl + . )';
      this.shortcut = 'ctrl+.';
    }
    return UnorderListButton.__super__._init.call(this);
  };

  return UnorderListButton;

})(ListButton);
Simditor.Toolbar.addButton(OrderListButton);
Simditor.Toolbar.addButton(UnorderListButton);
*/
BlockquoteButton = (function(superClass) {
  extend(BlockquoteButton, superClass);

  function BlockquoteButton() {
    return BlockquoteButton.__super__.constructor.apply(this, arguments);
  }

  BlockquoteButton.prototype.name = 'blockquote';

  BlockquoteButton.prototype.icon = 'quote-left';

  BlockquoteButton.prototype.htmlTag = 'blockquote';

  BlockquoteButton.prototype.disableTag = 'pre, table';

  BlockquoteButton.prototype.command = function() {
    var $rootNodes, clearCache, nodeCache;
    $rootNodes = this.editor.selection.rootNodes();
    $rootNodes = $rootNodes.filter(function(i, node) {
      return !$(node).parent().is('blockquote');
    });
    this.editor.selection.save();
    nodeCache = [];
    clearCache = (function(_this) {
      return function() {
        if (nodeCache.length > 0) {
          $("<" + _this.htmlTag + "/>").insertBefore(nodeCache[0]).append(nodeCache);
          return nodeCache.length = 0;
        }
      };
    })(this);
    $rootNodes.each((function(_this) {
      return function(i, node) {
        var $node;
        $node = $(node);
        if (!$node.parent().is(_this.editor.body)) {
          return;
        }
        if ($node.is(_this.htmlTag)) {
          clearCache();
          return $node.children().unwrap();
        } else if ($node.is(_this.disableTag) || _this.editor.util.isDecoratedNode($node)) {
          return clearCache();
        } else {
          return nodeCache.push(node);
        }
      };
    })(this));
    clearCache();
    this.editor.selection.restore();
    return this.editor.trigger('valuechanged');
  };

  return BlockquoteButton;

})(Button);

Simditor.Toolbar.addButton(BlockquoteButton);

CodeButton = (function(superClass) {
  extend(CodeButton, superClass);

  function CodeButton() {
    return CodeButton.__super__.constructor.apply(this, arguments);
  }

  CodeButton.prototype.name = 'code';

  CodeButton.prototype.icon = 'code';

  CodeButton.prototype.htmlTag = 'pre';

  CodeButton.prototype.disableTag = 'ul, ol, table';

  CodeButton.prototype._init = function() {
    CodeButton.__super__._init.call(this);
    this.editor.on('decorate', (function(_this) {
      return function(e, $el) {
        return $el.find('pre').each(function(i, pre) {
          return _this.decorate($(pre));
        });
      };
    })(this));
    return this.editor.on('undecorate', (function(_this) {
      return function(e, $el) {
        return $el.find('pre').each(function(i, pre) {
          return _this.undecorate($(pre));
        });
      };
    })(this));
  };

  CodeButton.prototype.render = function() {
    var args;
    args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
    CodeButton.__super__.render.apply(this, args);
    return this.popover = new CodePopover({
      button: this
    });
  };

  CodeButton.prototype._checkMode = function() {
    var $blockNodes, range;
    range = this.editor.selection.range();
    if (($blockNodes = $(range.cloneContents()).find(this.editor.util.blockNodes.join(','))) > 0 || (range.collapsed && this.editor.selection.startNodes().filter('code').length === 0)) {
      this.inlineMode = false;
      return this.htmlTag = 'pre';
    } else {
      this.inlineMode = true;
      return this.htmlTag = 'code';
    }
  };

  CodeButton.prototype._status = function() {
    this._checkMode();
    CodeButton.__super__._status.call(this);
    if (this.inlineMode) {
      return;
    }
    if (this.active) {
      return this.popover.show(this.node);
    } else {
      return this.popover.hide();
    }
  };

  CodeButton.prototype.decorate = function($pre) {
    var $code, lang, ref, ref1;
    $code = $pre.find('> code');
    if ($code.length > 0) {
      lang = (ref = $code.attr('class')) != null ? (ref1 = ref.match(/lang-(\S+)/)) != null ? ref1[1] : void 0 : void 0;
      $code.contents().unwrap();
      if (lang) {
        return $pre.attr('data-lang', lang);
      }
    }
  };

  CodeButton.prototype.undecorate = function($pre) {
    var $code, lang;
    lang = $pre.attr('data-lang');
    $code = $('<code/>');
    if (lang && lang !== -1) {
      $code.addClass('lang-' + lang);
    }
    return $pre.wrapInner($code).removeAttr('data-lang');
  };

  CodeButton.prototype.command = function() {
    if (this.inlineMode) {
      return this._inlineCommand();
    } else {
      return this._blockCommand();
    }
  };

  CodeButton.prototype._blockCommand = function() {
    var $rootNodes, clearCache, nodeCache, resultNodes;
    $rootNodes = this.editor.selection.rootNodes();
    nodeCache = [];
    resultNodes = [];
    clearCache = (function(_this) {
      return function() {
        var $pre;
        if (!(nodeCache.length > 0)) {
          return;
        }
        $pre = $("<" + _this.htmlTag + "/>").insertBefore(nodeCache[0]).text(_this.editor.formatter.clearHtml(nodeCache));
        resultNodes.push($pre[0]);
        return nodeCache.length = 0;
      };
    })(this);
    $rootNodes.each((function(_this) {
      return function(i, node) {
        var $node, $p;
        $node = $(node);
        if ($node.is(_this.htmlTag)) {
          clearCache();
          $p = $('<p/>').append($node.html().replace('\n', '<br/>')).replaceAll($node);
          return resultNodes.push($p[0]);
        } else if ($node.is(_this.disableTag) || _this.editor.util.isDecoratedNode($node) || $node.is('blockquote')) {
          return clearCache();
        } else {
          return nodeCache.push(node);
        }
      };
    })(this));
    clearCache();
    this.editor.selection.setRangeAtEndOf($(resultNodes).last());
    return this.editor.trigger('valuechanged');
  };

  CodeButton.prototype._inlineCommand = function() {
    var $code, $contents, range;
    range = this.editor.selection.range();
    if (this.active) {
      range.selectNodeContents(this.node[0]);
      this.editor.selection.save(range);
      this.node.contents().unwrap();
      this.editor.selection.restore();
    } else {
      $contents = $(range.extractContents());
      $code = $("<" + this.htmlTag + "/>").append($contents.contents());
      range.insertNode($code[0]);
      range.selectNodeContents($code[0]);
      this.editor.selection.range(range);
    }
    return this.editor.trigger('valuechanged');
  };

  return CodeButton;

})(Button);

CodePopover = (function(superClass) {
  extend(CodePopover, superClass);

  function CodePopover() {
    return CodePopover.__super__.constructor.apply(this, arguments);
  }

  CodePopover.prototype.render = function() {
    var $option, k, lang, len, ref;
    this._tpl = "<div class=\"code-settings\">\n  <div class=\"settings-field\">\n    <select class=\"select-lang\">\n      <option value=\"-1\">" + (this._t('selectLanguage')) + "</option>\n    </select>\n  </div>\n</div>";
    this.langs = this.editor.opts.codeLanguages || [
      {
        name: 'Bash',
        value: 'bash'
      }, {
        name: 'C++',
        value: 'c++'
      }, {
        name: 'C#',
        value: 'cs'
      }, {
        name: 'CSS',
        value: 'css'
      }, {
        name: 'Erlang',
        value: 'erlang'
      }, {
        name: 'Less',
        value: 'less'
      }, {
        name: 'Sass',
        value: 'sass'
      }, {
        name: 'Diff',
        value: 'diff'
      }, {
        name: 'CoffeeScript',
        value: 'coffeescript'
      }, {
        name: 'HTML,XML',
        value: 'html'
      }, {
        name: 'JSON',
        value: 'json'
      }, {
        name: 'Java',
        value: 'java'
      }, {
        name: 'JavaScript',
        value: 'js'
      }, {
        name: 'Markdown',
        value: 'markdown'
      }, {
        name: 'Objective C',
        value: 'oc'
      }, {
        name: 'PHP',
        value: 'php'
      }, {
        name: 'Perl',
        value: 'parl'
      }, {
        name: 'Python',
        value: 'python'
      }, {
        name: 'Ruby',
        value: 'ruby'
      }, {
        name: 'SQL',
        value: 'sql'
      }
    ];
    this.el.addClass('code-popover').append(this._tpl);
    this.selectEl = this.el.find('.select-lang');
    ref = this.langs;
    for (k = 0, len = ref.length; k < len; k++) {
      lang = ref[k];
      $option = $('<option/>', {
        text: lang.name,
        value: lang.value
      }).appendTo(this.selectEl);
    }
    this.selectEl.on('change', (function(_this) {
      return function(e) {
        var selected;
        _this.lang = _this.selectEl.val();
        selected = _this.target.hasClass('selected');
        _this.target.removeClass().removeAttr('data-lang');
        if (_this.lang !== -1) {
          _this.target.attr('data-lang', _this.lang);
        }
        if (selected) {
          _this.target.addClass('selected');
        }
        return _this.editor.trigger('valuechanged');
      };
    })(this));
    return this.editor.on('valuechanged', (function(_this) {
      return function(e) {
        if (_this.active) {
          return _this.refresh();
        }
      };
    })(this));
  };

  CodePopover.prototype.show = function() {
    var args;
    args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
    CodePopover.__super__.show.apply(this, args);
    this.lang = this.target.attr('data-lang');
    if (this.lang != null) {
      return this.selectEl.val(this.lang);
    } else {
      return this.selectEl.val(-1);
    }
  };

  return CodePopover;

})(Popover);

Simditor.Toolbar.addButton(CodeButton);

LinkButton = (function(superClass) {
  extend(LinkButton, superClass);

  function LinkButton() {
    return LinkButton.__super__.constructor.apply(this, arguments);
  }

  LinkButton.prototype.name = 'link';

  LinkButton.prototype.icon = 'link';

  LinkButton.prototype.htmlTag = 'a';

  LinkButton.prototype.disableTag = 'pre';

  LinkButton.prototype.render = function() {
    var args;
    args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
    LinkButton.__super__.render.apply(this, args);
    return this.popover = new LinkPopover({
      button: this
    });
  };

  LinkButton.prototype._status = function() {
    LinkButton.__super__._status.call(this);
    if (this.active && !this.editor.selection.rangeAtEndOf(this.node)) {
      return this.popover.show(this.node);
    } else {
      return this.popover.hide();
    }
  };

  LinkButton.prototype.command = function() {
    var $contents, $link, $newBlock, linkText, range, txtNode;
    range = this.editor.selection.range();
    if (this.active) {
      txtNode = document.createTextNode(this.node.text());
      this.node.replaceWith(txtNode);
      range.selectNode(txtNode);
    } else {
      $contents = $(range.extractContents());
      linkText = this.editor.formatter.clearHtml($contents.contents(), false);
      $link = $('<a/>', {
        href: 'http://www.example.com',
        target: '_blank',
        text: linkText || this._t('linkText')
      });
      if (this.editor.selection.blockNodes().length > 0) {
        range.insertNode($link[0]);
      } else {
        $newBlock = $('<p/>').append($link);
        range.insertNode($newBlock[0]);
      }
      range.selectNodeContents($link[0]);
      this.popover.one('popovershow', (function(_this) {
        return function() {
          if (linkText) {
            _this.popover.urlEl.focus();
            return _this.popover.urlEl[0].select();
          } else {
            _this.popover.textEl.focus();
            return _this.popover.textEl[0].select();
          }
        };
      })(this));
    }
    this.editor.selection.range(range);
    return this.editor.trigger('valuechanged');
  };

  return LinkButton;

})(Button);

LinkPopover = (function(superClass) {
  extend(LinkPopover, superClass);

  function LinkPopover() {
    return LinkPopover.__super__.constructor.apply(this, arguments);
  }

  LinkPopover.prototype.render = function() {
    var tpl;
    tpl = "<div class=\"link-settings\">\n  <div class=\"settings-field\">\n    <label>" + (this._t('linkText')) + "</label>\n    <input class=\"link-text\" type=\"text\"/>\n    <a class=\"btn-unlink\" href=\"javascript:;\" title=\"" + (this._t('removeLink')) + "\"\n      tabindex=\"-1\">\n      <span class=\"simditor-icon simditor-icon-unlink\"></span>\n    </a>\n  </div>\n  <div class=\"settings-field\">\n    <label>" + (this._t('linkUrl')) + "</label>\n    <input class=\"link-url\" type=\"text\"/>\n  </div>\n  <div class=\"settings-field\">\n    <label>" + (this._t('linkTarget')) + "</label>\n    <select class=\"link-target\">\n      <option value=\"_blank\">" + (this._t('openLinkInNewWindow')) + " (_blank)</option>\n      <option value=\"_self\">" + (this._t('openLinkInCurrentWindow')) + " (_self)</option>\n    </select>\n  </div>\n</div>";
    this.el.addClass('link-popover').append(tpl);
    this.textEl = this.el.find('.link-text');
    this.urlEl = this.el.find('.link-url');
    this.unlinkEl = this.el.find('.btn-unlink');
    this.selectTarget = this.el.find('.link-target');
    this.textEl.on('keyup', (function(_this) {
      return function(e) {
        if (e.which === 13) {
          return;
        }
        _this.target.text(_this.textEl.val());
        return _this.editor.inputManager.throttledValueChanged();
      };
    })(this));
    this.urlEl.on('keyup', (function(_this) {
      return function(e) {
        var val;
        if (e.which === 13) {
          return;
        }
        val = _this.urlEl.val();
        if (!(/https?:\/\/|^\//ig.test(val) || !val)) {
          val = 'http://' + val;
        }
        _this.target.attr('href', val);
        return _this.editor.inputManager.throttledValueChanged();
      };
    })(this));
    $([this.urlEl[0], this.textEl[0]]).on('keydown', (function(_this) {
      return function(e) {
        var range;
        if (e.which === 13 || e.which === 27 || (!e.shiftKey && e.which === 9 && $(e.target).hasClass('link-url'))) {
          e.preventDefault();
          range = document.createRange();
          _this.editor.selection.setRangeAfter(_this.target, range);
          _this.hide();
          return _this.editor.inputManager.throttledValueChanged();
        }
      };
    })(this));
    this.unlinkEl.on('click', (function(_this) {
      return function(e) {
        var range, txtNode;
        txtNode = document.createTextNode(_this.target.text());
        _this.target.replaceWith(txtNode);
        _this.hide();
        range = document.createRange();
        _this.editor.selection.setRangeAfter(txtNode, range);
        return _this.editor.inputManager.throttledValueChanged();
      };
    })(this));
    return this.selectTarget.on('change', (function(_this) {
      return function(e) {
        _this.target.attr('target', _this.selectTarget.val());
        return _this.editor.inputManager.throttledValueChanged();
      };
    })(this));
  };

  LinkPopover.prototype.show = function() {
    var args;
    args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
    LinkPopover.__super__.show.apply(this, args);
    this.textEl.val(this.target.text());
    return this.urlEl.val(this.target.attr('href'));
  };

  return LinkPopover;

})(Popover);

Simditor.Toolbar.addButton(LinkButton);

ImageButton = (function(superClass) {
  extend(ImageButton, superClass);

  function ImageButton() {
    return ImageButton.__super__.constructor.apply(this, arguments);
  }

  ImageButton.prototype.name = 'image';

  ImageButton.prototype.icon = 'picture-o';

  ImageButton.prototype.htmlTag = 'img';

  ImageButton.prototype.disableTag = 'pre, table';

  ImageButton.prototype.defaultImage = '';

  ImageButton.prototype.needFocus = false;

  ImageButton.prototype._init = function() {
    var item, k, len, ref;
    if (this.editor.opts.imageButton) {
      if (Array.isArray(this.editor.opts.imageButton)) {
        this.menu = [];
        ref = this.editor.opts.imageButton;
        for (k = 0, len = ref.length; k < len; k++) {
          item = ref[k];
          this.menu.push({
            name: item + '-image',
            text: this._t(item + 'Image')
          });
        }
      } else {
        this.menu = false;
      }
    } else {
      if (this.editor.uploader != null) {
        this.menu = [
          {
            name: 'upload-image',
            text: this._t('uploadImage')
          }, {
            name: 'external-image',
            text: this._t('externalImage')
          }
        ];
      } else {
        this.menu = false;
      }
    }
    this.defaultImage = this.editor.opts.defaultImage;
    this.editor.body.on('click', 'img:not([data-non-image])', (function(_this) {
      return function(e) {
        var $img, range;
        $img = $(e.currentTarget);
        range = document.createRange();
        range.selectNode($img[0]);
        _this.editor.selection.range(range);
        if (!_this.editor.util.support.onselectionchange) {
          _this.editor.trigger('selectionchanged');
        }
        return false;
      };
    })(this));
    this.editor.body.on('mouseup', 'img:not([data-non-image])', function(e) {
      return false;
    });
    this.editor.on('selectionchanged.image', (function(_this) {
      return function() {
        var $contents, $img, range;
        range = _this.editor.selection.range();
        if (range == null) {
          return;
        }
        $contents = $(range.cloneContents()).contents();
        if ($contents.length === 1 && $contents.is('img:not([data-non-image])')) {
          $img = $(range.startContainer).contents().eq(range.startOffset);
          return _this.popover.show($img);
        } else {
          return _this.popover.hide();
        }
      };
    })(this));
    this.editor.on('valuechanged.image', (function(_this) {
      return function() {
        var $masks;
        $masks = _this.editor.wrapper.find('.simditor-image-loading');
        if (!($masks.length > 0)) {
          return;
        }
        return $masks.each(function(i, mask) {
          var $img, $mask, file;
          $mask = $(mask);
          $img = $mask.data('img');
          if (!($img && $img.parent().length > 0)) {
            $mask.remove();
            if ($img) {
              file = $img.data('file');
              if (file) {
                _this.editor.uploader.cancel(file);
                if (_this.editor.body.find('img.uploading').length < 1) {
                  return _this.editor.uploader.trigger('uploadready', [file]);
                }
              }
            }
          }
        });
      };
    })(this));
    return ImageButton.__super__._init.call(this);
  };

  ImageButton.prototype.render = function() {
    var args;
    args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
    ImageButton.__super__.render.apply(this, args);
    this.popover = new ImagePopover({
      button: this
    });
    if (this.editor.opts.imageButton === 'upload') {
      return this._initUploader(this.el);
    }
  };

  ImageButton.prototype.renderMenu = function() {
    ImageButton.__super__.renderMenu.call(this);
    return this._initUploader();
  };

  ImageButton.prototype._initUploader = function($uploadItem) {
    var $input, createInput, uploadProgress;
    if ($uploadItem == null) {
      $uploadItem = this.menuEl.find('.menu-item-upload-image');
    }
    if (this.editor.uploader == null) {
      this.el.find('.btn-upload').remove();
      return;
    }
    $input = null;
    createInput = (function(_this) {
      return function() {
        if ($input) {
          $input.remove();
        }
        return $input = $('<input/>', {
          type: 'file',
          title: _this._t('uploadImage'),
          multiple: true,
          accept: 'image/*'
        }).appendTo($uploadItem);
      };
    })(this);
    createInput();
    $uploadItem.on('click mousedown', 'input[type=file]', function(e) {
      return e.stopPropagation();
    });
    $uploadItem.on('change', 'input[type=file]', (function(_this) {
      return function(e) {
        if (_this.editor.inputManager.focused) {
          _this.editor.uploader.upload($input, {
            inline: true
          });
          createInput();
        } else {
          _this.editor.one('focus', function(e) {
            _this.editor.uploader.upload($input, {
              inline: true
            });
            return createInput();
          });
          _this.editor.focus();
        }
        return _this.wrapper.removeClass('menu-on');
      };
    })(this));
    this.editor.uploader.on('beforeupload', (function(_this) {
      return function(e, file) {
        var $img;
        if (!file.inline) {
          return;
        }
        if (file.img) {
          $img = $(file.img);
        } else {
          $img = _this.createImage(file.name);
          file.img = $img;
        }
        $img.addClass('uploading');
        $img.data('file', file);
        return _this.editor.uploader.readImageFile(file.obj, function(img) {
          var src;
          if (!$img.hasClass('uploading')) {
            return;
          }
          src = img ? img.src : _this.defaultImage;
          return _this.loadImage($img, src, function() {
            if (_this.popover.active) {
              _this.popover.refresh();
              return _this.popover.srcEl.val(_this._t('uploading')).prop('disabled', true);
            }
          });
        });
      };
    })(this));
    uploadProgress = $.proxy(this.editor.util.throttle(function(e, file, loaded, total) {
      var $img, $mask, percent;
      if (!file.inline) {
        return;
      }
      $mask = file.img.data('mask');
      if (!$mask) {
        return;
      }
      $img = $mask.data('img');
      if (!($img.hasClass('uploading') && $img.parent().length > 0)) {
        $mask.remove();
        return;
      }
      percent = loaded / total;
      percent = (percent * 100).toFixed(0);
      if (percent > 99) {
        percent = 99;
      }
      return $mask.find('.progress').height((100 - percent) + "%");
    }, 500), this);
    this.editor.uploader.on('uploadprogress', uploadProgress);
    this.editor.uploader.on('uploadsuccess', (function(_this) {
      return function(e, file, result) {
        var $img, img_path, msg;
        if (!file.inline) {
          return;
        }
        $img = file.img;
        if (!($img.hasClass('uploading') && $img.parent().length > 0)) {
          return;
        }
        if (typeof result !== 'object') {
          try {
            result = $.parseJSON(result);
          } catch (_error) {
            e = _error;
            result = {
              success: false
            };
          }
        }
        if (result.success === false) {
          msg = result.msg || _this._t('uploadFailed');
          alert(msg);
          img_path = _this.defaultImage;
        } else {
          img_path = result.file_path;
        }
        _this.loadImage($img, img_path, function() {
          var $mask;
          $img.removeData('file');
          $img.removeClass('uploading').removeClass('loading');
          $mask = $img.data('mask');
          if ($mask) {
            $mask.remove();
          }
          $img.removeData('mask');
          _this.editor.trigger('valuechanged');
          if (_this.editor.body.find('img.uploading').length < 1) {
            return _this.editor.uploader.trigger('uploadready', [file, result]);
          }
        });
        if (_this.popover.active) {
          _this.popover.srcEl.prop('disabled', false);
          return _this.popover.srcEl.val(result.file_path);
        }
      };
    })(this));
    return this.editor.uploader.on('uploaderror', (function(_this) {
      return function(e, file, xhr) {
        var $img, msg, result;
        if (!file.inline) {
          return;
        }
        if (xhr.statusText === 'abort') {
          return;
        }
        if (xhr.responseText) {
          try {
            result = $.parseJSON(xhr.responseText);
            msg = result.msg;
          } catch (_error) {
            e = _error;
            msg = _this._t('uploadError');
          }
          alert(msg);
        }
        $img = file.img;
        if (!($img.hasClass('uploading') && $img.parent().length > 0)) {
          return;
        }
        _this.loadImage($img, _this.defaultImage, function() {
          var $mask;
          $img.removeData('file');
          $img.removeClass('uploading').removeClass('loading');
          $mask = $img.data('mask');
          if ($mask) {
            $mask.remove();
          }
          return $img.removeData('mask');
        });
        if (_this.popover.active) {
          _this.popover.srcEl.prop('disabled', false);
          _this.popover.srcEl.val(_this.defaultImage);
        }
        _this.editor.trigger('valuechanged');
        if (_this.editor.body.find('img.uploading').length < 1) {
          return _this.editor.uploader.trigger('uploadready', [file, result]);
        }
      };
    })(this));
  };

  ImageButton.prototype._status = function() {
    return this._disableStatus();
  };

  ImageButton.prototype.loadImage = function($img, src, callback) {
    var $mask, img, positionMask;
    positionMask = (function(_this) {
      return function() {
        var imgOffset, wrapperOffset;
        imgOffset = $img.offset();
        wrapperOffset = _this.editor.wrapper.offset();
        return $mask.css({
          top: imgOffset.top - wrapperOffset.top,
          left: imgOffset.left - wrapperOffset.left,
          width: $img.width(),
          height: $img.height()
        }).show();
      };
    })(this);
    $img.addClass('loading');
    $mask = $img.data('mask');
    if (!$mask) {
      $mask = $('<div class="simditor-image-loading">\n  <div class="progress"></div>\n</div>').hide().appendTo(this.editor.wrapper);
      positionMask();
      $img.data('mask', $mask);
      $mask.data('img', $img);
    }
    img = new Image();
    img.onload = (function(_this) {
      return function() {
        var height, width;
        if (!$img.hasClass('loading') && !$img.hasClass('uploading')) {
          return;
        }
        width = img.width;
        height = img.height;
        $img.attr({
          src: src,
          width: width,
          height: height,
          'data-image-size': width + ',' + height
        }).removeClass('loading');
        if ($img.hasClass('uploading')) {
          _this.editor.util.reflow(_this.editor.body);
          positionMask();
        } else {
          $mask.remove();
          $img.removeData('mask');
        }
        if ($.isFunction(callback)) {
          return callback(img);
        }
      };
    })(this);
    img.onerror = function() {
      if ($.isFunction(callback)) {
        callback(false);
      }
      $mask.remove();
      return $img.removeData('mask').removeClass('loading');
    };
    return img.src = src;
  };

  ImageButton.prototype.createImage = function(name) {
    var $img, range;
    if (name == null) {
      name = 'Image';
    }
    if (!this.editor.inputManager.focused) {
      this.editor.focus();
    }
    range = this.editor.selection.range();
    range.deleteContents();
    this.editor.selection.range(range);
    $img = $('<img/>').attr('alt', name);
    range.insertNode($img[0]);
    this.editor.selection.setRangeAfter($img, range);
    this.editor.trigger('valuechanged');
    return $img;
  };

  ImageButton.prototype.command = function(src) {
    var $img;
    $img = this.createImage();
    return this.loadImage($img, src || this.defaultImage, (function(_this) {
      return function() {
        _this.editor.trigger('valuechanged');
        _this.editor.util.reflow($img);
        $img.click();
        return _this.popover.one('popovershow', function() {
          _this.popover.srcEl.focus();
          return _this.popover.srcEl[0].select();
        });
      };
    })(this));
  };

  return ImageButton;

})(Button);

ImagePopover = (function(superClass) {
  extend(ImagePopover, superClass);

  function ImagePopover() {
    return ImagePopover.__super__.constructor.apply(this, arguments);
  }

  ImagePopover.prototype.offset = {
    top: 6,
    left: -4
  };

  ImagePopover.prototype.render = function() {
    var tpl;
    tpl = "<div class=\"link-settings\">\n  <div class=\"settings-field\">\n    <label>" + (this._t('imageUrl')) + "</label>\n    <input class=\"image-src\" type=\"text\" tabindex=\"1\" />\n    <a class=\"btn-upload\" href=\"javascript:;\"\n      title=\"" + (this._t('uploadImage')) + "\" tabindex=\"-1\">\n      <span class=\"simditor-icon simditor-icon-upload\"></span>\n    </a>\n  </div>\n  <div class='settings-field'>\n    <label>" + (this._t('imageAlt')) + "</label>\n    <input class=\"image-alt\" id=\"image-alt\" type=\"text\" tabindex=\"1\" />\n  </div>\n  <div class=\"settings-field\">\n    <label>" + (this._t('imageSize')) + "</label>\n    <input class=\"image-size\" id=\"image-width\" type=\"text\" tabindex=\"2\" />\n    <span class=\"times\">×</span>\n    <input class=\"image-size\" id=\"image-height\" type=\"text\" tabindex=\"3\" />\n    <a class=\"btn-restore\" href=\"javascript:;\"\n      title=\"" + (this._t('restoreImageSize')) + "\" tabindex=\"-1\">\n      <span class=\"simditor-icon simditor-icon-undo\"></span>\n    </a>\n  </div>\n</div>";
    this.el.addClass('image-popover').append(tpl);
    this.srcEl = this.el.find('.image-src');
    this.widthEl = this.el.find('#image-width');
    this.heightEl = this.el.find('#image-height');
    this.altEl = this.el.find('#image-alt');
    this.srcEl.on('keydown', (function(_this) {
      return function(e) {
        var range;
        if (!(e.which === 13 && !_this.target.hasClass('uploading'))) {
          return;
        }
        e.preventDefault();
        range = document.createRange();
        _this.button.editor.selection.setRangeAfter(_this.target, range);
        return _this.hide();
      };
    })(this));
    this.srcEl.on('blur', (function(_this) {
      return function(e) {
        return _this._loadImage(_this.srcEl.val());
      };
    })(this));
    this.el.find('.image-size').on('blur', (function(_this) {
      return function(e) {
        _this._resizeImg($(e.currentTarget));
        return _this.el.data('popover').refresh();
      };
    })(this));
    this.el.find('.image-size').on('keyup', (function(_this) {
      return function(e) {
        var inputEl;
        inputEl = $(e.currentTarget);
        if (!(e.which === 13 || e.which === 27 || e.which === 9)) {
          return _this._resizeImg(inputEl, true);
        }
      };
    })(this));
    this.el.find('.image-size').on('keydown', (function(_this) {
      return function(e) {
        var $img, inputEl, range;
        inputEl = $(e.currentTarget);
        if (e.which === 13 || e.which === 27) {
          e.preventDefault();
          if (e.which === 13) {
            _this._resizeImg(inputEl);
          } else {
            _this._restoreImg();
          }
          $img = _this.target;
          _this.hide();
          range = document.createRange();
          return _this.button.editor.selection.setRangeAfter($img, range);
        } else if (e.which === 9) {
          return _this.el.data('popover').refresh();
        }
      };
    })(this));
    this.altEl.on('keydown', (function(_this) {
      return function(e) {
        var range;
        if (e.which === 13) {
          e.preventDefault();
          range = document.createRange();
          _this.button.editor.selection.setRangeAfter(_this.target, range);
          return _this.hide();
        }
      };
    })(this));
    this.altEl.on('keyup', (function(_this) {
      return function(e) {
        if (e.which === 13 || e.which === 27 || e.which === 9) {
          return;
        }
        _this.alt = _this.altEl.val();
        return _this.target.attr('alt', _this.alt);
      };
    })(this));
    this.el.find('.btn-restore').on('click', (function(_this) {
      return function(e) {
        _this._restoreImg();
        return _this.el.data('popover').refresh();
      };
    })(this));
    this.editor.on('valuechanged', (function(_this) {
      return function(e) {
        if (_this.active) {
          return _this.refresh();
        }
      };
    })(this));
    return this._initUploader();
  };

  ImagePopover.prototype._initUploader = function() {
    var $uploadBtn, createInput;
    $uploadBtn = this.el.find('.btn-upload');
    if (this.editor.uploader == null) {
      $uploadBtn.remove();
      return;
    }
    createInput = (function(_this) {
      return function() {
        if (_this.input) {
          _this.input.remove();
        }
        return _this.input = $('<input/>', {
          type: 'file',
          title: _this._t('uploadImage'),
          multiple: true,
          accept: 'image/*'
        }).appendTo($uploadBtn);
      };
    })(this);
    createInput();
    this.el.on('click mousedown', 'input[type=file]', function(e) {
      return e.stopPropagation();
    });
    return this.el.on('change', 'input[type=file]', (function(_this) {
      return function(e) {
        _this.editor.uploader.upload(_this.input, {
          inline: true,
          img: _this.target
        });
        return createInput();
      };
    })(this));
  };

  ImagePopover.prototype._resizeImg = function(inputEl, onlySetVal) {
    var height, value, width;
    if (onlySetVal == null) {
      onlySetVal = false;
    }
    value = inputEl.val() * 1;
    if (!(this.target && ($.isNumeric(value) || value < 0))) {
      return;
    }
    if (inputEl.is(this.widthEl)) {
      width = value;
      height = this.height * value / this.width;
      this.heightEl.val(height);
    } else {
      height = value;
      width = this.width * value / this.height;
      this.widthEl.val(width);
    }
    if (!onlySetVal) {
      this.target.attr({
        width: width,
        height: height
      });
      return this.editor.trigger('valuechanged');
    }
  };

  ImagePopover.prototype._restoreImg = function() {
    var ref, size;
    size = ((ref = this.target.data('image-size')) != null ? ref.split(",") : void 0) || [this.width, this.height];
    this.target.attr({
      width: size[0] * 1,
      height: size[1] * 1
    });
    this.widthEl.val(size[0]);
    this.heightEl.val(size[1]);
    return this.editor.trigger('valuechanged');
  };

  ImagePopover.prototype._loadImage = function(src, callback) {
    if (/^data:image/.test(src) && !this.editor.uploader) {
      if (callback) {
        callback(false);
      }
      return;
    }
    if (this.target.attr('src') === src) {
      return;
    }
    return this.button.loadImage(this.target, src, (function(_this) {
      return function(img) {
        var blob;
        if (!img) {
          return;
        }
        if (_this.active) {
          _this.width = img.width;
          _this.height = img.height;
          _this.widthEl.val(_this.width);
          _this.heightEl.val(_this.height);
        }
        if (/^data:image/.test(src)) {
          blob = _this.editor.util.dataURLtoBlob(src);
          blob.name = "Base64 Image.png";
          _this.editor.uploader.upload(blob, {
            inline: true,
            img: _this.target
          });
        } else {
          _this.editor.trigger('valuechanged');
        }
        if (callback) {
          return callback(img);
        }
      };
    })(this));
  };

  ImagePopover.prototype.show = function() {
    var $img, args;
    args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
    ImagePopover.__super__.show.apply(this, args);
    $img = this.target;
    this.width = $img.width();
    this.height = $img.height();
    this.alt = $img.attr('alt');
    if ($img.hasClass('uploading')) {
      return this.srcEl.val(this._t('uploading')).prop('disabled', true);
    } else {
      this.srcEl.val($img.attr('src')).prop('disabled', false);
      this.widthEl.val(this.width);
      this.heightEl.val(this.height);
      return this.altEl.val(this.alt);
    }
  };

  return ImagePopover;

})(Popover);

Simditor.Toolbar.addButton(ImageButton);

IndentButton = (function(superClass) {
  extend(IndentButton, superClass);

  function IndentButton() {
    return IndentButton.__super__.constructor.apply(this, arguments);
  }

  IndentButton.prototype.name = 'indent';

  IndentButton.prototype.icon = 'indent';

  IndentButton.prototype._init = function() {
    this.title = this._t(this.name) + ' (Tab)';
    return IndentButton.__super__._init.call(this);
  };

  IndentButton.prototype._status = function() {};

  IndentButton.prototype.command = function() {
    return this.editor.indentation.indent();
  };

  return IndentButton;

})(Button);

Simditor.Toolbar.addButton(IndentButton);

OutdentButton = (function(superClass) {
  extend(OutdentButton, superClass);

  function OutdentButton() {
    return OutdentButton.__super__.constructor.apply(this, arguments);
  }

  OutdentButton.prototype.name = 'outdent';

  OutdentButton.prototype.icon = 'outdent';

  OutdentButton.prototype._init = function() {
    this.title = this._t(this.name) + ' (Shift + Tab)';
    return OutdentButton.__super__._init.call(this);
  };

  OutdentButton.prototype._status = function() {};

  OutdentButton.prototype.command = function() {
    return this.editor.indentation.indent(true);
  };

  return OutdentButton;

})(Button);

Simditor.Toolbar.addButton(OutdentButton);

HrButton = (function(superClass) {
  extend(HrButton, superClass);

  function HrButton() {
    return HrButton.__super__.constructor.apply(this, arguments);
  }

  HrButton.prototype.name = 'hr';

  HrButton.prototype.icon = 'minus';

  HrButton.prototype.htmlTag = 'hr';

  HrButton.prototype._status = function() {};

  HrButton.prototype.command = function() {
    var $hr, $newBlock, $nextBlock, $rootBlock;
    $rootBlock = this.editor.selection.rootNodes().first();
    $nextBlock = $rootBlock.next();
    if ($nextBlock.length > 0) {
      this.editor.selection.save();
    } else {
      $newBlock = $('<p/>').append(this.editor.util.phBr);
    }
    $hr = $('<hr/>').insertAfter($rootBlock);
    if ($newBlock) {
      $newBlock.insertAfter($hr);
      this.editor.selection.setRangeAtStartOf($newBlock);
    } else {
      this.editor.selection.restore();
    }
    return this.editor.trigger('valuechanged');
  };

  return HrButton;

})(Button);

Simditor.Toolbar.addButton(HrButton);

TableButton = (function(superClass) {
  extend(TableButton, superClass);

  function TableButton() {
    return TableButton.__super__.constructor.apply(this, arguments);
  }

  TableButton.prototype.name = 'table';

  TableButton.prototype.icon = 'table';

  TableButton.prototype.htmlTag = 'table';

  TableButton.prototype.disableTag = 'pre, li, blockquote';

  TableButton.prototype.menu = true;

  TableButton.prototype._init = function() {
    TableButton.__super__._init.call(this);
    $.merge(this.editor.formatter._allowedTags, ['thead', 'th', 'tbody', 'tr', 'td', 'colgroup', 'col']);
    $.extend(this.editor.formatter._allowedAttributes, {
      table: ['class'],
      td: ['rowspan', 'colspan', 'class'],//mod-for-jl
      col: ['width']
    });
    $.extend(this.editor.formatter._allowedStyles, {
      td: ['text-align'],
      th: ['text-align']
    });
    this._initShortcuts();
    this.editor.on('decorate', (function(_this) {
      return function(e, $el) {
        return $el.find('table').each(function(i, table) {
          return _this.decorate($(table));
        });
      };
    })(this));
    this.editor.on('undecorate', (function(_this) {
      return function(e, $el) {
        return $el.find('table').each(function(i, table) {
          return _this.undecorate($(table));
        });
      };
    })(this));
    this.editor.on('selectionchanged.table', (function(_this) {
      return function(e) {
        var $container, range;
        _this.editor.body.find('.simditor-table td, .simditor-table th').removeClass('active');
        range = _this.editor.selection.range();
        if (!range) {
          return;
        }
        $container = _this.editor.selection.containerNode();
        if (range.collapsed && $container.is('.simditor-table')) {
          if (_this.editor.selection.rangeAtStartOf($container)) {
            $container = $container.find('td:first');//mod-for-jl
          } else {
            $container = $container.find('td:last');
          }
          _this.editor.selection.setRangeAtEndOf($container);
        }
        return $container.closest('td, th', _this.editor.body).addClass('active');
      };
    })(this));
    this.editor.on('blur.table', (function(_this) {
      return function(e) {
        return _this.editor.body.find('.simditor-table td, .simditor-table th').removeClass('active');
      };
    })(this));
    this.editor.keystroke.add('up', 'td', (function(_this) {
      return function(e, $node) {
        _this._tdNav($node, 'up');
        return true;
      };
    })(this));
    this.editor.keystroke.add('up', 'th', (function(_this) {
      return function(e, $node) {
        _this._tdNav($node, 'up');
        return true;
      };
    })(this));
    this.editor.keystroke.add('down', 'td', (function(_this) {
      return function(e, $node) {
        _this._tdNav($node, 'down');
        return true;
      };
    })(this));
    return this.editor.keystroke.add('down', 'th', (function(_this) {
      return function(e, $node) {
        _this._tdNav($node, 'down');
        return true;
      };
    })(this));
  };

  TableButton.prototype._tdNav = function($td, direction) {
    var $anotherTr, $tr, action, anotherTag, index, parentTag, ref;
    if (direction == null) {
      direction = 'up';
    }
    action = direction === 'up' ? 'prev' : 'next';
    ref = direction === 'up' ? ['tbody', 'thead'] : ['thead', 'tbody'], parentTag = ref[0], anotherTag = ref[1];
    $tr = $td.parent('tr');
    $anotherTr = this["_" + action + "Row"]($tr);
    if (!($anotherTr.length > 0)) {//mod-for-jl
        if(direction=='up')
            return this.editor.selection.setRangeAtEndOf($tr.parent().parent().parent().prev());
        if(direction=='down')
            return this.editor.selection.setRangeAtEndOf($tr.parent().parent().parent().next());
      return true;
    }
    index = $tr.find('td, th').index($td);
    if($anotherTr.find('td, th').length-1<index) index = $anotherTr.find('td th').length-1; //mod-for-jl
    return this.editor.selection.setRangeAtEndOf($anotherTr.find('td, th').eq(index));
  };

  TableButton.prototype._nextRow = function($tr) {
    var $nextTr;
    $nextTr = $tr.next('tr');
    if ($nextTr.length < 1 && $tr.parent('thead').length > 0) {
      $nextTr = $tr.parent('thead').next('tbody').find('tr:first');
    }
    return $nextTr;
  };

  TableButton.prototype._prevRow = function($tr) {
    var $prevTr;
    $prevTr = $tr.prev('tr');
    if ($prevTr.length < 1 && $tr.parent('tbody').length > 0) {
      $prevTr = $tr.parent('tbody').prev('thead').find('tr');
    }
    return $prevTr;
  };

  TableButton.prototype.initResize = function($table) {//mod-for-jl
    var $colgroup, $resizeHandle, $wrapper;
    $wrapper = $table.parent('.simditor-table');
    $colgroup = $table.find('colgroup');
    if ($colgroup.length < 1) {
      $colgroup = $('<colgroup/>').prependTo($table);
      // seleccionamos la fila mas grande
      var cant_td, max_td, $trr;;
      max_td = 0;
      $table.find('tbody tr').each(function(i, tr) {
          cant_td = $(tr).find('td').length;
          if(cant_td>max_td){
              $trr = $(tr);
              max_td = cant_td;
          }
      });
      $trr.find('td').each(function(i, td) {
        var $col;
        return $col = $('<col/>').appendTo($colgroup);
      })
      this.refreshTableWidth($table);
    }
    $resizeHandle = $('<div />', {
      "class": 'simditor-resize-handle',
      contenteditable: 'false'
    }).appendTo($wrapper);
    $wrapper.on('mousemove', 'td, th', function(e) {
      var $col, $td, index, ref, ref1, x;
      if ($wrapper.hasClass('resizing')) {
        return;
      }
      $td = $(e.currentTarget);
      x = e.pageX - $(e.currentTarget).offset().left;
      if (x < 5 && $td.prev().length > 0) {
        $td = $td.prev();
      }
      if ($td.next('td, th').length < 1) {
        $resizeHandle.hide();
        return;
      }
      if ((ref = $resizeHandle.data('td')) != null ? ref.is($td) : void 0) {
        $resizeHandle.show();
        return;
      }
      index = $td.parent().find('td, th').index($td);
      $col = $colgroup.find('col').eq(index);
      if ((ref1 = $resizeHandle.data('col')) != null ? ref1.is($col) : void 0) {
        $resizeHandle.show();
        return;
      }
      return $resizeHandle.css('left', $td.position().left + $td.outerWidth() - 5).data('td', $td).data('col', $col).show();
    });
    $wrapper.on('mouseleave', function(e) {
      return $resizeHandle.hide();
    });
    return $wrapper.on('mousedown', '.simditor-resize-handle', function(e) {
      var $handle, $leftCol, $leftTd, $rightCol, $rightTd, minWidth, startHandleLeft, startLeftWidth, startRightWidth, startX, tableWidth;
      $handle = $(e.currentTarget);
      $leftTd = $handle.data('td');
      $leftCol = $handle.data('col');
      $rightTd = $leftTd.next('td, th');
      $rightCol = $leftCol.next('col');
      startX = e.pageX;
      startLeftWidth = $leftTd.outerWidth() * 1;
      startRightWidth = $rightTd.outerWidth() * 1;
      startHandleLeft = parseFloat($handle.css('left'));
      tableWidth = $leftTd.closest('table').width();
      minWidth = 50;
      $(document).on('mousemove.simditor-resize-table', function(e) {
        var deltaX, leftWidth, rightWidth;
        deltaX = e.pageX - startX;
        leftWidth = startLeftWidth + deltaX;
        rightWidth = startRightWidth - deltaX;
        if (leftWidth < minWidth) {
          leftWidth = minWidth;
          deltaX = minWidth - startLeftWidth;
          rightWidth = startRightWidth - deltaX;
        } else if (rightWidth < minWidth) {
          rightWidth = minWidth;
          deltaX = startRightWidth - minWidth;
          leftWidth = startLeftWidth + deltaX;
        }
        $leftCol.attr('width', (leftWidth / tableWidth * 100) + '%');
        $rightCol.attr('width', (rightWidth / tableWidth * 100) + '%');
        return $handle.css('left', startHandleLeft + deltaX);
      });
      $(document).one('mouseup.simditor-resize-table', function(e) {
        $(document).off('.simditor-resize-table');
        return $wrapper.removeClass('resizing');
      });
      $wrapper.addClass('resizing');
      return false;
    });
  };

  TableButton.prototype._initShortcuts = function() {
    this.editor.hotkeys.add('ctrl+alt+up', (function(_this) {
      return function(e) {
        _this.editMenu.find('.menu-item[data-param=insertRowAbove]').click();
        return false;
      };
    })(this));
    this.editor.hotkeys.add('ctrl+alt+down', (function(_this) {
      return function(e) {
        _this.editMenu.find('.menu-item[data-param=insertRowBelow]').click();
        return false;
      };
    })(this));
    this.editor.hotkeys.add('ctrl+alt+left', (function(_this) {
      return function(e) {
        _this.editMenu.find('.menu-item[data-param=insertColLeft]').click();
        return false;
      };
    })(this));
    return this.editor.hotkeys.add('ctrl+alt+right', (function(_this) {
      return function(e) {
        _this.editMenu.find('.menu-item[data-param=insertColRight]').click();
        return false;
      };
    })(this));
  };

  TableButton.prototype.decorate = function($table) {//mod-for-jl
    var $headRow, $tbody, $thead;
    if ($table.parent('.simditor-table').length > 0) {
      this.undecorate($table);
    }
    $table.wrap('<div class="simditor-table"></div>');
    this.initResize($table);
    return $table.parent();
  };

  TableButton.prototype.undecorate = function($table) {
    if (!($table.parent('.simditor-table').length > 0)) {
      return;
    }
    return $table.parent().replaceWith($table);
  };

  TableButton.prototype.renderMenu = function() {
    var $table;
    $("<div class=\"menu-create-table\">\n</div>\n<div class=\"menu-edit-table\">\n  <ul>\n    <li>\n      <a tabindex=\"-1\" unselectable=\"on\" class=\"menu-item\"\n        href=\"javascript:;\" data-param=\"deleteRow\">\n        <span>" + (this._t('deleteRow')) + "</span>\n      </a>\n    </li>\n    <li>\n      <a tabindex=\"-1\" unselectable=\"on\" class=\"menu-item\"\n        href=\"javascript:;\" data-param=\"insertRowAbove\">\n        <span>" + (this._t('insertRowAbove')) + " ( Ctrl + Alt + ↑ )</span>\n      </a>\n    </li>\n    <li>\n      <a tabindex=\"-1\" unselectable=\"on\" class=\"menu-item\"\n        href=\"javascript:;\" data-param=\"insertRowBelow\">\n        <span>" + (this._t('insertRowBelow')) + " ( Ctrl + Alt + ↓ )</span>\n      </a>\n    </li>\n    <li><span class=\"separator\"></span></li>\n    <li>\n      <a tabindex=\"-1\" unselectable=\"on\" class=\"menu-item\"\n        href=\"javascript:;\" data-param=\"deleteCol\">\n        <span>" + (this._t('deleteColumn')) + "</span>\n      </a>\n    </li>\n    <li>\n      <a tabindex=\"-1\" unselectable=\"on\" class=\"menu-item\"\n        href=\"javascript:;\" data-param=\"insertColLeft\">\n        <span>" + (this._t('insertColumnLeft')) + " ( Ctrl + Alt + ← )</span>\n      </a>\n    </li>\n    <li>\n      <a tabindex=\"-1\" unselectable=\"on\" class=\"menu-item\"\n        href=\"javascript:;\" data-param=\"insertColRight\">\n        <span>" + (this._t('insertColumnRight')) + " ( Ctrl + Alt + → )</span>\n      </a>\n    </li>\n    <li><span class=\"separator\"></span></li>\n    <li>\n      <a tabindex=\"-1\" unselectable=\"on\" class=\"menu-item\"\n        href=\"javascript:;\" data-param=\"paintRow\">\n        <span>" + (this._t('paintRow')) + "</span>\n      </a>\n    </li>\n  <li>\n      <a tabindex=\"-1\" unselectable=\"on\" class=\"menu-item\"\n        href=\"javascript:;\" data-param=\"paintCell\">\n        <span>" + (this._t('paintCell')) + "</span>\n      </a>\n    </li>\n    <li>\n      <a tabindex=\"-1\" unselectable=\"on\" class=\"menu-item\"\n        href=\"javascript:;\" data-param=\"dissolveRow\">\n        <span>" + (this._t('dissolveRow')) + "</span>\n      </a>\n    </li>\n  <li>\n      <a tabindex=\"-1\" unselectable=\"on\" class=\"menu-item\"\n        href=\"javascript:;\" data-param=\"dissolveCell\">\n        <span>" + (this._t('dissolveCell')) + "</span>\n      </a>\n    </li>\n   <li>\n      <a tabindex=\"-1\" unselectable=\"on\" class=\"menu-item\"\n        href=\"javascript:;\" data-param=\"addBorder\">\n        <span>" + (this._t('addBorder')) + "</span>\n      </a>\n    </li>\n   <li>\n      <a tabindex=\"-1\" unselectable=\"on\" class=\"menu-item\"\n        href=\"javascript:;\" data-param=\"removeBorder\">\n        <span>" + (this._t('removeBorder')) + "</span>\n      </a>\n    </li>\n   <li><span class=\"separator\"></span></li>\n    <li>\n      <a tabindex=\"-1\" unselectable=\"on\" class=\"menu-item\"\n        href=\"javascript:;\" data-param=\"deleteTable\">\n        <span>" + (this._t('deleteTable')) + "</span>\n      </a>\n    </li>\n  </ul>\n</div>").appendTo(this.menuWrapper);
    this.createMenu = this.menuWrapper.find('.menu-create-table');
    this.editMenu = this.menuWrapper.find('.menu-edit-table');
    $table = this.createTable(6, 6).appendTo(this.createMenu);
    this.createMenu.on('mouseenter', 'td, th', (function(_this) {
      return function(e) {
        var $td, $tr, $trs, num;
        _this.createMenu.find('td, th').removeClass('selected');
        $td = $(e.currentTarget);
        $tr = $td.parent();
        num = $tr.find('td, th').index($td) + 1;
        $trs = $tr.prevAll('tr').addBack();
        if ($tr.parent().is('tbody')) {
          $trs = $trs.add($table.find('thead tr'));
        }
        return $trs.find("td:lt(" + num + "), th:lt(" + num + ")").addClass('selected');
      };
    })(this));
    this.createMenu.on('mouseleave', function(e) {
      return $(e.currentTarget).find('td, th').removeClass('selected');
    });
    return this.createMenu.on('mousedown', 'td', (function(_this) {
      return function(e) {
        var $closestBlock, $td, $tr, colNum, rowNum;
        _this.wrapper.removeClass('menu-on');
        if (!_this.editor.inputManager.focused) {
          return;
        }
        $td = $(e.currentTarget);
        $tr = $td.parent();
        colNum = $tr.find('td').index($td) + 1;
        rowNum = $tr.prevAll('tr').length + 1;
        if ($tr.parent().is('tbody')) {
          rowNum += 1;
        }
        $table = _this.createTable(rowNum, colNum, true);
        $closestBlock = _this.editor.selection.blockNodes().last();
        if (_this.editor.util.isEmptyNode($closestBlock)) {
          $closestBlock.replaceWith($table);
        } else {
          $closestBlock.after($table);
        }
        _this.decorate($table);
        _this.editor.selection.setRangeAtStartOf($table.find('td:first'));
        _this.editor.trigger('valuechanged');
        return false;
      };
    })(this));
  };

  TableButton.prototype.createTable = function(row, col, phBr) {//mod-for-jl
    var $table, $tbody, $td, $thead, $tr, c, k, l, r, ref, ref1;
    $table = $('<table/>');
    $tbody = $('<tbody/>').appendTo($table);
    for (r = k = 0, ref = row; 0 <= ref ? k < ref : k > ref; r = 0 <= ref ? ++k : --k) {
      $tr = $('<tr/>');
      $tr.appendTo($tbody);
      for (c = l = 0, ref1 = col; 0 <= ref1 ? l < ref1 : l > ref1; c = 0 <= ref1 ? ++l : --l) {
        $td = $('<td/>').appendTo($tr);
        if (phBr) {
          $td.append(this.editor.util.phBr);
        }
      }
    }
    return $table;
  };

  TableButton.prototype.refreshTableWidth = function($table) { //mod-for-jl
    var cols, tableWidth;
    tableWidth = $table.width();
    cols = $table.find('col');

    // seleccionamos la fila mas grande
    var cant_td, max_td, $trr;;
    max_td = 0;
    $table.find('tbody tr').each(function(i, tr) {
        cant_td = $(tr).find('td').length;
        if(cant_td>max_td){
            $trr = $(tr);
            max_td = cant_td;
        }
    });

    return $trr.find('td').each(function(i, td) {
      var $col, tam;
      $col = cols.eq(i);
      tam = (typeof $(td).outerWidth=="function")? 100/cols.length:  ($(td).outerWidth()==0)? 100/cols.length: (td).outerWidth() / tableWidth * 100 ;
      return $col.attr('width', tam + '%');
    });
  };

  TableButton.prototype.setActive = function(active) {
    TableButton.__super__.setActive.call(this, active);
    if (active) {
      this.createMenu.hide();
      return this.editMenu.show();
    } else {
      this.createMenu.show();
      return this.editMenu.hide();
    }
  };

  TableButton.prototype._changeCellTag = function($tr, tagName) {
    return $tr.find('td, th').each(function(i, cell) {
      var $cell;
      $cell = $(cell);
      return $cell.replaceWith("<" + tagName + ">" + ($cell.html()) + "</" + tagName + ">");
    });
  };

  TableButton.prototype.deleteRow = function($td) {
    var $newTr, $tr, index;
    $tr = $td.parent('tr');
    if ($tr.closest('table').find('tr').length < 1) {
      return this.deleteTable($td);
    } else {
      $newTr = this._nextRow($tr);
      if (!($newTr.length > 0)) {
        $newTr = this._prevRow($tr);
      }
      index = $tr.find('td, th').index($td);
      if ($tr.parent().is('thead')) {
        $newTr.appendTo($tr.parent());
        this._changeCellTag($newTr, 'th');
      }
      if($newTr.find('td, th').eq(index).length==0) return this.deleteTable($td);//mod-for-jl
      $tr.remove();
      return this.editor.selection.setRangeAtEndOf($newTr.find('td, th').eq(index));
    }
  };

  TableButton.prototype.insertRow = function($td, direction) {
    var $newTr, $table, $tr, cellTag, colNum, i, index, k, ref;
    if (direction == null) {
      direction = 'after';
    }
    $tr = $td.parent('tr');
    $table = $tr.closest('table');
    colNum = 0;
    $table.find('tr').each(function(i, tr) {
      return colNum = Math.max(colNum, $(tr).find('td').length);
    });
    index = $tr.find('td, th').index($td);
    $newTr = $('<tr/>');
    cellTag = 'td';
    if (direction === 'after' && $tr.parent().is('thead')) {
      $tr.parent().next('tbody').prepend($newTr);
    } else if (direction === 'before' && $tr.parent().is('thead')) {
      $tr.before($newTr);
      $tr.parent().next('tbody').prepend($tr);
      this._changeCellTag($tr, 'td');
      cellTag = 'th';
    } else {
      $tr[direction]($newTr);
    }
    for (i = k = 1, ref = colNum; 1 <= ref ? k <= ref : k >= ref; i = 1 <= ref ? ++k : --k) {
      $("<" + cellTag + "/>").append(this.editor.util.phBr).appendTo($newTr);
    }
    return this.editor.selection.setRangeAtStartOf($newTr.find('td, th').eq(index));
  };

  TableButton.prototype.deleteCol = function($td) {
    var $newTd, $table, $tr, index, noOtherCol, noOtherRow;
    $tr = $td.parent('tr');
    noOtherRow = $tr.closest('table').find('tr').length < 2;
    noOtherCol = $td.siblings('td, th').length < 1;
    if (noOtherRow && noOtherCol) {
      return this.deleteTable($td);
    } else if($tr.find('td, th').length==1){//mod-for-jl
      return this.deleteTable($td);
    }else{
      index = $tr.find('td, th').index($td);
      $newTd = ($td.next('td, th').length!=0)? $td.next('td, th'): $td;//mod-for-jl
      if (!($newTd.length > 0)) {
        $newTd = $tr.prev('td, th');
      }
      $table = $tr.closest('table');
      $table.find('col').eq(index).remove();
      $table.find('tr').each(function(i, tr) {
        return $(tr).find('td, th').eq(index).remove();
      });
      this.refreshTableWidth($table);
      return this.editor.selection.setRangeAtEndOf($newTd);
    }
  };

  TableButton.prototype.insertCol = function($td, direction) {
    var $col, $newCol, $newTd, $table, $tr, index, tableWidth, width;
    if (direction == null) {
      direction = 'after';
    }
    $tr = $td.parent('tr');
    index = $tr.find('td, th').index($td);
    $table = $td.closest('table');
    $col = $table.find('col').eq(index);
    $table.find('tr').each((function(_this) {
      return function(i, tr) {
        var $newTd, cellTag;
        cellTag = $(tr).parent().is('thead') ? 'th' : 'td';
        $newTd = $("<" + cellTag + "/>").append(_this.editor.util.phBr);
        return $(tr).find('td, th').eq(index)[direction]($newTd);
      };
    })(this));
    $newCol = $('<col/>');
    $col[direction]($newCol);
    tableWidth = $table.width();
    width = Math.max(parseFloat($col.attr('width')) / 2, 50 / tableWidth * 100);
    $col.attr('width', width + '%');
    $newCol.attr('width', width + '%');
    this.refreshTableWidth($table);
    $newTd = direction === 'after' ? $td.next('td, th') : $td.prev('td, th');
    return this.editor.selection.setRangeAtStartOf($newTd);
  };

  TableButton.prototype.deleteTable = function($td) {
    var $block, $table;
    $table = $td.closest('.simditor-table');
    $block = $table.next('p');
    $block.html('<br>');
    $table.remove();
    if ($block.length > 0) {
      return this.editor.selection.setRangeAtStartOf($block);
    }
  };

  //mod-for-jl
  TableButton.prototype.paintCell = function($td) { $td.addClass('header');};
  TableButton.prototype.paintRow = function($td) { $td.parent('tr').find('td').each(function (i, td) {  $(td).addClass('header'); $(td).css({ 'text-align': 'center'});  })   };
  TableButton.prototype.dissolveCell = function($td) { $td.removeClass('header');};
  TableButton.prototype.dissolveRow = function($td) { $td.parent('tr').find('td').each(function (i, td) {  $(td).removeClass('header'); $(td).css({ 'text-align': 'left'});  })   };
  TableButton.prototype.addBorder = function($td) { $td.closest('table').removeClass('sin-bordes'); };
  TableButton.prototype.removeBorder = function($td) { $td.closest('table').addClass('sin-bordes'); };

  TableButton.prototype.command = function(param) {
    var $td;
    $td = this.editor.selection.containerNode().closest('td, th');
    if (!($td.length > 0)) {
      return;
    }
    if (param === 'deleteRow') {
      this.deleteRow($td);
    } else if (param === 'insertRowAbove') {
      this.insertRow($td, 'before');
    } else if (param === 'insertRowBelow') {
      this.insertRow($td);
    } else if (param === 'deleteCol') {
      this.deleteCol($td);
    } else if (param === 'insertColLeft') {
      this.insertCol($td, 'before');
    } else if (param === 'insertColRight') {
      this.insertCol($td);
    } else if (param === 'paintRow') {//mod-for-jl
      this.paintRow($td);
    } else if (param === 'paintCell') {
      this.paintCell($td);
    } else if (param === 'dissolveRow') {
      this.dissolveRow($td);
    } else if (param === 'dissolveCell') {
      this.dissolveCell($td);
    } else if (param === 'addBorder') {
      this.addBorder($td);
    } else if (param === 'removeBorder') {
      this.removeBorder($td);
    } else if (param === 'deleteTable') {
      this.deleteTable($td);
    } else {
      return;
    }
    return this.editor.trigger('valuechanged');
  };

  return TableButton;

})(Button);

Simditor.Toolbar.addButton(TableButton);

StrikethroughButton = (function(superClass) {
  extend(StrikethroughButton, superClass);

  function StrikethroughButton() {
    return StrikethroughButton.__super__.constructor.apply(this, arguments);
  }

  StrikethroughButton.prototype.name = 'strikethrough';

  StrikethroughButton.prototype.icon = 'strikethrough';

  StrikethroughButton.prototype.htmlTag = 'strike';

  StrikethroughButton.prototype.disableTag = 'pre';

  StrikethroughButton.prototype._activeStatus = function() {
    var active;
    active = document.queryCommandState('strikethrough') === true;
    this.setActive(active);
    return this.active;
  };

  StrikethroughButton.prototype.command = function() {
    document.execCommand('strikethrough');
    if (!this.editor.util.support.oninput) {
      this.editor.trigger('valuechanged');
    }
    return $(document).trigger('selectionchange');
  };

  return StrikethroughButton;

})(Button);

Simditor.Toolbar.addButton(StrikethroughButton);

AlignmentButton = (function(superClass) {
  extend(AlignmentButton, superClass);

  function AlignmentButton() {
    return AlignmentButton.__super__.constructor.apply(this, arguments);
  }

  AlignmentButton.prototype.name = "alignment";

  AlignmentButton.prototype.icon = 'align-left';

  AlignmentButton.prototype.htmlTag = 'p, h1, h2, h3, h4, td, th';

  AlignmentButton.prototype._init = function() {
    this.menu = [
      {
        name: 'left',
        text: this._t('alignLeft'),
        icon: 'align-left',
        param: 'left'
      }, {
        name: 'center',
        text: this._t('alignCenter'),
        icon: 'align-center',
        param: 'center'
      }, {
        name: 'right',
        text: this._t('alignRight'),
        icon: 'align-right',
        param: 'right'
      }, {//mod-for-jl
        name: 'justify',
        text: 'Justify',
        icon: 'align-justify',
        param: 'justify'
      }
    ];
    return AlignmentButton.__super__._init.call(this);
  };

  AlignmentButton.prototype.setActive = function(active, align) {
    if (align == null) {
      align = 'left';
    }
    if (align !== 'left' && align !== 'center' && align !== 'right' && align !== 'justify') {
      align = 'left';
    }
    if (align === 'left') {
      AlignmentButton.__super__.setActive.call(this, false);
    } else {
      AlignmentButton.__super__.setActive.call(this, active);
    }
    this.el.removeClass('align-left align-center align-right align-justify');
    if (active) {
      this.el.addClass('align-' + align);
    }
    this.setIcon('align-' + align);
    return this.menuEl.find('.menu-item').show().end().find('.menu-item-' + align).hide();
  };

  AlignmentButton.prototype._status = function() {
    this.nodes = this.editor.selection.nodes().filter(this.htmlTag);
    if (this.nodes.length < 1) {
      this.setDisabled(true);
      return this.setActive(false);
    } else {
      this.setDisabled(false);
      return this.setActive(true, this.nodes.first().css('text-align'));
    }
  };

  AlignmentButton.prototype.command = function(align) {
    if (align !== 'left' && align !== 'center' && align !== 'right' && align !== 'justify') {
      throw new Error("simditor alignment button: invalid align " + align);
    }
    this.nodes.css({
      'text-align': align === 'left' ? '' : align
    });
    this.editor.trigger('valuechanged');
    return this.editor.inputManager.throttledSelectionChanged();
  };

  return AlignmentButton;

})(Button);

Simditor.Toolbar.addButton(AlignmentButton);

return Simditor;

}));

(function() {
    'use strict'

    angular
    .module('app')
    .factory('SideNavFactory', SideNavFactory);

    function SideNavFactory() {

        var factory = {
            user: {
                id: '',
                first_name: '',
                last_name: '',
                cargo: '',
                email: '',
                photo: ''
            },
            userColor: '',
            visible: false,
            menu: [],
            getMenu: function () {
                return this.menu;
            },
            getUser: function () {
                return this.user;
            },
            getVisible: function () {
                return this.visible;
            },
            setMenu: function (menu) {
                this.menu = menu;
            },
            setUser: function (user) {
                this.user = user;
            },
            setVisible: function (visible) {
                this.visible = visible;
            }
        };

        return factory;

    }

})();
(function() {
    'use strict'

    angular
    .module('app')
    .directive('acmeSidenav', SidenavDirective);

    /** @ngInject */
    function SidenavDirective() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/sidenav/sidenav.html',
            scope: {},
            controller: ['$timeout', '$mdSidenav', 'SideNavFactory', '$location', 'Storage', 'Util', 'BreadcrumbFactory', '$log', SidenavController],
            controllerAs: 'vm',
            bindToController: true,
            link: function(scope, elem) {
                var $sidenav = elem

                $sidenav.on('click', '.md-button-href', function () {
                    $sidenav.find('.md-button-href').removeClass('active');
                    angular.element(this).addClass('active');
                })

                $sidenav.on('click', '.md-button-toggle', function () {
                    if ($sidenav.hasClass('collapsed')) {
                        return false;
                    }
                    $sidenav.find('.sidenav-sublist').slideUp(300);
                    $sidenav.find('.sidenav-list > li').removeClass('active');

                    var $this = angular.element(this);
                    $this.addClass('active');
                    if(!$this.next().is(":visible")) {
                        $this.next().slideToggle(300);
                        $this.closest('li').addClass('active');
                    }
                })
            }
        }

        return directive

        /** @ngInject */
        function SidenavController($timeout, $mdSidenav, SideNavFactory, $location, Storage, Util, BreadcrumbFactory, $log) {
            var vm = this;
            var color = ['info', 'success', 'danger', 'warning', 'primary'];

            vm.user = {};
            vm.menu = [];

            vm.toggleLeft = buildDelayedToggler('left');

            vm.send = function (url, submenu) {
                if (typeof submenu == 'undefined') {
                    if (Storage.exist('menu')) {
                        var page = Util.getMenuOption(Storage.getSession('menu'), url);
                        BreadcrumbFactory.setParent(page[0]);
                        BreadcrumbFactory.setCurrent(page[1]);
                    }
                    Storage.setSession('last_route', url);
                    // vm.toggleLeft();
                    $location.path(url);
                }
                vm.reset();
            }

            vm.reset = function () {
                angular.element('#toast-container-main').find('md-toast').fadeOut();
            }

            activate();

            function activate() {
                if(Storage.existUser()) {
                    SideNavFactory.setUser(Storage.getUser());
                    SideNavFactory.setMenu(Storage.getSession('menu'));
                }
                vm.menu = SideNavFactory.getMenu();
                Storage.setSession('menu', vm.menu);

                vm.active = $location.path().replace('/', '');
                SideNavFactory.userColor = color[parseInt(Math.random()*color.length)];

                $timeout(function () {
                    angular.element('#sidenav').find('.md-button-href.active').parent().parent().prev().click();
                }, 1000);
            }

            vm.getColor = function () {
                return SideNavFactory.userColor;
            }

            vm.getName = function () {
                var user = SideNavFactory.getUser();
                return user.first_name + ' ' + user.last_name;
            }

            vm.getEmail = function () {
                return SideNavFactory.getUser().email;
            }

            vm.getInitial = function () {
                var firstName = SideNavFactory.getUser().first_name;
                return firstName.length ? firstName[0].toUpperCase() : '?';
            }

            vm.getMenu = function () {
                return SideNavFactory.getMenu();
            }

            /**
            * Supplies a function that will continue to operate until the
            * time is up.
            */
            function debounce(func, wait) {
                var timer
                return function debounced() {
                    var context = vm,
                    args = Array.prototype.slice.call(arguments);
                    $timeout.cancel(timer);
                    timer = $timeout(function() {
                        timer = undefined;
                        func.apply(context, args);
                    }, wait || 10);
                }
            }
            /**
            * Build handler to open/close a SideNav when animation finishes
            * report completion in console
            */
            function buildDelayedToggler(navID) {
                return debounce(function() {
                    $mdSidenav(navID)
                    .toggle()
                    .then(function () {
                        $log.debug("toggle " + navID + " is done");
                    })
                }, 200);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
    .module('app')
    .component('mdSelectDate', {
        templateUrl: 'app/components/selectDate/selectDate.html',
        controller: ['$scope', 'Datetime', SelectDateController],
        controllerAs: 'vm',
        bindings: {
            ngModel: '=',
            ngDisabled: '=',
            ngRequired: '=',
            ngLabel: '@',
            yearIni: '@',
            yearEnd: '@',
            year: '@',
            month: '@',
            day: '@'
        }
    });

    /** @ngInject */
    function SelectDateController($scope, Datetime) {
        var vm = this;

        activate();

        function activate() {
            initDays();
            initMonths();
            initYears();

            if (vm.ngModel && Datetime.isDate(new Date(vm.ngModel))) {
                var date = new Date(vm.ngModel);
                vm.day = date.getDate();
                vm.month = date.getMonth() + 1;
                vm.year = date.getFullYear();
            }
        }

        function initDays() {
            var days = [];
            for (var i = 1; i <= 31; i++) {
                days.push({
                    name: i,
                    value: i
                });
            }
            vm.days = days;
        }

        function initMonths() {
            var months = [];
            for (var i = 0; i < 12; i++) {
                months.push({
                    name: Datetime.months[i],
                    value: i + 1
                });
            }
            vm.months = months;
        }

        function initYears() {
            var year = parseInt(Datetime.now('YYYY'));
            var years = [];
            var yearIni = year - (vm.yearIni || 100);
            var yearEnd = year - (vm.yearEnd || 0);
            for (var i = yearEnd, l = yearIni; i >= l; i--) {
                years.push({
                    name: i,
                    value: i
                });
            }
            vm.years = years;
            // if (typeof vm.year == 'undefined' && typeof vm.ngModel == 'undefined') {
            //     vm.year = year - 30;
            // }
        }

        $scope.$watch('vm.day', function (newValue, oldValue) {
            oldValue = oldValue; //TODO: Esta linea no es necesaria
            vm.ngModel = new Date(vm.year, vm.month-1, newValue);
        });
        $scope.$watch('vm.month', function (newValue, oldValue) {
            oldValue = oldValue; //TODO: Esta linea no es necesaria
            vm.ngModel = new Date(vm.year, newValue-1, vm.day);
        });
        $scope.$watch('vm.year', function (newValue, oldValue) {
            oldValue = oldValue; //TODO: Esta linea no es necesaria
            vm.ngModel = new Date(newValue, vm.month-1, vm.day);
        });
        $scope.$watch('vm.ngModel', function (newValue, oldValue) {
            if (newValue && newValue != oldValue && Datetime.isDate(new Date(newValue))) {
                var date = new Date(newValue);
                vm.day = date.getDate();
                vm.month = date.getMonth() + 1;
                vm.year = date.getFullYear();
            }
        });
    }

})();

(function() {
    'use strict'

    angular
    .module('app')
    .directive('acmeNavbar', acmeNavbar);

    /** @ngInject */
    function acmeNavbar() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/navbar/navbar.html',
            scope: {},
            controller: ['ExpirationTime', '$location', 'Storage', 'SideNavFactory', 'Util', 'DataService', '$window', 'restUrl', NavbarController],
            controllerAs: 'vm',
            bindToController: true
        }

        return directive

        /** @ngInject */
        function NavbarController(ExpirationTime, $location, Storage, SideNavFactory, Util, DataService, $window, restUrl) {
            var vm = this;

            vm.toggle = function () {
                angular.element('#sidenav-main').toggleClass('collapsed');
            }

            vm.openMenu = function ($mdOpenMenu, ev) {
                $mdOpenMenu(ev);
            }

            vm.profile = function () {
                $location.path("profile");
            }

            vm.settings = function () {
                $location.path("configuracion");
            }

            vm.getFirstName = function () {
                if (Storage.existUser()) {
                    return Storage.getUser().first_name;
                }
                return SideNavFactory.getUser().first_name;
            }

            vm.getColor = function () {
                return SideNavFactory.userColor;
            }

            vm.getInitial = function () {
                var firstName = SideNavFactory.getUser().first_name;
                return firstName.length ? firstName[0].toUpperCase() : '?';
            }

            vm.logout = function () {
              var codigo = $window.localStorage.getItem('oauth2_state');
              if (codigo) {
                  // this.$log.log('------------------------------codigo', codigo);
                  DataService.get(restUrl + 'salir?codigo=' + codigo)
                  .then(function (response) {
                      $window.location.href = response.datos;
                  });
              } else {
                  ExpirationTime.logout();
              }
            }

            vm.fullscreen = function () {
                angular.element('body').toggleClass('fullscreen');
                Util.fullscreen();
            }

            vm.cambiarUsuario = function () {
                $location.path("elegir");
            }
        }
    }

})();

(function() {
    'use strict'

    angular
    .module('app')
    .component('paletteFormly', {
        templateUrl : 'app/components/paletteFormly/paletteFormly.html',
        controller : PaletteFormlyController,
        controllerAs: 'vm',
        bindings: {
            menu: '=',
            funcionAgregar: '=',
            options: '=',
            node: '@'
        }
    });

    function PaletteFormlyController(){
        var vm = this;
        //contador de templates
        // var cont_templates = 0;

        //cargamos funcion
        vm.addItem = addItem;

        //variable que contiene la lista de menus con templates cada uno
        vm.elementos = [
            {
                "expanded": true,
                "titulo" : "DOCUMENTOS",
                "submenu": [
                    { name: "Datos generales", tipo: "datosGenerales" },
                    { name: "Encabezado", tipo: "encabezado" },
                    { name: "Asunto" , tipo: "inputt" },
                    // { name: "Cite", tipo: "cite" },
                    { name: "Documentos relacionados", tipo: "documentosRelacionados" },
                    { name: "Documentos a anular", tipo: "documentosAnular" },
                    { name: "Cc.:archivo", tipo: "ccArchivo" },
                    { name: "Caja chica", tipo: "cajachica" },
                    { name: "Certificacion comprometido", tipo: "certificacionComprometido" },
                    { name: "Lista de contactos", tipo: "listaContactos" },
                    { name: "Editor de texto", tipo: "editorTexto" }
                ]
            },
            {
                "expanded": true,
                "titulo": "SERVICIOS WEB",
                "submenu": [
                    { name: "Consulta a almacenes", tipo: "consultaAlmacen" },
                    { name: "Recuperar entrega de almacenes", tipo: "recuperarEntregaAlmacen" },
                    { name: "Ingreso de suministros y/o materiales", tipo: "ingresoAlmacen" },
                    { name: "Tabla de Activos Fijos", tipo: "tablaActivos" },
                    { name: "Ingreso de Activos Fijos", tipo: "ingresoActivos" },
                    { name: "Baja de Activos Fijos", tipo: "bajaActivos" }
                ]
            },
            {
                "expanded": true,
                "titulo" : "TEXTOS",
                "submenu": [
                    { name: "Título", tipo: "titulo" },
                    { name: "Subtítulo", tipo: "subtitulo" },
                    { name: "Párrafo", tipo: "parrafo" },
                    { name: "Lista", tipo: "lista" }
                ]
            },
            {
                "expanded": true,
                "titulo" : "LAYOUTS",
                "submenu": [
                    { name: "Contenedor", tipo: "layout" },
                    { name: "Espacio", tipo: "vacio" }
                ]
            },
            {
                "expanded": true,
                "titulo" : "ELEMENTOS FORMULARIO",
                "submenu": [
                   // { name: "Archivo", tipo: "archivo" },
                    { name: "Campo de texto" , tipo: "input" },
                    { name: "Selección radio", tipo: "radio" },
                    { name: "Selección simple", tipo: "select" },
                    { name: "Selección multiple", tipo: "select_multiple" },
                    { name: "Area de texto", tipo: "textarea" },
                    { name: "Checkbox", tipo: "checkbox" },
                    { name: "Calendario", tipo: "datepicker" },
                    // { name: "Calendario", tipo: "calendario" },
                    { name: "Deslizador", tipo: "slider" },
                    { name: "Interruptor", tipo: "switch" },
                    { name: "Palabras clave", tipo: "chips" },
                    { name: "Aprobación de pdf", tipo: "pdfsAprobacionCD" }

                ]
            }
        ];

        function addItem(tipo){
            if(angular.isDefined(vm.funcionAgregar)){
                vm.funcionAgregar(tipo);
            }
        }

    }
  })();

(function() {
    'use strict'

    angular
    .module('app')
    .component('menuCard', {
        templateUrl : 'app/components/menuCard/menuCard.html',
        controller : [MenuCardController],
        controllerAs: 'vm',
        bindings: {
            items: '=',
            titleTable: '=',
            node: '@'
        }
    });

    function MenuCardController(){
    }
  })();

(function () {
    'use strict';

    angular
        .module('app')
        .constant('simditorConfig', {
            placeholder: 'Ingrese contenido aquí...',
            toolbar: [ 'underline', 'ols', '|', 'indent', 'outdent', 'alignment', '|', 'table', 'link', 'hr' ],
            allowedTags: ['br', 'u', 'p', 'li', 'div'],
            toolbarHidden: true
        })
        .directive('ngSimditor', ['$timeout', 'simditorConfig', function ($timeout, simditorConfig) {
            Simditor.locale = 'en-US';  // eslint-disable-line no-undef
            Simditor.i18n['en-US'] = {  // eslint-disable-line no-undef
                'bold': 'Negrita',
                'italic': 'Itálica',
                'underline': 'Subrayar',
                'color': 'Color',
                'indent': 'Aumentar sangría',
                'outdent': 'Quitar sangría',
                'alignment': 'Alinear',
                'table': 'Tabla',
                'link': 'Enlace',
                'hr': 'Línea',
                'deleteRow': 'Eliminar fila',
                'insertRowAbove': 'Insertar fila arriba',
                'insertRowBelow': 'Insertar fila abajo',
                'deleteColumn': 'Eliminar columna',
                'insertColumnLeft': 'Insertar columna a la izquierda',
                'insertColumnRight': 'Insertar columna a la derecha',
                'paintRow': 'Pintar fila',
                'paintCell': 'Pintar celda',
                'dissolveRow': 'Despintar fila',
                'dissolveCell': 'Despintar celda',
                'deleteTable': 'Eliminar tabla',
                'addBorder': 'Agregar bordes',
                'removeBorder': 'Eliminar bordes',
                'listDisc': 'Circulos llenos',
                'listCircle': 'Circulos vacios',
                'listSquare': 'Cuadrados llenos',
                'listDecimal': '1, 2, 3, 4...',
                'listDecimal0': '01, 02, 03, 04...',
                'listUpperRoman': 'I, II, III, IV...',
                'listLowerRoman': 'i, ii, iii, iv...',
                'listUpperAlpha': 'A, B, C, D...',
                'listLowerAlpha': 'a, b, c, d...',
                'listGreek': 'Letras griegas',
                'toggleList': 'Añadir/quitar Lista'
            };

            // Runs during compile
            return {
                // name: '',
                // priority: 1,
                // terminal: true,
                scope: {
                    content: '=',
                    disabled: '=',
                    save: '@'
                }, // {} = isolate, true = child, false/undefined = no change
                // controller: function($scope, $element, $attrs, $transclude) {},
                // require: 'ngModel', // Array = multiple requires, ? = optional, ^ = check parent elements
                restrict: 'E', // E = Element, A = Attribute, C = Class, M = Comment
                template: '<textarea data-autosave="editor-content"></textarea>',
                // templateUrl: '',
                replace: true,
                // transclude: true,
                // compile: function(tElement, tAttrs, function transclude(function(scope, cloneLinkingFn){ return function linking(scope, elm, attrs){}})),
                link: function ($scope, iElm, iAttrs, controller) { // eslint-disable-line no-unused-vars
                    var sc = $scope;
                    var editor = new Simditor( // eslint-disable-line no-undef
                        angular.extend({ textarea: iElm }, simditorConfig)
                    );
                    // console.log(editor);

                    //cargar valor inicial si tiene
                    $timeout(function() {
                        editor.body[0].contentEditable = (angular.isDefined(sc.disabled))? !sc.disabled : true;
                        if(angular.isDefined(sc.content))  editor.setValue(sc.content);
                    })

                    //actualizar el content
                    var changed = function (ev) {  // eslint-disable-line no-unused-vars
                        sc.content = editor.getValue();
                    };

                    editor.on('valuechanged', changed);

                    editor.on('focus', function (ev) {  // eslint-disable-line no-unused-vars
                        angular.element(iElm).prev().prev().prev().addClass('active-editor');
                    });

                    editor.on('blur', function (ev) {  // eslint-disable-line no-unused-vars
                        $timeout(function () {
                            angular.element(iElm).prev().prev().prev().removeClass('active-editor');
                        }, 200);
                    });
                }
            };
        }]);

})();

(function() {
    'use strict'

    angular
    .module('app')
    .component('crudTableAprobacion', {
        templateUrl : 'app/components/crudTableAprobacion/crudTableAprobacion.html',
        controller : ['$scope', 'DataService', 'Message', 'Modal', 'Util', '$timeout', 'ArrayUtil', 'Datetime', '$state', '$sce', '$window', CrudTableAprobacionController],
        controllerAs: 'vm',
        bindings: {
            url: '=',
            fields: '=',
            fks: '=',
            titleTable: '=',
            template: '=',
            permission: '=',
            column: '=',
            formly: '=',
            editable: '=',
            eventSave: '=',
            dialogController: '=',
            order: '=',
            optionSelected: '=',
            condiciones: '=',
            buttons: '=',
            buttonAgregar: '=',
            headButtons: '=',
            idShow: '=',
            include: '=',
            queryExtra: '=',
            usuario: '=',
            informacionBienes: '=',
            estadoSw: '=', // TODO solo funciona con estado= 'ACTIVO'|'INACTIVO'
            onlyFields: '=',
            searchPro: '=',
            estadoChecks: '=',
            estadoOpciones: '=',
            items: '=?',
            habilitarSeleccion: '=',
            node: '@',
            seleccionados:'='
        }
    });

    function CrudTableAprobacionController($scope, DataService, Message, Modal, Util, $timeout, ArrayUtil, Datetime, $state, $sce, $window) {
        var vm = this;
        var bookmark;
        var limit = 10;

        vm.headers = [];
        vm.items = null;
        vm.item = null;
        // vm.node = true; // Habilitar para nodejs
        vm.tipo_busqueda='todos';
        vm.campo_seleccionado={};
        vm.busqueda_estado = [];

        vm.prevent = prevent;
        vm.estadoModificado = estadoModificado;
        vm.add = add;
        vm.edit = edit;
        vm.delete = deleteItem;
        vm.print = print;
        vm.save = save;
        vm.saveAll = saveAll;
        vm.removeFilter = removeFilter;
        vm.showFilter = showFilter;
        vm.getItems = getItems;
        vm.buttonEvent = buttonEvent;
        vm.dataGrid = {};
        vm.seleccionar = false;
        vm.seleccionarTodos = seleccionarTodos;
        vm.seleccionando = seleccionando;
        vm.objs = {};
        vm.adjunto = {"id": 0};
        vm.aprobarAdjunto = aprobarAdjunto;
        vm.aprobarDocumento = aprobarDocumento;
        // para permitir ver informacion pequeña de documentos
        vm.sw_cite = ['/documentos', '/impresion', '/aprobacion', '/en_curso', '/firmar'].indexOf($state.current.url) !== -1;

        vm.permissions = {
            create: true,
            read: true,
            update: true,
            delete: true,
            print: false,
            filter: true
        }

        vm.limitOptions = [limit, 25, 50];
        // vm.limitOptions = [limit];

        vm.options = {
            rowSelection: false,
            multiSelect: false,
            autoSelect: true,
            decapitate: false,
            largeEditDialog: true,
            boundaryLinks: true,
            limitSelect: true,
            pageSelect: false
        }

        vm.query = {
            order: (vm.fields.indexOf('_fecha_modificacion'))? '-_fecha_modificacion': '',
            limit: limit,
            page: 1,
            filter: ''
        }

        vm.filter = {
            options: {
                debounce: 500
            }
        };

        activate();

        function activate() {
            getFields();
        }

        function aprobarAdjunto (id_adjunto) {  
            openDialogConfirAdjunto(event, id_adjunto);
            
        }

        function aprobarDocumento (id_documento) {
            openDialogConfirDocumento(event, id_documento);
        }

        function seleccionando (){
          if(angular.isFunction(vm.seleccionados)) $timeout(function(){ vm.seleccionados(existeSeleccionado()); });
        }

        function estadoModificado(item) {
            item._usuario_modificacion = vm.usuario;
            DataService.put(vm.url+Util.getId(item, vm.fieldsData), angular.copy(item));
            if(vm.fields.indexOf('_usuario_modificacion')===-1) delete item._usuario_modificacion;
        }

        function seleccionarTodos() {
            if(!vm.seleccionar) {
                vm.items.data.map (function (item) {
                    item.selected = true;
                });
            } else {
                vm.items.data.map (function (item) {
                    item.selected = false;
                });
            }
            if(angular.isFunction(vm.seleccionados)) vm.seleccionados(existeSeleccionado());
        }

        function prevent(ev) {
            ev.stopPropagation();
        }

        function getItems () {
            if (vm.fieldsData) {
                vm.promise = getData();
            }
        }

        function add(event, item) {
            var id = Util.getId(item, vm.fieldsData);
            if (id) {
                getItem(event, false, id);
            } else {
                item = {};
                item._usuario_creacion = vm.usuario;
                item._fecha_creacion = new Date();
                item._fecha_modificacion = new Date();
                openDialog(event, true, item);
            }
        }

        function save (data) {

            var obj = {};

            for (var i in data) {
                obj[i] = vm.dataGrid[data[i]];
            }

            DataService.save(vm.url, Util.parseSave(obj, vm.fieldsData))
            .then(function(data) {
                if (data) {
                    Message.show(data.tipoMensaje,data.mensaje);
                }
            });
        }


        function saveAll () {
            var data = vm.dataGrid,
                c = 0,
                length = vm.headers.length,
                dataSave = [],
                obj = {},
                promises = [];

            for (var i in data) {
                var key = i.split('_');
                key.shift();
                key = key.join('_');
                obj[key] = data[i];
                c++;
                if (c % length == 0) {
                    dataSave.push(obj);
                    promises.push(savePromise(obj));
                    obj = {};
                }
            }
            Promise.all(promises)
            .then(function (response) {
                for (var i in response) {
                    if (response[i] === false) {
                        Message.error('Se produjo un error al grabar todos los datos.');
                        throw new Error('Error al grabar todos los datos');
                    }
                }
                Message.success('Se guardaron todos los datos');
            });
        }

        function savePromise(data) {
            return new Promise(function (resolve, reject) {
                DataService.save(vm.url, Util.parseSave(data, vm.fieldsData))
                .then(function(data) {
                    if (data) {
                        resolve(true);
                    } else {
                        reject(false);
                    }
                }).catch(function () {
                    reject(false);
                });
            });
        }

        function edit (event, item) {
            vm.add(event, item);
        }

        function deleteItem (event, item) {
            Modal.confirm('Se eliminará el registro de forma permanente, ¿Está seguro?.', function () {
                DataService.delete( vm.url , Util.getId(item, vm.fieldsData))
                .then(function() {
                    Message.success('El registro se eliminó correctamente.');
                    vm.getItems();
                })
                .catch(function () {
                    Message.error();
                });
            }, null, event);
        }

        function getItem(event, add, id) {
            DataService.get( vm.url, id + (vm.include ? '?include=' + vm.include: ''))
            .then(function(data) {
              if (data && data.datos[Util.getId(data, vm.fieldsData, true)]) {
                    data.datos._usuario_modificacion = vm.usuario;
                    data.datos._fecha_modificacion = new Date();
                    openDialog(event, add, Util.filterItem(data.datos));
                }
            });
        }

        function openDialog(event, add, item) {
            var config = {
                event: event,
                data: item,
                title: add ? 'Agregar' : 'Editar',
                add: add,
                fields: vm.fieldsData,
                column: vm.column || 1,
                templateUrl : vm.template || 'app/components/crudTableAprobacion/dialog.crudTable.html',
                done : function (answer, $mdDialog) {
                    if (answer == 'save') {
                        delete item._fecha_creacion;
                        delete item._fecha_modificacion;
                        DataService.save( vm.url, Util.parseSave(item, vm.fieldsData))
                        .then(function(data) {
                            if (data) {
                                Message.show(data.tipoMensaje,'', null, 0);
                                $mdDialog.hide();
                                vm.getItems();
                                if (vm.eventSave) {
                                    vm.eventSave(data);
                                }
                            }
                        });
                    }
                }
            };
            if (vm.dialogController) {
                config.controller = vm.dialogController;
            }
            Modal.show(config);
        }

        function openDialogConfirAdjunto(event, id_adjunto) {
            var config = {
                event: event,
                title: 'Confirmar Aprobación de Documento Adjunto',
                column: vm.column || 1,
                templateUrl : vm.template || 'app/components/crudTableAprobacion/dialog.confirmarAprobacionAdjunto.html',
                done : function (answer, $mdDialog) {
                    if (answer == 'save') {
                        DataService.post(vm.url + '/adjunto', { id_adjunto: id_adjunto })
                        .then(function (response) {
                            if(response && response &&  response.finalizado) {
                                vm.urlAbrir = $sce.trustAsResourceUrl(response.link);
                                $mdDialog.hide();
                                $window.location.href = vm.urlAbrir;
                            } else {
                                Message.error('Error en la solicitud.');
                            }
                        })
                        .catch(function (error) {
                            Message.error(error.mensaje || error.data.mensaje || 'Error en la solicitud.');
                        })
                    }
                }
            };
            if (vm.dialogController) {
                config.controller = vm.dialogController;
            }
            Modal.show(config);
        }

        function openDialogConfirDocumento(event, id_documento) {
            var config = {
                event: event,
                title: 'Confirmar Aprobación de Documento',
                column: vm.column || 1,
                templateUrl : vm.template || 'app/components/crudTableAprobacion/dialog.confirmarAprobacionDocumento.html',
                done : function (answer, $mdDialog) {
                    if (answer == 'save') {
                        DataService.post(vm.url, { id_documento: id_documento })
                        .then(function (response) {
                            if(response && response &&  response.finalizado) {
                                vm.urlAbrir = $sce.trustAsResourceUrl(response.link);
                                $mdDialog.hide();
                                $window.location.href = vm.urlAbrir;
                            } else {
                                Message.error('Error en la solicitud.');
                            }
                        })
                        .catch(function (error) {
                            Message.error(error.mensaje || error.data.mensaje || 'Error en la solicitud.');
                        })
                    }
                }
            };
            if (vm.dialogController) {
                config.controller = vm.dialogController;
            }
            Modal.show(config);
        }

        function getData() {
            if (vm.include) {
                vm.query.include = vm.include;
            }
            if (vm.queryExtra) {
                for (var k in vm.queryExtra) {
                    vm.query[k] = vm.queryExtra[k];
                }
            }
            if(vm.onlyFields){
                vm.query['fields'] = '';
                for (var i = 0; i < vm.fields.length; i++) {
                    vm.query['fields'] += vm.fields[i]+",";
                }
                vm.query['fields'] = vm.query['fields'].substring(0, vm.query['fields'].length-1);
            }
            if(vm.estadoChecks){
                if(vm.busqueda_estado.length>0) vm.query['estado'] = vm.busqueda_estado.toString();
                else delete vm.query['estado'];
            }
            
            if(vm.searchPro){
                vm.query['searchPro'] = 1;
                vm.query['tipoBus'] = vm.tipo_busqueda;
                if(vm.tipo_busqueda!='todos' || vm.tipo_busqueda!='documento'){
                    if(vm.tipo_busqueda=='campo'){
                        vm.query['campoSel'] = vm.campo_seleccionado.name || vm.headers[1].name;
                    }
                }else {
                    delete vm.query['tipoBus'];
                    delete vm.query['campoSel'];
                    delete vm.query['fFin'];
                }
                if(vm.check_fechas){
                    if (!Datetime.isDate(vm.fecha_inicio))
                    vm.fecha_inicio = new Date(Datetime.subtractDays(new Date(), 365));
                    if(!Datetime.isDate(vm.fecha_final))
                    vm.fecha_final = new Date();
                    vm.query['fIni'] = vm.fecha_inicio;
                    vm.query['fFin'] = new Date(Datetime.addDays(vm.fecha_final, 1));
                    vm.query['fIni'].setHours(0);
                    vm.query['fFin'].setHours(0);
                }else {
                    delete vm.query['fIni'];
                    delete vm.query['fFin'];
                }
            }
            return DataService.list( vm.url, vm.query)
            .then(function(data) {
                if (data) {
                  var items = {};
                  var datos = data.datos;
                  items.count = datos.total;
                  items.results = datos.resultado;
                  items.data = datos.resultado;
                  items.data = filterItems(datos.resultado);
                  vm.items = items;
                  if (items.count === 0) {
                    Message.show(
                      "INFORMACION",
                      "Usted no tiene documentos pendientes para aprobar con Ciudadanía Digital",
                      null,
                      0
                    );
                  }
                  if (angular.isFunction(vm.seleccionados))
                    vm.seleccionados(existeSeleccionado());
                }
            });
        }

        function existeSeleccionado() {
          var cont = 0;
          var respuesta = false;
          vm.items.data.map (function (item) {
            if(item.selected === true) cont++;
          });
          if(cont > 0) respuesta = true;
          return respuesta;
        }

        function getFields() {
            DataService.fields(vm.url)
            .then(function(data) {
                if (data) {
                    vm.fieldsData = Util.filterFields(data, vm.fields);
                    vm.fieldsData = Util.addPropertiesFormly(vm.fieldsData, vm.formly);

                    var arr = ["_usuario_creacion","_usuario_modificacion","_fecha_creacion","_fecha_modificacion"];
                    for (var i in vm.fieldsData) {
                      var xfield = vm.fieldsData[i];
                      var arrindex = arr.indexOf(xfield.key);
                      if( arrindex != -1){
                        xfield.templateOptions.required = false;
                        xfield.templateOptions.disabled = true;
                        if(arrindex == 2) xfield.templateOptions.label = "Fecha de creación";
                        if(arrindex == 3) xfield.templateOptions.label = "Fecha de modificación";
                      }else if(xfield.templateOptions.label == "ID"){
                        xfield.templateOptions.required = false;
                      }else if (xfield.key.indexOf("fid_") == 0) {
                        var object = {};
                        var options = xfield.templateOptions.options;
                        for (var k in options) {
                          object[options[k].value] = options[k].name  ;
                        }
                        xfield.templateOptions.fkeys = object;
                      }
                    }

                    addOptionSelected(vm.fieldsData, vm.optionSelected);
                    DataService.setFormly(vm.fieldsData);

                    setHeaders(vm.fieldsData);
                    if (vm.editable) {
                        vm.types = Util.getKeys(vm.fieldsData);
                    }
                    if (vm.permission) {
                        vm.permissions = angular.merge(vm.permissions, vm.permission);
                    }
                    if (vm.condiciones) {
                        vm.query = angular.merge(vm.query, vm.condiciones);
                    }
                    vm.getItems();
                }
            });
        }

        function addOptionSelected(data, options) {
            for (var i in data) {
                if (data[i].type == 'select') {
                    var item = Util.searchField(options, data[i].key);
                    if (item) {
                        ArrayUtil.insert(data[i].templateOptions.options, 0, {
                            name: item.text || 'Seleccione',
                            value: item.value || ''
                        });
                    }
                }
            }
        }

        function filterItems(data) {
            var fields = typeof vm.fields != 'undefined';
            var fks = typeof vm.fks != 'undefined';
            var array = [];
            for (var i in data) {
                for (var j in data[i]) {
                    if (fields && vm.fields.indexOf(j) == -1) {
                        delete data[i][j];
                    } else {
                        if (typeof vm.editable == 'undefined') {
                            if (typeof data[i][j] == 'boolean') {
                                // TODO: oendiente tratamiento
                                // data[i][j] = data[i][j] ? 'check_circle_success' : 'check_circle_gray';
                            } else if (fks && vm.fks.indexOf(j) != -1) {
                                if (Util.toType(data[i][j]) == 'array') {
                                    var l = Util.lengthOptions(vm.fieldsData, j);
                                    if (l > 1 && l == data[i][j].length) {
                                        data[i][j] = 'Todos';
                                    } else {
                                        var text = [];
                                        /*eslint-disable no-unused-vars*/
                                        data[i][j].map(function (e, i) {
                                          /*eslint-enable no-unused-vars*/
                                           text.push(Util.getFkData(vm.fieldsData ,j, e));
                                        });
                                        data[i][j] = text.join(', ');
                                    }
                                } else {
                                    data[i][j] = Util.getFkData(vm.fieldsData ,j, data[i][j]);
                                }
                            } else if (typeof data[i][j] == 'string' && !/[a-zA-Z]+/g.test(data[i][j]) && /^-?[0-9.]+\-?[0-9]+\-?[0-9]*$/g.test(data[i][j]) && data[i][j].length == 10) {
                                data[i][j] = Util.formatDate(data[i][j]);
                            } else if (Util.toType(data[i][j]) == 'array') {
                                // TODO: oendiente tratamiento
                                // data[i][j] = data[i][j][0];
                            } else if (typeof data[i][j] == 'string' && !/[a-zA-Z]+/g.test(data[i][j]) && /^(?:(?:([01]?\d|2[0-3]):)?([0-5]?\d):)?([0-5]?\d)$/g.test(data[i][j]) && data[i][j].length == 8) {
                              data[i][j] = formatTime(data[i][j])
                            }
                        }
                    }
                }
                array.push(orderItem(data[i], vm.fieldsData, i));
            }
            return array;
        }

        function orderItem(data, fields, pos) {

            if (typeof fields == 'undefined' || fields.length == 0) {
                return data;
            }

            var item = {};

            for (var i in fields) {
                var field = fields[i].key;
                if (typeof data[field] != 'undefined') {
                    if (vm.editable) {
                        if (typeof data[field] == 'string' && !/[a-zA-Z]+/g.test(data[field]) && /^-?[0-9.]+\-?[0-9]+\-?[0-9]*$/g.test(data[field]) && data[field].length == 10) {
                            var date = data[field].split('-');
                            vm.dataGrid[pos + '_' + field] = new Date(date[0], date[1]-1, date[2]);
                        } else {
                            vm.dataGrid[pos + '_' + field] = data[field];
                        }
                        item[field] = pos + '_' + field;
                    } else {
                        item[field] = data[field];
                    }
                }
            }
            return item;
        }

        function formatTime(time) {
            time = time.split(':')
            return [time[0], time[1]].join(':')
        }

        function setHeaders(data) {
            var headers = [];
            var order = typeof vm.order == 'undefined';
            for (var i in data) {
                headers.push({
                    name: data[i].key,
                    title: data[i].templateOptions.label,
                    order: order || (vm.order && vm.order.indexOf(data[i].key) != -1)
                });
            }
            vm.headers = headers;
        }

        function print(event, item) {
            DataService.pdf(vm.url + 'print/' + Util.getId(item, vm.fieldsData) + '/')
            .then(function (data) {
                Modal.show({
                    event: event,
                    data: data.url,
                    title: 'Impresión',
                    templateUrl : 'app/components/crudTableAprobacion/dialog.pdf.html',
                    controller: ['$scope', '$mdDialog', 'data', 'title', PdfController]
                });
            });
        }

        function PdfController($scope, $mdDialog, data, title) {
            var vm = $scope;

            vm.title = title;
            vm.data = data;
            vm.hide = $mdDialog.hide;
            vm.cancel = $mdDialog.cancel;
        }

        function showFilter() {
            vm.filter.show = true;
            $timeout(function () {
                angular.element('#crud-table-input').focus();
            }, 300);
        }

        function removeFilter () {
            vm.filter.show = false;
            vm.query.filter = '';
            vm.tipo_busqueda='todos';

            if(vm.filter.form.$dirty) {
                vm.filter.form.$setPristine();
            }
        }

        $scope.$watch('vm.query.filter', function (newValue, oldValue) {
            if(!oldValue) {
                bookmark = vm.query.page;
            }

            if(newValue !== oldValue) {
                vm.query.page = 1;
            }

            if(!newValue) {
                vm.query.page = bookmark;
            }

            vm.getItems();
        });

        //New Bottons
        function buttonEvent(event, item, callback) {
            callback(event, Util.getId(item, vm.fieldsData));
        }

    }

})();

(function() {
    'use strict';

    angular
    .module('app')
    .component('documentoIdentidad', {
        templateUrl: 'app/components/documentoIdentidad/documentoIdentidad.html',
        controller: ['$scope', 'DataService', 'Datetime', 'Message', DocumentoIdentidadController],
        controllerAs: 'vm',
        bindings: {
            ngModel: '=',
            ngDisabled: '=',
            onlyCi: '@',
            url: '='
        }
    });

    /** @ngInject */
    function DocumentoIdentidadController($scope, DataService, Datetime, Message) {
        var vm = this;

        vm.tipos = [
            {
                value: 'CI',
                name: 'Cedula de identidad'
            },
            {
                value: 'PASAPORTE',
                name: 'Pasaporte'
            }
        ];

        vm.tipo_documento = 'CI';
        vm.search = search;
        vm.isDisabled = isDisabled;

        activate();

        function activate() {
            if (vm.ngModel) {
                vm.model = vm.ngModel;
                vm.fecha_nacimiento = new Date(vm.model.persona.fecha_nacimiento);
                vm.complemento = vm.model.persona.complemento;
                vm.nro_documento = vm.model.persona.nro_documento;
                vm.tipo_documento = vm.model.persona.tipo_documento;
            } else {
                vm.model = {};
            }
        }

        function isDisabled() {
            return typeof vm.nro_documento == 'undefined' || !Datetime.isDate(vm.fecha_nacimiento);
        }

        function search() {
            Message.loading("Buscando datos en el SEGIP");
            DataService.get(vm.url + vm.nro_documento + '?fecha_nacimiento=' + Datetime.format(vm.fecha_nacimiento, 'dd/MM/YYYY'))
            .then(function(response) {
                if (response) {
                    vm.model.persona = response;
                    vm.ngModel = vm.model;
                } else {
                    vm.model.persona = {};
                    vm.ngModel = vm.model;
                }
            });
        }

        $scope.$watch('vm.tipo_documento', function (newValue) {
            vm.model.tipo_documento = newValue;
            vm.ngModel = vm.model;
        });
        $scope.$watch('vm.nro_documento', function (newValue) {
            vm.model.nro_documento = newValue;
            vm.ngModel = vm.model;
        });
        $scope.$watch('vm.complemento', function (newValue) {
            vm.model.complemento = newValue;
            vm.ngModel = vm.model;
        });
        $scope.$watch('vm.fecha_nacimiento', function (newValue) {
            vm.model.fecha_nacimiento = newValue;
            vm.ngModel = vm.model;
        });

    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .constant('charColors', {
            bo: {
                rojo: 'rgba(211, 47, 47, 0.7)',
                azul: 'rgba(48, 79, 254, 0.7)',
                amarillo: 'rgba(255, 171, 0, 0.7)',
                celeste: 'rgba(0, 184, 212, 0.7)',
                lila: 'rgba(123, 31, 162, 0.7)',
                naranja: 'rgba(230, 74, 25, 0.7)',
                verde: 'rgba(104, 159, 56, 0.7)'
            },
            bg: {
                rojo: 'rgba(211,47,47, 0.1)',
                azul: 'rgba(48, 79, 254, 0.1)',
                amarillo: 'rgba(255, 171, 0, 0.1)',
                celeste: 'rgba(0, 184, 212, 0.1)',
                lila: 'rgba(123, 31, 162, 0.1)',
                naranja: 'rgba(230, 74, 25, 0.1)',
                verde: 'rgba(104, 159, 56, 0.1)'
            }
        })
        .directive('chartGraph', ['$timeout', '$window', function ($timeout, $window) {
            var options_default = {
                line: {
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero:true
                            }
                        }],
                        xAxes: [{
                            ticks: {
                                autoSkip: false
                            }
                        }]
                    },
                    legend: {
                        labels: {
                            boxWidth: 15
                        }
                    },
                    tooltips: {
                        mode: 'x-axis'
                    }
                },
                bar: {
                    legend: {
                        labels: {
                            boxWidth: 15
                        }
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero:true
                            }
                        }],
                        xAxes: [{
                            ticks: {
                                autoSkip: false
                            }
                        }]
                    }

                }
            };
            // Runs during compile
            return {
                scope: {
                    ancho: '=',
                    alto: '=',
                    tipo: '=',
                    datos: '=',
                    actualizar: '=', // flag disparador del watch actualizar
                    reiniciar: '=', // flag disparador del watch reiniciar
                    opciones: '='
                },
                restrict: 'E', // E = Element, A = Attribute, C = Class, M = Comment
                link: function (sc, elm, attrs, controller) { // eslint-disable-line no-unused-vars
                    $timeout(function () {
                        var canvas, xchart;
                        elm.wrap('<div></div>');
                        elm.parent().css('overflow','auto');
                        // elm.parent().css('border','1px solid #c3c3c3');
                        // elm.parent().css('box-shadow','3px 3px 3px 0 solid #e3e3e3');

                        iniciar();
                        /**
                          Funcion que inicia o reinicia el componente chart
                        */
                        function isMobile() { return angular.isDefined($window.orientation); }

                        function iniciar() {
                            if(isMobile()){
                                if(sc.ancho>750) sc.ancho=750;
                                if(sc.alto>320) sc.alto=320;
                            }
                            elm.parent().css('width',((sc.ancho)||400));
                            elm.parent().css('height',((sc.alto)||250));
                            elm.html('<div class="chart-graph" style="width:'+(sc.ancho-25 || 400)+'px;height:'+(sc.alto-25||250)+'px;"><canvas></canvas></div>');
                            canvas = elm.children('div').children('canvas');
                            canvas.attr('width',(sc.ancho-20||400));
                            canvas.attr('height',(sc.alto-20||250));
                            xchart = new Chart(canvas, { // eslint-disable-line no-undef
                                type: sc.tipo || 'line',
                                data: sc.datos,
                                options: sc.opciones || options_default[sc.tipo || 'line']
                            });
                        }
                        /**
                          Funcion que se debe activar cambiando solo datos o labels del objeto sc.datos
                          vm.ch.datos.labels.shift();
                          vm.ch.datos.labels.push(newRandom()+'-02-2017');
                          vm.ch.datos.datasets[0].data.shift();
                          vm.ch.datos.datasets[0].data.push(newRandom());
                          o bien actuializar los arrays completos
                          vm.chart.datos.labels = createLabels(anio,mes);
                          vm.chart.datos.datasets[0].data = getDataRandom(vm.chart.datos.labels.length);
                        */
                        sc.$watch('actualizar', function () { if(angular.isDefined(sc.actualizar)) xchart.update(); })
                        /**
                          Funcion que reinicia el objeto xchart con los parametros ocnfigurados (mas que todo cuando se quiere cambiar de tipo)
                        */
                        sc.$watch('reiniciar', function () { if(angular.isDefined(sc.reiniciar)) iniciar(); });

                    })
                }
            };
        }]);

})();

(function() {
    'use strict'

    angular
    .module('app')
    .component('crudTable', {
        templateUrl : 'app/components/crudTable/crudTable.html',
        controller : ['$scope', 'DataService', 'Message', 'Modal', 'Util', '$timeout', 'ArrayUtil', 'Datetime', '$state', CrudTableController],
        controllerAs: 'vm',
        bindings: {
            url: '=',
            fields: '=',
            fks: '=',
            titleTable: '=',
            template: '=',
            permission: '=',
            column: '=',
            formly: '=',
            editable: '=',
            eventSave: '=',
            dialogController: '=',
            order: '=',
            optionSelected: '=',
            condiciones: '=',
            buttons: '=',
            buttonAgregar: '=',
            headButtons: '=',
            idShow: '=',
            include: '=',
            queryExtra: '=',
            usuario: '=',
            informacionBienes: '=',
            estadoSw: '=', // TODO solo funciona con estado= 'ACTIVO'|'INACTIVO'
            onlyFields: '=',
            searchPro: '=',
            estadoChecks: '=',
            estadoOpciones: '=',
            items: '=?',
            habilitarSeleccion: '=',
            node: '@',
            seleccionados:'='
        }
    });

    function CrudTableController($scope, DataService, Message, Modal, Util, $timeout, ArrayUtil, Datetime, $state) {
        var vm = this;
        var bookmark;
        var limit = 10;

        vm.headers = [];
        vm.items = null;
        vm.item = null;
        // vm.node = true; // Habilitar para nodejs
        vm.tipo_busqueda='todos';
        vm.campo_seleccionado={};
        vm.busqueda_estado = [];

        vm.prevent = prevent;
        vm.estadoModificado = estadoModificado;
        vm.add = add;
        vm.edit = edit;
        vm.delete = deleteItem;
        vm.print = print;
        vm.save = save;
        vm.saveAll = saveAll;
        vm.removeFilter = removeFilter;
        vm.showFilter = showFilter;
        vm.getItems = getItems;
        vm.buttonEvent = buttonEvent;
        vm.dataGrid = {};
        vm.seleccionar = false;
        vm.seleccionarTodos = seleccionarTodos;
        vm.seleccionando = seleccionando;
        // para permitir ver informacion pequeña de documentos
        vm.sw_cite = ['/documentos', '/impresion', '/aprobacion', '/en_curso', '/firmar'].indexOf($state.current.url) !== -1;

        vm.permissions = {
            create: true,
            read: true,
            update: true,
            delete: true,
            print: false,
            filter: true
        }

        vm.limitOptions = [limit, 25, 50];
        // vm.limitOptions = [limit];

        vm.options = {
            rowSelection: false,
            multiSelect: false,
            autoSelect: true,
            decapitate: false,
            largeEditDialog: true,
            boundaryLinks: true,
            limitSelect: true,
            pageSelect: false
        }

        vm.query = {
            order: (vm.fields.indexOf('_fecha_modificacion'))? '-_fecha_modificacion': '',
            limit: limit,
            page: 1,
            filter: ''
        }

        vm.filter = {
            options: {
                debounce: 500
            }
        };

        activate();

        function activate() {
            getFields();
        }

        function seleccionando (){
          if(angular.isFunction(vm.seleccionados)) $timeout(function(){ vm.seleccionados(existeSeleccionado()); });
        }

        function estadoModificado(item) {
            item._usuario_modificacion = vm.usuario;
            DataService.put(vm.url+Util.getId(item, vm.fieldsData), angular.copy(item));
            if(vm.fields.indexOf('_usuario_modificacion')===-1) delete item._usuario_modificacion;
        }

        function seleccionarTodos() {
            if(!vm.seleccionar) {
                vm.items.data.map (function (item) {
                    item.selected = true;
                });
            } else {
                vm.items.data.map (function (item) {
                    item.selected = false;
                });
            }
            if(angular.isFunction(vm.seleccionados)) vm.seleccionados(existeSeleccionado());
        }

        function prevent(ev) {
            ev.stopPropagation();
        }

        function getItems () {
            if (vm.fieldsData) {
                vm.promise = getData();
            }
        }

        function add(event, item) {
            var id = Util.getId(item, vm.fieldsData);
            if (id) {
                getItem(event, false, id);
            } else {
                item = {};
                item._usuario_creacion = vm.usuario;
                item._fecha_creacion = new Date();
                item._fecha_modificacion = new Date();
                openDialog(event, true, item);
            }
        }

        function save (data) {

            var obj = {};

            for (var i in data) {
                obj[i] = vm.dataGrid[data[i]];
            }

            DataService.save(vm.url, Util.parseSave(obj, vm.fieldsData))
            .then(function(data) {
                if (data) {
                    Message.show(data.tipoMensaje,data.mensaje);
                }
            });
        }


        function saveAll () {
            var data = vm.dataGrid,
                c = 0,
                length = vm.headers.length,
                dataSave = [],
                obj = {},
                promises = [];

            for (var i in data) {
                var key = i.split('_');
                key.shift();
                key = key.join('_');
                obj[key] = data[i];
                c++;
                if (c % length == 0) {
                    dataSave.push(obj);
                    promises.push(savePromise(obj));
                    obj = {};
                }
            }
            Promise.all(promises)
            .then(function (response) {
                for (var i in response) {
                    if (response[i] === false) {
                        Message.error('Se produjo un error al grabar todos los datos.');
                        throw new Error('Error al grabar todos los datos');
                    }
                }
                Message.success('Se guardaron todos los datos');
            });
        }

        function savePromise(data) {
            return new Promise(function (resolve, reject) {
                DataService.save(vm.url, Util.parseSave(data, vm.fieldsData))
                .then(function(data) {
                    if (data) {
                        resolve(true);
                    } else {
                        reject(false);
                    }
                }).catch(function () {
                    reject(false);
                });
            });
        }

        function edit (event, item) {
            vm.add(event, item);
        }

        function deleteItem (event, item) {
            Modal.confirm('Se eliminará el registro de forma permanente, ¿Está seguro?.', function () {
                DataService.delete( vm.url , Util.getId(item, vm.fieldsData))
                .then(function() {
                    Message.success('El registro se eliminó correctamente.');
                    vm.getItems();
                })
                .catch(function () {
                    Message.error();
                });
            }, null, event);
        }

        function getItem(event, add, id) {
            DataService.get( vm.url, id + (vm.include ? '?include=' + vm.include: ''))
            .then(function(data) {
              if (data && data.datos[Util.getId(data, vm.fieldsData, true)]) {
                    data.datos._usuario_modificacion = vm.usuario;
                    data.datos._fecha_modificacion = new Date();
                    openDialog(event, add, Util.filterItem(data.datos));
                }
            });
        }

        function openDialog(event, add, item) {
            var config = {
                event: event,
                data: item,
                title: add ? 'Agregar' : 'Editar',
                add: add,
                fields: vm.fieldsData,
                column: vm.column || 1,
                templateUrl : vm.template || 'app/components/crudTable/dialog.crudTable.html',
                done : function (answer, $mdDialog) {
                    if (answer == 'save') {
                        delete item._fecha_creacion;
                        delete item._fecha_modificacion;
                        DataService.save( vm.url, Util.parseSave(item, vm.fieldsData))
                        .then(function(data) {
                            if (data) {
                                Message.show(data.tipoMensaje,'', null, 0);
                                $mdDialog.hide();
                                vm.getItems();
                                if (vm.eventSave) {
                                    vm.eventSave(data);
                                }
                            }
                        });
                    }
                }
            };
            if (vm.dialogController) {
                config.controller = vm.dialogController;
            }
            Modal.show(config);
        }

        function getData() {
            if (vm.include) {
                vm.query.include = vm.include;
            }
            if (vm.queryExtra) {
                for (var k in vm.queryExtra) {
                    vm.query[k] = vm.queryExtra[k];
                }
            }
            if(vm.onlyFields){
                vm.query['fields'] = '';
                for (var i = 0; i < vm.fields.length; i++) {
                    vm.query['fields'] += vm.fields[i]+",";
                }
                vm.query['fields'] = vm.query['fields'].substring(0, vm.query['fields'].length-1);
            }
            if(vm.estadoChecks){
                if(vm.busqueda_estado.length>0) vm.query['estado'] = vm.busqueda_estado.toString();
                else delete vm.query['estado'];
            }

            if(vm.searchPro){
                vm.query['searchPro'] = 1;
                vm.query['tipoBus'] = vm.tipo_busqueda;
                if(vm.tipo_busqueda!='todos' || vm.tipo_busqueda!='documento'){
                    if(vm.tipo_busqueda=='campo'){
                        vm.query['campoSel'] = vm.campo_seleccionado.name || vm.headers[1].name;
                    }
                }else {
                    delete vm.query['tipoBus'];
                    delete vm.query['campoSel'];
                    delete vm.query['fFin'];
                }
                if(vm.check_fechas){
                    if (!Datetime.isDate(vm.fecha_inicio))
                        vm.fecha_inicio = new Date(Datetime.subtractDays(new Date(), 365));
                    if(!Datetime.isDate(vm.fecha_final))
                        vm.fecha_final = new Date();
                    vm.query['fIni'] = vm.fecha_inicio;
                    vm.query['fFin'] = new Date(Datetime.addDays(vm.fecha_final, 1));
                    vm.query['fIni'].setHours(0);
                    vm.query['fFin'].setHours(0);
                }else {
                    delete vm.query['fIni'];
                    delete vm.query['fFin'];
                }
            }
            return DataService.list( vm.url, vm.query)
            .then(function(data) {
                if (data) {
                    var items = {};
                    var datos = data.datos;

                    items.count = datos.total;
                    items.results = datos.resultado;
                    items.data = filterItems(datos.resultado);
                    vm.items = items;
                    if(angular.isFunction(vm.seleccionados)) vm.seleccionados(existeSeleccionado());
                }
            });
        }

        function existeSeleccionado() {
          var cont = 0;
          var respuesta = false;
          vm.items.data.map (function (item) {
            if(item.selected === true) cont++;
          });
          if(cont > 0) respuesta = true;
          return respuesta;
        }

        function getFields() {
            DataService.fields(vm.url)
            .then(function(data) {
                if (data) {
                    vm.fieldsData = Util.filterFields(data, vm.fields);
                    vm.fieldsData = Util.addPropertiesFormly(vm.fieldsData, vm.formly);

                    var arr = ["_usuario_creacion","_usuario_modificacion","_fecha_creacion","_fecha_modificacion"];
                    for (var i in vm.fieldsData) {
                      var xfield = vm.fieldsData[i];
                      var arrindex = arr.indexOf(xfield.key);
                      if( arrindex != -1){
                        xfield.templateOptions.required = false;
                        xfield.templateOptions.disabled = true;
                        if(arrindex == 2) xfield.templateOptions.label = "Fecha de creación";
                        if(arrindex == 3) xfield.templateOptions.label = "Fecha de modificación";
                      }else if(xfield.templateOptions.label == "ID"){
                        xfield.templateOptions.required = false;
                      }else if (xfield.key.indexOf("fid_") == 0) {
                        var object = {};
                        var options = xfield.templateOptions.options;
                        for (var k in options) {
                          object[options[k].value] = options[k].name  ;
                        }
                        xfield.templateOptions.fkeys = object;
                      }
                    }

                    addOptionSelected(vm.fieldsData, vm.optionSelected);
                    DataService.setFormly(vm.fieldsData);

                    setHeaders(vm.fieldsData);
                    if (vm.editable) {
                        vm.types = Util.getKeys(vm.fieldsData);
                    }
                    if (vm.permission) {
                        vm.permissions = angular.merge(vm.permissions, vm.permission);
                    }
                    if (vm.condiciones) {
                        vm.query = angular.merge(vm.query, vm.condiciones);
                    }
                    vm.getItems();
                }
            });
        }

        function addOptionSelected(data, options) {
            for (var i in data) {
                if (data[i].type == 'select') {
                    var item = Util.searchField(options, data[i].key);
                    if (item) {
                        ArrayUtil.insert(data[i].templateOptions.options, 0, {
                            name: item.text || 'Seleccione',
                            value: item.value || ''
                        });
                    }
                }
            }
        }

        function filterItems(data) {
            var fields = typeof vm.fields != 'undefined';
            var fks = typeof vm.fks != 'undefined';
            var array = [];
            for (var i in data) {
                for (var j in data[i]) {
                    if (fields && vm.fields.indexOf(j) == -1) {
                        delete data[i][j];
                    } else {
                        if (typeof vm.editable == 'undefined') {
                            if (typeof data[i][j] == 'boolean') {
                                data[i][j] = data[i][j] ? 'check_circle_success' : 'check_circle_gray';
                            } else if (fks && vm.fks.indexOf(j) != -1) {
                                if (Util.toType(data[i][j]) == 'array') {
                                    var l = Util.lengthOptions(vm.fieldsData, j);
                                    if (l > 1 && l == data[i][j].length) {
                                        data[i][j] = 'Todos';
                                    } else {
                                        var text = [];
                                        /*eslint-disable no-unused-vars*/
                                        data[i][j].map(function (e, i) {
                                          /*eslint-enable no-unused-vars*/
                                           text.push(Util.getFkData(vm.fieldsData ,j, e));
                                        });
                                        data[i][j] = text.join(', ');
                                    }
                                } else {
                                    data[i][j] = Util.getFkData(vm.fieldsData ,j, data[i][j]);
                                }
                            } else if (typeof data[i][j] == 'string' && !/[a-zA-Z]+/g.test(data[i][j]) && /^-?[0-9.]+\-?[0-9]+\-?[0-9]*$/g.test(data[i][j]) && data[i][j].length == 10) {
                                data[i][j] = Util.formatDate(data[i][j]);
                            } else if (Util.toType(data[i][j]) == 'array') {
                                data[i][j] = data[i][j][0];
                            } else if (typeof data[i][j] == 'string' && !/[a-zA-Z]+/g.test(data[i][j]) && /^(?:(?:([01]?\d|2[0-3]):)?([0-5]?\d):)?([0-5]?\d)$/g.test(data[i][j]) && data[i][j].length == 8) {
                              data[i][j] = formatTime(data[i][j])
                            }
                        }
                    }
                }
                array.push(orderItem(data[i], vm.fieldsData, i));
            }
            return array;
        }

        function orderItem(data, fields, pos) {

            if (typeof fields == 'undefined' || fields.length == 0) {
                return data;
            }

            var item = {};

            for (var i in fields) {
                var field = fields[i].key
                if (typeof data[field] != 'undefined') {
                    if (vm.editable) {
                        if (typeof data[field] == 'string' && !/[a-zA-Z]+/g.test(data[field]) && /^-?[0-9.]+\-?[0-9]+\-?[0-9]*$/g.test(data[field]) && data[field].length == 10) {
                            var date = data[field].split('-');
                            vm.dataGrid[pos + '_' + field] = new Date(date[0], date[1]-1, date[2]);
                        } else {
                            vm.dataGrid[pos + '_' + field] = data[field];
                        }
                        item[field] = pos + '_' + field;
                    } else {
                        item[field] = data[field];
                    }
                }
            }

            return item;
        }

        function formatTime(time) {
            time = time.split(':')
            return [time[0], time[1]].join(':')
        }

        function setHeaders(data) {
            var headers = [];
            var order = typeof vm.order == 'undefined';
            for (var i in data) {
                headers.push({
                    name: data[i].key,
                    title: data[i].templateOptions.label,
                    order: order || (vm.order && vm.order.indexOf(data[i].key) != -1)
                });
            }
            vm.headers = headers;
        }

        function print(event, item) {
            DataService.pdf(vm.url + 'print/' + Util.getId(item, vm.fieldsData) + '/')
            .then(function (data) {
                Modal.show({
                    event: event,
                    data: data.url,
                    title: 'Impresión',
                    templateUrl : 'app/components/crudTable/dialog.pdf.html',
                    controller: ['$scope', '$mdDialog', 'data', 'title', PdfController]
                });
            });
        }

        function PdfController($scope, $mdDialog, data, title) {
            var vm = $scope;

            vm.title = title;
            vm.data = data;
            vm.hide = $mdDialog.hide;
            vm.cancel = $mdDialog.cancel;
        }

        function showFilter() {
            vm.filter.show = true;
            $timeout(function () {
                angular.element('#crud-table-input').focus();
            }, 300);
        }

        function removeFilter () {
            vm.filter.show = false;
            vm.query.filter = '';
            vm.tipo_busqueda='todos';

            if(vm.filter.form.$dirty) {
                vm.filter.form.$setPristine();
            }
        }

        $scope.$watch('vm.query.filter', function (newValue, oldValue) {
            if(!oldValue) {
                bookmark = vm.query.page;
            }

            if(newValue !== oldValue) {
                vm.query.page = 1;
            }

            if(!newValue) {
                vm.query.page = bookmark;
            }

            vm.getItems();
        });

        //New Bottons
        function buttonEvent(event, item, callback) {
            callback(event, Util.getId(item, vm.fieldsData));
        }

    }

})();

'use strict';

angular
.module('app')
.directive('ngMostrarThumb',['$window',function($window){
  var helper={
    support: !!($window.FileReader && $window.CanvasRenderingContext2D),
    extension:function(pUrl){
      return pUrl.slice(pUrl.lastIndexOf(".")+1);
    }
  }

  return{
    restrict:'A',
    template:'<canvas/>',
    link:function(scope,element,attributes){
      var params=scope.$eval(attributes.ngMostrarThumb);
      var canvas = element.find('canvas');
      var imagenes=['jpg','png','jpeg','bmp','gif'];
      // var documentos=['pdf'];
      var extension=helper.extension(params.ruta);

      if(imagenes.indexOf(extension)> -1){
        // var reader = new FileReader();
        var img = new Image();
        img.src=params.ruta;
        helper.extension(params.ruta);
        img.onload=function(){
          var width = params.width || this.width / this.height * params.height;
          var height = params.height || this.height / this.width * params.width;
          canvas.attr({width:width, height:height});
          canvas[0].getContext('2d').drawImage(img,0,0,width,height);
        }
      }
      // TODO: como se adjunta un pdf a canvas??, es necesario usar pdf.js??
      // else if(documentos.indexOf(extension)> -1){
      // }



    }
  };
}]);

'use strict';

angular
    .module('app')
    .directive('ngThumb', ['$window', function($window) {
        var helper = {
            support: !!($window.FileReader && $window.CanvasRenderingContext2D),
            isFile: function(item) {
                return angular.isObject(item) && item instanceof $window.File;
            },
            isImage: function(file) {
                var type =  '|' + file.type.slice(file.type.lastIndexOf('/') + 1) + '|';
                return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1;
            }
        };

        return {
            restrict: 'A',
            template: '<canvas/>',
            link: function(scope, element, attributes) {
                if (!helper.support) return;

                var params = scope.$eval(attributes.ngThumb);

                if (!helper.isFile(params.file)) return;
                if (!helper.isImage(params.file)) return;

                var canvas = element.find('canvas');
                var reader = new FileReader();

                reader.onload = onLoadFile;
                reader.readAsDataURL(params.file);

                function onLoadFile(event) {
                    var img = new Image();
                    img.onload = onLoadImage;
                    img.src = event.target.result;
                }

                function onLoadImage() {
                    var width = params.width || this.width / this.height * params.height;
                    var height = params.height || this.height / this.width * params.width;
                    canvas.attr({ width: width, height: height });
                    canvas[0].getContext('2d').drawImage(this, 0, 0, width, height);
                }
            }
        };
    }]);
(function() {
    'use strict'

    angular
    .module('app')
    .component('cargadorArchivos', {
        templateUrl : 'app/components/cargadorArchivos/cargadorArchivos.html',
        controller : ['$scope', 'restUrl', 'DataService', 'Storage', 'FileUploader','Modal', CargadorArchivosController],
        controllerAs: 'vm',
        bindings: {
            archivos: '=', // Lista de archivos subidos
            permitidos: '=',
            anchoMiniatura: '=',
            altoMiniatura: '=',
            soloImagenes: '=',
            maxArchivosPermitidos: '=',
            mostrar:'='
        }
    });

    function CargadorArchivosController($scope, restUrl, DataService, Storage, FileUploader,Modal) {

        var vm = this;
        vm.uploader = new FileUploader({url: ""});
        vm.restUrl=restUrl;
        vm.fotosEliminar=[];

        if(vm.archivos==null){
            vm.archivos = vm.uploader.queue;
        }else {
            vm.uploader.queue = vm.archivos;
        }
        vm.formatos = vm.permitidos.replace(/(\||,)/g, " ").toUpperCase();
        var uploader = vm.uploader;
        uploader.filters.push({
                name: 'fileFilter',
                fn: function (item) {
                    var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
                    return vm.permitidos.indexOf(type) !== -1;
                }
            });

        //funcion para unir el drop y select
        vm.clickUp = function () {
            angular.element('#input_seleccionar').trigger('click'); //angular way

        };

        vm.esImagen =  function(file) {
                var type =  '|' + file.type.slice(file.type.lastIndexOf('/') + 1) + '|';
                return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1;
        }

        // Funcion que elimina un "archivo".
        vm.eliminar = function(pArchivo){
          // Despliega el modal de confirmacion para eliminar un elemento.
          Modal.confirm('Se eliminará la foto, ¿Está seguro?.', function () {
            var indice=vm.mostrar.indexOf(pArchivo);

            // Si el elemento existe dentro del vector.
            if (indice > -1) {
              // Elimina el elemento, basado en su indice.
              vm.mostrar.splice(indice, 1);
              // Agrega el item eliminado a un vector.
              vm.fotosEliminar.push(pArchivo);
            }

          });

        }



    } //Fin del controller


  })();

(function() {
    'use strict'

    angular
    .module('app')
    .factory('BreadcrumbFactory', BreadcrumbFactory)

    function BreadcrumbFactory() {

        var factory = {
            parent: '',
            current: '',
            setParent: function (parent) {
                this.parent = parent;
            },
            setCurrent: function (current) {
                this.current = current;
            },
            getParent: function () {
                return this.parent;
            },
            getCurrent: function () {
                return this.current;
            }
        };

        return factory;

    }

})();
(function() {
    'use strict';

    angular
    .module('app')
    .component('breadcrumb', {
        templateUrl : 'app/components/breadcrumb/breadcrumb.html',
        controller : ['Storage', '$location', 'BreadcrumbFactory', 'Util', BreadcrumbController],
        bindings: {
            // parent: '=',
            // current: '='
        }
    });

    /** @ngInject */
    function BreadcrumbController(Storage, $location, BreadcrumbFactory, Util) {
        var vm = this;

        vm.getParent = getParent;
        vm.getCurrent = getCurrent;

        activate();

        function activate() {
            if (Storage.exist('menu')) {
                var page = Util.getMenuOption(Storage.getSession('menu'), $location.path().replace('/', ''));
                BreadcrumbFactory.setParent(page[0]);
                BreadcrumbFactory.setCurrent(page[1]);
            }
        }

        function getParent() {
            return BreadcrumbFactory.getParent();
        }

        function getCurrent() {
            return BreadcrumbFactory.getCurrent();
        }

    }

})();

(function() {
  'use strict';

  angular
  .module('app')
  .component('actionTable', {
    templateUrl: 'app/components/actionTable/actionTable.html',
    controller: ['$scope', actionTableController],
    controllerAs: 'vm',
    bindings: {
      fields: '=',
      buttons: '=',
      items: '='
    }
  });

  function actionTableController($scope) {
    var vm = this;
    vm.sc = $scope
    vm.buttonEvent = buttonEvent;

    function buttonEvent(event, item, callback, index) {
      callback(event, item, index);
    }
    
  }
})();
(function() {
  'use strict';

  angular
  .module('app')
  .service('DataService', ['$http', 'Message', 'Util', '$sce', '$log', DataService]);



  /** @ngInject */
  function DataService($http, Message, Util, $sce, $log) {

    var formly = null;
    var errorConnection = 'No se pudo establecer conexión con el servidor.';
    var error500 = 'Se produjo un error en el servidor, inténtelo más tarde.';
    var error404 = 'No existe el recurso solicitado.';
    var error403 = 'No tiene los permisos necesarios.';
    var error401 = 'No se pudo realizar la operación.';

    var service = {
      list: list,
      all: list,
      delete: remove,
      save: save,
      get: get,
      put: put,
      patch: patch,
      post: post,
      postWithFiles: postWithFiles,
      putWithFiles: putWithFiles,
      fields: fields,
      option: fields,
      pdf: pdf,
      file: file,
      setFormly: setFormly
    };

    return service;

    function list(url, query) {
      return $http.get(url + (query ? '?' + Util.serialize(query) : ''))
      .then(function (response) {
        if(response.data){
          return response.data;
        }else{
          $log.warn("list->respuesta sin datos");
        }
      }).catch(function (error) {
        msgError(error);
      });
    }

    function save(url, data) {
      return $http[data.id ? 'put' : 'post'](url + (data.id ? data.id + '/': ''), data)
      .then(function (response) {
        if(response.data){
          return response.data;
        } else {
          $log.warn("save->respuesta sin datos");
        }
      }).catch(function (error) {
        msgError(error);
      });
    }

    function put(url, data) {
      return $http.put(url + (data.id ? data.id + '/': ''), data)
      .then(function (response) {
        if(response.data){
          return response.data;
        }else{
          $log.warn("put->respuesta sin datos");
        }
      }).catch(function (error) {
        msgError(error);
      });
    }

    function putWithFiles(url, data) {
      var config = {
        headers: {
          'Content-Type': undefined
        }
      };
      return $http.put(url, data, config)
      .then(function (response) {
        if(response.data){
          return response.data;
        }else{
          $log.warn("putWithFiles->respuesta sin datos");
        }
      }).catch(function (error) {
        msgError(error);
      });
    }

    function patch(url, data) {
      return $http.patch(url + (data.id ? data.id + '/': ''), data)
      .then(function (response) {
        if(response.data){
          return response.data;
        }else{
          $log.warn("patch->respuesta sin datos");
        }
      }).catch(function (error) {
        msgError(error);
      });
    }

    function post(url, data) {
      return $http.post(url, data)
      .then(function (response) {
        if(response.data){
          return response.data;
        }else{
          $log.warn("post->respuesta sin datos");
        }
      }).catch(function (error) {
        msgError(error);
      });
    }

    function postWithFiles(url, data) {
      var config = {
        headers: {
          'Content-Type': undefined
        }
      };
      return $http.post(url, data, config)
      .then(function (response) {
        if(response.data){
          return response.data;
        }else{
          $log.warn("postWithFiles->respuesta sin datos");
        }
      }).catch(function (error) {
        msgError(error);
      });
    }

    function remove(url, id, noID) {
      var urlRemove = noID == true ? url: url + id + '/';
      return $http.delete(urlRemove)
      .then(function (response) {
        if(response.data){
          return response.data;
        }else{
          $log.warn("remove->respuesta sin datos");
        }
      }).catch(function (error) {
        msgError(error);
      });
    }

    function get(url, id) {
      return $http.get(url + (id ? id + '/' : ''))
      .then(function (response) {
        if(response.data){
          return response.data;
        }else{
          $log.warn("get->respuesta sin datos");
        }
      }).catch(function (error) {
        msgError(error);
      });
    }

    function fields(url) {
      return $http({method: 'OPTIONS', url: url})
      .then(function (response) {
        if(response.data){
          return response.data;
        }else{
          $log.warn("fields->respuesta sin datos");
        }
      }).catch(function (error) {
        msgError(error);
      });
    }

    function pdf(url, data) {
      return $http.post(url, data || {}, {responseType:'arraybuffer'})
      .then(function (response) {
        if (response.data) {
          var file = new Blob([response.data], {type: 'application/pdf'});
          var fileURL = URL.createObjectURL(file);
          return { data: response.data, url: $sce.trustAsResourceUrl(fileURL) };
        }
        return null;
      }).catch(function (error) {
        if(url.indexOf('/documento/firmar')==-1){
          msgError(error);
        }
      });
    }

    function file(url, data, type) {
      // return $http.get(url, data || {}, {responseType:'arraybuffer'})
      return $http.get(url, data || {})
      .then(function (response) {
        if (response.data) {
          // var blob = new Blob([response.data], { type: type || 'text/plain' }),
          //     url = $window.URL || $window.webkitURL;
          var blob = new Blob([response.data], { type: (type || 'text/plain') }, false);
          blob = blob; // TODO: esta linea es innecesaria
          // saveAs(blob, filename || 'file.txt');

          // return url.createObjectURL(blob);
        }
        return true;
      }).catch(function (error) {
        msgError(error);
      });
    }

    function setFormly(data) {
      formly = data;
    }

    function parseError(error) {
      var message = [];
      if (error) {
        if (error.detail || error.error || error.non_field_errors) {
          return error.detail || error.error || error.non_field_errors;
        }
        for (var i in error) {
          var label = i;
          if (formly) {
            formly.filter(function (el) {
              if (el.key == i) {
                label = el.templateOptions.label;
              }
            });
          }
          message.push('<strong>' + label + ':</strong> ' + (Util.toType(error[i]) == 'array' ? error[i].join(', ') : error[i]));
        }
        return message.join('<br>');
      }
      return null;
    }

    function msgError(error) {
      if (error.status === 500) {
        if(error.data.indexOf("SequelizeUniqueConstraintError:") !== -1){
          var xcad = error.data.substring(error.data.indexOf("«"), error.data.indexOf("»"));
          var campo = xcad.substring(1,xcad.lastIndexOf("_"));
          Message.error("El campo "+campo+" ya existe, y no debe duplicarse.");
        }
        else if(error.data.indexOf("SequelizeValidationError:") !== -1){
          var mensajeError=((error.data.split(" ")).splice(3)).join(' ');
          var indice=mensajeError.indexOf("<br>");
          mensajeError=mensajeError.substring(0,indice);
          Message.error(mensajeError);
        }
        else
        Message.error(error500);
      } else if (error.status === 404) {
        Message.error(error404);
      } else if (error.status === 403) {
        Message.error(error403);
      } else if (error.status === 401) {
        Message.error(error401);
      } else if (error.status === 412) {
        Message.show((error.data.tipoMensaje || 'ERROR'), (error.data.mensaje || 'No se pudo obtener una respuesta'));
      } else {
        Message.error(parseError(error.data) || errorConnection);
      }
    }

  }

})();

(function() {
    'use strict';

    angular
    .module('app')
    .filter('datetime', ['Datetime', function(Datetime) {

        return function(date, format) {

            if (format) {
                if (format == 'literal') {
                    return Datetime.dateLiteral(date);
                }
                if (format == 'year') {
                    return Datetime.now('YYYY');
                }
                if (format == 'timeLiteral') {
                    return Datetime.timeLiteral(date);
                }
                if (format == 'HH:mm') {
                    date = date.split(':');
                    return [date[0], date[1]].join(':')
                }
            }

            return date;
        }
    }]);
})();
(function() {
  'use strict';

  angular
    .module('app')
    .config(ThemeConfig);

    /** @ngInject */
    function ThemeConfig($mdThemingProvider) {
        
        $mdThemingProvider.theme('default')
                .primaryPalette('teal') // red, pink, purple, deep-purple, indigo, blue, light-blue, cyan, teal, green, light-green, lime, yellow, amber, orange, deep-orange, brown, grey, blue-grey
                .accentPalette('orange')
               
    }

})();


(function() {
  'use strict';

  angular
    .module('app')
    .run(runBlock);

  /** @ngInject */
    function runBlock(Storage, $location, $log, PageNoLogin, $window, Datetime, $mdDialog, RouteValidator, formlyConfig, MyFormlyConfig, ExpirationTime) {
        RouteValidator.init();
        MyFormlyConfig.init(formlyConfig);
        var $container = angular.element('#container-main');
        var $document = $window.document;

        // Collapsed Panel
        $container.on('click', '.btn-collapsed', function () {
            var $el = angular.element(this)
            $el.parent().parent().next().slideToggle()
            $el.toggleClass('rotate')
        })

        var $toasts = angular.element('#toast-container-main')
        $toasts.on('click', '.md-toast-close', function () {
            angular.element(this).parent().parent().parent().fadeOut()
        });

        // Redirect
        if (!Storage.existUser()) {
            var path = $location.path();
            // $log.log('Revisando el path', path);
            if (!exist(path)) {
                if (path.length) Storage.setSession('path', path.replace('/', ''));                
                if (Storage.getSession('path') !== 'verificar') $location.path('login');
            }
        } else {
            ExpirationTime.init();
        }

        function exist(path) {
            var paths = PageNoLogin;
            for (var i in paths) {
                if (path.indexOf('/' + paths[i]) == 0 || path.indexOf('/' + paths[i] + '/') == 0) {
                    return true;
                }
            }
            return false;
        }

        //Fullscreen
        function exitFullScreen () {
            angular.element('body').removeClass('fullscreen');
        }

        angular.element($window.document).on('keyup', function(e) {
            if (e.keyCode == 27) {
                exitFullScreen();
            }
        });

        $document.addEventListener("mozfullscreenchange", function () {
            if (!$document.mozFullScreen) {
                exitFullScreen();
            }
        }, false);

    }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('home', {
        url: '/',
        templateUrl: 'app/modules/dashboard/main.html',
        controller: 'MainController',
        controllerAs: 'main'
      })
      .state('usuario', {
        url: '/usuario',
        templateUrl: 'app/modules/admin/usuarios/modules.admin.usuarios.html',
        controller: 'UsuariosController',
        controllerAs: 'usuarios'
      })
      .state('menu', {
        url: '/menu',
        templateUrl: 'app/modules/seguridad/menu/modules.seguridad.menu.html',
        controller: 'MenuController',
        controllerAs: 'menu'
      })
      .state('rol', {
        url: '/rol',
        templateUrl: 'app/modules/seguridad/rol/modules.seguridad.rol.html',
        controller: 'RolController',
        controllerAs: 'rol'
      })
      .state('login', {
        url: '/login',
        templateUrl: 'app/modules/admin/login/modules.admin.login.html',
        controller: 'LoginController',
        controllerAs: 'login'
      })
      .state('elegir', {
        url: '/elegir',
        templateUrl: 'app/modules/admin/virtual/virtual.html',
        controller: 'VirtualController',
        controllerAs: 'virtual'
      })
      .state('verificar', {
        url: '/verificar',
        templateUrl: 'app/modules/verificacion/modules.verificar.html',
        controller: 'VerificarController',
        controllerAs: 'verificar'
      })
      .state('profile', {
        url: '/profile',
        templateUrl: 'app/modules/admin/profile/modules.admin.profile.html',
        controller: 'ProfileController',
        controllerAs: 'profile'
      })
      .state('contactos', {
        url: '/contactos',
        templateUrl: 'app/modules/plantillasFormly/contactos/modules.plantillasFormly.contactos.html',
        controller: 'ContactosController',
        controllerAs: 'contactos'
      })
      .state('plantillas', {
        url: '/plantillas',
        templateUrl: 'app/modules/plantillasFormly/plantillas/modules.plantillasFormly.plantillas.html',
        controller: 'PlantillasController',
        controllerAs: 'plantillas'
      })
      .state('plantilla', {
        url: '/plantilla/:idPlantilla',
        templateUrl: 'app/modules/plantillasFormly/plantillas/plantilla/modules.plantillasFormly.plantillas.plantilla.html',
        controller: 'PlantillaController',
        controllerAs: 'plantilla'
      })
      .state('documentos', {
        url: '/documentos',
        templateUrl: 'app/modules/plantillasFormly/documentos/modules.plantillasFormly.documentos.html',
        controller: 'DocumentosController',
        controllerAs: 'documentos'
      })
      .state('documento', {
        url: '/documento/:idDocumento',
        templateUrl: 'app/modules/plantillasFormly/documentos/documento/modules.plantillasFormly.documentos.documento.html',
        controller: 'DocumentoController',
        controllerAs: 'documento'
      })
      .state('aprobacion', {
        url: '/aprobacion',
        templateUrl: 'app/modules/plantillasFormly/aprobacion/modules.plantillasFormly.aprobacion.html',
        controller: 'AprobacionController',
        controllerAs: 'aprobacion'
      })
      .state('impresion', {
        url: '/impresion',
        templateUrl: 'app/modules/plantillasFormly/impresion/modules.plantillasFormly.impresion.html',
        controller: 'ImpresionController',
        controllerAs: 'impresion'
      })
      .state('progreso', {
        url: '/progreso',
        templateUrl: 'app/modules/plantillasFormly/progreso/modules.plantillasFormly.progreso.html',
        controller: 'ProgresoController',
        controllerAs: 'progreso'
      })
      .state('enCurso', {
        url: '/en_curso',
        templateUrl: 'app/modules/plantillasFormly/enCurso/modules.plantillasFormly.enCurso.html',
        controller: 'EnCursoController',
        controllerAs: 'enCurso'
      })
      .state('firmar', {
        url: '/firmar',
        templateUrl: 'app/modules/plantillasFormly/firmar/modules.plantillasFormly.firmar.html',
        controller: 'FirmarController',
        controllerAs: 'firmar'
      })
      .state('aprobarDocumento', {
        url: '/aprobar_documento',
        templateUrl: 'app/modules/plantillasFormly/aprobarDocumento/modules.plantillasFormly.aprobarDocumento.html',
        controller: 'AprobarDocumentoController',
        controllerAs: 'aprobarDocumento'
      })
      .state('vistaPdf', {
        url: '/vista_pdf',
        templateUrl: 'app/modules/plantillasFormly/vistaPdf/modules.plantillasFormly.vistaPdf.html',
        controller: 'VistaPdfController',
        controllerAs: 'vistaPdf'
      })
      .state('monitoreo', {
        url: '/monitoreo',
        templateUrl: 'app/modules/plantillasFormly/monitoreo/modules.plantillasFormly.monitoreo.html',
        controller: 'MonitoreoController',
        controllerAs: 'monitoreo'
      })
      .state('catalogos', {
        url: '/catalogos',
        templateUrl: 'app/modules/plantillasFormly/catalogos/modules.plantillasFormly.catalogos.html',
        controller: 'CatalogosController',
        controllerAs: 'catalogos'
      })
      .state('catalogo', {
        url: '/catalogo/:idCatalogo',
        templateUrl: 'app/modules/plantillasFormly/catalogos/catalogo/modules.plantillasFormly.catalogos.catalogo.html',
        controller: 'CatalogoController',
        controllerAs: 'catalogo'
      })
      .state('compartidos', {
        url: '/compartidos',
        templateUrl: 'app/modules/plantillasFormly/compartidos/modules.plantillasFormly.compartidos.html',
        controller: 'CompartidosController',
        controllerAs: 'compartidos'
      })
      .state('compartido', {
        url: '/compartido/:idCompartido',
        templateUrl: 'app/modules/plantillasFormly/compartidos/compartido/modules.plantillasFormly.compartidos.compartido.html',
        controller: 'CompartidoController',
        controllerAs: 'compartido'
      })
    $urlRouterProvider.otherwise('/');
  }

})();

/* global moment:false */
(function() {
  'use strict';

  angular
    .module('app')
    .constant('moment', moment)
    .constant('appName', 'app')
    .constant('PageNoLogin', ['login'])
    .constant('authUrl', 'https://plantillas.fndr.gob.bo/ws/autenticar') // Auth
    .constant('restUrl', 'https://plantillas.fndr.gob.bo/ws/api/v1/') // Rest Api Backend
    .constant('backUrl', 'https://plantillas.fndr.gob.bo/ws/') // Backend
    .constant('reCaptchaSiteKey','6LfyTYYjAAAAADci6TVkwnbxqZSWcjKj06URJwt2') //'6LeF5z4dAAAAAG728ibVjjShu8AOkt1ShYhjGXa_')
    .constant('maxPdfSizeAprobacion', 20971520) // Tamaño máximo del pdf para aprobaciones con ciudadania digital [bytes]
    .constant('maxSumPdfsSizeAprobacion', 31457280) // Tamaño máximo del total de archivos pdf para aprobaciones con ciudadania digital por documento [bytes]
})();

(function() {
  'use strict';

  angular
    .module('app')
    .config(config);

  /** @ngInject */
    function config($logProvider, $authProvider, restUrl, authUrl, appName, $mdDateLocaleProvider, moment, $httpProvider, $mdAriaProvider) {
        // Enable log
        $logProvider.debugEnabled(true);
        // Globally disables all ARIA warnings.
        $mdAriaProvider.disableWarnings();

        // Config auth
        $authProvider.loginUrl = authUrl;
        // $authProvider.signupUrl = "http://api.com/auth/signup";
        $authProvider.tokenName = "token";
        $authProvider.tokenPrefix = appName;
        $authProvider.storageType = 'sessionStorage';
        // $authProvider.authToken = 'Bearer';

        $mdDateLocaleProvider.formatDate = function(date) {
            if (date) {
                return moment(date).format('DD/MM/YYYY');
            }
            return null;
        };

        $mdDateLocaleProvider.parseDate = function(dateString) {
            var m = moment(dateString, 'DD/MM/YYYY', true);
            return m.isValid() ? m.toDate() : new Date(NaN);
        };

        $httpProvider.interceptors.push('HttpInterceptor');


        //initialize get if not there
        if (!$httpProvider.defaults.headers.get) {
            $httpProvider.defaults.headers.get = {};
        }
        $httpProvider.defaults.headers.get['Cache-Control'] = 'private, no-cache, no-store, must-revalidate';
        $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';

        //disable IE ajax request caching
        $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
        // extra

    }

})();

angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/actionTable/actionTable.html","<md-card><md-table-container><table md-table ng-model=selected md-progress=promise><thead md-head><tr md-row><th md-column ng-if=\" vm.buttons.length > 0\">Acciones</th><th ng-repeat=\"field in vm.fields\" md-column><span>{{field.field_name}}</span></th></tr></thead><tbody md-body><!-- <tr md-row md-select=\"item\" ng-repeat=\"item in vm.items\" class=\"testClass\" md-success> --><tr md-row md-select=item ng-repeat=\"item in vm.items\" class=\"{{(item.estado)?(item.estado==\'ACTIVO\'?\'filaActiva\':\'filaInactiva\'):\'\'}}\"><td md-cell class=action-buttons ng-if=\"vm.buttons.length > 0\"><span ng-repeat=\"button in vm.buttons\" flex><md-button class=md-icon-button aria-label=button.tooltip ng-click=\"vm.buttonEvent($event, item, button.onclick, $parent.$parent.$index)\" ng-if=!button.condition><md-tooltip>{{button.tooltip}}</md-tooltip><md-icon>{{button.icon}}d</md-icon></md-button><md-button class=md-icon-button aria-label=button.tooltip ng-click=\"vm.buttonEvent($event, item, button.onclick, $parent.$parent.$index)\" ng-if=\"button.condition && !button.condition.type && item[button.condition.field] == button.condition.is\"><md-tooltip>{{button.tooltip}}</md-tooltip><md-icon class=\"{{(button.condition && button.condition.class)? button.condition.class:\'\'}}\">{{button.icon}}d</md-icon></md-button><md-button class=md-icon-button aria-label=button.tooltip ng-click=\"vm.buttonEvent($event, item, button.onclick, $parent.$parent.$index)\" ng-if=\"button.condition && button.condition.type && button.condition.type == \'defaultUp\' && $parent.$parent.$index > 0 && $parent.$parent.$index <= vm.items.length\"><md-tooltip>{{button.tooltip}}</md-tooltip><md-icon class=\"{{(button.condition && button.condition.class)? button.condition.class:\'\'}}\">{{button.icon}}</md-icon></md-button><md-button class=md-icon-button aria-label=button.tooltip ng-click=\"vm.buttonEvent($event, item, button.onclick, $parent.$parent.$index)\" ng-if=\"button.condition && button.condition.type && button.condition.type == \'defaultDown\' && $parent.$parent.$index >= 0 && $parent.$parent.$index < vm.items.length-1\"><md-tooltip>{{button.tooltip}}</md-tooltip><md-icon class=\"{{(button.condition && button.condition.class)? button.condition.class:\'\'}}\">{{button.icon}}</md-icon></md-button></span></td><td md-cell ng-repeat=\"(key, value) in vm.fields\"><div>{{item[value.field_value]}}</div></td></tr></tbody></table></md-table-container></md-card>");
$templateCache.put("app/components/breadcrumb/breadcrumb.html","<ol class=breadcrumb><li ng-if=$ctrl.getParent()>{{$ctrl.getParent()}}</li><li class=active ng-if=$ctrl.getCurrent()>{{$ctrl.getCurrent()}}</li></ol>");
$templateCache.put("app/components/cargadorArchivos/cargadorArchivos.html","<div layout=row layout-wrap><div flex><div ng-click=vm.clickUp() ng-show=vm.uploader.isHTML5 ng-if=\"vm.maxArchivosPermitidos > vm.uploader.queue.length\"><div class=caja-up nv-file-drop=\"\" nv-file-over=\"\" nv-file-select=\"\" uploader=vm.uploader><div layout=row layout-wrap layout-align=\"center center\"><div flex=30 style=text-align:right><md-icon class=md-display-1>attach_file</md-icon></div><div flex=70 class=md-body-1>Suelte los archivos aquí o haga click para añadir archivos<br>Solo se permiten archivos en formato: {{vm.formatos}}</div></div></div></div><input id=input_seleccionar type=file nv-file-select=\"\" uploader=vm.uploader multiple ng-show=!vm.uploader.isHTML5><table ng-if=!vm.soloImagenes><tbody><!-- TODO: Habilitar para los archivos antiguos (edicion y eliminacion)\n    <tr ng-show=\'item.mostrar\' ng-repeat=\"item in vm.noticia_adjuntos\">\n                    <td><a ng-href=\'{{item.link}}\'> {{item.nombre_publico}}</a></td>\n                    <td>\n                        <md-button class=\"md-icon-button md-accent md-very-small\" aria-label=\"Eliminar\" ng-click=\"vm.eliminarAdjuntos(item)\">\n                            <md-icon class=\"md-very-small\">delete</md-icon>\n                        </md-button>\n                    </td>\n                </tr>--><tr ng-repeat=\"item in vm.uploader.queue\"><td>{{item.file.name}}</td><td><md-button class=\"md-icon-button md-accent md-very-small\" aria-label=Eliminar ng-click=item.remove()><md-icon class=md-very-small>delete</md-icon></md-button></td></tr></tbody></table><span ng-repeat=\"item in vm.uploader.queue\" class=imagen ng-if=vm.soloImagenes>{{item.file.name}}<div ng-show=\"vm.uploader.isHTML5 && vm.esImagen(item.file)\" ng-thumb=\"{ file: item._file, height: vm.altoMiniatura, width: vm.anchoMiniatura }\"></div><md-button class=\"md-icon-button md-accent md-very-small\" aria-label=Eliminar ng-click=item.remove()><md-icon class=md-very-small>delete</md-icon></md-button></span><span ng-repeat=\"item in vm.mostrar\" class=imagen>{{item.nombre_publico}}<div ng-mostrar-thumb=\"{ ruta:\'{{vm.restUrl}}{{item.ruta}}\',height: vm.altoMiniatura, width: vm.anchoMiniatura }\"></div><md-button class=\"md-icon-button md-accent md-very-small\" aria-label=Eliminar ng-click=vm.eliminar(item)><md-icon class=md-very-small>delete</md-icon></md-button></span><md-progress-linear md-mode=determinate value={{vm.uploader.progress}}></md-progress-linear></div></div>");
$templateCache.put("app/components/crudTable/crudTable.html","<md-card><md-toolbar class=\"md-table-toolbar md-default\" ng-show=vm.filter.show><div class=md-toolbar-tools><md-icon>search</md-icon><form flex name=vm.filter.form ng-class=\"{\'flex-xs-70\': vm.searchPro, \'flex-sm-70\': vm.searchPro}\"><div layout=column layout-gt-sm=row ng-class=\"{\'crud-table-searchpro\': vm.searchPro}\"><input type=text ng-class=\"{\'crud-table-filter\': !vm.searchPro, \'flex\': vm.searchPro}\" id=crud-table-input ng-model=vm.query.filter ng-model-options=vm.filter.options placeholder=\"Escriba su búsqueda aquí...\" ng-if=\"!vm.searchPro || vm.tipo_busqueda==\'campo\' || vm.tipo_busqueda==\'todos\' || vm.tipo_busqueda==\'documento\' || vm.tipo_busqueda==\'flujo\'\"><divider></divider><div class=date-pick ng-if=vm.check_fechas><md-datepicker ng-change=vm.getItems() ng-model=vm.fecha_inicio></md-datepicker><md-tooltip>Fecha inicio</md-tooltip></div><div class=date-pick ng-if=vm.check_fechas><md-datepicker ng-change=vm.getItems() ng-model=vm.fecha_final></md-datepicker><md-tooltip>Fecha fin</md-tooltip></div><div ng-if=vm.searchPro><md-checkbox ng-model=vm.check_fechas ng-change=vm.getItems() aria-label=check_fechas></md-checkbox><md-tooltip>Fechas</md-tooltip></div><divider></divider><label for=select-tipo ng-if=vm.searchPro>Tipo de búsqueda:</label><md-input-container flex class=\"select-tipo flex-gt-sm-10\" ng-if=vm.searchPro><md-select ng-model=vm.tipo_busqueda ng-change=\"vm.query.filter=\'\'; vm.getItems();\"><md-option class=opt-select-tipo ng-value=\"\'todos\'\">Todos</md-option><md-option class=opt-select-tipo ng-value=\"\'campo\'\">Campo</md-option><md-option class=opt-select-tipo ng-value=\"\'documento\'\">En documento</md-option><md-option class=opt-select-tipo ng-value=\"\'flujo\'\">Por flujo</md-option></md-select></md-input-container><md-input-container flex class=\"select-tipo flex-gt-sm-10\" ng-if=\"vm.tipo_busqueda==\'campo\'\" ng-init=\"vm.campo_seleccionado=vm.headers[1]\"><md-select ng-model=vm.campo_seleccionado ng-change=vm.getItems()><md-option class=opt-select-tipo ng-value=h ng-repeat=\"h in vm.headers\" ng-if=\"h.title!=\'ID\'\">{{(h.title==\'Nombre\')? h.title+\'(CITE)\': h.title }}</md-option></md-select><md-tooltip>{{vm.campo_seleccionado.title}}</md-tooltip></md-input-container></div></form><md-button class=md-icon-button ng-click=vm.removeFilter()><md-icon>close</md-icon></md-button></div></md-toolbar><md-toolbar class=md-table-toolbar ng-show=!vm.filter.show><div class=md-toolbar-tools><md-icon>grid_on</md-icon><span>{{vm.titleTable}}</span><div flex></div><md-button class=md-icon-button ng-click=vm.showFilter() ng-if=vm.permissions.filter><md-tooltip>Filtrar registros</md-tooltip><md-icon>filter_list</md-icon></md-button><md-button class=md-icon-button ng-click=vm.saveAll() ng-if=vm.editable><md-tooltip>Guardar todo</md-tooltip><md-icon>playlist_add_check</md-icon></md-button><md-button class=md-icon-button ng-click=vm.getItems() id=btn-refresh-crudtable><md-tooltip>Actualizar</md-tooltip><md-icon>refresh</md-icon></md-button><md-button class=\"md-icon-button btn-collapsed\"><md-tooltip>Ocultar/Ver</md-tooltip><md-icon>keyboard_arrow_down</md-icon></md-button></div></md-toolbar><md-card-content ng-class=\"{\'crud-table-content\': vm.searchPro && vm.filter.show}\"><div class=\"md-row btn-container-row\"><md-button class=\"md-cell md-fab md-primary\" ng-click=vm.add($event) aria-label=Add ng-if=vm.permissions.create><md-tooltip>Agregar nuevo registro</md-tooltip><md-icon>add</md-icon></md-button><md-button class=\"md-cell md-fab md-primary\" ng-click=vm.buttonAgregar.onclick($event) aria-label=Add ng-if=\"!vm.permissions.create && vm.buttonAgregar\"><md-tooltip>{{ vm.buttonAgregar.tooltip || \'Agregar nuevo registro\' }}</md-tooltip><md-icon>{{vm.buttonAgregar.icon}}</md-icon></md-button><md-button class=\"md-cell md-fab md-primary\" ng-repeat=\"button in vm.headButtons\" ng-click=button.onclick($event)><md-tooltip>{{button.tooltip}}</md-tooltip><md-icon>{{button.icon}}</md-icon></md-button></div><md-table-container><table md-table ng-model=selected md-progress=promise ng-if=vm.permissions.read><thead md-head md-order=vm.query.order md-on-reorder=vm.getItems><tr md-row><th md-cell ng-if=vm.habilitarSeleccion><md-checkbox class=md-primary ng-model=vm.seleccionar ng-click=vm.seleccionarTodos()></md-checkbox></th><th md-column ng-if=\"vm.permissions.update || vm.permissions.update || vm.permissions.print || vm.buttons.length > 0 || vm.permissions.delete\">Acciones</th><th ng-repeat=\"header in vm.headers\" md-column ng-if=\"$index > 0 && !vm.idShow[header.name]\" md-order-by=\"{{header.order ? header.name : \'\'}}\"><span ng-if=!vm.estadoChecks>{{header.title}}</span> <span ng-if=vm.estadoChecks><span ng-if=\"header.name==\'estado\'\"><md-input-container class=\"select-sin-mb select-crud-estado\" ng-click=vm.prevent($event)><label>{{header.title}}</label><md-select ng-model=vm.busqueda_estado multiple ng-change=vm.getItems()><md-option ng-value=op.v ng-repeat=\"op in vm.estadoOpciones\">{{op.t}}</md-option></md-select></md-input-container></span><span ng-if=\"header.name!=\'estado\'\">{{header.title}}</span></span></th><th md-column ng-if=vm.informacionBienes>Bienes</th></tr></thead><tbody md-body class=\"{{vm.editable ? \'formly-table-editable\' : \'\'}}\"><tr md-row md-select=item ng-repeat=\"item in vm.items.data\" class=seleccionado><td md-cell ng-if=vm.habilitarSeleccion><md-checkbox class=md-primary ng-model=item.selected ng-click=vm.seleccionando(item)></md-checkbox></td><td md-cell class=\"text-center md-table-options\" ng-if=\"vm.permissions.update || vm.permissions.update || vm.permissions.print || vm.buttons.length > 0 || vm.permissions.delete\"><md-button class=\"md-icon-button boton-extra\" aria-label=Editar ng-click=\"vm.edit($event, item)\" ng-if=\"vm.permissions.update && !vm.editable\"><md-tooltip>Editar</md-tooltip><md-icon>mode_edit</md-icon></md-button><md-button class=\"md-icon-button boton-extra\" aria-label=Editar ng-click=vm.save(item) ng-if=\"vm.permissions.update && vm.editable\"><md-tooltip>Guardar registro</md-tooltip><md-icon>check</md-icon></md-button><md-button class=\"md-icon-button boton-extra\" aria-label=Editar ng-click=\"vm.print($event, item)\" ng-if=vm.permissions.print><md-tooltip>Imprimir</md-tooltip><md-icon>print</md-icon></md-button><span ng-repeat=\"button in vm.buttons\"><span ng-if=button.multiple><span ng-if=button.opcion[item[button.key_item]]><md-button class=md-icon-button ng-class=\"button.opcion[item[button.key_item]].xclass || \'boton-extra\'\" aria-label=button.opcion[item[button.key_item]].tooltip ng-click=\"vm.buttonEvent($event, item, button.opcion[item[button.key_item]].onclick)\"><md-tooltip>{{button.opcion[item[button.key_item]].tooltip}}</md-tooltip><md-icon>{{button.opcion[item[button.key_item]].icon}}</md-icon></md-button></span><span ng-if=\"button.opcion[\'DEFAULT\'] && !button.opcion[item[button.key_item]]\"><md-button class=md-icon-button ng-class=\"button.opcion[item[button.key_item]].xclass || \'boton-extra\'\" aria-label=\"button.opcion[\'DEFAULT\'].tooltip\" ng-click=\"vm.buttonEvent($event, item, button.opcion[\'DEFAULT\'].onclick)\"><md-tooltip ng-if=\"button.opcion[\'DEFAULT\'].tooltip\">{{button.opcion[\'DEFAULT\'].tooltip}}</md-tooltip><md-icon>{{button.opcion[\'DEFAULT\'].icon}}</md-icon></md-button></span></span><md-button class=\"md-icon-button boton-extra\" aria-label=button.tooltip ng-click=\"vm.buttonEvent($event, item, button.onclick)\" ng-if=\"!button.multiple && !button.tipo\"><md-tooltip>{{button.tooltip}}</md-tooltip><md-icon>{{button.icon}}</md-icon></md-button><md-button class=\"md-icon-button (item[button.campo]==true?\'icono-activo\':\'\')\" aria-label=button.tooltip ng-click=\"vm.buttonEvent($event, item, button.onclick)\" ng-if=\"!button.multiple && button.tipo==\'icon\'\"><md-icon>{{button.icon}}</md-icon></md-button>{{item[button.campo]}}</span><md-button class=\"md-icon-button boton-eliminar\" aria-label=Eliminar ng-click=\"vm.delete($event, item)\" ng-if=\"vm.permissions.delete && !item.id_documento\"><md-tooltip>Eliminar</md-tooltip><md-icon>delete</md-icon></md-button><md-button class=\"md-icon-button boton-eliminar\" aria-label=Eliminar ng-click=\"vm.delete($event, item)\" ng-if=\"vm.permissions.delete && item.id_documento && (item.estado==\'NUEVO\' || item.estado==\'RECHAZADO\')\"><md-tooltip>Eliminar</md-tooltip><md-icon>delete</md-icon></md-button><md-button class=md-icon-button aria-label=\"\" ng-if=\"vm.permissions.delete && item.id_documento && (item.estado!=\'NUEVO\' && item.estado!=\'RECHAZADO\')\"><md-icon></md-icon></md-button></td><td md-cell ng-repeat=\"(key, value) in item\" ng-if=\"$index > 0 && !vm.idShow[key] && key !== \'selected\' \"><div ng-if=vm.editable><div ng-switch on=vm.types[key].type><div ng-switch-when=input><md-input-container><label>{{vm.types[key].templateOptions.label}}</label><input ng-model=vm.dataGrid[value]></md-input-container></div><div ng-switch-when=textarea><md-input-container><label>{{vm.types[key].templateOptions.label}}</label><textarea ng-model=vm.dataGrid[value]></textarea></md-input-container></div><div ng-switch-when=select><md-input-container><md-select ng-model=vm.dataGrid[value]><label>{{vm.types[key].templateOptions.label}}</label><md-option ng-repeat=\"option in vm.types[key].templateOptions.options\" value={{option.value}}>{{option.name}}</md-option></md-select></md-input-container></div><div ng-switch-when=checkbox><md-checkbox ng-model=vm.dataGrid[value] aria-label={{vm.types[key].templateOptions.label}}></md-checkbox></div><div ng-switch-when=datepicker><md-datepicker ng-model=vm.dataGrid[value] md-placeholder={{vm.types[key].templateOptions.label}}></md-datepicker></div><div ng-switch-default>{{value}}</div></div></div><div ng-if=!vm.editable><div ng-switch on=value><div ng-switch-when=check_circle_success><md-icon class=bg-success>check_circle</md-icon></div><div ng-switch-when=check_circle_gray><md-icon class=bg-gray>check_circle</md-icon></div><div ng-switch-default><div ng-if=\"key.indexOf(\'fecha\') != -1\">{{value|date:\'dd/MM/yyyy\'}}</div><div ng-if=\"key.indexOf(\'fid_\') == 0\">{{vm.fieldsData[vm.fields.indexOf(key)].templateOptions.fkeys[value] || value}}</div><div ng-if=\"key.indexOf(\'fecha\') == -1 && key.indexOf(\'fid_\') != 0\"><div ng-if=\"!vm.estadoSw || (vm.estadoSw && key!=\'estado\' && key!=\'impreso\' )\"><span ng-if=\"vm.sw_cite && key==\'nombre\'\">{{value}}<tooltip doc=item></tooltip></span><div ng-if=\"!vm.sw_cite || key!=\'nombre\'\">{{value}}</div></div><div ng-if=\"vm.estadoSw && key==\'estado\'\"><md-switch ng-true-value=\"\'ACTIVO\'\" ng-false-value=\"\'INACTIVO\'\" ng-model=item.estado aria-label=estado ng-change=vm.estadoModificado(item)></md-switch></div><div ng-if=\"vm.estadoSw && key==\'impreso\'\"><md-switch ng-true-value=\"\'SI\'\" ng-false-value=\"\'NO\'\" ng-model=item.impreso aria-label=impreso ng-change=vm.estadoModificado(item)></md-switch></div></div></div></div></div></td></tr></tbody></table></md-table-container><md-table-pagination md-label=\"{page: \'Página:\', rowsPerPage: \'Filas por página:\', of: \'de\'}\" md-limit=vm.query.limit md-limit-options=vm.limitOptions md-page=vm.query.page md-total={{vm.items.count}} md-page-select=vm.options.pageSelect md-boundary-links=vm.options.boundaryLinks md-on-paginate=vm.getItems></md-table-pagination></md-card-content></md-card>");
$templateCache.put("app/components/crudTable/dialog.crudTable.html","<md-dialog aria-label=Agregar/Editar ng-cloak class=\"formly-dialog formly-column-{{column}}\"><form ng-submit=\"answer(\'save\')\" id=data-form name=form novalidate><md-toolbar><div class=md-toolbar-tools><h2>{{title}}</h2><span flex></span><md-button class=\"md-icon-button md-toast-button-close\" ng-click=cancel()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content><md-content layout-gt-sm=column layout-padding class=formly><formly-form model=data fields=fields options=options form=form></formly-form></md-content></div></md-dialog-content><md-dialog-actions layout=row><span flex></span><md-button class=md-raised ng-click=cancel()><md-icon>cancel</md-icon>Cancelar</md-button><md-button type=submit class=\"md-raised md-primary\" ng-disabled=form.$invalid><md-icon>check</md-icon>Guardar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/crudTable/dialog.pdf.html","<md-dialog aria-label=Imprimir ng-cloak class=\"formly-dialog formly-column-{{column}}\" style=\"width: 960px\"><md-toolbar><div class=md-toolbar-tools><h2>{{title}}</h2><span flex></span><md-button class=\"md-icon-button md-toast-button-close\" ng-click=cancel()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><iframe src={{data}} style=\"width:100%; height:600px; border: none\" id=iframe-pdf-crud></iframe></md-dialog-content></md-dialog>");
$templateCache.put("app/components/crudTableAprobacion/crudTableAprobacion.html","<md-card><md-toolbar class=\"md-table-toolbar md-default\" ng-show=vm.filter.show><div class=md-toolbar-tools><md-icon>search</md-icon><form flex name=vm.filter.form ng-class=\"{\'flex-xs-70\': vm.searchPro, \'flex-sm-70\': vm.searchPro}\"><div layout=column layout-gt-sm=row ng-class=\"{\'crud-table-searchpro\': vm.searchPro}\"><input type=text ng-class=\"{\'crud-table-filter\': !vm.searchPro, \'flex\': vm.searchPro}\" id=crud-table-input ng-model=vm.query.filter ng-model-options=vm.filter.options placeholder=\"Escriba su búsqueda aquí...\" ng-if=\"!vm.searchPro || vm.tipo_busqueda==\'campo\' || vm.tipo_busqueda==\'todos\' || vm.tipo_busqueda==\'documento\' || vm.tipo_busqueda==\'flujo\'\"><divider></divider></div></form><md-button class=md-icon-button ng-click=vm.removeFilter()><md-icon>close</md-icon></md-button></div></md-toolbar><md-toolbar class=md-table-toolbar ng-show=!vm.filter.show><div class=md-toolbar-tools><md-icon>grid_on</md-icon><span>{{vm.titleTable}}</span><div flex></div><md-button class=md-icon-button ng-click=vm.showFilter() ng-if=vm.permissions.filter><md-tooltip>Filtrar registros</md-tooltip><md-icon>filter_list</md-icon></md-button><md-button class=md-icon-button ng-click=vm.getItems() id=btn-refresh-crudtable><md-tooltip>Actualizar</md-tooltip><md-icon>refresh</md-icon></md-button><md-button class=\"md-icon-button btn-collapsed\"><md-tooltip>Ocultar/Ver</md-tooltip><md-icon>keyboard_arrow_down</md-icon></md-button></div></md-toolbar><md-card-content ng-class=\"{\'crud-table-content\': vm.searchPro && vm.filter.show}\"><md-table-container><table md-table ng-model=selected md-progress=promise ng-if=vm.permissions.read><thead md-head md-order=vm.query.order md-on-reorder=vm.getItems><tr md-row><th md-column ng-if=\"vm.permissions.update || vm.permissions.update || vm.permissions.print || vm.buttons.length > 0 || vm.permissions.delete\">Acciones</th><th ng-repeat=\"header in vm.headers\" md-column ng-if=\"$index > 0 && !vm.idShow[header.name]\" md-order-by=\"{{header.order ? header.name : \'\'}}\"><span ng-if=!vm.estadoChecks>{{header.title}}</span></th><th md-column ng-if=vm.informacionBienes>Bienes</th></tr></thead><tbody md-body class=\"{{vm.editable ? \'formly-table-editable\' : \'\'}}\" md-row md-select=item ng-repeat=\"item in vm.items.results\"><tr class=seleccionado><td md-cell class=\"text-center md-table-options\" ng-if=\"vm.permissions.update || vm.permissions.update || vm.permissions.print || vm.buttons.length > 0 || vm.permissions.delete\"><span ng-repeat=\"button in vm.buttons\"><span ng-if=button.multiple><span ng-if=button.opcion[item[button.key_item]]><md-button class=md-icon-button ng-class=\"button.opcion[item[button.key_item]].xclass || \'boton-extra\'\" aria-label=button.opcion[item[button.key_item]].tooltip ng-click=\"vm.buttonEvent($event, item, button.opcion[item[button.key_item]].onclick)\"><md-tooltip>{{button.opcion[item[button.key_item]].tooltip}}</md-tooltip><md-icon>{{button.opcion[item[button.key_item]].icon}}</md-icon></md-button></span><span ng-if=\"button.opcion[\'DEFAULT\'] && !button.opcion[item[button.key_item]]\"><md-button class=md-icon-button ng-class=\"button.opcion[item[button.key_item]].xclass || \'boton-extra\'\" aria-label=\"button.opcion[\'DEFAULT\'].tooltip\" ng-click=\"vm.buttonEvent($event, item, button.opcion[\'DEFAULT\'].onclick)\"><md-tooltip ng-if=\"button.opcion[\'DEFAULT\'].tooltip\">{{button.opcion[\'DEFAULT\'].tooltip}}</md-tooltip><md-icon>{{button.opcion[\'DEFAULT\'].icon}}</md-icon></md-button></span></span><md-button class=\"md-icon-button boton-extra\" aria-label=button.tooltip ng-click=\"vm.buttonEvent($event, item, button.onclick)\" ng-if=\"!button.multiple && !button.tipo\"><md-tooltip>{{button.tooltip}}</md-tooltip><md-icon>{{button.icon}}</md-icon></md-button><md-button class=\"md-icon-button (item[button.campo]==true?\'icono-activo\':\'\')\" aria-label=button.tooltip ng-click=\"vm.buttonEvent($event, item, button.onclick)\" ng-if=\"!button.multiple && button.tipo==\'icon\'\"><md-icon>{{button.icon}}</md-icon></md-button>{{item[button.campo]}}</span></td><td md-cell ng-repeat=\"(key, value) in item\" ng-if=\"$index > 0 && !vm.idShow[key] && key !== \'selected\' \"><div ng-if=\"![\'adjunto_aprobacion_cd\', \'aprobarDocumento\'].includes(key)\" class=mb-2><div ng-switch on=value><div ng-switch-default><div ng-if=\"key.indexOf(\'fecha\') != -1\">{{value|date:\'dd/MM/yyyy\'}}</div><div ng-if=\"key.indexOf(\'fecha\') == -1 && key.indexOf(\'fid_\') != 0\"><div ng-if=\"!vm.estadoSw || (vm.estadoSw && key!=\'estado\' && key!=\'impreso\' )\"><div ng-if=\"(!vm.sw_cite || key!=\'nombre\') && key!=\'adjunto_aprobacion_cd\'\">{{value}}</div></div></div></div></div></div></td></tr><tr class=buttonTable><td></td><td class=mb-2 colspan=9 ng-if=\"item.adjunto_aprobacion_cd.length > 0\"><md-table-container class=initTable><p class=titleDetail>Documentos Adjuntos<md-icon ng-show=!item.aprobarDocumento>error_outline<md-tooltip md-direction=center>Ten en cuenta que para poder aprobar un documento principal, primero debes aprobar cada documento adjunto.</md-tooltip></md-icon></p><md-radio-group class=detailTable ng-model=newObject[adjunto.id]><span ng-repeat=\"adjunto in item.adjunto_aprobacion_cd\" class=box><md-radio-button ng-if=\"adjunto.solicitud_aprobacion_cd.length==0\" ng-value=adjunto.id aria-label=\"Label 1\" class=titleRadio><md-tooltip>{{adjunto.nombre_publico}}</md-tooltip>{{adjunto.nombre_publico.substr(0, 27)}}</md-radio-button><span ng-if=\"adjunto.solicitud_aprobacion_cd.length>0\" class=aprobado style=\"color: #757575\"><md-tooltip>{{adjunto.nombre_publico}}</md-tooltip><md-icon>check_circle</md-icon><b>{{adjunto.nombre_publico.substr(0, 27)}}</b></span></span></md-radio-group><div class=footerTable><md-button class=md-raised ng-click=vm.aprobarAdjunto(newObject[adjunto.id]) ng-style=\"{\'background\': newObject[adjunto.id] ? \'#436791\': \'#aaa\', color: \'#fff\'}\" style=\"text-transform: capitalize !important\" ng-show=!item.aprobarDocumento ng-disabled=!newObject[adjunto.id]><!-- <md-icon>done</md-icon> --><md-tooltip md-direction=right>Aprobar Adjunto</md-tooltip><b style=\"margin: 0px 7px 0px 7px\">Aprobar Adjunto</b></md-button></div></md-table-container><md-button class=\"md-raised md-accent footerTable\" ng-click=vm.aprobarDocumento(item.id_documento) style=\"background: #43916D; color: #fff; text-transform: capitalize !important\" ng-show=item.aprobarDocumento><!-- <md-icon>done</md-icon> --><md-tooltip md-direction=right>Aprobar Documento</md-tooltip><b style=\"margin: 0px 7px 0px 7px\">Aprobar Documento</b></md-button></td></tr><tr class=buttonTable><td></td><td colspan=9><md-button class=\"md-raised md-accent\" ng-click=vm.aprobarDocumento(item.id_documento) style=\"background: #43916D; color: #fff; text-transform: capitalize !important\" ng-show=\"item.adjunto_aprobacion_cd.length==0\"><!-- <md-icon>done</md-icon> --><md-tooltip md-direction=right>Aprobar Documento</md-tooltip><b style=\"margin: 0px 7px 0px 7px\">Aprobar Documento</b></md-button></td></tr></tbody></table></md-table-container><md-table-pagination md-label=\"{page: \'Página:\', rowsPerPage: \'Filas por página:\', of: \'de\'}\" md-limit=vm.query.limit md-limit-options=vm.limitOptions md-page=vm.query.page md-total={{vm.items.count}} md-page-select=vm.options.pageSelect md-boundary-links=vm.options.boundaryLinks md-on-paginate=vm.getItems></md-table-pagination></md-card-content></md-card>");
$templateCache.put("app/components/crudTableAprobacion/dialog.confirmarAprobacionAdjunto.html","<md-dialog aria-label=ConfirmarDocumento class=\"formly-dialog formly-column-{{column}}\" style=\"max-width: 400px; width: 100%\"><form ng-submit=\"answer(\'save\')\" id=data-form name=form novalidate><div class=text-center><h3>Aprobación de adjunto<br>con Ciudadania Digital</h3><span flex></span></div><md-dialog-content class=md-dialog-content><div layout layout-padding><h4>Serás enviado al módulo de <b>Aprobación de documentos de Ciudadanía Digital</b> para aprobar el documento adjunto seleccionado<br>¿Deseas continuar?</h4></div></md-dialog-content><md-dialog-actions layout=row><span flex></span><md-button class=md-raised ng-click=cancel()><md-icon>cancel</md-icon>Cancelar</md-button><md-button type=submit class=\"md-raised md-primary\"><md-icon>check</md-icon>Sí, continuar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/crudTableAprobacion/dialog.confirmarAprobacionDocumento.html","<md-dialog aria-label=ConfirmarDocumento class=\"formly-dialog formly-column-{{column}}\" style=\"max-width: 400px; width: 100%\"><form ng-submit=\"answer(\'save\')\" id=data-form name=form novalidate><div class=text-center><h3>Aprobación de documento<br>con Ciudadania Digital.</h3><span flex></span></div><md-dialog-content><div layout layout-padding><h4>Serás enviado al módulo de <b>Aprobación de documentos de Ciudadanía Digital</b> para aprobar el documento seleccionado<br>¿Deseas continuar?</h4></div></md-dialog-content><md-dialog-actions layout=row><span flex></span><md-button class=md-raised ng-click=cancel()><md-icon>cancel</md-icon>Cancelar</md-button><md-button type=submit class=\"md-raised md-primary\"><md-icon>check</md-icon>Sí, Continuar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/crudTableAprobacion/dialog.crudTable.html","<md-dialog aria-label=Agregar/Editar ng-cloak class=\"formly-dialog formly-column-{{column}}\"><form ng-submit=\"answer(\'save\')\" id=data-form name=form novalidate><md-toolbar><div class=md-toolbar-tools><h2>{{title}}</h2><span flex></span><md-button class=\"md-icon-button md-toast-button-close\" ng-click=cancel()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content><md-content layout-gt-sm=column layout-padding class=formly><formly-form model=data fields=fields options=options form=form></formly-form></md-content></div></md-dialog-content><md-dialog-actions layout=row><span flex></span><md-button class=md-raised ng-click=cancel()><md-icon>cancel</md-icon>Cancelar</md-button><md-button type=submit class=\"md-raised md-primary\" ng-disabled=form.$invalid><md-icon>check</md-icon>Guardar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/crudTableAprobacion/dialog.pdf.html","<md-dialog aria-label=Imprimir ng-cloak class=\"formly-dialog formly-column-{{column}}\" style=\"width: 960px\"><md-toolbar><div class=md-toolbar-tools><h2>{{title}}</h2><span flex></span><md-button class=\"md-icon-button md-toast-button-close\" ng-click=cancel()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><iframe src={{data}} style=\"width:100%; height:600px; border: none\" id=iframe-pdf-crud></iframe></md-dialog-content></md-dialog>");
$templateCache.put("app/components/documentoIdentidad/documentoIdentidad.html","<div class=doc-identidad><md-input-container class=doc-identidad-tipo ng-if=\"vm.onlyCi === undefined || !vm.onlyCi\"><label>Tipo de documento</label><md-select ng-model=vm.tipo_documento required ng-disabled=vm.ngDisabled><md-option ng-repeat=\"option in vm.tipos\" value={{option.value}}>{{option.name}}</md-option></md-select></md-input-container><div class=\"alert alert-info doc-identidad-cedula-info\" ng-class=\"{display: vm.onlyCi}\" ng-if=\"vm.tipo_documento == \'CI\' && !vm.ngDisabled\"><md-icon>info_outline</md-icon>Ingrese número de documento, complemento y fecha de nacimiento para su búsqueda.</div><div layout=row class=form-horizontal><md-input-container><label>Número de documento</label><input ng-model=vm.nro_documento required ng-disabled=vm.ngDisabled></md-input-container><md-input-container ng-if=\"vm.tipo_documento == \'CI\'\"><label>Complemento</label><input ng-model=vm.complemento ng-disabled=vm.ngDisabled></md-input-container><md-select-date ng-model=vm.fecha_nacimiento ng-label=\"Fecha de nacimiento:\" ng-disabled=vm.ngDisabled ng-required=true></md-select-date><md-button class=\"md-raised md-primary doc-identidad-button\" ng-click=vm.search() ng-disabled=vm.isDisabled() ng-if=\"!vm.ngDisabled && vm.tipo_documento == \'CI\'\"><md-icon>search</md-icon>Buscar</md-button></div></div>");
$templateCache.put("app/components/menuCard/menuCard.html","<md-card><md-toolbar class=md-table-toolbar ng-show=true><div class=md-toolbar-tools><md-icon>grid_on</md-icon><span>{{vm.titleTable}}</span><div flex></div><md-button class=\"md-icon-button btn-collapsed\"><md-tooltip>Ocultar/Ver</md-tooltip><md-icon>keyboard_arrow_down</md-icon></md-button></div></md-toolbar><md-card-content><div class=menuCard-list ng-repeat=\"item in vm.items\"><h4 class=menuCard-titulo ng-click=\"item.show=!item.show\">{{item.name}}</h4><div class=menuCard-animated-hide ng-if=!item.show layout=row layout-padding layout-fill layout-wrap ng-cloak><a class=menuCard-link ng-repeat=\"xitem in item.data\" ng-href=#/{{xitem.url}}><md-whiteframe md-whiteframe={{height}} layout layout-align=\"center center\" ng-init=\"height = 1\" ng-mouseenter=\"height = 3\" ng-mouseleave=\"height = 1\"><div layout=column layout-align=\"center center\"><md-icon class=md-display-3>{{xitem.icono || \'details\'}}</md-icon><span class=text-center>{{xitem.name}}</span></div></md-whiteframe></a></div></div></md-card-content></md-card>");
$templateCache.put("app/components/navbar/navbar.html","<md-toolbar><div class=md-toolbar-tools><md-button class=md-icon-button ng-click=vm.toggle() aria-label=\"Menu collapse\" show-gt-md><md-tooltip>Mostrar/ocultar menú</md-tooltip><i class=md-icon>menu</i></md-button><!-- <span class=\"navbar-user-name\" flex>{{vm.getFirstName()}}</span> --> <span flex></span><md-button class=\"margin-0 md-icon-button btn-fullscreen\" ng-click=vm.fullscreen() aria-label=Fullscreen show-gt-md id=btn-fullscreen><md-icon>fullscreen</md-icon><md-icon>fullscreen_exit</md-icon><md-tooltip class=tooltip-fullscreen><span class=exit>Salir </span>Pantalla completa</md-tooltip></md-button><md-menu><!-- <md-button aria-label=\"interactions menu\" class=\"md-icon-button navbar-user-icon bg-{{vm.getColor()}}-user\" ng-click=\"vm.openMenu($mdOpenMenu, $event)\">\n                {{vm.getInitial()}}\n            </md-button> --><md-button class=\"margin-0 md-icon-button\" aria-label=Más ng-click=\"vm.openMenu($mdOpenMenu, $event)\"><md-tooltip>Más opciones</md-tooltip><md-icon>more_vert</md-icon></md-button><md-menu-content class=navbar-options><md-menu-item><md-button ng-click=vm.profile()><i class=md-icon>account_circle</i> Mi cuenta</md-button></md-menu-item><md-menu-item><md-button ng-click=vm.cambiarUsuario()><i class=md-icon>refresh</i> Cambio de usuario</md-button></md-menu-item><!-- <md-menu-divider></md-menu-divider> --><md-menu-item style=\"width: 200px\"><md-button ng-click=vm.logout()><i class=md-icon>power_setting_new</i> Salir</md-button></md-menu-item></md-menu-content></md-menu><md-button class=md-icon-button aria-label=More style=\"display: none\"><i class=md-icon>more_vert</i></md-button></div></md-toolbar>");
$templateCache.put("app/components/paletteFormly/paletteFormly.html","<div class=component-palette-formly md-autofocus><div class=md-accordion ng-repeat=\"data in vm.elementos\"><div class=header-accordion ng-click=\"data.expanded = !data.expanded\"><div layout layout-align=\"center center\"><span class=titulo>{{ data.titulo }}</span> <span flex=\"\"></span> <span ng-class=\"{expandCollapse:true, active: data.expanded}\"></span><!-- <md-icon ng-class=\"{expandCollapse2:true, active: data.expanded}\">keyboard_arrow_down</md-icon> --></div></div><div class=body-accordion ng-class=\"{dataContent:true, activeContent:data.expanded}\"><md-list-item class=submenu ng-repeat=\"item in data.submenu\"><div class=md-list-item-text layout=column flex dnd-draggable=item.tipo dnd-effect-allowed=move><div>{{ item.name }}</div></div><md-button class=\"md-fab md-primary md-mini button-mini\" ng-click=vm.addItem(item.tipo)><md-tooltip>Añadir {{ item.name }}</md-tooltip><md-icon>add</md-icon></md-button></md-list-item></div></div></div>");
$templateCache.put("app/components/selectDate/selectDate.html","<div layout=row class=select-date><label>{{vm.ngLabel}}:</label><md-input-container><label>Día</label><md-select ng-model=vm.day ng-required=vm.ngRequired ng-disabled=vm.ngDisabled><md-option ng-repeat=\"option in vm.days\" value={{option.value}}>{{option.name}}</md-option></md-select></md-input-container><md-input-container><label>Mes</label><md-select ng-model=vm.month ng-required=vm.ngRequired ng-disabled=vm.ngDisabled><md-option ng-repeat=\"option in vm.months\" value={{option.value}}>{{option.name}}</md-option></md-select></md-input-container><md-input-container><label>Año</label><md-select ng-model=vm.year ng-required=vm.ngRequired ng-disabled=vm.ngDisabled><md-option ng-repeat=\"option in vm.years\" value={{option.value}}>{{option.name}}</md-option></md-select></md-input-container></div>");
$templateCache.put("app/components/sidenav/sidenav.html","<md-sidenav class=md-sidenav-left md-component-id=left md-is-locked-open=\"$mdMedia(\'gt-sm\')\" id=sidenav><md-toolbar class=sidenav-title><h1 class=md-toolbar-tools><i class=\"md-icon sidenav-title-icon\">description</i> <span class=sidenav-title-text>PLANTILLAS</span></h1></md-toolbar><div class=sidenav-user><figure><img class=sidenav-user-photo src=\"\" alt=\"Image User\" hidden><div class=\"sidenav-user-default bg-{{vm.getColor()}}-user\"><!-- <i class=\"md-icon\">account_circle</i> --> {{vm.getInitial()}}</div></figure><h2 class=sidenav-user-name>{{vm.getName()}}<md-tooltip md-direction=bottom>{{vm.getName()}}</md-tooltip></h2><div class=sidenav-user-item>{{vm.getEmail()}}</div></div><ul class=sidenav-list><li ng-repeat=\"opcion in vm.getMenu()\"><md-button type=button class=\"md-button-toggle md-button md-button md-ink-ripple\" ng-click=\"vm.send(opcion.url, opcion.submenu.length)\"><i class=\"md-icon md-icon-option\">{{opcion.icon}}</i> <span class=md-icon-text>{{opcion.label}}</span> <i class=\"md-icon md-icon-arrow-down\" ng-if=opcion.submenu.length>keyboard_arrow_down</i></md-button><ul class=sidenav-sublist ng-if=opcion.submenu.length><li ng-repeat=\"sub in opcion.submenu\"><md-button type=button class=\"md-button md-button md-ink-ripple md-button-href {{vm.active == sub.url ? \'active\' : \'\'}}\" data-url={{sub.url}} ng-click=vm.send(sub.url)><span class=md-icon-text>{{sub.label}}</span></md-button></li></ul></li></ul></md-sidenav><md-button ng-click=vm.toggleLeft() class=md-icon-button hide-gt-md><i class=md-icon>menu</i></md-button>");
$templateCache.put("app/components/visorImagenes/visorImagenes.dialog.html","<md-dialog aria-label=Ver/Editar ng-cloak class=\"formly-dialog formly-column-{{column}}\"><md-dialog-content class=md-dialog-content><div flex layout=row><img ng-src={{data}}></div></md-dialog-content></md-dialog>");
$templateCache.put("app/components/visorImagenes/visorImagenes.html","<div layout=row layout-wrap ng-if=\"vm.imagenes.length > 0\"><div flex><h4>{{vm.titulo}}</h4><span ng-repeat=\"item in vm.imagenes\"><div class=contenedor-miniatura><img src={{vm.restUrl}}{{item.ruta}} alt={{item.nombre_publico}} class=miniatura style=\"width:{{vm.ancho}}px; height:{{vm.alto}}px\" ng-click=\"vm.mostrarImagen(vm.restUrl + item.ruta)\"><br><md-button class=\"md-icon-button md-accent md-very-small\" aria-label=Eliminar ng-click=vm.eliminarImagen(item) ng-if=vm.eliminar><md-icon class=md-very-small>delete</md-icon></md-button></div></span></div></div>");
$templateCache.put("app/factories/Catalogo/dialog.historial.html","<md-dialog aria-label=\"Ver historial\" class=\"formly-dialog formly-column-{{column}} dialog-progreso\" style=\"max-width: 800px; width: 100%\"><md-toolbar><div class=md-toolbar-tools><h2><md-icon>dashboard</md-icon>Historial de acciones</h2><span flex></span><md-button class=md-icon-button aria-label=Cerrar ng-click=cerrar()><md-tooltip>Cerrar</md-tooltip><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content class=md-dialog-content><timeline><timeline-event ng-repeat=\"item in catalogos\"><timeline-badge class=bg-firmo><md-icon aria-label=description>create</md-icon><md-tooltip>{{item.accion}} - {{item.tipo}}</md-tooltip></timeline-badge><timeline-panel><timeline-heading><h3>{{item.accion}} - {{item.tipo}}</h3></timeline-heading><p ng-if=\"item.accion == \'CREAR\'\"><span class=ap-text-danger>{{item.autor}}</span> creó el catalogo: <strong>{{item.nombreCatalogo}}</strong><br></p><div ng-if=\"item.accion ==\'MODIFICAR\'\"><span class=ap-text-danger>{{item.autor}}</span> modificó los siguientes datos:<br></div><table md-table><tbody md-body><tr md-row ng-repeat=\"dato in item.datos\"><td md-cell>{{dato.campo}}</td><td md-cell><strong>{{dato.valor}}</strong></td></tr></tbody></table>En fecha {{item.fecha}} a horas {{item.hora}}</timeline-panel></timeline-event></timeline></md-dialog-content><md-dialog-actions><div flex></div><md-button class=md-raised ng-click=cerrar()><md-icon>check</md-icon><span>Cerrar</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/factories/Documento/dialog.progreso.html","<md-dialog aria-label=\"Ver progreso\" class=\"formly-dialog formly-column-{{column}} dialog-progreso\" style=\"max-width: 800px; width: 100%\"><md-toolbar><div class=md-toolbar-tools><h2><md-icon>dashboard</md-icon>{{titleModal}}</h2><span flex></span><md-button class=md-icon-button aria-label=Cerrar ng-click=cerrar()><md-tooltip>Cerrar</md-tooltip><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content class=md-dialog-content ng-if=!mostrarContenido><timeline><timeline-event ng-repeat=\"it in data.datos\"><timeline-badge class=bg-{{it.bg_color}}><img src=../../../assets/fonts/iconfont/iconAprobacion.png width=48px ng-if=\"it.accion==\'APROBADO_CD\'\"><md-icon aria-label=description ng-if=\"it.accion!=\'APROBADO_CD\'\">{{it.icon}}</md-icon><md-tooltip>{{it.acc}}</md-tooltip></timeline-badge><timeline-panel ng-if=\"it.accion !== \'ANULADO\'\"><timeline-heading><h3>{{it.nombres}}</h3></timeline-heading><p><span class=ap-text-{{it.bg_color}}>{{it.acc}} {{it.acc==\'Sin respuesta\'? \'desde \': \'\'}} </span>el {{it.fecha_mos}} a las {{it.hora_mos}}</p><p ng-if=\"it.accion==\'DERIVADO\' && it.derivado\">A: <strong>{{it.derivado.nombres}}</strong></p><p ng-if=it.tipo_doc>Documento: {{it.tipo_doc}}</p><p ng-if=it.cite>CITE: <span class=ap-cursor-pointer ng-click=verDocumento(it.id_documento)>{{it.cite}}</span></p><p ng-if=\"it.accion==\'RECHAZADO\'\">{{it.observacion}}</p><p ng-if=\"it.accion==\'DERIVADO\'\">Proveído: {{it.observacion}}</p><div ng-if=\"it.mensajeAdjuntos!=undefined\" class=mt-3><label>{{it.mensajeAdjuntos}}</label><p class=\"text-right ap-cursor-pointer\" ng-click=mostrarHistorial(it.id_historial_flujo)><br><md-icon aria-label=\"Ver Adjuntos\">remove_red_eye</md-icon>Ver detalle</p></div></timeline-panel><timeline-panel ng-if=\"it.accion==\'ANULADO\'\"><timeline-heading><h3>Anulación</h3></timeline-heading><p><strong>Del documento: </strong><span class=\"ap-text-{{it.bg_color}} ap-cursor-pointer\" ng-click=verDocumento(it.id_documento)>{{it.cite}}.</span><br><strong>Mediante: </strong><span class=ap-cursor-pointer ng-click=verDocumento(it.id_documento)>{{it.observacion}}.</span><br>El cual fue solicitado por <strong>{{it.nombres}}</strong> y aprobado por <strong>{{it.aprobado.nombres}}</strong> el {{it.fecha_mos}} a las {{it.hora_mos}}</p></timeline-panel></timeline-event></timeline></md-dialog-content><md-dialog-content style=\"min-height: auto\" ng-if=mostrarContenido><md-content class=md-padding><md-table-container><table md-table><thead md-head><tr md-row><th md-column>Nombre</th><th md-column>Fecha de Aprobación</th><th md-column>Hora de Aprobación</th></tr></thead><tbody md-body ng-repeat=\"item in adjuntos\"><tr md-row><td md-cell>{{item.nombre_publico}}</td><td md-cell>{{item.fecha_mos}}</td><td md-cell>{{item.hora_mos}}</td></tr></tbody></table></md-table-container></md-content></md-dialog-content><md-dialog-actions><div flex></div><md-button class=md-raised ng-click=cerrar() ng-if=!mostrarContenido><md-icon>check</md-icon><span>Cerrar</span></md-button><md-button class=md-raised ng-click=verHistorial(false) ng-if=mostrarContenido><md-icon>check</md-icon><span>Cerrar</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/factories/Documento/dialogPDF.html","<md-dialog aria-label=\"Documento PDF\" class=\"formly-dialog formly-column-{{column}} dialog-pdf\" style=\"max-width: 800px; width: 100%\"><md-toolbar><div class=md-toolbar-tools><h2><md-icon>picture_as_pdf</md-icon>Vista previa</h2><span flex></span><md-button class=md-icon-button aria-label=\"Ver pdf\" ng-click=verPdf() ng-show=data.flag_html><md-tooltip>Ver PDF</md-tooltip><md-icon aria-label=\"Close dialog\">picture_as_pdf</md-icon></md-button><md-button class=md-icon-button aria-label=\"Ver html\" ng-click=verHtml() ng-show=!data.flag_html><md-tooltip>Ver html</md-tooltip><md-icon aria-label=\"Close dialog\">code</md-icon></md-button><md-button class=md-icon-button aria-label=Cerrar ng-click=cerrar()><md-tooltip>Cerrar</md-tooltip><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><div class=dialog-firmas><div ng-repeat=\"(indice, item) in data.firmas\" class=\"{{(item.firmo===true?\'firmado\':\'sin-firma\')}}\">{{item.firmante}}<md-tooltip>{{item.firmante}}</md-tooltip></div></div><md-dialog-content class=md-dialog-content><div ng-show=data.flag_html bind-html-compile=data.html></div><iframe class=iframe-pdf src={{data.pdf}} style=\"width:100%; height:600px; border: none\" ng-if=\"data.show_pdf && !data.flag_html\" allowfullscreen></iframe><div id=canvasContainer ng-show=!data.flag_html></div></md-dialog-content><md-dialog-actions><span flex></span><md-button class=md-raised ng-click=cerrar()><md-icon>cancel</md-icon>Cancelar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/factories/Loading/Loading.html","<md-dialog class=\"{{data.tipo || \'loader-info\' }} loader-padre\"><md-dialog-content><center><div class=loader-contenendor><div class=loader></div></div><p></p><h2>{{data.mensaje}}</h2><p></p></center></md-dialog-content></md-dialog>");
$templateCache.put("app/factories/Messages/layout.toast.html","<md-toast class=md-toast-{{type}}><div class=md-toast-title><md-icon class=md-toast-icon>{{icon}}</md-icon>{{title}}<md-button class=\"md-toast-close md-icon-button\" aria-label=Close><md-icon class=md-icon>close</md-icon></md-button></div><div class=md-toast-message ng-bind-html=message></div></md-toast>");
$templateCache.put("app/factories/Panel/defaultPanelTemplate.html","<md-card><md-content>Usando panel factory, introduzca su template</md-content></md-card>");
$templateCache.put("app/modules/dashboard/main.html","<div class=container>Mi dashboard</div>");
$templateCache.put("app/modules/firmador/modules.firmador.html","<md-dialog aria-label=\"Firmar Digitalmente\" class=\"formly-dialog formly-column-{{column}}\" style=\"max-width: 700px; width: 100%\"><md-toolbar><div class=md-toolbar-tools><h2><md-icon>done_all</md-icon>Firmar documentos</h2><span flex></span></div></md-toolbar><md-dialog-content class=md-dialog-content><div ng-if=\"iniciado === false\">Iniciando...</div><div ng-if=\"iniciado === true\"><div ng-if=!demofi_ejecutandose class=\"alert alert-warning\" ng-if=\"data.certificado === null\"><i class=\"fa fa-warning\"></i> <span>Demofi no se está ejecutando en su equipo o no tiene agregado el certificado de seguridad en su navegador.</span><br><ul><li><span>Visite el siguiente enlace para su instalación y/o configuración. Presione <a target=_blank href=http://test.local.agetic.gob.bo/firmador/#>aquí</a>.<help message=helpMessage.demofi_no_instalado></help></span></li><li><span>Para verificar que el certificado de seguridad de Demofi se encuentra instalado. Presione <a href=# ng-click=verificarServidor()>aquí</a>.</span></li></ul></div></div><div layout=row ng-if=demofi_ejecutandose><div flex layout-align=\"center center\"><img class=img-certificado src=assets/images/certificate.png></div><div flex=66><br><div ng-if=demofi_ejecutandose><span style=\"font-weight: bold\">TOKEN: </span><span ng-if=\"tokens.length == 0\">Conecte su token </span><span ng-repeat=\"tokenName in tokens\"><span>{{tokenName}}</span></span></div><br><div flex-gt-xs><md-input-container><label>PIN:</label><md-icon>vpn_key</md-icon><input name=pin type=password class=form-control ng-model=formData.pin ng-disabled=!token_conectado required></md-input-container><md-button class=\"md-raised md-primary\" ng-click=autenticar() ng-disabled=\"!token_conectado || autenticado \"><md-icon>verified_user</md-icon>Autenticar</md-button></div><md-input-container><label>CERTIFICADO DIGITAL:</label><md-icon>content_copy</md-icon><md-select ng-model=formData.certificado_seleccionado required ng-disabled=!autenticado><md-option ng-repeat=\"(index, cer) in certificados\" value={{cer}} ng-select=\"index == 1 && formData.uniqueValue\">{{cer.nombreComunSubject}}</md-option></md-select></md-input-container></div></div><h4 ng-if=\"documentosParaFirmar.length > 0\">Se firmarán los siguientes documentos:</h4><h4 ng-if=\"documentosParaFirmar.length == 0\">No se seleccionaron documentos para firmar</h4><span class=\"chip {{yaFirmo ? doc.class : \'enCola\'}}\" ng-repeat=\"doc in documentosParaFirmar\">{{doc.nombre}}</span><h4 ng-if=\"yaFirmo ==true\">Se firmaron <strong>{{firmados}}</strong> documentos de <strong>{{documentosParaFirmar.length}}</strong>.</h4></md-dialog-content><md-dialog-actions><div flex></div><md-button class=\"md-raised md-secondary\" ng-click=cancelar()><md-icon>cancel</md-icon><span>{{yaFirmo==true? \'Listo\': \'Cancelar\'}}</span></md-button><md-button class=\"md-raised md-primary\" ng-click=firmar() ng-disabled=\"(documentosParaFirmar.length == 0) || !token_conectado|| !autenticado || yaFirmo\"><md-icon>check</md-icon><span>Firmar</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/verificacion/modules.verificar.html","<div class=container-main><div class=logo-agetic><img src=assets/images/logo.png class=text-button alt=AGETIC ng-click=verificar.irInicio()></div><md-card style=\"height: calc(100vh - 200px)\"><md-tabs class=\"md-accent verificar-contenedor {{(verificar.datosDocumento?\'ampliar\':\'\')}}\" md-align-tabs=top md-selected=verificar.data.selectedIndex><md-tab name=verificar><md-tab-label><strong>Verificar Por: Cite y Codigo</strong></md-tab-label><md-tab-body><md-button class=\"md-fab md-mini md-icon-button md-primary\" aria-label=home ng-click=verificar.irInicio()><md-icon>home</md-icon><md-tooltip>Volver al inicio</md-tooltip></md-button><form name=form id=verificarForm ng-submit=verificar.verificarDocumento($event)><div class=md-padding layout layout-xs=column layout-align=center><md-input-container><label>Cite</label><input ng-model=verificar.datos.cite required></md-input-container><md-input-container><label>Codigo</label><input ng-model=verificar.datos.codigo required></md-input-container><md-input-container><div class=recaptcha id=recaptcha></div></md-input-container><center><md-button type=submit class=\"md-raised md-primary\" ng-disabled=form.$invalid>Validar documento</md-button></center></div></form><div ng-if=verificar.datosDocumento layout layout-sm=column layout-xs=column class=visor-verificado flex-direction-sm=column><md-card flex-sm=50 flex-gt-sm=100 flex-gt-md=30 layout=row layout-sm layout-xs=4 layout-align=\"center center\"><section style=\"width:100%; height:100%\" ng-if=verificar.datosDocumento><md-toolbar class=\"md-hue-2 titulo-seccion-verificar\" layout-align=\"center center\"><div layout=row class=md-headline><h2 class=md-toolbar-tools><span>Participantes del documento</span></h2></div></md-toolbar><md-list layout-padding class=lista-firmantes><md-list-item class=md-2-line ng-repeat=\"usuario in verificar.datosDocumento.firmantes\"><md-icon class=\"md-48 md-primary\">accessibility</md-icon><div class=md-list-item-text><label class=texto-firmante>{{usuario.nombres + \' \' + usuario.primer_apellido }}</label><label class=texto-firmante ng-show=\"usuario.segundo_apellido!=null\">{{\' \' + usuario.segundo_apellido}}</label><p>{{usuario.ci}}</p><p>{{usuario.fechaSolicitud | date:\"dd/MM/yyyy\"}}</p><p class=texto-descripcion>{{usuario.descripcion}}</p></div><md-divider md-inset hide-sm></md-divider><md-divider hide-gt-sm></md-divider></md-list-item></md-list></section></md-card><md-card flex-sm=50 flex-gt-sm=100 flex-gt-md=70 layout layout-align=\"center center\" layout-xs=4><section style=\"width:100%; height:100%\"><md-toolbar class=\"md-hue-2 titulo-seccion-verificar\" layout-align=\"center center\"><div layout=row class=md-headline><h2 class=md-toolbar-tools><span class=titulo-card-verificar>Documento Aprobado {{verificar.esMovil}}</span></h2></div></md-toolbar><iframe ng-if=\"verificar.pdf && (verificar.esMovil==false || !verificar.esMovil)\" class=iframe-verificado-pdf src={{verificar.pdf}} allowfullscreen></iframe><div ng-if=\"verificar.pdf && verificar.esMovil==true\" id=canvasContainerVerificado></div></section></md-card></div></md-tab-body></md-tab><!-- <md-tab name=\"historial\">\n        <md-tab-label>\n          Historial\n        </md-tab-label>\n        <md-tab-body>\n          historial de mis verificaciones\n        </md-tab-body>\n      </md-tab> --></md-tabs></md-card></div>");
$templateCache.put("app/components/formlyComponents/aprobacionCD/pdfsAprobacionCD.html","<div ng-if=!to.multiple><md-button ng-if=!to.disabled class=\"md-raised md-warn\" ng-click=vm.elegirPdf($event)>{{to.label}}</md-button><input ng-show=false type=file ng-model=fileCache base-sixty-four-input accept=.pdf on-after-validate=vm.onLoadModel multiple maxsize=maxPdfSizeAprobacion onloadstart=vm.onLoadStart> <span ng-show=vm.cargando><i>Cargando pdf</i><div class=custom-loader></div></span><table class=\"table table-hover table-striped\" ng-if=model[options.key]><thead><tr><th></th><th>Documento</th><th>Peso</th></tr></thead><tbody><tr ng-repeat=\"pdf in model[options.key] track by $index\"><td class=buttons layout-gt-sm><md-icon ng-click=vm.showPdf(pdf.url) class=ap-cursor-pointer ng-if=pdf.url>picture_as_pdf<md-tooltip>Ver pdf</md-tooltip></md-icon><md-icon class=\"ap-text-warning ap-cursor-pointer\" ng-click=vm.limpiarPdf($index) ng-if=!to.disabled>delete</md-icon></td><td>{{$index}} {{pdf.filename}}</td><td>{{vm.redondear(pdf.filesize/1024, 2)}} KB</td></tr><tr><td></td><td></td><td><b>Total: </b>{{ vm.redondear(vm.getTotalFilesSize() / 1024, 2) }} MB</td></tr></tbody></table></div>");
$templateCache.put("app/components/formlyComponents/archivo/archivo.html","<div ng-if=!to.multiple><md-button class=\"md-raised md-warn\" ng-click=vm.elegirPdf($event) ng-if=!model[options.key]>{{to.label}}</md-button><input ng-show=false type=file ng-model=model[options.key] base-sixty-four-input accept=.pdf on-after-validate=vm.onLoadModel><div ng-if=model[options.key]>Documento: {{ model[options.key].filename}} Peso: {{ vm.redondear(model[options.key].filesize/1024, 2)}} kb<md-icon ng-click=vm.showPdf(model[options.key].url) class=ap-cursor-pointer ng-if=model[options.key].url>picture_as_pdf<md-tooltip>Ver pdf</md-tooltip></md-icon><md-icon class=\"ap-text-warning ap-cursor-pointer\" ng-click=vm.limpiarPdf() ng-if=!to.disabled>delete<md-tooltip>Eliminar</md-tooltip></md-icon><br></div></div><div ng-if=to.multiple><md-button class=\"md-raised md-warn\" ng-click=vm.elegirPdf($event)>{{to.label}}</md-button><input ng-show=false type=file ng-model=model[options.key] base-sixty-four-input accept=.pdf on-after-validate=vm.onLoadModel multiple><div ng-repeat=\"pdf in model[options.key]\">Documento: {{ pdf.filename}} Peso: {{ vm.redondear(pdf.filesize/1024, 2)}} kb<md-icon ng-click=vm.showPdf(pdf.url) class=ap-cursor-pointer ng-if=pdf.url>picture_as_pdf<md-tooltip>Ver pdf</md-tooltip></md-icon><md-icon class=\"ap-text-warning ap-cursor-pointer\" ng-click=vm.limpiarPdf($index) ng-if=!to.disabled>delete</md-icon></div></div>");
$templateCache.put("app/components/formlyComponents/cajachica/cajachica.html","<ng-form name=cajaChicaForm><div layout layout-align=\"start center\"><md-button class=\"md-fab md-mini md-icon-button md-primary\" aria-label=add ng-click=vm.addRow(model[options.key].tipo,1) ng-if=\"!to.disabled && model[options.key].tipo!=\'PAGADO\'\"><md-icon>add</md-icon><md-tooltip>Agregar fila</md-tooltip></md-button><md-autocomplete ng-if=\"!to.disabled && model[options.key].tipo==\'PAGADO\'\" flex=40 md-no-cache=true md-selected-item=vm.buscar.doc_seleccionado md-search-text=vm.buscar.doc md-items=\"item in vm.buscarDocumentos(vm.buscar.doc)\" md-selected-item-change=vm.cargarPartidas(item.nombre) md-item-text=item.nombre md-min-length=0 placeholder=\"Seleccione un cite para añadir\"><md-item-template><span>{{item.nombre}}</span></md-item-template><md-not-found>Escriba un cite válido.</md-not-found></md-autocomplete><md-autocomplete ng-if=\"(model[options.key].tipo==\'COMPROMETIDO\' || model[options.key].tipo==\'MODIFICADO\') && !to.disabled\" flex=40 md-no-cache=true md-selected-item=vm.buscar.par_seleccionado md-search-text=vm.buscar.par md-items=\"item in vm.buscarPartidas(vm.buscar.par)\" md-selected-item-change=vm.addRow(model[options.key].tipo) md-item-text=item.num_des md-min-length=0 ng-disabled=to.disabled placeholder=\"Partida ...\"><md-item-template><span>{{item.num_des}}</span></md-item-template><md-not-found>No se encontraron coincidencias para \"{{vm.buscar.par}}\".</md-not-found></md-autocomplete><span flex></span><md-input-container md-no-float flex=25><input type=text placeholder=\"Buscar... \" ng-model=vm.filter ng-disabled=false></md-input-container><md-input-container ng-if=\"to.tipo==\'GESTION\'\" flex=10><md-select ng-model=model[options.key].tipo ng-change=\"model[options.key].rows=[]\"><md-option value=INICIAL>INICIAR PARTIDAS</md-option><md-option value=MODIFICADO>MODIFICAR PARTIDAS</md-option></md-select></md-input-container></div><div layout layout-align=\"start center\" class=alert ng-class=\"\'alert-\'+vm.alert.tipo\" ng-show=vm.alert.show><md-icon>{{vm.alert.icono}}</md-icon><div flex>{{vm.alert.mensaje}}</div><md-icon class=ap-cursor-pointer ng-click=\"vm.alert.show=false\" ng-if=\"vm.alert.time==0\">close</md-icon></div><table class=\"table table-hover table-striped\"><thead><tr><th ng-if=!to.disabled></th><th ng-if=\"to.tipo==\'PAGADO\'\">Cite</th><th>Partida</th><th>{{to.tipo==\'COMPROMETIDO\' || to.tipo==\'PAGADO\'? \'Detalle\':\'Descripción\'}}</th><th ng-if=\"to.tipo==\'PAGADO\'\">Comprometido</th><th>{{to.tipo==\'PAGADO\'? \'Pagado\':\'Monto\'}}</th></tr></thead><tbody><tr ng-repeat=\"row in model[options.key].rows | filter: vm.filter\"><td class=buttons ng-if=!to.disabled layout-gt-sm><span ng-if=\"to.tipo==\'COMPROMETIDO\'\"><md-checkbox ng-model=row.pago_multiple></md-checkbox><md-tooltip>Pagado múltiple</md-tooltip></span><md-button class=md-icon-button aria-label=getSaldo ng-click=vm.deleteRow($index)><md-icon>delete</md-icon><md-tooltip>Eliminar fila</md-tooltip></md-button><md-button class=md-icon-button aria-label=delete ng-click=vm.obtenerSaldo(row.id_comprometido) ng-if=\"to.tipo==\'PAGADO\' && row.pago_multiple\"><md-icon>attach_money</md-icon><md-tooltip>Obtener saldo actual</md-tooltip></md-button></td><td ng-if=\"to.tipo==\'PAGADO\'\"><md-input-container><textarea ng-model=row.cite.nombre disabled></textarea></md-input-container></td><td><md-input-container ng-if=\"model[options.key].tipo==\'INICIAL\'\"><textarea ng-model=row.partida></textarea></md-input-container><md-input-container ng-if=\"model[options.key].tipo!=\'INICIAL\'\"><textarea ng-model=row.partida.num_des disabled></textarea></md-input-container></td><td><md-input-container><textarea ng-model=row.descripcion ng-disabled=\"to.tipo==\'PAGADO\' || to.disabled\"></textarea></md-input-container></td><td ng-if=\"to.tipo==\'PAGADO\'\"><md-input-container><input type=text ng-model=row.comprometido disabled></md-input-container><!-- <div class=\"saldo\" ng-if=\"row.saldo\"> Saldo={{row.saldo}} </div> --></td><td><md-input-container><input type=text ng-model=row.monto ng-blur=vm.calcularTotal(row)></md-input-container></td></tr></tbody><tfoot><tr><td ng-if=!to.disabled></td><td ng-if=\"to.tipo==\'PAGADO\'\"></td><td></td><td ng-if=\"to.tipo==\'PAGADO\'\"></td><td>Total</td><td><md-input-container><input type=text ng-model=model[options.key].monto_total disabled></md-input-container></td></tr></tfoot></table></ng-form>");
$templateCache.put("app/components/formlyComponents/calendario/calendario.html","<div layout layout-align=\"start start\" class=calendario><div><label flex layout layout-align=\"start start\">{{to.label}}</label><div><md-input-container flex><md-datepicker ng-model=model[options.key] md-min-date=to.minDate md-max-date=to.maxDate ng-required=to.required md-no-asterisk ng-disabled=to.disabled></md-datepicker><div ng-messages=fc.$error><div ng-message=required>Debe llenar este campo</div><div ng-message=mindate>La fecha no se encuentra en el rango</div><div ng-message=maxdate>La fecha no se encuentra en el rango</div></div></md-input-container></div></div></div>");
$templateCache.put("app/components/formlyComponents/ccArchivo/ccArchivo.html","<md-input-container class=md-block><textarea ng-model=model[options.key] style=\"font-size: 10px; line-height: 11px\" rows=1></textarea></md-input-container>");
$templateCache.put("app/components/formlyComponents/certificacionComprometido/certificacionComprometido.html","<ng-form name=certificacionComprometido><div class=\"ap-text-warning ap-text-center\" ng-if=!to.showItem>Esta sección no se mostrará en el PDF hasta que se apruebe y se le asigne un \"CITE\".</div><div class=certificacion-comprometido><h3>{{to.label}}</h3><table class=\"table table-hover table-striped\"><thead><tr><th>Partida</th><th>Saldo inicial</th><th>Monto comprometido</th><th>Saldo final</th></tr></thead><tbody><tr ng-repeat=\"row in model[options.key].rows\"><td></td><td></td><td></td><td></td></tr></tbody></table></div></ng-form>");
$templateCache.put("app/components/formlyComponents/cite/cite.html","<div layout ng-if=\"!to.tipoMembrete || to.tipoMembrete==\'sin membrete\'\"><div flex layout layout-align=\"start end\" ng-if=\"(model[options.key] && model[options.key][\'cite\'])\">{{ model[options.key][\'cite\'] }}</div><div class=placeholder flex layout layout-align=\"start end\" ng-if=\"!(model[options.key] && model[options.key][\'cite\'])\">{{ to.labelCite }}</div><div flex layout layout-align=\"end end\" ng-if=\"(model[options.key] && model[options.key][\'fecha\'])\">{{ model[options.key][\'fecha\'] }}</div><div class=placeholder flex layout layout-align=\"end end\" ng-if=\"!(model[options.key] && model[options.key][\'fecha\'])\">{{ to.labelFecha }}</div></div><div ng-if=\"to.tipoMembrete==\'externo\'\"><div flex ng-if=\"(model[options.key] && model[options.key][\'fecha\'])\">{{ model[options.key][\'fecha\'] }}</div><div class=placeholder flex ng-if=\"!(model[options.key] && model[options.key][\'fecha\'])\">{{ to.labelFecha }}</div><div flex ng-if=\"(model[options.key] && model[options.key][\'cite\'])\">{{ model[options.key][\'cite\'] }}</div><div class=placeholder flex ng-if=\"!(model[options.key] && model[options.key][\'cite\'])\">{{ to.labelCite }}</div></div><br>");
$templateCache.put("app/components/formlyComponents/datosGenerales/datosGenerales.html","<ng-form name=datosGeneralesForm><div class=\"ap-text-warning ap-text-center\" ng-if=!to.showItem>Esta sección no se mostrará al imprimir en PDF.</div><div ng-class=\"{\'border-div\': !to.showItem}\"><div layout ng-if=to.show.para><div ng-class=\"\'flex-\'+to.labelw\" layout=column><div class=label flex layout layout-align=\"start start\"><span class=ap-cursor-pointer ng-click=\"vm.openSelect($event, \'para\')\"><span>PARA:</span></span></div><md-input-container class=input-search ng-show=vm.show_para><label>Usuarios</label><md-select ng-model=\"model[options.key][\'para\']\" name=select_para required md-on-close=\"vm.buscar_para=\'\'; vm.show_para=false;\" data-md-container-class=select-search><md-select-header class=select-header><input ng-model=vm.buscar_para placeholder=\"Buscar destinatario ..\" class=\"header-searchbox md-text\"></md-select-header><md-optgroup label=usuarios><md-option ng-value=u ng-repeat=\"u in vm.usuarios_jefes | filter:vm.buscar_para\">{{ u.nombres+\' \'+u.apellidos }}</md-option></md-optgroup></md-select></md-input-container><div flex></div></div><div flex><div>{{ model[options.key][\'para\'].nombres+\' \'+model[options.key][\'para\'].apellidos }}<md-icon class=ap-text-success ng-if=\"vm.usuarios_check[model[options.key][\'para\'].id_usuario]\">check<md-tooltip>Aprobó</md-tooltip></md-icon></div><span>{{ model[options.key][\'para\'].cargo }}</span><div class=ap-ng-msg ng-messages=datosGeneralesForm.select_para.$error ng-show=\"datosGeneralesForm.$submitted || datosGeneralesForm.select_para.$touched\"><div ng-message=required>Debe elegir una opción haciendo click en PARA:</div></div></div></div><div layout ng-if=to.show.via><div ng-class=\"\'flex-\'+to.labelw\" layout=column><div class=label flex layout layout-align=\"start start\"><span class=ap-cursor-pointer ng-click=\"vm.openSelect($event, \'via\')\"><span>VÍA:</span></span></div><md-input-container class=input-search ng-show=vm.show_via><label>Usuarios</label><md-select ng-model=\"model[options.key][\'via\']\" name=select_via md-on-close=\"vm.buscar_via=\'\'; vm.show_via=false;\" data-md-container-class=select-search multiple><md-select-header class=select-header><input ng-model=vm.buscar_via type=search placeholder=\"Buscar ..\" class=\"header-searchbox md-text\"></md-select-header><md-optgroup label=usuarios><md-option ng-value=u ng-repeat=\"u in vm.usuarios_jefes | filter:vm.buscar_via\">{{ u.nombres+\' \'+u.apellidos }}</md-option></md-optgroup></md-select></md-input-container><div flex></div></div><div flex><div ng-repeat=\"p in model[options.key][\'via\']\"><div>{{ p.nombres+\' \'+p.apellidos }}<md-icon class=ap-text-success ng-if=vm.usuarios_check[p.id_usuario]>check<md-tooltip>Aprobó</md-tooltip></md-icon></div><span>{{ p.cargo }}<md-icon class=ap-cursor-pointer ng-click=\"vm.moverUsuario($index,\'down\')\" ng-if=\" $index!=(model[options.key][\'via\'].length-1) && !to.disabled \">arrow_downward<md-tooltip>Bajar</md-tooltip></md-icon><md-icon class=ap-cursor-pointer ng-click=\"vm.moverUsuario($index,\'up\')\" ng-if=\" $index!=0 && !to.disabled \">arrow_upward<md-tooltip>Subir</md-tooltip></md-icon></span></div><div class=ap-ng-msg ng-messages=datosGeneralesForm.select_via.$error ng-show=\"datosGeneralesForm.$submitted || datosGeneralesForm.select_via.$touched\"><div ng-message=required>Debe elegir una opción haciendo click en VÍA:</div></div></div></div><div layout ng-if=to.show.de><div ng-class=\"\'flex-\'+to.labelw\" layout=column><div class=label flex layout layout-align=\"start start\"><span class=ap-cursor-pointer ng-click=\"vm.openSelect($event, \'de\')\"><span>DE:</span></span></div><md-input-container class=input-search ng-show=vm.show_de><label>Usuarios</label><md-select ng-model=\"model[options.key][\'de\']\" name=select_de md-on-close=\"vm.buscar_de=\'\'; vm.show_de=false;\" data-md-container-class=select-search multiple required><md-select-header class=select-header><input ng-model=vm.buscar_de type=search placeholder=\"Buscar ..\" class=\"header-searchbox md-text\"></md-select-header><md-optgroup label=usuarios><md-option ng-value=u ng-repeat=\"u in vm.usuarios | filter:vm.buscar_de\">{{ u.nombres+\' \'+u.apellidos }}</md-option></md-optgroup></md-select></md-input-container><div flex></div></div><div flex><div ng-repeat=\"p in model[options.key][\'de\']\"><div>{{ p.nombres+\' \'+p.apellidos }}</div><span>{{ p.cargo }}</span></div><div class=ap-ng-msg ng-messages=datosGeneralesForm.select_de.$error ng-show=\"datosGeneralesForm.$submitted || datosGeneralesForm.select_de.$touched\"><div ng-message=required>Debe elegir una opción haciendo click en De:</div></div></div></div><div layout ng-if=to.show.ref><div ng-class=\"\'flex-\'+to.labelw\" layout=column><div class=label flex layout layout-align=\"start end\"><span>{{to.labelRef}}</span></div><div flex></div></div><div flex><md-input-container style=\"width: 100%\"><input name=ref ng-model=\"model[options.key][\'ref\']\" required md-no-asterisk><div ng-messages=datosGeneralesForm.ref.$error><div ng-message=required>Debe llenar este campo</div></div></md-input-container></div></div></div><div class=separador></div></ng-form>");
$templateCache.put("app/components/formlyComponents/documentosAnular/documentosAnular.html","<ng-form name=docsAnular><div layout><div ng-class=\"\'flex-\'+to.labelw\" layout=column><div class=label flex layout layout-align=\"start start\"><span class=ap-cursor-pointer ng-click=\"vm.openSelect($event, \'doc\')\">{{to.label}} </span>&nbsp;&nbsp;&nbsp;</div><md-input-container class=input-search ng-show=vm.show_doc><label>Documentos</label><md-select ng-model=model[options.key] name=select_anular md-on-close=vm.closeSelectDoc() data-md-container-class=select-search multiple required><md-select-header class=select-header><input ng-model=vm.buscar_doc placeholder=\"Buscar ...\" class=\"header-searchbox md-text\"></md-select-header><md-optgroup label=documentos><md-option ng-value=d ng-repeat=\"d in vm.documentos\">{{d.nombre}}</md-option></md-optgroup></md-select></md-input-container><div flex></div></div><div class=docs flex><div layout layout-wrap><div ng-repeat=\"d in model[options.key]\"><md-icon class=\"ap-cursor-pointer md-mini\" ng-click=vm.mostrarPdf(d.id_documento)>description</md-icon><span class=ap-cursor-pointer ng-click=vm.mostrarPdf(d.id_documento)>{{ d.nombre }} {{ ( $index != (model[options.key].length-1) )? \', \' : \'\' }}</span></div></div><div class=ap-ng-msg ng-messages=docsAnular.select_anular.$error ng-show=\"docsAnular.$submitted || docsAnular.select_anular.$touched\"><div ng-message=required>Debe escojer al menos un documento para anular</div></div></div></div></ng-form>");
$templateCache.put("app/components/formlyComponents/documentosRelacionados/documentosRelacionados.html","<ng-form name=docsRelForm><div layout><div ng-class=\"\'flex-\'+to.labelw\" layout=column><div class=label flex layout layout-align=\"start start\"><span class=ap-cursor-pointer ng-click=\"vm.openSelect($event, \'doc\')\">{{to.label}} </span>&nbsp;&nbsp;&nbsp;</div><md-input-container class=input-search ng-show=vm.show_doc><label>Documentos</label><md-select ng-model=model[options.key] name=select_doc md-on-close=vm.closeSelectDoc() data-md-container-class=select-search multiple><md-select-header class=select-header><input ng-model=vm.buscar_doc placeholder=\"Buscar ...\" class=\"header-searchbox md-text\"></md-select-header><md-optgroup label=documentos><md-option ng-value=d ng-repeat=\"d in vm.documentos\">{{d.nombre}}</md-option></md-optgroup></md-select></md-input-container><div flex></div></div><div class=docs flex><div layout layout-wrap><div ng-repeat=\"d in model[options.key]\"><md-icon class=\"ap-cursor-pointer md-mini\" ng-click=vm.mostrarPdf(d.id_documento)>description</md-icon><span class=ap-cursor-pointer ng-click=vm.mostrarPdf(d.id_documento)>{{ d.nombre }} {{ ( $index != (model[options.key].length-1) )? \', \' : \'\' }}</span></div></div><div class=ap-ng-msg ng-messages=docsRelForm.select_doc.$error ng-show=\"docsRelForm.$submitted || docsRelForm.select_doc.$touched\"><div ng-message=required>Debe escojer una opción haciendo click en Documentos adjuntos:</div></div></div></div></ng-form>");
$templateCache.put("app/components/formlyComponents/editorTexto/editorTexto.html","<ng-simditor content=model[options.key] disabled></ng-simditor>");
$templateCache.put("app/components/formlyComponents/encabezado/encabezado.html","<ng-form name=cabeceraForm><div layout ng-if=to.show.para><div ng-class=\"\'flex-\'+to.labelw\" layout=column><div class=label flex layout layout-align=\"start start\"><span class=ap-cursor-pointer ng-click=\"vm.openSelect($event, \'para\')\"><span>PARA:</span></span></div><md-input-container class=input-search ng-show=vm.show_para><label>Usuarios</label><md-select ng-model=\"model[options.key][\'para\']\" name=select_para md-on-close=\"vm.buscar_para=\'\'; vm.show_para=false;\" data-md-container-class=select-search multiple><md-select-header class=select-header><input ng-model=vm.buscar_para placeholder=\"Buscar destinatario ..\" class=\"header-searchbox md-text\"></md-select-header><md-optgroup label=usuarios><md-option ng-value=u ng-repeat=\"u in vm.usuarios_jefes | filter:vm.buscar_para\">{{ u.nombres+\' \'+u.apellidos }}</md-option></md-optgroup></md-select></md-input-container><div flex></div></div><div flex><div ng-repeat=\"p in model[options.key][\'para\']\" ng-init=\"p.mostrar_cargo= (p.mostrar_cargo==undefined)? true : p.mostrar_cargo\"><div>{{ p.nombres+\' \'+p.apellidos }} <span ng-if=!to.disabled><md-checkbox class=cargo ng-model=p.mostrar_cargo aria-label=cargo></md-checkbox><md-tooltip>{{(p.mostrar_cargo)? \'Ocultar \': \'Mostrar \'}}cargo</md-tooltip></span><md-icon class=ap-cursor-pointer ng-click=\"vm.moverUsuario($index,\'down\',\'para\')\" ng-if=\" $index!=(model[options.key][\'para\'].length-1) && !to.disabled \">arrow_downward<md-tooltip>Bajar</md-tooltip></md-icon><md-icon class=ap-cursor-pointer ng-click=\"vm.moverUsuario($index,\'up\',\'para\')\" ng-if=\" $index!=0 && !to.disabled \">arrow_upward<md-tooltip>Subir</md-tooltip></md-icon></div><span ng-if=p.mostrar_cargo>{{ p.cargo }}</span></div></div></div><div layout ng-if=to.show.via><div ng-class=\"\'flex-\'+to.labelw\" layout=column><div class=label flex layout layout-align=\"start start\"><span class=ap-cursor-pointer ng-click=\"vm.openSelect($event, \'via\')\"><span>VÍA:</span></span></div><md-input-container class=input-search ng-show=vm.show_via><label>Usuarios</label><md-select ng-model=\"model[options.key][\'via\']\" name=select_via md-on-close=\"vm.buscar_via=\'\'; vm.show_via=false;\" data-md-container-class=select-search multiple><md-select-header class=select-header><input ng-model=vm.buscar_via type=search placeholder=\"Buscar ..\" class=\"header-searchbox md-text\"></md-select-header><md-optgroup label=usuarios><md-option ng-value=u ng-repeat=\"u in vm.usuarios_jefes | filter:vm.buscar_via\">{{ u.nombres+\' \'+u.apellidos }}</md-option></md-optgroup></md-select></md-input-container><div flex></div></div><div flex><div ng-repeat=\"p in model[options.key][\'via\']\" ng-init=\"p.mostrar_cargo= (p.mostrar_cargo==undefined)? true : p.mostrar_cargo\"><div>{{ p.nombres+\' \'+p.apellidos }} <span ng-if=!to.disabled><md-checkbox class=cargo ng-model=p.mostrar_cargo aria-label=cargo></md-checkbox><md-tooltip>{{(p.mostrar_cargo)? \'Ocultar \': \'Mostrar \'}}cargo</md-tooltip></span><md-icon class=ap-cursor-pointer ng-click=\"vm.moverUsuario($index,\'down\',\'via\')\" ng-if=\" $index!=(model[options.key][\'via\'].length-1) && !to.disabled \">arrow_downward<md-tooltip>Bajar</md-tooltip></md-icon><md-icon class=ap-cursor-pointer ng-click=\"vm.moverUsuario($index,\'up\',\'via\')\" ng-if=\" $index!=0 && !to.disabled \">arrow_upward<md-tooltip>Subir</md-tooltip></md-icon></div><span ng-if=p.mostrar_cargo>{{ p.cargo }}</span></div></div></div><div layout ng-if=to.show.de><div ng-class=\"\'flex-\'+to.labelw\" layout=column><div class=label flex layout layout-align=\"start start\"><span class=ap-cursor-pointer ng-click=\"vm.openSelect($event, \'de\')\"><span>DE:</span></span></div><md-input-container class=input-search ng-show=vm.show_de><label>Usuarios</label><md-select ng-model=\"model[options.key][\'de\']\" name=select_de md-on-close=\"vm.buscar_de=\'\'; vm.show_de=false;\" data-md-container-class=select-search multiple><md-select-header class=select-header><input ng-model=vm.buscar_de type=search placeholder=\"Buscar ..\" class=\"header-searchbox md-text\"></md-select-header><md-optgroup label=usuarios><md-option ng-value=u ng-repeat=\"u in vm.usuarios | filter:vm.buscar_de\">{{ u.nombres+\' \'+u.apellidos }}</md-option></md-optgroup></md-select></md-input-container><div flex></div></div><div flex><div ng-repeat=\"p in model[options.key][\'de\']\" ng-init=\"p.mostrar_cargo= (p.mostrar_cargo==undefined)? true : p.mostrar_cargo\"><div>{{ p.nombres+\' \'+p.apellidos }} <span ng-if=!to.disabled><md-checkbox class=cargo ng-model=p.mostrar_cargo aria-label=cargo></md-checkbox><md-tooltip>{{(p.mostrar_cargo)? \'Ocultar \': \'Mostrar \'}}cargo</md-tooltip></span><md-icon class=ap-cursor-pointer ng-click=\"vm.moverUsuario($index,\'down\',\'de\')\" ng-if=\" $index!=(model[options.key][\'de\'].length-1) && !to.disabled \">arrow_downward<md-tooltip>Bajar</md-tooltip></md-icon><md-icon class=ap-cursor-pointer ng-click=\"vm.moverUsuario($index,\'up\',\'de\')\" ng-if=\" $index!=0 && !to.disabled \">arrow_upward<md-tooltip>Subir</md-tooltip></md-icon></div><span ng-if=p.mostrar_cargo>{{ p.cargo }}</span></div></div></div><div layout ng-if=to.show.ref><div ng-class=\"\'flex-\'+to.labelw\" layout=column><div class=label flex layout layout-align=\"start end\"><span>{{to.labelRef}}</span></div><div flex></div></div><div flex><md-input-container style=\"width: 100%\"><input name=ref ng-model=\"model[options.key][\'ref\']\" required md-no-asterisk><div ng-messages=cabeceraForm.ref.$error><div ng-message=required>Debe llenar este campo</div></div></md-input-container></div></div><div class=separador></div></ng-form>");
$templateCache.put("app/components/formlyComponents/inputt/inputt.html","<div layout layout-align=\"start start\"><div class=label ng-class=\"[to.alineacion||\'ap-text-right\',\'flex-\'+to.labelw]\" ng-if=\"to.labelw>0\">{{to.labelx}}</div><div class=label ng-class=\"[to.alineacion||\'ap-text-right\']\" ng-if=\"to.labelw==0\">{{to.labelx}}</div><md-input-container flex><textarea ng-model=model[options.key] ng-required=to.required md-no-asterisk ng-disabled=to.disabled> </textarea><div ng-messages=fc.$error><div ng-message=required>Debe llenar este campo</div></div></md-input-container></div>");
$templateCache.put("app/components/formlyComponents/listaContactos/listaContactos.html","<ng-form name=listaContactosForm><div layout><div ng-class=\"\'flex-\'+to.labelw\" layout=column><div class=label flex layout layout-align=\"start start\"><span class=ap-cursor-pointer ng-click=\"vm.abrirSelector($event, \'contacto\')\">{{to.label}} </span>&nbsp;&nbsp;&nbsp;</div><md-input-container class=input-search ng-show=vm.mostrarContacto><label>Contactos</label><md-select ng-model=model[options.key].lista name=seleccionarContacto md-on-close=vm.cerrarSelector() data-md-container-class=select-search multiple required><md-select-header class=select-header><input ng-model=vm.buscarContacto placeholder=Buscar... ng-keydown=$event.stopPropagation($event) ng-keyup=$event.stopPropagation($event) class=\"header-searchbox md-text\"></md-select-header><md-optgroup label=contactos><md-option ng-value=d ng-repeat=\"d in vm.contactos\"><div>{{d.grado}} {{d.nombres}} {{d.apellidos}}</div><div ng-if=d.cargo>{{d.cargo}} - {{d.sigla}}</div><div ng-if=\"!d.cargo || d.cargo === undefined\">{{d.sigla}}</div></md-option></md-optgroup></md-select></md-input-container><div flex></div></div><div class=docs flex><div layout=column layout-wrap><div ng-repeat=\"d in model[options.key].lista\" class=\"{{$index%2==0? \'par\':\'impar\'}}\"><div>{{ d.nombres }} {{ d.apellidos }}</div><div>{{d.cargo}}</div><div>{{d.sigla}}</div></div></div><div class=ap-ng-msg ng-messages=listaContactosForm.seleccionarContacto.$error ng-show=\"listaContactosForm.$submitted || listaContactosForm.select_doc.$touched\"><div ng-message=required>Debe escojer al menos un contacto</div></div></div></div></ng-form>");
$templateCache.put("app/components/formlyComponents/listas/listas.html","<div layout><div flex ng-if=\"to.className==\'ap-text-right\' || to.className==\'ap-text-center\'\"></div><div><span>{{to.label}}</span><ul ng-if=\"to.tipo==\'ul\'\"><li ng-repeat=\"i in to.options\">{{i}}</li></ul><ol ng-if=\"to.tipo==\'ol\'\"><li ng-repeat=\"i in to.options\">{{i}}</li></ol></div><div flex ng-if=\"to.className==\'ap-text-center\'\"></div></div>");
$templateCache.put("app/components/formlyComponents/texto/texto.html","<h1 ng-if=\"to.tipo==\'h1\'\" ng-class=\"[to.className,{\'no-margin-top\': !to.mTop },{ \'no-margin-bot\': !to.mBot }]\">{{to.label}}</h1><h2 ng-if=\"to.tipo==\'h2\'\" ng-class=\"[to.className,{\'no-margin-top\': !to.mTop },{ \'no-margin-bot\': !to.mBot }]\">{{to.label}}</h2><h3 ng-if=\"to.tipo==\'h3\'\" ng-class=\"[to.className,{\'no-margin-top\': !to.mTop },{ \'no-margin-bot\': !to.mBot }]\">{{to.label}}</h3><h4 ng-if=\"to.tipo==\'h4\'\" ng-class=\"[to.className,{\'no-margin-top\': !to.mTop },{ \'no-margin-bot\': !to.mBot }]\">{{to.label}}</h4><h5 ng-if=\"to.tipo==\'h5\'\" ng-class=\"[to.className,{\'no-margin-top\': !to.mTop },{ \'no-margin-bot\': !to.mBot }]\">{{to.label}}</h5><h6 ng-if=\"to.tipo==\'h6\'\" ng-class=\"[to.className,{\'no-margin-top\': !to.mTop },{ \'no-margin-bot\': !to.mBot }]\">{{to.label}}</h6><p ng-if=\"to.tipo==\'p\'\" ng-class=\"[to.className,{\'no-margin-top\': !to.mTop },{ \'no-margin-bot\': !to.mBot }]\">{{to.label}}</p>");
$templateCache.put("app/components/formlyComponents/vacio/vacio.html","<div flex ng-style=to.style style=\"outline: 1px dashed #ddd\"></div>");
$templateCache.put("app/modules/admin/login/login.dialog.html","<md-dialog aria-label=Agregar/Editar ng-cloak class=login-dialog><form id=data-form name=form ng-submit=\"answer(\'login\')\"><md-toolbar><div class=md-toolbar-tools><h2><md-icon>lock_outline</md-icon>Iniciar su sesión</h2><span flex></span></div></md-toolbar><md-dialog-content><div class=md-dialog-content><p class=\"bg-warning-user alert\">Su sesión ha expirado, debe iniciarla de nuevo.</p><md-content layout-gt-sm=column layout-padding style=\"overflow: initial\"><md-input-container><label>Nombre de usuario</label><md-icon>person</md-icon><input ng-model=data.username required></md-input-container><md-input-container><label>Contraseña</label><md-icon>lock</md-icon><input ng-model=data.password type=password required></md-input-container><md-button type=submit class=\"md-raised md-primary\" ng-disabled=form.$invalid>Iniciar sesión</md-button></md-content></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/modules/admin/login/modules.admin.login.html","<md-toolbar style=\"display: none\"><div class=logo><img src=assets/images/logo.png></div></md-toolbar><div class=container><div class=logo-agetic><img src=assets/images/logo.png></div><!-- <md-card class=\"login-panel md-whiteframe-3dp\"></md-card> --><md-card class=login-panel><md-card-content><div layout layout-xs=column layout-sm=column layout-align=\"center center\"><div class=\"boton-circular rotar\" flex layout-xs=row><md-tooltip>Iniciar sesión</md-tooltip><img class=\"icon-circular-imagen ciudadania\" src=assets/images/Ciudadania-Digital-Logo-v01-cuadrado.png ng-click=login.iniciarSesion()></div><div class=\"boton-circular rotar\" flex layout-xs=row><md-tooltip>Verificar documentos</md-tooltip><img class=icon-circular-imagen src=assets/images/certificate.png ng-click=login.irAVerificar()></div></div><!-- <form name=\"form\" ng-submit=\"login.login()\">\r\n          <md-input-container>\r\n              <label>Nombre de usuario</label>\r\n              <md-icon>person</md-icon><input ng-model=\"login.username\" required>\r\n          </md-input-container>\r\n          <md-input-container>\r\n              <label>Contraseña</label>\r\n              <md-icon>lock</md-icon><input ng-model=\"login.password\" type=\"password\" required>\r\n          </md-input-container>\r\n          <md-button type=\"submit\" class=\"md-raised md-primary\" ng-disabled=\"form.$invalid\">\r\n              Iniciar sesión\r\n          </md-button>\r\n        </form> --></md-card-content></md-card></div>");
$templateCache.put("app/modules/admin/login/recuperar.dialog.html","<md-dialog aria-label=Recuperar ng-cloak class=\"formly-dialog formly-column-{{column}}\" style=\"max-width: 800px; width: 100%\"><form ng-submit=recuperar() name=recuperarForm><md-toolbar><div class=md-toolbar-tools><h2><md-icon>autorenew</md-icon>Recuperar contraseña</h2><span flex></span> <span flex></span><md-button class=md-icon-button aria-label=Cerrar ng-click=cerrar($event)><md-tooltip>Cerrar</md-tooltip><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content class=md-dialog-content><div class=md-dialog-content><md-input-container class=md-block flex-gt-sm><label>Usuario</label><input name=usuario ng-model=usuario type=text required><div ng-messages=recuperarForm.usuario.$error><div ng-message=required>Debe llenar este campo</div></div></md-input-container><md-input-container class=md-block flex-gt-sm><label>Correo electronico</label><input name=email ng-model=email type=email required><div ng-messages=recuperarForm.email.$error><div ng-message=required>Debe llenar este campo</div></div></md-input-container><md-input-container class=md-block flex-gt-sm><label>Número de documento de identidad</label><input name=numero_documento ng-model=numero_documento type=text required><div ng-messages=recuperarForm.numero_documento.$error><div ng-message=required>Debe llenar este campo</div></div></md-input-container><div class=informacion-recuperar><strong>Usuario:</strong> <span>Es el usuario con el que fue registrado en el sistema.</span><br><strong>Correo electronico:</strong> <span>El mismo con el que fue registrado</span><br><strong>Numero de documento de indentidad:</strong> <span>Escriba solo el número</span></div></div></md-dialog-content><md-dialog-actions><span flex></span><md-button type=submit class=\"md-raised md-primary\" ng-disabled=recuperarForm.$invalid><md-icon>check</md-icon><span>Recuperar</span></md-button><md-button class=md-raised ng-click=cerrar()><md-icon>cancel</md-icon>Cancelar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/admin/profile/modules.admin.profile.html","<div class=profile><div class=profile-user-bg><div class=\"profile-user-photo bg-{{profile.getColor()}}-user\"><img src=\"\" alt=\"\" hidden><!-- <i class=\"md-icon\">account_circle</i> --> {{profile.getInitial()}}</div><div class=profile-data><h2 class=profile-user-name>{{profile.getName()}}</h2><h3 class=profile-user-item>{{profile.getEmail()}}</h3><!-- <ul class=\"profile-user-data\">\r\n				<li>\r\n					<span class=\"profile-data-number\">10</span>\r\n					<span class=\"profile-data-details\">Dato 1</span>\r\n				</li>\r\n				<li>\r\n					<span class=\"profile-data-number\">20</span>\r\n					<span class=\"profile-data-details\">Dato 2</span>\r\n				</li>\r\n				<li>\r\n					<span class=\"profile-data-number\">30</span>\r\n					<span class=\"profile-data-details\">Dato 3</span>\r\n				</li>\r\n			</ul> --></div></div><div class=profile-statistics layout=row><div class=\"profile-char text-left\" flex ng-show=!profile.swEditarCuenta><div layout><md-button class=md-raised ng-click=\"profile.abrirEditar(\'editar_notificaciones\')\"><md-icon>edit</md-icon>Editar alertas</md-button><!-- <md-button class=\"md-raised\" ng-click=\"profile.abrirEditar(\'editar_cuenta\')\">\r\n						<md-icon>edit</md-icon>\r\n						Editar cuenta\r\n				</md-button>\r\n				<md-button class=\"md-raised\" ng-click=\"profile.abrirEditar(\'editar_contrasena\')\">\r\n						<md-icon>edit</md-icon>\r\n						Editar Contraseña\r\n				</md-button> --><div flex></div></div><p><strong>Nombre de usuario: </strong>{{profile.getData(\'username\')}}</p><p><strong>Número de documento: </strong>{{profile.getData(\'doc\')}}</p><p><strong>Nombre(s): </strong>{{profile.getData(\'first_name\')}}</p><p><strong>Apellido(s): </strong>{{profile.getData(\'last_name\')}}</p><p><strong>Correo electrónico: </strong>{{profile.getData(\'email\')}}</p><!-- <p><strong>Último login: </strong>{{profile.getData(\'last_login\')}}</p> --><p><strong>Activo desde: </strong>{{profile.getData(\'date_joined\')}}</p></div><div class=profile-char-edit flex ng-show=\"profile.swEditarCuenta==\'editar_notificaciones\'\"><p>Recibir notificaciones vía:</p><md-radio-group layout ng-model=profile.ca.canal><!-- <md-radio-button value=\"SMS\"> SMS </md-radio-button> --><!-- <md-radio-button value=\"CORREO\"> CORREO ELECTRÓNICO </md-radio-button> --><!-- <md-radio-button value=\"SMS_CORREO\"> SMS Y CORREO ELECTRÓNICO </md-radio-button> --><md-checkbox value=CORREO ng-model=profile.ca.canal_habilitado>CORREO ELECTRÓNICO</md-checkbox></md-radio-group><br><!-- <md-input-container ng-if=\"profile.ca.canal==\'SMS\' || profile.ca.canal==\'SMS_CORREO\'\">\r\n		        <label>Nro. de celular</label>\r\n		        <input ng-model=\"profile.ca.celular\">\r\n		    </md-input-container>\r\n      --><md-input-container ng-if=\"profile.ca.canal==\'CORREO\' || profile.ca.canal==\'SMS_CORREO\'\"><label>Correo electrónico</label><input ng-model=profile.ca.email disabled></md-input-container><p>De documentos que:</p><div layout><!-- <md-checkbox ng-model=\"profile.ca.enviado\" ng-if=\"profile.getEsJefe()\">envien</md-checkbox> --><!-- <md-checkbox ng-model=\"profile.ca.observado\" disabled>observen </md-checkbox> --><md-checkbox ng-model=profile.ca.enviado ng-disabled=!profile.ca.canal_habilitado>Me envien</md-checkbox><md-checkbox ng-model=profile.ca.observado ng-disabled=!profile.ca.canal_habilitado>Me observen</md-checkbox><md-checkbox ng-model=profile.ca.derivado ng-disabled=!profile.ca.canal_habilitado>Me deriven</md-checkbox><md-checkbox ng-model=profile.ca.aprobar_ciudadania ng-disabled=!profile.ca.canal_habilitado>Deba aprobar con CD</md-checkbox><md-checkbox ng-model=profile.ca.aprobados_ciudadania ng-disabled=!profile.ca.canal_habilitado>Han sido aprobados con CD</md-checkbox></div><div layout><!-- <div flex></div> --><md-button class=\"md-raised md-primary\" ng-click=profile.editarConfiguracion()><md-icon>check</md-icon>Guardar</md-button><md-button class=md-raised ng-click=profile.cancelarEditar()><md-icon>cancel</md-icon>Cancelar</md-button><div flex></div></div></div><div class=profile-char-edit flex ng-show=\"profile.swEditarCuenta==\'editar_cuenta\'\"><form name=cuentaForm><div layout-gt-sm=row layout-align=\"center center\"><h3>Modificar cuenta de usuario</h3></div><div layout-gt-sm=row><md-input-container flex-gt-sm><label>Número de documento</label><input name=numero_documento ng-model=profile.numero_documento required><div ng-messages=cuentaForm.numero_documento.$error><div ng-message=required>Debe llenar este campo</div></div></md-input-container><md-input-container flex-gt-sm><label>Nombre de usuario</label><input name=nombre_usuario ng-model=profile.nombre_usuario required><div ng-messages=cuentaForm.nombre_usuario.$error><div ng-message=required>Debe llenar este campo</div></div></md-input-container><md-input-container flex-gt-sm><label>Correo eletrónico</label><input name=email ng-model=profile.email required type=email><div ng-messages=cuentaForm.email.$error><div ng-message=required>Debe llenar este campo</div></div></md-input-container></div><div layout-gt-sm=row><md-input-container flex-gt-sm=50><label>Nombre(s)</label><input name=nombres ng-model=profile.nombres required><div ng-messages=cuentaForm.nombres.$error><div ng-message=required>Debe llenar este campo</div></div></md-input-container><md-input-container flex-gt-sm><label>Apellidos</label><input name=apellidos ng-model=profile.apellidos required><div ng-messages=cuentaForm.apellidos.$error><div ng-message=required>Debe llenar este campo</div></div></md-input-container></div><div layout><div flex></div><md-button class=\"md-raised md-primary\" ng-click=profile.editarCuenta()><md-icon>check</md-icon>Guardar</md-button><md-button class=md-raised ng-click=profile.cancelarEditar()><md-icon>cancel</md-icon>Cancelar</md-button></div></form></div><div class=profile-char-edit flex ng-show=\"profile.swEditarCuenta==\'editar_contrasena\'\"><form name=cuentaPassForm><div layout><div flex=0 flex-gt-sm=30></div><div flex-gt-sm=40 layout=column layout-align=\"center stretch\"><h3>Modificar contraseña de usuario</h3><md-input-container flex><label>Contraseña actual</label><input name=contrasena ng-model=profile.contrasena required type=password><div ng-messages=cuentaPassForm.contrasena.$error><div ng-message=required>Debe llenar este campo</div></div></md-input-container><md-input-container flex><label>Contraseña nueva</label><input name=contrasena_nueva ng-model=profile.contrasena_nueva required type=password><div ng-messages=cuentaPassForm.contrasena_nueva.$error><div ng-message=required>Debe llenar este campo</div></div></md-input-container><md-input-container flex><label>Confirmar contraseña nueva</label><input name=contrasena_confirm ng-model=profile.contrasena_confirm required type=password><div ng-messages=cuentaPassForm.contrasena_confirm.$error><div ng-message=required>Debe llenar este campo</div></div></md-input-container><div layout><div flex></div><md-button class=\"md-raised md-primary\" ng-click=profile.editarCuenta()><md-icon>check</md-icon>Guardar</md-button><md-button class=md-raised ng-click=profile.cancelarEditar()><md-icon>cancel</md-icon>Cancelar</md-button></div></div></div></form></div></div></div>");
$templateCache.put("app/modules/admin/usuarios/dialog.usuario.html","<md-dialog ng-cloak class=\"formly-dialog formly-column-{{column}}\" style=\"max-width: 800px; width: 100%\"><form ng-submit=registrarUsuario() name=usuarioForm><md-toolbar><div class=md-toolbar-tools><h2><md-icon>business</md-icon>{{data.id_usuario == null ? \"Nuevo usuario\" : \"Editar usuario\"}}</h2><span flex></span> <span flex></span><md-button class=md-icon-button aria-label=Cerrar ng-click=cerrar($event)><md-tooltip>Cerrar</md-tooltip><md-icon>close</md-icon></md-button></div></md-toolbar><md-dialog-content class=md-dialog-content><div layout=row><md-card style=width:50%><md-card-header><md-card-header-text><span class=md-title>Datos personales</span></md-card-header-text></md-card-header><md-card-content><md-input-container class=md-block flex-gt-sm><label>Nro documento de identidad</label><input ng-model=data.numero_documento type=text pattern=[A-Za-z0-9-]{5,15}[^\\s] required maxlength=15></md-input-container><md-input-container class=md-block flex-gt-sm><label>Nombre(s)</label><input ng-model=data.nombres type=text pattern=\"[A-Za-z\\u00C0-\\u017FñÑ ]{2,25}[^\\d^\\W]\" required maxlength=25></md-input-container><md-input-container class=md-block flex-gt-sm><label>Apellidos</label><input ng-model=data.apellidos type=text pattern=\"[A-Za-z\\u00C0-\\u017FñÑ ]{2,40}[^\\d^\\W]\" required maxlength=40></md-input-container><md-input-container class=md-block flex-gt-sm><label>Cargo</label><input ng-model=data.cargo type=text required></md-input-container><md-input-container class=md-block flex-gt-sm><label>Correo electronico</label><input ng-model=data.email type=email required></md-input-container><!-- TODO: probando a usar chips --><h3>Usuarios virtuales</h3><md-input-container class=md-block flex-gt-sm ng-show=virtual ng-repeat=\"virtual in data.virtuales\"><md-checkbox ng-model=virtual.valor aria-label={{virtual.cargo}} ng-if=\"virtual.libre === true\">{{virtual.cargo}}</md-checkbox><md-checkbox ng-model=virtual.fake aria-label={{virtual.cargo}} ng-disabled={{!virtual.libre}} ng-if=\"virtual.libre === false\">{{virtual.cargo}}<md-icon class=info-icono>info</md-icon><md-tooltip class=info-virtual>{{virtual.titular.nombres}} {{virtual.titular.apellidos}}</md-tooltip></md-checkbox></md-input-container></md-card-content></md-card><md-card style=width:50%><md-card-header><md-card-header-text><span class=md-title>Datos de usuario</span></md-card-header-text></md-card-header><md-card-content><md-input-container class=md-block flex-gt-sm><label>Nombre de usuario</label><input ng-model=data.usuario type=text required></md-input-container><md-input-container class=md-block flex-gt-sm><label>Estado</label><md-select ng-model=data.estado name=estado required><md-option ng-value=\"\'ACTIVO\'\">ACTIVO</md-option><md-option ng-value=\"\'INACTIVO\'\">INACTIVO</md-option></md-select><div ng-messages=usuarioForm.estado.$error ng-show=usuarioForm.estado.$dirty><div ng-message=required>Debe seleccionar un estado</div></div></md-input-container><md-input-container class=md-block flex-gt-sm><label>Unidad</label><md-select ng-model=data.fid_unidad name=unidad><md-option ng-value=u.id_unidad ng-repeat=\"u in data.unidades\">{{u.abreviacion+\' - \'+u.nombre}}</md-option></md-select></md-input-container><h3>Roles</h3><md-input-container class=md-block flex-gt-sm ng-show=rol ng-repeat=\"rol in data.roles\"><md-checkbox ng-model=rol.valor aria-label={{rol.nombre}}>{{rol.nombre}}</md-checkbox></md-input-container></md-card-content></md-card></div></md-dialog-content><md-dialog-actions layout=row><span flex></span><md-button type=submit class=\"md-raised md-primary\" ng-disabled=usuarioForm.$invalid><md-icon>check</md-icon>Guardar</md-button><md-button class=md-raised ng-click=cerrar()><md-icon>cancel</md-icon>Cancelar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/admin/usuarios/edit.dialog.html","<md-dialog aria-label=Agregar/Editar ng-cloak><form id=data-form name=form ng-submit=\"answer(\'save\')\"><md-toolbar><div class=md-toolbar-tools><h2>{{title}}</h2><span flex></span><md-button class=md-icon-button ng-click=cancel()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content><md-content layout-gt-sm=column layout-padding style=\"overflow: initial\"><md-input-container><label>Nombre de usuario</label><input ng-model=data.username required></md-input-container><md-input-container ng-if=add><label>Contraseñssssa</label><input ng-model=data.password type=password required></md-input-container><md-input-container><label>Email</label><input ng-model=data.email type=email></md-input-container><md-input-container class=md-block flex-gt-sm><label>Nombre(s)</label><input ng-model=data.first_name></md-input-container><md-input-container class=md-block flex-gt-sm><label>Apellido(s)</label><input ng-model=data.last_name></md-input-container><input ng-model=data.id type=hidden> <input ng-model=data.is_active type=hidden></md-content></div></md-dialog-content><md-dialog-actions layout=row><span flex></span><md-button class=md-raised ng-click=\"answer(\'cancel\')\"><md-icon>cancel</md-icon>Cancelar</md-button><md-button type=submit class=\"md-raised md-primary\" ng-disabled=form.$invalid><md-icon>check</md-icon>Guardar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/admin/usuarios/modules.admin.usuarios.html","<div class=container><crud-table url=usuarios.url title-table=usuarios.title fields=usuarios.fields usuario=usuarios.usuario template=usuarios.template dialog-controller=usuarios.dialogController permission=usuarios.permission></crud-table></div>");
$templateCache.put("app/modules/admin/virtual/virtual.html","<div class=container><md-card-content><div layout layout-xs=column layout-sm=column layout-align=\"center center\"><div class=contenedor-virtual ng-repeat=\"item in virtual.usuariosVirtuales\"><center><div class=\"virtual-icon {{(!item.activo || item.activo ==false ? \'boton-circular\':\'desactivar\')}}\" layout-xs=row><md-tooltip md-direction=top>{{item.cargo}}</md-tooltip><img class=icon-circular-imagen src=assets/images/robo{{$index}}.png ng-click=virtual.seleccionar(item) ng-if=!item.activo> <img class=icon-circular-imagen src=assets/images/robo{{$index}}.png ng-if=\"item.activo && item.activo== true\"></div><div><md-icon class=\"{{(!item.activo || item.activo ==false ? \'inactivo\':\'activo\')}}\">check</md-icon><div><strong>{{item.nombres}}</strong></div></div></center></div></div></md-card-content></div>");
$templateCache.put("app/modules/plantillasFormly/aprobacion/dialogPDF.html","<md-dialog aria-label=Agregar/Editar ng-cloak class=\"formly-dialog formly-column-{{column}} dialog-aprobacion\" style=\"max-width: 800px; width: 100%\"><form name=obsForm><md-toolbar><div class=md-toolbar-tools><h2><md-icon>picture_as_pdf</md-icon>Documento creado por {{data.nombres +\' \'+ data.apellidos}}</h2><span flex></span><md-button class=md-icon-button aria-label=\"Ver pdf\" ng-click=verPdf() ng-show=data.flag_html><md-tooltip>Ver PDF</md-tooltip><md-icon aria-label=\"Close dialog\">picture_as_pdf</md-icon></md-button><md-button class=md-icon-button aria-label=\"Ver html\" ng-click=verHtml() ng-show=!data.flag_html><md-tooltip>Ver html</md-tooltip><md-icon aria-label=\"Close dialog\">code</md-icon></md-button><md-button class=md-icon-button aria-label=Cerrar ng-click=cerrar()><md-tooltip>Cerrar</md-tooltip><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content class=md-dialog-content><div layout=column ng-if=\"!data.es_para && !data.es_derivar\"><md-input-container style=width:100%><label>{{ (data.accion==\'derivar\')? \'Proveído\': \'Observaciones\'}}</label><textarea name=obs ng-model=data.observaciones md-maxlength=250 maxlength=250 rows=2 required></textarea></md-input-container></div><div layout=column ng-if=\"!data.es_derivar && data.es_para\"><md-tabs md-dynamic-height md-border-bottom md-selected=4 md-stretch-tabs=always md-pagination-wrapper><md-tab label=\"Aprobar y crear\" md-on-select=\"data.accion=\'crear\'\"><md-content class=md-padding></md-content></md-tab><md-tab label=\"Aprobar y derivar\" md-on-select=\"data.accion=\'derivar\'\"><md-content layout=column class=md-padding><md-input-container><label>Usuario</label><md-select name=user ng-model=data._usuario_seleccionado required><md-option ng-repeat=\"us in data.usuarios\" ng-value=us.id_usuario>{{us.nombres+\' \'+us.apellidos}}<br>-{{us.cargo}}-</md-option></md-select></md-input-container><md-input-container style=width:100%><label>Proveído</label><textarea name=obs ng-model=data.observaciones md-maxlength=250 maxlength=250 rows=2 required></textarea></md-input-container></md-content></md-tab><md-tab label=\"Aprobar y cerrar\" md-on-select=\"data.accion=\'cerrar\'\"><md-content class=md-padding></md-content></md-tab><md-tab label=Observar md-on-select=\"data.accion=\'observar\'\"><md-content layout=column class=md-padding><md-input-container style=width:100%><label>Observaciones</label><textarea name=obs ng-model=data.observaciones md-maxlength=250 maxlength=250 rows=2 required></textarea></md-input-container></md-content></md-tab></md-tabs></div><div layout=column ng-if=data.es_derivar><div>Proveído de {{ data.usuario_proveido}}<br>{{data.dc.observaciones}}<div><br></div></div><md-input-container><label>Usuario</label><md-select name=user ng-model=data._usuario_seleccionado required><md-option ng-repeat=\"us in data.usuarios\" ng-value=us.id_usuario>{{us.nombres+\' \'+us.apellidos}}<br>-{{us.cargo}}-</md-option></md-select></md-input-container><md-input-container style=width:100%><label>Proveído</label><textarea name=obs ng-model=data.observaciones md-maxlength=250 maxlength=250 rows=2 required></textarea></md-input-container></div><div ng-if=data.sw_es_respuesta><div class=\"ap-text-center ap-text-warning\">Referencias:</div><div class=\"ap-text-center ap-text-warning\" ng-repeat=\"dg in data.docs_grupo\" ng-if=\"dg.id_documento!=data.dc.id_documento\">* {{dg.nombre_plantilla}} -- <span class=ap-cursor-pointer ng-click=verDocumento(dg.id_documento)>{{dg.nombre}}</span></div></div><div ng-show=data.flag_html bind-html-compile=data.html></div><iframe class=iframe-pdf src={{data.pdf}} style=\"width:100%; height:600px; border: none\" ng-if=\"data.show_pdf && !data.flag_html\" allowfullscreen></iframe><div id=canvasContainer ng-show=\"!data.show_pdf && !data.flag_html\"></div></md-dialog-content><md-dialog-actions><span flex></span><div ng-if=data.es_derivar><md-button class=\"ap md-raised bt-bg-warning\" ng-click=derivar() ng-disabled=\"obsForm.user.$invalid || obsForm.obs.$invalid\"><md-icon>check</md-icon>Derivar</md-button><md-button class=\"ap md-raised bt-bg-success\" ng-click=openSelect($event)><md-icon>error</md-icon>Crear documento</md-button><md-input-container style=\"transform: scale(0.01)\" ng-show=data.show_select><md-select name=plantilla ng-model=data._plantilla_seleccionada required ng-change=crear() md-on-close=\"data.show_select=false;\"><md-option ng-repeat=\"pla in data.plantillas_disponibles\" ng-value=pla>{{pla.nombre}} ({{pla.abreviacion}})</md-option></md-select></md-input-container></div><div ng-if=!data.es_derivar><md-button class=\"ap md-raised\" ng-class=\"{\'bt-bg-success\': data.es_para}\" ng-click=openSelect($event) ng-if=\"data.es_para && data.accion==\'crear\'\"><md-icon>error</md-icon>Crear documento</md-button><md-input-container style=\"transform: scale(0.01)\" ng-show=data.show_select><md-select name=plantilla ng-model=data._plantilla_seleccionada required ng-change=crear(true) md-on-close=\"data.show_select=false;\"><md-option ng-repeat=\"pla in data.plantillas_disponibles\" ng-value=pla>{{pla.nombre}} ({{pla.abreviacion}})</md-option></md-select></md-input-container><md-button class=\"ap md-raised\" ng-class=\"{\'bt-bg-warning\': data.es_para}\" ng-click=\"aprobar(\'derivar\')\" ng-disabled=\"obsForm.user.$invalid || obsForm.obs.$invalid\" ng-if=\"data.es_para && data.accion==\'derivar\'\"><md-icon>check</md-icon>Derivar</md-button><md-button class=\"ap md-raised\" ng-class=\"{\'bt-bg-info\': data.es_para, \'bt-bg-success\': !data.es_para}\" ng-disabled=!obsForm.obs.$invalid ng-click=\"aprobar(\'aprobar\')\" ng-if=\"!data.es_para || data.accion==\'cerrar\'\"><md-icon>check</md-icon>Aprobar</md-button><md-button class=\"ap md-raised bt-bg-danger\" ng-click=observar() ng-disabled=obsForm.obs.$invalid ng-if=\"!data.es_para || data.accion==\'observar\'\"><md-icon>error</md-icon>Observar</md-button></div><md-button class=md-raised ng-click=cerrar()><md-icon>cancel</md-icon>Cancelar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/plantillasFormly/aprobacion/modules.plantillasFormly.aprobacion.html","<div class=container><crud-table url=aprobacion.url title-table=aprobacion.titulo fields=aprobacion.fields usuario=aprobacion.usuario permission=aprobacion.permission buttons=aprobacion.buttons query-extra=aprobacion.queryExtra only-fields=true estado-checks=true estado-opciones=aprobacion.estadoOpciones></crud-table><br><br></div>");
$templateCache.put("app/modules/plantillasFormly/aprobarDocumento/modules.plantillasFormly.aprobarDocumento.html","<div class=container><crud-table-aprobacion url=aprobarDocumento.url title-table=aprobarDocumento.titulo fields=aprobarDocumento.fields usuario=aprobarDocumento.usuario permission=aprobarDocumento.permission buttons=aprobarDocumento.buttons only-fields=true items=aprobarDocumento.items habilitar-seleccion=firmar.habilitarSeleccion seleccionados=firmar.obtenerSeleccionados></crud-table-aprobacion></div>");
$templateCache.put("app/modules/plantillasFormly/catalogos/modules.plantillasFormly.catalogos.html","<div class=container><crud-table url=catalogos.url title-table=catalogos.titulo fields=catalogos.fields usuario=catalogos.usuario permission=catalogos.permissions buttons=catalogos.botones button-agregar=catalogos.botonAgregar head-buttons=catalogos.botonesCabecera only-fields=true habilitar-seleccion=true seleccionados=catalogos.escucharSeleccion items=catalogos.items></crud-table></div>");
$templateCache.put("app/modules/plantillasFormly/catalogos/propietario.dialog.html","<md-dialog aria-label=\"Cambiar propietario\" ng-cloak><form ng-submit=transferir()><md-toolbar><div class=md-toolbar-tools><h2><md-icon>people</md-icon>Cambiar propietario</h2><span flex></span></div></md-toolbar><md-dialog-content><div class=md-dialog-content><md-input-container class=input-search><label>Seleccionar propietario</label><md-select ng-model=usuario name=select_propietario required md-on-close=\"buscarPropietario=\'\'; \" data-md-container-class=select-search><md-select-header class=select-header flex><input ng-model=buscarPropietario placeholder=\"Buscar nuevo propietario...\" class=\"header-searchbox md-text\"></md-select-header><md-optgroup label=usuarios><md-option ng-value=u ng-repeat=\"u in usuarios | filter:buscarPropietario\">{{ u.nombres+\' \'+u.apellidos }}</md-option></md-optgroup></md-select></md-input-container><br><span>Documentos a transferir al nuevo propietario</span><ul><li ng-repeat=\"catalogo in listaCatalogos\">{{catalogo.nombre}}</li></ul></div></md-dialog-content><md-dialog-actions><div flex></div><md-button class=md-raised ng-click=cerrar()><md-icon>cancel</md-icon>Cancelar</md-button><md-button type=submit class=\"md-raised md-primary\" ng-disabled=form.$invalid><md-icon>check</md-icon>Transferir</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/plantillasFormly/compartidos/modules.plantillasFormly.compartidos.html","<div class=container><crud-table url=compartidos.url title-table=compartidos.titulo fields=compartidos.fields usuario=compartidos.usuario permission=compartidos.permissions buttons=compartidos.botones only-fields=true></crud-table></div>");
$templateCache.put("app/modules/plantillasFormly/contactos/dialog.contactos.html","<md-dialog ng-cloak class=\"formly-dialog formly-column-{{column}}\" style=\"max-width: 800px; width: 100%\"><form ng-submit=registrarContacto() name=contactoForm novalidate><md-toolbar><div class=md-toolbar-tools><h2><md-icon>business</md-icon>{{titulo}}</h2><span flex></span><md-button class=md-icon-button aria-label=Cerrar ng-click=cerrar()><md-tooltip>Cerrar</md-tooltip><md-icon>close</md-icon></md-button></div></md-toolbar><md-dialog-content><div layout><md-card flex><md-card-header><md-card-header-text><span class=md-title>Datos del contacto</span></md-card-header-text></md-card-header><md-card-content><md-input-container class=md-block><label>Grado</label><input ng-model=data.grado type=text><div ng-messages=contactoForm.grado.$error ng-show=contactoForm.grado.$dirty><div ng-message=required>Debe llenar este campo</div></div></md-input-container><md-input-container class=md-block><label>Nombres</label><input ng-model=data.nombres type=text required><div ng-messages=contactoForm.nombres.$error ng-show=contactoForm.nombres.$dirty><div ng-message=required>Debe llenar este campo</div></div></md-input-container><md-input-container class=md-block><label>Apellidos</label><input ng-model=data.apellidos type=text required><div ng-messages=contactoForm.apellidos.$error ng-show=contactoForm.apellidos.$dirty><div ng-message=required>Debe llenar este campo</div></div></md-input-container><md-input-container class=md-block><label>Cargo</label><input ng-model=data.cargo type=text><div ng-messages=contactoForm.cargo.$error ng-show=contactoForm.cargo.$dirty><div ng-message=required>Debe llenar este campo</div></div></md-input-container><md-input-container class=md-block><label>Teléfono/Celular</label><input ng-model=data.telefono type=text><div ng-messages=contactoForm.telefono.$error ng-show=contactoForm.telefono.$dirty><div ng-message=required>Debe llenar este campo</div></div></md-input-container><md-input-container class=md-block><label for=estado>Estado</label><md-select name=estado ng-model=data.estado placeholder=Estado required><md-option ng-value=item.id ng-repeat=\"item in estados\">{{ item.name }}</md-option></md-select><div ng-messages=contactoForm.estado.$error ng-show=contactoForm.estado.$dirty><div ng-message=required>Debe seleccionar una opción</div></div></md-input-container></md-card-content></md-card><md-card flex><md-card-header><md-card-header-text><span class=md-title>Datos de la entidad</span></md-card-header-text></md-card-header><md-card-content><md-input-container class=md-block><label>Entidad</label><input ng-model=data.entidad type=text required><div ng-messages=contactoForm.entidad.$error ng-show=contactoForm.entidad.$dirty><div ng-message=required>Debe llenar este campo</div></div></md-input-container><md-input-container class=md-block><label for=tipo_entidad>Tipo de entidad</label><md-select name=tipo_entidad ng-model=data.tipo_entidad placeholder=\"Tipo de entidad\" required><md-option ng-value=item.tipo_entidad ng-repeat=\"item in tiposEntidad\" ng-click=habilitarOtro(item)>{{ item.tipo_entidad }}</md-option></md-select><div ng-messages=contactoForm.tipo_entidad.$error ng-show=contactoForm.tipo_entidad.$dirty><div ng-message=required>Debe seleccionar una opción</div></div></md-input-container><md-input-container class=md-block ng-if=\"otroEditar==true\"><label>Tipo de entidad</label><input ng-model=data.otro_tipo type=text required><div ng-messages=contactoForm.otro_tipo.$error ng-show=contactoForm.otro_tipo.$dirty><div ng-message=required>Debe llenar este campo</div></div></md-input-container><md-input-container class=md-block><label>Sigla</label><input ng-model=data.sigla type=text><div ng-messages=contactoForm.sigla.$error ng-show=contactoForm.sigla.$dirty><div ng-message=required>Debe llenar este campo</div></div></md-input-container><md-input-container class=md-block><label>Dirección</label><input ng-model=data.direccion type=text required><div ng-messages=contactoForm.direccion.$error ng-show=contactoForm.direccion.$dirty><div ng-message=required>Debe llenar este campo</div></div></md-input-container><md-input-container class=md-block><label for=departamento>Departamento</label><md-select name=departamento ng-model=data.departamento placeholder=Departamento required><md-option ng-value=item.id ng-repeat=\"item in departamentos\">{{ item.name }}</md-option></md-select><div ng-messages=contactoForm.departamento.$error ng-show=contactoForm.departamento.$dirty><div ng-message=required>Debe seleccionar una opción</div></div></md-input-container></md-card-content></md-card></div></md-dialog-content><md-dialog-actions layout layout-padding><span flex></span><md-button type=submit class=\"md-raised md-primary\" ng-disabled=contactoForm.$invalid><md-icon>check</md-icon>Guardar</md-button><md-button type=button class=md-raised ng-click=cerrar()><md-icon>cancel</md-icon>Cancelar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/plantillasFormly/contactos/modules.plantillasFormly.contactos.html","<div class=container><crud-table url=contactos.url title-table=contactos.titulo fields=contactos.fields usuario=contactos.usuario dialog-controller=contactos.dialogController permission=contactos.permission order=contactos.order template=contactos.template></crud-table></div>");
$templateCache.put("app/modules/plantillasFormly/documentos/documento.dialog.html","<md-dialog aria-label=\"Elegir plantilla\" class=\"formly-dialog formly-column-{{column}}\" style=\"max-width: 600px; width: 100%\"><md-toolbar><div class=md-toolbar-tools><h2><md-icon>dashboard</md-icon>Elegir documento</h2><span flex></span></div></md-toolbar><p style=margin-left:10px>Seleccione un documento y haga click en aceptar:</p><md-input-container style=\"margin-left:10px !important\"><input ng-model=p.buscarPlantilla></md-input-container><md-dialog-content class=md-dialog-content><div flex layout><div flex></div><md-radio-group ng-model=plantilla_seleccionada><md-radio-button ng-repeat=\"p in plantillas_disponibles| filter:p.buscarPlantilla\" ng-value=p.id_plantilla_formly class=md-primary>{{p.nombre}} ({{p.abreviacion}})</md-radio-button></md-radio-group><div flex></div></div></md-dialog-content><md-dialog-actions><div flex></div><md-button class=\"md-raised md-primary\" ng-click=elegir()><md-icon>check</md-icon><span>Aceptar</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/plantillasFormly/documentos/modules.plantillasFormly.documentos.html","<div class=container><crud-table url=documentos.url title-table=documentos.titulo fields=documentos.fields usuario=documentos.usuario permission=documentos.permission buttons=documentos.buttons button-agregar=documentos.buttonAgregar only-fields=true estado-checks=true estado-opciones=documentos.estadoOpciones></crud-table><br><br></div>");
$templateCache.put("app/modules/plantillasFormly/enCurso/modules.plantillasFormly.enCurso.html","<div class=container><crud-table url=enCurso.url title-table=enCurso.titulo fields=enCurso.fields usuario=enCurso.usuario permission=enCurso.permission buttons=enCurso.buttons only-fields=true></crud-table><br><br></div>");
$templateCache.put("app/modules/plantillasFormly/firmar/modules.plantillasFormly.firmar.html","<div class=container><crud-table url=firmar.url title-table=firmar.titulo fields=firmar.fields usuario=firmar.usuario permission=firmar.permission buttons=firmar.buttons only-fields=true items=firmar.items seleccionados=firmar.obtenerSeleccionados habilitar-seleccion=firmar.habilitarSeleccion></crud-table><md-button class=\"md-raised md-primary\" ng-click=firmar.firmarDocumentos() ng-disabled=!firmar.habilitarBotonFirma><md-icon>done_all</md-icon><md-tooltip md-direction=right>Firmar Digitalmente</md-tooltip>Firmar</md-button><br></div>");
$templateCache.put("app/modules/plantillasFormly/impresion/modules.plantillasFormly.impresion.html","<div class=container><crud-table url=impresion.url title-table=impresion.titulo fields=impresion.fields usuario=impresion.usuario permission=impresion.permission buttons=impresion.buttons button-agregar=impresion.multiple query-extra=impresion.queryExtra estado-sw=true only-fields=true search-pro=true></crud-table><br><br></div>");
$templateCache.put("app/modules/plantillasFormly/impresion/multiple.dialog.html","<md-dialog aria-label=\"Impresion multiple\" class=\"formly-dialog formly-column-{{column}}\" style=\"max-width: 600px; width: 100%\"><md-toolbar><div class=md-toolbar-tools><h2><md-icon>print</md-icon>Impresion multiple</h2><span flex></span><md-button class=\"md-icon-button md-toast-button-close\" ng-click=cancel()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content class=md-dialog-content><form name=multipleForm ng-submit=obtenerDocumento()><div flex layout><md-input-container class=md-block flex-gt-sm><label>Escríba el cite de un documento multiple</label><input ng-model=cite type=text required></md-input-container><md-button class=\"md-fab md-mini md-primary\" type=submit ng-disabled=multipleForm.$invalid><md-icon>search</md-icon></md-button><!-- <md-button class=\"md-fab md-mini md-primary\" ng-click=\"obtenerDocumento()\">\n          <md-icon>search</md-icon>\n        </md-button> --></div></form><iframe class=iframe-pdf src={{documentoAImprimir.url}} style=\"width:100%; height:600px; border: none\" ng-if=documentoAImprimir.url allowfullscreen></iframe></md-dialog-content></md-dialog>");
$templateCache.put("app/modules/plantillasFormly/monitoreo/dialogPresupuestoPDF.html","<md-dialog aria-label=\"Documento PDF\" class=\"formly-dialog formly-column-{{column}} dialog-pdf\" style=\"max-width: 800px; width: 100%\"><md-toolbar><div class=md-toolbar-tools><h2><md-icon>picture_as_pdf</md-icon>Vista previa</h2><span flex></span><md-button class=md-icon-button aria-label=\"Ver pdf\" ng-click=verPdf() ng-show=data.flag_html><md-tooltip>Ver PDF</md-tooltip><md-icon aria-label=\"Close dialog\">picture_as_pdf</md-icon></md-button><md-button class=md-icon-button aria-label=\"Ver html\" ng-click=verHtml() ng-show=!data.flag_html><md-tooltip>Ver html</md-tooltip><md-icon aria-label=\"Close dialog\">code</md-icon></md-button><md-button class=md-icon-button aria-label=Cerrar ng-click=cerrar()><md-tooltip>Cerrar</md-tooltip><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content class=md-dialog-content><iframe class=iframe-pdf src={{data.pdf}} style=\"width:100%; height:600px; border: none\" ng-if=\"data.show_pdf && !data.flag_html\" allowfullscreen></iframe><div id=canvasContainer ng-show=\"!data.show_pdf && !data.flag_html\"></div><div ng-if=false><p>Tu navegador web no puede visualizar archivos PDF. Pero tu puedes hacer <a ng-href={{data.pdf}} target=_blank>click aqui para descargar el PDF</a></p></div></md-dialog-content><md-dialog-actions><span flex></span><md-button class=md-raised ng-click=cerrar()><md-icon>cancel</md-icon>Cancelar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/plantillasFormly/monitoreo/modules.plantillasFormly.monitoreo.html","<div class=\"container container-monitoreo\"><md-card><md-toolbar class=md-table-toolbar><div class=md-toolbar-tools><md-icon>grid_on</md-icon><span>Monitoreo</span><div flex></div><md-button class=md-icon-button ng-click=monitoreo.refrescarChart()><md-tooltip>Actualizar</md-tooltip><md-icon>refresh</md-icon></md-button><md-button class=\"md-icon-button btn-collapsed\"><md-tooltip>Ocultar/Ver</md-tooltip><md-icon>keyboard_arrow_down</md-icon></md-button></div></md-toolbar><md-card-content><div layout=column layout-gt-sm style=\"margin-top: 15px\"><div><md-input-container><label>Gráfico</label><md-select ng-model=monitoreo.grafico placeholder=\"Selecciona que grafico ver\" ng-change=monitoreo.reiniciarChart()><md-option ng-value=g ng-repeat=\"g in monitoreo.graficos\">{{g.nombre}}</md-option></md-select></md-input-container><md-input-container ng-if=\"monitoreo.grafico.cod==4 || monitoreo.grafico.cod==7 || monitoreo.grafico.cod==8\"><label>Gestión</label><md-select ng-model=monitoreo.gestion ng-change=monitoreo.refrescarChart()><md-option ng-value=$index ng-repeat=\"a in monitoreo.gestiones\">{{a.gestion}}</md-option></md-select></md-input-container><md-input-container ng-if=\"[4, 5, 6, 7, 8, 9].indexOf(monitoreo.grafico.cod) == -1\"><label>Año</label><md-select ng-model=monitoreo.anio ng-change=monitoreo.refrescarChart()><md-option ng-value=$index ng-repeat=\"a in monitoreo.anios\">{{a}}</md-option></md-select></md-input-container><md-input-container ng-if=\"monitoreo.grafico.cod === 9\"><label>Año</label><md-select ng-model=monitoreo.anioContable ng-change=monitoreo.refrescarChart()><md-option ng-value=$index ng-repeat=\"a in monitoreo.aniosContables\">{{a}}</md-option></md-select></md-input-container><md-input-container ng-if=\"monitoreo.grafico.cod!==4 && monitoreo.grafico.cod!=5 && monitoreo.grafico.cod!=6 && monitoreo.grafico.cod!=7 && monitoreo.grafico.cod!=8 && monitoreo.grafico.cod!=9\"><label>Mes</label><md-select ng-model=monitoreo.mes ng-change=monitoreo.refrescarChart()><md-option ng-value=$index ng-repeat=\"m in monitoreo.meses\">{{m}}</md-option></md-select></md-input-container><md-input-container ng-if=\"monitoreo.grafico.cod===9\"><label>Tipo documento</label><md-select ng-model=monitoreo.tipoInformePago ng-change=monitoreo.refrescarChart()><md-option ng-value=$index ng-repeat=\"m in monitoreo.docsContables\">{{m}}</md-option></md-select></md-input-container><md-input-container class=input-search ng-if=\"monitoreo.grafico.cod==3\"><label>Usuarios</label><md-select ng-model=monitoreo.usuario ng-change=monitoreo.refrescarChart()><md-option ng-value=u.id_usuario ng-repeat=\"u in monitoreo.usuarios | filter:monitoreo.usuario_buscar\">{{u.usuario}}</md-option></md-select></md-input-container><md-input-container class=input-search ng-if=\"monitoreo.grafico.cod==3\"><label>Nombres</label><md-select ng-model=monitoreo.usuario ng-change=monitoreo.refrescarChart()><md-option ng-value=u.id_usuario ng-repeat=\"u in monitoreo.usuarios | filter:monitoreo.usuario_buscar\">{{u.nombres}} {{u.apellidos}}</md-option></md-select></md-input-container><div class=paginador ng-if=\"[0, 4, 5, 6, 7, 8, 9].indexOf(monitoreo.grafico.cod) == -1 \"><!-- <div class=\"paginador\" ng-if=\"monitoreo.grafico.cod!=0 && monitoreo.grafico.cod!=4 && monitoreo.grafico.cod!=5 && monitoreo.grafico.cod!=6 && monitoreo.grafico.cod!=7 && monitoreo.grafico.cod!=8\"> --><md-button ng-click=\"monitoreo.paginar(\'aa\')\" ng-disabled=\"monitoreo.page<=1\"><md-icon>first_page</md-icon></md-button><md-button ng-click=\"monitoreo.paginar(\'a\')\" ng-disabled=\"monitoreo.page<=1\"><md-icon>chevron_left</md-icon></md-button><md-input-container><label>Intervalo</label><input ng-model=monitoreo.page_text size=7 disabled></md-input-container><md-button ng-click=\"monitoreo.paginar(\'s\')\" ng-disabled=\"monitoreo.page*20>=monitoreo.page_tot\"><md-icon>chevron_right</md-icon></md-button><md-button ng-click=\"monitoreo.paginar(\'ss\')\" ng-disabled=\"monitoreo.page*20>=monitoreo.page_tot\"><md-icon>last_page</md-icon></md-button></div><md-input-container ng-if=\"monitoreo.grafico.cod==5\"><label>Fecha Inicial</label><md-datepicker ng-model=monitoreo.fechaInicial md-placeholder=\"Fecha Inicial\" ng-change=monitoreo.reiniciarChart()></md-datepicker></md-input-container><md-input-container ng-if=\"monitoreo.grafico.cod==5\"><label>Fecha Final</label><md-datepicker ng-model=monitoreo.fechaFinal md-placeholder=\"Fecha Final\" ng-change=monitoreo.reiniciarChart()></md-datepicker></md-input-container></div><div flex></div><div style=float:right ng-if=\"monitoreo.grafico.cod==4 \"><md-button class=\"md-fab md-primary\" ng-csv=monitoreo.filasPresupuesto() field-separator=| csv-header=monitoreo.cabeceraPresupuesto() filename=Presupuesto.csv><md-icon>library_books</md-icon><md-tooltip md-direction=left>Exportar a CSV</md-tooltip></md-button><md-button class=\"md-fab md-primary\" ng-click=monitoreo.generarPDF()><md-icon>picture_as_pdf</md-icon><md-tooltip md-direction=left>Exportar a PDF</md-tooltip></md-button></div><div style=float:right ng-if=\"monitoreo.grafico.cod===9 \"><md-button class=\"md-fab md-primary\" ng-csv=monitoreo.filasPresupuesto() field-separator=| csv-header=monitoreo.cabeceraPresupuesto() filename=\"{{monitoreo.generarNombre(\'ABC\')}}.csv\"><md-icon>library_books</md-icon><md-tooltip md-direction=left>Exportar a CSV</md-tooltip></md-button></div></div><div layout layout-align=\"center start\" ng-if=\"[4, 5, 6, 7, 8, 9].indexOf(monitoreo.grafico.cod) == -1\"><chart-graph ancho=1000 alto=500 tipo=monitoreo.chart.tipo datos=monitoreo.chart.datos actualizar=monitoreo.chart.actualizar reiniciar=monitoreo.chart.reiniciar></chart-graph></div><!--Presupuesto--><div ng-if=\"monitoreo.grafico.cod==4\"><div flex style=float:right><md-checkbox ng-repeat=\"header in monitoreo.headers\" ng-model=header.mostrar aria-label=Mostrar/Ocultar ng-if=!header.mostrar>{{header.title}}</md-checkbox></div><md-table-container><table md-table ng-model=selected md-progress=promise><thead md-head><tr md-row><th ng-repeat=\"header in monitoreo.headers\" md-column ng-if=header.mostrar><span><md-checkbox ng-model=header.mostrar aria-label=Mostrar/Ocultar></md-checkbox><md-tooltip md-direction=bottom>Ocultar esta columna</md-tooltip><md-button ng-click=\"monitoreo.ordenarPor = header.name;  monitoreo.ordenInverso = !monitoreo.ordenInverso\">{{header.title}}<md-icon ng-show=\"monitoreo.ordenarPor == header.name && !monitoreo.ordenInverso\">keyboard_arrow_down</md-icon><md-icon ng-show=\"monitoreo.ordenarPor == header.name && monitoreo.ordenInverso\">keyboard_arrow_up</md-icon></md-button></span><md-input-container class=md-block flex-gt-sm ng-show=\"header.name === \'numero\'\"><input ng-model=monitoreo.busqueda.numero></md-input-container><md-input-container class=md-block flex-gt-sm ng-show=\"header.name === \'descripcion\'\"><input ng-model=monitoreo.busqueda.descripcion></md-input-container><div style=\"height: 65px; width: 20px; border: 0px solid red\" ng-show=\"header.name !== \'descripcion\' && header.name !== \'numero\'\"></div></th></tr></thead><tbody md-body><tr md-row md-select=item ng-repeat=\"item in monitoreo.items | orderBy:monitoreo.ordenarPor:monitoreo.ordenInverso | filter:monitoreo.busqueda\"><td md-cell ng-if=\"monitoreo.mostrarOcultar(\'numero\')\" style=\"text-align: right\">{{item.numero.replace(\',00\', \'\') }}</td><td md-cell ng-if=\"monitoreo.mostrarOcultar(\'descripcion\')\">{{item.descripcion}}</td><td md-cell ng-if=\"monitoreo.mostrarOcultar(\'inicial\')\" style=\"text-align: right\">{{item.inicial}}</td><td md-cell ng-if=\"monitoreo.mostrarOcultar(\'comprometido\')\" style=\"text-align: right\">{{item.comprometido}}</td><td md-cell ng-if=\"monitoreo.mostrarOcultar(\'pagado\')\" style=\"text-align: right\">{{item.pagado}}</td><td md-cell ng-if=\"monitoreo.mostrarOcultar(\'modificado\')\" style=\"text-align: right\">{{item.modificado}}</td><td md-cell ng-if=\"monitoreo.mostrarOcultar(\'vigente\')\" style=\"text-align: right\">{{item.vigente}}</td><td md-cell ng-if=\"monitoreo.mostrarOcultar(\'saldo\')\" style=\"text-align: right\">{{item.saldo}}</td></tr></tbody></table></md-table-container></div><!--Documentos por estado y usuario--><div ng-if=\"monitoreo.grafico.cod==5\"><md-table-container><table md-table ng-model=selected md-progress=promise><thead md-head><tr md-row><th md-column><md-button ng-click=\"monitoreo.ordenarPor = \'nombres\'; monitoreo.ordenInverso = !monitoreo.ordenInverso\">Usuario<md-icon ng-show=\"monitoreo.ordenarPor == \'nombres\' && !monitoreo.ordenInverso\">keyboard_arrow_down</md-icon><md-icon ng-show=\"monitoreo.ordenarPor == \'nombres\' && monitoreo.ordenInverso\">keyboard_arrow_up</md-icon></md-button></th><th md-column><md-button ng-click=\"monitoreo.ordenarPor = \'CREADO\'; monitoreo.ordenInverso = !monitoreo.ordenInverso\">Creados<md-icon ng-show=\"monitoreo.ordenarPor == \'CREADO\' && !monitoreo.ordenInverso\">keyboard_arrow_down</md-icon><md-icon ng-show=\"monitoreo.ordenarPor == \'CREADO\' && monitoreo.ordenInverso\">keyboard_arrow_up</md-icon></md-button></th><th md-column><md-button ng-click=\"monitoreo.ordenarPor=\'ENVIADO\'; monitoreo.ordenInverso = !monitoreo.ordenInverso\">Enviados<md-icon ng-show=\"monitoreo.ordenarPor == \'ENVIADO\' && !monitoreo.ordenInverso\">keyboard_arrow_down</md-icon><md-icon ng-show=\"monitoreo.ordenarPor == \'ENVIADO\' && monitoreo.ordenInverso\">keyboard_arrow_up</md-icon></md-button></th><th md-column><md-button ng-click=\"monitoreo.ordenarPor=\'DERIVADO\'; monitoreo.ordenInverso = !monitoreo.ordenInverso\">Derivados<md-icon ng-show=\"monitoreo.ordenarPor == \'DERIVADO\' && !monitoreo.ordenInverso\">keyboard_arrow_down</md-icon><md-icon ng-show=\"monitoreo.ordenarPor == \'DERIVADO\' && monitoreo.ordenInverso\">keyboard_arrow_up</md-icon></md-button></th><th md-column><md-button ng-click=\"monitoreo.ordenarPor=\'APROBADO\'; monitoreo.ordenInverso = !monitoreo.ordenInverso\">Aprobados<md-icon ng-show=\"monitoreo.ordenarPor == \'APROBADO\' && !monitoreo.ordenInverso\">keyboard_arrow_down</md-icon><md-icon ng-show=\"monitoreo.ordenarPor == \'APROBADO\' && monitoreo.ordenInverso\">keyboard_arrow_up</md-icon></md-button></th><th md-column><md-button ng-click=\"monitoreo.ordenarPor=\'RECHAZADO\'; monitoreo.ordenInverso = !monitoreo.ordenInverso\">Rechazados<md-icon ng-show=\"monitoreo.ordenarPor == \'RECHAZADO\' && !monitoreo.ordenInverso\">keyboard_arrow_down</md-icon><md-icon ng-show=\"monitoreo.ordenarPor == \'RECHAZADO\' && monitoreo.ordenInverso\">keyboard_arrow_up</md-icon></md-button></th><th md-column><md-button ng-click=\"monitoreo.ordenarPor=\'CERRADO\'; monitoreo.ordenInverso = !monitoreo.ordenInverso\">Cerrados<md-icon ng-show=\"monitoreo.ordenarPor == \'CERRADO\' && !monitoreo.ordenInverso\">keyboard_arrow_down</md-icon><md-icon ng-show=\"monitoreo.ordenarPor == \'CERRADO\' && monitoreo.ordenInverso\">keyboard_arrow_up</md-icon></md-button></th><th md-column><md-button ng-click=\"monitoreo.ordenarPor=\'ELIMINADO\'; monitoreo.ordenInverso = !monitoreo.ordenInverso\">Eliminados<md-icon ng-show=\"monitoreo.ordenarPor == \'ELIMINADO\' && !monitoreo.ordenInverso\">keyboard_arrow_down</md-icon><md-icon ng-show=\"monitoreo.ordenarPor == \'ELIMINADO\' && monitoreo.ordenInverso\">keyboard_arrow_up</md-icon></md-button></th></tr></thead><tbody md-body><tr md-row md-select=item ng-repeat=\"item in monitoreo.estados | orderBy:monitoreo.ordenarPor:monitoreo.ordenInverso \"><td md-cell>{{item.nombres}} {{item.apellidos}}</td><td md-cell style=\"text-align: left; padding-left:20px; background-color: rgb({{255-item.CREADO}}, 255 ,{{255+item.CREADO}})\">{{item.CREADO}}</td><td md-cell style=\"text-align: left; padding-left:20px; background-color: rgb({{255-item.ENVIADO}}, 255 , {{255+item.ENVIADO}})\">{{item.ENVIADO}}</td><td md-cell style=\"text-align: left; padding-left:20px; background-color: rgb({{255-item.DERIVADO}}, 255 ,{{255+item.DERIVADO}})\">{{item.DERIVADO}}</td><td md-cell style=\"text-align: left; padding-left:20px; background-color: rgb({{255-item.APROBADO}}, 255 ,{{255+item.APROBADO}})\">{{item.APROBADO}}</td><td md-cell style=\"text-align: left; padding-left:20px; background-color: rgb({{255-item.RECHAZADO}}, 255 ,{{255+item.RECHAZADO}})\">{{item.RECHAZADO}}</td><td md-cell style=\"text-align: left; padding-left:20px; background-color: rgb({{255-item.CERRADO}}, 255 ,{{255+item.CERRADO}})\">{{item.CERRADO}}</td><td md-cell style=\"text-align: left; padding-left:20px; background-color: rgb({{255-item.ELIMINADO}}, 255 ,{{255+item.ELIMINADO}})\">{{item.ELIMINADO}}</td></tr></tbody></table></md-table-container></div><!--Documentos pendientes por usuario--><div ng-if=\"monitoreo.grafico.cod==6\"><md-table-container><table md-table ng-model=selected md-progress=promise><thead md-head><tr md-row><th md-column><md-button ng-click=\"monitoreo.ordenarPor=\'nombres\'; monitoreo.ordenInverso = !monitoreo.ordenInverso\">Usuario<md-icon ng-show=\"monitoreo.ordenarPor == \'nombres\' && !monitoreo.ordenInverso\">keyboard_arrow_down</md-icon><md-icon ng-show=\"monitoreo.ordenarPor == \'nombres\' && monitoreo.ordenInverso\">keyboard_arrow_up</md-icon></md-button></th><th md-column><md-button ng-click=\"monitoreo.ordenarPor=\'ENVIADO\'; monitoreo.ordenInverso = !monitoreo.ordenInverso\">Enviados<md-icon ng-show=\"monitoreo.ordenarPor == \'ENVIADO\' && !monitoreo.ordenInverso\">keyboard_arrow_down</md-icon><md-icon ng-show=\"monitoreo.ordenarPor == \'ENVIADO\' && monitoreo.ordenInverso\">keyboard_arrow_up</md-icon></md-button></th><th md-column><md-button ng-click=\"monitoreo.ordenarPor=\'RECHAZADO\'; monitoreo.ordenInverso = !monitoreo.ordenInverso\">Rechazados<md-icon ng-show=\"monitoreo.ordenarPor == \'RECHAZADO\' && !monitoreo.ordenInverso\">keyboard_arrow_down</md-icon><md-icon ng-show=\"monitoreo.ordenarPor == \'RECHAZADO\' && monitoreo.ordenInverso\">keyboard_arrow_up</md-icon></md-button></th><th md-column><md-button ng-click=\"monitoreo.ordenarPor=\'DERIVADO\'; monitoreo.ordenInverso = !monitoreo.ordenInverso\">Derivados<md-icon ng-show=\"monitoreo.ordenarPor == \'DERIVADO\' && !monitoreo.ordenInverso\">keyboard_arrow_down</md-icon><md-icon ng-show=\"monitoreo.ordenarPor == \'DERIVADO\' && monitoreo.ordenInverso\">keyboard_arrow_up</md-icon></md-button></th><th md-column><md-button ng-click=\"monitoreo.ordenarPor=\'total\'; monitoreo.ordenInverso = !monitoreo.ordenInverso\">Total pendientes<md-icon ng-show=\"monitoreo.ordenarPor == \'total\' && !monitoreo.ordenInverso\">keyboard_arrow_down</md-icon><md-icon ng-show=\"monitoreo.ordenarPor == \'total\' && monitoreo.ordenInverso\">keyboard_arrow_up</md-icon></md-button></th></tr></thead><tbody md-body><tr md-row md-select=item ng-repeat=\"item in monitoreo.pendientes | orderBy:monitoreo.ordenarPor:monitoreo.ordenInverso \"><td md-cell>{{item.nombres}} {{item.apellidos}}</td><td md-cell>{{item.ENVIADO}}</td><td md-cell>{{item.RECHAZADO}}</td><td md-cell>{{item.DERIVADO}}</td><td md-cell>{{item.total}}</td></tr></tbody></table></md-table-container></div><!--Comprometido--><div ng-if=\"monitoreo.grafico.cod==7\"><md-table-container><table md-table ng-model=selected md-progress=promise><thead md-head><tr md-row><th md-column><md-button ng-click=\"monitoreo.ordenarPor=\'numero\'; monitoreo.ordenInverso = !monitoreo.ordenInverso\">Número<md-icon ng-show=\"monitoreo.ordenarPor == \'numero\' && !monitoreo.ordenInverso\">keyboard_arrow_down</md-icon><md-icon ng-show=\"monitoreo.ordenarPor == \'numero\' && monitoreo.ordenInverso\">keyboard_arrow_up</md-icon></md-button><md-input-container class=md-block flex-gt-sm><input ng-model=monitoreo.busqueda.numero></md-input-container></th><th md-column><md-button ng-click=\"monitoreo.ordenarPor=\'descripcion\'; monitoreo.ordenInverso = !monitoreo.ordenInverso\">Descripción<md-icon ng-show=\"monitoreo.ordenarPor == \'descripcion\' && !monitoreo.ordenInverso\">keyboard_arrow_down</md-icon><md-icon ng-show=\"monitoreo.ordenarPor == \'descripcion\' && monitoreo.ordenInverso\">keyboard_arrow_up</md-icon></md-button><md-input-container class=md-block flex-gt-sm><input ng-model=monitoreo.busqueda.descripcion></md-input-container></th><th md-column><md-button ng-click=\"monitoreo.ordenarPor=\'monto\'; monitoreo.ordenInverso = !monitoreo.ordenInverso\">Monto<md-icon ng-show=\"monitoreo.ordenarPor == \'monto\' && !monitoreo.ordenInverso\">keyboard_arrow_down</md-icon><md-icon ng-show=\"monitoreo.ordenarPor == \'monto\' && monitoreo.ordenInverso\">keyboard_arrow_up</md-icon></md-button><div style=\"height: 65px; width: 20px; border: 0px solid red\"></div></th><th md-column><md-button ng-click=\"monitoreo.ordenarPor=\'cite\'; monitoreo.ordenInverso = !monitoreo.ordenInverso\">Documento relacionado<md-icon ng-show=\"monitoreo.ordenarPor == \'cite\' && !monitoreo.ordenInverso\">keyboard_arrow_down</md-icon><md-icon ng-show=\"monitoreo.ordenarPor == \'cite\' && monitoreo.ordenInverso\">keyboard_arrow_up</md-icon></md-button><div style=\"height: 65px; width: 20px; border: 0px solid red\"></div></th><th md-column><md-button ng-click=\"monitoreo.ordenarPor=\'_fecha_creacion\'; monitoreo.ordenInverso = !monitoreo.ordenInverso\">Fecha del comprometido<md-icon ng-show=\"monitoreo.ordenarPor == \'_fecha_creacion\' && !monitoreo.ordenInverso\">keyboard_arrow_down</md-icon><md-icon ng-show=\"monitoreo.ordenarPor == \'_fecha_creacion\' && monitoreo.ordenInverso\">keyboard_arrow_up</md-icon></md-button><md-input-container class=md-block flex-gt-sm><input ng-model=monitoreo.busqueda._fecha_creacion></md-input-container></th></tr></thead><tbody md-body><tr md-row md-select=item ng-repeat=\"item in monitoreo.comprometido | orderBy:monitoreo.ordenarPor:monitoreo.ordenInverso | filter:monitoreo.busqueda\"><td md-cell style=\"text-align: right\">{{item.numero}}</td><td md-cell>{{item.descripcion}}</td><td md-cell style=\"text-align: right\">{{item.monto}}</td><td md-cell><md-button ng-click=monitoreo.vistaPrevia(item.id_documento)>{{item.cite}}</md-button></td><td md-cell>{{item._fecha_creacion |date:\'dd/MM/yyyy\'}}</td></tr></tbody></table></md-table-container></div><!--Pagado--><div ng-if=\"monitoreo.grafico.cod==8\"><md-table-container><table md-table ng-model=selected md-progress=promise><thead md-head><tr md-row><th md-column><md-button ng-click=\"monitoreo.ordenarPor=\'numero\'; monitoreo.ordenInverso = !monitoreo.ordenInverso\">Número<md-icon ng-show=\"monitoreo.ordenarPor == \'numero\' && !monitoreo.ordenInverso\">keyboard_arrow_down</md-icon><md-icon ng-show=\"monitoreo.ordenarPor == \'numero\' && monitoreo.ordenInverso\">keyboard_arrow_up</md-icon></md-button><md-input-container class=md-block flex-gt-sm><input ng-model=monitoreo.busqueda.numero></md-input-container></th><th md-column><md-button ng-click=\"monitoreo.ordenarPor=\'descripcion\'; monitoreo.ordenInverso = !monitoreo.ordenInverso\">Descripción<md-icon ng-show=\"monitoreo.ordenarPor == \'descripcion\' && !monitoreo.ordenInverso\">keyboard_arrow_down</md-icon><md-icon ng-show=\"monitoreo.ordenarPor == \'descripcion\' && monitoreo.ordenInverso\">keyboard_arrow_up</md-icon></md-button><md-input-container class=md-block flex-gt-sm><input ng-model=monitoreo.busqueda.descripcion></md-input-container></th><th md-column><md-button ng-click=\"monitoreo.ordenarPor=\'monto\'; monitoreo.ordenInverso = !monitoreo.ordenInverso\">Monto<md-icon ng-show=\"monitoreo.ordenarPor == \'monto\' && !monitoreo.ordenInverso\">keyboard_arrow_down</md-icon><md-icon ng-show=\"monitoreo.ordenarPor == \'monto\' && monitoreo.ordenInverso\">keyboard_arrow_up</md-icon></md-button><div style=\"height: 65px; width: 20px; border: 0px solid red\"></div></th><th md-column><md-button ng-click=\"monitoreo.ordenarPor=\'cite_ref\'; monitoreo.ordenInverso = !monitoreo.ordenInverso\">Documento relacionado<md-icon ng-show=\"monitoreo.ordenarPor == \'cite_ref\' && !monitoreo.ordenInverso\">keyboard_arrow_down</md-icon><md-icon ng-show=\"monitoreo.ordenarPor == \'cite_ref\' && monitoreo.ordenInverso\">keyboard_arrow_up</md-icon></md-button><div style=\"height: 65px; width: 20px; border: 0px solid red\"></div></th><th md-column><md-button ng-click=\"monitoreo.ordenarPor=\'_fecha_creacion\'; monitoreo.ordenInverso = !monitoreo.ordenInverso\">Fecha del comprometido<md-icon ng-show=\"monitoreo.ordenarPor == \'_fecha_creacion\' && !monitoreo.ordenInverso\">keyboard_arrow_down</md-icon><md-icon ng-show=\"monitoreo.ordenarPor == \'_fecha_creacion\' && monitoreo.ordenInverso\">keyboard_arrow_up</md-icon></md-button><md-input-container class=md-block flex-gt-sm><input ng-model=monitoreo.busqueda._fecha_creacion></md-input-container></th></tr></thead><tbody md-body><tr md-row md-select=item ng-repeat=\"item in monitoreo.pagado | orderBy:monitoreo.ordenarPor:monitoreo.ordenInverso | filter:monitoreo.busqueda\"><td md-cell style=\"text-align: right\">{{item.numero}}</td><td md-cell>{{item.descripcion}}</td><td md-cell style=\"text-align: right\">{{item.monto}}</td><td md-cell><md-button ng-click=monitoreo.vistaPrevia(item.id_documento)>{{item.cite_ref}}</md-button></td><td md-cell>{{item._fecha_creacion |date:\'dd/MM/yyyy\'}}</td></tr></tbody></table></md-table-container></div><div ng-if=\"monitoreo.grafico.cod===9\"><div class=infoContable><div><strong>IPV</strong>: Informe de pago de viáticos</div><div><strong>IPBS</strong>: Informe de pago de bienes y servicios</div><div><strong>IPSPCL-A</strong>: Informe de pago de servicios personales y consultorias de linea</div></div><div flex style=float:right><md-checkbox ng-repeat=\"header in monitoreo.headers\" ng-model=header.mostrar aria-label=Mostrar/Ocultar ng-if=!header.mostrar>{{header.title}}</md-checkbox></div><md-table-container><table md-table ng-model=selected md-progress=promise><thead md-head><tr md-row><th ng-repeat=\"header in monitoreo.headers\" md-column ng-if=header.mostrar><span><md-checkbox ng-model=header.mostrar aria-label=Mostrar/Ocultar></md-checkbox><md-tooltip md-direction=bottom>Ocultar esta columna</md-tooltip><md-button ng-click=\"monitoreo.ordenarPor = header.name;  monitoreo.ordenInverso = !monitoreo.ordenInverso\">{{header.title}}<md-icon ng-show=\"monitoreo.ordenarPor == header.name && !monitoreo.ordenInverso\">keyboard_arrow_down</md-icon><md-icon ng-show=\"monitoreo.ordenarPor == header.name && monitoreo.ordenInverso\">keyboard_arrow_up</md-icon></md-button></span><md-input-container class=md-block flex-gt-sm ng-show=\"header.name === \'cite\'\"><input ng-model=monitoreo.busqueda.cite></md-input-container><md-input-container class=md-block flex-gt-sm ng-show=\"header.name === \'detalle\'\"><input ng-model=monitoreo.busqueda.detalle></md-input-container><div style=\"height: 65px; width: 20px; border: 0px solid red\" ng-show=\"header.name !== \'detalle\' && header.name !== \'cite\'\"></div></th></tr></thead><tbody md-body><tr md-row md-select=item ng-repeat=\"item in monitoreo.items | orderBy:monitoreo.ordenarPor:monitoreo.ordenInverso | filter:monitoreo.busqueda\"><td md-cell ng-if=\"monitoreo.mostrarOcultar(\'cite\')\" style=\"text-align: right\">{{item.cite}}</td><td md-cell ng-if=\"monitoreo.mostrarOcultar(\'detalle\')\">{{item.detalle}}</td><td md-cell ng-if=\"monitoreo.mostrarOcultar(\'c31\')\" style=\"text-align: right\">{{item.c31}}</td><td md-cell ng-if=\"monitoreo.mostrarOcultar(\'importe\')\" style=\"text-align: right\">{{item.importe}}</td></tr></tbody></table></md-table-container></div><br><br></md-card-content></md-card></div>");
$templateCache.put("app/modules/plantillasFormly/plantillas/modules.plantillasFormly.plantillas.html","<div class=container><crud-table url=plantillas.url title-table=plantillas.titulo fields=plantillas.fields usuario=plantillas.usuario permission=plantillas.permission buttons=plantillas.buttons query-extra=plantillas.queryExtra button-agregar=plantillas.buttonAgregar estado-sw=plantillas.estadoSw only-fields=true></crud-table></div>");
$templateCache.put("app/modules/plantillasFormly/vistaPdf/modules.plantillasFormly.vistaPdf.html","<div class=container><div layout layout-align=\"center start\"><md-card flex-gt-sm=50 flex><md-toolbar><div class=md-toolbar-tools><h2><md-icon>picture_as_pdf</md-icon>Vista previa</h2><span flex></span><md-button class=md-icon-button aria-label=\"Ver pdf\" ng-click=vistaPdf.verPdf() ng-show=vistaPdf.flag_html><md-tooltip>Ver PDF</md-tooltip><md-icon aria-label=\"Close dialog\">picture_as_pdf</md-icon></md-button><md-button class=md-icon-button aria-label=\"Ver html\" ng-click=vistaPdf.verHtml() ng-show=!vistaPdf.flag_html><md-tooltip>Ver html</md-tooltip><md-icon aria-label=\"Close dialog\">code</md-icon></md-button></div></md-toolbar><md-card-content><div ng-show=vistaPdf.flag_html bind-html-compile=vistaPdf.html></div><iframe class=iframe-pdf src={{vistaPdf.pdf}} style=\"width:100%; height:600px; border: none\" ng-if=\"vistaPdf.show_pdf && !vistaPdf.flag_html\" allowfullscreen></iframe><div id=canvasContainer ng-show=\"!vistaPdf.show_pdf && !vistaPdf.flag_html\"></div></md-card-content></md-card></div></div>");
$templateCache.put("app/modules/seguridad/menu/modules.seguridad.menu.html","<div class=container><crud-table url=menu.url title-table=menu.titulo fields=menu.fields usuario=menu.usuario></crud-table></div>");
$templateCache.put("app/modules/seguridad/rol/dialog.rol.html","<md-dialog ng-cloak class=\"formly-dialog formly-column-{{column}}\" style=\"max-width: 800px; width: 100%\"><form ng-submit=registrarRol() name=rolForm novalidate><md-toolbar><div class=md-toolbar-tools><h2><md-icon>business</md-icon>{{data.id_rol == null ? \"Agregar\" : \"Editar\"}}</h2><span flex></span><md-button class=md-icon-button aria-label=Cerrar ng-click=cerrar()><md-tooltip>Cerrar</md-tooltip><md-icon>close</md-icon></md-button></div></md-toolbar><md-dialog-content><div layout><md-card flex><md-card-header><md-card-header-text><span class=md-title>Datos del rol</span></md-card-header-text></md-card-header><md-card-content><md-input-container class=md-block><label>Nombre</label><input ng-model=data.nombre type=text required><div ng-messages=rolForm.nombre.$error ng-show=rolForm.nombre.$dirty><div ng-message=required>Debe llenar este campo</div></div></md-input-container><md-input-container class=md-block><label>Descripcion</label><input ng-model=data.descripcion type=text required><div ng-messages=rolForm.descripcion.$error ng-show=rolForm.descripcion.$dirty><div ng-message=required>Debe llenar este campo</div></div></md-input-container><md-input-container class=md-block><label>Peso</label><input ng-model=data.peso type=text required><div ng-messages=rolForm.peso.$error ng-show=rolForm.peso.$dirty><div ng-message=required>Debe llenar este campo</div></div></md-input-container><md-input-container class=md-block><label for=estado>Estado</label><md-select name=estado ng-model=data.estado placeholder=Estado required><md-option ng-value=item.id ng-repeat=\"item in estados\">{{ item.name }}</md-option></md-select><div ng-messages=rolForm.estado.$error ng-show=rolForm.estado.$dirty><div ng-message=required>Debe seleccionar una opción</div></div></md-input-container><md-input-container class=md-block><label for=fecha_creacion>Fecha de creación</label><md-datepicker ng-model=data._fecha_creacion disabled></md-datepicker></md-input-container><md-input-container class=md-block><label for=fecha_creacion>Fecha de modificación</label><md-datepicker ng-model=data._fecha_modificacion disabled></md-datepicker></md-input-container></md-card-content></md-card><md-card flex><md-card-header><md-card-header-text><span class=md-title>Menus del rol</span></md-card-header-text></md-card-header><md-card-content><div ng-repeat=\"m in menus\"><h3 ng-if=\"m.fid_menu_padre===null\">{{m.nombre}}</h3><md-input-container class=md-block ng-if=\"m.fid_menu_padre!==null\"><md-checkbox ng-model=m.checked aria-label={{m.nombre}}>{{m.nombre}}</md-checkbox></md-input-container></div></md-card-content></md-card></div></md-dialog-content><md-dialog-actions layout layout-padding><span flex></span><md-button type=submit class=\"md-raised md-primary\" ng-disabled=rolForm.$invalid><md-icon>check</md-icon>Guardar</md-button><md-button type=button class=md-raised ng-click=cerrar()><md-icon>cancel</md-icon>Cancelar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/modules/seguridad/rol/modules.seguridad.rol.html","<div class=container><crud-table url=rol.url title-table=rol.titulo fields=rol.fields usuario=rol.usuario id-show=rol.idShow dialog-controller=rol.dialogController template=rol.template></crud-table></div>");
$templateCache.put("app/components/formlyComponents/activo/bajaActivos/bajaActivos.html","<h1>Datos para la baja de activos fijos</h1><ng-form name=bajaActivosForm><div layout layout-align=\"start start\"><md-input-container flex><label>Causal de baja</label><md-select ng-model=model[options.key].motivo required><md-option ng-repeat=\"option in vm.listaMotivos\" ng-value={{option.key}}>{{option.value}}</md-option></md-select></md-input-container></div><div layout layout-align=\"start start\"><md-input-container flex><div class=layout flex><div class=row flex><md-input-container class=input-search flex><label>Respaldo</label><md-select ng-model=vm.docSeleccionado name=select_doc md-on-close=vm.closeSelectDoc() data-md-container-class=select-search required flex><md-select-header class=select-header flex><input ng-model=vm.buscar_doc placeholder=\"Buscar ...\" class=\"header-searchbox md-text\" ng-keydown=$event.stopPropagation() flex></md-select-header><md-optgroup label=documentos><md-option ng-value=d ng-repeat=\"d in vm.documentos\" ng-click=vm.controlSelectDoc(d)>{{d.nombre}}</md-option></md-optgroup></md-select></md-input-container></div><div class=row><md-icon class=\"ap-cursor-pointer md-mini\" ng-click=vm.mostrarPdf(model[options.key].respaldo.id_documento)>description</md-icon><span class=ap-cursor-pointer ng-click=vm.mostrarPdf(model[options.key].fecha.id_documento)>{{ model[options.key].fecha.nombre }}</span></div></div></md-input-container><md-input-container flex><input type=text ng-model=model[options.key].respaldo.fechaMostrar placeholder=\"Fecha respaldo\" required disabled></md-input-container></div><div layout layout-align=\"start start\"><md-input-container flex><textarea ng-model=model[options.key].observaciones placeholder=Observaciones></textarea></md-input-container></div></ng-form><div layout layout-align=\"start center\"><md-autocomplete ng-if=!to.disabled flex=100 md-no-cache=true md-items=\"item in vm.consultarActivo(vm.buscar.texto_buscar)\" md-search-text=vm.buscar.texto_buscar md-selected-item-change=vm.agregarActivo() md-selected-item=vm.buscar.item_seleccionado md-item-text=item.description md-min-length=0 ng-disabled=to.disabled placeholder=\"Escribe el item a buscar ...\"><md-item-template><span>{{item.barcode}} - {{item.description}}</span></md-item-template><md-not-found>No se encontraron coincidencias para \"{{vm.buscar.texto_buscar}}\".</md-not-found></md-autocomplete></div><table class=\"table table-hover table-striped\"><thead><tr><th ng-if=!to.disabled></th><th>Código de barras</th><th>Grupo contable</th><th>Descripción</th></tr></thead><tbody><tr ng-repeat=\"row in model[options.key].activos | filter: vm.filter\"><td class=buttons ng-if=!to.disabled layout-gt-sm><md-button class=md-icon-button ng-click=vm.eliminarActivo($index)><md-icon>delete</md-icon><md-tooltip>Eliminar fila</md-tooltip></md-button></td><td>{{row.barcode}}</td><td>{{row.cuenta}}</td><td>{{row.description}}</td></tr></tbody></table>");
$templateCache.put("app/components/formlyComponents/activo/ingresoActivos/ingresoActivos.html","<!-- <h1>Datos generales para el ingreso </h1> --><ng-form name=ingresoActivosForm><div layout layout-align=\"start start\"><md-input-container flex><label>Tipo de ingreso</label><div layout layout-align=\"end center\" style=\"margin-bottom: 20px;background-color:#fafafa;padding:5px\"><md-radio-group layout ng-model=model[options.key].tipoIngreso ng-change=vm.controlSeleccionTipoIngreso(model[options.key].tipoIngreso)><md-radio-button ng-repeat=\"option in vm.listaTipos\" ng-value={{option.key}}>{{option.value}}</md-radio-button></md-radio-group></div></md-input-container></div><!-- Seccion COMPRA tipoIngreso === 1 --><div ng-if=\"model[options.key].tipoIngreso === 1\"><div layout layout-align=\"start start\"><md-input-container class=input-search flex><label>Proveedores</label><md-select ng-model=model[options.key].proveedor name=seleccionarProveedor required data-md-container-class=select-search><md-select-header class=select-header><div layout layout-align=\"start start\" flex><md-input-container flex><input ng-model=vm.proveedor_buscar placeholder=\"Escriba el nombre del proveedor a buscar...\" ng-keydown=$event.stopPropagation($event) ng-keyup=$event.stopPropagation($event) class=\"header-searchbox md-text\"></md-input-container><md-button class=\"md-fab md-mini md-icon-button md-primary\" aria-label=add ng-click=vm.buscarProveedor()><md-icon>search</md-icon><md-tooltip>Buscar proveedor</md-tooltip></md-button></div></md-select-header><md-optgroup label=proveedores><md-option ng-value=p ng-repeat=\"p in vm.proveedores\" ng-click=vm.controlSeleccionProveedor(p)><div>{{p.nombre}} {{p.nit}}</div></md-option></md-optgroup></md-select></md-input-container><md-input-container flex><input type=text ng-model=model[options.key].nitProveedor placeholder=\"NIT Proveedor\" disabled required></md-input-container></div><div layout layout-align=\"start start\"><md-input-container flex><input type=text ng-model=model[options.key].numeroFactura placeholder=\"Número de factura\" required></md-input-container><md-input-container flex><input type=text ng-model=model[options.key].autorizacionFactura placeholder=\"Número de autorización\" required></md-input-container><md-input-container flex><label>Fecha factura</label><md-datepicker style=\"width: 100%!important\" ng-model=model[options.key].fechaFactura required></md-datepicker></md-input-container></div><div layout layout-align=\"start start\"><md-input-container flex><input type=text ng-model=model[options.key].numeroEntrega placeholder=\"Número de nota de entrega\"></md-input-container><md-input-container flex><label>Fecha nota de entrega</label><md-datepicker style=\"width: 100%!important\" ng-model=model[options.key].fechaEntrega required></md-datepicker></md-input-container></div><div layout layout-align=\"start start\"><md-input-container flex><input type=text ng-model=model[options.key].numeroPreventivo placeholder=\"Nro requerimiento / Nro preventivo\" required></md-input-container><md-input-container flex><label>Fecha requerimiento / Fecha preventivo</label><md-datepicker style=\"width: 100%!important\" ng-model=model[options.key].fechaPreventivo required></md-datepicker></md-input-container></div></div><!-- Seccion DONACION y REPOSICION --><div ng-if=\"model[options.key].tipoIngreso === 2 || model[options.key].tipoIngreso === 3\"><div layout layout-align=\"start start\" ng-if=\"model[options.key].tipoIngreso === 2\"><md-input-container flex><input type=text name=donante_activos ng-model=model[options.key].donante placeholder=\"Entidad donante\"></md-input-container></div><div layout layout-align=\"start start\"><md-input-container flex><div class=layout flex><div class=row flex><md-input-container class=input-search flex><label>Respaldo</label><md-select ng-model=vm.docSeleccionado name=select_doc_respaldo md-on-close=vm.closeSelectDoc() data-md-container-class=select-search required flex><md-select-header class=select-header flex><input ng-model=vm.buscar_doc_activos placeholder=\"Buscar ...\" class=\"header-searchbox md-text\" ng-keydown=$event.stopPropagation() flex></md-select-header><md-optgroup label=documentos_respaldo><md-option ng-value=d ng-repeat=\"d in vm.documentos\" ng-click=vm.controlSelectDoc(d)>{{d.nombre}}</md-option></md-optgroup></md-select></md-input-container></div><div class=row><md-icon class=\"ap-cursor-pointer md-mini\" ng-click=vm.mostrarPdf(model[options.key].respaldo.id_documento)>description</md-icon></div></div></md-input-container><md-input-container flex><input type=text ng-model=model[options.key].respaldo.fechaMostrar placeholder=\"Fecha respaldo\" required disabled></md-input-container></div><div layout layout-align=\"start start\" ng-if=\"model[options.key].tipoIngreso === 3\"><md-autocomplete ng-if=!to.disabled flex=100 md-no-cache=true md-items=\"item in vm.consultarActivoBaja(vm.buscar.texto_buscar_baja)\" md-search-text=vm.buscar.texto_buscar_baja md-selected-item-change=vm.seleccionarActivoBaja() md-selected-item=vm.buscar.item_seleccionado_baja md-item-text=item.description md-min-length=0 ng-disabled=to.disabled placeholder=\"Escribe el activo con baja a buscar ...\"><md-item-template><span>{{item.barcode}} - {{item.description}}</span></md-item-template><md-not-found>No se encontraron coincidencias para \"{{vm.buscar.texto_buscar_baja}}\".</md-not-found></md-autocomplete></div><div layout layout-align=\"start start\" ng-if=\"model[options.key].tipoIngreso === 3\"><md-input-container flex><input type=text ng-model=model[options.key].activoBaja.description placeholder=\"Activo a reponer\" required disabled></md-input-container></div></div><div layout layout-align=\"start start\"><md-input-container flex><textarea ng-model=model[options.key].observaciones placeholder=Observaciones></textarea></md-input-container></div></ng-form><div layout layout-align=\"start center\"><md-autocomplete ng-if=!to.disabled flex=100 md-no-cache=true md-items=\"item in vm.consultarActivo(vm.buscar.texto_buscar)\" md-search-text=vm.buscar.texto_buscar md-selected-item-change=vm.agregarActivo() md-selected-item=vm.buscar.item_seleccionado md-item-text=item.description md-min-length=0 ng-disabled=to.disabled placeholder=\"Escribe el item a buscar ...\"><md-item-template><span>{{item.barcode}} - {{item.description}}</span></md-item-template><md-not-found>No se encontraron coincidencias para \"{{vm.buscar.texto_buscar}}\".</md-not-found></md-autocomplete></div><table class=\"table table-hover table-striped\"><thead><tr><th ng-if=!to.disabled></th><th>Código de barras</th><th>Grupo contable</th><th>Descripción</th><th>Precio unitario</th></tr></thead><tbody><tr ng-repeat=\"row in model[options.key].activos | filter: vm.filter\"><td class=buttons ng-if=!to.disabled layout-gt-sm><md-button class=md-icon-button ng-click=vm.eliminarActivo($index)><md-icon>delete</md-icon><md-tooltip>Eliminar fila</md-tooltip></md-button></td><td>{{row.barcode}}</td><td>{{row.cuenta}}</td><td>{{row.description}}</td><td>{{row.precio}}</td></tr><tr><td></td><td></td><td></td><td>Total</td><td>{{model[options.key].total}}</td></tr></tbody></table>");
$templateCache.put("app/components/formlyComponents/activo/tablaActivos/tablaActivos.html","<h1>Tabla de Activos Fijos</h1><ng-form name=tablaActivosForm><div layout layout-align=\"end center\" style=\"margin-bottom: 20px;background-color:#fafafa;padding:5px\" ng-if=\"model[options.key].tipoFormulario === \'ASIGNACION_DEVOLUCION\'\"><md-radio-group layout ng-model=model[options.key].tipoFormularioSeleccionado ng-change=vm.cambiarTipoFormularioSeleccionado(model[options.key].tipoFormularioSeleccionado)><md-radio-button value=ASIGNACION>Asignación</md-radio-button><md-radio-button value=DEVOLUCION>Devolución</md-radio-button></md-radio-group></div><div style=\"margin-bottom: 20px\" ng-if=\"model[options.key].tipoFormulario === \'ASIGNACION_DEVOLUCION\' && model[options.key].tipoFormularioSeleccionado === \'ASIGNACION\'\"><md-radio-group layout ng-model=model[options.key].tipoBusqueda ng-change=vm.cambiarTipoBusqueda(model[options.key].tipoBusqueda)><md-radio-button value=BUSQUEDA_POR_CITE>Búsqueda por CITE</md-radio-button><md-radio-button value=BUSQUEDA_GLOBAL>Asignar por primera vez</md-radio-button></md-radio-group></div><div layout layout-align=\"start center\" ng-if=\"model[options.key].tipoFormulario === \'ASIGNACION_DEVOLUCION\' && model[options.key].tipoFormularioSeleccionado === \'ASIGNACION\' && model[options.key].tipoBusqueda === \'BUSQUEDA_POR_CITE\'\"><md-input-container flex=100><input type=text ng-model=model[options.key].citeBusqueda placeholder=\"Escriba el CITE de la solicitud de activos\"></md-input-container><md-button class=\"md-fab md-mini md-icon-button md-primary\" aria-label=add ng-click=vm.recuperarSolicitud()><md-icon>search</md-icon><md-tooltip>Buscar solicitud</md-tooltip></md-button></div><div layout layout-align=\"start center\" ng-if=\"(model[options.key].tipoFormulario === \'ASIGNACION_DEVOLUCION\' || model[options.key].tipoFormulario === \'OTRA_DEVOLUCION\') && model[options.key].tipoFormularioSeleccionado === \'DEVOLUCION\'\"><md-input-container flex=100><input type=text ng-model=model[options.key].usuario_ci placeholder=\"Escriba el CI del usuario\"></md-input-container><md-button class=\"md-fab md-mini md-icon-button md-primary\" aria-label=add ng-click=vm.recuperarActivosAsignados()><md-icon>search</md-icon><md-tooltip>Buscar Activos</md-tooltip></md-button></div><div layout layout-align=\"start center\" ng-if=\"model[options.key].tipoFormulario === \'ASIGNACION_DEVOLUCION\' && model[options.key].tipoFormularioSeleccionado === \'ASIGNACION\' && model[options.key].tipoBusqueda === \'BUSQUEDA_GLOBAL\'\"><md-input-container flex><input type=text ng-model=model[options.key].usuario_ci required placeholder=\"C.I. del usuario al que se le asignarán los activos\"></md-input-container><md-button class=\"md-fab md-mini md-icon-button md-primary\" aria-label=add ng-click=vm.validarUsuario()><md-icon>check</md-icon><md-tooltip>Validar usuario</md-tooltip></md-button></div><div ng-if=\"model[options.key].tipoFormularioSeleccionado == \'ASIGNACION\' && model[options.key].documentoDe.numero_documento\">Asignar a : {{model[options.key].documentoDe.nombres}} {{model[options.key].documentoDe.apellidos}} - {{model[options.key].documentoDe.numero_documento}}</div><br><div layout layout-align=\"start start\" ng-if=!model[options.key].devolucionPropia><md-input-container flex><label>Motivo</label><md-select ng-model=model[options.key].motivo required><md-option class=opt-select-tipo ng-value=\"\'Abandono\'\">Abandono</md-option><md-option class=opt-select-tipo ng-value=\"\'Fallecimiento\'\">Fallecimiento</md-option><md-option class=opt-select-tipo ng-value=\"\'Caso fortuito\'\">Caso fortuito</md-option><md-option class=opt-select-tipo ng-value=\"\'Fuerza mayor\'\">Fuerza mayor</md-option></md-select></md-input-container><md-input-container flex><input type=text ng-model=model[options.key].referencia placeholder=Referencia required></md-input-container></div><div layout layout-align=\"start start\" ng-if=!model[options.key].devolucionPropia><md-input-container flex><textarea ng-model=model[options.key].descripcion placeholder=Asunto required></textarea></md-input-container></div><div layout layout-align=\"start center\" ng-if=\"[\'SOLICITUD\',\'ASIGNACION\'].includes(model[options.key].tipoFormularioSeleccionado) && model[options.key].tipoBusqueda === \'BUSQUEDA_GLOBAL\'\"><md-autocomplete ng-if=!to.disabled flex=100 md-no-cache=true md-items=\"item in vm.consultarActivo(vm.buscar.texto_buscar)\" md-search-text=vm.buscar.texto_buscar md-selected-item-change=vm.agregarFila() md-selected-item=vm.buscar.item_seleccionado md-item-text=item.description md-min-length=0 ng-disabled=to.disabled placeholder=\"Escribe el item a buscar ...\"><md-item-template><span>{{item.barcode}} - {{item.description}}</span></md-item-template><md-not-found>No se encontraron coincidencias para \"{{vm.buscar.texto_buscar}}\".</md-not-found></md-autocomplete></div><div layout layout-align=\"start center\" class=alert ng-class=\"\'alert-\'+vm.alert.tipo\" ng-show=vm.alert.show><md-icon>{{vm.alert.icono}}</md-icon><div flex>{{vm.alert.mensaje}}</div><md-icon class=ap-cursor-pointer ng-click=\"vm.alert.show=false\" ng-if=\"vm.alert.time==0\">close</md-icon></div><table class=\"table table-hover table-striped\"><thead><tr><th ng-if=!to.disabled></th><!-- <th> ID </th> --><th>Código de barras</th><th>Descripción</th><th>Cantidad</th></tr></thead><tbody><tr ng-repeat=\"row in model[options.key].filas | filter: vm.filter\"><td class=buttons ng-if=!to.disabled layout-gt-sm><md-button class=md-icon-button aria-label=getSaldo ng-click=vm.eliminarFila($index)><md-icon>delete</md-icon><md-tooltip>Eliminar fila</md-tooltip></md-button></td><!-- <td>\n          <md-input-container>\n            <input type=\"text\" ng-model=\"row.id\" disabled>\n          </md-input-container>\n        </td> --><td><md-input-container><input type=text ng-model=row.barcode disabled></md-input-container></td><td><md-input-container><textarea ng-model=row.description disabled></textarea></md-input-container></td><td><md-input-container><input type=number ng-model=row.cantidad disabled></md-input-container></td></tr></tbody></table><div ng-if=\"model[options.key].tipoFormulario === \'ASIGNACION_DEVOLUCION\' && model[options.key].tipoFormularioSeleccionado === \'ASIGNACION\'\"><div>Solicitado por: {{model[options.key].solicitadoPor.nombre}}</div><div>Entregado por: {{model[options.key].entregadoPor.nombre}}</div><!-- <div>Fecha de entrega: {{model[options.key].fecha_entrega}}</div> --></div><div ng-if=\"model[options.key].tipoFormulario === \'ASIGNACION_DEVOLUCION\' && model[options.key].tipoFormularioSeleccionado === \'DEVOLUCION\'\"><div>Solicitado por: {{model[options.key].solicitadoPor.nombre}}</div><div>Devuelto por: {{model[options.key].devueltoPor.nombre}}</div><!-- <div>Fecha de devolución: {{model[options.key].fecha_devolucion}}</div> --></div></ng-form>");
$templateCache.put("app/components/formlyComponents/almacen/consultaAlmacen/consultaAlmacen.html","<ng-form name=consultaAlmacenForm><div layout layout-align=\"start center\"><md-autocomplete ng-if=!to.disabled flex md-no-cache=true md-items=\"item in vm.consultarAlmacen(vm.buscar.texto_buscar)\" md-search-text=vm.buscar.texto_buscar md-selected-item-change=vm.agregarFila() md-selected-item=vm.buscar.item_seleccionado md-item-text=item.descripcion md-min-length=0 ng-disabled=to.disabled placeholder=\"Escribe el item a buscar ...\"><md-item-template><span>{{item.descripcion}}</span></md-item-template><md-not-found>No se encontraron coincidencias para \"{{vm.buscar.texto_buscar}}\".</md-not-found></md-autocomplete></div><div layout layout-align=\"start center\" class=alert ng-class=\"\'alert-\'+vm.alert.tipo\" ng-show=vm.alert.show><md-icon>{{vm.alert.icono}}</md-icon><div flex>{{vm.alert.mensaje}}</div><md-icon class=ap-cursor-pointer ng-click=\"vm.alert.show=false\" ng-if=\"vm.alert.time==0\">close</md-icon></div><table class=\"table table-hover table-striped\"><thead><tr><th ng-if=!to.disabled></th><th>Código</th><th>Descripción</th><th>Unidad</th><th>Cantidad</th></tr></thead><tbody><tr ng-repeat=\"row in model[options.key].filas | filter: vm.filter\"><td class=buttons ng-if=!to.disabled layout-gt-sm><md-button class=md-icon-button aria-label=getSaldo ng-click=vm.eliminarFila($index)><md-icon>delete</md-icon><md-tooltip>Eliminar fila</md-tooltip></md-button></td><td><md-input-container><input type=text ng-model=row.codigo disabled></md-input-container></td><td><md-input-container><textarea ng-model=row.descripcion disabled></textarea></md-input-container></td><td><md-input-container><input type=text ng-model=row.unidad disabled></md-input-container></td><td ng-if=\"to.tipo==\'PAGADO\'\"><md-input-container><input type=text ng-model=row.comprometido disabled></md-input-container></td><td><md-input-container><input type=number ng-model=row.cantidad></md-input-container></td></tr></tbody></table></ng-form>");
$templateCache.put("app/components/formlyComponents/almacen/ingreso/ingreso.html","<ng-form name=ingresoAlmacenForm><div layout layout-align=\"start start\"><md-input-container flex><label>Tipo de ingreso</label><div layout layout-align=\"end center\" style=\"margin-bottom: 20px;background-color:#fafafa;padding:5px\"><md-radio-group layout ng-model=model[options.key].tipoIngreso ng-change=vm.controlSeleccionTipoIngreso(model[options.key].tipoIngreso)><md-radio-button ng-repeat=\"option in vm.listaTipos\" ng-value={{option.key}}>{{option.value}}</md-radio-button></md-radio-group></div></md-input-container></div><div ng-if=\"model[options.key].tipoIngreso === 1\"><div layout layout-align=\"start start\" flex><md-input-container class=input-search flex><label>Proveedores</label><md-select ng-model=model[options.key].proveedor name=seleccionarProveedor required data-md-container-class=select-search><md-select-header class=select-header><div layout layout-align=\"start start\" flex><md-input-container flex><input ng-model=vm.proveedor_buscar placeholder=\"Escriba el nombre del proveedor a buscar...\" ng-keydown=$event.stopPropagation($event) ng-keyup=$event.stopPropagation($event) class=\"header-searchbox md-text\"></md-input-container><md-button class=\"md-fab md-mini md-icon-button md-primary\" aria-label=add ng-click=vm.buscarProveedor()><md-icon>search</md-icon><md-tooltip>Buscar proveedor</md-tooltip></md-button></div></md-select-header><md-optgroup label=proveedores><md-option ng-value=p ng-repeat=\"p in vm.proveedores\" ng-click=vm.controlSeleccionProveedor(p)><div>{{p.nombre}} {{p.nit}}</div></md-option></md-optgroup></md-select></md-input-container><md-input-container flex><input type=text ng-model=model[options.key].nitProveedor placeholder=\"NIT Proveedor\" disabled required></md-input-container></div><div layout layout-align=\"start start\"><md-input-container flex><input type=text ng-model=model[options.key].factura_numero placeholder=\"{{model[options.key].reingreso? \'Número de informe\':\'Número de factura.\'}}\" required></md-input-container><md-input-container flex><input type=text ng-model=model[options.key].factura_autorizacion placeholder=\"Número autorización.\" ng-required=!model[options.key].reingreso></md-input-container><md-input-container flex><label>{{model[options.key].reingreso? \'Fecha de informe\':\'Fecha de la factura.\'}}</label><md-datepicker style=\"width: 100%!important\" ng-model=model[options.key].factura_fecha required></md-datepicker></md-input-container></div><div layout layout-align=\"start start\"><md-input-container flex><input type=text ng-model=model[options.key].nota_entrega placeholder=\"Número de nota de entrega.\"></md-input-container><md-input-container flex><label>Fecha de la nota entrega.</label><md-datepicker style=\"width: 100%!important\" ng-model=model[options.key].nota_entrega_fecha ng-required=!model[options.key].reingreso></md-datepicker></md-input-container></div><div layout layout-align=\"start start\"><md-input-container flex><input type=text ng-model=model[options.key].c31 placeholder=\"Nro requerimiento / Nro preventivo\" ng-required=!model[options.key].reingreso></md-input-container><md-input-container flex><label>Fecha requerimiento / Fecha preventivo</label><md-datepicker style=\"width: 100%!important\" ng-model=model[options.key].c31_fecha required></md-datepicker></md-input-container></div><div layout layout-align=\"start start\"><md-input-container flex><input type=number ng-model=model[options.key].descuento ng-pattern=/^[0-9]+(\\.[0-9]{1,2})?$/ step=0.01 ng-change=vm.calcularTotalConDescuento() placeholder=\"Escríba el descuento.\"></md-input-container></div></div><!-- Seccion donacion o reingreso tipo ingreso = 2 || 3 --><div ng-if=\"model[options.key].tipoIngreso === 2 || model[options.key].tipoIngreso === 3\"><div layout layout-align=\"start start\" ng-if=\"model[options.key].tipoIngreso === 2\"><md-input-container flex><input type=text ng-model=model[options.key].donante placeholder=\"Entidad donante\"></md-input-container></div><div layout layout-align=\"start start\"><md-input-container flex><div class=layout flex><div class=row flex><md-input-container class=input-search flex><label>Respaldo</label><md-select ng-model=vm.docSeleccionado name=select_doc_respaldo_almacen md-on-close=vm.closeSelectDoc() data-md-container-class=select-search required flex><md-select-header class=select-header flex><input ng-model=vm.buscar_doc placeholder=\"Buscar ...\" class=\"header-searchbox md-text\" ng-keydown=$event.stopPropagation($event) ng-keyup=$event.stopPropagation($event) flex></md-select-header><md-optgroup label=documentos_respaldo><md-option ng-value=d ng-repeat=\"d in vm.documentos\" ng-click=vm.controlSelectDoc(d)>{{d.nombre}}</md-option></md-optgroup></md-select></md-input-container></div><div class=row><md-icon class=\"ap-cursor-pointer md-mini\" ng-click=vm.mostrarPdf(model[options.key].respaldo.id_documento)>description</md-icon></div></div></md-input-container><md-input-container flex><input type=text ng-model=model[options.key].respaldo.fechaMostrar placeholder=\"Fecha respaldo\" required disabled></md-input-container></div></div><div layout layout-align=\"start start\" flex><md-input-container flex><textarea ng-model=model[options.key].observaciones placeholder=Observaciones></textarea></md-input-container></div><div layout layout-align=\"start start\" flex><md-input-container class=input-search flex><label>Artículo/Subartículo</label><md-select ng-model=vm.articulo name=seleccionarArticulo data-md-container-class=select-search><md-select-header class=select-header flex><div layout layout-align=\"start start\"><md-input-container flex><input ng-model=vm.articulo_buscar placeholder=\"Buscar articulo/subarticulo...\" ng-keydown=$event.stopPropagation($event) class=\"header-searchbox md-text\"></md-input-container><md-button class=\"md-fab md-mini md-icon-button md-primary\" aria-label=add ng-click=vm.buscarArticulo()><md-icon>search</md-icon><md-tooltip>Buscar articulo/subarticulo</md-tooltip></md-button></div></md-select-header><md-optgroup label=articulos><md-option ng-value=art ng-repeat=\"art in vm.articulos\"><div ng-click=vm.agregarFila($index)>{{art.codigo}} {{art.descripcion}}</div></md-option></md-optgroup></md-select></md-input-container></div><table class=\"table table-hover table-striped\"><thead><tr><th ng-if=!to.disabled></th><th>Código</th><th>Grupo contable</th><th>Unidad</th><th>Detalle</th><th>Cantidad</th><th>Precio</th><th>Precio Total</th></tr></thead><tbody><tr ng-repeat=\"row in model[options.key].items | filter: vm.filter\"><td class=buttons ng-if=!to.disabled layout-gt-sm><md-button class=md-icon-button aria-label=getSaldo ng-click=vm.eliminarFila($index)><md-icon>delete</md-icon><md-tooltip>Eliminar fila</md-tooltip></md-button></td><td><md-input-container><input type=text ng-model=row.codigo disabled></md-input-container></td><td><md-input-container><input type=text ng-model=row.cuenta disabled></md-input-container></td><td><md-input-container><input type=text ng-model=row.unidad disabled></md-input-container></td><td><md-input-container><textarea ng-model=row.descripcion disabled></textarea></md-input-container></td><td><md-input-container><input type=text ng-model=row.cantidad ng-change=vm.calcularSubTotal($index)></md-input-container></td><td><md-input-container><input type=text ng-model=row.precio ng-change=vm.calcularSubTotal($index) ng-pattern=/^[0-9]+(\\.[0-9]{1,4})?$/ step=0.0001></md-input-container></td><td><md-input-container><input type=text ng-model=row.total disabled></md-input-container></td></tr><tr><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td>{{model[options.key].total}}</td></tr></tbody></table></ng-form>");
$templateCache.put("app/components/formlyComponents/almacen/recuperarEntregaAlmacen/recuperarEntregaAlmacen.html","<ng-form name=consultaAlmacenForm><br><div layout layout-align=\"start center\" ng-if=vm.activar_busqueda><md-input-container flex><input type=text ng-model=vm.cite_buscar placeholder=\"Escriba el CITE de la solicitud de materiales\"></md-input-container><md-button class=\"md-fab md-mini md-icon-button md-primary\" aria-label=add ng-click=vm.recuperarEntrega()><md-icon>search</md-icon><md-tooltip>Buscar entrega</md-tooltip></md-button></div><div layout layout-align=\"start center\" class=alert ng-class=\"\'alert-\'+vm.alert.tipo\" ng-show=vm.alert.show><md-icon>{{vm.alert.icono}}</md-icon><div flex>{{vm.alert.mensaje}}</div><md-icon class=ap-cursor-pointer ng-click=\"vm.alert.show=false\" ng-if=\"vm.alert.time==0\">close</md-icon></div><table class=\"table table-hover table-striped\"><thead><tr><th ng-if=!to.disabled></th><th>Código</th><th>Descripción</th><th>Unidad</th><th>Cantidad solicitada</th><th>Cantidad entregada</th></tr></thead><tbody><tr ng-repeat=\"row in model[options.key].filas | filter: vm.filter\"><td class=buttons ng-if=!to.disabled layout-gt-sm><md-button class=md-icon-button aria-label=getSaldo ng-click=vm.eliminarFila($index)><md-icon>delete</md-icon><md-tooltip>Eliminar fila</md-tooltip></md-button></td><td><md-input-container><input type=text ng-model=row.codigo disabled></md-input-container></td><td><md-input-container><textarea ng-model=row.descripcion disabled></textarea></md-input-container></td><td><md-input-container><input type=text ng-model=row.unidad disabled></md-input-container></td><td ng-if=\"to.tipo==\'PAGADO\'\"><md-input-container><input type=text ng-model=row.comprometido disabled></md-input-container></td><td><md-input-container><input type=number ng-model=row.solicitado disabled></md-input-container></td><td><md-input-container><input type=number ng-model=row.cantidad disabled></md-input-container></td></tr></tbody></table><div ng-if=\"model[options.key].solicitado_por.nombre_completo && model[options.key].entregado_por.nombre_completo\"><div>Solicitado por: {{model[options.key].solicitado_por.nombre_completo}}</div><div>Entregado por: {{model[options.key].entregado_por.nombre_completo}}</div><div>Fecha de entrega: {{model[options.key].fecha_entrega}}</div></div></ng-form>");
$templateCache.put("app/modules/plantillasFormly/catalogos/catalogo/modules.plantillasFormly.catalogos.catalogo.html","<div class=container-plantilla><section layout><md-content flex><div class=\"header botones\" layout layout-align=\"start center\"><md-button class=\"md-fab md-primary\" ng-click=catalogo.guardarCatalogo()><md-icon>save</md-icon><md-tooltip md-direction=right>Guardar catalogo</md-tooltip></md-button><md-button class=\"md-fab md-primary\" ng-click=catalogo.volverAtras()><md-icon>reply</md-icon><md-tooltip md-direction=right>Volver atras</md-tooltip></md-button></div><div><form name=catalogoForm novalidate><md-card flex><md-card-header><md-card-header-text><span class=md-title>Datos generales del catalogo</span></md-card-header-text></md-card-header><!-- TODO: mejorar estilos respecto al padding --><md-card-container class=\"md-block container\"><md-input-container class=md-block><label>Nombre</label><input type=text ng-model=catalogo.data.nombre ng-change=catalogo.escucharCambioNombre()><div ng-messages=catalogoForm.nombre.$error ng-show=catalogoForm.nombre.$dirty><div ng-message=required>Debe llenar este campo</div></div></md-input-container><md-input-container class=md-block ng-if=\"catalogo.esPropietario && catalogo.esModificacionNombre\"><label>Comentario</label><input type=text ng-model=catalogo.data.comentario required><div ng-messages=catalogoForm.comentario.$error ng-show=catalogoForm.comentario.$dirty><div ng-message=required>Debe llenar este campo</div></div></md-input-container><md-input-container class=md-block><label>Descripción</label><textarea ng-model=catalogo.data.descripcion></textarea><div ng-messages=catalogoForm.descripcion.$error ng-show=catalogoForm.descripcion.$dirty><div ng-message=required>Debe llenar este campo</div></div></md-input-container></md-card-container></md-card><div layout=row><md-card style=width:60%><md-card-header><md-card-header-text><span class=md-title>Documentos</span></md-card-header-text></md-card-header><md-card-container><div layout=row class=container><md-input-container flex><input ng-model=catalogo.buscar_documento></md-input-container><md-button class=\"md-fab md-primary\" ng-click=catalogo.buscarDocumento($event) aria-label=Add><md-tooltip>Buscar y validar</md-tooltip><md-icon>search</md-icon></md-button></div><div layout=row class=container ng-if=catalogo.documento.nombre><form name=catalogoDocumentoForm><md-input-container flex><label>Documento</label><input ng-model=catalogo.documento.nombre disabled></md-input-container><md-input-container class=md-block flex><label>Descripción</label><textarea ng-model=catalogo.documento.descripcion></textarea><div ng-messages=catalogoDocumentoForm.documento.descripcion.$error ng-show=catalogoDocumentoForm.documento.descripcion.$dirty><div ng-message=required>Debe llenar este campo</div></div></md-input-container><md-button class=\"md-fab md-primary\" ng-click=catalogo.guardarModificarDocumento($event) aria-label=Add><md-tooltip>{{catalogo.documento.editar?\'Guardar\':\'Agregar\'}}</md-tooltip><md-icon>{{catalogo.documento.editar?\'save\':\'add\'}}</md-icon></md-button></form></div><action-table fields=catalogo.camposDocumentos items=catalogo.data.documentos buttons=catalogo.botonesDocumentos></action-table></md-card-container></md-card><md-card flex><md-card-header><md-card-header-text layout=row><span class=md-title>Personas que pueden ver el catalogo</span></md-card-header-text></md-card-header><md-card-container><div layout=row class=container><md-input-container flex><label>Escriba el nombre o el apellido a buscar...</label><input ng-model=catalogo.buscar_usuario></md-input-container><md-button class=\"md-fab md-primary\" ng-click=catalogo.buscarUsuario($event) aria-label=Add><md-tooltip>Buscar personas</md-tooltip><md-icon>search</md-icon></md-button></div><div ng-if=\"catalogo.usuarios.length > 0\"><md-chips ng-model=catalogo.usuarios name=usuarios readonly md-removable=true input-aria-label=Usuarios><md-chip-template><strong>{{$chip.nombres}} {{$chip.apellidos}}</strong><md-button class=\"md-icon-button md-primary\" ng-click=\"catalogo.autorizarUsuario($event, $chip)\" aria-label=Add><md-tooltip>Agregar nuevo usuario</md-tooltip><md-icon>add</md-icon></md-button></md-chip-template></md-chips></div><action-table fields=catalogo.camposUsuarios items=catalogo.data.usuarios buttons=catalogo.botonesUsuarios></action-table></md-card-container></md-card></div></form></div></md-content></section></div>");
$templateCache.put("app/modules/plantillasFormly/compartidos/compartido/modules.plantillasFormly.compartidos.compartido.html","<div class=container-plantilla><section layout><md-content flex><div class=\"header botones\" layout layout-align=\"start center\"><md-button class=\"md-fab md-primary\" ng-click=compartido.volverAtras()><md-icon>reply</md-icon><md-tooltip md-direction=right>Volver atras</md-tooltip></md-button></div><div><md-card flex><md-card-header><md-card-header-text><span class=md-title>Datos generales del catalogo</span></md-card-header-text></md-card-header><md-card-container class=\"md-block container\"><md-input-container class=md-block><label>Nombre</label><input type=text ng-model=compartido.data.nombre disabled></md-input-container><md-input-container class=md-block><label>Descripción</label><textarea ng-model=compartido.data.descripcion disabled></textarea></md-input-container></md-card-container></md-card><div layout=row><md-card style=width:60%><md-card-header><md-card-header-text><span class=md-title>Documentos</span></md-card-header-text></md-card-header><md-card-container><div layout=row class=container ng-if=compartido.esEditor><md-input-container flex><input ng-model=compartido.buscar_documento></md-input-container><md-button class=\"md-fab md-primary\" ng-click=compartido.buscarDocumento($event) aria-label=Add><md-tooltip>Buscar y validar</md-tooltip><md-icon>search</md-icon></md-button></div><div layout=row class=container ng-if=\"compartido.esEditor && compartido.documento.nombre\"><form name=compartidoDocumentoForm><div class=layout flex><div class=row><md-input-container class=row flex><label>Documento</label><input ng-model=compartido.documento.nombre disabled></md-input-container></div><div class=row><md-input-container class=\"md-block row\" flex><label>Descripción</label><textarea ng-model=compartido.documento.descripcion></textarea><div ng-messages=compartidoDocumentoForm.documento.descripcion.$error ng-show=compartidoDocumentoForm.documento.descripcion.$dirty><div ng-message=required>Debe llenar este campo</div></div></md-input-container></div><div class=row><md-button class=\"md-fab md-primary\" ng-click=compartido.guardarModificarDocumento($event) aria-label=Add><md-tooltip>{{compartido.documento.editar && compartido.esEditor?\'Guardar\':\'Agregar\'}}</md-tooltip><md-icon>{{compartido.documento.editar && compartido.esEditor?\'save\':\'add\'}}</md-icon></md-button></div></div></form></div><action-table fields=compartido.camposDocumentos items=compartido.data.documentos buttons=compartido.botonesDocumentos></action-table></md-card-container></md-card><md-card flex><md-card-header><md-card-header-text layout=row><span class=md-title>Personas que pueden ver el catalogo</span></md-card-header-text></md-card-header><md-card-container><action-table fields=compartido.camposUsuarios items=compartido.data.usuarios buttons=compartido.botonesUsuarios></action-table></md-card-container></md-card></div></div></md-content></section></div>");
$templateCache.put("app/modules/plantillasFormly/documentos/documento/dialogError.html","<md-dialog aria-label=Error class=formly-dialog-error style=\"max-width: 800px; width: 100%\"><md-toolbar><div class=md-toolbar-tools><h2><md-icon>error</md-icon>Error</h2><span flex></span> <span flex></span><md-button class=md-icon-button aria-label=Cerrar ng-click=cerrar()><md-tooltip>Cerrar</md-tooltip><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content class=md-dialog-content><div ng-if=\"data.tipo==\'formu\'\">Debe completar los datos de todos los campos requeridos del documento para poder enviarlo.<br><br>Los campos requeridos tienen un (*) y se muestran con una linea roja.</div><div ng-if=\"data.tipo==\'timeZone\'\">Esta plantilla tiene fechas para llenar y la zona horaria de su ordenador no es la correcta.<br><br>Por favor configure la zona horaria a UTC-4, La Paz - Bolivia, para evitar futuros errores de impresión.<br><br>Si usted no sabe configurar la zona horaria, puede pedir ayuda al personal de soporte técnico.</div><br></md-dialog-content><md-dialog-actions><span flex></span><md-button class=md-raised ng-click=cerrar()><md-icon>check</md-icon>Aceptar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/plantillasFormly/documentos/documento/modules.plantillasFormly.documentos.documento.html","<div class=container-plantilla><section layout><md-content flex><div class=\"header botones\" layout layout-align=\"start center\"><md-button class=\"md-fab md-primary\" ng-click=documento.guardarDocumento() ng-if=!documento.sw_enviado><md-icon>save</md-icon><md-tooltip md-direction=right>Guardar documento</md-tooltip></md-button><md-button class=\"md-fab md-primary\" ng-click=documento.volverAtras() ng-if=documento.sw_enviado><md-icon>reply</md-icon><md-tooltip md-direction=right>Volver atras</md-tooltip></md-button><md-button class=\"md-fab md-primary\" ng-click=documento.vistaPrevia()><md-icon>remove_red_eye</md-icon><md-tooltip md-direction=right>Vista previa</md-tooltip></md-button><!-- <md-button class=\"md-fab md-primary\" ng-click=\"documento.firmar()\" >\r\n                    <md-icon>done_all</md-icon>\r\n                    <md-tooltip md-direction=\"right\"> Firmar Digitalmente</md-tooltip>\r\n                </md-button> --><md-button class=\"md-fab md-primary\" ng-click=documento.copearDocumento() ng-if=\"documento.id_documento!=0\"><md-icon>content_copy</md-icon><md-tooltip md-direction=right>Duplicar documento sin cite</md-tooltip></md-button><!-- <p>\r\n                  {{documento.enviarEjecutandose}} <br>\r\n                  bbb\r\n                  {{!documento.enviarEjecutandose}} <br>\r\n                  aaa\r\n                </p> --><md-button class=\"md-fab md-primary\" ng-click=documento.guardarDocumento(true) ng-if=!documento.sw_enviado ng-disabled=\"documento.enviarEjecutandose ==1? true:false\"><md-icon>send</md-icon><md-tooltip md-direction=right>{{ (documento.id_documento==0)? \'Guardar y enviar documento\' : \'Enviar documento\' }}</md-tooltip></md-button><div flex></div><md-input-container><label for=documento-nombre>Nombre del documento</label><input ng-model=documento.doc.nombre size=50 maxlength=250 ng-disabled=documento.sw_enviado required></md-input-container><div flex><md-button class=\"md-fab md-warning\" ng-click=documento.verObservaciones($event) ng-if=documento.sw_rechazado><md-icon>find_in_page</md-icon><md-tooltip md-direction=right>Ver observaciones</md-tooltip></md-button></div><div flex ng-if=!documento.sw_enviado></div></div><div class=documento-edit><div class=\"header header-doc\" ng-if=\"documento.sw_grupo && documento.docs_grupo.length > 0\"><div class=\"ap-text-center ap-text-warning\">Referencias:</div><div class=\"ap-text-center ap-text-warning\" ng-repeat=\"dg in documento.docs_grupo\" ng-if=\"dg.id_documento!=documento.id_documento\">* {{dg.nombre_plantilla}} -- <span class=ap-cursor-pointer ng-click=documento.verDocumento(dg.id_documento)>{{dg.nombre}}</span></div></div><div class=pagina ng-if=documento.load><form name=documento.formu novalidate><img class=img-membrete ng-src={{documento.url_img}} ng-if=documento.url_img><formly-form class=view-formly-form model=documento.model_actual fields=documento.form_actual></formly-form></form></div></div></md-content></section></div>");
$templateCache.put("app/modules/plantillasFormly/documentos/documento/observacion.panel.html","<md-card style=\"max-width: 400px\"><md-card-title><md-card-title-text><span class=md-headline>Observaciones</span><!-- <span class=\"md-subhead\">Extra Large</span> --></md-card-title-text></md-card-title><md-card-content>{{ observacion }}</md-card-content><md-card-actions layout=row layout-align=\"end center\"><md-button ng-click=closePanel()>Aceptar</md-button></md-card-actions></md-card>");
$templateCache.put("app/modules/plantillasFormly/plantillas/plantilla/item.panel.html","<md-card class=animated style=\"max-width: 400px; min-width: 300px\"><md-card-title><md-card-title-text><span class=md-headline>{{titulos[item.val.element[0].type] || item.val.element[0].type}}</span><!-- <span class=\"md-subhead\">Extra Large</span> --></md-card-title-text></md-card-title><md-card-content ng-switch on=item.val.element[0].type style=\"max-height: 280px; overflow-y: auto; padding-top: 10px\"><div class=\"container container-elementos\"><div ng-switch-when=input layout=column><md-input-container><label>Nombre</label><input type=text ng-model=item.val.element[0].templateOptions.label></md-input-container><md-checkbox ng-model=item.val.element[0].templateOptions.required aria-label=Requerido>Requerido ?</md-checkbox><label>Validación</label><md-select ng-model=item.val.element[0].templateOptions.pattern><md-option ng-value=v.pattern ng-repeat=\"v in validaciones\">{{ v.name }}</md-option></md-select></div><div ng-switch-when=radio layout=column><md-input-container><label>Nombre</label><input type=text ng-model=item.val.element[0].templateOptions.label></md-input-container><md-checkbox ng-model=item.val.element[0].templateOptions.required aria-label=Requerido>Requerido ?</md-checkbox><md-checkbox ng-model=item.val.element[0].templateOptions.vertical aria-label=vertical>Orientacion vertical ?</md-checkbox><label>Opciones</label><md-chips ng-model=item.val.element[0].opciones></md-chips></div><div ng-switch-when=select layout=column><md-input-container><label>Nombre</label><input type=text ng-model=item.val.element[0].templateOptions.label></md-input-container><md-checkbox ng-model=item.val.element[0].templateOptions.required aria-label=Requerido>Requerido ?</md-checkbox><md-checkbox ng-model=item.val.element[0].templateOptions.showItem>Mostrar en PDF</md-checkbox><label>Opciones</label><md-chips ng-model=item.val.element[0].opciones></md-chips></div><div ng-switch-when=textarea layout=column><md-input-container><label>Nombre</label><input type=text ng-model=item.val.element[0].templateOptions.label></md-input-container><md-input-container><label>Altura</label><input type=number ng-model=item.val.element[0].templateOptions.rows></md-input-container><md-checkbox ng-model=item.val.element[0].templateOptions.required aria-label=Requerido>Requerido ?</md-checkbox><md-checkbox ng-model=item.val.element[0].templateOptions.interlineado aria-label=Interlineado-de-parrafos>Quitar interlineado de parrafos ?</md-checkbox><!-- <label>Alineación</label>\n                <md-radio-group layout layout-wrap class=\"radio-parrafo\" ng-model=\"item.val.element[0].className\">\n                    <md-radio-button ng-value=\"\'ap-text-left\'\"> <md-icon>format_align_left</md-icon> </md-radio-button>\n                    <md-radio-button ng-value=\"\'ap-text-center\'\"> <md-icon>format_align_center</md-icon> </md-radio-button>\n                    <md-radio-button ng-value=\"\'ap-text-right\'\"> <md-icon>format_align_right</md-icon> </md-radio-button>\n                    <md-radio-button ng-value=\"\'ap-text-justify\'\"> <md-icon>format_align_justify</md-icon> </md-radio-button>\n                </md-radio-group> --></div><div ng-switch-when=checkbox layout=column><md-input-container><label>Nombre</label><input type=text ng-model=item.val.element[0].templateOptions.label></md-input-container></div><div ng-switch-when=switch layout=column><md-input-container><label>Nombre</label><input type=text ng-model=item.val.element[0].templateOptions.label></md-input-container></div><div ng-switch-when=datepicker layout=column><md-input-container><label>Nombre</label><input type=text ng-model=item.val.element[0].templateOptions.label></md-input-container><md-checkbox ng-model=item.val.element[0].templateOptions.required aria-label=Requerido>Requerido ?</md-checkbox></div><div ng-switch-when=calendario layout=column><md-input-container><label>Nombre</label><input type=text ng-model=item.val.element[0].templateOptions.label></md-input-container><md-checkbox ng-model=item.val.element[0].templateOptions.required aria-label=Requerido>Requerido ?</md-checkbox><md-input-container><label>Días antes</label><input type=number ng-model=item.val.element[0].templateOptions.diasAntes></md-input-container><md-input-container><label>Días Despues</label><input type=number ng-model=item.val.element[0].templateOptions.diasDespues></md-input-container></div><div ng-switch-when=slider layout=column><md-input-container><label>Nombre</label><input type=text ng-model=item.val.element[0].templateOptions.label></md-input-container><md-input-container><label>Step</label><input type=text ng-model=item.val.element[0].templateOptions.step></md-input-container><md-input-container><label>Min</label><input type=number ng-model=item.val.element[0].templateOptions.min></md-input-container><md-input-container><label>Max</label><input type=number ng-model=item.val.element[0].templateOptions.max></md-input-container><md-checkbox ng-model=item.val.element[0].templateOptions.discrete aria-label=Discreto>Discreto ?</md-checkbox></div><div ng-switch-when=chips layout=column><md-input-container><label>Nombre</label><input type=text ng-model=item.val.element[0].templateOptions.label></md-input-container><md-input-container><label>Placeholder</label><input type=text ng-model=item.val.element[0].templateOptions.placeholder></md-input-container><md-input-container><label>2do Placeholder</label><input type=text ng-model=item.val.element[0].templateOptions.secondaryPlaceholder></md-input-container><md-checkbox ng-model=item.val.element[0].templateOptions.required aria-label=Requerido>Requerido ?</md-checkbox></div><div ng-switch-when=texto layout=column><!-- <label ng-if=\"item.val.element[0].templateOptions.tipo!==\'p\'\">Tipo</label>\n                <md-radio-group layout layout-wrap class=\"radio-parrafo\" ng-model=\"item.val.element[0].templateOptions.tipo\" ng-if=\"item.val.element[0].templateOptions.tipo!==\'p\'\">\n                    <md-radio-button ng-value=\"\'h1\'\"> h1 </md-radio-button>\n                    <md-radio-button ng-value=\"\'h2\'\"> h2 </md-radio-button>\n                    <md-radio-button ng-value=\"\'h3\'\"> h3 </md-radio-button>\n                    <md-radio-button ng-value=\"\'h4\'\"> h4 </md-radio-button>\n                    <md-radio-button ng-value=\"\'h5\'\"> h5 </md-radio-button>\n                    <md-radio-button ng-value=\"\'h6\'\"> h6 </md-radio-button>\n                </md-radio-group> --><label>Alineación</label><md-radio-group layout layout-wrap class=radio-parrafo ng-model=item.val.element[0].templateOptions.className><md-radio-button ng-value=\"\'ap-text-left\'\"><md-icon>format_align_left</md-icon></md-radio-button><md-radio-button ng-value=\"\'ap-text-center\'\"><md-icon>format_align_center</md-icon></md-radio-button><md-radio-button ng-value=\"\'ap-text-right\'\"><md-icon>format_align_right</md-icon></md-radio-button><md-radio-button ng-value=\"\'ap-text-justify\'\" ng-if=\"item.val.element[0].templateOptions.tipo===\'p\'\"><md-icon>format_align_justify</md-icon></md-radio-button></md-radio-group><label>Espacios</label><div layout layout-wrap class=radio-parrafo><md-checkbox ng-model=item.val.element[0].templateOptions.mTop>Espacio superior</md-checkbox><md-checkbox ng-model=item.val.element[0].templateOptions.mBot>Espacio inferior</md-checkbox></div><md-input-container ng-if=\"item.val.element[0].templateOptions.tipo!==\'p\'\"><label>Texto</label><input ng-model=item.val.element[0].templateOptions.label></md-input-container><md-input-container ng-if=\"item.val.element[0].templateOptions.tipo===\'p\'\"><label>Texto</label><textarea ng-model=item.val.element[0].templateOptions.label rows=3 md-no-resize=true max-rows=3>\n                    </textarea></md-input-container></div><div ng-switch-when=lista layout=column><md-input-container class=ap-input-ns><label>Texto</label><input ng-model=item.val.element[0].templateOptions.label></md-input-container><label>Tipo de lista</label><md-radio-group layout layout-wrap class=radio-parrafo ng-model=item.val.element[0].templateOptions.tipo><md-radio-button ng-value=\"\'ol\'\">Lista ordenada</md-radio-button><md-radio-button ng-value=\"\'ul\'\">Lista no ordenada</md-radio-button></md-radio-group><label>Alineación</label><md-radio-group layout layout-wrap class=radio-parrafo ng-model=item.val.element[0].templateOptions.className><md-radio-button ng-value=\"\'ap-text-left\'\"><md-icon>format_align_left</md-icon></md-radio-button><md-radio-button ng-value=\"\'ap-text-center\'\"><md-icon>format_align_center</md-icon></md-radio-button><md-radio-button ng-value=\"\'ap-text-right\'\"><md-icon>format_align_right</md-icon></md-radio-button></md-radio-group><label>Elementos</label><md-chips ng-model=item.val.element[0].opciones></md-chips><br></div><div ng-switch-when=inputt layout=column><md-input-container class=ap-input-ns><label>Texto</label><input ng-model=item.val.element[0].templateOptions.labelx></md-input-container><md-checkbox ng-model=item.val.element[0].templateOptions.required aria-label=Requerido>Requerido ?</md-checkbox><label>Alineación</label><md-radio-group layout layout-wrap class=radio-parrafo ng-model=item.val.element[0].templateOptions.alineacion><md-radio-button ng-value=\"\'ap-text-left\'\"><md-icon>format_align_left</md-icon></md-radio-button><md-radio-button ng-value=\"\'ap-text-center\'\"><md-icon>format_align_center</md-icon></md-radio-button><md-radio-button ng-value=\"\'ap-text-right\'\"><md-icon>format_align_right</md-icon></md-radio-button></md-radio-group><label>Espacio de texto = {{item.val.element[0].templateOptions.labelw}}</label><md-slider flex min=0 max=80 ng-model=item.val.element[0].templateOptions.labelw step=5 aria-label=remdes-width></md-slider><br></div><div ng-switch-when=cite layout=column><!-- <md-input-container class=\"ap-input-ns\">\n                    <label>Texto cite</label>\n                    <input ng-model=\"item.val.element[0].templateOptions.labelCite\">\n                </md-input-container>\n                <md-input-container class=\"ap-input-ns\">\n                    <label>Texto fecha</label>\n                    <input ng-model=\"item.val.element[0].templateOptions.labelFecha\">\n                </md-input-container> --><md-input-container><label>Tipo de membrete</label><md-select ng-model=item.val.element[0].templateOptions.tipoMembrete><md-option ng-value=\"\'sin membrete\'\">Sin membrete</md-option><md-option ng-value=\"\'externo\'\">Membrete externo</md-option><md-option ng-value=\"\'legal\'\">Membrete legal</md-option></md-select></md-input-container><br><md-input-container><label>Tipo de hoja</label><md-select ng-model=item.val.element[0].templateOptions.tipoHoja ng-click=controlTipoHoja><md-option ng-value=\"\'Letter\'\">Carta</md-option><md-option ng-value=\"\'Oficio\'\">Oficio</md-option><md-option ng-value=\"\'A4\'\">A4</md-option><md-option ng-value=\"\'Externo\'\">Nota Externa</md-option><md-option ng-value=\"\'Legal\'\">Nota Legal</md-option></md-select></md-input-container><!-- <br> --><!-- <label>Tipo de membrete</label>\n                <md-radio-group layout layout-wrap class=\"radio-parrafo\" ng-model=\"item.val.element[0].templateOptions.tipoMembrete\">\n                    <md-radio-button ng-value=\"\'sin membrete\'\"> Sin membrete </md-radio-button>\n                    <md-radio-button ng-value=\"\'externo\'\"> membrete externo </md-radio-button>\n                </md-radio-group> --><!-- <md-checkbox ng-model=\"item.val.element[0].templateOptions.tipoMembrete\" aria-label=\"Vertical\"> Vertical </md-checkbox> --><label>Tipo de cite</label><md-radio-group layout layout-wrap ng-model=item.val.element[0].templateOptions.tipo><md-radio-button flex value=general>General</md-radio-button><md-radio-button flex value=unidad>Unidad</md-radio-button></md-radio-group><label>Numeración de pagina</label><md-radio-group layout layout-wrap ng-model=item.val.element[0].templateOptions.numeracionPagina><md-radio-button flex value=true>Si</md-radio-button><md-radio-button flex value=false>No</md-radio-button></md-radio-group><!-- <label>¿Se puede generar de manera multiple?</label>\n                <md-radio-group layout layout-wrap ng-model=\"item.val.element[0].templateOptions.generacionMultiple\">\n                  <md-radio-button flex value=\"true\"> Si </md-radio-button>\n                  <md-radio-button flex value=\"false\"> No </md-radio-button>\n                </md-radio-group> --></div><div ng-switch-when=layout layout=column><label>Número de elementos</label><md-radio-group layout layout-wrap class=radio-parrafo ng-model=\"item.val.element[0].elementAttributes[\'num-cols\']\"><md-radio-button ng-value=\"\'2\'\">2</md-radio-button><md-radio-button ng-value=\"\'3\'\">3</md-radio-button><md-radio-button ng-value=\"\'4\'\">4</md-radio-button></md-radio-group></div><div ng-switch-when=vacio layout=column><md-input-container class=ap-input-ns><label>Altura en cm (0, 30)</label><input ng-model=item.val.element[0].templateOptions.height></md-input-container></div><div ng-switch-when=datosGenerales layout=column><md-checkbox ng-model=item.val.element[0].templateOptions.aprobarPorDireccion>Aprobar por dirección</md-checkbox><div layout layout-wrap class=radio-parrafo><md-checkbox ng-model=item.val.element[0].templateOptions.show.via>Via</md-checkbox><md-checkbox ng-model=item.val.element[0].templateOptions.show.ref>Ref</md-checkbox><md-checkbox ng-model=item.val.element[0].templateOptions.showItem>Mostrar en PDF</md-checkbox></div><md-input-container class=ap-input-ns><label>Texto referencia</label><input ng-model=item.val.element[0].templateOptions.labelRef></md-input-container></div><div ng-switch-when=encabezado layout=column><div layout layout-wrap class=radio-parrafo><md-checkbox ng-model=item.val.element[0].templateOptions.show.via>Via</md-checkbox><md-checkbox ng-model=item.val.element[0].templateOptions.show.ref>Ref</md-checkbox></div><md-input-container class=ap-input-ns><label>Texto referencia</label><input ng-model=item.val.element[0].templateOptions.labelRef></md-input-container></div><div ng-switch-when=documentosRelacionados layout=column><md-input-container class=ap-input-ns><label>Texto</label><input ng-model=item.val.element[0].templateOptions.label></md-input-container><!-- <label>Espacio de texto = {{item.val.element[0].templateOptions.labelw-5}}</label>\n                    <md-slider flex min=\"5\" max=\"80\" ng-model=\"item.val.element[0].templateOptions.labelw\" step=\"5\" aria-label=\"remdes-width\">\n                </md-slider> --></div><div ng-switch-when=documentosAnular layout=column><md-input-container class=ap-input-ns><label>Texto</label><input ng-model=item.val.element[0].templateOptions.label></md-input-container></div><div ng-switch-when=archivo layout=column><md-input-container class=ap-input-ns><label>Texto</label><input ng-model=item.val.element[0].templateOptions.label></md-input-container><md-checkbox ng-model=item.val.element[0].templateOptions.multiple>Multiple ?</md-checkbox></div><div ng-switch-when=cajachica layout=column><md-input-container><label>Acción</label><md-select ng-model=item.val.element[0].templateOptions.tipo><md-option value=GESTION>GESTION PARTIDAS</md-option><md-option value=COMPROMETIDO>COMPROMETIDO</md-option><md-option value=PAGADO>PAGADO</md-option></md-select></md-input-container><!-- <md-checkbox ng-model=\"item.val.element[0].templateOptions.show.cite\"> Cite ?  </md-checkbox>\n                <md-checkbox ng-model=\"item.val.element[0].templateOptions.show.pagado\"> Pagado ?  </md-checkbox>\n\n                <label>Partidas</label>\n                <md-chips ng-model=\"item.val.element[0].templateOptions.partidas\"></md-chips>\n                <label>Acciones</label>\n                <md-chips ng-model=\"item.val.element[0].templateOptions.acciones\"></md-chips> --><!-- <md-input-container class=\"ap-input-ns\">\n                    <label>Texto</label>\n                    <input ng-model=\"item.val.element[0].templateOptions.label\">\n                </md-input-container> --><!-- <md-checkbox ng-model=\"item.val.element[0].templateOptions.multiple\"> Multiple ?  </md-checkbox> --></div><div ng-switch-when=consultaAlmacen layout=column><md-input-container><label>Titulo</label><input ng-model=item.val.element[0].templateOptions.label></md-input-container><md-input-container><label>Modo de consulta</label><md-select ng-model=item.val.element[0].templateOptions.tipo><md-option value=SOLICITUD>SOLICITUD</md-option><md-option value=REINGRESO>REINGRESO</md-option></md-select></md-input-container></div><div ng-switch-when=recuperarEntregaAlmacen layout=column><md-input-container><label>Titulo</label><input ng-model=item.val.element[0].templateOptions.label></md-input-container><md-input-container><label>Abreviacion de solicitud</label><input ng-model=item.val.element[0].templateOptions.solicitud></md-input-container></div><div ng-switch-when=certificacionComprometido layout=column><md-input-container class=ap-input-ns><label>Titulo</label><input ng-model=item.val.element[0].templateOptions.label></md-input-container></div><div ng-switch-when=listaContactos layout=column><md-input-container class=ap-input-ns><label>Título</label><input ng-model=item.val.element[0].templateOptions.label></md-input-container></div><div ng-switch-when=ingresoAlmacen layout=column><md-input-container><label>Titulo</label><input ng-model=item.val.element[0].templateOptions.label></md-input-container></div><div ng-switch-when=tablaActivos layout=column><md-input-container><label>Tipo de formulario</label><md-select ng-model=item.val.element[0].templateOptions.tipoFormulario><md-option ng-value=\"\'SOLICITUD\'\">SOLICITUD</md-option><md-option ng-value=\"\'ASIGNACION_DEVOLUCION\'\">ASIGNACION/DEVOLUCION</md-option><md-option ng-value=\"\'OTRA_DEVOLUCION\'\">OTRAS DEVOLUCIONES</md-option></md-select></md-input-container></div><div ng-switch-when=ingresoActivos layout=column><md-input-container></md-input-container></div><div ng-switch-when=bajaActivos layout=column></div><div ng-switch-default layout=column>Falta codigo para este</div></div></md-card-content><md-card-actions layout=row layout-align=\"end center\"><md-button class=md-primary ng-click=xeditItem()>Aceptar</md-button><!-- <md-button ng-click=\"xremoveItem()\"> Eliminar </md-button> --><md-button ng-click=xcancelEditItem()>Cancelar</md-button></md-card-actions></md-card>");
$templateCache.put("app/modules/plantillasFormly/plantillas/plantilla/modules.plantillasFormly.plantillas.plantilla.html","<div class=container-plantilla><section layout><md-content flex class=documento><div class=header-plantillas layout layout-align=\"start center\"><md-button class=\"md-fab md-primary\" ng-click=plantilla.guardarPlantilla()><md-icon>save</md-icon><md-tooltip md-direction=right>{{ (plantilla.id_plantilla==0)? \'Guardar plantilla\' : \'Modificar plantilla\' }}</md-tooltip></md-button><md-menu><md-button aria-label=\"open menu\" class=\"md-fab md-primary\" md-menu-origin ng-click=$mdOpenMenu($event)><md-icon>location_searching</md-icon><md-tooltip md-direction=right>Ver json de estructura</md-tooltip></md-button><md-menu-content class=menu-content-json width=4 style=\"max-width: 400px\"><h3>Cuerpo json del formulario</h3><pre>{{plantilla.data | json}}</pre></md-menu-content></md-menu><md-button class=\"md-fab md-primary\" ng-click=plantilla.vistaPrevia() ng-if=!plantilla.vista_previa><md-icon>visibility</md-icon><md-tooltip md-direction=right>Vista previa</md-tooltip></md-button><md-button class=\"md-fab md-primary\" ng-click=\"plantilla.vista_previa=false\" ng-if=plantilla.vista_previa><md-icon>visibility_off</md-icon><md-tooltip md-direction=right>Cancelar vista previa</md-tooltip></md-button><md-menu ng-if=plantilla.vista_previa><md-button aria-label=\"open menu\" class=\"md-fab md-primary\" md-menu-origin ng-click=$mdOpenMenu($event)><md-icon>location_searching</md-icon><md-tooltip md-direction=right>Ver json de valores</md-tooltip></md-button><md-menu-content class=menu-content-json width=4 style=\"max-width: 400px\"><h3>Cuerpo json de valores</h3><pre>{{plantilla.form_model | json}}</pre></md-menu-content></md-menu><md-button class=\"md-fab md-primary\" ng-click=plantilla.verPdf() ng-if=plantilla.vista_previa><md-icon>picture_as_pdf</md-icon><md-tooltip md-direction=right>Ver pdf</md-tooltip></md-button><div flex=10 ng-if=!plantilla.vista_previa></div><md-input-container><label for=plantilla-nombre>Nombre de la plantilla</label><input ng-model=plantilla.nombre size=50 ng-disabled=plantilla.existe_documento required></md-input-container><!-- <md-input-container>\n                    <label for=\"plantilla-abreviacion\">Abreviación</label>\n                    <input ng-model=\"plantilla.abreviacion\" required ng-disabled=\"plantilla.existe_documento\" ng-keyup=\"plantilla.abreviacion=plantilla.abreviacion.toUpperCase()\">\n                </md-input-container> --><div flex><!-- <md-button class=\"md-fab md-primary\" ng-click=\"plantilla.togglePalette($event)\" >\n                        <md-icon>\n                            reorder\n                        </md-icon>\n                        <md-tooltip>\n                            Abrir paleta\n                        </md-tooltip>\n                    </md-button> --></div></div><div class=pagina ng-if=plantilla.vista_previa><form name=plantilla.formu_prueba novalidate><img class=img-membrete ng-src={{plantilla.url_img}} ng-if=plantilla.url_img><formly-form class=view-formly-form model=plantilla.form_model fields=plantilla.form_previo></formly-form></form></div><div class=pagina ng-if=!plantilla.vista_previa><img class=img-membrete ng-src={{plantilla.url_img}} ng-if=plantilla.url_img><md-card-content class=lista dnd-list=plantilla.items dnd-drop=\"plantilla.dropCallback(index, item)\"><p class=content-drop ng-if=\"plantilla.items.length == 0\">Arrastre alg&uacute;n elemento en esta secci&oacute;n o haga clic en el bot&oacute;n \'+\' de alg&uacute;n elemento</p><div class=div-{{item.val.element[0].type}} ng-repeat=\"item in plantilla.items\" ng-show=!item.notvisualize><div class=column layout layout-align=\"center center\" ng-switch on=item.val.element[0].type><div flex ng-switch-when=layout><div ng-class=\"\'sublista-\'+item.val.element[0].elementAttributes[\'num-cols\']\" dnd-list=item.val.element[0].fieldGroup dnd-drop=\"plantilla.dropLayoutCallback(index, item, $index)\"><div ng-class=\"\'div-li-\'+item.val.element[0].elementAttributes[\'num-cols\']\" ng-if=\"item.val.element[0].fieldGroup.length==0\" class=layout-drop>&nbsp;&nbsp;&nbsp;Puede arrastrar alg&uacute;n elemento en esta secci&oacute;n</div><div ng-class=\"\'div-li-\'+item.val.element[0].elementAttributes[\'num-cols\']\" ng-repeat=\"subitem in item.val.element[0].fieldGroup\" ng-mouseover=\"layoutIndex=$parent.$index\"><div layout layout-align=\"center center\" ng-switch on=subitem.val.element[0].type ng-show=!subitem.notvisualize><!-- <pre>{{subitem | json}}</pre> --><div flex ng-switch-when=layout>No puede añadir contenedores dentro de contenedores</div><div flex ng-switch-default><formly-form class=view-formly-form model=subitem.val.model fields=subitem.val.element></formly-form></div><div layout=column><md-icon class=\"ap-text-success ap-cursor-pointer\" dnd-draggable=subitem.val.element[0] dnd-effect-allowed=move dnd-dragstart=\"plantilla.startLayoutCallback($index, subitem, layoutIndex)\" dnd-dragend=plantilla.endLayoutCallback(layoutIndex) ng-click=\"plantilla.openMenu(subitem, $event, $index, layoutIndex)\"><md-tooltip>Click para editar o puede arrastrar</md-tooltip>blur_on</md-icon><md-icon class=\"ap-cursor-pointer ap-text-error\" ng-click=\"plantilla.removeItem(item, $index, layoutIndex)\"><md-tooltip>Eliminar</md-tooltip>delete</md-icon></div></div></div></div></div><div flex ng-switch-default><formly-form class=view-formly-form model=item.val.model fields=item.val.element></formly-form></div><div layout=column><md-icon class=ap-cursor-pointer dnd-draggable=item.val.element[0] dnd-effect-allowed=move dnd-dragstart=\"plantilla.startCallback($index, item)\" dnd-dragend=plantilla.endCallback() ng-click=\"plantilla.openMenu(item, $event, $index)\"><md-tooltip>Click para editar o puede arrastrar</md-tooltip>blur_on</md-icon><md-icon class=\"ap-cursor-pointer ap-text-error\" ng-click=\"plantilla.removeItem(item, $index)\" ng-if=\"item.val.element[0].type!=\'cite\'\"><md-tooltip>Eliminar</md-tooltip>delete</md-icon></div></div></div></md-card-content></div><div flex></div><br><br><br><br><br><br><br><br><br><br><br></md-content><md-sidenav class=\"md-sidenav-right ap-sidenav-right md-whiteframe-1dp\" md-component-id=right md-disable-backdrop md-is-locked-open=\"$mdMedia(\'gt-sm\')\"><md-content><!-- <md-card-title-text>\n                    <span class=\"md-headline\">Paleta</span>\n                </md-card-title-text> --><palette-formly funcion-agregar=plantilla.funcionAgregar></palette-formly></md-content></md-sidenav></section></div>");}]);